import { TemporalEngine as e, drawDefinitionConstants as t, entryStatusConstants as n, eventConstants as r, eventGovernor as i, factoryConstants as a, fixtures as o, genderConstants as s, governors as c, matchUpFormatCode as l, matchUpStatusConstants as u, mocksEngine as d, participantConstants as f, scoreGovernor as p, temporal as m, tools as h, tournamentEngine as g } from "tods-competition-factory";
//#region \0rolldown/runtime.js
var _ = Object.create, v = Object.defineProperty, y = Object.getOwnPropertyDescriptor, b = Object.getOwnPropertyNames, x = Object.getPrototypeOf, S = Object.prototype.hasOwnProperty, C = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), w = (e, t) => {
	let n = {};
	for (var r in e) v(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || v(n, Symbol.toStringTag, { value: "Module" }), n;
}, T = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = b(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !S.call(e, s) && s !== n && v(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = y(t, s)) || r.enumerable
	});
	return e;
}, E = (e, t, n) => (n = e == null ? {} : _(x(e)), T(t || !e || !e.__esModule ? v(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), D = /* @__PURE__ */ E((/* @__PURE__ */ C(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})))());
function O({ variant: e }) {
	return (0, D.default)("chc-placeholder", e === "showAddress" && "chc-placeholder--show-address");
}
var k = (e) => "chc-participant", A = (e) => (0, D.default)("chc-participant-name", e?.variant && `chc-participant-name--${e.variant}`), j = (e) => (0, D.default)("chc-participant-type", e?.variant && `chc-participant-type--${e.variant}`);
function M({ drawPosition: e, sideNumber: t }) {
	let n = (0, D.default)("chc-participant-container", t === 1 && "chc-participant-container--side1");
	return e ? `${n} chc-has-draw-position` : n;
}
//#endregion
//#region src/styles/getChevronStyle.ts
function N({ winnerChevron: e, isDoubles: t }) {
	return e ? t ? "chc-chevron-doubles--winner" : "chc-chevron--winner" : "";
}
//#endregion
//#region src/styles/participantDetailStyle.ts
var P = () => "chc-participant-detail";
//#endregion
//#region src/components/renderStructure/renderAddress.ts
function F({ individualParticipant: e, className: t }) {
	let { city: n, state: r, countryCode: i } = e?.person?.addresses?.[0] || {}, a = [
		n,
		r,
		i
	].filter(Boolean).join(", ") || " ", o = document.createElement("div");
	return o.className = (0, D.default)(P(), t), o.innerHTML = a, o;
}
//#endregion
//#region src/components/modal/cmodalStyles.ts
var ee = () => "chc-backdrop", te = () => "chc-modal", ne = () => "chc-body-freeze", re = () => "chc-modal-container", I = () => "chc-modal-dialog", ie = () => "chc-modal-header", ae = () => "chc-modal-title", oe = () => "chc-modal-footer", se = "Nothing to see here";
function L(e) {
	return typeof e == "function";
}
function ce(e) {
	return typeof e == "string";
}
function le(e) {
	return Array.isArray(e);
}
function ue(e) {
	if (e) for (; e.firstChild;) e.firstChild.remove();
}
var R = (() => {
	let e = ne(), t = {}, n = [], r, i = [], a = [], o, s = (e) => {
		if (e) {
			let t;
			a = a.filter((n) => (n.id === e && (t = n), n.id !== e)), t && t.remove();
		} else {
			let e = a.pop();
			e && e.remove();
		}
	}, c = () => {
		o && (o.style.opacity = "0", o.style.display = "none");
	}, l = (o) => {
		let l = a.length;
		if (o && t[l] === !1) return;
		let u = i.pop(), d = n.pop();
		L(u) && u({ content: d }), document.querySelectorAll("[data-modal-popover]").forEach((e) => e.remove()), document.body.classList.remove(e), document.body.style.top = null, window.scrollTo({
			top: r,
			behavior: "instant"
		}), c(), s();
	}, u = () => {
		o = document.createElement("div"), o.className = ee(), o.id = "cmdl-backdrop", o.onclick = () => l(!0), document.body.appendChild(o);
	}, d = ({ config: t }) => {
		r = window.scrollY, document.body.classList.add(e), document.body.style.top = `-${r}px`, o || u(), o.style.display = "", t?.backdrop !== !1 && (o.style.backgroundColor = "var(--chc-bg-overlay)", o.style.transition = "opacity 0.15s linear", o.style.opacity = "1");
	}, f = ({ config: e, attr: t, attrs: n, unit: r = "em", value: i }) => {
		let a;
		return ce(t) ? a = de({
			element: e,
			attr: t
		}) : le(n) && (a = n.map((t) => de({
			element: e,
			attr: t
		})).find(Boolean)), a !== void 0 && (i = a), Number.isNaN(i) ? i : `${i}${r}`;
	}, p = ({ buttons: e, config: t, modalNumber: r }) => {
		let i = document.createElement("div");
		i.className = oe(), i.style.padding = f({
			config: t,
			attrs: ["footer.padding", "padding"],
			value: ".5"
		});
		let a = {
			label: t?.dictionary?.close || "Close",
			onClick: () => R.close(),
			intent: "is-info"
		};
		for (let t of e) {
			if (t.hide) continue;
			let e = {
				...a,
				...t
			}, o = document.createElement("button");
			e.disabled !== void 0 && (o.disabled = e.disabled), e.id && (o.id = e.id), o.className = e?.footer?.className || "button font-medium", e.intent && e.intent !== "none" && o.classList.add(e.intent);
			let s = e?.footer?.style || "";
			o.style.cssText = "margin-right: .5em;" + (s ? " " + s : ""), o.innerHTML = e.label || e.text || "", o.onclick = (t) => {
				t.stopPropagation(), L(e.onClick) && e.onClick({
					e: t,
					content: n[r]
				}), e.close !== !1 && (L(e.close) && e.close(), R.close());
			}, i.appendChild(o);
		}
		return i;
	};
	return {
		close: l,
		open: ({ title: e = "", content: r, buttons: o, footer: s, config: c, onClose: u } = {}) => {
			d({ config: c }), i.push(u);
			let m = a.length + 1;
			t[m] = c?.clickAway;
			let h = document.createElement("section"), g = `cmdl-${m}`;
			h.className = te(), h.role = "dialog", h.tabIndex = -1, h.id = g;
			let _ = document.createElement("div");
			_.className = re(), _.style.maxWidth = `${c?.maxWidth || 450}px`, _.onclick = () => l(!0);
			let v = document.createElement("div");
			v.className = I(), v.style.color = "var(--chc-text-primary)", c?.className && v.classList.add(c.className), c?.style && Object.assign(v.style, c.style), v.onclick = (e) => e.stopPropagation();
			let y = document.createElement("div"), b = document.createElement("div");
			y.appendChild(b);
			let x = document.createElement("div");
			x.style.cssText = "display: flex; align-items: center; gap: 8px; margin-left: auto; flex-shrink: 0;";
			let S, C;
			if (c?.info) {
				S = document.createElement("span"), S.innerHTML = "?", S.style.cssText = "\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background-color: #3273dc;\n        color: white;\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 1;\n        flex-shrink: 0;\n        user-select: none;\n      ";
				let e = () => {
					C && document.body.contains(C) && (C.remove(), C = void 0);
				};
				S.onclick = (t) => {
					if (t.stopPropagation(), C && document.body.contains(C)) {
						e();
						return;
					}
					if (!c?.info) return;
					C = document.createElement("div"), C.dataset.modalPopover = "true", C.style.cssText = "\n          position: absolute;\n          z-index: 10000;\n          background-color: var(--chc-bg-elevated);\n          border: 1px solid var(--chc-border-focus, #5b9bd5);\n          border-radius: 4px;\n          box-shadow: 0 2px 8px rgba(0,0,0,0.25);\n          padding: 1em;\n          max-width: 300px;\n          font-size: 14px;\n          font-weight: normal;\n          line-height: 1.5;\n          color: var(--chc-text-primary);\n        ";
					let n = document.createElement("span");
					n.textContent = "×", n.style.cssText = "\n          position: absolute;\n          top: 4px;\n          right: 8px;\n          cursor: pointer;\n          font-size: 18px;\n          line-height: 1;\n          color: var(--chc-text-secondary, #666);\n        ", n.onclick = (t) => {
						t.stopPropagation(), e();
					}, C.appendChild(n);
					let r = document.createElement("style");
					r.textContent = "\n          [data-modal-popover] strong {\n            color: var(--chc-text-primary) !important;\n            font-weight: 600;\n          }\n        ", document.querySelector("[data-modal-popover-styles]") || (r.dataset.modalPopoverStyles = "true", document.head.appendChild(r));
					let i = document.createElement("div");
					ce(c.info) ? i.innerHTML = c.info : i.textContent = String(c.info), C.appendChild(i), document.body.appendChild(C);
					let a = S.getBoundingClientRect();
					C.style.right = `${window.innerWidth - a.left + 5}px`, C.style.top = `${a.bottom + 5}px`, C.style.left = "auto", setTimeout(() => {
						let t = (n) => {
							C && !C.contains(n.target) && n.target !== S && (e(), document.removeEventListener("click", t, !0));
						};
						document.addEventListener("click", t, !0);
					}, 100);
				}, x.appendChild(S);
			}
			let w;
			if (c?.menu?.menuItems?.length) {
				let e = document.createElement("span");
				e.className = "chc-modal-menu-caret", e.innerHTML = "&#9662;", e.style.cssText = "\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 24px;\n        height: 24px;\n        border-radius: 4px;\n        font-size: 14px;\n        flex-shrink: 0;\n        user-select: none;\n        color: var(--chc-text-secondary, #666);\n        transition: background-color 0.15s;\n      ", e.onmouseenter = () => {
					e.style.backgroundColor = "var(--chc-hover-bg, #f0f0f0)";
				}, e.onmouseleave = () => {
					e.style.backgroundColor = "";
				}, e.onclick = (t) => {
					if (t.stopPropagation(), w && document.body.contains(w)) {
						w.remove(), w = void 0;
						return;
					}
					w = document.createElement("div"), w.dataset.modalPopover = "true", w.className = "chc-modal-menu-dropdown";
					for (let e of c.menu.menuItems) {
						let t = document.createElement("div");
						t.className = "chc-modal-menu-item" + (e.active ? " chc-modal-menu-item--active" : ""), t.textContent = e.label, t.onclick = (t) => {
							t.stopPropagation(), w?.remove(), w = void 0, e.onClick();
						}, w.appendChild(t);
					}
					document.body.appendChild(w);
					let n = e.getBoundingClientRect();
					w.style.top = `${n.bottom + 4}px`, w.style.right = `${window.innerWidth - n.right}px`, setTimeout(() => {
						let t = (n) => {
							w && !w.contains(n.target) && n.target !== e && (w.remove(), w = void 0, document.removeEventListener("click", t, !0));
						};
						document.addEventListener("click", t, !0);
					}, 100);
				}, x.appendChild(e);
			}
			(c?.info || c?.menu?.menuItems?.length) && y.appendChild(x), v.appendChild(y);
			let T = c?.info || c?.menu?.menuItems?.length, E = ({ title: e, config: t }) => {
				y.className = e ? ie() : "", y.style.padding = f({
					config: t,
					attrs: ["title.padding", "padding"],
					value: ".5"
				}), y.style.display = e || T ? "flex" : "", y.style.alignItems = "center", y.style.justifyContent = e ? "space-between" : "flex-end", b.className = e ? ae() : "", b.innerHTML = e;
			};
			(e || T) && E({
				title: e,
				config: c
			});
			let D = document.createElement("div");
			v.appendChild(D);
			let O = ({ content: e, config: t }) => {
				D.style.fontSize = f({
					config: t,
					attr: "fontSize",
					value: "15px"
				}), D.style.position = "relative", D.style.padding = f({
					config: t,
					attrs: ["content.padding", "padding"],
					value: ".5"
				}), L(e) ? n[m] = e(D) : e instanceof HTMLElement ? D.appendChild(e) : ce(e) ? D.innerHTML = e : D.innerHTML = se;
			};
			O({
				content: r,
				config: c
			});
			let k;
			if (le(o)) k = p({
				buttons: o,
				config: c,
				modalNumber: m
			}), v.appendChild(k);
			else if (s) {
				let e = document.createElement("div");
				e.className = oe(), e.style.padding = f({
					config: c,
					attrs: ["footer.padding", "padding"]
				}), s instanceof HTMLElement ? e.appendChild(s) : ce(s) ? e.innerHTML = s : e.innerHTML = se, k = e, v.appendChild(e);
			}
			_.appendChild(v), h.appendChild(_), document.body.appendChild(h), a.push(h);
			let A = ({ content: e, config: t }) => {
				n[m] = void 0, ue(D), O({
					content: e,
					config: t
				});
			}, j = ({ buttons: e, config: t }) => {
				k && k.remove(), k = p({
					buttons: e,
					config: t,
					modalNumber: m
				}), v.appendChild(k);
			}, M = ({ onClose: e }) => {
				i.length = 0, i.push(e);
			};
			return {
				setContent: A,
				setButtons: j,
				update: ({ content: e, buttons: t, title: n, config: r, onClose: i }) => {
					c = r || c, C && document.body.contains(C) && (C.remove(), C = void 0), S && (S.style.display = c?.info ? "inline-flex" : "none"), e && A({
						content: e,
						config: c
					}), t && j({
						buttons: t,
						config: c
					}), i && M({ onClose: i }), n && E({
						title: n,
						config: c
					});
				}
			};
		}
	};
})();
//#endregion
//#region src/helpers/getAttr.ts
function de({ element: e, attr: t }) {
	if (!ce(t)) return;
	let n = t.split(".");
	for (let t of n) if (e = e?.[t], !e) return;
	return e;
}
//#endregion
//#region src/components/renderStructure/renderPersonAttribute.ts
function fe({ individualParticipant: e, attribute: t, className: n }) {
	let r = e?.person, i = de({
		element: r,
		attr: t
	});
	if (!i) return "";
	let a = document.createElement("div");
	return a.className = (0, D.default)(P(), n), a.innerHTML = i, a;
}
//#endregion
//#region src/components/renderStructure/renderTeam.ts
function pe({ individualParticipant: e, className: t }) {
	let n = e?.teams?.[0], r = n?.participantName || " ", i = document.createElement("div");
	return i.className = (0, D.default)(P(), t), i.classList.add("tmx-tm"), i.setAttribute("id", n?.participantId || ""), i.innerHTML = r, i;
}
//#endregion
//#region src/components/renderStructure/renderParticipantDetail.ts
function me(e) {
	let t = e?.composition?.configuration?.participantDetail;
	if (t === "TEAM") return pe(e);
	if (e?.composition?.configuration?.showAddress ?? t === "ADDRESS") return F(e);
	if (t) {
		let n = fe({
			...e,
			attribute: t
		});
		if (n && typeof n != "string") return n;
	}
	return document.createElement("div");
}
//#endregion
//#region src/helpers/typeOf.ts
function z(e) {
	return typeof e == "function";
}
function he(e) {
	return typeof e == "object" && !Array.isArray(e);
}
//#endregion
//#region src/helpers/createTypeAhead.ts
var ge = /* @__PURE__ */ E((/* @__PURE__ */ C(((e, t) => {
	(function() {
		var e = function(t, n) {
			var i = this;
			e.count = (e.count || 0) + 1, this.count = e.count, this.isOpened = !1, this.input = a(t), this.input.setAttribute("autocomplete", "off"), this.input.setAttribute("aria-autocomplete", "list"), this.input.setAttribute("aria-expanded", "false"), this.input.setAttribute("aria-controls", "awesomplete_list_" + this.count), this.input.setAttribute("aria-owns", "awesomplete_list_" + this.count), this.input.setAttribute("role", "combobox"), this.options = n ||= {}, r(this, {
				minChars: 2,
				maxItems: 10,
				autoFirst: !1,
				data: e.DATA,
				filter: e.FILTER_CONTAINS,
				sort: n.sort === !1 ? !1 : e.SORT_BYLENGTH,
				container: e.CONTAINER,
				item: e.ITEM,
				replace: e.REPLACE,
				tabSelect: !1,
				listLabel: "Results List",
				statusNoResults: "No results found",
				statusXResults: "{0} results found",
				statusTypeXChar: "Type {0} or more characters for results"
			}, n), this.index = -1, this.container = this.container(t), this.ul = a.create("ul", {
				hidden: "hidden",
				role: "listbox",
				id: "awesomplete_list_" + this.count,
				inside: this.container,
				"aria-label": this.listLabel
			}), this.status = a.create("span", {
				className: "visually-hidden",
				role: "status",
				"aria-live": "assertive",
				"aria-atomic": !0,
				inside: this.container,
				textContent: ""
			}), this._events = {
				input: {
					input: this.evaluate.bind(this),
					blur: this.close.bind(this, { reason: "blur" }),
					keydown: function(e) {
						var t = e.keyCode;
						i.opened && (t === 13 && i.selected || t === 9 && i.selected && i.tabSelect ? (e.preventDefault(), i.select(void 0, void 0, e)) : t === 27 ? i.close({ reason: "esc" }) : (t === 38 || t === 40) && (e.preventDefault(), i[t === 38 ? "previous" : "next"]()));
					}
				},
				form: { submit: this.close.bind(this, { reason: "submit" }) },
				ul: {
					mousedown: function(e) {
						e.preventDefault();
					},
					click: function(e) {
						var t = e.target;
						if (t !== this) {
							for (; t && !/li/i.test(t.nodeName);) t = t.parentNode;
							t && e.button === 0 && (e.preventDefault(), i.select(t, e.target, e));
						}
					}
				}
			}, a.bind(this.input, this._events.input), a.bind(this.input.form, this._events.form), a.bind(this.ul, this._events.ul), this.input.hasAttribute("list") ? (this.list = "#" + this.input.getAttribute("list"), this.input.removeAttribute("list")) : this.list = this.input.getAttribute("data-list") || n.list || [], e.all.push(this);
		};
		e.prototype = {
			set list(e) {
				if (Array.isArray(e)) this._list = e;
				else if (typeof e == "string" && e.indexOf(",") > -1) this._list = e.split(/\s*,\s*/);
				else if (e = a(e), e && e.children) {
					var t = [];
					i.apply(e.children).forEach(function(e) {
						if (!e.disabled) {
							var n = e.textContent.trim(), r = e.value || n, i = e.label || n;
							r !== "" && t.push({
								label: i,
								value: r
							});
						}
					}), this._list = t;
				}
				document.activeElement === this.input && this.evaluate();
			},
			get selected() {
				return this.index > -1;
			},
			get opened() {
				return this.isOpened;
			},
			close: function(e) {
				this.opened && (this.input.setAttribute("aria-expanded", "false"), this.ul.setAttribute("hidden", ""), this.isOpened = !1, this.index = -1, this.status.setAttribute("hidden", ""), this.input.setAttribute("aria-activedescendant", ""), a.fire(this.input, "awesomplete-close", e || {}));
			},
			open: function() {
				this.input.setAttribute("aria-expanded", "true"), this.ul.removeAttribute("hidden"), this.isOpened = !0, this.status.removeAttribute("hidden"), this.autoFirst && this.index === -1 && this.goto(0), a.fire(this.input, "awesomplete-open");
			},
			destroy: function() {
				if (a.unbind(this.input, this._events.input), a.unbind(this.input.form, this._events.form), !this.options.container) {
					var t = this.container.parentNode;
					t.insertBefore(this.input, this.container), t.removeChild(this.container);
				}
				this.input.removeAttribute("autocomplete"), this.input.removeAttribute("aria-autocomplete"), this.input.removeAttribute("aria-expanded"), this.input.removeAttribute("aria-controls"), this.input.removeAttribute("aria-owns"), this.input.removeAttribute("role");
				var n = e.all.indexOf(this);
				n !== -1 && e.all.splice(n, 1);
			},
			next: function() {
				var e = this.ul.children.length;
				this.goto(this.index < e - 1 ? this.index + 1 : e ? 0 : -1);
			},
			previous: function() {
				var e = this.ul.children.length, t = this.index - 1;
				this.goto(this.selected && t !== -1 ? t : e - 1);
			},
			goto: function(e) {
				var t = this.ul.children;
				this.selected && t[this.index].setAttribute("aria-selected", "false"), this.index = e, e > -1 && t.length > 0 && (t[e].setAttribute("aria-selected", "true"), this.input.setAttribute("aria-activedescendant", this.ul.id + "_item_" + this.index), this.ul.scrollTop = t[e].offsetTop - this.ul.clientHeight + t[e].clientHeight, a.fire(this.input, "awesomplete-highlight", { text: this.suggestions[this.index] }));
			},
			select: function(e, t, n) {
				if (e ? this.index = a.siblingIndex(e) : e = this.ul.children[this.index], e) {
					var r = this.suggestions[this.index];
					a.fire(this.input, "awesomplete-select", {
						text: r,
						origin: t || e,
						originalEvent: n
					}) && (this.replace(r), this.close({ reason: "select" }), a.fire(this.input, "awesomplete-selectcomplete", {
						text: r,
						originalEvent: n
					}));
				}
			},
			evaluate: function() {
				var e = this, t = this.input.value;
				t.length >= this.minChars && this._list && this._list.length > 0 ? (this.index = -1, this.ul.innerHTML = "", this.suggestions = this._list.map(function(r) {
					return new n(e.data(r, t));
				}).filter(function(n) {
					return e.filter(n, t);
				}), this.sort !== !1 && (this.suggestions = this.suggestions.sort(this.sort)), this.suggestions = this.suggestions.slice(0, this.maxItems), this.suggestions.forEach(function(n, r) {
					e.ul.appendChild(e.item(n, t, r));
				}), this.ul.children.length === 0 ? (this.status.textContent = this.statusNoResults, this.close({ reason: "nomatches" })) : (this.input.setAttribute("aria-activedescendant", ""), this.open(), this.status.textContent = this.statusXResults.replaceAll("{0}", this.ul.children.length))) : (this.close({ reason: "nomatches" }), this.minChar <= 1 || t.length >= this.minChars ? this.status.textContent = this.statusNoResults : this.status.textContent = this.statusTypeXChar.replaceAll("{0}", this.minChars));
			}
		}, e.all = [], e.FILTER_CONTAINS = function(e, t) {
			return RegExp(a.regExpEscape(t.trim()), "i").test(e);
		}, e.FILTER_STARTSWITH = function(e, t) {
			return RegExp("^" + a.regExpEscape(t.trim()), "i").test(e);
		}, e.SORT_BYLENGTH = function(e, t) {
			return e.length === t.length ? e < t ? -1 : 1 : e.length - t.length;
		}, e.CONTAINER = function(e) {
			return a.create("div", {
				className: "awesomplete",
				around: e
			});
		}, e.ITEM = function(e, t, n) {
			var r = t.trim() === "" ? e : e.replace(RegExp(a.regExpEscape(t.trim()), "gi"), "<mark>$&</mark>");
			return a.create("li", {
				innerHTML: r,
				role: "option",
				"aria-selected": "false",
				tabindex: "-1",
				id: "awesomplete_list_" + this.count + "_item_" + n
			});
		}, e.REPLACE = function(e) {
			this.input.value = e.value;
		}, e.DATA = function(e) {
			return e;
		};
		function n(e) {
			var t = Array.isArray(e) ? {
				label: e[0],
				value: e[1]
			} : typeof e == "object" && "label" in e && "value" in e ? e : {
				label: e,
				value: e
			};
			this.label = t.label || t.value, this.value = t.value;
		}
		Object.defineProperty(n.prototype = Object.create(String.prototype), "length", { get: function() {
			return this.label.length;
		} }), n.prototype.toString = n.prototype.valueOf = function() {
			return "" + this.label;
		};
		function r(e, t, n) {
			for (var r in t) {
				var i = t[r], a = e.input.getAttribute("data-" + r.toLowerCase());
				typeof i == "number" ? e[r] = parseInt(a) : i === !1 ? e[r] = a !== null : i instanceof Function ? e[r] = null : e[r] = a, !e[r] && e[r] !== 0 && (e[r] = r in n ? n[r] : i);
			}
		}
		var i = Array.prototype.slice;
		function a(e, t) {
			return typeof e == "string" ? (t || document).querySelector(e) : e || null;
		}
		function o(e, t) {
			return i.call((t || document).querySelectorAll(e));
		}
		a.create = function(e, t) {
			var n = document.createElement(e);
			for (var r in t) {
				var i = t[r];
				if (r === "inside") a(i).appendChild(n);
				else if (r === "around") {
					var o = a(i);
					o.parentNode.insertBefore(n, o), n.appendChild(o), o.getAttribute("autofocus") != null && o.focus();
				} else r in n ? n[r] = i : n.setAttribute(r, i);
			}
			return n;
		}, a.bind = function(e, t) {
			if (e) for (var n in t) {
				var r = t[n];
				n.split(/\s+/).forEach(function(t) {
					e.addEventListener(t, r);
				});
			}
		}, a.unbind = function(e, t) {
			if (e) for (var n in t) {
				var r = t[n];
				n.split(/\s+/).forEach(function(t) {
					e.removeEventListener(t, r);
				});
			}
		}, a.fire = function(e, t, n) {
			var r = document.createEvent("HTMLEvents");
			for (var i in r.initEvent(t, !0, !0), n) r[i] = n[i];
			return e.dispatchEvent(r);
		}, a.regExpEscape = function(e) {
			return e.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
		}, a.siblingIndex = function(e) {
			for (var t = 0; e = e.previousElementSibling; t++);
			return t;
		};
		function s() {
			o("input.awesomplete").forEach(function(t) {
				new e(t);
			});
		}
		return typeof self < "u" && (self.Awesomplete = e), typeof Document < "u" && (document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", s) : s()), e.$ = a, e.$$ = o, typeof t == "object" && t.exports && (t.exports = e), e;
	})();
})))());
function _e({ list: e, element: t, callback: n, currentValue: r, withCatchTab: i, onChange: a, onSelectComplete: o, listProvider: s }) {
	let c = new ge.default(t, { list: e });
	t.parentElement && (t.parentElement.style.width = "100%"), z(s) && t.addEventListener("focus", () => {
		c.list = s();
	});
	let l = !1, u = "", d = (e) => {
		l = !0, z(n) && n(e.text.value), t.value = e.text.label, c.suggestions = [], z(o) && setTimeout(() => o(), 0);
	};
	if (i) {
		let e = (e) => e.key === "Tab" && e.preventDefault();
		t.addEventListener("keydown", e, !1), t.addEventListener("keyup", e, !1);
	}
	if (typeof a == "function" && t.addEventListener("change", a), t.setAttribute("autocomplete", "off"), t.addEventListener("focus", () => {
		u = t.value;
	}), t.addEventListener("awesomplete-selectcomplete", (e) => d(e), !1), t.addEventListener("keyup", function(e) {
		let r = e.key === "Tab" && e.shiftKey;
		if ((e.key === "Enter" || e.key === "Tab" && !r) && !l) {
			let r = t.value.trim(), i = r === "";
			if (e.key === "Tab" && r === u && !i) return;
			if (e.key === "Enter" && i) {
				z(n) && n(""), t.value = "", c.suggestions = [], z(o) && setTimeout(() => o(), 0);
				return;
			}
			c.suggestions?.length && !i && (c.next(), c.select(0));
		}
		l = !1;
	}), r) {
		let n = e.find((e) => e.value === r)?.label;
		n && (t.value = n);
	}
	return { typeAhead: c };
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/lib/utils.js
function ve(e) {
	return e[e.length - 1];
}
function ye(e, ...t) {
	return t.forEach((t) => {
		e.includes(t) || e.push(t);
	}), e;
}
function be(e, t) {
	return e ? e.split(t) : [];
}
function xe(e, t, n) {
	return (t === void 0 || e >= t) && (n === void 0 || e <= n);
}
function Se(e, t, n) {
	return e < t ? t : e > n ? n : e;
}
function Ce(e, t, n = {}, r = 0, i = "") {
	let a = Object.keys(n).reduce((e, t) => {
		let i = n[t];
		return typeof i == "function" && (i = i(r)), `${e} ${t}="${i}"`;
	}, e);
	i += `<${a}></${e}>`;
	let o = r + 1;
	return o < t ? Ce(e, t, n, o, i) : i;
}
function we(e) {
	return e.replace(/>\s+/g, ">").replace(/\s+</, "<");
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/lib/date.js
function Te(e) {
	return new Date(e).setHours(0, 0, 0, 0);
}
function Ee() {
	return (/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0);
}
function De(...e) {
	switch (e.length) {
		case 0: return Ee();
		case 1: return Te(e[0]);
	}
	let t = /* @__PURE__ */ new Date(0);
	return t.setFullYear(...e), t.setHours(0, 0, 0, 0);
}
function Oe(e, t) {
	let n = new Date(e);
	return n.setDate(n.getDate() + t);
}
function ke(e, t) {
	return Oe(e, t * 7);
}
function Ae(e, t) {
	let n = new Date(e), r = n.getMonth() + t, i = r % 12;
	i < 0 && (i += 12);
	let a = n.setMonth(r);
	return n.getMonth() === i ? a : n.setDate(0);
}
function je(e, t) {
	let n = new Date(e), r = n.getMonth(), i = n.setFullYear(n.getFullYear() + t);
	return r === 1 && n.getMonth() === 2 ? n.setDate(0) : i;
}
function Me(e, t) {
	return (e - t + 7) % 7;
}
function Ne(e, t, n = 0) {
	let r = new Date(e).getDay();
	return Oe(e, Me(t, n) - Me(r, n));
}
function Pe(e, t) {
	return Math.round((e - t) / 6048e5) + 1;
}
function Fe(e) {
	let t = Ne(e, 4, 1);
	return Pe(t, Ne(new Date(t).setMonth(0, 4), 4, 1));
}
function Ie(e, t) {
	let n = Ne(new Date(e).setMonth(0, 1), t, t), r = Ne(e, t, t), i = Pe(r, n);
	return i < 53 ? i : r === Ne(new Date(e).setDate(32), t, t) ? 1 : i;
}
function Le(e) {
	return Ie(e, 0);
}
function Re(e) {
	return Ie(e, 6);
}
function ze(e, t) {
	let n = new Date(e).getFullYear();
	return Math.floor(n / t) * t;
}
function Be(e, t, n) {
	if (t !== 1 && t !== 2) return e;
	let r = new Date(e);
	return t === 1 ? n ? r.setMonth(r.getMonth() + 1, 0) : r.setDate(1) : n ? r.setFullYear(r.getFullYear() + 1, 0, 0) : r.setMonth(0, 1), r.setHours(0, 0, 0, 0);
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/lib/date-format.js
var Ve = /dd?|DD?|mm?|MM?|yy?(?:yy)?/, He = /[\s!-/:-@[-`{-~年月日]+/, Ue = {}, We = {
	y(e, t) {
		return new Date(e).setFullYear(parseInt(t, 10));
	},
	m(e, t, n) {
		let r = new Date(e), i = parseInt(t, 10) - 1;
		if (isNaN(i)) {
			if (!t) return NaN;
			let e = t.toLowerCase(), r = (t) => t.toLowerCase().startsWith(e);
			if (i = n.monthsShort.findIndex(r), i < 0 && (i = n.months.findIndex(r)), i < 0) return NaN;
		}
		return r.setMonth(i), r.getMonth() === Ke(i) ? r.getTime() : r.setDate(0);
	},
	d(e, t) {
		return new Date(e).setDate(parseInt(t, 10));
	}
}, Ge = {
	d(e) {
		return e.getDate();
	},
	dd(e) {
		return qe(e.getDate(), 2);
	},
	D(e, t) {
		return t.daysShort[e.getDay()];
	},
	DD(e, t) {
		return t.days[e.getDay()];
	},
	m(e) {
		return e.getMonth() + 1;
	},
	mm(e) {
		return qe(e.getMonth() + 1, 2);
	},
	M(e, t) {
		return t.monthsShort[e.getMonth()];
	},
	MM(e, t) {
		return t.months[e.getMonth()];
	},
	y(e) {
		return e.getFullYear();
	},
	yy(e) {
		return qe(e.getFullYear(), 2).slice(-2);
	},
	yyyy(e) {
		return qe(e.getFullYear(), 4);
	}
};
function Ke(e) {
	return e > -1 ? e % 12 : Ke(e + 12);
}
function qe(e, t) {
	return e.toString().padStart(t, "0");
}
function Je(e) {
	if (typeof e != "string") throw Error("Invalid date format.");
	if (e in Ue) return Ue[e];
	let t = e.split(Ve), n = e.match(new RegExp(Ve, "g"));
	if (t.length === 0 || !n) throw Error("Invalid date format.");
	let r = n.map((e) => Ge[e]), i = Object.keys(We).reduce((e, t) => (n.find((e) => e[0] !== "D" && e[0].toLowerCase() === t) && e.push(t), e), []);
	return Ue[e] = {
		parser(e, t) {
			let r = e.split(He).reduce((e, t, r) => {
				if (t.length > 0 && n[r]) {
					let i = n[r][0];
					i === "M" ? e.m = t : i !== "D" && (e[i] = t);
				}
				return e;
			}, {});
			return i.reduce((e, n) => {
				let i = We[n](e, r[n], t);
				return isNaN(i) ? e : i;
			}, Ee());
		},
		formatter(e, n) {
			let i = r.reduce((r, i, a) => r += `${t[a]}${i(e, n)}`, "");
			return i += ve(t);
		}
	};
}
function Ye(e, t, n) {
	if (e instanceof Date || typeof e == "number") {
		let t = Te(e);
		return isNaN(t) ? void 0 : t;
	}
	if (e) {
		if (e === "today") return Ee();
		if (t && t.toValue) {
			let r = t.toValue(e, t, n);
			return isNaN(r) ? void 0 : Te(r);
		}
		return Je(t).parser(e, n);
	}
}
function Xe(e, t, n) {
	if (isNaN(e) || !e && e !== 0) return "";
	let r = typeof e == "number" ? new Date(e) : e;
	return t.toDisplay ? t.toDisplay(r, t, n) : Je(t).formatter(r, n);
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/lib/dom.js
var Ze = document.createRange();
function Qe(e) {
	return Ze.createContextualFragment(e);
}
function $e(e) {
	return e.parentElement || (e.parentNode instanceof ShadowRoot ? e.parentNode.host : void 0);
}
function et(e) {
	return e.getRootNode().activeElement === e;
}
function tt(e) {
	e.style.display !== "none" && (e.style.display && (e.dataset.styleDisplay = e.style.display), e.style.display = "none");
}
function nt(e) {
	e.style.display === "none" && (e.dataset.styleDisplay ? (e.style.display = e.dataset.styleDisplay, delete e.dataset.styleDisplay) : e.style.display = "");
}
function rt(e) {
	e.firstChild && (e.removeChild(e.firstChild), rt(e));
}
function it(e, t) {
	rt(e), t instanceof DocumentFragment ? e.appendChild(t) : typeof t == "string" ? e.appendChild(Qe(t)) : typeof t.forEach == "function" && t.forEach((t) => {
		e.appendChild(t);
	});
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/lib/event.js
var at = /* @__PURE__ */ new WeakMap(), { addEventListener: ot, removeEventListener: st } = EventTarget.prototype;
function ct(e, t) {
	let n = at.get(e);
	n || (n = [], at.set(e, n)), t.forEach((e) => {
		ot.call(...e), n.push(e);
	});
}
function lt(e) {
	let t = at.get(e);
	t && (t.forEach((e) => {
		st.call(...e);
	}), at.delete(e));
}
if (!Event.prototype.composedPath) {
	let e = (t, n = []) => {
		n.push(t);
		let r;
		return t.parentNode ? r = t.parentNode : t.host ? r = t.host : t.defaultView && (r = t.defaultView), r ? e(r, n) : n;
	};
	Event.prototype.composedPath = function() {
		return e(this.target);
	};
}
function ut(e, t, n) {
	let [r, ...i] = e;
	if (t(r)) return r;
	if (!(r === n || r.tagName === "HTML" || i.length === 0)) return ut(i, t, n);
}
function dt(e, t) {
	let n = typeof t == "function" ? t : (e) => e instanceof Element && e.matches(t);
	return ut(e.composedPath(), n, e.currentTarget);
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/i18n/base-locales.js
var ft = { en: {
	days: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	],
	daysShort: [
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat"
	],
	daysMin: [
		"Su",
		"Mo",
		"Tu",
		"We",
		"Th",
		"Fr",
		"Sa"
	],
	months: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	],
	monthsShort: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	],
	today: "Today",
	clear: "Clear",
	titleFormat: "MM y"
} }, pt = {
	autohide: !1,
	beforeShowDay: null,
	beforeShowDecade: null,
	beforeShowMonth: null,
	beforeShowYear: null,
	clearButton: !1,
	dateDelimiter: ",",
	datesDisabled: [],
	daysOfWeekDisabled: [],
	daysOfWeekHighlighted: [],
	defaultViewDate: void 0,
	disableTouchKeyboard: !1,
	enableOnReadonly: !0,
	format: "mm/dd/yyyy",
	language: "en",
	maxDate: null,
	maxNumberOfDates: 1,
	maxView: 3,
	minDate: null,
	nextArrow: "»",
	orientation: "auto",
	pickLevel: 0,
	prevArrow: "«",
	showDaysOfWeek: !0,
	showOnClick: !0,
	showOnFocus: !0,
	startView: 0,
	title: "",
	todayButton: !1,
	todayButtonMode: 0,
	todayHighlight: !1,
	updateOnBlur: !0,
	weekNumbers: 0,
	weekStart: 0
}, { language: mt, format: ht, weekStart: gt } = pt;
function _t(e, t) {
	return e.length < 6 && t >= 0 && t < 7 ? ye(e, t) : e;
}
function vt(e, t) {
	switch (e === 4 ? t === 6 ? 3 : !t + 1 : e) {
		case 1: return Fe;
		case 2: return Le;
		case 3: return Re;
	}
}
function yt(e, t, n) {
	return t.weekStart = e, t.weekEnd = (e + 6) % 7, n === 4 && (t.getWeekNumber = vt(4, e)), e;
}
function bt(e, t, n, r) {
	let i = Ye(e, t, n);
	return i === void 0 ? r : i;
}
function xt(e, t, n = 3) {
	let r = parseInt(e, 10);
	return r >= 0 && r <= n ? r : t;
}
function St(e, t, n, r = void 0) {
	t in e && (n in e || (e[n] = r ? r(e[t]) : e[t]), delete e[t]);
}
function Ct(e, t) {
	let n = Object.assign({}, e), r = {}, i = t.constructor.locales, a = !!t.rangeSideIndex, { datesDisabled: o, format: s, language: c, locale: l, maxDate: u, maxView: d, minDate: f, pickLevel: p, startView: m, weekNumbers: h, weekStart: g } = t.config || {};
	if (St(n, "calendarWeeks", "weekNumbers", (e) => e ? 1 : 0), St(n, "clearBtn", "clearButton"), St(n, "todayBtn", "todayButton"), St(n, "todayBtnMode", "todayButtonMode"), n.language) {
		let e;
		if (n.language !== c && (i[n.language] ? e = n.language : (e = n.language.split("-")[0], i[e] || (e = !1))), delete n.language, e) {
			c = r.language = e;
			let t = l || i[mt];
			l = Object.assign({
				format: ht,
				weekStart: gt
			}, i[mt]), c !== mt && Object.assign(l, i[c]), r.locale = l, s === t.format && (s = r.format = l.format), g === t.weekStart && (g = yt(l.weekStart, r, h));
		}
	}
	if (n.format) {
		let e = typeof n.format.toDisplay == "function", t = typeof n.format.toValue == "function", i = Ve.test(n.format);
		(e && t || i) && (s = r.format = n.format), delete n.format;
	}
	let _ = p;
	"pickLevel" in n && (_ = xt(n.pickLevel, p, 2), delete n.pickLevel), _ !== p && (_ > p && ("minDate" in n || (n.minDate = f), "maxDate" in n || (n.maxDate = u)), o && !n.datesDisabled && (n.datesDisabled = []), p = r.pickLevel = _);
	let v = f, y = u;
	if ("minDate" in n) {
		let e = De(0, 0, 1);
		v = n.minDate === null ? e : bt(n.minDate, s, l, v), v !== e && (v = Be(v, p, !1)), delete n.minDate;
	}
	if ("maxDate" in n && (y = n.maxDate === null ? void 0 : bt(n.maxDate, s, l, y), y !== void 0 && (y = Be(y, p, !0)), delete n.maxDate), y < v ? (f = r.minDate = y, u = r.maxDate = v) : (f !== v && (f = r.minDate = v), u !== y && (u = r.maxDate = y)), n.datesDisabled) {
		let e = n.datesDisabled;
		if (typeof e == "function") r.datesDisabled = null, r.checkDisabled = (t, n) => e(new Date(t), n, a);
		else {
			let t = r.datesDisabled = e.reduce((e, t) => {
				let n = Ye(t, s, l);
				return n === void 0 ? e : ye(e, Be(n, p, a));
			}, []);
			r.checkDisabled = (e) => t.includes(e);
		}
		delete n.datesDisabled;
	}
	if ("defaultViewDate" in n) {
		let e = Ye(n.defaultViewDate, s, l);
		e !== void 0 && (r.defaultViewDate = e), delete n.defaultViewDate;
	}
	if ("weekStart" in n) {
		let e = Number(n.weekStart) % 7;
		isNaN(e) || (g = yt(e, r, h)), delete n.weekStart;
	}
	if (n.daysOfWeekDisabled && (r.daysOfWeekDisabled = n.daysOfWeekDisabled.reduce(_t, []), delete n.daysOfWeekDisabled), n.daysOfWeekHighlighted && (r.daysOfWeekHighlighted = n.daysOfWeekHighlighted.reduce(_t, []), delete n.daysOfWeekHighlighted), "weekNumbers" in n) {
		let e = n.weekNumbers;
		if (e) {
			let t = typeof e == "function" ? (t, n) => e(new Date(t), n) : vt(e = parseInt(e, 10), g);
			t && (h = r.weekNumbers = e, r.getWeekNumber = t);
		} else h = r.weekNumbers = 0, r.getWeekNumber = null;
		delete n.weekNumbers;
	}
	if ("maxNumberOfDates" in n) {
		let e = parseInt(n.maxNumberOfDates, 10);
		e >= 0 && (r.maxNumberOfDates = e, r.multidate = e !== 1), delete n.maxNumberOfDates;
	}
	n.dateDelimiter && (r.dateDelimiter = String(n.dateDelimiter), delete n.dateDelimiter);
	let b = d;
	"maxView" in n && (b = xt(n.maxView, d), delete n.maxView), b = p > b ? p : b, b !== d && (d = r.maxView = b);
	let x = m;
	if ("startView" in n && (x = xt(n.startView, x), delete n.startView), x < p ? x = p : x > d && (x = d), x !== m && (r.startView = x), n.prevArrow) {
		let e = Qe(n.prevArrow);
		e.childNodes.length > 0 && (r.prevArrow = e.childNodes), delete n.prevArrow;
	}
	if (n.nextArrow) {
		let e = Qe(n.nextArrow);
		e.childNodes.length > 0 && (r.nextArrow = e.childNodes), delete n.nextArrow;
	}
	if ("disableTouchKeyboard" in n && (r.disableTouchKeyboard = "ontouchstart" in document && !!n.disableTouchKeyboard, delete n.disableTouchKeyboard), n.orientation) {
		let e = n.orientation.toLowerCase().split(/\s+/g);
		r.orientation = {
			x: e.find((e) => e === "left" || e === "right") || "auto",
			y: e.find((e) => e === "top" || e === "bottom") || "auto"
		}, delete n.orientation;
	}
	if ("todayButtonMode" in n) {
		switch (n.todayButtonMode) {
			case 0:
			case 1: r.todayButtonMode = n.todayButtonMode;
		}
		delete n.todayButtonMode;
	}
	return Object.entries(n).forEach(([e, t]) => {
		t !== void 0 && e in pt && (r[e] = t);
	}), r;
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/options/shortcutKeys.js
var wt = {
	show: { key: "ArrowDown" },
	hide: null,
	toggle: { key: "Escape" },
	prevButton: {
		key: "ArrowLeft",
		ctrlOrMetaKey: !0
	},
	nextButton: {
		key: "ArrowRight",
		ctrlOrMetaKey: !0
	},
	viewSwitch: {
		key: "ArrowUp",
		ctrlOrMetaKey: !0
	},
	clearButton: {
		key: "Backspace",
		ctrlOrMetaKey: !0
	},
	todayButton: {
		key: ".",
		ctrlOrMetaKey: !0
	},
	exitEditMode: {
		key: "ArrowDown",
		ctrlOrMetaKey: !0
	}
};
function Tt(e) {
	return Object.keys(wt).reduce((t, n) => {
		let r = e[n] === void 0 ? wt[n] : e[n], i = r && r.key;
		if (!i || typeof i != "string") return t;
		let a = {
			key: i,
			ctrlOrMetaKey: !!(r.ctrlOrMetaKey || r.ctrlKey || r.metaKey)
		};
		return i.length > 1 && (a.altKey = !!r.altKey, a.shiftKey = !!r.shiftKey), t[n] = a, t;
	}, {});
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/picker/templates/pickerTemplate.js
var Et = (e) => e.map((e) => `<button type="button" class="%buttonClass% ${e}" tabindex="-1"></button>`).join(""), Dt = we(`<div class="datepicker">
  <div class="datepicker-picker">
    <div class="datepicker-header">
      <div class="datepicker-title"></div>
      <div class="datepicker-controls">
        ${Et([
	"prev-button prev-btn",
	"view-switch",
	"next-button next-btn"
])}
      </div>
    </div>
    <div class="datepicker-main"></div>
    <div class="datepicker-footer">
      <div class="datepicker-controls">
        ${Et(["today-button today-btn", "clear-button clear-btn"])}
      </div>
    </div>
  </div>
</div>`), Ot = we(`<div class="days">
  <div class="days-of-week">${Ce("span", 7, { class: "dow" })}</div>
  <div class="datepicker-grid">${Ce("span", 42)}</div>
</div>`), kt = we(`<div class="week-numbers calendar-weeks">
  <div class="days-of-week"><span class="dow"></span></div>
  <div class="weeks">${Ce("span", 6, { class: "week" })}</div>
</div>`), At = class {
	constructor(e, t) {
		Object.assign(this, t, {
			picker: e,
			element: Qe("<div class=\"datepicker-view\"></div>").firstChild,
			selected: [],
			isRangeEnd: !!e.datepicker.rangeSideIndex
		}), this.init(this.picker.datepicker.config);
	}
	init(e) {
		"pickLevel" in e && (this.isMinView = this.id === e.pickLevel), this.setOptions(e), this.updateFocus(), this.updateSelection();
	}
	prepareForRender(e, t, n) {
		this.disabled = [];
		let r = this.picker;
		r.setViewSwitchLabel(e), r.setPrevButtonDisabled(t), r.setNextButtonDisabled(n);
	}
	setDisabled(e, t) {
		t.add("disabled"), ye(this.disabled, e);
	}
	performBeforeHook(e, t) {
		let n = this.beforeShow(new Date(t));
		switch (typeof n) {
			case "boolean":
				n = { enabled: n };
				break;
			case "string": n = { classes: n };
		}
		if (n) {
			let r = e.classList;
			if (n.enabled === !1 && this.setDisabled(t, r), n.classes) {
				let e = n.classes.split(/\s+/);
				r.add(...e), e.includes("disabled") && this.setDisabled(t, r);
			}
			n.content && it(e, n.content);
		}
	}
	renderCell(e, t, n, r, { selected: i, range: a }, o, s = []) {
		e.textContent = t, this.isMinView && (e.dataset.date = r);
		let c = e.classList;
		if (e.className = `datepicker-cell ${this.cellClass}`, n < this.first ? c.add("prev") : n > this.last && c.add("next"), c.add(...s), (o || this.checkDisabled(r, this.id)) && this.setDisabled(r, c), a) {
			let [e, t] = a;
			n > e && n < t && c.add("range"), n === e && c.add("range-start"), n === t && c.add("range-end");
		}
		i.includes(n) && c.add("selected"), n === this.focused && c.add("focused"), this.beforeShow && this.performBeforeHook(e, r);
	}
	refreshCell(e, t, n, [r, i]) {
		let a = e.classList;
		a.remove("range", "range-start", "range-end", "selected", "focused"), t > r && t < i && a.add("range"), t === r && a.add("range-start"), t === i && a.add("range-end"), n.includes(t) && a.add("selected"), t === this.focused && a.add("focused");
	}
	changeFocusedCell(e) {
		this.grid.querySelectorAll(".focused").forEach((e) => {
			e.classList.remove("focused");
		}), this.grid.children[e].classList.add("focused");
	}
}, jt = class extends At {
	constructor(e) {
		super(e, {
			id: 0,
			name: "days",
			cellClass: "day"
		});
	}
	init(e, t = !0) {
		if (t) {
			let e = Qe(Ot).firstChild;
			this.dow = e.firstChild, this.grid = e.lastChild, this.element.appendChild(e);
		}
		super.init(e);
	}
	setOptions(e) {
		let t;
		if ("minDate" in e && (this.minDate = e.minDate), "maxDate" in e && (this.maxDate = e.maxDate), e.checkDisabled && (this.checkDisabled = e.checkDisabled), e.daysOfWeekDisabled && (this.daysOfWeekDisabled = e.daysOfWeekDisabled, t = !0), e.daysOfWeekHighlighted && (this.daysOfWeekHighlighted = e.daysOfWeekHighlighted), "todayHighlight" in e && (this.todayHighlight = e.todayHighlight), "weekStart" in e && (this.weekStart = e.weekStart, this.weekEnd = e.weekEnd, t = !0), e.locale) {
			let n = this.locale = e.locale;
			this.dayNames = n.daysMin, this.switchLabelFormat = n.titleFormat, t = !0;
		}
		if ("beforeShowDay" in e && (this.beforeShow = typeof e.beforeShowDay == "function" ? e.beforeShowDay : void 0), "weekNumbers" in e) if (e.weekNumbers && !this.weekNumbers) {
			let e = Qe(kt).firstChild;
			this.weekNumbers = {
				element: e,
				dow: e.firstChild,
				weeks: e.lastChild
			}, this.element.insertBefore(e, this.element.firstChild);
		} else this.weekNumbers && !e.weekNumbers && (this.element.removeChild(this.weekNumbers.element), this.weekNumbers = null);
		"getWeekNumber" in e && (this.getWeekNumber = e.getWeekNumber), "showDaysOfWeek" in e && (e.showDaysOfWeek ? (nt(this.dow), this.weekNumbers && nt(this.weekNumbers.dow)) : (tt(this.dow), this.weekNumbers && tt(this.weekNumbers.dow))), t && Array.from(this.dow.children).forEach((e, t) => {
			let n = (this.weekStart + t) % 7;
			e.textContent = this.dayNames[n], e.className = this.daysOfWeekDisabled.includes(n) ? "dow disabled" : "dow";
		});
	}
	updateFocus() {
		let e = new Date(this.picker.viewDate), t = e.getFullYear(), n = e.getMonth(), r = De(t, n, 1), i = Ne(r, this.weekStart, this.weekStart);
		this.first = r, this.last = De(t, n + 1, 0), this.start = i, this.focused = this.picker.viewDate;
	}
	updateSelection() {
		let { dates: e, rangepicker: t } = this.picker.datepicker;
		this.selected = e, t && (this.range = t.dates);
	}
	render() {
		if (this.today = this.todayHighlight ? Ee() : void 0, this.prepareForRender(Xe(this.focused, this.switchLabelFormat, this.locale), this.first <= this.minDate, this.last >= this.maxDate), this.weekNumbers) {
			let e = this.weekStart, t = Ne(this.first, e, e);
			Array.from(this.weekNumbers.weeks.children).forEach((n, r) => {
				let i = ke(t, r);
				n.textContent = this.getWeekNumber(i, e), r > 3 && n.classList[i > this.last ? "add" : "remove"]("next");
			});
		}
		Array.from(this.grid.children).forEach((e, t) => {
			let n = Oe(this.start, t), r = new Date(n), i = r.getDay(), a = [];
			this.today === n && a.push("today"), this.daysOfWeekHighlighted.includes(i) && a.push("highlighted"), this.renderCell(e, r.getDate(), n, n, this, n < this.minDate || n > this.maxDate || this.daysOfWeekDisabled.includes(i), a);
		});
	}
	refresh() {
		let e = this.range || [];
		Array.from(this.grid.children).forEach((t) => {
			this.refreshCell(t, Number(t.dataset.date), this.selected, e);
		});
	}
	refreshFocus() {
		this.changeFocusedCell(Math.round((this.focused - this.start) / 864e5));
	}
};
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/picker/views/MonthsView.js
function Mt(e, t) {
	if (!e || !e[0] || !e[1]) return;
	let [[n, r], [i, a]] = e;
	if (!(n > t || i < t)) return [n === t ? r : -1, i === t ? a : 12];
}
var Nt = class extends At {
	constructor(e) {
		super(e, {
			id: 1,
			name: "months",
			cellClass: "month"
		});
	}
	init(e, t = !0) {
		t && (this.grid = this.element, this.element.classList.add("months", "datepicker-grid"), this.grid.appendChild(Qe(Ce("span", 12, { "data-month": (e) => e }))), this.first = 0, this.last = 11), super.init(e);
	}
	setOptions(e) {
		if (e.locale && (this.monthNames = e.locale.monthsShort), "minDate" in e) if (e.minDate === void 0) this.minYear = this.minMonth = this.minDate = void 0;
		else {
			let t = new Date(e.minDate);
			this.minYear = t.getFullYear(), this.minMonth = t.getMonth(), this.minDate = t.setDate(1);
		}
		if ("maxDate" in e) if (e.maxDate === void 0) this.maxYear = this.maxMonth = this.maxDate = void 0;
		else {
			let t = new Date(e.maxDate);
			this.maxYear = t.getFullYear(), this.maxMonth = t.getMonth(), this.maxDate = De(this.maxYear, this.maxMonth + 1, 0);
		}
		e.checkDisabled && (this.checkDisabled = this.isMinView || e.datesDisabled === null ? e.checkDisabled : () => !1), "beforeShowMonth" in e && (this.beforeShow = typeof e.beforeShowMonth == "function" ? e.beforeShowMonth : void 0);
	}
	updateFocus() {
		let e = new Date(this.picker.viewDate);
		this.year = e.getFullYear(), this.focused = e.getMonth();
	}
	updateSelection() {
		let { dates: e, rangepicker: t } = this.picker.datepicker;
		this.selected = e.reduce((e, t) => {
			let n = new Date(t), r = n.getFullYear(), i = n.getMonth();
			return e[r] === void 0 ? e[r] = [i] : ye(e[r], i), e;
		}, {}), t && t.dates && (this.range = t.dates.map((e) => {
			let t = new Date(e);
			return isNaN(t) ? void 0 : [t.getFullYear(), t.getMonth()];
		}));
	}
	render() {
		this.prepareForRender(this.year, this.year <= this.minYear, this.year >= this.maxYear);
		let e = this.selected[this.year] || [], t = this.year < this.minYear || this.year > this.maxYear, n = this.year === this.minYear, r = this.year === this.maxYear, i = Mt(this.range, this.year);
		Array.from(this.grid.children).forEach((a, o) => {
			let s = Be(new Date(this.year, o, 1), 1, this.isRangeEnd);
			this.renderCell(a, this.monthNames[o], o, s, {
				selected: e,
				range: i
			}, t || n && o < this.minMonth || r && o > this.maxMonth);
		});
	}
	refresh() {
		let e = this.selected[this.year] || [], t = Mt(this.range, this.year) || [];
		Array.from(this.grid.children).forEach((n, r) => {
			this.refreshCell(n, r, e, t);
		});
	}
	refreshFocus() {
		this.changeFocusedCell(this.focused);
	}
};
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/picker/views/YearsView.js
function Pt(e) {
	return [...e].reduce((e, t, n) => e += n ? t : t.toUpperCase(), "");
}
var Ft = class extends At {
	constructor(e, t) {
		super(e, t);
	}
	init(e, t = !0) {
		t && (this.navStep = this.step * 10, this.beforeShowOption = `beforeShow${Pt(this.cellClass)}`, this.grid = this.element, this.element.classList.add(this.name, "datepicker-grid"), this.grid.appendChild(Qe(Ce("span", 12)))), super.init(e);
	}
	setOptions(e) {
		if ("minDate" in e && (e.minDate === void 0 ? this.minYear = this.minDate = void 0 : (this.minYear = ze(e.minDate, this.step), this.minDate = De(this.minYear, 0, 1))), "maxDate" in e && (e.maxDate === void 0 ? this.maxYear = this.maxDate = void 0 : (this.maxYear = ze(e.maxDate, this.step), this.maxDate = De(this.maxYear, 11, 31))), e.checkDisabled && (this.checkDisabled = this.isMinView || e.datesDisabled === null ? e.checkDisabled : () => !1), this.beforeShowOption in e) {
			let t = e[this.beforeShowOption];
			this.beforeShow = typeof t == "function" ? t : void 0;
		}
	}
	updateFocus() {
		let e = new Date(this.picker.viewDate), t = ze(e, this.navStep), n = t + 9 * this.step;
		this.first = t, this.last = n, this.start = t - this.step, this.focused = ze(e, this.step);
	}
	updateSelection() {
		let { dates: e, rangepicker: t } = this.picker.datepicker;
		this.selected = e.reduce((e, t) => ye(e, ze(t, this.step)), []), t && t.dates && (this.range = t.dates.map((e) => {
			if (e !== void 0) return ze(e, this.step);
		}));
	}
	render() {
		this.prepareForRender(`${this.first}-${this.last}`, this.first <= this.minYear, this.last >= this.maxYear), Array.from(this.grid.children).forEach((e, t) => {
			let n = this.start + t * this.step, r = Be(new Date(n, 0, 1), 2, this.isRangeEnd);
			e.dataset.year = n, this.renderCell(e, n, n, r, this, n < this.minYear || n > this.maxYear);
		});
	}
	refresh() {
		let e = this.range || [];
		Array.from(this.grid.children).forEach((t) => {
			this.refreshCell(t, Number(t.textContent), this.selected, e);
		});
	}
	refreshFocus() {
		this.changeFocusedCell(Math.round((this.focused - this.start) / this.step));
	}
};
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/events/functions.js
function It(e, t) {
	let n = {
		bubbles: !0,
		cancelable: !0,
		detail: {
			date: e.getDate(),
			viewDate: new Date(e.picker.viewDate),
			viewId: e.picker.currentView.id,
			datepicker: e
		}
	};
	e.element.dispatchEvent(new CustomEvent(t, n));
}
function Lt(e, t) {
	let { config: n, picker: r } = e, { currentView: i, viewDate: a } = r, o;
	switch (i.id) {
		case 0:
			o = Ae(a, t);
			break;
		case 1:
			o = je(a, t);
			break;
		default: o = je(a, t * i.navStep);
	}
	o = Se(o, n.minDate, n.maxDate), r.changeFocus(o).render();
}
function Rt(e) {
	let t = e.picker.currentView.id;
	t !== e.config.maxView && e.picker.changeView(t + 1).render();
}
function zt(e) {
	e.setDate({ clear: !0 });
}
function Bt(e) {
	let t = Ee();
	e.config.todayButtonMode === 1 ? e.setDate(t, {
		forceRefresh: !0,
		viewDate: t
	}) : e.setFocusedDate(t, !0);
}
function Vt(e) {
	let t = () => {
		e.config.updateOnBlur ? e.update({ revert: !0 }) : e.refresh("input"), e.hide();
	}, n = e.element;
	et(n) ? n.addEventListener("blur", t, { once: !0 }) : t();
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/events/pickerListeners.js
function Ht(e, t) {
	let n = e.picker, r = new Date(n.viewDate), i = n.currentView.id, a = i === 1 ? Ae(r, t - r.getMonth()) : je(r, t - r.getFullYear());
	n.changeFocus(a).changeView(i - 1).render();
}
function Ut(e) {
	Rt(e);
}
function Wt(e) {
	Lt(e, -1);
}
function Gt(e) {
	Lt(e, 1);
}
function Kt(e, t) {
	let n = dt(t, ".datepicker-cell");
	if (!n || n.classList.contains("disabled")) return;
	let { id: r, isMinView: i } = e.picker.currentView, a = n.dataset;
	i ? e.setDate(Number(a.date)) : r === 1 ? Ht(e, Number(a.month)) : Ht(e, Number(a.year));
}
function qt(e) {
	e.preventDefault();
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/picker/Picker.js
var Jt = [
	"left",
	"top",
	"right",
	"bottom"
].reduce((e, t) => (e[t] = `datepicker-orient-${t}`, e), {}), Yt = (e) => e && `${e}px`;
function Xt(e, t) {
	if ("title" in t && (t.title ? (e.controls.title.textContent = t.title, nt(e.controls.title)) : (e.controls.title.textContent = "", tt(e.controls.title))), t.prevArrow) {
		let n = e.controls.prevButton;
		rt(n), t.prevArrow.forEach((e) => {
			n.appendChild(e.cloneNode(!0));
		});
	}
	if (t.nextArrow) {
		let n = e.controls.nextButton;
		rt(n), t.nextArrow.forEach((e) => {
			n.appendChild(e.cloneNode(!0));
		});
	}
	if (t.locale && (e.controls.todayButton.textContent = t.locale.today, e.controls.clearButton.textContent = t.locale.clear), "todayButton" in t && (t.todayButton ? nt(e.controls.todayButton) : tt(e.controls.todayButton)), "minDate" in t || "maxDate" in t) {
		let { minDate: t, maxDate: n } = e.datepicker.config;
		e.controls.todayButton.disabled = !xe(Ee(), t, n);
	}
	"clearButton" in t && (t.clearButton ? nt(e.controls.clearButton) : tt(e.controls.clearButton));
}
function Zt(e) {
	let { dates: t, config: n, rangeSideIndex: r } = e;
	return Se(t.length > 0 ? ve(t) : Be(n.defaultViewDate, n.pickLevel, r), n.minDate, n.maxDate);
}
function Qt(e, t) {
	!("_oldViewDate" in e) && t !== e.viewDate && (e._oldViewDate = e.viewDate), e.viewDate = t;
	let { id: n, year: r, first: i, last: a } = e.currentView, o = new Date(t).getFullYear();
	switch (n) {
		case 0: return t < i || t > a;
		case 1: return o !== r;
		default: return o < i || o > a;
	}
}
function $t(e) {
	return window.getComputedStyle(e).direction;
}
function en(e) {
	let t = $e(e);
	if (!(t === document.body || !t)) return window.getComputedStyle(t).overflow === "visible" ? en(t) : t;
}
var tn = class {
	constructor(e) {
		let { config: t, inputField: n } = this.datepicker = e, r = this.element = Qe(Dt.replace(/%buttonClass%/g, t.buttonClass)).firstChild, [i, a, o] = r.firstChild.children, s = i.firstElementChild, [c, l, u] = i.lastElementChild.children, [d, f] = o.firstChild.children, p = {
			title: s,
			prevButton: c,
			viewSwitch: l,
			nextButton: u,
			todayButton: d,
			clearButton: f
		};
		this.main = a, this.controls = p;
		let m = n ? "dropdown" : "inline";
		r.classList.add(`datepicker-${m}`), Xt(this, t), this.viewDate = Zt(e), ct(e, [
			[
				r,
				"mousedown",
				qt
			],
			[
				a,
				"click",
				Kt.bind(null, e)
			],
			[
				p.viewSwitch,
				"click",
				Ut.bind(null, e)
			],
			[
				p.prevButton,
				"click",
				Wt.bind(null, e)
			],
			[
				p.nextButton,
				"click",
				Gt.bind(null, e)
			],
			[
				p.todayButton,
				"click",
				Bt.bind(null, e)
			],
			[
				p.clearButton,
				"click",
				zt.bind(null, e)
			]
		]), this.views = [
			new jt(this),
			new Nt(this),
			new Ft(this, {
				id: 2,
				name: "years",
				cellClass: "year",
				step: 1
			}),
			new Ft(this, {
				id: 3,
				name: "decades",
				cellClass: "decade",
				step: 10
			})
		], this.currentView = this.views[t.startView], this.currentView.render(), this.main.appendChild(this.currentView.element), t.container ? t.container.appendChild(this.element) : n.after(this.element);
	}
	setOptions(e) {
		Xt(this, e), this.views.forEach((t) => {
			t.init(e, !1);
		}), this.currentView.render();
	}
	detach() {
		this.element.remove();
	}
	show() {
		if (this.active) return;
		let { datepicker: e, element: t } = this, n = e.inputField;
		if (n) {
			let r = $t(n);
			r === $t($e(t)) ? t.dir && t.removeAttribute("dir") : t.dir = r, this.place(), t.classList.add("active"), e.config.disableTouchKeyboard && n.blur();
		} else t.classList.add("active");
		this.active = !0, It(e, "show");
	}
	hide() {
		this.active && (this.datepicker.exitEditMode(), this.element.classList.remove("active"), this.active = !1, It(this.datepicker, "hide"));
	}
	place() {
		let { classList: e, style: t } = this.element;
		t.display = "block";
		let { width: n, height: r } = this.element.getBoundingClientRect(), i = this.element.offsetParent;
		t.display = "";
		let { config: a, inputField: o } = this.datepicker, { left: s, top: c, right: l, bottom: u, width: d, height: f } = o.getBoundingClientRect(), { x: p, y: m } = a.orientation, h = s, g = c;
		if (i === document.body || !i) h += window.scrollX, g += window.scrollY;
		else {
			let e = i.getBoundingClientRect();
			h -= e.left - i.scrollLeft, g -= e.top - i.scrollTop;
		}
		let _ = en(o), v = 0, y = 0, { clientWidth: b, clientHeight: x } = document.documentElement;
		if (_) {
			let e = _.getBoundingClientRect();
			e.top > 0 && (y = e.top), e.left > 0 && (v = e.left), e.right < b && (b = e.right), e.bottom < x && (x = e.bottom);
		}
		let S = 0;
		p === "auto" && (s < v ? (p = "left", S = v - s) : s + n > b ? (p = "right", b < l && (S = b - l)) : p = $t(o) === "rtl" ? l - n < v ? "left" : "right" : "left"), p === "right" && (h += d - n), h += S, m === "auto" && (m = c - r > y && u + r > x ? "top" : "bottom"), m === "top" ? g -= r : g += f, e.remove(...Object.values(Jt)), e.add(Jt[p], Jt[m]), t.left = Yt(h), t.top = Yt(g);
	}
	setViewSwitchLabel(e) {
		this.controls.viewSwitch.textContent = e;
	}
	setPrevButtonDisabled(e) {
		this.controls.prevButton.disabled = e;
	}
	setNextButtonDisabled(e) {
		this.controls.nextButton.disabled = e;
	}
	changeView(e) {
		let t = this.currentView;
		return e !== t.id && (this._oldView ||= t, this.currentView = this.views[e], this._renderMethod = "render"), this;
	}
	changeFocus(e) {
		return this._renderMethod = Qt(this, e) ? "render" : "refreshFocus", this.views.forEach((e) => {
			e.updateFocus();
		}), this;
	}
	update(e = void 0) {
		let t = e === void 0 ? Zt(this.datepicker) : e;
		return this._renderMethod = Qt(this, t) ? "render" : "refresh", this.views.forEach((e) => {
			e.updateFocus(), e.updateSelection();
		}), this;
	}
	render(e = !0) {
		let { currentView: t, datepicker: n, _oldView: r } = this, i = new Date(this._oldViewDate), a = e && this._renderMethod || "render";
		if (delete this._oldView, delete this._oldViewDate, delete this._renderMethod, t[a](), r && (this.main.replaceChild(t.element, r.element), It(n, "changeView")), !isNaN(i)) {
			let e = new Date(this.viewDate);
			e.getFullYear() !== i.getFullYear() && It(n, "changeYear"), e.getMonth() !== i.getMonth() && It(n, "changeMonth");
		}
	}
};
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/events/elementListeners.js
function nn(e, t, n, r, i, a) {
	if (xe(e, i, a)) return r(e) ? nn(t(e, n), t, n, r, i, a) : e;
}
function rn(e, t, n) {
	let r = e.picker, i = r.currentView, a = i.step || 1, o = r.viewDate, s;
	switch (i.id) {
		case 0:
			o = Oe(o, n ? t * 7 : t), s = Oe;
			break;
		case 1:
			o = Ae(o, n ? t * 4 : t), s = Ae;
			break;
		default: o = je(o, t * (n ? 4 : 1) * a), s = je;
	}
	o = nn(o, s, t < 0 ? -a : a, (e) => i.disabled.includes(e), i.minDate, i.maxDate), o !== void 0 && r.changeFocus(o).render();
}
function an(e, t) {
	let { config: n, picker: r, editMode: i } = e, a = r.active, { key: o, altKey: s, shiftKey: c } = t, l = t.ctrlKey || t.metaKey, u = () => {
		t.preventDefault(), t.stopPropagation();
	};
	if (o === "Tab") {
		Vt(e);
		return;
	}
	if (o === "Enter") {
		if (!a) e.update();
		else if (i) e.exitEditMode({
			update: !0,
			autohide: n.autohide
		});
		else {
			let t = r.currentView;
			t.isMinView ? e.setDate(r.viewDate) : (r.changeView(t.id - 1).render(), u());
		}
		return;
	}
	let d = n.shortcutKeys, f = {
		key: o,
		ctrlOrMetaKey: l,
		altKey: s,
		shiftKey: c
	}, p = Object.keys(d).find((e) => {
		let t = d[e];
		return !Object.keys(t).find((e) => t[e] !== f[e]);
	});
	if (p) {
		let t;
		if (p === "toggle" ? t = p : i ? p === "exitEditMode" && (t = p) : a ? p === "hide" ? t = p : p === "prevButton" ? t = [Lt, [e, -1]] : p === "nextButton" ? t = [Lt, [e, 1]] : p === "viewSwitch" ? t = [Rt, [e]] : n.clearButton && p === "clearButton" ? t = [zt, [e]] : n.todayButton && p === "todayButton" && (t = [Bt, [e]]) : p === "show" && (t = p), t) {
			Array.isArray(t) ? t[0].apply(null, t[1]) : e[t](), u();
			return;
		}
	}
	if (!a || i) return;
	let m = (n, r) => {
		c || l || s ? e.enterEditMode() : (rn(e, n, r), t.preventDefault());
	};
	o === "ArrowLeft" ? m(-1, !1) : o === "ArrowRight" ? m(1, !1) : o === "ArrowUp" ? m(-1, !0) : o === "ArrowDown" ? m(1, !0) : (o === "Backspace" || o === "Delete" || o && o.length === 1 && !l) && e.enterEditMode();
}
function on(e) {
	e.config.showOnFocus && !e._showing && e.show();
}
function sn(e, t) {
	let n = t.target;
	(e.picker.active || e.config.showOnClick) && (n._active = et(n), n._clicking = setTimeout(() => {
		delete n._active, delete n._clicking;
	}, 2e3));
}
function cn(e, t) {
	let n = t.target;
	n._clicking && (clearTimeout(n._clicking), delete n._clicking, n._active && e.enterEditMode(), delete n._active, e.config.showOnClick && e.show());
}
function ln(e, t) {
	t.clipboardData.types.includes("text/plain") && e.enterEditMode();
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/events/otherListeners.js
function un(e, t) {
	let { element: n, picker: r } = e;
	if (!r.active && !et(n)) return;
	let i = r.element;
	dt(t, (e) => e === n || e === i) || Vt(e);
}
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/Datepicker.js
function dn(e, t) {
	return e.map((e) => Xe(e, t.format, t.locale)).join(t.dateDelimiter);
}
function fn(e, t, n = !1) {
	if (t.length === 0) return n ? [] : void 0;
	let { config: r, dates: i, rangeSideIndex: a } = e, { pickLevel: o, maxNumberOfDates: s } = r, c = t.reduce((e, t) => {
		let n = Ye(t, r.format, r.locale);
		return n === void 0 ? e : (n = Be(n, o, a), xe(n, r.minDate, r.maxDate) && !e.includes(n) && !r.checkDisabled(n, o) && (o > 0 || !r.daysOfWeekDisabled.includes(new Date(n).getDay())) && e.push(n), e);
	}, []);
	if (c.length !== 0) return r.multidate && !n && (c = c.reduce((e, t) => (i.includes(t) || e.push(t), e), i.filter((e) => !c.includes(e)))), s && c.length > s ? c.slice(s * -1) : c;
}
function pn(e, t = 3, n = !0, r = void 0) {
	let { config: i, picker: a, inputField: o } = e;
	if (t & 2) {
		let e = a.active ? i.pickLevel : i.startView;
		a.update(r).changeView(e).render(n);
	}
	t & 1 && o && (o.value = dn(e.dates, i));
}
function mn(e, t, n) {
	let r = e.config, { clear: i, render: a, autohide: o, revert: s, forceRefresh: c, viewDate: l } = n;
	a === void 0 && (a = !0), a ? o === void 0 && (o = r.autohide) : o = c = !1, l = Ye(l, r.format, r.locale);
	let u = fn(e, t, i);
	!u && !s || (u && u.toString() !== e.dates.toString() ? (e.dates = u, pn(e, a ? 3 : 1, !0, l), It(e, "changeDate")) : pn(e, c ? 3 : 1, !0, l), o && e.hide());
}
function hn(e, t) {
	return t ? (n) => Xe(n, t, e.config.locale) : (e) => new Date(e);
}
var gn = class {
	constructor(e, t = {}, n = void 0) {
		e.datepicker = this, this.element = e, this.dates = [];
		let r = this.config = Object.assign({
			buttonClass: t.buttonClass && String(t.buttonClass) || "button",
			container: null,
			defaultViewDate: Ee(),
			maxDate: void 0,
			minDate: void 0
		}, Ct(pt, this)), i;
		if (e.tagName === "INPUT" ? (i = this.inputField = e, i.classList.add("datepicker-input"), t.container && (r.container = t.container instanceof HTMLElement ? t.container : document.querySelector(t.container))) : r.container = e, n) {
			let e = n.inputs.indexOf(i), t = n.datepickers;
			if (e < 0 || e > 1 || !Array.isArray(t)) throw Error("Invalid rangepicker object.");
			t[e] = this, this.rangepicker = n, this.rangeSideIndex = e;
		}
		this._options = t, Object.assign(r, Ct(t, this)), r.shortcutKeys = Tt(t.shortcutKeys || {});
		let a = be(e.value || e.dataset.date, r.dateDelimiter);
		delete e.dataset.date;
		let o = fn(this, a);
		o && o.length > 0 && (this.dates = o), i && (i.value = dn(this.dates, r));
		let s = this.picker = new tn(this), c = [
			e,
			"keydown",
			an.bind(null, this)
		];
		i ? ct(this, [
			c,
			[
				i,
				"focus",
				on.bind(null, this)
			],
			[
				i,
				"mousedown",
				sn.bind(null, this)
			],
			[
				i,
				"click",
				cn.bind(null, this)
			],
			[
				i,
				"paste",
				ln.bind(null, this)
			],
			[
				document,
				"mousedown",
				un.bind(null, this)
			],
			[
				window,
				"resize",
				s.place.bind(s)
			]
		]) : (ct(this, [c]), this.show());
	}
	static formatDate(e, t, n) {
		return Xe(e, t, n && ft[n] || ft.en);
	}
	static parseDate(e, t, n) {
		return Ye(e, t, n && ft[n] || ft.en);
	}
	static get locales() {
		return ft;
	}
	get active() {
		return !!(this.picker && this.picker.active);
	}
	get pickerElement() {
		return this.picker ? this.picker.element : void 0;
	}
	setOptions(e) {
		let t = Ct(e, this);
		Object.assign(this._options, e), Object.assign(this.config, t), this.picker.setOptions(t), pn(this, 3);
	}
	show() {
		if (this.inputField) {
			let { config: e, inputField: t } = this;
			if (t.disabled || t.readOnly && !e.enableOnReadonly) return;
			!et(t) && !e.disableTouchKeyboard && (this._showing = !0, t.focus(), delete this._showing);
		}
		this.picker.show();
	}
	hide() {
		this.inputField && (this.picker.hide(), this.picker.update().changeView(this.config.startView).render());
	}
	toggle() {
		this.picker.active ? this.inputField && this.picker.hide() : this.show();
	}
	destroy() {
		this.hide(), lt(this), this.picker.detach();
		let e = this.element;
		return e.classList.remove("datepicker-input"), delete e.datepicker, this;
	}
	getDate(e = void 0) {
		let t = hn(this, e);
		if (this.config.multidate) return this.dates.map(t);
		if (this.dates.length > 0) return t(this.dates[0]);
	}
	setDate(...e) {
		let t = [...e], n = {}, r = ve(e);
		r && typeof r == "object" && !Array.isArray(r) && !(r instanceof Date) && Object.assign(n, t.pop());
		let i = Array.isArray(t[0]) ? t[0] : t;
		mn(this, i, n);
	}
	update(e = void 0) {
		if (!this.inputField) return;
		let t = Object.assign(e || {}, {
			clear: !0,
			render: !0,
			viewDate: void 0
		}), n = be(this.inputField.value, this.config.dateDelimiter);
		mn(this, n, t);
	}
	getFocusedDate(e = void 0) {
		return hn(this, e)(this.picker.viewDate);
	}
	setFocusedDate(e, t = !1) {
		let { config: n, picker: r, active: i, rangeSideIndex: a } = this, o = n.pickLevel, s = Ye(e, n.format, n.locale);
		s !== void 0 && (r.changeFocus(Be(s, o, a)), i && t && r.changeView(o), r.render());
	}
	refresh(e = void 0, t = !1) {
		e && typeof e != "string" && (t = e, e = void 0);
		let n;
		n = e === "picker" ? 2 : e === "input" ? 1 : 3, pn(this, n, !t);
	}
	enterEditMode() {
		let e = this.inputField;
		!e || e.readOnly || !this.picker.active || this.editMode || (this.editMode = !0, e.classList.add("in-edit"));
	}
	exitEditMode(e = void 0) {
		if (!this.inputField || !this.editMode) return;
		let t = Object.assign({ update: !1 }, e);
		delete this.editMode, this.inputField.classList.remove("in-edit"), t.update && this.update(t);
	}
};
//#endregion
//#region node_modules/.pnpm/vanillajs-datepicker@1.3.4/node_modules/vanillajs-datepicker/js/DateRangePicker.js
function _n(e) {
	let t = Object.assign({}, e);
	return delete t.inputs, delete t.allowOneSidedRange, delete t.maxNumberOfDates, t;
}
function vn(e, t, n, r) {
	ct(e, [[
		n,
		"changeDate",
		t
	]]), new gn(n, r, e);
}
function yn(e, t) {
	if (e._updating) return;
	e._updating = !0;
	let n = t.target;
	if (n.datepicker === void 0) return;
	let r = e.datepickers, [i, a] = r, o = { render: !1 }, s = e.inputs.indexOf(n), c = s === 0 ? 1 : 0, l = r[s].dates[0], u = r[c].dates[0];
	l !== void 0 && u !== void 0 ? s === 0 && l > u ? (i.setDate(u, o), a.setDate(l, o)) : s === 1 && l < u && (i.setDate(l, o), a.setDate(u, o)) : e.allowOneSidedRange || (l !== void 0 || u !== void 0) && (o.clear = !0, r[c].setDate(r[s].dates, o)), r.forEach((e) => {
		e.picker.update().render();
	}), delete e._updating;
}
var bn = class {
	constructor(e, t = {}) {
		let n = Array.isArray(t.inputs) ? t.inputs : Array.from(e.querySelectorAll("input"));
		if (n.length < 2) return;
		e.rangepicker = this, this.element = e, this.inputs = n = n.slice(0, 2), Object.freeze(n), this.allowOneSidedRange = !!t.allowOneSidedRange;
		let r = yn.bind(null, this), i = _n(t), a = this.datepickers = [];
		n.forEach((e) => {
			vn(this, r, e, i);
		}), Object.freeze(a), Object.defineProperty(this, "dates", { get() {
			return a.map((e) => e.dates[0]);
		} }), a[0].dates.length > 0 ? yn(this, { target: n[0] }) : a[1].dates.length > 0 && yn(this, { target: n[1] });
	}
	setOptions(e) {
		this.allowOneSidedRange = !!e.allowOneSidedRange;
		let t = _n(e);
		this.datepickers.forEach((e) => {
			e.setOptions(t);
		});
	}
	destroy() {
		this.datepickers.forEach((e) => {
			e.destroy();
		}), lt(this), delete this.element.rangepicker;
	}
	getDates(e = void 0) {
		let t = e ? (t) => Xe(t, e, this.datepickers[0].config.locale) : (e) => new Date(e);
		return this.dates.map((e) => e === void 0 ? e : t(e));
	}
	setDates(e, t) {
		let { datepickers: [n, r], inputs: [i, a], dates: [o, s] } = this;
		this._updating = !0, n.setDate(e), r.setDate(t), delete this._updating, r.dates[0] === s ? n.dates[0] !== o && yn(this, { target: i }) : yn(this, { target: a });
	}
};
//#endregion
//#region src/components/forms/renderValidator.ts
function xn(e, t, n, r, i) {
	if (i) {
		let a = t.target.value;
		i(a) ? (r.innerHTML = "", r.classList.remove("is-danger"), n.classList.remove("is-danger"), n.classList.add("is-success")) : (r.innerHTML = e.error || "Invalid", n.classList.remove("is-success"), n.classList.add("is-danger"), r.classList.add("is-danger"));
	}
}
//#endregion
//#region src/components/forms/createMultiSelect.ts
function Sn(e) {
	let t = new Set(e.options.filter((e) => e.selected).map((e) => e.value)), n = document.createElement("div");
	n.style.cssText = "position: relative; width: 100%;";
	let r = document.createElement("div");
	r.style.cssText = "display: flex; align-items: center; flex-wrap: wrap; gap: 4px; min-height: 2.5em; padding: 4px 8px; border: 1px solid var(--chc-input-border, #7a7a7a); border-radius: 4px; background: var(--chc-input-bg, #fff); cursor: pointer; box-sizing: border-box";
	let i = document.createElement("div");
	i.style.cssText = "display: flex; flex-wrap: wrap; gap: 4px; flex: 1; min-width: 0;";
	let a = document.createElement("span");
	a.textContent = "▾", a.style.cssText = "margin-left: auto; padding-left: 8px; user-select: none; color: var(--chc-text-secondary, #666);", r.appendChild(i), r.appendChild(a);
	let o = document.createElement("div");
	o.style.cssText = [
		"display: none",
		"position: absolute",
		"top: 100%",
		"left: 0",
		"right: 0",
		"z-index: 50",
		"max-height: 220px",
		"overflow-y: auto",
		"border: 1px solid var(--chc-border-primary, #dbdbdb)",
		"border-top: none",
		"border-radius: 0 0 4px 4px",
		"background: var(--chc-dropdown-bg, #fff)",
		"box-shadow: 0 4px 8px rgba(0,0,0,0.1)"
	].join("; ");
	let s = /* @__PURE__ */ new Map();
	for (let t of e.options) {
		let e = document.createElement("label");
		e.style.cssText = [
			"display: flex",
			"align-items: center",
			"gap: 8px",
			"padding: 6px 10px",
			"cursor: pointer",
			"color: var(--chc-text-primary, #363636)"
		].join("; "), e.addEventListener("mouseenter", () => {
			e.style.background = "var(--chc-hover-bg, #f5f5f5)";
		}), e.addEventListener("mouseleave", () => {
			e.style.background = "";
		});
		let n = document.createElement("input");
		n.type = "checkbox", n.value = t.value, n.checked = !!t.selected, t.disabled && (n.disabled = !0), n.style.cssText = "margin: 0; cursor: pointer;";
		let r = document.createElement("span");
		r.textContent = t.label, e.appendChild(n), e.appendChild(r), o.appendChild(e), s.set(t.value, n);
	}
	n.appendChild(r), n.appendChild(o);
	let c = !1;
	function l() {
		c = !c, o.style.display = c ? "block" : "none";
	}
	function u() {
		c = !1, o.style.display = "none";
	}
	function d() {
		if (i.innerHTML = "", t.size === 0) {
			let e = document.createElement("span");
			e.textContent = "Select…", e.style.cssText = "color: var(--chc-text-muted, #999); user-select: none;", i.appendChild(e);
			return;
		}
		for (let n of t) {
			let r = e.options.find((e) => e.value === n);
			if (!r) continue;
			let a = document.createElement("span");
			a.style.cssText = [
				"display: inline-flex",
				"align-items: center",
				"gap: 4px",
				"padding: 2px 6px",
				"border-radius: 3px",
				"background: var(--chc-status-info, blue)",
				"color: var(--chc-text-inverse, #fff)",
				"font-size: 0.85em",
				"white-space: nowrap"
			].join("; "), a.textContent = r.label;
			let o = document.createElement("span");
			o.textContent = "×", o.style.cssText = "cursor: pointer; margin-left: 2px; font-weight: bold;", o.addEventListener("click", (e) => {
				e.stopPropagation(), t.delete(n);
				let r = s.get(n);
				r && (r.checked = !1), d(), f();
			}), a.appendChild(o), i.appendChild(a);
		}
	}
	function f() {
		if (z(e.onChange)) {
			let t = new Event("change", { bubbles: !0 });
			p.dispatchEvent(t), e.onChange(t, e);
		}
	}
	r.addEventListener("click", () => l()), document.addEventListener("click", (e) => {
		c && !n.contains(e.target) && u();
	});
	for (let [e, n] of s) n.addEventListener("change", () => {
		n.checked ? t.add(e) : t.delete(e), d(), f();
	});
	d();
	let p = n;
	return Object.defineProperty(p, "selectedValues", {
		get: () => [...t],
		enumerable: !0
	}), Object.defineProperty(p, "value", {
		get: () => [...t].join(","),
		enumerable: !0
	}), {
		container: n,
		element: p
	};
}
//#endregion
//#region src/data/componentConstants.ts
var Cn = "none";
//#endregion
//#region src/components/forms/renderField.ts
function wn(e, t) {
	for (let n of t.options) {
		if (n.hide) continue;
		let r = document.createElement("option");
		r.className = "font-medium", n.value && r.setAttribute("value", n.value), (n.selected || t.value === n.value) && r.setAttribute("selected", "true"), n.disabled && r.setAttribute("disabled", "true"), r.innerHTML = n.label, e.appendChild(r);
	}
}
function Tn(e) {
	let t = document.createElement("div");
	if (t.className = "field font-medium", e.class && t.classList.add(e.class), e.width ? t.style.cssText = `width: ${e.width}` : t.style.cssText = "flex-grow: 1", e.label && !e.checkbox) {
		let n = document.createElement("label");
		n.className = "label", e.labelStyle && (n.style.cssText = e.labelStyle), n.innerHTML = e.label, t.appendChild(n);
	}
	let n, r, i = [], a = document.createElement("div");
	if (a.className = "control font-medium", e.controlVisible === !1 && (a.style.display = Cn), e.controlId && (a.id = e.controlId), e.text) {
		let t = document.createElement("div");
		e.id && (t.id = e.id), t.className = "content", t.innerHTML = e.text, a.appendChild(t);
	} else if (e.radio) {
		let t = En(e, i);
		a.appendChild(t), n = t;
	} else if (e.options && e.multiple) {
		let { container: t, element: r } = Sn(e);
		e.id && (t.id = e.id), a.appendChild(t), n = r;
	} else if (e.options) n = Dn(e, a);
	else if (e.checkbox) n = On(e, a);
	else {
		let t = kn(e, a);
		n = t.inputElement, r = t.datepicker;
	}
	return t.appendChild(a), e.visible === !1 && (t.style.display = Cn), {
		field: t,
		inputElement: n,
		datepicker: r,
		subFields: i
	};
}
function En(e, t) {
	let n = document.createElement("div");
	n.id = e.id, n.className = "control";
	for (let r of e.options ?? []) {
		let i = document.createElement("label");
		i.className = "radio";
		let a = document.createElement("input");
		r.field && t.push({
			input: a,
			field: r.field
		}), r.id && (a.id = r.id), a.name = e.id, a.type = "radio", a.value = r.text, r.checked && (a.checked = !0), z(e.onChange) && a.addEventListener("change", (t) => e.onChange(t, e)), i.appendChild(a), n.appendChild(i);
		let o = document.createElement("span");
		o.style.marginLeft = ".25em", o.style.marginRight = "1em", o.style.color = "var(--chc-text-primary)", o.innerHTML = r.text, n.appendChild(o);
	}
	return n;
}
function Dn(e, t) {
	let n = document.createElement("div");
	n.className = "select font-medium", n.style.cssText = "width: 100%", e.zIndex && (n.style.zIndex = e.zIndex);
	let r = document.createElement("select");
	if (e.dataPlaceholder && r.setAttribute("data-placeholder", e.dataPlaceholder), e.dataType && r.setAttribute("data-type", e.dataType), e.disabled && (r.disabled = !0), e.id && (n.id = e.id), r.style.cssText = "width: 100%", wn(r, e), n.appendChild(r), t.appendChild(n), e.help) {
		let n = document.createElement("p");
		n.className = "help font-medium is-info", n.innerHTML = e.help?.text, n.style.display = e.help?.visible ? "" : Cn, t.appendChild(n);
	}
	return z(e.onChange) && r.addEventListener("change", (t) => e.onChange(t, e)), r;
}
function On(e, t) {
	let n = document.createElement("div");
	n.className = "flexrow nowrap", n.style.display = "inline-block";
	let r = document.createElement("input");
	z(e.onChange) && r.addEventListener("change", (t) => e.onChange(t, e)), r.className = `is-checkradio ${e.intent ?? "is-success"}`, r.type = "checkbox", r.id = e.id, e.checked && (r.checked = !0), n.appendChild(r);
	let i = document.createElement("label");
	return i.setAttribute("for", e.id), e.color && (i.style.color = e.color), i.innerHTML = e.label, n.appendChild(i), t.appendChild(n), r;
}
function kn(e, t) {
	let n, r = document.createElement("input");
	if (r.className = "input font-medium", e.class && r.classList.add(e.class), r.setAttribute("type", e.type || "text"), r.setAttribute("autocomplete", e.autocomplete || "off"), r.setAttribute("placeholder", e.placeholder || ""), e.disabled && r.setAttribute("disabled", "true"), e.id && r.setAttribute("id", e.id), t.appendChild(r), e.iconLeft) {
		t.classList.add("has-icons-left");
		let n = document.createElement("span");
		n.className = "icon is-small is-left font-medium";
		let r = document.createElement("i");
		r.className = e.iconLeft, n.appendChild(r), t.appendChild(n);
	}
	if (e.type === "password") {
		t.classList.add("has-icons-right");
		let n = document.createElement("span");
		n.className = "icon is-small is-right font-medium";
		let r = document.createElement("i");
		r.className = e.iconRight, n.appendChild(r), t.appendChild(n);
	}
	let i = document.createElement("p");
	if (i.className = "help font-medium", t.appendChild(i), e.validator && r.addEventListener("input", (t) => xn(e, t, r, i, e.validator)), e.date) {
		let t = e.maxNumberOfDates || 1, i = !e.maxNumberOfDates || t === 1;
		n = new gn(r, {
			maxDate: e.maxDate,
			minDate: e.minDate,
			format: "yyyy-mm-dd",
			language: e.language || "en",
			maxNumberOfDates: t,
			autohide: i
		});
	} else e.typeAhead && _e({
		...e.typeAhead,
		element: r
	});
	return z(e.onKeyDown) && r.addEventListener("keydown", (t) => e.onKeyDown(t, e)), z(e.onChange) && r.addEventListener("change", (t) => e.onChange(t, e)), z(e.onInput) && r.addEventListener("input", (t) => e.onInput(t, e)), z(e.onKeyUp) && r.addEventListener("keyup", (t) => e.onKeyUp(t, e)), e.value !== void 0 && (r.value = e.value), e.selectOnFocus && r.addEventListener("focus", () => r.select()), {
		inputElement: r,
		datepicker: n
	};
}
//#endregion
//#region src/components/renderStructure/renderParticipantInput.ts
var An = "__BYE__", jn = "__QUALIFIER__";
function Mn({ matchUp: e, side: t, sideNumber: n, eventHandlers: r, composition: i, position: a, currentParticipant: o }) {
	let s = i?.configuration, c = t?.drawPosition, l = () => {
		let e = L(s?.participantProvider) ? s.participantProvider() : [], t = s?.persistInputFields, n = e;
		t && o && (e.some((e) => e.participantId === o.participantId) || (n = [o, ...e]));
		let r = n.map((e) => ({
			label: e.participantName || e.participantId,
			value: e.participantId
		})), i = o?.participantId === An, a = o?.participantId === jn, c = [];
		return i || c.push({
			label: "— BYE —",
			value: An
		}), s?.hasQualifying && !a && c.push({
			label: "— QUALIFIER —",
			value: jn
		}), [...c, ...r];
	}, u = l(), d = (i) => {
		if (!t) return;
		if (!i || i.trim() === "") {
			L(r?.removeAssignment) && r.removeAssignment({
				matchUp: e,
				side: t,
				sideNumber: n || 1
			});
			return;
		}
		if (i === An) {
			L(r?.assignBye) && r.assignBye({
				matchUp: e,
				side: t,
				sideNumber: n || 1
			});
			return;
		}
		if (i === jn) {
			L(r?.assignQualifier) && r.assignQualifier({
				matchUp: e,
				side: t,
				sideNumber: n || 1
			});
			return;
		}
		let a = (L(s?.participantProvider) ? s.participantProvider() : []).find((e) => e.participantId === i);
		a && L(r?.assignParticipant) && r.assignParticipant({
			matchUp: e,
			side: t,
			sideNumber: n || 1,
			participant: a
		});
	}, f = !1, p = () => {
		if (f) {
			f = !1;
			return;
		}
		let e = Array.from(document.querySelectorAll(".participant-assignment-input input")), t = e.findIndex((e) => e.id === h);
		if (t !== -1 && t < e.length - 1) {
			let n = e[t + 1];
			setTimeout(() => {
				n.focus();
			}, 100);
		}
	}, m = a ? `-p${a}` : "", h = `assign-${e.matchUpId}-side${n}${m}`, g = o?.participantId, { field: _ } = Tn({
		typeAhead: {
			list: u,
			callback: d,
			onSelectComplete: p,
			listProvider: l,
			currentValue: g
		},
		placeholder: a ? `Partner ${a}` : "Type participant name...",
		field: h,
		id: h,
		class: "participant-assignment-input"
	});
	c && (_.dataset.drawPosition = c.toString());
	let v = _.querySelector("input");
	v && v.addEventListener("keydown", (e) => {
		e.key === "Tab" && (f = !0, setTimeout(() => {
			f = !1;
		}, 500));
	}), _.style.width = "100%", _.style.margin = "0";
	let y = s?.assignmentInputFontSize;
	return y && (_.style.fontSize = y), setTimeout(() => {
		let e = _.querySelector("input");
		if (e) {
			let t = e.parentElement, n = 0;
			for (; t && n < 15;) {
				let e = window.getComputedStyle(t);
				(e.overflow !== "visible" || e.overflowX !== "visible" || e.overflowY !== "visible") && (t.style.setProperty("overflow", "visible", "important"), t.style.setProperty("overflow-x", "visible", "important"), t.style.setProperty("overflow-y", "visible", "important")), t = t.parentElement, n++;
			}
		}
	}, 100), _;
}
//#endregion
//#region src/styles/seedStyle.ts
var Nn = () => "chc-seed";
//#endregion
//#region src/components/renderStructure/renderSeeding.ts
function Pn({ className: e, composition: t, side: n }) {
	let r = n?.seedValue === "~" ? "" : n?.seedValue !== void 0 && n.seedValue || n?.seedNumber;
	if (!r) return "";
	let i = t?.configuration || {}, { bracketedSeeds: a } = i, o = typeof a == "boolean" && ["(", ")"] || a === "square" && ["[", "]"] || ["", ""], s = `${o[0]}${r}${o[1]}`, c = i.seedingElement === "sup" ? "sup" : "span", l = document.createElement(c);
	return l.className = e || "", l.innerHTML = s, l;
}
//#endregion
//#region src/styles/scaleStyle.ts
var Fn = (e) => (0, D.default)("chc-scale", e?.color && `chc-scale--${e.color}`);
//#endregion
//#region src/components/renderStructure/renderScale.ts
function In({ individualParticipant: e, composition: t, className: n, matchUp: r, spacer: i }) {
	let a = t?.configuration, o = a?.scaleAttributes?.eventType || r?.matchUpType || "SINGLES", s = e?.rankings, c = e?.ratings, l = a?.scaleAttributes, u = l?.scaleType, d = l?.scaleName, f = l?.accessor, p = u === "RATING" ? c : s, m = p?.SINGLES?.find((e) => e?.scaleName === d)?.scaleValue, h = p?.DOUBLES?.find((e) => e?.scaleName === d)?.scaleValue, g = m && f ? m[f] : m || "", _ = h && f ? h[f] : h || "", v = o === "SINGLES" ? g : _, y = a?.scaleAttributes?.fallback, b = !i && (v || y && (g || _)), x = document.createElement("span"), S = a?.scaleAttributes?.scaleColor, C = S === "green" || S === "red" ? S : void 0;
	return b && (x.className = (0, D.default)(n, Fn(C ? { color: C } : {}))), x.innerHTML = b || "", x;
}
//#endregion
//#region src/styles/flagStyle.ts
var Ln = (e) => (0, D.default)("chc-flag", e?.variant && `chc-flag--${e.variant}`);
//#endregion
//#region src/components/renderStructure/renderFlag.ts
function Rn({ matchUp: e, individualParticipant: t, spacer: n }) {
	let r = t?.person?.iso2NationalityCode || "", i = r ? o.countryToFlag(r)?.slice(0, 4) : "", a = document.createElement("span"), s = e?.matchUpType?.toLowerCase();
	return n || (a.className = Ln({ variant: s })), a.innerHTML = n ? "" : i, a;
}
//#endregion
//#region src/components/renderStructure/renderFrill.ts
function zn({ individualParticipant: e, composition: t, className: n, matchUp: r, spacer: i, side: a, type: o }) {
	if (o === "scale") return In({
		individualParticipant: e,
		composition: t,
		className: n,
		matchUp: r,
		spacer: i
	});
	let s = t?.configuration || {}, c = document.createElement("div");
	if (o === "flag" && s.flags) return Rn({
		matchUp: r,
		individualParticipant: e,
		spacer: i
	});
	if (o === "seeding") {
		let e = Pn({
			className: n,
			composition: t,
			side: a
		});
		return typeof e == "string" ? c : e;
	}
	return c;
}
//#endregion
//#region src/components/renderStructure/renderIndividual.ts
var { FEED_IN: Bn } = t, { MALE: Vn, FEMALE: Hn } = s, { LUCKY_LOSER: Un } = n, Wn = "Qualifier", Gn = "BYE", Kn = "TBD";
function qn(e, t, n, r, i, a) {
	let o;
	return o = e?.bye ? {
		participantId: "__BYE__",
		participantName: "— BYE —"
	} : e?.qualifier ? {
		participantId: "__QUALIFIER__",
		participantName: "— QUALIFIER —"
	} : t, Mn({
		matchUp: n,
		side: e,
		sideNumber: r,
		eventHandlers: i,
		composition: a,
		currentParticipant: o
	});
}
function Jn(e, t, n, r, i, a) {
	let o = document.createElement("span");
	if (n && r?.winnerColor) o.style.color = typeof r.winnerColor == "string" ? r.winnerColor : "green";
	else if (r?.genderColor) {
		let e = i?.person?.sex, t = e === Vn && "var(--chc-gender-male, #2E86C1)" || e === Hn && "var(--chc-gender-female, #E07BAF)" || "";
		o.style.color = typeof r.genderColor == "string" ? r.genderColor : t;
	}
	if (o.innerHTML = t, e.appendChild(o), a?.participant?.luckyAdvancement) {
		let t = document.createElement("span");
		t.className = "chc-lucky-advancement-badge", t.textContent = "LL", e.appendChild(t);
	} else if (a?.participant?.entryStatus === Un) {
		let t = document.createElement("span");
		t.className = "chc-lucky-loser-badge", t.textContent = "LL", e.appendChild(t);
	}
}
function Yn(e) {
	let { isWinningSide: t, side: n, sideNumber: r, individualParticipant: i, matchUp: a, composition: o } = e || {}, s = t ? "winner" : void 0, c = e.eventHandlers || {}, l = o?.configuration, u = {
		QUALIFIER: l?.placeHolders?.qualifier || Wn,
		BYE: l?.placeHolders?.bye || Gn,
		TBD: l?.placeHolders?.tbd || Kn
	}, d = !l?.useParticipantName && i?.participantOtherName || i?.participantName, f = (e) => {
		L(c?.participantClick) && (e.stopPropagation(), c.participantClick({
			individualParticipant: i,
			pointerEvent: e,
			matchUp: a,
			side: n
		}));
	}, p = document.createElement("div");
	p.classList.add("tmx-i"), p.setAttribute("sideNumber", String(r)), p.setAttribute("id", i?.participantId), p.onclick = f;
	let m = document.createElement("div");
	m.className = k({ variant: s });
	let h = l?.flags, g = l?.scaleAttributes, _ = h ? "left" : l?.scaleAttributes?.scalePosition || "left", v = h && zn({
		...e,
		type: "flag"
	});
	if (v) m.appendChild(v);
	else if (_ === "left") {
		let t = zn({
			type: "scale",
			...e
		});
		t && m.appendChild(t);
	}
	let y = document.createElement("div");
	y.className = A({ variant: s });
	let b = a?.roundNumber === 1, x = a?.drawType === Bn && a?.roundNumber > 1 && n?.drawPosition && !n?.sourceMatchUp, S = b || x, C = l?.persistInputFields;
	if (l?.inlineAssignment && L(c?.assignParticipant) && L(l?.participantProvider) && S && (!n?.bye || C) && (!n?.qualifier || C) && a && (!d || n?.bye || n?.qualifier || C)) y.appendChild(qn(n, i, a, r, c, o));
	else if (d) Jn(y, d, t, l, i, n);
	else {
		let e = document.createElement("abbr");
		e.className = O({ variant: l?.showAddress ? "showAddress" : "" }), e.innerHTML = n?.bye && u.BYE || n?.qualifier && u.QUALIFIER || u.TBD, y.appendChild(e);
	}
	if (g && (v || _ === "right")) {
		let t = zn({
			type: "scale",
			...e
		});
		t && (t.style.marginInlineStart = "0.5em", t.style.marginInlineEnd = "0", y.appendChild(t));
	}
	let w = zn({
		...e,
		className: Nn(),
		type: "seeding"
	});
	w && y.appendChild(w), m.appendChild(y), p.appendChild(m);
	let T = me(e);
	return p.appendChild(T), { element: p };
}
//#endregion
//#region src/styles/pillStyle.ts
var Xn = (e) => (0, D.default)("chc-pill", e?.variant && `chc-pill--${e.variant}`), { WALKOVER: Zn, DEFAULTED: Qn, DOUBLE_WALKOVER: $n, DOUBLE_DEFAULT: er, ABANDONED: tr, IN_PROGRESS: nr } = u;
function rr({ matchUpStatus: e }) {
	let t = e?.toLowerCase(), n = [
		"defaulted",
		"retired",
		"walkover",
		"defaulted",
		"double_walkover",
		"double_default",
		"cancelled",
		"in_progress",
		"awaiting_result",
		"dead_rubber",
		"incomplete",
		"suspended",
		"abandoned"
	].includes(t) ? t : void 0, r = [Zn, $n].includes(e || "") ? "WO" : [Qn, er].includes(e || "") ? "DEF" : e === tr ? "ABD" : e === nr ? "LIVE" : e?.split("_").join("").slice(0, 3) || "", i = document.createElement("div");
	i.className = Xn(n ? { variant: n } : {});
	let a = document.createElement("abbr");
	return a.setAttribute("title", e || ""), a.style.textDecoration = "none", a.style.borderBottom = "none", a.innerHTML = r, i.appendChild(a), i;
}
//#endregion
//#region src/utilities/isElement.ts
function ir(e) {
	return e instanceof Element || e;
}
//#endregion
//#region src/styles/teamLogoStyle.ts
var ar = () => "chc-team-logo", or = [
	{
		name: "Altitude",
		src: "data:image/png;base64,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"
	},
	{
		name: "Fortune",
		src: "data:image/png;base64,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"
	},
	{
		name: "Inferno",
		src: "data:image/png;base64,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"
	},
	{
		name: "Outriders",
		src: "data:image/png;base64,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"
	},
	{
		name: "Ridge",
		src: "data:image/png;base64,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"
	},
	{
		name: "Rips",
		src: "data:image/png;base64,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"
	},
	{
		name: "Rise",
		src: "data:image/png;base64,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"
	},
	{
		name: "Smash",
		src: "data:image/png;base64,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"
	}
];
function sr(e) {
	return or[(e % or.length + or.length) % or.length];
}
function cr(e) {
	let t = 0;
	for (let n = 0; n < e.length; n++) t = (t << 5) - t + e.charCodeAt(n) | 0;
	return Math.abs(t);
}
//#endregion
//#region src/components/renderStructure/renderTeamLogo.ts
function lr({ participantId: e }) {
	let t = document.createElement("div");
	t.className = ar();
	let n = sr(e ? cr(e) : Math.floor(Math.random() * 8)), r = document.createElement("img");
	return r.src = n.src, r.alt = n.name, r.style.cssText = "height: 100%; width: auto; object-fit: contain;", t.appendChild(r), t;
}
//#endregion
//#region src/styles/sideStyles.ts
var ur = () => "chc-side-container", dr = () => "chc-side-row", fr = () => "chc-tick";
//#endregion
//#region src/components/renderStructure/renderTick.ts
function pr({ dim: e = "20px" } = {}) {
	return `
    <div style="line-height: 0;">
      <svg height="${e}" viewBox="0 0 18 24" width="${e}" xmlns="http://www.w3.org/2000/svg" class="${fr()}" style="fill: currentcolor;">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
      </svg>
    </div>
  `;
}
//#endregion
//#region src/components/renderStructure/renderParticipant.ts
var { WALKOVER: mr, DEFAULTED: hr, DOUBLE_WALKOVER: gr, DOUBLE_DEFAULT: _r, RETIRED: vr, SUSPENDED: yr, CANCELLED: br, IN_PROGRESS: xr, ABANDONED: Sr } = u;
function Cr({ configuration: e, matchUp: t, eventHandlers: n, sideNumber: r, winningSide: i, matchUpStatus: a, isWinningSide: o, gameScoreOnly: s, irregularEnding: c }) {
	let l = document.createElement("div"), u = e?.inlineScoring, d = t?.readyToScore;
	if (u && d && !(i || a === "COMPLETED") && (!a || a === "IN_PROGRESS" || a === "TO_BE_PLAYED")) {
		let e = rr({ matchUpStatus: xr });
		e.classList.add("chc-live-chip"), e.addEventListener("click", (e) => {
			e.stopPropagation(), n?.pillClick?.({
				pointerEvent: e,
				matchUp: t,
				sideNumber: r
			});
		}), l.appendChild(e);
	} else if (o && !s) {
		let e = pr();
		typeof e == "string" ? l.innerHTML = e : l.appendChild(e);
	} else if (c) {
		let e = rr({ matchUpStatus: a });
		u && (e.classList.add("chc-live-chip"), e.addEventListener("click", (e) => {
			e.stopPropagation(), n?.pillClick?.({
				pointerEvent: e,
				matchUp: t,
				sideNumber: r
			});
		})), l.appendChild(e);
	}
	return l;
}
function wr({ initialRoundNumber: e = 1, eventHandlers: t, sideContainer: n, composition: r, participant: i, placeholder: a, sideNumber: o, matchUp: s }) {
	let { winningSide: c, matchUpType: l, isRoundRobin: u, matchUpStatus: d } = s || {}, f = r?.configuration, p, m = o ? s?.sides?.find((e) => e.sideNumber === o) : void 0;
	i || (i = m?.participant, p = f?.allDrawPositions || f?.drawPositions && m?.drawPosition && (s?.roundNumber === e || m?.participantFed || u) ? m?.drawPosition : "");
	let h = l === "DOUBLES", g = h ? i?.individualParticipants?.[0] : i, _ = h && i?.individualParticipants?.[1], v = !!(c && o === c || d === "BYE" && i), y = f?.winnerChevron && v, b = f?.teamLogo, x = [
		vr,
		mr,
		hr,
		gr,
		_r,
		yr,
		br,
		xr,
		Sr
	].includes(d) && !v, S = f?.gameScoreOnly, C = document.createElement("div");
	if (n && (C.className = M({
		drawPosition: p,
		sideNumber: o
	}), p && (C.dataset.drawPosition = String(p), f?.drawPositionColor && C.style.setProperty("--chc-draw-position-color", f.drawPositionColor))), C.classList.add("tmx-p"), C.setAttribute("id", i?.participantId || ""), b) {
		let e = lr({
			teamLogo: b,
			participantId: i?.participantId
		});
		C.appendChild(e);
	}
	let w = document.createElement("div");
	w.className = j(h ? { variant: "doubles" } : {});
	let T = document.createElement("div");
	T.className = N({
		winnerChevron: y,
		isDoubles: h
	});
	let E = Yn({
		individualParticipant: g,
		eventHandlers: t,
		isWinningSide: v,
		composition: r,
		sideNumber: o,
		matchUp: s,
		side: m
	}).element;
	if (T.appendChild(E), _) {
		let e = Yn({
			individualParticipant: _,
			eventHandlers: t,
			isWinningSide: v,
			composition: r,
			sideNumber: o,
			matchUp: s,
			side: m
		}).element;
		T.appendChild(e);
	} else h && a && ir(a) && T.appendChild(a);
	return w.appendChild(T), C.appendChild(w), n && C.appendChild(Cr({
		configuration: f,
		matchUp: s,
		eventHandlers: t,
		sideNumber: o,
		winningSide: c,
		matchUpStatus: d,
		isWinningSide: v,
		gameScoreOnly: S,
		irregularEnding: x
	})), C;
}
//#endregion
//#region src/styles/roundHeaderStyle.ts
var Tr = () => "chc-round-header";
//#endregion
//#region src/components/renderStructure/renderRoundHeader.ts
function Er({ eventHandlers: e, roundMatchUps: t, roundProfile: n, roundNumber: r, context: i }) {
	let a = document.createElement("div");
	a.className = Tr(), a.classList.add("tmx-rh"), a.setAttribute("roundNumber", String(r));
	let o = L(e?.roundVisibilityClick), s = L(e?.roundHeaderClick);
	s && (a.onclick = (a) => e.roundHeaderClick({
		roundNumber: r,
		roundProfile: n,
		roundMatchUps: t,
		context: i,
		pointerEvent: a
	}));
	let c = n?.[r]?.roundName;
	if (!c) return a;
	let l = document.createElement("div");
	l.style.cssText = "display:flex; flex-direction:row; justify-content:space-between;";
	let u = document.createElement("div");
	u.textContent = c, l.appendChild(u);
	let d = document.createElement("div");
	if (d.style.cssText = "display:flex; align-items:center; gap:4px;", o) {
		let a = i?.roundVisibilityState?.[r], o = a?.hidden === !0, s = a?.embargoed === !0, c = o ? "fa-eye-slash" : s ? "fa-clock" : "fa-eye", l = o ? "#e74c3c" : s ? "#f39c12" : "inherit", u = o || s ? "0.85" : "0.7", f = document.createElement("i");
		f.className = `fa-solid ${c} tmx-rh-vis`, f.style.cssText = `cursor:pointer; font-size:0.85rem; color:${l}; opacity:${u}; transition:opacity 0.15s;`, f.onmouseenter = () => f.style.opacity = "1", f.onmouseleave = () => f.style.opacity = u, f.onclick = (a) => {
			a.stopPropagation(), e.roundVisibilityClick({
				roundNumber: r,
				roundProfile: n,
				roundMatchUps: t,
				context: i,
				pointerEvent: a
			});
		}, d.appendChild(f);
	}
	if (s) {
		let e = document.createElement("span");
		e.style.cssText = "font-weight:bold; cursor:pointer;", e.textContent = "⋮", d.appendChild(e);
	}
	return l.appendChild(d), a.appendChild(l), a;
}
//#endregion
//#region src/styles/roundContainerStyle.ts
var Dr = () => "chc-round-container", Or = () => "chc-structure", kr = (e) => (0, D.default)("chc-round", e?.variant === "adHoc" && "chc-round--adhoc");
//#endregion
//#region src/components/renderStructure/isLuckyDraw.ts
function Ar({ roundsNotPowerOf2: e, hasNoRoundPositions: t, roundNumbers: n, roundProfile: r }) {
	return t ? !0 : e ? !(n && n.length > 1 && r && n.every((e, t) => {
		if (t === 0) return !0;
		let i = r[n[t - 1]]?.matchUpsCount, a = r[e]?.matchUpsCount;
		return i && a && (a === i / 2 || a === i);
	})) : !1;
}
//#endregion
//#region src/styles/groupSeparatorStyle.ts
var jr = (e) => (0, D.default)("chc-group-separator", e?.variant === 0 && "chc-group-separator--0", e?.roundOrder === "first" && "chc-group-separator--round-first", e?.roundOrder === "last" && "chc-group-separator--round-last"), Mr = () => "chc-group-name";
//#endregion
//#region src/styles/getSelectedMatchUpStyle.ts
function Nr() {
	return "chc-selected-matchup";
}
//#endregion
//#region src/styles/matchUpContainerStyle.ts
var Pr = () => "chc-matchup-container";
//#endregion
//#region src/styles/getMatchUpStyle.ts
function Fr({ configuration: e }) {
	return e?.matchUpHover ? "chc-matchup chc-matchup--custom-hover" : "chc-matchup";
}
//#endregion
//#region src/styles/centerInfoStyle.ts
function Ir({ variant: e }) {
	return (0, D.default)("chc-center-info", e != null && `chc-center-info--${e}`);
}
var Lr = () => "chc-column", Rr = () => "chc-entry", zr = () => "chc-status";
//#endregion
//#region src/components/renderStructure/renderCenterInfo.ts
function Br({ eventHandlers: e, entryStatus: t, sideNumber: n, className: r, matchUp: i }) {
	let a = document.createElement("div");
	L(e?.centerInfoClick) && (a.onclick = (t) => e.centerInfoClick({
		matchUp: i,
		sideNumber: n,
		pointerEvent: t
	})), a.className = (0, D.default)(Ir({ variant: n }), r), a.classList.add("tmx-ci"), a.setAttribute("sideNumber", String(n));
	let o = document.createElement("div");
	o.className = Lr();
	let s = document.createElement("div");
	s.className = Rr();
	let c = document.createElement("div");
	c.className = zr(), c.innerHTML = t ? "Entry status:&nbsp;" : "", s.appendChild(c);
	let l = document.createElement("div");
	return l.className = zr(), l.innerHTML = t || "", s.appendChild(l), o.appendChild(s), a.appendChild(o), { element: a };
}
//#endregion
//#region src/compositions/lineHeights.ts
var Vr = {
	scheduleInfo: 1.8,
	centerInfo: 1.5,
	gameScore: 2
};
//#endregion
//#region src/styles/getLinkStyle.ts
function Hr({ composition: e, isDoubles: t, roundFactor: n = 1 }) {
	let r = parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size")), i = e?.configuration || {}, a = i?.connectorWidth || 16, o = i.centerInfo ? Vr.centerInfo * r : 0, s = i.scheduleInfo ? Vr.scheduleInfo * r : 0, c = (60 + (i.showAddress ? r : 0)) * (t ? 1.3 : 1) + o, l = c * n, u = (c + s) * n;
	return (e) => {
		let t = (0, D.default)("chc-link", e.isFirstRound && "chc-link--first-round", e.link === "mr" && "chc-link--no-link", e.link === "m1" && "chc-link--m1", e.link === "m2" && "chc-link--m2", e.link === "m0" && "chc-link--m0", e.link === "noProgression" && "chc-link--no-progression");
		return {
			className: t,
			applyStyles(e) {
				e.style.setProperty("--chc-connector-w", `${a}px`), e.style.setProperty("--chc-link-m1-h", `${l}px`), e.style.setProperty("--chc-link-m2-h", `${u}px`);
			},
			toString() {
				return t;
			}
		};
	};
}
//#endregion
//#region src/styles/scoreWrapperStyle.ts
var Ur = (e) => (e) => (0, D.default)("chc-score-wrapper", (e?.sideNumber === 1 || String(e?.sideNumber) === "1") && "chc-score-wrapper--side1", e?.fontSize === "small" && "chc-score-wrapper--small"), Wr = () => "chc-tiebreak", Gr = (e) => (0, D.default)("chc-game-score", e?.variant && `chc-game-score--${e.variant}`), Kr = () => "chc-game-wrapper", qr = (e) => (0, D.default)("chc-point-score", e?.inverted && "chc-point-score--inverted", e?.position === "leading" && "chc-point-score--leading", e?.position === "trailing" && "chc-point-score--trailing"), Jr = (e) => (0, D.default)("chc-results-item", e?.variant && `chc-results-item--${e.variant}`);
//#endregion
//#region src/components/renderStructure/renderGameScore.ts
function Yr({ value: e } = {}) {
	let t = document.createElement("input");
	return t.onclick = (e) => e.target.select(), t.className = Gr(), t.value = String(e || ""), t;
}
//#endregion
//#region src/components/renderStructure/renderSideScore.ts
function Xr({ gameScoreOnly: e, scoreStripes: t, set: n, sideNumber: r }) {
	let i = r === n?.winningSide || n?.winningSide ? "loser" : void 0, a = r === 2 ? n.side2Score : n.side1Score, o = n.side2TiebreakScore || n.side1TiebreakScore, s = r === 2 ? n.side2TiebreakScore : n.side1TiebreakScore, c = a === void 0 && s, l = c || a, u = t && n.setNumber % 2 ? "var(--chc-bg-secondary)" : "transparent", d = n.editing ? n.editing === r : void 0, f;
	if (d) f = Yr({ value: l });
	else if (f = document.createElement("p"), f.className = Gr({ variant: i }), f.classList.add("tmx-st"), f.setAttribute("setNumber", n.setNumber), f.style.backgroundColor = u, f.innerHTML = l != null && !Number.isNaN(Number(l)) ? l : "", !e) {
		let e = document.createElement("span");
		e.className = Wr(), e.innerHTML = o && !c ? String(s) : "", f.appendChild(e);
	}
	return f;
}
function Zr(e, t, n, r, i, a) {
	if (e.length === 0) return;
	let o = e.at(-1);
	if (!(o.side1PointScore != null || o.side2PointScore != null)) return;
	let s = t === 2 ? o.side2PointScore : o.side1PointScore, c = n?.position || "trailing", l = n?.inverted !== !1, u = document.createElement("p");
	return u.className = qr({
		inverted: l,
		position: c
	}), u.textContent = s == null ? "" : String(s), r?.configuration?.inlineScoring && !o.winningSide && (u.classList.add("chc-inline-scoring-clickable"), u.style.cursor = "pointer", u.addEventListener("click", (e) => {
		e.stopPropagation(), e.preventDefault(), i?.scoreIncrement?.({
			matchUpId: a.matchUpId,
			sideNumber: t,
			scoreType: "point"
		});
	})), u;
}
function Qr(e, t, n, r, i) {
	e.classList.add("chc-inline-scoring-clickable"), e.style.cursor = "pointer", e.addEventListener("click", (e) => {
		e.stopPropagation(), e.preventDefault();
		let a = t.mode === "games" ? "game" : "point";
		n?.scoreIncrement?.({
			matchUpId: r.matchUpId,
			sideNumber: i,
			scoreType: a
		});
	});
}
function $r({ participantHeight: e, eventHandlers: t, composition: n, sideNumber: r, matchUp: i }) {
	let a = n?.configuration?.winnerChevron, o = n?.configuration?.gameScoreOnly, s = n?.configuration?.gameScore, c = i?.score?.sets || [], l = n?.configuration?.scoreBox, u = e ? r === 2 ? e : e - 1 : void 0, d = (e) => {
		L(t?.scoreClick) && (e.stopPropagation(), t.scoreClick({
			pointerEvent: e,
			matchUp: i
		}));
	}, f = document.createElement("div");
	f.className = Ur()({
		...!l && r === 1 && { sideNumber: 1 },
		fontSize: "small"
	}), u && (f.style.height = `${u}px`), f.classList.add("sideScore"), f.classList.add("tmx-scr"), f.onclick = d;
	let p = document.createElement("div");
	p.className = Kr();
	let m = Zr(c, r, s, n, t, i), h = n?.configuration?.resultsInfo && r === 1;
	h && (p.style.alignSelf = "stretch");
	let g = (e, t, n) => {
		let r = document.createElement("div");
		r.style.cssText = "position:relative; align-self:stretch; display:flex; align-items:center;", r.appendChild(e);
		let i = document.createElement("div");
		return i.className = Jr({ variant: n }), i.textContent = t, r.appendChild(i), r;
	}, _ = s?.position || "trailing";
	m && _ === "leading" && p.appendChild(h ? g(m, "PTS", "points") : m);
	let v = n?.configuration?.inlineScoring;
	for (let e of c || []) {
		let n = Xr({
			gameScoreOnly: o,
			scoreStripes: a,
			sideNumber: r,
			set: e
		});
		v && !e.winningSide && Qr(n, v, t, i, r), p.appendChild(h ? g(n, String(e.setNumber), "set") : n);
	}
	return m && _ !== "leading" && p.appendChild(h ? g(m, "PTS", "points") : m), f.appendChild(p), f;
}
//#endregion
//#region src/styles/schedulingStyle.ts
var ei = () => "chc-scheduling", ti = /* @__PURE__ */ E((/* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var x = "$isDayjsObject", S = function(e) {
			return e instanceof E || !(!e || !e[x]);
		}, C = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, w = function(e, t) {
			if (S(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new E(n);
		}, T = v;
		T.l = C, T.i = S, T.w = function(e, t) {
			return w(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var E = function() {
			function g(e) {
				this.$L = C(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (T.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return T;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = w(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return w(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < w(e);
			}, _.$g = function(e, t, n) {
				return T.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!T.u(t) || t, u = T.p(e), p = function(e, t) {
					var i = T.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return T.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = T.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[T.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = T.p(u), h = function(e) {
					var t = w(p);
					return T.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return T.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = T.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return T.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return T.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return T.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return T.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return T.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return T.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return T.s(t.$s, 2, "0");
							case "SSS": return T.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = T.p(f), _ = w(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return T.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : T.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = C(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return T.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), D = E.prototype;
		return w.prototype = D, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			D[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), w.extend = function(e, t) {
			return e.$i ||= (e(t, E, w), !0), w;
		}, w.locale = C, w.isDayjs = S, w.unix = function(e) {
			return w(1e3 * e);
		}, w.en = b[y], w.Ls = b, w.p = {}, w;
	}));
})))());
function ni({ matchUp: e, eventHandlers: t }) {
	let { scheduledTime: n, scheduledDate: r, venueAbbreviation: i, courtName: a } = e?.schedule || {}, { dateTime: { extractDate: o, extractTime: s } } = h, c = s(n), l = o(r), u = "ddd D MMMM";
	c && (u += ", hh:mm A", l += `T${c}`);
	let d = r ? (0, ti.default)(l).format(u) : "Not scheduled", f = i && a?.toString().startsWith(i) && a || i && a && `${i} ${a}` || a || i || "", p = document.createElement("div");
	p.className = ei(), p.classList.add("tmx-sch"), L(t?.scheduleClick) && (p.onclick = (n) => t.scheduleClick({
		matchUp: e,
		pointerEvent: n
	}));
	let m = document.createElement("div");
	m.innerHTML = d, p.append(m);
	let g = (n) => {
		L(t?.venueClick) && (n.stopPropagation(), t.venueClick({
			pointerEvent: n,
			matchUp: e
		}));
	}, _ = document.createElement("div");
	_.style = "display: flex; flex-direction: row";
	let v = document.createElement("div");
	if (v.style.paddingRight = ".2rem", v.onclick = g, v.innerHTML = f, _.append(v), p.append(_), p.onclick) {
		let e = document.createElement("div");
		e.innerHTML = "⋮", _.append(e);
	}
	return p;
}
//#endregion
//#region src/components/renderStructure/renderSide.ts
var { completedMatchUpStatuses: ri } = a;
function ii({ initialRoundNumber: e = 1, eventHandlers: t, composition: n, sideNumber: r, className: i, matchUp: a }) {
	let o = n?.configuration || {}, s = o?.scheduleInfo, c = a?.score?.scoreStringSide1 || a?.score?.sets?.length, l = n?.configuration?.scoreBox && c, u = a?.matchUpStatus && ri.includes(a.matchUpStatus), d = a?.readyToScore && t?.scoreClick && !g.checkScoreHasValue({ matchUp: a }) && !u, f = document.createElement("div");
	if (f.className = (0, D.default)(ur(), i), f.classList.add("tmx-sd"), f.setAttribute("sideNumber", String(r)), s && r === 1) {
		let e = ni({
			matchUp: a,
			eventHandlers: t
		});
		f.appendChild(e);
	}
	let p = document.createElement("div");
	p.className = dr();
	let m = wr({
		sideContainer: !0,
		initialRoundNumber: e,
		eventHandlers: t,
		composition: n,
		sideNumber: r,
		matchUp: a
	});
	if (p.appendChild(m), l) {
		let e = document.createElement("div");
		e.style.border = "1px solid var(--chc-border-secondary)", p.appendChild(e);
	}
	let h = o?.inlineScoring;
	if (c) {
		let e = $r({
			eventHandlers: t,
			composition: n,
			sideNumber: r,
			matchUp: a
		});
		p.appendChild(e);
	} else if (h && a?.readyToScore && !u) {
		let e = $r({
			eventHandlers: t,
			composition: n,
			sideNumber: r,
			matchUp: {
				...a,
				score: { sets: [{
					setNumber: 1,
					side1Score: 0,
					side2Score: 0,
					...h.mode === "points" && {
						side1PointScore: "0",
						side2PointScore: "0"
					}
				}] }
			}
		});
		p.appendChild(e);
	}
	if (d && !h) {
		let e = (e) => {
			L(t?.scoreClick) && (e.stopPropagation(), t.scoreClick({
				pointerEvent: e,
				matchUp: a
			}));
		}, n = document.createElement("div");
		n.className = Ur()({
			...!l && r === 1 && { sideNumber: 1 },
			fontSize: "small"
		}), n.onclick = e, n.innerHTML = "[Score]", p.appendChild(n);
	}
	return f.appendChild(p), f;
}
//#endregion
//#region src/components/renderStructure/renderMatchUp.ts
var { QUALIFYING: ai } = t;
function oi(e) {
	let { composition: t, initialRoundNumber: n = 1, matchUp: r, moiety: i, selectedMatchUpId: a, searchActive: o } = e, { roundFactor: s, roundNumber: c, finishingRound: l, matchUpType: u, preFeedRound: d, stage: f } = r, p = e.isFinalRound || (l ? Number.parseInt(String(l)) === 1 : !1), m = f === ai && p, h = p, g = c ? Number.parseInt(String(c)) === n : !1, _ = u === "DOUBLES", v = (o || r.isRoundRobin || r.collectionId || e.isLucky || e.isAdHoc) && "mr" || h && "noProgression" || (m || d) && "m0" || i && "m1" || "m2", y = Hr({
		composition: t,
		isDoubles: _,
		roundFactor: s
	})({
		isFirstRound: g,
		link: v
	}), b = y.className, x = t?.configuration || {}, { centerInfo: S } = x || {}, C = e.eventHandlers || {}, w = (e) => {
		L(C?.matchUpClick) && C.matchUpClick({
			pointerEvent: e,
			matchUp: r
		});
	}, T = document.createElement("div");
	T.className = (0, D.default)(t?.theme, e?.className, "matchup", Pr()), T.classList.add("tmx-m"), T.setAttribute("id", r?.matchUpId), T.onclick = w;
	let E = document.createElement("div");
	E.className = Fr({ configuration: x });
	let O = ({ sideNumber: e }) => {
		let t = r?.sides?.find((t) => t.sideNumber === e)?.participant?.entryStatus?.replace("_", " ");
		return Br({
			eventHandlers: C,
			entryStatus: t,
			sideNumber: e,
			className: e === 2 ? b : void 0,
			matchUp: r
		});
	}, k = ii({
		initialRoundNumber: n,
		eventHandlers: C,
		sideNumber: 1,
		composition: t,
		matchUp: r
	}), A = ii({
		className: !S && b,
		initialRoundNumber: n,
		eventHandlers: C,
		sideNumber: 2,
		composition: t,
		matchUp: r
	});
	if (E.appendChild(k), S) {
		let e = O({ sideNumber: 1 }), t = O({ sideNumber: 2 });
		E.appendChild(e.element), t.element && y.applyStyles(t.element), E.appendChild(t.element);
	}
	if (E.appendChild(A), S || y.applyStyles(A), x?.matchUpFooter) {
		let e = document.createElement("div"), t = x?.inlineScoring, n = r.sides?.length === 2 && r.sides[0]?.participant && r.sides[1]?.participant, i = t?.canUndo || t?.canRedo || t?.isComplete || t?.isDirty;
		if (t && t.showFooter !== !1 && n && (!r.winningSide || i)) {
			e.className = "chc-matchup-footer chc-inline-scoring-footer-slot";
			let n = document.createElement("span");
			n.className = "chc-matchup-footer-round";
			let i = r.roundName || "", a = r.roundPosition;
			n.textContent = a ? `${i} \u2022 M${a}` : i, e.appendChild(n);
			let o = document.createElement("div");
			o.className = "chc-inline-scoring-footer-buttons";
			let s = (e, t, n) => {
				let i = document.createElement("button");
				return i.textContent = e, i.className = `chc-inline-scoring-btn ${t}`, n && (i.onclick = (e) => {
					e.stopPropagation(), n({ matchUpId: r.matchUpId });
				}), i;
			}, c = s("Undo", "chc-is-undo", C.inlineUndo), l = s("Redo", "chc-is-redo", C.inlineRedo), u = s("Clear", "chc-is-clear", C.inlineClear), d = s("Submit", "chc-is-submit", C.inlineSubmit);
			c.disabled = !t.canUndo, l.disabled = !t.canRedo, u.disabled = !t.canUndo && !t.canRedo, d.disabled = !t.isDirty;
			let f = document.createElement("div");
			f.className = "chc-inline-scoring-buttons", f.append(c, l, u, d), o.appendChild(f), e.appendChild(o);
		} else {
			e.className = "chc-matchup-footer";
			let t = r.roundName || "", n = r.roundPosition;
			e.textContent = n ? `${t} \u2022 Match ${n}` : t;
		}
		E.appendChild(e);
	}
	if (T.appendChild(E), a === r.matchUpId) {
		let e = document.createElement("div");
		e.className = Nr(), T.appendChild(e);
	}
	return T;
}
//#endregion
//#region src/components/renderStructure/renderRound.ts
function si({ initialRoundNumber: e = 1, selectedMatchUpId: t, eventHandlers: n, isFinalRound: r, isRoundRobin: i, searchActive: a, composition: o, roundFactor: s, roundNumber: c, roundProfile: l, minWidth: u, matchUps: d, context: f, isLucky: p }) {
	let m = d.filter((e) => e.roundNumber === c).sort((e, t) => (e.roundPosition || 0) - (t.roundPosition || 0)), g = m.every(({ roundPosition: e, drawPositions: t }) => !e && !t), _ = o?.configuration || {}, v = document.createElement("div");
	if (v.className = Dr(), v.classList.add("tmx-rd"), v.setAttribute("roundNumber", String(c)), _.roundHeader) {
		let e = Er({
			roundProfile: l,
			roundMatchUps: m,
			roundNumber: c,
			eventHandlers: n,
			context: f
		});
		v.appendChild(e);
	}
	let y = document.createElement("div");
	y.className = kr({ variant: g ? "adHoc" : void 0 }), u && (y.style.minWidth = u);
	let b, x, S;
	if (i) {
		let e = (e) => (e || []).reduce((e, t) => t + e, 0);
		m.sort((t, n) => {
			let r = e(t.drawPositions) - e(n.drawPositions), i = t.drawPositions || [], a = n.drawPositions || [], o = (i.length ? Math.min.apply(null, i) : 0) - (a.length ? Math.min.apply(null, a) : 0);
			return r || o;
		});
		let t = m.reduce((e, t) => (e[t.structureId] = t.structureName, e), {});
		b = Object.values(t), x = Object.keys(t), S = Object.keys(h.instanceCount(m.map(({ structureId: e }) => e))).length;
	} else g && m.sort((e, t) => (e.roundOrder ?? 0) - (t.roundOrder ?? 0));
	let C = S && m.length / S, w = Object.keys(l).map((e) => parseInt(e)), T = w.indexOf(c), E = T === 0 && "first" || T === w.length - 1 && "last", D = null;
	return m.forEach((i, u) => {
		let d = C && !(u % C), f = C && Math.floor(u / C), h = C && b[f];
		if (d) {
			D = document.createElement("div"), D.className = "chc-rr-group", D.setAttribute("data-group-id", x[f]), y.appendChild(D);
			let t = document.createElement("div");
			t.className = jr({
				...f === 0 && { variant: 0 },
				...E && { roundOrder: E }
			}), D.appendChild(t);
			let r = document.createElement("div");
			if (r.className = Mr(), L(n?.groupHeaderClick)) {
				let { drawId: e, containerStructureId: t } = m[0];
				D.onclick = (r) => n.groupHeaderClick({
					structureId: x[f],
					containerStructureId: t,
					pointerEvent: r,
					drawId: e
				});
			}
			c === e && (r.innerHTML = h), D.appendChild(r);
		}
		let _ = u % 2 == 0;
		if (s) i.roundFactor = s;
		else if (e > 1 && i.roundFactor) {
			let t = l?.[e]?.roundFactor || 1;
			i.roundFactor /= t;
		} else i.roundFactor ||= 2 ** (c - e);
		let v = oi({
			initialRoundNumber: e,
			selectedMatchUpId: t,
			eventHandlers: n,
			isFinalRound: r,
			searchActive: a,
			composition: o,
			isAdHoc: g,
			isLucky: p,
			matchUp: i,
			moiety: _
		});
		(D || y).appendChild(v);
	}), v.appendChild(y), v;
}
//#endregion
//#region src/components/renderStructure/renderStructure.ts
function ci({ initialRoundNumber: e = 1, selectedMatchUpId: t, eventHandlers: n, searchActive: r, composition: i, structureId: a, finalColumn: o, matchUps: s, minWidth: c, context: l }) {
	let { roundNumbers: u, roundProfile: d, roundsNotPowerOf2: f, hasNoRoundPositions: p } = g.getRoundMatchUps({ matchUps: s });
	a = a || l?.structureId || s?.[0]?.structureId;
	let m = s.some(({ isRoundRobin: e }) => e), h = Ar({
		roundsNotPowerOf2: f,
		hasNoRoundPositions: p,
		roundNumbers: u,
		roundProfile: d
	}), _ = document.createElement("div");
	_.className = Or(), _.classList.add("tmx-str"), _.setAttribute("id", a || "");
	let v = u.length ? Math.max.apply(null, u) : 0;
	for (let a of u) {
		if (a < e) continue;
		let o = si({
			initialRoundNumber: e,
			selectedMatchUpId: t,
			eventHandlers: n,
			isFinalRound: a === v,
			isRoundRobin: m,
			searchActive: r,
			composition: i,
			roundNumber: a,
			roundProfile: d,
			matchUps: s,
			minWidth: c,
			context: l,
			isLucky: h
		});
		_.appendChild(o);
	}
	let y = null, b = (e, t) => {
		_.querySelectorAll(`.tmx-i[id="${CSS.escape(e)}"]`).forEach((e) => {
			e.closest(".tmx-p")?.classList.toggle("chc-participant-hover", t);
		});
	};
	if (_.addEventListener("mouseover", (e) => {
		let t = e.target.closest(".tmx-i")?.id;
		t && t !== "undefined" && t !== y ? (y && b(y, !1), y = t, b(t, !0)) : (!t || t === "undefined") && y && (b(y, !1), y = null);
	}), _.addEventListener("mouseleave", () => {
		y &&= (b(y, !1), null);
	}), o && typeof o != "boolean") {
		let e = document.createElement("div");
		e.className = Dr();
		let t = document.createElement("div");
		t.className = kr(), t.appendChild(o), e.appendChild(t), _.appendChild(e);
	}
	return _;
}
//#endregion
//#region src/styles/containerStyle.ts
var li = () => "chc-container";
//#endregion
//#region src/components/renderStructure/renderContainer.ts
function ui({ content: e, theme: t }) {
	let n = document.createElement("div");
	return n.className = t ? (0, D.default)(li(), t) : li(), t && n.classList.add(t), typeof e == "string" ? n.innerHTML = e : n.appendChild(e), n;
}
//#endregion
//#region src/styles/themes/createTheme.ts
function di(e, t) {
	return `chc-theme-${e.replace("-theme", "")}`;
}
//#endregion
//#region src/styles/themes/australianTheme.ts
var fi = di("australian-theme", { colors: {
	borderHover: "#0091d2",
	connector: "#999"
} }), pi = di("basiccard-theme", { colors: {
	connector: "transparent",
	border: "#ddd",
	borderHover: "#0066cc",
	matchupBoxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)"
} }), mi = di("wimbledon-theme", {
	borderWidths: {},
	colors: {
		connector: "transparent",
		border: "#00703c",
		matchUp: "var(--chc-bg-elevated)"
	},
	participant: { textTransform: "uppercase" }
}), hi = di("french-theme", {
	colors: {
		winnerName: "#01503d!important",
		winner: "#01503d!important",
		borderHover: "#0091d2",
		border: "var(--chc-border-secondary)"
	},
	matchUp: { boxShadow: "0 0 30px 0 hsla(0,0%,89%,9)" }
}), gi = di("usopen-theme", { colors: {
	matchUpBackgroundColor: "var(--chc-bg-secondary)",
	internalDividers: "darkgray",
	borderHover: "#0091d2",
	connector: "#999"
} }), _i = di("basic-theme", {
	colors: {
		internalDividers: "transparent",
		winner: "#50B649!important",
		loser: "#E61A1A!important",
		connector: "#999"
	},
	space: { gameMarginInlineEnd: "0.75rem" },
	participant: { seed: "transparent" },
	fontSizes: { 1: "1.5rem" }
}), vi = di("itf-theme", {
	colors: {
		borderHover: "#0091d2",
		connector: "#999",
		matchUp: "var(--chc-bg-elevated)"
	},
	participant: {
		textTransform: "uppercase",
		seed: "gray"
	}
}), yi = {
	Australian: {
		configuration: { flags: !0 },
		theme: fi
	},
	Basic: {
		configuration: {
			gameScoreOnly: !0,
			teamLogo: !1,
			roundHeader: !0,
			placeHolders: {
				tbd: "TBD",
				bye: "Bye"
			}
		},
		theme: _i
	},
	DrawPositions: {
		configuration: {
			gameScoreOnly: !0,
			drawPositions: !0,
			teamLogo: !1
		},
		theme: _i
	},
	French: {
		configuration: {
			bracketedSeeds: !0,
			flags: !0
		},
		theme: hi
	},
	Wimbledon: {
		configuration: {
			resultsInfo: !0,
			flags: !0
		},
		theme: mi
	},
	"US Open": {
		configuration: {
			scoreBox: !0,
			flags: !0
		},
		theme: gi
	},
	ITF: {
		configuration: {
			winnerChevron: !0,
			centerInfo: !0,
			flags: !0,
			roundHeader: !0
		},
		theme: vi
	},
	BasicCard: {
		configuration: {
			flags: !0,
			scheduleInfo: !0,
			matchUpFooter: !0,
			roundHeader: !0
		},
		theme: pi
	},
	InlineScoring: {
		configuration: {
			matchUpFooter: !0,
			gameScore: {
				position: "trailing",
				inverted: !0
			},
			inlineScoring: {
				mode: "games",
				showFooter: !0,
				showSituation: !0
			}
		},
		theme: pi
	},
	National: {
		configuration: {
			bracketedSeeds: "square",
			allDrawPositions: !0,
			drawPositions: !0,
			scheduleInfo: !0,
			roundHeader: !0,
			showAddress: !0,
			scaleAttributes: {
				scaleColor: "red",
				scaleType: "RATING",
				scaleName: "WTN",
				accessor: "wtnRating"
			}
		},
		theme: fi
	}
}, bi = "National";
function xi(e, t = bi) {
	let n = yi[e?.compositionName ?? t] ?? yi[t] ?? yi[bi];
	return {
		theme: e?.theme ?? n.theme,
		configuration: {
			...n.configuration,
			...e?.configuration
		}
	};
}
//#endregion
//#region src/components/renderSchematicStructure/renderSchematicMatchUp.ts
var { QUALIFYING: Si } = t;
function Ci({ matchUp: e, moiety: t, isFirstRound: n, isFinalRound: r, isRoundRobin: i, isLucky: a }) {
	let { stage: o, preFeedRound: s } = e, c = o === Si && r, l = r, u = (i || e.collectionId || a) && "mr" || l && "noProgression" || (c || s) && "m0" || t && "m1" || "m2", d = document.createElement("div");
	d.className = "chc-schematic-matchup";
	let f = document.createElement("div");
	f.className = "chc-schematic-slot";
	let p = document.createElement("div");
	p.className = "chc-schematic-divider";
	let m = document.createElement("div");
	m.className = (0, D.default)("chc-schematic-slot", "chc-schematic-link", n && "chc-schematic-link--first-round", u === "mr" && "chc-schematic-link--no-link", u === "m1" && "chc-schematic-link--m1", u === "m2" && "chc-schematic-link--m2", u === "m0" && "chc-schematic-link--m0", u === "noProgression" && "chc-schematic-link--no-progression");
	let h = e.roundFactor || 1, g = 11 / 2 * h, _ = 11 / 2 * h;
	return m.style.setProperty("--chc-schematic-connector-w", "8px"), m.style.setProperty("--chc-schematic-m1-h", `${g}px`), m.style.setProperty("--chc-schematic-m2-h", `${_}px`), d.appendChild(f), d.appendChild(p), d.appendChild(m), d;
}
//#endregion
//#region src/components/renderSchematicStructure/renderSchematicRound.ts
function wi({ initialRoundFactor: e, initialRoundNumber: t = 1, isFinalRound: n, isRoundRobin: r, roundNumber: i, matchUps: a, showHeader: o, isLucky: s }) {
	let c = a.filter((e) => e.roundNumber === i).sort((e, t) => (e.roundPosition || 0) - (t.roundPosition || 0)), l = document.createElement("div");
	if (l.className = "chc-schematic-round-container", l.dataset.roundNumber = String(i), o) {
		let e = document.createElement("div");
		e.className = "chc-schematic-round-header", e.textContent = `R${i}`, l.appendChild(e);
	}
	let u = document.createElement("div");
	return u.className = "chc-schematic-round", c.forEach((a, o) => {
		e && a.roundFactor ? a.roundFactor /= e : a.roundFactor ||= 2 ** (i - t);
		let c = o % 2 == 0, l = Ci({
			initialRoundNumber: t,
			isRoundRobin: r,
			isFinalRound: n,
			isFirstRound: i === t,
			isLucky: s,
			matchUp: a,
			moiety: c
		});
		u.appendChild(l);
	}), c.some((e) => e.preFeedRound) && !n && l.classList.add("chc-schematic-round--pre-feed"), l.appendChild(u), l;
}
//#endregion
//#region src/components/renderSchematicStructure/renderSchematicStructure.ts
function Ti({ initialRoundNumber: e = 1, showHeaders: t = !0, structureId: n, matchUps: r }) {
	let { roundNumbers: i, roundProfile: a, roundsNotPowerOf2: o, hasNoRoundPositions: s } = g.getRoundMatchUps({ matchUps: r }), c = r.some((e) => e.isRoundRobin), l = o || s, u = e > 1 ? a?.[e]?.roundFactor || 1 : void 0, d = document.createElement("div");
	d.className = "chc-schematic-structure", n && d.setAttribute("id", `schematic-${n}`);
	let f = i.length ? Math.max(...i) : 0;
	for (let n of i) {
		if (n < e) continue;
		let i = wi({
			showHeader: t,
			initialRoundFactor: u,
			initialRoundNumber: e,
			isRoundRobin: c,
			isFinalRound: n === f,
			roundNumber: n,
			matchUps: r,
			isLucky: l
		});
		d.appendChild(i);
	}
	return d;
}
//#endregion
//#region src/components/forms/renderForm.ts
function Ei(e, t, n) {
	let r = document.createElement("div");
	r.style.cssText = "display: flex; flex-direction: column; width: 100%;", r.classList.add("flexcol");
	let i = {}, a = {}, o;
	for (let e of t) {
		if ((e.text || e.html) && !e.field) {
			o = Oi(e, r, i, a, o);
			continue;
		}
		if (e.divider) {
			let e = document.createElement("hr");
			e.classList.add("dropdown-divider"), r.appendChild(e);
			continue;
		}
		if (e.spacer) {
			let t = document.createElement("div"), n = typeof e.spacer == "number" && `${e.spacer}em` || typeof e.spacer == "string" && e.spacer || "1em";
			t.style.marginBlockEnd = n, r.appendChild(t);
			continue;
		}
		!e.label && !e.field || e.hide || e.field && (o = ki(e, r, i, a, o));
	}
	return o && setTimeout(() => o.focus(), 200), e.appendChild(r), n?.length && Ai(n, t, i, a), i;
}
function Di(e, t, n, r) {
	let i = r, { field: a, inputElement: o, datepicker: s } = Tn(e.fieldPair);
	return s && (t[`${e.field}.date`] = s), o && (t[e.fieldPair.field] = o, e.fieldPair.focus && (i = o)), n[e.fieldPair.field] = a, i;
}
function Oi(e, t, n, r, i) {
	let a = i, o = e.fieldPair && document.createElement("div");
	o && (o.className = "flexrow");
	let s = document.createElement("div");
	s.className = "flexaligncenter", s.style.cssText = e.style || e.header && "font-weight: bold; font-size: larger;" || "height: 2.5em; padding-right: 1em;";
	let c = document.createElement("div");
	return e.id && (c.id = e.id), c.className = "content", c.innerHTML = e.text, s.appendChild(c), o ? (o.appendChild(s), a = Di(e, n, r, a), o.appendChild(r[e.fieldPair.field]), t.appendChild(o)) : t.appendChild(s), a;
}
function ki(e, t, n, r, i) {
	let a = i, o = e.fieldPair && document.createElement("div");
	o && (o.className = "flexrow");
	let { field: s, inputElement: c, datepicker: l, subFields: u } = Tn(e);
	return u && u.forEach((e) => n[e.field] = e.input), l && (n[`${e.field}.date`] = l), e.focus && (a = c), n[e.field] = c, r[e.field] = s, o ? (o.appendChild(s), a = Di(e, n, r, a), o.appendChild(r[e.fieldPair.field]), t.appendChild(o)) : t.appendChild(s), a;
}
function Ai(e, t, n, r) {
	for (let i of e) {
		if (i.dateRange && Array.isArray(i.fields)) {
			let [e, r] = i.fields;
			if (n[e] && n[r]) {
				let a = t.find((t) => t.field === e), o = new bn(n[e], {
					inputs: [n[e], n[r]],
					minDate: i.minDate,
					maxDate: i.maxDate,
					format: "yyyy-mm-dd",
					language: a?.language || "en",
					autohide: !0
				});
				n[`${e}.date`] = o;
			}
		}
		i.control && (z(i.onChange) && n[i.control].addEventListener("change", (e) => i.onChange({
			e,
			inputs: n,
			fields: r
		})), z(i.onInput) && n[i.control] && n[i.control].addEventListener("input", (e) => i.onInput({
			e,
			inputs: n,
			fields: r
		})), z(i.onFocusOut) && n[i.control] && n[i.control].addEventListener("focusout", (e) => i.onFocusOut({
			e,
			inputs: n,
			fields: r
		})));
	}
}
//#endregion
//#region src/components/modal/mockParticipants.ts
var { ratingsParameters: ji } = o, { WTN: Mi, UTR: Ni } = a.ratingConstants, { FEMALE: Pi, MALE: Fi, ANY: Ii } = s;
function Li(e = {}) {
	let { callback: t, consideredDate: n, title: r = "Generate mock participants", labels: i = {}, defaults: a = {}, roleOptions: o } = e, s, c = o && o.length > 1, l = a.participantRole || o?.[0]?.value || "COMPETITOR", u = {
		role: i.role || "Participant role",
		gender: i.gender || "Participant gender",
		count: i.count || "Participant count",
		ageRange: i.ageRange || "Participant Age Range",
		minAge: i.minAge || "Min Age",
		maxAge: i.maxAge || "Max Age",
		ratings: i.ratings || "Generate Ratings",
		countries: i.countries || "# of Countries",
		cancel: i.cancel,
		generate: i.generate,
		genderAny: i.genderAny,
		genderFemale: i.genderFemale,
		genderMale: i.genderMale
	}, f = a.ratings ? [...a.ratings] : [...a.wtnRating ? [Mi] : [], ...a.utrRating ? [Ni] : []], p = {
		gender: a.gender || Ii,
		participantsCount: a.participantsCount || 32,
		ageMin: a.ageMin,
		ageMax: a.ageMax,
		nationalityCodesCount: a.nationalityCodesCount
	}, m = Object.entries(ji).filter(([, e]) => !e.deprecated).map(([e]) => ({
		label: e,
		value: e,
		selected: f.includes(e)
	})), h = [{
		label: u.cancel || "Cancel",
		intent: "none",
		close: !0
	}, {
		label: u.generate || "Generate",
		intent: "is-info",
		close: !0,
		onClick: () => {
			let e = s.participantsCount.value, r = s.gender.value, i = r === Ii ? void 0 : r, a = c ? s.participantRole.value : l, o = s.ageMin?.value ? Number.parseInt(s.ageMin.value) : void 0, u = s.ageMax?.value ? Number.parseInt(s.ageMax.value) : void 0, f = s.nationalityCodesCount?.value ? Number.parseInt(s.nationalityCodesCount.value) : void 0, p = (s.ratings?.selectedValues || []).map((e) => {
				let t = ji[e];
				if (!t) return null;
				let [n, r] = t.range || [0, 100], i = Math.min(n, r), a = Math.max(n, r) - i;
				return {
					ratingType: e,
					ratingMin: i + a * .3,
					ratingMax: i + a * .7
				};
			}).filter(Boolean), m = o || u ? {
				ageMin: o,
				ageMax: u
			} : void 0, { participants: h } = d.generateParticipants({
				participantsCount: Number.parseInt(e),
				scaleAllParticipants: !0,
				nationalityCodesCount: f,
				participantRole: a,
				consideredDate: n,
				categories: p,
				category: m,
				sex: i
			});
			t && t(h);
		}
	}], g = [{
		control: "ageMin",
		onChange: ({ inputs: e }) => {
			let t = Number.parseInt(e.ageMin.value) || 0, n = Number.parseInt(e.ageMax.value) || 0;
			t > n && n > 0 && (e.ageMax.value = t);
		}
	}, {
		control: "ageMax",
		onChange: ({ inputs: e }) => {
			let t = Number.parseInt(e.ageMin.value) || 0, n = Number.parseInt(e.ageMax.value) || 0;
			n < t && t > 0 && n > 0 && (e.ageMin.value = n);
		}
	}], _ = c ? [{
		options: o.map((e) => ({
			label: e.label,
			value: e.value,
			selected: e.value === l
		})),
		label: u.role,
		field: "participantRole",
		value: l
	}] : [];
	R.open({
		title: r,
		content: (e) => s = Ei(e, [
			..._,
			{
				options: [
					{
						label: u.genderAny || "Any",
						value: Ii,
						selected: p.gender === Ii
					},
					{
						label: u.genderFemale || "Female",
						value: Pi,
						selected: p.gender === Pi
					},
					{
						label: u.genderMale || "Male",
						value: Fi,
						selected: p.gender === Fi
					}
				],
				label: u.gender,
				field: "gender",
				value: p.gender
			},
			{
				options: [
					{
						label: "8",
						value: 8,
						selected: p.participantsCount === 8
					},
					{
						label: "16",
						value: 16,
						selected: p.participantsCount === 16
					},
					{
						label: "32",
						value: 32,
						selected: p.participantsCount === 32
					},
					{
						label: "64",
						value: 64,
						selected: p.participantsCount === 64
					},
					{
						label: "128",
						value: 128,
						selected: p.participantsCount === 128
					},
					{
						label: "256",
						value: 256,
						selected: p.participantsCount === 256
					}
				],
				label: u.count,
				field: "participantsCount",
				value: p.participantsCount
			},
			{
				label: u.minAge,
				field: "ageMin",
				placeholder: "e.g., 10",
				type: "number",
				value: p.ageMin,
				width: "50%",
				fieldPair: {
					label: u.maxAge,
					field: "ageMax",
					placeholder: "e.g., 18",
					type: "number",
					value: p.ageMax
				}
			},
			{
				label: u.countries,
				field: "nationalityCodesCount",
				id: "nationalityCodesCount",
				placeholder: "e.g., 10",
				type: "number",
				value: p.nationalityCodesCount
			},
			{
				label: u.ratings,
				field: "ratings",
				id: "ratings",
				multiple: !0,
				options: m
			}
		], g),
		buttons: h
	});
}
//#endregion
//#region src/components/modal/generateTeamsModal.ts
var { FEMALE: Ri, MALE: zi, ANY: Bi } = s, { TEAM: Vi } = f;
function Hi(e) {
	if (!e?.collectionDefinitions?.length) return 8;
	let t = 0;
	for (let n of e.collectionDefinitions) {
		let e = n.matchUpCount || 0, r = n.matchUpType === "DOUBLES" ? 2 : 1;
		t += e * r;
	}
	return t || 8;
}
function Ui(e = {}) {
	let { callback: t, consideredDate: n, title: r = "Generate mock teams", tieFormats: i = [], labels: a = {} } = e, o, s = i.length > 0, c = [{
		label: a.manualTeamSize || "Manual team size",
		value: "-",
		selected: !0
	}, ...i.map((e) => ({
		label: e.label,
		value: e.value,
		selected: !1
	}))], l = [{
		label: a.cancel || "Cancel",
		intent: "none",
		close: !0
	}, {
		label: a.generate || "Generate",
		intent: "is-info",
		close: !0,
		onClick: () => {
			let e = Number.parseInt(o.teamsCount.value) || 4, r = o.gender.value, a = r === Bi ? void 0 : r, c, l = s ? o.tieFormatSelect?.value : "-";
			if (l && l !== "-") {
				let e = i.find((e) => e.value === l);
				c = e ? Hi(e.tieFormat) : 8;
				let t = o.teamSize?.value, n = t ? Number.parseInt(t) : 0;
				n > c && (c = n);
			} else c = Number.parseInt(o.teamSize?.value) || 8;
			let u = o.nationalityCodesCount?.value ? Number.parseInt(o.nationalityCodesCount.value) : void 0, { participants: f } = d.generateParticipants({
				participantsCount: e,
				participantType: Vi,
				nationalityCodesCount: u,
				consideredDate: n,
				teamSize: c,
				sex: a
			});
			t && t(f);
		}
	}], u = s ? [{
		control: "tieFormatSelect",
		onChange: ({ inputs: e }) => {
			let t = e.tieFormatSelect.value;
			if (t && t !== "-") {
				let n = i.find((e) => e.value === t), r = n ? Hi(n.tieFormat) : 8;
				e.teamSize.value = r, e.teamSize.disabled = !0;
			} else e.teamSize.disabled = !1;
		}
	}] : [], f = s ? [{
		options: c,
		label: a.tieFormatTemplate || "Tie format template",
		field: "tieFormatSelect",
		value: "-"
	}] : [];
	R.open({
		title: r,
		content: (e) => o = Ei(e, [
			{
				options: [
					{
						label: a.genderAny || "Any",
						value: Bi,
						selected: !0
					},
					{
						label: a.genderFemale || "Female",
						value: Ri
					},
					{
						label: a.genderMale || "Male",
						value: zi
					}
				],
				label: a.gender || "Gender",
				field: "gender",
				value: Bi
			},
			{
				options: [
					{
						label: "2",
						value: 2
					},
					{
						label: "4",
						value: 4,
						selected: !0
					},
					{
						label: "8",
						value: 8
					},
					{
						label: "16",
						value: 16
					},
					{
						label: "32",
						value: 32
					}
				],
				label: a.teamsCount || "Number of teams",
				field: "teamsCount",
				value: 4
			},
			...f,
			{
				label: a.playersPerTeam || "Players per team",
				field: "teamSize",
				placeholder: "e.g., 8",
				type: "number",
				value: 8
			},
			{
				label: a.countries || "# of Countries",
				field: "nationalityCodesCount",
				placeholder: "e.g., 10",
				type: "number"
			}
		], u),
		buttons: l
	});
}
//#endregion
//#region src/components/modal/compositionEditorModal.ts
var Wi = "grand-slam", Gi = "tour", Ki = "itf", qi = "national-federation", Ji = [
	{
		id: Wi,
		name: "Grand Slam",
		category: Wi,
		tier: 1
	},
	{
		id: "wimbledon",
		name: "Wimbledon",
		category: Wi,
		tier: 1
	},
	{
		id: "australian-open",
		name: "Australian Open",
		category: Wi,
		tier: 2
	},
	{
		id: "wta-500",
		name: "WTA 500",
		category: Gi,
		tier: 2
	},
	{
		id: "wta-1000",
		name: "WTA 1000",
		category: Gi,
		tier: 2
	},
	{
		id: "atp-250",
		name: "ATP 250",
		category: Gi,
		tier: 2
	},
	{
		id: "atp-finals",
		name: "ATP Finals",
		category: Gi,
		tier: 3
	},
	{
		id: "itf-junior",
		name: "ITF Junior",
		category: Ki,
		tier: 3
	},
	{
		id: "itf-pro-circuit",
		name: "ITF Pro Circuit",
		category: Ki,
		tier: 2
	},
	{
		id: qi,
		name: "National Federation",
		category: "national",
		tier: 3
	},
	{
		id: "collegiate-ncaa",
		name: "NCAA Collegiate",
		category: "collegiate",
		tier: 1
	},
	{
		id: "club-basic",
		name: "Club Basic",
		category: "club",
		tier: 1
	}
];
function Yi(e = {}) {
	let t = "preset", n = {}, r = {}, i = {}, a, o = (t) => {
		i = Ei(t, [
			{
				header: !0,
				text: "Composition Preset"
			},
			{ spacer: .5 },
			{
				field: "preset",
				label: "Select Preset",
				options: Ji.map((t) => ({
					label: `${t.name} (${t.category}, Tier ${t.tier})`,
					value: t.id,
					selected: t.id === (e.initialPreset || "club-basic")
				}))
			},
			{ spacer: 1 },
			{
				text: "Select a preset to populate header and footer settings, then customize in the Header and Footer tabs.",
				style: "color: var(--chc-text-muted); font-size: 13px;"
			}
		]);
	}, s = (t) => {
		let r = e.initialHeader || {};
		n = Ei(t, [
			{
				header: !0,
				text: "Header Configuration"
			},
			{ spacer: .5 },
			{
				field: "layout",
				label: "Layout",
				options: [
					{
						label: "Grand Slam",
						value: Wi,
						selected: r.layout === Wi
					},
					{
						label: "ITF / Professional",
						value: Ki,
						selected: r.layout === Ki
					},
					{
						label: "WTA / ATP Tour",
						value: "wta-tour",
						selected: r.layout === "wta-tour"
					},
					{
						label: "National Federation",
						value: qi,
						selected: r.layout === qi
					},
					{
						label: "Minimal",
						value: "minimal",
						selected: r.layout === "minimal" || !r.layout
					},
					{
						label: "None",
						value: "none",
						selected: r.layout === "none"
					}
				]
			},
			{ divider: !0 },
			{
				field: "tournamentName",
				label: "Tournament Name",
				value: r.tournamentName || "",
				placeholder: "e.g., Australian Open 2026"
			},
			{
				field: "subtitle",
				label: "Subtitle / Event",
				value: r.subtitle || "",
				placeholder: "e.g., Womens Singles"
			},
			{ divider: !0 },
			{
				field: "startDate",
				label: "Start Date",
				value: r.startDate || "",
				placeholder: "e.g., 19 Jan 2026",
				fieldPair: {
					field: "endDate",
					label: "End Date",
					value: r.endDate || "",
					placeholder: "e.g., 1 Feb 2026"
				}
			},
			{
				field: "city",
				label: "City",
				value: r.city || "",
				placeholder: "e.g., Melbourne",
				fieldPair: {
					field: "country",
					label: "Country",
					value: r.country || "",
					placeholder: "e.g., AUS"
				}
			},
			{
				field: "surface",
				label: "Surface",
				value: r.surface || "",
				placeholder: "e.g., Hard"
			},
			{
				field: "prizeMoney",
				label: "Prize Money",
				value: r.prizeMoney || "",
				placeholder: "e.g., 1,520,600"
			},
			{ divider: !0 },
			{
				field: "supervisor",
				label: "Supervisor",
				value: r.supervisor || ""
			},
			{
				field: "grade",
				label: "Grade",
				value: r.grade || "",
				placeholder: "e.g., J300"
			},
			{
				field: "sectionLabel",
				label: "Section Label",
				value: r.sectionLabel || "",
				placeholder: "e.g., SINGLES MAIN DRAW"
			}
		]);
	}, c = (t) => {
		let n = e.initialFooter || {};
		r = Ei(t, [
			{
				header: !0,
				text: "Footer Configuration"
			},
			{ spacer: .5 },
			{
				field: "layout",
				label: "Layout",
				options: [
					{
						label: "Standard (timestamp + page)",
						value: "standard",
						selected: n.layout === "standard" || !n.layout
					},
					{
						label: "Seedings Table",
						value: "seedings-table",
						selected: n.layout === "seedings-table"
					},
					{
						label: "Prize Money",
						value: "prize-money",
						selected: n.layout === "prize-money"
					},
					{
						label: "Officials Sign-off",
						value: "officials-signoff",
						selected: n.layout === "officials-signoff"
					},
					{
						label: "Combined Tour (WTA/ATP)",
						value: "combined-tour",
						selected: n.layout === "combined-tour"
					},
					{
						label: "None",
						value: "none",
						selected: n.layout === "none"
					}
				]
			},
			{ divider: !0 },
			{
				field: "showPageNumbers",
				id: "comp-pagenums",
				label: "Show Page Numbers",
				checkbox: !0,
				checked: n.showPageNumbers !== !1
			},
			{
				field: "showTimestamp",
				id: "comp-timestamp",
				label: "Show Timestamp",
				checkbox: !0,
				checked: n.showTimestamp !== !1
			},
			{ divider: !0 },
			{
				field: "releaseDate",
				label: "Release Date",
				value: n.releaseDate || "",
				placeholder: "e.g., 18 Jan 2026 at 15:30"
			},
			{
				field: "drawCeremonyDate",
				label: "Draw Ceremony",
				value: n.drawCeremonyDate || "",
				placeholder: "e.g., 18 Jan 2026 at 14:00"
			}
		]);
	}, l = () => ({
		layout: n.layout?.value || "minimal",
		tournamentName: n.tournamentName?.value || "",
		subtitle: n.subtitle?.value || void 0,
		startDate: n.startDate?.value || void 0,
		endDate: n.endDate?.value || void 0,
		city: n.city?.value || void 0,
		country: n.country?.value || void 0,
		surface: n.surface?.value || void 0,
		prizeMoney: n.prizeMoney?.value || void 0,
		supervisor: n.supervisor?.value || void 0,
		grade: n.grade?.value || void 0,
		sectionLabel: n.sectionLabel?.value || void 0
	}), u = () => ({
		layout: r.layout?.value || "standard",
		showPageNumbers: r.showPageNumbers?.checked ?? !0,
		showTimestamp: r.showTimestamp?.checked ?? !0,
		releaseDate: r.releaseDate?.value || void 0,
		drawCeremonyDate: r.drawCeremonyDate?.value || void 0
	}), d = [
		{
			label: "Preset",
			active: !0,
			onClick: () => {
				t = "preset", f();
			}
		},
		{
			label: "Header",
			active: !1,
			onClick: () => {
				t = "header", f();
			}
		},
		{
			label: "Footer",
			active: !1,
			onClick: () => {
				t = "footer", f();
			}
		}
	], f = () => {
		d.forEach((e) => e.active = e.label.toLowerCase() === t);
		let e = t === "preset" ? o : t === "header" ? s : c;
		a && a.update({
			content: e,
			config: {
				menu: { menuItems: d },
				maxWidth: 520
			}
		});
	};
	return a = R.open({
		title: "PDF Composition",
		content: o,
		buttons: [{
			label: "Apply",
			intent: "is-info",
			onClick: () => {
				let t = {
					header: l(),
					footer: u(),
					preset: i.preset?.value
				};
				e.onApply?.(t), R.close();
			}
		}, {
			label: "Cancel",
			close: !0
		}],
		config: {
			menu: { menuItems: d },
			maxWidth: 520
		}
	}), a;
}
//#endregion
//#region src/components/modal/scheduleCellConfigModal.ts
var Xi = {
	showParticipantNames: !0,
	showNationality: !0,
	showSeedings: !0,
	showMatchNumber: !1,
	showEventRound: !0,
	showScheduledTime: !0,
	showMatchFormat: !1,
	showScore: !0,
	nameFormat: "full",
	cellStyle: "detailed"
};
function Zi(e = {}) {
	let t = {
		...Xi,
		...e.initial
	}, n = {}, r = (e) => {
		n = Ei(e, [
			{
				header: !0,
				text: "Schedule Cell Content"
			},
			{
				text: "Select which information appears in each schedule grid cell.",
				style: "color: var(--chc-text-muted); font-size: 13px;"
			},
			{ spacer: .5 },
			{
				field: "showNationality",
				id: "scc-nationality",
				label: "Nationality (country code)",
				checkbox: !0,
				checked: t.showNationality
			},
			{
				field: "showSeedings",
				id: "scc-seedings",
				label: "Seedings",
				checkbox: !0,
				checked: t.showSeedings
			},
			{
				field: "showEventRound",
				id: "scc-eventround",
				label: "Event & Round",
				checkbox: !0,
				checked: t.showEventRound
			},
			{
				field: "showScheduledTime",
				id: "scc-time",
				label: "Scheduled Time / Not Before",
				checkbox: !0,
				checked: t.showScheduledTime
			},
			{
				field: "showScore",
				id: "scc-score",
				label: "Score (for completed matches)",
				checkbox: !0,
				checked: t.showScore
			},
			{
				field: "showMatchNumber",
				id: "scc-matchnum",
				label: "Match Number",
				checkbox: !0,
				checked: t.showMatchNumber
			},
			{
				field: "showMatchFormat",
				id: "scc-format",
				label: "Match Format Code",
				checkbox: !0,
				checked: t.showMatchFormat
			},
			{ divider: !0 },
			{
				field: "nameFormat",
				label: "Name Format",
				options: [
					{
						label: "Full (LASTNAME, First)",
						value: "full",
						selected: t.nameFormat === "full"
					},
					{
						label: "Abbreviated (F. LASTNAME)",
						value: "abbreviated",
						selected: t.nameFormat === "abbreviated"
					},
					{
						label: "Last Name Only",
						value: "lastOnly",
						selected: t.nameFormat === "lastOnly"
					}
				]
			},
			{
				field: "cellStyle",
				label: "Cell Density",
				options: [{
					label: "Detailed",
					value: "detailed",
					selected: t.cellStyle === "detailed"
				}, {
					label: "Compact",
					value: "compact",
					selected: t.cellStyle === "compact"
				}]
			}
		]);
	}, i = () => ({
		showParticipantNames: !0,
		showNationality: n.showNationality?.checked ?? !0,
		showSeedings: n.showSeedings?.checked ?? !0,
		showMatchNumber: n.showMatchNumber?.checked ?? !1,
		showEventRound: n.showEventRound?.checked ?? !0,
		showScheduledTime: n.showScheduledTime?.checked ?? !0,
		showMatchFormat: n.showMatchFormat?.checked ?? !1,
		showScore: n.showScore?.checked ?? !0,
		nameFormat: n.nameFormat?.value || "full",
		cellStyle: n.cellStyle?.value || "detailed"
	}), a = document.createElement("div");
	a.style.cssText = "display: flex; gap: 6px; margin-top: 4px;";
	let o = [
		{
			label: "Detailed",
			config: { ...Xi }
		},
		{
			label: "Compact",
			config: {
				...Xi,
				showNationality: !1,
				showScheduledTime: !1,
				showMatchFormat: !1,
				nameFormat: "abbreviated",
				cellStyle: "compact"
			}
		},
		{
			label: "Broadcast",
			config: {
				...Xi,
				showMatchNumber: !0,
				showMatchFormat: !0
			}
		},
		{
			label: "Minimal",
			config: {
				...Xi,
				showNationality: !1,
				showSeedings: !1,
				showScheduledTime: !1,
				showMatchFormat: !1,
				showScore: !1,
				nameFormat: "lastOnly",
				cellStyle: "compact"
			}
		}
	];
	for (let e of o) {
		let t = document.createElement("button");
		t.textContent = e.label, t.className = "chc-button chc-button--sm", t.style.cssText = "padding: 2px 8px; font-size: 11px; cursor: pointer; border: 1px solid var(--chc-border-primary); border-radius: 3px; background: var(--chc-bg-secondary);", t.onclick = () => {
			let t = e.config;
			n.showNationality && (n.showNationality.checked = t.showNationality), n.showSeedings && (n.showSeedings.checked = t.showSeedings), n.showMatchNumber && (n.showMatchNumber.checked = t.showMatchNumber), n.showEventRound && (n.showEventRound.checked = t.showEventRound), n.showScheduledTime && (n.showScheduledTime.checked = t.showScheduledTime), n.showMatchFormat && (n.showMatchFormat.checked = t.showMatchFormat), n.showScore && (n.showScore.checked = t.showScore), n.nameFormat && (n.nameFormat.value = t.nameFormat), n.cellStyle && (n.cellStyle.value = t.cellStyle);
		}, a.appendChild(t);
	}
	return R.open({
		title: "Schedule Cell Configuration",
		content: (e) => {
			r(e);
			let t = document.createElement("div");
			t.style.cssText = "font-size: 12px; color: var(--chc-text-muted); margin-top: 12px;", t.textContent = "Quick presets:", e.appendChild(t), e.appendChild(a);
		},
		buttons: [{
			label: "Apply",
			intent: "is-info",
			onClick: () => {
				e.onApply?.(i()), R.close();
			}
		}, {
			label: "Cancel",
			close: !0
		}],
		config: { maxWidth: 440 }
	});
}
//#endregion
//#region src/components/matchUpFormat/matchUpFormatLogic.ts
var Qi = "Timed set", $i = "Tiebreak", ea = [
	"SET",
	"HAL",
	"QTR",
	"PER",
	"INN",
	"RND",
	"FRM",
	"MAP"
], ta = {
	SET: "Set",
	HAL: "Half",
	QTR: "Quarter",
	PER: "Period",
	INN: "Inning",
	RND: "Round",
	FRM: "Frame",
	MAP: "Map"
};
function na(e) {
	return !e || e === "SET" ? [
		1,
		3,
		5
	] : [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12
	];
}
function ra(e = !1) {
	return {
		descriptor: e ? "Final set" : "Best of",
		bestOf: e ? void 0 : 3,
		advantage: "Ad",
		what: "Set",
		setTo: 6,
		tiebreakAt: 6,
		tiebreakTo: 7,
		winBy: 2,
		minutes: 10
	};
}
function ia() {
	return {
		matchRoot: void 0,
		aggregate: void 0,
		gameFormat: void 0,
		setFormat: ra(!1),
		finalSetFormat: ra(!0)
	};
}
function aa(e) {
	return !!(e?.tiebreakSet?.tiebreakTo && !e?.setTo);
}
function oa(e, t) {
	let { what: n, setTo: r, tiebreakAt: i, tiebreakTo: a, winBy: o, minutes: s, advantage: c, based: l, modifier: u } = e, d = { setTo: r };
	return n === "Set" && c === "No-Ad" && (d.NoAD = !0), t && n === "Set" && (d.tiebreakAt = i, d.tiebreakFormat = { tiebreakTo: a }, o === 1 && (d.tiebreakFormat.NoAD = !0), u && (d.tiebreakFormat.modifier = u)), n === "Timed set" && (d.minutes = s, d.timed = !0, l && (d.based = l), u && (d.modifier = u)), n === "Tiebreak" && (d.tiebreakSet = { tiebreakTo: a }, o === 1 && (d.tiebreakSet.NoAD = !0), u && (d.tiebreakSet.modifier = u)), d;
}
function sa(e) {
	return e <= 1 ? [] : [e - 1, e];
}
function ca(e, t) {
	return sa(e).includes(t) ? t : e;
}
function la(e) {
	if (e) return e.tiebreakSet?.modifier || e.tiebreakFormat?.modifier || e.modifier || void 0;
}
function ua(e, t) {
	let n = t(e);
	if (!n) return ia();
	let r = ra(!1), i = ra(!0), a = {
		matchRoot: n.matchRoot || void 0,
		aggregate: n.aggregate || void 0,
		gameFormat: n.gameFormat || void 0,
		setFormat: {
			...r,
			...n.setFormat
		},
		finalSetFormat: {
			...i,
			...n.finalSetFormat
		}
	};
	n.setFormat?.based && (a.setFormat.based = n.setFormat.based), n.finalSetFormat?.based && (a.finalSetFormat.based = n.finalSetFormat.based);
	let o = la(n.setFormat);
	o && (a.setFormat.modifier = o);
	let s = la(n.finalSetFormat);
	return s && (a.finalSetFormat.modifier = s), n.exactly ? (a.setFormat.exactly = n.exactly, a.setFormat.descriptor = "Exactly", delete a.setFormat.bestOf, a.setFormat.timed && (a.setFormat.what = Qi)) : (a.setFormat.bestOf = n.bestOf || 3, a.setFormat.descriptor = "Best of", delete a.setFormat.exactly), aa(n.setFormat) && (a.setFormat.what = $i, a.setFormat.tiebreakTo = n.setFormat.tiebreakSet.tiebreakTo, a.setFormat.winBy = n.setFormat.tiebreakSet.NoAD ? 1 : 2), n.setFormat?.timed && (a.setFormat.what = Qi, a.setFormat.minutes = n.setFormat.minutes), aa(n.finalSetFormat) && (a.finalSetFormat.what = $i, a.finalSetFormat.tiebreakTo = n.finalSetFormat.tiebreakSet.tiebreakTo, a.finalSetFormat.winBy = n.finalSetFormat.tiebreakSet.NoAD ? 1 : 2), n.finalSetFormat?.timed && (a.finalSetFormat.what = Qi, a.finalSetFormat.minutes = n.finalSetFormat.minutes), a;
}
//#endregion
//#region src/components/matchUpFormat/matchUpFormats.json
var da = [
	{
		key: "custom",
		name: "Custom",
		desc: ""
	},
	{
		key: "standard",
		name: "Standard Advantage",
		format: "SET3-S:6/TB7",
		desc: "Best of 3 Sets to 6 with Advantage"
	},
	{
		key: "atpd",
		name: "Standard Doubles",
		format: "SET3-S:6NOAD/TB7-F:TB10",
		desc: "Best of 3 Sets to 6, no Ad",
		desc2: "Final Set Tiebreak to 10"
	},
	{
		key: "standard1",
		name: "One Standard Set",
		format: "SET1-S:6/TB7",
		desc: "1 Set to 6 Games, Tiebreak to 7"
	},
	{
		key: "wimbledon2018",
		name: "Wimbledon 2018",
		format: "SET5-S:6/TB7-F:6",
		desc: "Best of 5 tiebreak sets, final set no tiebreak"
	},
	{
		key: "wimbledon2019",
		name: "Wimbledon 2019",
		format: "SET5-S:6/TB7-F:6/TB7@12",
		desc: "Best of 5 tiebreak sets, final set tiebreak at 12"
	},
	{
		key: "Aus2019",
		name: "Australian Open 2019",
		format: "SET5-S:6/TB7-F:6/TB10",
		desc: "Best of 5 tiebreak sets, final set tiebreak at 12"
	},
	{
		key: "short",
		name: "Short Sets TB7@4",
		format: "SET3-S:4/TB7",
		desc: "Best of 3 Sets to 4, tiebreak to 7 at 4-4"
	},
	{
		key: "short1",
		name: "Fast 4",
		format: "SET3-S:4/TB5@3",
		desc: "Best of 3 Sets to 4, tiebreak to 5 at 3-3"
	},
	{
		key: "short2",
		name: "One Short Set TB7",
		format: "SET1-S:4/TB7",
		desc: "One Set to 4, tiebreak to 7 at 4-4"
	},
	{
		key: "short3",
		name: "One Short Set TB5",
		format: "SET1-S:4/TB5@3",
		desc: "One Set to 4, tiebreak to 5 at 3-3"
	},
	{
		key: "short4",
		name: "Short Sets w/ 3rd TB10",
		format: "SET3-S:4/TB7-F:TB10",
		desc: "Best of 3 Sets to 4 Games, tiebreak to 10",
		desc2: "3rd Set Tiebreak to 7"
	},
	{
		key: "short5",
		name: "Short Sets w/ 3rd TB7",
		format: "SET3-S:4/TB7-F:TB7",
		desc: "Best of 3 Sets to 4 Games, tiebreak to 7",
		desc2: "3rd Set Tiebreak to 7"
	},
	{
		key: "pro",
		name: "Pro Set",
		format: "SET1-S:8/TB7",
		desc: "One Set to 8 with Advantage, tiebreak at 8-8"
	},
	{
		key: "cps",
		name: "College Pro Set",
		format: "SET1-S:8/TB7@7"
	},
	{
		key: "tbsets1",
		name: "Best of 3 TB7",
		format: "SET3-S:TB7",
		desc: "Two tiebreak sets",
		desc2: "7-point match tiebreak at one set all"
	},
	{
		key: "tbsets2",
		name: "Best of 3 TB10",
		format: "SET3-S:TB10",
		desc: "Best of 3 tiebreaks to 10"
	},
	{
		key: "tbsets3",
		name: "One Tiebreak to 10",
		format: "SET1-S:TB10",
		desc: "One Match Tiebreak to 10 with Advantage"
	},
	{
		key: "tbsets4",
		name: "Two TB7 w/ 3rd TB10",
		format: "SET3-S:TB7-F:TB10",
		desc: "Two 7 point tiebreak sets",
		desc2: "10 point tiebreak at one set all"
	},
	{
		key: "timed10",
		name: "Timed 10 minute game - game based",
		format: "SET1-S:T10"
	},
	{
		key: "1pointslam",
		name: "1 Point Slam",
		format: "SET1-S:TB1NOAD"
	},
	{
		key: "pickleball",
		name: "Pickleball Standard",
		format: "SET3-S:TB11",
		desc: "Best of 3 games to 11"
	},
	{
		key: "pickleballRally",
		name: "Pickleball Rally",
		format: "SET3-S:TB11@RALLY",
		desc: "Best of 3 games to 11, rally scoring"
	},
	{
		key: "mlp",
		name: "MLP Format",
		format: "SET5-S:TB21@RALLY-F:TB15@RALLY",
		desc: "Best of 5 to 21, final to 15, rally scoring"
	},
	{
		key: "padel",
		name: "Padel Standard",
		format: "SET3-S:6NOAD/TB7",
		desc: "Best of 3 sets to 6, golden point"
	},
	{
		key: "padelStarPoint",
		name: "Padel Star Point (2026)",
		format: "SET3-S:6/TB7-G:TN3D",
		desc: "Best of 3 sets to 6, golden point, Star Point deuce"
	},
	{
		key: "squash",
		name: "Squash PAR-11",
		format: "SET5-S:TB11",
		desc: "Best of 5 games to 11"
	},
	{
		key: "badminton",
		name: "Badminton BWF",
		format: "SET3-S:TB21",
		desc: "Best of 3 games to 21"
	},
	{
		key: "volleyball",
		name: "Volleyball Indoor",
		format: "SET5-S:TB25-F:TB15",
		desc: "Best of 5 sets to 25, final to 15"
	},
	{
		key: "beachVolleyball",
		name: "Beach Volleyball",
		format: "SET3-S:TB21-F:TB15",
		desc: "Best of 3 sets to 21, final to 15"
	},
	{
		key: "soccer",
		name: "Soccer",
		format: "HAL2A-S:T45",
		desc: "2 halves of 45 minutes, aggregate"
	},
	{
		key: "basketball",
		name: "Basketball NBA",
		format: "QTR4A-S:T12",
		desc: "4 quarters of 12 minutes, aggregate"
	},
	{
		key: "iceHockey",
		name: "Ice Hockey",
		format: "PER3A-S:T20",
		desc: "3 periods of 20 minutes, aggregate"
	},
	{
		key: "boxing",
		name: "Boxing Championship",
		format: "RND12A-S:T3",
		desc: "12 rounds of 3 minutes, aggregate"
	},
	{
		key: "mma",
		name: "MMA Standard",
		format: "RND3A-S:T5",
		desc: "3 rounds of 5 minutes, aggregate"
	},
	{
		key: "blw",
		name: "BLW Standard",
		format: "INN4XA-S:O3-M:T50",
		desc: "4 innings, 3 outs, 50 minute max match time"
	},
	{
		key: "typti",
		name: "TYPTI Standard",
		format: "SET5-S:5-G:3C",
		desc: "Best of 5 sets to 5, 3 consecutive points/game"
	},
	{
		key: "intennse",
		name: "INTENNSE",
		format: "SET7XA-S:T10P",
		desc: "Exactly 7 timed sets, aggregate, points-based"
	}
], B = "none", V = "▾", fa = "all .2s ease-in-out", pa = "var(--chc-text-primary)", ma = "var(--chc-dropdown-bg)", ha = "var(--chc-hover-bg)";
function ga(e) {
	return typeof e == "function";
}
var _a = {
	labels: {
		title: "Match format",
		setFormatLabel: "Set format",
		finalSetLabel: "Final set",
		tiebreakLabel: "Tiebreak",
		finalSetToggleLabel: "Final set",
		standardFormatsLabel: "Standard formats",
		cancel: "Cancel",
		select: "Select",
		custom: "Custom",
		aggregate: "Aggregate",
		game: "Game",
		gameType: "Game type",
		deuceRule: "Deuce rule",
		none: "None",
		traditional: "Traditional",
		consecutive2: "2 consecutive",
		consecutive3: "3 consecutive",
		consecutive4: "4 consecutive",
		goldenPoint: "Golden point",
		starPoint: "Star point",
		games: "Games",
		points: "Points",
		descriptors: {
			bestOf: "Best of",
			exactly: "Exactly"
		},
		what: {
			sets: "Set",
			tiebreaks: "Tiebreak",
			timedSets: "Timed set"
		},
		advantage: {
			ad: "Ad",
			noAd: "No-Ad"
		}
	},
	options: {
		bestOf: [
			1,
			3,
			5
		],
		exactly: [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12
		],
		setTo: [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9
		],
		tiebreakTo: [
			1,
			3,
			5,
			7,
			9,
			10,
			11,
			12,
			13,
			15,
			21,
			25
		],
		tiebreakToExactly: [1, 3],
		tiebreakAt: [
			3,
			4,
			5,
			6,
			7,
			8
		],
		minutes: [
			3,
			5,
			8,
			10,
			12,
			15,
			20,
			25,
			30,
			45,
			60,
			90,
			120
		],
		winBy: [1, 2],
		matchRoots: [...ea],
		gameFormats: [
			"None",
			"TN",
			"2C",
			"3C",
			"4C"
		],
		modifiers: ["None", "RALLY"]
	}
}, H = _a, va, U, ya = {};
function W(e) {
	return ya[e] || document.getElementById(e) || null;
}
var ba = "Timed set", xa = "Tiebreak", Sa = "No-Ad", Ca = "Set", wa = "Ad", Ta = {
	Games: "G",
	Points: "P"
};
function Ea() {
	return {
		G: H.labels?.games || "Games",
		P: H.labels?.points || "Points"
	};
}
function Da() {
	return {
		None: H.labels?.none || "None",
		TN: H.labels?.traditional || "Traditional",
		"2C": H.labels?.consecutive2 || "2 consecutive",
		"3C": H.labels?.consecutive3 || "3 consecutive",
		"4C": H.labels?.consecutive4 || "4 consecutive"
	};
}
function Oa() {
	return {
		None: H.labels?.none || "None",
		"1D": H.labels?.goldenPoint || "Golden point",
		"3D": H.labels?.starPoint || "Star point"
	};
}
function ka(e) {
	let t = Da(), n = Oa();
	if (!e) return H.labels?.none || "None";
	let r;
	if (e.type === "TRADITIONAL") r = t.TN || "Traditional";
	else if (e.type === "CONSECUTIVE") r = t[`${e.count}C`] || `${e.count} consecutive`;
	else return H.labels?.none || "None";
	if (e.deuceAfter) {
		let t = `${e.deuceAfter}D`;
		r += ` + ${n[t] || t}`;
	}
	return r;
}
var G = {
	matchRoot: void 0,
	aggregate: void 0,
	gameFormat: void 0,
	setFormat: {
		descriptor: "Best of",
		bestOf: 3,
		advantage: wa,
		what: Ca,
		setTo: 6,
		tiebreakAt: 6,
		tiebreakTo: 7,
		winBy: 2,
		minutes: 10
	},
	finalSetFormat: {
		descriptor: "Final set",
		advantage: wa,
		what: Ca,
		setTo: 6,
		tiebreakAt: 6,
		tiebreakTo: 7,
		winBy: 2,
		minutes: 10
	}
};
function Aa(e) {
	let t = G[e ? "finalSetFormat" : "setFormat"];
	return oa(t, W(e ? "finalSetTiebreak" : "setTiebreak")?.checked || !1);
}
function ja() {
	U = { setFormat: Aa() }, G.matchRoot && G.matchRoot !== "SET" && (U.matchRoot = G.matchRoot), G.aggregate && (U.aggregate = !0), G.gameFormat && (U.gameFormat = G.gameFormat);
	let e = G.setFormat.descriptor, t = G.setFormat.exactly ?? G.setFormat.bestOf ?? 3;
	e === "Exactly" ? (U.exactly = t, delete U.bestOf) : (U.bestOf = t, delete U.exactly), W("finalSetOption")?.checked && (U.finalSetFormat = Aa(1));
	let n = c.scoreGovernor.stringifyMatchUpFormat(U), r = (H.preDefinedFormats ? H.preDefinedFormats.map((e) => ({
		value: e.code,
		label: e.text,
		format: e.code
	})) : da).some((e) => e.format === n), i = W("matchUpFormatSelector");
	if (i) {
		let e = i.value, t = r ? n : "Custom";
		if (e !== t) {
			let e = i.onchange;
			i.onchange = null, i.value = t, i.onchange = e;
		}
	}
	return n;
}
function K(e) {
	let t = e || ja();
	va = t;
	let n = W("matchUpFormatString");
	n && (n.innerHTML = t);
}
var Ma = (e, t) => t && e.finalSetFormat || e.setFormat, Na = [
	{
		getValue: (e) => e.exactly ? H.labels?.descriptors?.exactly || "Exactly" : H.labels?.descriptors?.bestOf || "Best of",
		options: () => [H.labels?.descriptors?.bestOf || "Best of", H.labels?.descriptors?.exactly || "Exactly"],
		id: "descriptor",
		value: H.labels?.descriptors?.bestOf || "Best of",
		finalSet: !1,
		onChange: "changeDescriptor"
	},
	{
		getValue: (e) => e.bestOf || e.exactly,
		finalSet: !1,
		id: "bestOf",
		options: () => G.setFormat.descriptor === (H.labels?.descriptors?.exactly || "Exactly") ? H.options?.exactly || _a.options.exactly : na(G.matchRoot),
		onChange: "pluralize",
		onChangeCallback: "updateFinalSetVisibility",
		value: 3
	},
	{
		getValue: (e, t) => {
			let n = Ma(e, t), r = n?.NoAD ? Sa : wa;
			return n?.timed || n?.tiebreakSet ? void 0 : r;
		},
		options: [wa, Sa],
		onChange: "changeAdvantage",
		defaultValue: wa,
		id: "advantage",
		whats: [Ca]
	},
	{
		getValue: (e, t) => {
			let n = Ma(e, t);
			return n || console.log({ pmf: e }), n?.timed ? ba : n?.tiebreakSet ? xa : Ca;
		},
		options: [
			Ca,
			xa,
			ba
		],
		finalSetLabel: `${Ca}${V}`,
		onChange: "changeWhat",
		onChangeCallback: "updateWhatValue",
		pluralize: !0,
		id: "what"
	},
	{
		getValue: (e, t) => Ma(e, t).setTo,
		options: () => H.options?.setTo || _a.options.setTo,
		onChange: "changeCount",
		defaultValue: 6,
		whats: [Ca],
		prefix: "to ",
		id: "setTo"
	},
	{
		getValue: (e, t) => {
			let n = Ma(e, t);
			return n.tiebreakFormat?.tiebreakTo || n.tiebreakSet?.tiebreakTo;
		},
		options: (e) => {
			let t = G.setFormat.descriptor, n = H.options?.tiebreakTo || _a.options.tiebreakTo, r = H.options?.tiebreakToExactly || _a.options.tiebreakToExactly;
			return e && t === "Exactly" ? [...r, ...n] : n;
		},
		onChange: "changeTiebreakTo",
		whats: [Ca, xa],
		id: "tiebreakTo",
		defaultValue: 7,
		prefix: "TB to ",
		tbSet: !0,
		value: 7,
		tb: !0
	},
	{
		getValue: (e, t) => Ma(e, t).tiebreakAt,
		options: (e) => {
			let t = G[e ? "finalSetFormat" : "setFormat"].setTo;
			return sa(t);
		},
		onChange: "changeTiebreakAt",
		id: "tiebreakAt",
		defaultValue: 6,
		whats: [Ca],
		prefix: "@",
		value: 6,
		tb: !0
	},
	{
		getValue: (e, t) => {
			let n = Ma(e, t);
			if (!(!n.tiebreakFormat && !n.tiebreakSet)) return n.tiebreakFormat?.NoAD || n.tiebreakSet?.NoAD ? 1 : 2;
		},
		whats: [Ca, xa],
		onChange: "changeWinBy",
		prefix: "Win by ",
		options: [1, 2],
		defaultValue: 2,
		tbSet: !0,
		id: "winBy",
		tb: !0
	},
	{
		getValue: (e, t) => {
			let n = Ma(e, t);
			return n.timed && n.minutes || void 0;
		},
		options: () => H.options?.minutes || _a.options.minutes,
		onChange: "changeMinutes",
		whats: [ba],
		suffix: " Minutes",
		defaultValue: 10,
		id: "minutes",
		timed: !0
	},
	{
		getValue: (e, t) => {
			let n = Ma(e, t);
			if (!n?.timed) return;
			let r = n.based || "G";
			return Ea()[r] || r;
		},
		options: () => ["Games", "Points"],
		onChange: "changeBased",
		whats: [ba],
		defaultValue: "Games",
		id: "based",
		timed: !0
	},
	{
		getValue: (e, t) => {
			let n = Ma(e, t);
			return n?.tiebreakSet?.modifier || n?.tiebreakFormat?.modifier || n?.modifier || void 0;
		},
		options: () => H.options?.modifiers || _a.options.modifiers,
		onChange: "changeModifier",
		whats: [xa, ba],
		prefix: "@",
		defaultValue: "None",
		id: "modifier",
		tb: !0
	}
];
function Pa(e) {
	if (G.setFormat.what !== ba) {
		delete G.setFormat.setTo, delete G.setFormat.tiebreakAt, delete G.setFormat.tiebreakTo, delete G.setFormat.winBy, delete G.setFormat.tiebreakFormat, delete G.setFormat.NoAD, G.setFormat.what = ba, G.setFormat.minutes || (G.setFormat.minutes = 10), La.changeWhat(new Event("click"), void 0, ba);
		let t = W("what");
		t && (t.innerHTML = `${ba}${e > 1 ? "s" : ""}${V}`);
		let n = W("minutes");
		n && (n.innerHTML = `${G.setFormat.minutes} Minutes${V}`, n.style.display = "");
		let r = W("based");
		if (r) {
			let e = G.setFormat.based || "G";
			r.innerHTML = `${Ea()[e] || e}${V}`, r.style.display = "";
		}
	}
	G.setFormat.exactly = e, delete G.setFormat.bestOf;
}
function Fa(e) {
	let t = e % 2 == 0 ? e + 1 : e;
	G.setFormat.bestOf = t, delete G.setFormat.exactly;
	let n = W("bestOf");
	n && (n.innerHTML = `${t}${V}`), t !== e && La.pluralize(new Event("click"), void 0, t);
}
function Ia() {
	let e = W("tiebreakTo-1");
	if (!e || e.style.display === B) return;
	let t = G.finalSetFormat.tiebreakTo || 7, n = Na.find((e) => e.id === "tiebreakTo");
	if (!n) return;
	let { prefix: r = "", suffix: i = "" } = n, a = (ga(n.options) ? n.options(1) : n.options).includes(t) ? t : 7;
	a !== t && (G.finalSetFormat.tiebreakTo = a), e.innerHTML = `${r}${a}${i}${V}`;
}
var La = {
	changeDescriptor: (e, t, n) => {
		G.setFormat.descriptor = n;
		let r = G.setFormat.bestOf || G.setFormat.exactly || 3;
		n === "Exactly" ? Pa(r) : Fa(r), Ia(), K();
	},
	changeWhat: (e, t, n) => {
		let r = n === Ca, i = W(t ? "finalSetTiebreakToggle" : "setTiebreakToggle");
		if (i && (i.style.display = r ? "" : B), !t && n !== ba && G.setFormat.descriptor === "Exactly") {
			G.setFormat.descriptor = "Best of";
			let e = G.setFormat.exactly || 3, t = e % 2 == 0 ? e + 1 : e;
			G.setFormat.bestOf = t, delete G.setFormat.exactly;
			let n = W("descriptor");
			n && (n.innerHTML = `Best of${V}`);
			let r = W("bestOf");
			r && (r.innerHTML = `${t}${V}`);
		}
		Na.forEach((e) => {
			if (e.whats) {
				let { prefix: r = "", suffix: i = "", pluralize: a } = e, o = e.whats.includes(n), s = W(t ? `${e.id}-${t}` : e.id);
				if (!s) return;
				if (s.style.display === B && o) {
					let n = U.bestOf || U.exactly, o = !t && a && n > 1 ? "s" : "", c = e.defaultValue;
					s.innerHTML = `${r}${c}${o}${i}${V}`;
					let l = c;
					if (e.id === "modifier" && c === "None" && (l = void 0), e.id === "based") {
						let e = Ta[c] || c;
						l = e === "G" ? void 0 : e;
					}
					G[t ? "finalSetFormat" : "setFormat"][e.id] = l;
				}
				s.style.display = o ? "" : B;
			}
		}), K();
	},
	changeCount: (e, t, n) => {
		let r = t ? "finalSetFormat" : "setFormat";
		G[r].setTo = n;
		let i = G[r].tiebreakAt, a = ca(n, i);
		if (a !== i) {
			G[r].tiebreakAt = a;
			let e = W(t ? `tiebreakAt-${t}` : "tiebreakAt");
			e && (e.innerHTML = `@${a}${V}`);
		}
		K();
	},
	changeTiebreakAt: (e, t, n) => {
		G[t ? "finalSetFormat" : "setFormat"].tiebreakAt = n, K();
	},
	updateWhatValue: (e, t, n) => {
		G[t ? "finalSetFormat" : "setFormat"].what = n;
	},
	changeAdvantage: (e, t, n) => {
		G[t ? "finalSetFormat" : "setFormat"].advantage = n, K();
	},
	changeTiebreakTo: (e, t, n) => {
		G[t ? "finalSetFormat" : "setFormat"].tiebreakTo = n, K();
	},
	changeWinBy: (e, t, n) => {
		G[t ? "finalSetFormat" : "setFormat"].winBy = n, K();
	},
	changeMinutes: (e, t, n) => {
		G[t ? "finalSetFormat" : "setFormat"].minutes = n, K();
	},
	changeBased: (e, t, n) => {
		let r = t ? "finalSetFormat" : "setFormat", i = Ta[n] || n;
		if (G[r].based = i === "G" ? void 0 : i, !t) {
			let e = W("gameFormat");
			e && (i === "P" ? (G.gameFormat = void 0, e.style.display = B) : e.style.display = "");
		}
		K();
	},
	changeModifier: (e, t, n) => {
		let r = t ? "finalSetFormat" : "setFormat";
		G[r].modifier = n === "None" ? void 0 : n, K();
	},
	changeMatchRoot: (e, t, n) => {
		let r = G.matchRoot || "SET";
		if (G.matchRoot = n === "SET" ? void 0 : n, r !== n) {
			let e = na(G.matchRoot), t = G.setFormat.bestOf;
			if (t && !e.includes(t)) {
				let n = e[e.length - 1] >= t ? e.reduce((e, n) => n <= t ? n : e, e[0]) : e[e.length - 1];
				G.setFormat.bestOf = n;
				let r = W("bestOf");
				r && (r.innerHTML = `${n}${V}`);
			}
		}
		K();
	},
	changeAggregate: () => {
		G.aggregate = W("aggregateOption")?.checked || void 0, K();
	},
	changeGameFormat: (e, t, n) => {
		G.gameFormat = n, K();
	},
	pluralize: (e, t, n) => {
		let r = G[t ? "finalSetFormat" : "setFormat"].what, i = W(t ? `what-${t}` : "what");
		i && (i.innerHTML = `${r}${n > 1 ? "s" : ""}${V}`), t || (G.setFormat.descriptor === "Exactly" ? (G.setFormat.exactly = n, delete G.setFormat.bestOf) : (G.setFormat.bestOf = n, delete G.setFormat.exactly)), K();
	},
	updateFinalSetVisibility: (e, t, n) => {
		let r = n > 1, i = W("finalSetOption"), a = W("finalSetOptionLabel");
		i && a && (r ? (i.style.display = "", a.style.display = "") : (i.checked && (i.checked = !1, i.dispatchEvent(new Event("change"))), i.style.display = "none", a.style.display = "none"));
	}
};
function Ra({ existingMatchUpFormat: e = "SET3-S:6/TB7", callback: t, config: n, modalConfig: r } = {}) {
	H = n ? {
		labels: {
			..._a.labels,
			...n.labels
		},
		options: {
			..._a.options,
			...n.options
		},
		preDefinedFormats: n.preDefinedFormats || _a.preDefinedFormats
	} : _a, va = e, ya = {}, U = l.parse(va), U ||= (console.warn("Invalid matchUpFormat:", va), va = "SET3-S:6/TB7", l.parse(va));
	let i = ua(va, l.parse);
	G.matchRoot = i.matchRoot, G.aggregate = i.aggregate, G.gameFormat = i.gameFormat, G.setFormat = { ...i.setFormat }, G.finalSetFormat = { ...i.finalSetFormat };
	let a = () => {
		let e = W("matchUpFormatSelector"), n = e?.value && e.value !== "Custom" ? va : ja();
		ga(t) && t(n);
	}, o = [{
		onClick: () => {
			Wa(), t?.("");
		},
		label: H.labels?.cancel || "Cancel",
		intent: "none",
		footer: {
			className: "button",
			style: "background-color: var(--chc-bg-primary); color: var(--chc-text-primary); border: 1px solid var(--chc-border-primary);"
		},
		close: !0
	}, {
		label: H.labels?.select || "Select",
		intent: "is-info",
		close: !0,
		onClick: () => {
			Wa(), a();
		}
	}], s = "switch is-rounded is-danger", c = document.createElement("div");
	c.addEventListener("click", (e) => {
		let t = e.target;
		!t.closest(".dropdown") && !t.classList.contains("mfcButton") && Wa();
	});
	let u = document.createElement("div");
	u.id = "matchUpFormatString", u.innerHTML = va, u.style.fontSize = "1.5em", u.style.color = "var(--chc-format-code-color)", u.style.marginBottom = "1em", ya.matchUpFormatString = u, c.appendChild(u);
	let d = document.createElement("div");
	d.style.marginBlockEnd = "1em";
	let f = H.preDefinedFormats ? H.preDefinedFormats.map((e) => ({
		value: e.code,
		label: e.text,
		format: e.code
	})) : da, p = {
		id: "matchUpFormatSelector",
		options: [{
			value: "Custom",
			label: H.labels?.custom || "Custom",
			selected: !1
		}, ...f.filter((e) => e.format).map((e) => ({
			selected: e.format === va,
			value: e.format,
			label: ("label" in e ? e.label : e.name) || ""
		}))]
	}, m = document.createElement("select");
	m.id = "matchUpFormatSelector", m.className = "input", m.style.width = "100%", m.style.backgroundColor = "var(--chc-input-bg)", m.style.color = pa, m.style.border = "1px solid var(--chc-input-border)";
	for (let e of p.options) {
		let t = document.createElement("option");
		t.value = e.value || "", t.text = e.label || "", t.style.backgroundColor = "var(--chc-input-bg)", t.style.color = pa, e.selected && (t.selected = !0), m.appendChild(t);
	}
	ya.matchUpFormatSelector = m;
	function h(e, t, n) {
		if (!e.getValue) return;
		let r = e.getValue(U, n), i = W(t);
		if (i && r != null) {
			let { prefix: t = "", suffix: n = "", pluralize: a } = e, o = U.bestOf || U.exactly;
			i.innerHTML = `${t}${r}${a && o > 1 ? "s" : ""}${n}${V}`, i.style.display = "";
		} else i && (i.style.display = B);
	}
	function g(e, t, n, r, i) {
		let a = W("matchRoot");
		if (a) {
			let e = G.matchRoot || "SET";
			a.innerHTML = `${ta[e] || e}${V}`;
		}
		let o = W("aggregateOption");
		o && (o.checked = !!G.aggregate);
		let s = W("gameFormat");
		s && (s.innerHTML = `${H.labels?.game || "Game"}: ${ka(G.gameFormat)}${V}`, s.style.display = G.setFormat.based === "P" ? B : "");
		let c = U.bestOf || U.exactly;
		La.updateFinalSetVisibility(null, 0, c);
		let l = U.finalSetFormat;
		e.style.display = l ? "" : B, t.style.display = l ? "" : B, n.checked = !!l;
		let u = l?.tiebreakSet?.tiebreakTo && !l?.setTo;
		i.checked = !!l?.tiebreakFormat, i.style.display = u ? B : "";
		let d = W("finalSetTiebreakToggle");
		d && (d.style.display = u ? B : "");
		let f = G.setFormat.what, p = !!U.setFormat.tiebreakFormat;
		r.checked = p;
		let m = f === Ca;
		r.style.display = m ? "" : B;
		let g = W("setTiebreakToggle");
		g && (g.style.display = m ? "" : B), Na.forEach((e) => {
			if (h(e, e.id, !1), e.tb && f === Ca) {
				let t = W(e.id);
				t && (t.style.display = p ? t.style.display : B);
			}
			l && h(e, `${e.id}-1`, !0);
		});
	}
	m.onchange = (e) => {
		if (va = e.target.value, K(va), U = l.parse(va), !U) {
			console.warn("Invalid matchUpFormat selected:", va);
			return;
		}
		let t = ua(va, l.parse);
		G.matchRoot = t.matchRoot, G.aggregate = t.aggregate, G.gameFormat = t.gameFormat, G.setFormat = { ...t.setFormat }, G.finalSetFormat = { ...t.finalSetFormat }, g(j, M, k, E, P);
	}, d.appendChild(m), c.appendChild(d);
	let _ = document.createElement("div");
	_.style.display = "flex", _.style.flexWrap = "wrap", _.style.gap = "0.5em", _.style.marginBottom = "0.5em", _.style.alignItems = "center";
	let v = G.matchRoot || "SET", y = document.createElement("button");
	y.className = "mfcButton", y.id = "matchRoot", y.innerHTML = `${ta[v] || v}${V}`, y.style.transition = fa, y.style.backgroundColor = "inherit", y.style.border = "none", y.style.color = "inherit", y.style.padding = ".3em", y.style.textAlign = "center", y.style.textDecoration = "none", y.style.fontSize = "1em", y.style.cursor = "pointer", y.onclick = (e) => {
		Ka(e, (H.options?.matchRoots || _a.options.matchRoots).map((t) => ({
			text: `${ta[t] || t}`,
			onClick: () => {
				y.innerHTML = `${ta[t] || t}${V}`, La.changeMatchRoot(e, void 0, t);
			}
		})));
	}, _.appendChild(y);
	let b = document.createElement("input");
	b.type = "checkbox", b.className = "switch is-rounded is-warning", b.id = "aggregateOption", b.name = "aggregateOption", b.checked = !!G.aggregate, b.onchange = () => {
		La.changeAggregate(new Event("change"), void 0, void 0);
	}, _.appendChild(b);
	let x = document.createElement("label");
	x.setAttribute("for", "aggregateOption"), x.innerHTML = H.labels?.aggregate || "Aggregate", x.style.marginRight = "1em", _.appendChild(x);
	let S = ka(G.gameFormat), C = document.createElement("button");
	C.className = "mfcButton", C.id = "gameFormat", C.innerHTML = `${H.labels?.game || "Game"}: ${S}${V}`, C.style.transition = fa, C.style.backgroundColor = "inherit", C.style.border = "none", C.style.color = "inherit", C.style.padding = ".3em", C.style.textAlign = "center", C.style.textDecoration = "none", C.style.fontSize = "1em", C.style.cursor = "pointer", G.setFormat.based === "P" && (C.style.display = B), C.onclick = (e) => {
		Ga(e, G.gameFormat, (e) => {
			G.gameFormat = e, C.innerHTML = `${H.labels?.game || "Game"}: ${ka(G.gameFormat)}${V}`, K();
		});
	}, _.appendChild(C), ya.matchRoot = y, ya.aggregateOption = b, ya.gameFormat = C, c.appendChild(_);
	let w = document.createElement("div");
	w.style.display = "flex", w.style.flexWrap = "wrap", w.style.gap = "0.5em", w.style.marginBottom = "1em", Na.map((e) => {
		let t = e.getValue ? e.getValue(U) : void 0, n = Ba({
			...e,
			value: t
		});
		return ya[e.id] = n, n;
	}).forEach((e) => w.appendChild(e)), w.id = "setFormat", c.appendChild(w);
	let T = document.createElement("div");
	T.className = "field", T.style.fontSize = "1em";
	let E = document.createElement("input");
	E.className = s, E.name = "setTiebreak", E.id = "setTiebreak", E.type = "checkbox", E.checked = !!U.setFormat.tiebreakFormat, ya.setTiebreak = E, E.onchange = (e) => {
		let t = e.target.checked;
		Na.filter(({ tb: e }) => e).forEach((e) => {
			let n = W(e.id);
			if (n) {
				if (n.style.display === B && t) {
					let { prefix: t = "", suffix: r = "", pluralize: i, defaultValue: a } = e, o = U.bestOf || U.exactly;
					n.innerHTML = `${t}${a}${i && o > 1 ? "s" : ""}${r}${V}`;
				}
				n.style.display = t ? "" : B;
			}
		}), K();
	}, T.appendChild(E);
	let D = document.createElement("label");
	D.setAttribute("for", "setTiebreak"), D.id = "setTiebreakToggle", D.innerHTML = H.labels?.tiebreakLabel || "Tiebreak", D.style.marginRight = "1em", ya.setTiebreakToggle = D, T.appendChild(D);
	let O = (U.bestOf || U.exactly) > 1, k = document.createElement("input");
	k.className = "switch is-rounded is-info", k.type = "checkbox", k.name = "finalSetOption", k.checked = !!U.finalSetFormat, k.id = "finalSetOption", ya.finalSetOption = k, k.style.display = O ? "" : "none", k.onchange = (e) => {
		let t = e.target.checked;
		if (t) {
			G.finalSetFormat = {
				...G.setFormat,
				descriptor: "Final set"
			};
			let e = G.setFormat.what, t = G.setFormat.bestOf || G.setFormat.exactly || 3, n = W("what-1");
			n && (n.innerHTML = `${e}${t > 1 ? "s" : ""}${V}`), Na.forEach((t) => {
				let n = W(`${t.id}-1`);
				if (n) if (!t.whats || t.whats.includes(e)) {
					let e = G.finalSetFormat[t.id];
					if (e !== void 0) {
						let { prefix: r = "", suffix: i = "" } = t;
						n.innerHTML = `${r}${e}${i}${V}`;
					}
					n.style.display = "";
				} else n.style.display = B;
			});
			let r = W("finalSetTiebreakToggle");
			if (r && (r.style.display = e === Ca ? "" : B), e === Ca) {
				let e = W("setTiebreak"), t = W("finalSetTiebreak");
				e && t && (t.checked = e.checked);
			}
		}
		j.style.display = t ? "" : B, M.style.display = t ? "" : B, K();
	}, T.appendChild(k);
	let A = document.createElement("label");
	A.setAttribute("for", "finalSetOption"), A.innerHTML = H.labels?.finalSetLabel || "Final set", A.style.display = O ? "" : "none", ya.finalSetOptionLabel = A, T.appendChild(A), c.appendChild(T);
	let j = document.createElement("div");
	j.style.display = U.finalSetFormat ? "flex" : B, j.style.flexWrap = "wrap", j.style.gap = "0.5em", j.style.marginBottom = "1em", j.id = "finalSetFormat", ya.finalSetFormatDiv = j, [{
		label: `<div style='font-weight: bold'>${H.labels?.finalSetLabel || "Final set"}</div>`,
		options: [],
		finalSet: !0
	}].concat(Na.map((e) => {
		let t = e.getValue ? e.getValue(U, !0) : void 0;
		return {
			...e,
			value: t
		};
	})).filter((e) => e.finalSet !== !1).map((e) => {
		let t = Ba({
			...e,
			index: 1
		});
		return e.id && (ya[`${e.id}-1`] = t), t;
	}).forEach((e) => j.appendChild(e)), c.appendChild(j);
	let M = document.createElement("div");
	M.id = "finalSetConfig", ya.finalSetConfigDiv = M, M.style.display = U.finalSetFormat ? "" : B, M.className = "field", M.style.fontSize = "1em";
	let N = U.finalSetFormat?.tiebreakSet?.tiebreakTo && !U.finalSetFormat?.setTo, P = document.createElement("input");
	P.className = s, P.name = "finalSetTiebreak", P.id = "finalSetTiebreak", ya.finalSetTiebreak = P, P.type = "checkbox", P.checked = U.finalSetFormat ? !!U.finalSetFormat.tiebreakFormat : !!U.setFormat.tiebreakFormat, P.style.display = N ? B : "", M.onchange = (e) => {
		let t = e.target.checked;
		Na.filter(({ tb: e }) => e).forEach((e) => {
			let n = W(`${e.id}-1`);
			if (n) {
				if (n.style.display === B && t) {
					let { prefix: t = "", suffix: r = "", pluralize: i, defaultValue: a } = e, o = U.bestOf || U.exactly;
					n.innerHTML = `${t}${a}${i && o > 1 ? "s" : ""}${r}${V}`;
				}
				n.style.display = t ? "" : B;
			}
		}), K();
	}, M.appendChild(P);
	let F = document.createElement("label");
	F.setAttribute("for", "finalSetTiebreak"), F.id = "finalSetTiebreakToggle", F.innerHTML = H.labels?.tiebreakLabel || "Tiebreak", F.style.marginRight = "1em", F.style.display = N ? B : "", ya.finalSetTiebreakToggle = F, M.appendChild(F), c.appendChild(M);
	let ee = {
		content: { padding: "1.5" },
		maxWidth: 480,
		fontSize: "14px",
		style: {
			backgroundColor: "var(--chc-bg-secondary)",
			borderRadius: "8px",
			boxShadow: "0 8px 16px rgba(0, 102, 204, 0.2)"
		}
	}, te = r?.fontSize || r?.style?.fontSize || ee.fontSize, ne = {
		...ee,
		...r,
		fontSize: te,
		style: {
			...ee.style,
			...n?.style || {},
			...r?.style || {}
		}
	}, re = R.open({
		title: H.labels?.title || "Score format",
		content: c,
		buttons: o,
		config: ne
	});
	return setTimeout(() => {
		if (U.finalSetFormat?.tiebreakSet?.tiebreakTo && !U.finalSetFormat?.setTo) {
			let e = W("what-1");
			e && (e.innerHTML = `${xa}${V}`), La.changeWhat(new Event("click"), 1, xa);
		}
		let e = document.querySelector(".modal.is-active");
		if (e) {
			let t = new MutationObserver((n) => {
				n.forEach((n) => {
					n.removedNodes.forEach((n) => {
						n === e && (Wa(), t.disconnect());
					});
				});
			});
			t.observe(document.body, { childList: !0 });
		}
	}, 0), re;
}
function za({ index: e, finalSetLabel: t, label: n, prefix: r = "", suffix: i = "", value: a, pluralize: o }) {
	let s = G.setFormat.bestOf || G.setFormat.exactly || 1;
	return n || e && t || `${r}${a}${!e && o && s > 1 ? "s" : ""}${i}${V}`;
}
function Ba(e) {
	let { id: t, initiallyHidden: n, index: r, value: i } = e, a = document.createElement("button");
	return a.className = "mfcButton", a.id = r ? `${t}-${r}` : t, a.innerHTML = za(e), a.onclick = (t) => Va({
		e: t,
		button: a,
		...e
	}), a.style.display = i || e.label ? "" : B, n && (a.style.display = B), a.style.transition = fa, a.style.backgroundColor = "inherit", a.style.border = "none", a.style.color = "inherit", a.style.padding = ".3em", a.style.textAlign = "center", a.style.textDecoration = "none", a.style.fontSize = "1em", a.style.cursor = "pointer", a;
}
function Va(e) {
	let { e: t, id: n, button: r, pluralize: i, options: a, onChange: o, onChangeCallback: s, index: c, prefix: l = "", suffix: u = "" } = e, d = G.setFormat.bestOf || G.setFormat.exactly || 1, f = !c && i && d > 1 ? "s" : "";
	Ka(t, (ga(a) ? a(c) : a).map((e) => ({
		text: `${e}${f}`,
		onClick: () => {
			r.innerHTML = `${l}${e}${f}${u}${V}`, G[c ? "finalSetFormat" : "setFormat"][n] = e, o && ga(La[o]) && La[o](t, c, e), s && ga(La[s]) && La[s](t, c, e), K();
		}
	})));
}
var Ha = null, Ua = null;
function Wa() {
	Ha && document.body.contains(Ha) && Ha.remove(), Ua &&= (document.removeEventListener("click", Ua), null), Ha = null;
}
function Ga(e, t, n) {
	Wa();
	let r = document.createElement("div");
	r.className = "dropdown is-active", r.style.position = "absolute", r.style.zIndex = "10000";
	let i = document.createElement("div");
	i.className = "dropdown-menu", i.style.backgroundColor = ma, i.style.border = "1px solid var(--chc-border-secondary)", i.style.borderRadius = "4px", i.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)", i.style.padding = "0.25em 0", i.style.minWidth = "180px";
	let a = "none", o = "none";
	t?.type === "TRADITIONAL" ? a = "TN" : t?.type === "CONSECUTIVE" && (a = `${t.count}C`), t?.deuceAfter && (o = `${t.deuceAfter}D`);
	function s(e, t) {
		if (e === "none" && t === "none") return;
		let n = {};
		return e === "TN" ? n.type = "TRADITIONAL" : /^\d+C$/.test(e) ? (n.type = "CONSECUTIVE", n.count = Number(e.slice(0, -1))) : n.type = "TRADITIONAL", t !== "none" && (n.deuceAfter = Number(t.slice(0, -1))), n;
	}
	function c() {
		let e = r.querySelector("input[name=\"gameType\"]:checked"), t = r.querySelector("input[name=\"deuceRule\"]:checked");
		n(s(e?.value || "none", t?.value || "none"));
	}
	let l = "padding: 0.3em 1em; font-weight: bold; font-size: 0.85rem; color: var(--chc-text-muted); text-transform: uppercase; letter-spacing: 0.5px;", u = "border-top: 1px solid #eee; margin: 0.25em 0;", d = document.createElement("div");
	d.textContent = H.labels?.none || "None", d.style.cssText = "padding: 0.4em 1em; cursor: pointer; background-color: var(--chc-dropdown-bg); color: var(--chc-text-primary); font-size: 1rem;", d.onmouseenter = () => {
		d.style.backgroundColor = ha;
	}, d.onmouseleave = () => {
		d.style.backgroundColor = ma;
	}, d.onclick = (e) => {
		e.preventDefault(), e.stopPropagation(), n(void 0), Wa();
	}, i.appendChild(d);
	function f(e, t, n, r) {
		let i = document.createElement("label");
		i.style.cssText = "display: flex; align-items: center; padding: 0.3em 1em; cursor: pointer; gap: 0.4em; font-size: 1rem; color: var(--chc-text-primary);", i.onmouseenter = () => {
			i.style.backgroundColor = ha;
		}, i.onmouseleave = () => {
			i.style.backgroundColor = ma;
		};
		let a = document.createElement("input");
		a.type = "radio", a.name = e, a.value = t, a.checked = r, a.style.margin = "0", a.onchange = () => c();
		let o = document.createElement("span");
		return o.textContent = n, i.appendChild(a), i.appendChild(o), i;
	}
	let p = document.createElement("div");
	p.style.cssText = u, i.appendChild(p);
	let m = document.createElement("div");
	m.style.cssText = l, m.textContent = H.labels?.gameType || "Game type", i.appendChild(m);
	let h = Da(), g = [
		{
			value: "none",
			label: H.labels?.none || "None"
		},
		{
			value: "TN",
			label: h.TN
		},
		{
			value: "2C",
			label: h["2C"]
		},
		{
			value: "3C",
			label: h["3C"]
		},
		{
			value: "4C",
			label: h["4C"]
		}
	];
	for (let e of g) i.appendChild(f("gameType", e.value, e.label, a === e.value));
	let _ = document.createElement("div");
	_.style.cssText = u, i.appendChild(_);
	let v = document.createElement("div");
	v.style.cssText = l, v.textContent = H.labels?.deuceRule || "Deuce rule", i.appendChild(v);
	let y = Oa(), b = [
		{
			value: "none",
			label: H.labels?.none || "None"
		},
		{
			value: "1D",
			label: y["1D"]
		},
		{
			value: "3D",
			label: y["3D"]
		}
	];
	for (let e of b) i.appendChild(f("deuceRule", e.value, e.label, o === e.value));
	r.appendChild(i);
	let x = e.target.getBoundingClientRect();
	r.style.left = `${x.left}px`, r.style.top = `${x.bottom}px`, document.body.appendChild(r), Ha = r, setTimeout(() => {
		Ua = (e) => {
			r.contains(e.target) || Wa();
		}, document.addEventListener("click", Ua);
	}, 100);
}
function Ka(e, t) {
	Wa();
	let n = document.createElement("div");
	n.className = "dropdown is-active", n.style.position = "absolute", n.style.zIndex = "10000";
	let r = document.createElement("div");
	r.className = "dropdown-menu", r.style.backgroundColor = ma, r.style.border = "1px solid var(--chc-border-secondary)", r.style.borderRadius = "4px", r.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
	let i = () => {
		Wa();
	};
	t.forEach((e) => {
		let t = document.createElement("div");
		t.style.padding = "0.5em 1em", t.style.cursor = "pointer", t.style.backgroundColor = ma, t.style.color = pa, t.style.fontSize = "1rem", t.style.lineHeight = "1.5", t.textContent = e.text, t.onclick = (t) => {
			t.preventDefault(), t.stopPropagation(), i(), e.onClick();
		}, t.onmouseenter = () => {
			t.style.backgroundColor = ha, t.style.color = pa;
		}, t.onmouseleave = () => {
			t.style.backgroundColor = ma, t.style.color = pa;
		}, r.appendChild(t);
	}), n.appendChild(r);
	let a = e.target.getBoundingClientRect();
	n.style.left = `${a.left}px`, n.style.top = `${a.bottom}px`, document.body.appendChild(n), Ha = n, setTimeout(() => {
		Ua = (e) => {
			n.contains(e.target) || i();
		}, document.addEventListener("click", Ua);
	}, 100);
}
//#endregion
//#region src/components/categories/ageCategory/ageCategoryLogic.ts
var qa = "Simple Under", Ja = "Simple Over";
function Ya(e) {
	if (!e) return null;
	let t = e.trim().toUpperCase();
	if (t === "OPEN") return { type: "open" };
	let n = t.match(/^C(\d{1,2})-(\d{1,2})$/);
	if (n) {
		let [, e, t] = n;
		return {
			type: "combined",
			ageMin: Number.parseInt(e, 10),
			ageMax: Number.parseInt(t, 10),
			isCombined: !0
		};
	}
	if (t.includes("-")) {
		let e = Qa(t);
		if (e) return e;
	}
	return $a(t);
}
function Xa(e) {
	if (!e.startsWith("U") && !e.endsWith("U")) return;
	let t = e.match(/^U?(\d{1,2})U?$/);
	if (t) return {
		age: Number.parseInt(t[1], 10),
		position: e.startsWith("U") ? "pre" : "post"
	};
}
function Za(e) {
	if (!e.startsWith("O") && !e.endsWith("O")) return;
	let t = e.match(/^O?(\d{1,2})O?$/);
	if (t) return {
		age: Number.parseInt(t[1], 10),
		position: e.startsWith("O") ? "pre" : "post"
	};
}
function Qa(e) {
	let t = e.split("-");
	if (t.length !== 2) return null;
	let [n, r] = t, i, a, o, s, c, l = Xa(n), u = Za(n);
	l ? (c = "max-min", a = l.position === "pre" ? l.age - 1 : l.age, o = l.position) : u && (c = "min-max", i = u.position === "pre" ? u.age + 1 : u.age, s = u.position);
	let d = Xa(r), f = Za(r);
	return d ? (a = d.position === "pre" ? d.age - 1 : d.age, o = d.position) : f && (i = f.position === "pre" ? f.age + 1 : f.age, s = f.position), i !== void 0 || a !== void 0 ? {
		type: "range",
		ageMin: i,
		ageMax: a,
		uPosition: o,
		oPosition: s,
		rangeOrder: c
	} : null;
}
function $a(e) {
	let t = e.match(/^U(\d{1,2})$|^(\d{1,2})U$/);
	if (t) return {
		type: "under",
		ageValue: Number.parseInt(t[1] || t[2], 10),
		uPosition: t[1] ? "pre" : "post"
	};
	let n = e.match(/^O(\d{1,2})$|^(\d{1,2})O$/);
	return n ? {
		type: "over",
		ageValue: Number.parseInt(n[1] || n[2], 10),
		oPosition: n[1] ? "pre" : "post"
	} : null;
}
function eo(e) {
	let { type: t, ageValue: n, ageMin: r, ageMax: i, uPosition: a = "post", oPosition: o = "post", rangeOrder: s = "min-max" } = e;
	if (t === "open") return "OPEN";
	if (t === "combined" && r !== void 0 && i !== void 0) return `C${r}-${i}`;
	if (t === "under" && n !== void 0) return a === "pre" ? `U${n}` : `${n}U`;
	if (t === "over" && n !== void 0) return o === "pre" ? `O${n}` : `${n}O`;
	if (t === "range" && (r !== void 0 || i !== void 0)) {
		let e = i !== void 0 && a ? (() => {
			let e = a === "pre" ? i + 1 : i;
			return a === "pre" ? `U${e}` : `${e}U`;
		})() : null, t = r !== void 0 && o ? (() => {
			let e = o === "pre" ? r - 1 : r;
			return o === "pre" ? `O${e}` : `${e}O`;
		})() : null;
		return s === "max-min" ? [e, t].filter(Boolean).join("-") : [t, e].filter(Boolean).join("-");
	}
	return "";
}
function to() {
	return [
		8,
		10,
		12,
		14,
		16,
		18,
		21,
		30,
		35,
		40,
		45,
		50,
		55,
		60,
		65,
		70,
		75,
		80,
		85,
		90
	];
}
function no() {
	return [
		qa,
		Ja,
		"Range",
		"Combined",
		"Open"
	];
}
function ro(e) {
	switch (e) {
		case qa: return "under";
		case Ja: return "over";
		case "Range": return "range";
		case "Combined": return "combined";
		case "Open": return "open";
		default: return "open";
	}
}
function io(e) {
	switch (e) {
		case "under": return qa;
		case "over": return Ja;
		case "range": return "Range";
		case "combined": return "Combined";
		case "open": return "Open";
		default: return "Open";
	}
}
function ao() {
	return [
		{
			code: "OPEN",
			text: "Open (No age limit)"
		},
		{
			code: "8U",
			text: "8 and Under"
		},
		{
			code: "10U",
			text: "10 and Under"
		},
		{
			code: "12U",
			text: "12 and Under"
		},
		{
			code: "14U",
			text: "14 and Under"
		},
		{
			code: "16U",
			text: "16 and Under"
		},
		{
			code: "18U",
			text: "18 and Under"
		},
		{
			code: "21U",
			text: "21 and Under"
		},
		{
			code: "30O",
			text: "30 and Over"
		},
		{
			code: "35O",
			text: "35 and Over"
		},
		{
			code: "40O",
			text: "40 and Over"
		},
		{
			code: "45O",
			text: "45 and Over"
		},
		{
			code: "50O",
			text: "50 and Over"
		},
		{
			code: "55O",
			text: "55 and Over"
		},
		{
			code: "60O",
			text: "60 and Over"
		},
		{
			code: "65O",
			text: "65 and Over"
		},
		{
			code: "70O",
			text: "70 and Over"
		},
		{
			code: "75O",
			text: "75 and Over"
		},
		{
			code: "80O",
			text: "80 and Over"
		}
	];
}
//#endregion
//#region src/components/categories/ageCategory/ageCategory.ts
var oo = "▾", so = "1px solid var(--chc-border-secondary)", co = "var(--chc-text-primary)", lo = "var(--chc-dropdown-bg)";
function uo(e) {
	return typeof e == "function";
}
var fo = {
	labels: {
		title: "Age Category",
		consideredDateLabel: "Considered Date",
		typeLabel: "Category Type",
		ageLabel: "Age",
		standardCodesLabel: "Standard Categories"
	},
	options: {
		ages: to(),
		categoryTypes: no()
	},
	defaultConsideredDate: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
}, po = fo, mo, ho, q = { type: "open" }, go = {};
function _o() {
	let e = eo(q);
	if (!e || e === "OPEN") {
		go = {};
		return;
	}
	try {
		let t = i.getCategoryAgeDetails({
			category: { ageCategoryCode: e },
			consideredDate: ho
		});
		if (t.error) {
			go = { errors: [typeof t.error == "string" ? t.error : t.error.message || "Invalid category or date"] };
			return;
		}
		go = {
			ageMin: t.ageMin,
			ageMax: t.ageMax,
			ageMinDate: t.ageMinDate,
			ageMaxDate: t.ageMaxDate,
			errors: t.errors
		};
	} catch (e) {
		go = { errors: [`Failed to calculate age details: ${e instanceof Error ? e.message : "Unknown error"}`] };
	}
}
function vo() {
	let e = eo(q);
	mo = e;
	let t = document.getElementById("ageCategoryCodeString");
	t && (t.innerHTML = e || "Invalid"), _o(), yo();
}
function yo() {
	let e = document.getElementById("calculatedDetailsPanel");
	if (!e) return;
	if (q.type === "open" || !mo) {
		e.style.display = "none";
		return;
	}
	e.style.display = "";
	let { ageMin: t, ageMax: n, ageMinDate: r, ageMaxDate: i, errors: a } = go, o = "<div style=\"margin-top: 1em; padding: 0.75em; background: var(--chc-bg-secondary); border-radius: 4px; color: var(--chc-text-primary);\">";
	a && a.length > 0 && (o += "<div style=\"color: var(--chc-status-error); margin-bottom: 0.5em;\"><strong style=\"color: var(--chc-text-primary);\">Errors:</strong><ul style=\"margin: 0; padding-left: 1.5em; color: var(--chc-text-primary);\">", a.forEach((e) => {
		o += `<li style="color: var(--chc-status-error);">${e}</li>`;
	}), o += "</ul></div>"), (t !== void 0 || n !== void 0) && (o += "<div style=\"margin-bottom: 0.5em; color: var(--chc-text-primary);\"><strong style=\"color: var(--chc-text-primary);\">Age Range:</strong> ", t !== void 0 && n !== void 0 ? o += `${t} - ${n}` : t === void 0 ? n !== void 0 && (o += `${n} and under`) : o += `${t} and over`, o += "</div>"), r && (o += `<div style="margin-bottom: 0.5em; color: var(--chc-text-primary);"><strong style="color: var(--chc-text-primary);">Min Birth Date:</strong> ${r}</div>`), i && (o += `<div style="margin-bottom: 0.5em; color: var(--chc-text-primary);"><strong style="color: var(--chc-text-primary);">Max Birth Date:</strong> ${i}</div>`), o += "</div>", e.innerHTML = o;
}
function bo() {
	let { type: e } = q, t = document.getElementById("ageValue"), n = e === "under" || e === "over";
	t && (t.style.display = n ? "" : "none");
	let r = document.getElementById("positionToggle"), i = e === "under" || e === "over";
	r && (r.style.display = i ? "" : "none");
	let a = document.getElementById("ageMin"), o = e === "range" || e === "combined";
	a && (a.style.display = o ? "" : "none");
	let s = document.getElementById("ageMax"), c = e === "range" || e === "combined";
	s && (s.style.display = c ? "" : "none");
	let l = document.getElementById("combinedLabel");
	l && (l.style.display = e === "combined" ? "" : "none");
}
function xo(e) {
	let { id: t, label: n, onClick: r, initiallyHidden: i } = e, a = document.createElement("button");
	return a.className = "accButton", a.id = t, a.innerHTML = n, r && (a.onclick = r), i && (a.style.display = "none"), a.style.transition = "all .2s ease-in-out", a.style.backgroundColor = "inherit", a.style.border = "none", a.style.color = co, a.style.padding = ".3em", a.style.textAlign = "center", a.style.textDecoration = "none", a.style.fontSize = "1em", a.style.cursor = "pointer", a;
}
var So = null, Co = null;
function wo() {
	So && document.body.contains(So) && So.remove(), Co &&= (document.removeEventListener("click", Co), null), So = null;
}
function To(e, t) {
	wo();
	let n = document.createElement("div");
	n.className = "dropdown is-active", n.style.position = "absolute", n.style.zIndex = "10000";
	let r = document.createElement("div");
	r.className = "dropdown-menu", r.style.backgroundColor = lo, r.style.border = so, r.style.borderRadius = "4px", r.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
	let i = () => {
		wo();
	};
	t.forEach((e) => {
		let t = document.createElement("div");
		t.style.padding = "0.5em 1em", t.style.cursor = "pointer", t.style.backgroundColor = lo, t.style.color = co, t.style.fontSize = "1rem", t.style.lineHeight = "1.5", t.textContent = e.text, t.onclick = (t) => {
			t.preventDefault(), t.stopPropagation(), i(), setTimeout(() => {
				e.onClick();
			}, 0);
		}, t.onmouseenter = () => {
			t.style.backgroundColor = "var(--chc-hover-bg)";
		}, t.onmouseleave = () => {
			t.style.backgroundColor = lo;
		}, r.appendChild(t);
	}), n.appendChild(r);
	let a = e.target.getBoundingClientRect();
	n.style.left = `${a.left}px`, n.style.top = `${a.bottom}px`, document.body.appendChild(n), So = n, setTimeout(() => {
		Co = (e) => {
			n.contains(e.target) || i();
		}, document.addEventListener("click", Co);
	}, 100);
}
function Eo({ existingAgeCategoryCode: e, existingCategory: t = {}, editorConfig: n, consideredDate: r, callback: i, config: a, modalConfig: o } = {}) {
	let s = n || a;
	po = s ? {
		labels: {
			...fo.labels,
			...s.labels
		},
		options: {
			...fo.options,
			...s.options
		},
		preDefinedCodes: s.preDefinedCodes || ao(),
		defaultConsideredDate: s.defaultConsideredDate || fo.defaultConsideredDate
	} : {
		...fo,
		preDefinedCodes: ao()
	}, ho = r || po.defaultConsideredDate || (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
	let c = e || t.ageCategoryCode || "OPEN";
	mo = c;
	let l = Ya(c);
	l ? Object.assign(q, l) : Object.assign(q, { type: "open" });
	let u = () => {
		let e = eo(q);
		uo(i) && i({
			...t,
			ageCategoryCode: e
		});
	}, d = [{
		onClick: () => {
			wo(), i?.({
				...t,
				ageCategoryCode: ""
			});
		},
		label: "Cancel",
		intent: "none",
		footer: {
			className: "button",
			style: "background-color: var(--chc-bg-primary); color: var(--chc-text-primary); border: 1px solid var(--chc-border-primary);"
		},
		close: !0
	}, {
		label: "Select",
		intent: "is-info",
		close: !0,
		onClick: () => {
			wo(), u();
		}
	}], f = document.createElement("div");
	f.addEventListener("click", (e) => {
		let t = e.target;
		!t.closest(".dropdown") && !t.classList.contains("accButton") && wo();
	});
	let p = document.createElement("div");
	p.id = "ageCategoryCodeString", p.innerHTML = mo, p.style.fontSize = "1.5em", p.style.color = "var(--chc-format-code-color)", p.style.marginBottom = "1em", p.style.fontWeight = "bold", f.appendChild(p);
	let m = document.createElement("div");
	m.style.marginBottom = "1em", Ei(m, [{
		label: po.labels?.standardCodesLabel || "Standard Categories",
		field: "standardCategory",
		id: "ageCategorySelector",
		options: [{
			label: "Custom",
			value: "Custom",
			selected: !po.preDefinedCodes?.some((e) => e.code === mo)
		}, ...(po.preDefinedCodes || []).map((e) => ({
			selected: e.code === mo,
			value: e.code,
			label: e.text
		}))],
		onChange: (e) => {
			let t = e.target.value;
			if (t === "Custom") return;
			mo = t;
			let n = Ya(t);
			n && (Object.assign(q, n), bo(), k(), vo());
		}
	}, {
		label: po.labels?.consideredDateLabel || "Considered Date",
		field: "consideredDate",
		id: "consideredDateInput",
		value: ho,
		date: !0,
		onChange: (e) => {
			ho = e.target.value, vo();
		}
	}]), f.appendChild(m);
	let h = xo({
		id: "categoryType",
		label: `${io(q.type)}${oo}`,
		onClick: (e) => {
			To(e, (po.options?.categoryTypes || no()).map((e) => ({
				text: e,
				onClick: () => {
					let t = ro(e);
					q.type = t, q.ageValue = void 0, q.ageMin = void 0, q.ageMax = void 0, t === "under" || t === "over" ? (q.ageValue = 18, q.uPosition = "post", q.oPosition = "post") : (t === "range" || t === "combined") && (q.ageMin = 10, q.ageMax = 18, q.uPosition = "post", q.oPosition = "post", q.rangeOrder = "min-max"), t === "combined" ? q.isCombined = !0 : q.isCombined = !1, h.innerHTML = `${e}${oo}`, bo(), k(), vo();
				}
			})));
		}
	}), g = document.createElement("div");
	g.style.display = "flex", g.style.flexWrap = "wrap", g.style.gap = "0.5em", g.style.marginBottom = "1em", g.appendChild(h);
	let _ = document.createElement("div");
	_.id = "ageValue", _.style.display = q.type !== "under" && q.type !== "over" ? "none" : "";
	let v = document.createElement("input");
	v.type = "number", v.min = "1", v.max = "120", v.value = String(q.ageValue || 18), v.style.width = "80px", v.style.padding = "0.3em", v.style.border = so, v.style.borderRadius = "4px", v.oninput = () => {
		let e = Number.parseInt(v.value, 10);
		!Number.isNaN(e) && e >= 1 && e <= 120 && (q.ageValue = e, vo());
	}, _.appendChild(v), g.appendChild(_);
	let y = xo({
		id: "positionToggle",
		label: O(),
		onClick: () => {
			q.type === "under" ? q.uPosition = q.uPosition === "pre" ? "post" : "pre" : q.type === "over" && (q.oPosition = q.oPosition === "pre" ? "post" : "pre"), y.innerHTML = O(), vo();
		},
		initiallyHidden: q.type !== "under" && q.type !== "over"
	});
	g.appendChild(y);
	let b = document.createElement("div");
	b.id = "ageMin", b.style.display = q.type !== "range" && q.type !== "combined" ? "none" : "", b.style.display = "flex", b.style.alignItems = "center", b.style.gap = "0.5em";
	let x = document.createElement("span");
	x.textContent = "Min:", x.style.color = co;
	let S = document.createElement("input");
	S.type = "number", S.min = "1", S.max = "120", S.value = String(q.ageMin || 10), S.style.width = "80px", S.style.padding = "0.3em", S.style.border = so, S.style.borderRadius = "4px", S.oninput = () => {
		let e = Number.parseInt(S.value, 10);
		!Number.isNaN(e) && e >= 1 && e <= 120 && (q.ageMin = e, q.ageMax !== void 0 && q.ageMax < e && (q.ageMax = e, T.value = String(e)), vo());
	}, b.appendChild(x), b.appendChild(S), g.appendChild(b), q.type !== "range" && q.type !== "combined" && (b.style.display = "none");
	let C = document.createElement("div");
	C.id = "ageMax", C.style.display = q.type !== "range" && q.type !== "combined" ? "none" : "", C.style.display = "flex", C.style.alignItems = "center", C.style.gap = "0.5em";
	let w = document.createElement("span");
	w.textContent = "Max:", w.style.color = co;
	let T = document.createElement("input");
	T.type = "number", T.min = "1", T.max = "120", T.value = String(q.ageMax || 18), T.style.width = "80px", T.style.padding = "0.3em", T.style.border = so, T.style.borderRadius = "4px", T.oninput = () => {
		let e = Number.parseInt(T.value, 10);
		!Number.isNaN(e) && e >= 1 && e <= 120 && (q.ageMax = e, q.ageMin !== void 0 && q.ageMin > e && (q.ageMin = e, S.value = String(e)), vo());
	}, C.appendChild(w), C.appendChild(T), g.appendChild(C), q.type !== "range" && q.type !== "combined" && (C.style.display = "none");
	let E = document.createElement("div");
	E.id = "combinedLabel", E.innerHTML = "<em style=\"color: var(--chc-text-muted);\">Combined age range</em>", E.style.display = q.type === "combined" ? "" : "none", E.style.padding = "0.3em", g.appendChild(E), f.appendChild(g);
	let D = document.createElement("div");
	D.id = "calculatedDetailsPanel", f.appendChild(D);
	function O() {
		if (q.type === "under") {
			let e = q.ageValue || 18;
			return q.uPosition === "pre" ? `U${e}` : `${e}U`;
		} else if (q.type === "over") {
			let e = q.ageValue || 10;
			return q.oPosition === "pre" ? `O${e}` : `${e}O`;
		}
		return "";
	}
	function k() {
		let e = document.getElementById("categoryType");
		e && (e.innerHTML = `${io(q.type)}${oo}`), q.ageValue !== void 0 && (v.value = String(q.ageValue));
		let t = document.getElementById("positionToggle");
		t && (t.innerHTML = O()), q.ageMin !== void 0 && (S.value = String(q.ageMin)), q.ageMax !== void 0 && (T.value = String(q.ageMax));
	}
	let A = {
		content: { padding: "1.5" },
		maxWidth: 480,
		fontSize: "14px",
		style: {
			backgroundColor: "var(--chc-bg-secondary)",
			borderRadius: "8px",
			boxShadow: "0 8px 16px rgba(0, 102, 204, 0.2)"
		}
	}, j = o?.fontSize || o?.style?.fontSize || A.fontSize, M = {
		...A,
		...o,
		fontSize: j,
		style: {
			...A.style,
			...a?.style || {},
			...o?.style
		}
	}, N = R.open({
		title: po.labels?.title || "Age Category",
		content: f,
		buttons: d,
		config: M
	});
	return setTimeout(() => {
		bo(), k(), vo();
	}, 0), setTimeout(() => {
		let e = document.querySelector(".modal.is-active");
		if (e) {
			let t = new MutationObserver((n) => {
				n.forEach((n) => {
					n.removedNodes.forEach((n) => {
						n === e && (wo(), t.disconnect());
					});
				});
			});
			t.observe(document.body, { childList: !0 });
		}
	}, 0), N;
}
//#endregion
//#region src/components/categories/category/category.ts
var Do = {
	labels: {
		title: "Category",
		categoryNameLabel: "Category Name",
		typeLabel: "Category Type",
		ageCategoryCodeLabel: "Age Category Code",
		ratingTypeLabel: "Rating Type",
		ratingMinLabel: "Minimum Rating",
		ratingMaxLabel: "Maximum Rating",
		ballTypeLabel: "Ball Type",
		notesLabel: "Notes"
	},
	options: {
		types: [
			"AGE",
			"RATING",
			"BOTH"
		],
		ratingTypes: [
			"WTN",
			"UTR",
			"TRN",
			"NTRP",
			"DUPR"
		],
		ballTypes: [
			"HIGH_ALTITUDE",
			"STAGE1GREEN",
			"STAGE2ORANGE",
			"STAGE3RED",
			"T2STANDARD_PRESSURELESS",
			"T2STANDARD_PRESSURISED",
			"TYPE1FAST",
			"TYPE3SLOW"
		]
	},
	defaultConsideredDate: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
};
function Oo(e) {
	return typeof e == "function";
}
function ko(e) {
	let { existingCategory: t, editorConfig: n, callback: r } = e, a = {
		labels: {
			...Do.labels,
			...n?.labels
		},
		options: {
			...Do.options,
			...n?.options
		},
		defaultConsideredDate: n?.defaultConsideredDate || Do.defaultConsideredDate,
		modalConfig: n?.modalConfig || {}
	}, o = {
		categoryName: t?.categoryName || "",
		type: t?.type,
		ageCategoryCode: t?.ageCategoryCode,
		ratingType: t?.ratingType,
		ratingMin: t?.ratingMin,
		ratingMax: t?.ratingMax,
		ballType: t?.ballType,
		notes: t?.notes || "",
		ageMin: t?.ageMin,
		ageMax: t?.ageMax,
		ageMinDate: t?.ageMinDate,
		ageMaxDate: t?.ageMaxDate
	}, s = a.defaultConsideredDate, c = document.createElement("div");
	c.style.display = "flex", c.style.flexDirection = "column", c.style.gap = "1em", c.style.minWidth = "400px";
	let l = () => {
		let e = c.querySelector("#ageDetailsPanel");
		if (e) {
			if (!o.ageCategoryCode || o.ageCategoryCode === "OPEN") {
				e.style.display = "none";
				return;
			}
			try {
				let t = i.getCategoryAgeDetails({
					category: { ageCategoryCode: o.ageCategoryCode },
					consideredDate: s
				});
				if (t.error) {
					e.style.display = "block", e.innerHTML = `
          <div style="padding: 0.75em; background-color: var(--chc-bg-secondary); border-left: 4px solid var(--chc-status-error); border-radius: 4px; color: var(--chc-text-primary);">
            <strong style="color: var(--chc-text-primary);">Error:</strong> ${typeof t.error == "string" ? t.error : t.error.message || "Invalid category"}
          </div>
        `;
					return;
				}
				o.ageMin = t.ageMin, o.ageMax = t.ageMax, o.ageMinDate = t.ageMinDate, o.ageMaxDate = t.ageMaxDate, e.style.display = "block", e.innerHTML = `
        <div style="padding: 0.75em; background-color: var(--chc-bg-secondary); border-left: 4px solid var(--chc-status-success); border-radius: 4px; color: var(--chc-text-primary);">
          <strong style="color: var(--chc-text-primary);">Age Range:</strong> ${t.ageMin || "N/A"} - ${t.ageMax || "N/A"}<br>
          <strong style="color: var(--chc-text-primary);">Min Birth Date:</strong> ${t.ageMinDate || "N/A"}<br>
          <strong style="color: var(--chc-text-primary);">Max Birth Date:</strong> ${t.ageMaxDate || "N/A"}
        </div>
      `;
			} catch (t) {
				e.style.display = "block", e.innerHTML = `
        <div style="padding: 0.75em; background-color: var(--chc-bg-secondary); border-left: 4px solid var(--chc-status-error); border-radius: 4px; color: var(--chc-text-primary);">
          <strong style="color: var(--chc-text-primary);">Error:</strong> ${t?.message || "Failed to calculate age details"}
        </div>
      `;
			}
		}
	}, u = document.createElement("div"), d = (e) => {
		if ((e.categoryName?.value || "").trim().length < 5) return !1;
		let t = e.type?.value;
		if (!t) return !1;
		let n = t === "AGE" || t === "BOTH", r = t === "RATING" || t === "BOTH";
		return n && !r ? !!o.ageCategoryCode : !n && r ? !!o.ratingType : n && r ? !!(o.ageCategoryCode || o.ratingType) : !1;
	}, f = (e) => {
		let t = document.getElementById("categoryOkButton");
		t && (t.disabled = !d(e));
	}, p = Ei(u, [
		{
			label: a.labels?.categoryNameLabel || "Category Name",
			validator: ((e, t) => (n) => n?.trim().length >= e && (!t || n?.trim().length <= t))(5),
			error: "Minimum 5 characters",
			field: "categoryName",
			placeholder: "e.g., Boys U18, Open Singles, 3.5-4.0",
			value: o.categoryName,
			focus: !0,
			onChange: (e) => {
				o.categoryName = e.target.value;
			}
		},
		{
			label: a.labels?.typeLabel || "Category Type",
			field: "type",
			options: [{
				label: "Select type...",
				value: "",
				selected: !o.type
			}, ...(a.options?.types || []).map((e) => ({
				label: e,
				value: e,
				selected: e === o.type
			}))],
			onChange: (e) => {
				o.type = e.target.value, S();
			}
		},
		{
			label: a.labels?.ballTypeLabel || "Ball Type",
			field: "ballType",
			options: [{
				label: "None",
				value: "",
				selected: !o.ballType
			}, ...(a.options?.ballTypes || []).map((e) => ({
				label: e,
				value: e,
				selected: e === o.ballType
			}))],
			onChange: (e) => {
				o.ballType = e.target.value || void 0;
			}
		},
		{
			label: a.labels?.notesLabel || "Notes",
			field: "notes",
			placeholder: "Additional information...",
			value: o.notes,
			onChange: (e) => {
				o.notes = e.target.value;
			}
		}
	], [
		{
			control: "categoryName",
			onInput: ({ inputs: e }) => {
				f(e);
			}
		},
		{
			control: "type",
			onInput: ({ inputs: e }) => {
				f(e);
			}
		},
		{
			control: "ballType",
			onInput: ({ inputs: e }) => {
				f(e);
			}
		},
		{
			control: "notes",
			onInput: ({ inputs: e }) => {
				f(e);
			}
		}
	]);
	c.appendChild(u);
	let m = document.createElement("div");
	m.id = "ageCategorySection", m.style.display = o.type === "AGE" || o.type === "BOTH" ? "block" : "none";
	let h = document.createElement("label");
	h.textContent = a.labels?.ageCategoryCodeLabel || "Age Category Code", h.style.display = "block", h.style.marginBottom = "0.5em", h.style.fontWeight = "bold", h.style.fontSize = "0.9em", h.style.color = "var(--chc-text-primary)", m.appendChild(h);
	let g = document.createElement("div");
	g.style.display = "flex", g.style.alignItems = "center", g.style.gap = "0.5em";
	let _ = document.createElement("div");
	_.id = "ageCategoryValue", _.style.padding = "0.5em", _.style.border = "1px solid var(--chc-input-border)", _.style.borderRadius = "4px", _.style.backgroundColor = "var(--chc-bg-secondary)", _.style.flex = "1", _.style.minHeight = "2.5em", _.style.display = "flex", _.style.alignItems = "center", _.style.color = "var(--chc-text-primary)", _.textContent = o.ageCategoryCode || "Not set", g.appendChild(_);
	let v = document.createElement("button");
	v.className = "button is-info is-small", v.textContent = o.ageCategoryCode ? "Edit" : "Set", v.onclick = () => {
		Eo({
			existingAgeCategoryCode: o.ageCategoryCode,
			editorConfig: { defaultConsideredDate: s },
			callback: (e) => {
				o.ageCategoryCode = e.ageCategoryCode, _.textContent = e.ageCategoryCode || "Not set", v.textContent = e.ageCategoryCode ? "Edit" : "Set", l(), f(p);
			}
		});
	}, g.appendChild(v), m.appendChild(g);
	let y = document.createElement("div");
	y.id = "ageDetailsPanel", y.style.marginTop = "0.5em", y.style.display = "none", m.appendChild(y), c.appendChild(m);
	let b = document.createElement("div");
	b.id = "ratingSection", b.style.display = o.type === "RATING" || o.type === "BOTH" ? "block" : "none";
	let x = document.createElement("div");
	Ei(x, [{
		label: a.labels?.ratingTypeLabel || "Rating Type",
		field: "ratingType",
		options: [{
			label: "Select rating type...",
			value: "",
			selected: !o.ratingType
		}, ...(a.options?.ratingTypes || []).map((e) => ({
			label: e,
			value: e,
			selected: e === o.ratingType
		}))],
		onChange: (e) => {
			o.ratingType = e.target.value || void 0;
		}
	}, {
		label: a.labels?.ratingMinLabel || "Minimum Rating",
		field: "ratingMin",
		type: "number",
		placeholder: "Min",
		value: o.ratingMin?.toString() || "",
		onChange: (e) => {
			let t = e.target.value;
			o.ratingMin = t ? Number.parseFloat(t) : void 0;
		},
		fieldPair: {
			label: a.labels?.ratingMaxLabel || "Maximum Rating",
			field: "ratingMax",
			type: "number",
			placeholder: "Max",
			value: o.ratingMax?.toString() || "",
			onChange: (e) => {
				let t = e.target.value;
				o.ratingMax = t ? Number.parseFloat(t) : void 0;
			}
		}
	}], [
		{
			control: "ratingType",
			onInput: () => {
				f(p);
			}
		},
		{
			control: "ratingMin",
			onInput: () => {
				f(p);
			}
		},
		{
			control: "ratingMax",
			onInput: () => {
				f(p);
			}
		}
	]), b.appendChild(x), c.appendChild(b);
	let S = () => {
		let e = o.type === "AGE" || o.type === "BOTH", t = o.type === "RATING" || o.type === "BOTH";
		m.style.display = e ? "block" : "none", b.style.display = t ? "block" : "none", e && l();
	};
	setTimeout(() => {
		S(), l();
	}, 0);
	let C = [{
		label: "Cancel",
		close: !0
	}, {
		label: "OK",
		id: "categoryOkButton",
		intent: "is-success",
		close: !0,
		disabled: !0,
		onClick: () => {
			Oo(r) && r(o);
		}
	}], w = { ...a.modalConfig }, T = R.open({
		title: a.labels?.title || "Category",
		content: c,
		buttons: C,
		config: w
	});
	return setTimeout(() => {
		f(p);
	}, 0), T;
}
//#endregion
//#region src/components/validators/numericValidator.ts
function Ao(e) {
	if (e === "" || e == null) return !1;
	let t = Number(e);
	return !isNaN(t) && Number.isInteger(t) && t >= 0;
}
//#endregion
//#region src/components/validators/numericRange.ts
var jo = (e, t) => (n) => Ao(n) && Number(n) >= e && Number(n) <= t, { WTN: Mo, UTR: No, TRN: Po, NTRP: Fo, DUPR: Io } = a.ratingConstants, { RATING: Lo } = a.scaleConstants, Ro = [
	"Blue",
	"Red",
	"Green",
	"Orange",
	"Purple",
	"Yellow",
	"Pink",
	"Gold",
	"Silver",
	"Bronze"
], zo = [
	Mo,
	No,
	Po,
	Fo,
	Io
], Bo = [
	{
		value: "WATERFALL",
		label: "Waterfall",
		description: "Distributes evenly: 1→2→3→1→2→3 (like dealing cards)"
	},
	{
		value: "LEVEL_BASED",
		label: "Level Based",
		description: "Groups by skill tiers: [1-5], [6-10], [11-15]"
	},
	{
		value: "SHUTTLE",
		label: "Shuttle",
		description: "Alternating direction: 1→2→3→3→2→1→1→2→3 (like a loom shuttle)"
	}
];
function Vo(e) {
	let { flightsCount: t, namingType: n, customName: r, suffixType: i } = e, a = [];
	for (let e = 0; e < t; e++) if (n === "colors") a.push(Ro[e] || `Flight ${e + 1}`);
	else {
		let t = i === "letters" ? String.fromCodePoint(65 + e) : (e + 1).toString();
		a.push(`${r || "Flight"} ${t}`);
	}
	return a;
}
function Ho(e) {
	let t = { scaleType: e.scaleType };
	return e.eventType && (t.eventType = e.eventType), e.scaleType === Lo && e.scaleName && (t.scaleName = e.scaleName, o.ratingsParameters[e.scaleName] ? (t.ascending = o.ratingsParameters[e.scaleName].ascending, t.accessor = o.ratingsParameters[e.scaleName].accessor) : (delete t.ascending, delete t.accessor)), t;
}
function Uo(e) {
	return {
		WATERFALL: "splitWaterfall",
		LEVEL_BASED: "splitLevelBased",
		SHUTTLE: "splitShuttle"
	}[e] || "splitLevelBased";
}
function Wo(e) {
	let t = [];
	return !e.flightsCount || Number.isNaN(e.flightsCount) || e.flightsCount <= 0 ? t.push("Number of flights must be a valid number greater than 0") : e.flightsCount < 2 ? t.push("Must have at least 2 flights") : e.flightsCount > 10 && t.push("Maximum 10 flights allowed"), e.scaleType === Lo && !e.scaleName && t.push("Rating system must be selected"), t;
}
//#endregion
//#region src/components/flightProfile/getFlightProfileFormItems.ts
var { RATING: Go, RANKING: Ko } = a.scaleConstants, qo = "flightsCount", Jo = "namingType", Yo = "customName", Xo = "suffixType", Zo = "scaleType", Qo = "scaleName", $o = "splitMethod";
function es({ existingProfile: e, editorConfig: t = {} } = {}) {
	let n = !!e, r = {
		flightsCount: 2,
		namingType: "colors",
		customName: "Flight",
		suffixType: "numbers",
		scaleType: Go,
		scaleName: "WTN",
		splitMethod: "LEVEL_BASED"
	};
	if (n && e) {
		let { flights: t, scaleAttributes: n, splitMethod: i } = e;
		if (t && t.length > 0) {
			r.flightsCount = t.length;
			let e = t[0].drawName;
			if (Ro.includes(e)) r.namingType = "colors";
			else {
				let t = e.match(/^(.+?)\s+([A-Z]|\d+)$/);
				t && (r.namingType = "custom", r.customName = t[1], r.suffixType = /[A-Z]/.test(t[2]) ? "letters" : "numbers");
			}
		}
		n && (r.scaleType = n.scaleType || Go, r.scaleName = n.scaleName), i && (r.splitMethod = {
			splitWaterfall: "WATERFALL",
			splitLevelBased: "LEVEL_BASED",
			splitShuttle: "SHUTTLE"
		}[i] || "LEVEL_BASED");
	}
	return [
		{
			error: "Must be in range 2-10",
			placeholder: "2",
			validator: jo(2, 10),
			value: r.flightsCount,
			label: t.labels?.flightsCountLabel || "Number of Flights (2-10)",
			field: qo,
			selectOnFocus: !0,
			hide: n,
			type: "number",
			focus: !0
		},
		{
			options: [{
				label: "Color Names",
				value: "colors",
				selected: r.namingType === "colors"
			}, {
				label: "Root Word",
				value: "custom",
				selected: r.namingType === "custom"
			}],
			label: t.labels?.namingTypeLabel || "Naming Strategy",
			value: r.namingType,
			field: Jo,
			hide: n
		},
		{
			placeholder: "Flight",
			label: t.labels?.customNameLabel || "Root Word",
			visible: r.namingType === "custom",
			value: r.customName,
			selectOnFocus: !0,
			field: Yo,
			hide: n,
			fieldPair: {
				options: [{
					label: "Letters (A, B, C)",
					value: "letters",
					selected: r.suffixType === "letters"
				}, {
					label: "Numbers (1, 2, 3)",
					value: "numbers",
					selected: r.suffixType === "numbers"
				}],
				label: t.labels?.suffixTypeLabel || "Suffix Style",
				visible: r.namingType === "custom",
				value: r.suffixType,
				field: Xo
			}
		},
		{
			options: [{
				label: "Rating",
				value: Go,
				selected: r.scaleType === Go
			}, {
				label: "Ranking",
				value: Ko,
				selected: r.scaleType === Ko
			}],
			label: t.labels?.scaleTypeLabel || "Flighting Strategy",
			field: Zo,
			value: r.scaleType,
			hide: n
		},
		{
			options: zo.map((e) => ({
				label: e,
				value: e,
				selected: e === r.scaleName
			})),
			label: t.labels?.scaleNameLabel || "Rating System",
			field: Qo,
			value: r.scaleName,
			visible: r.scaleType === Go,
			hide: n
		},
		{
			label: t.labels?.splitMethodLabel || "Split Method",
			field: $o,
			value: r.splitMethod,
			radio: !0,
			options: Bo.map((e) => ({
				text: e.label,
				value: e.value,
				checked: e.value === r.splitMethod
			})),
			hide: n
		}
	];
}
//#endregion
//#region src/components/flightProfile/getFlightProfileFormRelationships.ts
var { RATING: ts } = a.scaleConstants, ns = "none";
function rs() {
	let e = ({ inputs: e }) => {
		let t = document.getElementById("flightProfileOk");
		if (!t) return;
		let n = e[qo]?.value, r = jo(2, 10)(n);
		t.disabled = !r, t.style.opacity = r ? "1" : "0.5", t.style.cursor = r ? "pointer" : "not-allowed";
	};
	return [
		{
			onInput: ({ inputs: t }) => {
				e({ inputs: t });
			},
			control: qo
		},
		{
			onChange: ({ e, fields: t }) => {
				let n = e.target.value;
				if (t) {
					let e = n === "custom";
					t[Yo].style.display = e ? "" : ns, t[Xo].style.display = e ? "" : ns;
				}
			},
			control: Jo
		},
		{
			onChange: ({ e, fields: t }) => {
				let n = e.target.value;
				if (t) {
					let e = n === ts;
					t[Qo].style.display = e ? "" : ns;
				}
			},
			control: Zo
		}
	];
}
//#endregion
//#region src/components/flightProfile/flightProfileNew.ts
var { RATING: is } = a.scaleConstants;
function as(e) {
	return typeof e == "function";
}
function os(e) {
	let { existingFlightProfile: t, editorConfig: n = {}, callback: r } = e, i = !!t, a, o = (e) => {
		if (i) {
			let t = document.createElement("div");
			t.className = "notification is-info is-light", t.innerHTML = n.labels?.existingNote || "<strong style=\"color: #000;\">Note:</strong> Flight split has already been performed. You can only rename the flights.", e.appendChild(t);
		}
		let r = es({
			existingProfile: t,
			editorConfig: n
		}), o = rs(), s = document.createElement("div");
		if (e.appendChild(s), a = Ei(s, r, o), i && t?.flights) {
			let r = document.createElement("div");
			r.className = "field", r.innerHTML = `
        <label class="label">${n.labels?.flightNamesLabel || "Flight Names"}</label>
      `, t.flights.forEach((e, n) => {
				let i = document.createElement("div");
				i.className = "field", i.innerHTML = `
          <div class="control">
            <input 
              type="text" 
              class="input" 
              id="flightName_${n}"
              value="${e.drawName}"
              placeholder="Flight ${n + 1}"
            />
          </div>
        `, i.querySelector("input").addEventListener("input", (e) => {
					t.flights[n].drawName = e.target.value;
				}), r.appendChild(i);
			}), e.appendChild(r);
		}
	}, s = [{
		label: n.labels?.cancel || "Cancel",
		close: !0
	}, {
		label: n.labels?.ok || "OK",
		id: "flightProfileOk",
		intent: "is-success",
		close: !0,
		onClick: () => {
			if (i) return as(r) && r({ flights: t.flights }), !0;
			{
				let e = {
					flightsCount: Number.parseInt(a.flightsCount?.value || "0"),
					namingType: a.namingType?.value || "colors",
					customName: a.customName?.value || "Flight",
					suffixType: a.suffixType?.value || "numbers",
					scaleType: a.scaleType?.value || is,
					scaleName: a.scaleName?.value,
					splitMethod: a.splitMethod?.value || "LEVEL_BASED",
					isExisting: !1
				}, t = Wo(e);
				if (t.length > 0) return alert(t.join("\n")), !1;
				let n = Vo(e), i = Ho(e), o = Uo(e.splitMethod);
				return as(r) && r({
					flightsCount: e.flightsCount,
					drawNames: n,
					scaleAttributes: i,
					splitMethod: o
				}), !0;
			}
		}
	}], c = { modalSize: "is-medium" };
	return i || (c.info = "\n      <div style=\"color: #000;\">\n        <div style=\"margin-bottom: 1em;\">\n          <strong style=\"color: #000;\">Waterfall:</strong><br>\n          <span style=\"color: #666;\">Distributes evenly like dealing cards: 1→2→3→1→2→3</span>\n        </div>\n        <div style=\"margin-bottom: 1em;\">\n          <strong style=\"color: #000;\">Level Based:</strong><br>\n          <span style=\"color: #666;\">Groups by skill tiers: [1-5], [6-10], [11-15]</span>\n        </div>\n        <div>\n          <strong style=\"color: #000;\">Shuttle:</strong><br>\n          <span style=\"color: #666;\">Alternating direction like a loom shuttle: 1→2→3→3→2→1→1→2→3</span>\n        </div>\n      </div>\n    "), R.open({
		title: n.labels?.title || "Flight Profile",
		content: o,
		buttons: s,
		config: c
	});
}
//#endregion
//#region src/components/inline-scoring/renderInlineMatchUp.ts
var ss = "chc-inline-scoring-active";
function cs(e) {
	let { composition: t, manager: n, matchUpFormat: r, eventHandlers: i } = e, a = t?.configuration?.inlineScoring, o = e.matchUp.matchUpId, s = a?.mode || "points", c = r || e.matchUp.matchUpFormat || "SET3-S:6/TB7";
	n.getOrCreate(o, c, e.matchUp);
	let l = !1, u = e.matchUp, d = document.createElement("div");
	d.className = "chc-inline-scoring-wrapper", d.setAttribute("data-matchup-id", o), d.classList.add(ss);
	function f() {
		d.innerHTML = "";
		let r = n.getMatchUp(o, u), c = n.isComplete(o), p = {
			...t,
			configuration: {
				...t.configuration,
				inlineScoring: {
					...a,
					canUndo: n.canUndo(o),
					canRedo: n.canRedo(o),
					isComplete: c,
					isDirty: l
				}
			}
		}, m = {
			...i,
			scoreClick: ({ pointerEvent: e }) => {
				e.stopPropagation();
			},
			scoreIncrement: ({ matchUpId: e, sideNumber: t, scoreType: r }) => {
				if (n.isComplete(e) || u.matchUpStatus && !["IN_PROGRESS", "TO_BE_PLAYED"].includes(u.matchUpStatus)) return;
				let i = t - 1, a;
				r === "point" || s === "points" ? a = n.addPoint(e, i, u) : (r === "game" || s === "games") && (a = n.addGame(e, i, u)), a && (l = !0, f());
			},
			pillClick: ({ pointerEvent: e, sideNumber: t }) => {
				e.stopPropagation();
				let r = u.matchUpStatus;
				ls(e, t, r, (e) => {
					if (e === "IN_PROGRESS") u = {
						...u,
						matchUpStatus: "IN_PROGRESS",
						winningSide: void 0,
						readyToScore: !0
					};
					else {
						e === "WALKOVER" && n.reset(o, u);
						let r = [
							"RETIRED",
							"DEFAULTED",
							"WALKOVER",
							"DOUBLE_WALKOVER",
							"DOUBLE_DEFAULT"
						].includes(e) ? t === 1 ? 2 : 1 : void 0;
						u = {
							...u,
							matchUpStatus: e,
							winningSide: r,
							readyToScore: !1
						}, n.callbacks?.onEndMatch?.({
							matchUpId: o,
							matchUpStatus: e,
							sideNumber: t,
							engine: n.get(o)?.engine
						});
					}
					l = !0, f();
				});
			},
			inlineUndo: () => {
				n.undo(o, u) && (l = !0, f());
			},
			inlineRedo: () => {
				n.redo(o, u) && (l = !0, f());
			},
			inlineClear: () => {
				n.reset(o, u), u = {
					...u,
					matchUpStatus: "IN_PROGRESS",
					winningSide: void 0,
					readyToScore: !0,
					score: void 0
				}, l = !0, f();
			},
			inlineSubmit: () => {
				let e = n.get(o);
				if (e) {
					let t = n.getMatchUp(o, u);
					n.callbacks?.onSubmit?.({
						matchUpId: o,
						matchUp: t,
						engine: e.engine
					}), l = !1, f();
				}
			}
		}, h = oi({
			...e,
			composition: p,
			matchUp: r,
			eventHandlers: m
		});
		c && d.classList.remove(ss), d.appendChild(h);
	}
	return f(), d;
}
function ls(e, t, n, r) {
	document.querySelectorAll(".chc-live-chip-popover").forEach((e) => e.remove());
	let i = e.currentTarget.getBoundingClientRect(), a = document.createElement("div");
	a.className = "chc-live-chip-popover";
	let o = !!document.querySelector("[data-theme=\"dark\"]"), s = o ? "#222244" : "#fff", c = o ? "#444" : "#dee2e6", l = o ? "0 2px 12px rgba(0,0,0,0.4), 0 0 0 1px rgba(91,155,213,0.3)" : "0 2px 8px rgba(0,0,0,0.12)", u = t === 2 ? `bottom: ${document.documentElement.clientHeight - i.top + 4}px;` : `top: ${i.bottom + 4}px;`;
	a.style.cssText = `
    position: fixed;
    ${u}
    right: ${document.documentElement.clientWidth - i.right}px;
    z-index: 1000;
    display: flex;
    flex-wrap: wrap;
    max-width: 12rem;
    gap: 0.3rem;
    padding: 0.35rem;
    background: ${s};
    border: 1px solid ${c};
    border-radius: 6px;
    box-shadow: ${l};
  `;
	let d = n && ![
		"IN_PROGRESS",
		"COMPLETED",
		"TO_BE_PLAYED"
	].includes(n) ? [
		"IN_PROGRESS",
		"RETIRED",
		"DEFAULTED",
		"WALKOVER",
		"SUSPENDED",
		"CANCELLED",
		"ABANDONED"
	] : [
		"RETIRED",
		"DEFAULTED",
		"WALKOVER",
		"SUSPENDED",
		"CANCELLED",
		"ABANDONED"
	];
	for (let e of d) {
		let t = rr({ matchUpStatus: e });
		t.classList.add("chc-live-chip-popover-item"), t.onclick = (t) => {
			t.stopPropagation(), a.remove(), document.removeEventListener("click", f), r(e);
		}, a.appendChild(t);
	}
	document.body.appendChild(a);
	let f = (e) => {
		a.contains(e.target) || (a.remove(), document.removeEventListener("click", f));
	};
	setTimeout(() => document.addEventListener("click", f), 0);
}
//#endregion
//#region src/components/inline-scoring/engineToMatchUp.ts
function us(e, t) {
	let n = e.isComplete(), r = e.getInputMode();
	if (r === "none" && t.score?.sets?.length) return {
		...t,
		matchUpStatus: n ? "COMPLETED" : t.matchUpStatus || "IN_PROGRESS",
		winningSide: e.getWinner() ?? t.winningSide ?? void 0
	};
	let i = e.getScore(), a = i.pointDisplay && (r === "points" || r === "mixed"), o = (i.sets || []).map((e, t) => ({
		setNumber: t + 1,
		side1Score: e.side1Score,
		side2Score: e.side2Score,
		side1TiebreakScore: e.side1TiebreakScore,
		side2TiebreakScore: e.side2TiebreakScore,
		winningSide: e.winningSide,
		...a && !e.winningSide && !n && {
			side1PointScore: i.pointDisplay[0],
			side2PointScore: i.pointDisplay[1]
		}
	})), s = t.matchUpStatus && [
		"RETIRED",
		"DEFAULTED",
		"WALKOVER",
		"DOUBLE_WALKOVER",
		"DOUBLE_DEFAULT"
	].includes(t.matchUpStatus);
	if (!n && !s) {
		let e = o.length > 0 && o.every((e) => e.winningSide);
		(o.length === 0 || e) && o.push({
			setNumber: o.length + 1,
			side1Score: 0,
			side2Score: 0
		});
	}
	if (!n && !s && o.length > 0) {
		let e = o[o.length - 1];
		!e.winningSide && e.side1PointScore == null && e.side2PointScore == null && (e.side1PointScore = "0", e.side2PointScore = "0");
	}
	let c = e.getWinner();
	return {
		...t,
		matchUpStatus: n ? "COMPLETED" : t.matchUpStatus || "IN_PROGRESS",
		winningSide: c ?? t.winningSide ?? void 0,
		score: {
			sets: o,
			scoreStringSide1: e.getScoreboard() || void 0
		}
	};
}
//#endregion
//#region src/components/inline-scoring/inlineScoringManager.ts
var { ScoringEngine: ds } = p, fs = class {
	constructor(e) {
		this.engines = /* @__PURE__ */ new Map(), this.callbacks = e || {};
	}
	getOrCreate(e, t, n) {
		let r = this.engines.get(e);
		if (r) return r;
		let i = new ds({ matchUpFormat: t });
		if (n?.score?.sets?.length) try {
			let e = n.score.sets, t = e.filter((e) => e.winningSide), r = e.find((e) => !e.winningSide), a;
			if (r?.side1PointScore != null && r?.side2PointScore != null) {
				let e = (e) => {
					let t = String(e);
					if (t === "0") return 0;
					if (t === "15") return 1;
					if (t === "30") return 2;
					if (t === "40") return 3;
					if (t === "AD") return 4;
					let n = Number(e);
					return isNaN(n) ? 0 : n;
				};
				a = {
					side1Points: e(r.side1PointScore),
					side2Points: e(r.side2PointScore)
				};
			}
			i.setInitialScore({
				sets: t,
				...r && { currentSetScore: {
					side1Score: r.side1Score || 0,
					side2Score: r.side2Score || 0
				} },
				...a && { currentGameScore: a },
				matchUpStatus: n.matchUpStatus,
				winningSide: n.winningSide
			});
		} catch {}
		return r = {
			engine: i,
			matchUpFormat: t,
			pointCount: 0
		}, this.engines.set(e, r), r;
	}
	get(e) {
		return this.engines.get(e);
	}
	has(e) {
		return this.engines.has(e);
	}
	addPoint(e, t, n) {
		let r = this.engines.get(e);
		if (!r || r.engine.isComplete()) return;
		let i = r.pointCount % 2;
		return r.engine.addPoint({
			winner: t,
			server: i,
			result: "Winner"
		}), r.pointCount++, this.notifyAndReturn(e, n);
	}
	addGame(e, t, n) {
		let r = this.engines.get(e);
		if (!(!r || r.engine.isComplete())) return r.engine.addGame({ winner: t }), this.notifyAndReturn(e, n);
	}
	addSet(e, t, n, r) {
		let i = this.engines.get(e);
		if (!(!i || i.engine.isComplete())) return i.engine.addSet({
			side1Score: t,
			side2Score: n
		}), this.notifyAndReturn(e, r);
	}
	undo(e, t) {
		let n = this.engines.get(e);
		if (!(!n || !n.engine.canUndo())) return n.engine.undo(), n.pointCount > 0 && n.pointCount--, this.notifyAndReturn(e, t);
	}
	redo(e, t) {
		let n = this.engines.get(e);
		if (!(!n || !n.engine.canRedo())) return n.engine.redo(), n.pointCount++, this.notifyAndReturn(e, t);
	}
	reset(e, t) {
		let n = this.engines.get(e);
		if (n) return n.engine.reset(), n.pointCount = 0, this.notifyAndReturn(e, t);
	}
	getMatchUp(e, t) {
		let n = this.engines.get(e);
		return n ? us(n.engine, t) : t;
	}
	getSituation(e) {
		let t = this.engines.get(e);
		if (t) return t.engine.getScore()?.situation;
	}
	canUndo(e) {
		return this.engines.get(e)?.engine.canUndo() ?? !1;
	}
	canRedo(e) {
		return this.engines.get(e)?.engine.canRedo() ?? !1;
	}
	isComplete(e) {
		return this.engines.get(e)?.engine.isComplete() ?? !1;
	}
	remove(e) {
		this.engines.delete(e);
	}
	clear() {
		this.engines.clear();
	}
	notifyAndReturn(e, t) {
		let n = this.engines.get(e), r = us(n.engine, t);
		if (this.callbacks.onScoreChange?.({
			matchUpId: e,
			matchUp: r,
			engine: n.engine
		}), n.engine.isComplete()) {
			let t = n.engine.getWinner();
			t != null && this.callbacks.onMatchComplete?.({
				matchUpId: e,
				winningSide: t,
				engine: n.engine
			});
		}
		return r;
	}
}, ps = {
	scoringApproach: "dynamicSets",
	smartComplements: !0,
	composition: "Australian",
	idiom: "en",
	dateFormat: "YYYY-MM-DD",
	timeFormat: "HH:mm"
}, ms = { ...ps };
function hs() {
	return { ...ms };
}
function gs(e) {
	ms = {
		...ms,
		...e
	};
}
function _s() {
	ms = { ...ps };
}
function vs() {
	return {
		scoringApproach: ms.scoringApproach,
		smartComplements: ms.smartComplements,
		composition: ms.composition
	};
}
//#endregion
//#region src/components/scoring/approaches/inlineScoringApproach.ts
function ys(e) {
	let { matchUp: t, container: n, onScoreChange: r } = e;
	n.innerHTML = "", n.style.display = "flex", n.style.flexDirection = "column", n.style.gap = "0.5em";
	let i = yi[hs().composition || "Australian"] || yi.Australian, a = {
		...i,
		configuration: {
			...i.configuration,
			matchUpFooter: !0,
			inlineScoring: {
				mode: "games",
				showFooter: !0,
				showSituation: !0
			}
		}
	}, o = t.matchUpFormat || "SET3-S:6/TB7", s = {
		...t,
		matchUpStatus: "IN_PROGRESS",
		readyToScore: !0,
		winningSide: void 0
	}, c = (e, t) => {
		let n = e?.score?.sets || [];
		r({
			isValid: t || n.some((e) => e.side1Score || e.side2Score),
			sets: n,
			winningSide: e?.winningSide,
			matchUpStatus: e?.matchUpStatus,
			matchUpFormat: o,
			score: e?.score?.scoreStringSide1
		});
	}, l = new fs({
		onScoreChange: ({ matchUpId: e, matchUp: t }) => {
			c(t, l.isComplete(e));
		},
		onMatchComplete: ({ matchUpId: e }) => {
			c(l.getMatchUp(e, s), !0);
		},
		onEndMatch: ({ matchUpId: e, matchUpStatus: t }) => {
			c({
				...l.getMatchUp(e, s),
				matchUpStatus: t
			}, !0);
		}
	}), u = cs({
		matchUp: s,
		composition: a,
		manager: l,
		matchUpFormat: o,
		isLucky: !0
	});
	n.appendChild(u), globalThis.resetInlineScoring = () => {
		l.reset(t.matchUpId, s), n.innerHTML = "";
		let e = cs({
			matchUp: {
				...t,
				matchUpStatus: "IN_PROGRESS",
				readyToScore: !0,
				winningSide: void 0
			},
			composition: a,
			manager: l,
			matchUpFormat: o,
			isLucky: !0
		});
		n.appendChild(e), r({
			isValid: !1,
			sets: [],
			matchUpStatus: "TO_BE_PLAYED"
		});
	};
}
//#endregion
//#region src/components/scoring/utils/scoreValidator.ts
var { COMPLETED: bs } = u, { validateMatchUpScore: xs, validateSetScore: Ss } = c.scoreGovernor;
function Cs(e, t, n, r, i) {
	let a = n?.finalSetFormat?.tiebreakSet?.tiebreakTo && !n?.finalSetFormat?.setTo, o = n?.setFormat?.tiebreakSet?.tiebreakTo && !n?.setFormat?.setTo, s = n?.finalSetFormat?.tiebreakSet?.tiebreakTo === 1, c = n?.setFormat?.tiebreakSet?.tiebreakTo === 1;
	for (let n = 0; n < e.length; n++) {
		let l = e[n], u = n + 1, d = u === t, f = l.startsWith("[") && l.endsWith("]"), p = (l === "1-0" || l === "0-1") && (d && s || c), m = o || d && a;
		if (!m && f) return {
			isValid: !1,
			sets: r,
			scoreObject: i,
			error: `Set ${u}: Format expects regular set (e.g., 6-4), but got tiebreak-only set ${l}`
		};
		if (m && !f && !p) return {
			isValid: !1,
			sets: r,
			scoreObject: i,
			error: `Set ${u}: Format expects tiebreak-only set (e.g., [10-8]), but got regular set ${l}`
		};
	}
	return null;
}
function ws(e, t, n, r, i) {
	if (e || t === void 0) return !1;
	let a = !!i?.aggregate, o = !!i?.exactly;
	if (a) return n.filter((e) => e.side1Score !== void 0 && e.side2Score !== void 0).length >= r;
	{
		let e = Math.ceil(r / 2), t = {
			side1: 0,
			side2: 0
		};
		return n.forEach((e) => {
			e.winningSide === 1 ? t.side1++ : e.winningSide === 2 && t.side2++;
		}), !(!(t.side1 >= e || t.side2 >= e) || o && n.length < r);
	}
}
function Ts(e, t, n) {
	let { WALKOVER: r, CANCELLED: i, DEAD_RUBBER: a } = u, o = [
		r,
		i,
		a
	];
	if (!e?.trim()) return n && o.includes(n) ? {
		isValid: !0,
		sets: [],
		matchUpStatus: n,
		scoreObject: void 0
	} : {
		isValid: !1,
		sets: [],
		error: "Score is required"
	};
	try {
		let { outcome: r, error: i } = g.generateOutcomeFromScoreString({
			scoreString: e.trim(),
			matchUpFormat: t,
			preserveSideOrder: !0
		});
		if (i || !r?.score?.sets) return {
			isValid: !1,
			sets: [],
			error: i || "Invalid score format"
		};
		let a = r.score.sets, o = r.score, s = e.trim().split(/\s+/).filter((e) => e.length > 0), c = l.parse(t), u = c?.exactly || c?.bestOf || 3, d = Cs(s, u, c, a, o);
		if (d) return d;
		let f = !1, p = a.map((e, n) => {
			if (!Ss(e, t, n + 1 === u, !1).isValid) {
				f = !0;
				let { ...t } = e;
				return t;
			}
			return e;
		}), m = {
			...o,
			sets: p
		}, h = xs(p, t, n);
		if (!h.isValid) return {
			isValid: !1,
			sets: p,
			scoreObject: m,
			error: h.error
		};
		let _ = Math.ceil(u / 2), v = f ? void 0 : r.winningSide;
		return ws(f, v, p, u, c) ? {
			isValid: !0,
			sets: p,
			scoreObject: m,
			winningSide: v,
			matchUpStatus: bs,
			matchUpFormat: t,
			score: e.trim()
		} : {
			isValid: !1,
			sets: p,
			scoreObject: m,
			error: `Incomplete match - need ${_} sets to win`
		};
	} catch (e) {
		return {
			isValid: !1,
			sets: [],
			error: e instanceof Error ? e.message : "Invalid score format"
		};
	}
}
function Es(e, t, n) {
	if (!e || e.length === 0) return {
		isValid: !1,
		sets: [],
		error: "At least one set is required"
	};
	let r = e.map((e) => {
		let t = e.side1 ?? "", n = e.side2 ?? "";
		if ((!t || t === 0) && (!n || n === 0) && e.side1TiebreakScore !== void 0 && e.side2TiebreakScore !== void 0) return `[${e.side1TiebreakScore}-${e.side2TiebreakScore}]`;
		if (t === "" || n === "") return "";
		if (e.side1TiebreakScore !== void 0 || e.side2TiebreakScore !== void 0) {
			let r = e.side1TiebreakScore ?? 0, i = e.side2TiebreakScore ?? 0;
			return `${t}-${n}(${Number(t) > Number(n) ? i : r})`;
		}
		return `${t}-${n}`;
	}).filter((e) => e !== "").join(" ");
	return r ? Ts(r, t, n ? void 0 : bs) : {
		isValid: !1,
		sets: [],
		error: "At least one complete set is required"
	};
}
//#endregion
//#region src/components/scoring/utils/setExpansionLogic.ts
function Ds(e) {
	if (!e) return {
		bestOf: 3,
		setsToWin: 2,
		isTimed: !1,
		isExactlyFormat: !1
	};
	let t = l.parse(e);
	if (!t) return {
		bestOf: 3,
		setsToWin: 2,
		isTimed: !1,
		isExactlyFormat: !1
	};
	let n = !!(t.setFormat?.timed || t.finalSetFormat?.timed), r = !!t.exactly || t.bestOf === 1, i = t.exactly || t.bestOf || 3, a = Math.ceil(i / 2);
	return {
		bestOf: t.bestOf || i,
		exactly: t.exactly,
		setsToWin: a,
		isTimed: n,
		isExactlyFormat: r
	};
}
function Os(e, t) {
	if (!e || e.length === 0) return !0;
	let n = Ds(t), { bestOf: r, isExactlyFormat: i, setsToWin: a } = n, o = n.exactly || r;
	if (i) {
		if (e.length >= o) return !1;
		let r = l.parse(t), i = !!r?.aggregate, a = r?.finalSetFormat?.tiebreakSet?.tiebreakTo !== void 0;
		if (i && a && n.isTimed) {
			let t = o - 1;
			if (e.length < t) return !0;
			if (e.length === t) {
				let t = e.reduce((e, t) => (t.side1Score !== void 0 && t.side1Score !== null && (e.side1 += t.side1Score), t.side2Score !== void 0 && t.side2Score !== null && (e.side2 += t.side2Score), e), {
					side1: 0,
					side2: 0
				});
				return t.side1 === t.side2;
			} else return !1;
		}
		return !0;
	}
	let s = {
		side1: 0,
		side2: 0
	};
	return e.forEach((e) => {
		let t = e.side1Score ?? 0, n = e.side2Score ?? 0;
		t > n ? s.side1++ : n > t && s.side2++;
	}), s.side1 >= a || s.side2 >= a || e.length >= r ? !1 : e.every((e) => e.side1Score !== void 0 && e.side2Score !== void 0 && e.side1Score !== null && e.side2Score !== null);
}
//#endregion
//#region src/components/scoring/logic/dynamicSetsLogic.ts
function ks(e, t) {
	return (t.bestOf === 1 || e + 1 === t.bestOf) && t.finalSetFormat ? t.finalSetFormat : t.setFormat;
}
function As(e) {
	return e?.tiebreakSet?.tiebreakTo !== void 0;
}
function js(e) {
	return e?.timed === !0 && e?.minutes !== void 0;
}
function Ms(e, t, n, r) {
	let i = ks(e, r);
	if (js(i)) return Infinity;
	let a = i?.setTo || 6, o = i?.tiebreakAt || a, s = t === 1 ? n.side2 : n.side1, c = o === a ? a + 1 : a;
	return s === 0 ? c : s < o - 1 ? a : s === o - 1 ? o === a ? a + 1 : a : s === o ? c : s > o && s < a ? a : s === a ? o === a ? a + 2 : o : s > a ? s + 2 : c;
}
function Ns(e, t, n) {
	let r = ks(e, n);
	if (js(r)) return t.side1 !== void 0 && t.side1 !== null && t.side2 !== void 0 && t.side2 !== null;
	if (As(r)) return t.side1 > 0 && t.side2 > 0 && t.side1 !== t.side2;
	let i = r?.setTo || 6, a = r?.tiebreakAt || i, o = Math.max(t.side1, t.side2), s = Math.min(t.side1, t.side2), c = Math.abs(t.side1 - t.side2);
	return o >= i && c >= 2 || (a === i ? o === a + 1 && s === a : o === i && s === a) && t.tiebreak !== void 0;
}
function Ps(e, t, n) {
	if (Ns(e, t, n)) {
		if (t.side1 > t.side2) return 1;
		if (t.side2 > t.side1) return 2;
	}
}
function Fs(e, t, n) {
	let r = Math.ceil(t / 2), i = e.filter((e) => e.winningSide === 1).length, a = e.filter((e) => e.winningSide === 2).length;
	return i >= r || a >= r ? n ? e.filter((e) => e.side1Score !== void 0 && e.side2Score !== void 0).length >= n : !0 : !1;
}
function Is(e, t, n) {
	if (!Fs(e, t, n)) return;
	let r = Math.ceil(t / 2), i = e.filter((e) => e.winningSide === 1).length, a = e.filter((e) => e.winningSide === 2).length;
	if (i >= r) return 1;
	if (a >= r) return 2;
}
function Ls(e, t) {
	let n = t?.setTo || 6;
	if (e >= n) return null;
	let r = t?.tiebreakAt || n;
	return e < n - 1 ? n : r === n ? n + 1 : n;
}
function Rs(e, t, n, r, i, a, o) {
	if (!o) return {
		field1Value: e,
		field2Value: 0,
		shouldApply: !1,
		reason: "Feature disabled in settings"
	};
	if (a.has(n)) return {
		field1Value: e,
		field2Value: 0,
		shouldApply: !1,
		reason: "Already used for this set"
	};
	if (Fs(r, i.bestOf, i.exactly)) return {
		field1Value: e,
		field2Value: 0,
		shouldApply: !1,
		reason: "Match already complete"
	};
	let s = ks(n, i);
	if (As(s)) return {
		field1Value: e,
		field2Value: 0,
		shouldApply: !1,
		reason: "Tiebreak-only set"
	};
	if (js(s)) return {
		field1Value: e,
		field2Value: 0,
		shouldApply: !1,
		reason: "Timed set"
	};
	let c = Ls(e, s);
	return c === null ? {
		field1Value: e,
		field2Value: 0,
		shouldApply: !1,
		reason: "No predictable complement for this digit"
	} : t ? {
		field1Value: c,
		field2Value: e,
		shouldApply: !0
	} : {
		field1Value: e,
		field2Value: c,
		shouldApply: !0
	};
}
function zs(e, t, n) {
	let r = ks(e, n);
	if (js(r) || As(r)) return !1;
	let i = r?.setTo || 6, a = r?.tiebreakAt || i, o = Math.max(t.side1, t.side2), s = Math.min(t.side1, t.side2);
	return a === i ? o === a + 1 && s === a : o === i && s === a;
}
function Bs(e, t, n) {
	if (e + 1 >= n.bestOf || Fs(t, n.bestOf, n.exactly)) return !1;
	let r = t[e];
	return r ? r.winningSide !== void 0 : !1;
}
function Vs(e, t, n, r, i) {
	let a = Number.parseInt(t) || 0, o = Number.parseInt(n) || 0, s = r ? Number.parseInt(r) : void 0, c = ks(e, i);
	if (As(c)) {
		let t = a > 0 && o > 0 && a !== o ? a > o ? 1 : 2 : void 0;
		return {
			setNumber: e + 1,
			side1Score: 0,
			side2Score: 0,
			side1TiebreakScore: a,
			side2TiebreakScore: o,
			winningSide: t
		};
	}
	let l = Ps(e, {
		side1: a,
		side2: o,
		tiebreak: s
	}, i), u = {
		setNumber: e + 1,
		side1Score: a,
		side2Score: o,
		winningSide: l
	};
	if (s !== void 0) {
		let e = c?.tiebreakFormat?.tiebreakTo || 7, t = c?.tiebreakFormat?.noAd, n;
		n = s < e - 1 ? e : t ? s + 1 : s + 2, a > o ? (u.side1TiebreakScore = n, u.side2TiebreakScore = s) : (u.side1TiebreakScore = s, u.side2TiebreakScore = n);
	}
	return u;
}
//#endregion
//#region src/components/scoring/approaches/dynamicSetsApproach.ts
var { COMPLETED: Hs, RETIRED: Us, WALKOVER: Ws, DEFAULTED: Gs, DOUBLE_WALKOVER: Ks, DOUBLE_DEFAULT: qs } = u, Js = "var(--chc-text-secondary)", Ys = "var(--chc-text-primary)";
function Xs(e) {
	let t = e.side1Score === 0 && e.side2Score === 0 && (e.side1TiebreakScore !== void 0 || e.side2TiebreakScore !== void 0), n = t ? {
		side1TiebreakScore: e.side1TiebreakScore,
		side2TiebreakScore: e.side2TiebreakScore
	} : {
		side1: e.side1Score,
		side2: e.side2Score
	};
	return !t && e.side1TiebreakScore !== void 0 && (n.side1TiebreakScore = e.side1TiebreakScore), !t && e.side2TiebreakScore !== void 0 && (n.side2TiebreakScore = e.side2TiebreakScore), e.winningSide !== void 0 && (n.winningSide = e.winningSide), e.side1PointScore !== void 0 && (n.side1PointScore = e.side1PointScore), e.side2PointScore !== void 0 && (n.side2PointScore = e.side2PointScore), n;
}
function Zs(e, t) {
	if (t.sets && t.scoreObject?.sets) for (let n = 0; n < e.length && n < t.scoreObject.sets.length; n++) {
		let r = e[n];
		r.side1PointScore !== void 0 && (t.scoreObject.sets[n].side1PointScore = r.side1PointScore), r.side2PointScore !== void 0 && (t.scoreObject.sets[n].side2PointScore = r.side2PointScore);
	}
	if (t.sets) for (let n = 0; n < e.length && n < t.sets.length; n++) {
		let r = e[n];
		r.side1PointScore !== void 0 && (t.sets[n].side1PointScore = r.side1PointScore), r.side2PointScore !== void 0 && (t.sets[n].side2PointScore = r.side2PointScore);
	}
}
function Qs(e, t, n, r) {
	e === Hs ? (r.style.display = "none", n.style.display = t ? "none" : "block") : (n.style.display = "block", r.style.display = "block");
}
function $s(e, t, n) {
	t !== Hs && (n ? (e.matchUpStatus = t, e.winningSide = n, e.isValid = !0) : t === Ws ? (e.matchUpStatus = Ks, e.isValid = !0) : t === Gs ? (e.matchUpStatus = qs, e.isValid = !0) : (e.matchUpStatus = t, e.isValid = !1));
}
function ec(e, t, n) {
	if (t) {
		let t = e.filter((e) => e.winningSide !== void 0).length;
		return Math.max(1, t);
	}
	let r = e.length - 1;
	return r >= 0 && e[r].winningSide !== void 0 && e.length < n ? e.length + 1 : Math.max(1, e.length);
}
var tc = "input[name=\"matchOutcome\"]", nc = "input[name=\"irregularWinner\"]", rc = ".tiebreak-container";
function ic(e) {
	let { matchUp: t, container: n, onScoreChange: r, labels: i = {} } = e;
	n.innerHTML = "", n.style.display = "flex", n.style.flexDirection = "column", n.style.gap = "1em";
	let a = t.matchUpFormat || "SET3-S:6/TB7", o = () => {
		let e = Ds(a), t = l.parse(a);
		return {
			bestOf: e.bestOf,
			exactly: t?.exactly,
			setFormat: t?.setFormat,
			finalSetFormat: t?.finalSetFormat
		};
	}, s = o(), c = () => s.bestOf, u = () => s.exactly, d = (e) => ks(e, s), f = document.createElement("div");
	if (f.style.marginBottom = "0.5em", n.appendChild(f), t.matchUpFormat) {
		let e = document.createElement("div");
		e.style.fontSize = "0.9em", e.style.marginBottom = "0.5em", e.style.display = "flex", e.style.alignItems = "center", e.style.gap = "0.5em";
		let r = document.createElement("span");
		r.textContent = (i.format || "Format") + ":", r.style.color = Js, e.appendChild(r);
		let c = document.createElement("button");
		c.textContent = t.matchUpFormat, c.className = "button is-small is-white", c.style.fontSize = "0.75em", c.style.padding = "0.2em 0.5em", c.style.cursor = "pointer", c.title = "Click to edit format", c.addEventListener("click", () => {
			try {
				Ra({
					existingMatchUpFormat: t.matchUpFormat,
					callback: (e) => {
						e && e !== t.matchUpFormat && (t.matchUpFormat = e, a = e, c.textContent = e, s = o(), globalThis.resetDynamicSets && globalThis.resetDynamicSets());
					},
					modalConfig: { style: {
						fontSize: "12px",
						border: "3px solid #0066cc"
					} }
				});
			} catch (e) {
				console.error("[DynamicSets] Error opening format selector:", e);
			}
		}), e.appendChild(c), n.appendChild(e);
	}
	let m = Hs, h, g = /* @__PURE__ */ new Set(), _ = t.score ? { ...t.score } : void 0, v = t.winningSide, y = t.matchUpStatus, b = document.createElement("div");
	b.style.marginBottom = "0.8em";
	let x = document.createElement("div");
	x.textContent = (i.irregularEnding || "Irregular Ending") + ":", x.style.fontSize = "0.75em", x.style.fontWeight = "500", x.style.marginBottom = "0.3em", x.style.color = Ys, b.appendChild(x);
	let S = document.createElement("div");
	S.style.display = "flex", S.style.gap = "0.5em", S.style.flexWrap = "wrap", [
		{
			value: Us,
			label: i.retired || "Retired"
		},
		{
			value: Ws,
			label: i.walkover || "Walkover"
		},
		{
			value: Gs,
			label: i.defaulted || "Defaulted"
		}
	].forEach((e) => {
		let t = document.createElement("label");
		t.style.display = "flex", t.style.alignItems = "center", t.style.gap = "0.3em", t.style.cursor = "pointer";
		let n = document.createElement("input");
		n.type = "radio", n.name = "matchOutcome", n.value = e.value, n.checked = !1, n.addEventListener("change", (e) => {
			if (m = e.target.value, m === Ws) {
				k.querySelectorAll("input").forEach((e) => {
					e.value = "";
				});
				let e = k.querySelectorAll(".set-row");
				for (let t = e.length - 1; t > 0; t--) e[t].remove();
				I = [], j = null, M = 0, _ = void 0;
			}
			w.style.display = "block", setTimeout(() => {
				typeof L == "function" && L();
			}, 0);
		});
		let r = document.createElement("span");
		r.textContent = e.label, r.style.fontSize = "0.75em", t.appendChild(n), t.appendChild(r), S.appendChild(t);
	});
	let C = document.createElement("button");
	C.textContent = i.clear || "Clear", C.className = "button", C.style.fontSize = "0.7em", C.style.padding = "0.2em 0.5em", C.addEventListener("click", () => {
		b.querySelectorAll(tc).forEach((e) => e.checked = !1), m = Hs, h = void 0, w.style.display = "none", y = void 0, v = void 0, b.querySelectorAll(nc).forEach((e) => e.checked = !1), setTimeout(() => {
			typeof L == "function" && L();
		}, 0);
	}), S.appendChild(C), b.appendChild(S);
	let w = document.createElement("div");
	w.style.display = "none", w.style.marginTop = "0.3em", w.style.paddingLeft = "1em", w.style.borderLeft = "3px solid var(--chc-clear-btn-bg)";
	let T = document.createElement("div");
	T.textContent = (i.winner || "Winner") + ":", T.style.fontSize = "0.75em", T.style.fontWeight = "500", T.style.marginBottom = "0.2em", T.style.color = Ys, w.appendChild(T);
	let E = document.createElement("div");
	E.style.display = "flex", E.style.gap = "0.5em";
	let D = t.sides?.[0], O = t.sides?.[1];
	[1, 2].forEach((e) => {
		let t = document.createElement("label");
		t.style.display = "flex", t.style.alignItems = "center", t.style.gap = "0.3em", t.style.cursor = "pointer";
		let n = document.createElement("input");
		n.type = "radio", n.name = "irregularWinner", n.value = e.toString(), n.addEventListener("change", () => {
			h = e, setTimeout(() => {
				typeof L == "function" && (P = !0, L(), P = !1);
			}, 0);
		});
		let r = document.createElement("span");
		r.textContent = (e === 1 ? D : O)?.participant?.participantName || `Side ${e}`, r.style.fontSize = "0.75em", t.appendChild(n), t.appendChild(r), E.appendChild(t);
	}), w.appendChild(E), b.appendChild(w), n.appendChild(b);
	let k = document.createElement("div");
	k.style.display = "flex", k.style.flexDirection = "column", k.style.gap = "0.5em", n.appendChild(k);
	let { ScoringEngine: A } = p, j = null, M = 0, N = !1, P = !1, F = (e) => {
		if (!j) return;
		let t = M % 2;
		j.addPoint({
			winner: e,
			server: t,
			result: "Winner"
		}), M++, P = !0, L(), P = !1;
	}, ee = () => {
		if (!t.matchUpFormat) return;
		j = new A({ matchUpFormat: t.matchUpFormat }), M = 0;
		let e = I.filter((e) => e.winningSide !== void 0).map((e) => ({
			side1Score: e.side1Score,
			side2Score: e.side2Score,
			side1TiebreakScore: e.side1TiebreakScore,
			side2TiebreakScore: e.side2TiebreakScore,
			winningSide: e.winningSide
		})), n = I[I.length - 1];
		if (n && n.winningSide === void 0 && (n.side1Score || n.side2Score) && e.push({
			side1Score: n.side1Score,
			side2Score: n.side2Score,
			side1TiebreakScore: n.side1TiebreakScore,
			side2TiebreakScore: n.side2TiebreakScore,
			winningSide: void 0
		}), e.length > 0) try {
			j.setInitialScore({ sets: e });
		} catch {}
	}, te = () => {
		if (!j) return {};
		let e = j.getScore()?.pointDisplay;
		return !e || e[0] === "0" && e[1] === "0" && M === 0 ? {} : {
			side1: String(e[0]),
			side2: String(e[1])
		};
	}, ne = (e, t) => {
		if (!j) return;
		let n = {
			0: 0,
			15: 1,
			30: 2,
			40: 3,
			AD: 4
		};
		if (e in n || t in n) {
			let r = n[e] ?? 0, i = n[t] ?? 0;
			for (let e = 0; e < r; e++) {
				let e = M % 2;
				j.addPoint({
					winner: 0,
					server: e,
					result: "Winner"
				}), M++;
			}
			for (let e = 0; e < i; e++) {
				let e = M % 2;
				j.addPoint({
					winner: 1,
					server: e,
					result: "Winner"
				}), M++;
			}
		} else {
			let n = parseInt(e, 10) || 0, r = parseInt(t, 10) || 0;
			for (let e = 0; e < n; e++) {
				let e = M % 2;
				j.addPoint({
					winner: 0,
					server: e,
					result: "Winner"
				}), M++;
			}
			for (let e = 0; e < r; e++) {
				let e = M % 2;
				j.addPoint({
					winner: 1,
					server: e,
					result: "Winner"
				}), M++;
			}
		}
	}, re = () => {
		let e = m === Us || m === Gs, t = I[I.length - 1], n = t && t.winningSide === void 0;
		if (N = !!(e && n), !N) {
			j = null, M = 0;
			return;
		}
		P || ee();
	}, I = [];
	globalThis.resetDynamicSets = () => {
		k.innerHTML = "", I = [], g.clear(), j = null, M = 0, N = !1, m = Hs, h = void 0, _ = void 0, v = void 0, y = void 0, b.querySelectorAll(tc).forEach((e) => e.checked = !1), b.querySelectorAll(nc).forEach((e) => e.checked = !1), b.style.display = "none", w.style.display = "none";
		let e = oe(0);
		k.appendChild(e), e.querySelectorAll("input").forEach((e) => {
			e.addEventListener("input", me), e.addEventListener("keydown", xe);
		}), ie({ clearAll: !0 }), r({
			isValid: !1,
			sets: [],
			matchUpStatus: "TO_BE_PLAYED"
		});
		let t = k.querySelector("input");
		t && t.focus();
	};
	let ie = (e) => {
		f.innerHTML = "";
		let n;
		e?.clearAll ? (n = void 0, _ = void 0) : e?.scoreObject ? (n = e.scoreObject, _ = e.scoreObject) : I.length > 0 ? (n = { sets: I }, _ = { sets: I }) : n = _, e?.clearAll ? (v = void 0, y = void 0) : e && (v = e.winningSide, y = e.matchUpStatus || void 0, [
			Ws,
			Us,
			Gs,
			Ks,
			qs
		].includes(y) && I.length === 0 && (n = void 0, _ = void 0));
		let r = oi({
			matchUp: {
				...t,
				score: n,
				winningSide: v,
				matchUpStatus: y
			},
			isLucky: !0,
			composition: yi[hs().composition || "Australian"] || yi.Australian
		});
		if (N) {
			let e = j?.isComplete(), t = r.querySelector(".tmx-sd[sideNumber=\"1\"] .sideScore");
			if (t) {
				let n = document.createElement("button");
				n.className = "chc-game-btn", n.textContent = "+", n.title = "Point for side 1", n.disabled = e, n.addEventListener("click", (e) => {
					e.stopPropagation(), e.preventDefault(), F(0);
				}), t.appendChild(n);
			}
			let n = r.querySelector(".tmx-sd[sideNumber=\"2\"] .sideScore");
			if (n) {
				let t = document.createElement("button");
				t.className = "chc-game-btn", t.textContent = "+", t.title = "Point for side 2", t.disabled = e, t.addEventListener("click", (e) => {
					e.stopPropagation(), e.preventDefault(), F(1);
				}), n.appendChild(t);
			}
		}
		f.appendChild(r), ae();
	}, ae = () => {
		requestAnimationFrame(() => {
			let e = f.firstElementChild;
			if (!e) return;
			e.style.width = "fit-content", e.style.minWidth = "100%", e.style.transform = "", f.style.height = "";
			let t = f.clientWidth, n = e.scrollWidth;
			if (n > t && t > 0) {
				let r = t / n;
				e.style.transformOrigin = "top left", e.style.transform = `scale(${r})`, f.style.height = `${e.offsetHeight * r}px`;
			}
		});
	}, oe = (e) => {
		let t = document.createElement("div");
		t.className = "set-row", t.style.display = "flex", t.style.alignItems = "center", t.style.gap = "0.5em", t.style.marginBottom = "0.25em";
		let n = document.createElement("div");
		n.textContent = `Set ${e + 1}:`, n.style.width = "3.5em", n.style.fontSize = "0.9em", n.style.fontWeight = "500", n.style.color = Ys, t.appendChild(n);
		let r = document.createElement("input");
		r.type = "text", r.className = "input", r.style.width = "3em", r.style.textAlign = "center", r.placeholder = "0", r.dataset.setIndex = e.toString(), r.dataset.side = "1";
		let i = document.createElement("input");
		i.type = "text", i.className = "input", i.style.width = "3em", i.style.textAlign = "center", i.placeholder = "0", i.dataset.setIndex = e.toString(), i.dataset.side = "2";
		let a = document.createElement("span");
		a.textContent = "-", a.style.fontWeight = "bold", a.style.color = Js, t.appendChild(r), t.appendChild(a), t.appendChild(i);
		let o = document.createElement("span");
		o.className = "tiebreak-container", o.style.display = "none", o.style.marginLeft = "0.5em";
		let s = document.createElement("span");
		s.textContent = "(", s.style.color = Js;
		let c = document.createElement("input");
		c.type = "text", c.className = "input tiebreak-input", c.style.width = "2.5em", c.style.textAlign = "center", c.dataset.setIndex = e.toString(), c.dataset.type = "tiebreak";
		let l = document.createElement("span");
		l.textContent = ")", l.style.color = Js, o.appendChild(s), o.appendChild(c), o.appendChild(l), t.appendChild(o);
		let u = document.createElement("span");
		return u.className = "set-indicator", u.style.fontSize = "1.2em", u.style.minWidth = "1.5em", t.appendChild(u), t;
	}, se = (e) => {
		let t = k.querySelector(`input[data-set-index="${e}"][data-side="1"]`), n = k.querySelector(`input[data-set-index="${e}"][data-side="2"]`), r = k.querySelector(`input[data-set-index="${e}"][data-type="tiebreak"]`);
		if (!t || !n) return !1;
		let i = t.value.trim(), a = n.value.trim();
		return i === "" || a === "" ? !1 : Ns(e, {
			side1: Number.parseInt(i) || 0,
			side2: Number.parseInt(a) || 0,
			tiebreak: r?.value.trim() ? Number.parseInt(r.value) : void 0
		}, s);
	}, L = () => {
		m === Hs && (w.style.display = "none");
		let e = [];
		for (let t = 0; t < c(); t++) {
			let n = k.querySelector(`input[data-set-index="${t}"][data-side="1"]`), r = k.querySelector(`input[data-set-index="${t}"][data-side="2"]`), i = k.querySelector(`input[data-set-index="${t}"][data-type="tiebreak"]`);
			if (!n || !r) break;
			let a = n.value.trim(), o = r.value.trim();
			if (a === "" && o === "") break;
			let c = i?.value.trim(), l = Vs(t, a, o, c, s);
			e.push(l);
		}
		if (I = e, re(), N && I.length > 0) {
			let e = I[I.length - 1];
			if (e.winningSide === void 0) {
				let t = te();
				(t.side1 || t.side2) && (e.side1PointScore = t.side1 || "0", e.side2PointScore = t.side2 || "0");
			}
		}
		let n = k.querySelectorAll(".set-row"), i = Fs(I, c(), u()), a = ec(I, i, c());
		for (let e = n.length - 1; e >= a; e--) n[e].remove();
		if (I.length > 0 || m !== Hs) {
			let e = I.some((e) => e.winningSide === void 0), n = (m !== Hs || e ? I : I.filter((e) => e.winningSide !== void 0)).map(Xs), i = Es(n, t.matchUpFormat, m !== Hs);
			Zs(n, i);
			let a = i.isValid && i.winningSide !== void 0;
			Qs(m, a, b, w), $s(i, m, h), ie(i), r(i);
		} else b.style.display = "block", ie(), r({
			isValid: !1,
			sets: [],
			matchUpStatus: "TO_BE_PLAYED"
		});
	}, ce = () => {
		let e = document.getElementById("clearScoreV2");
		if (e) {
			let t = k.querySelectorAll(".set-row"), n = k.querySelector("input[data-set-index=\"0\"][data-side=\"1\"]"), r = k.querySelector("input[data-set-index=\"0\"][data-side=\"2\"]");
			e.disabled = !(t.length > 1 || n?.value.trim() !== "" || r?.value.trim() !== "");
		}
	}, le = (e) => {
		let t = k.querySelector(`input[data-set-index="${e}"][data-side="1"]`), n = k.querySelector(`input[data-set-index="${e}"][data-side="2"]`), r = k.querySelector(`.set-row:nth-child(${e + 1}) .tiebreak-container`), i = k.querySelector(`input[data-set-index="${e}"][data-type="tiebreak"]`);
		!t || !n || !r || (zs(e, {
			side1: Number.parseInt(t.value) || 0,
			side2: Number.parseInt(n.value) || 0
		}, s) ? r.style.display = "inline" : (r.style.display = "none", i && (i.value = "")));
	}, ue = (e, t) => {
		let n = t === "1" ? "2" : "1", r = k.querySelector(`input[data-set-index="${e}"][data-side="${n}"]`), i = k.querySelector(`input[data-set-index="${e}"][data-side="${t}"]`), a = Number.parseInt(i?.value) || 0, o = Number.parseInt(r?.value) || 0;
		return Ms(e, t === "1" ? 1 : 2, {
			side1: t === "1" ? a : o,
			side2: t === "2" ? a : o
		}, s);
	};
	function R() {
		m = Hs, h = void 0, b.querySelectorAll(tc).forEach((e) => e.checked = !1), w.style.display = "none";
	}
	function de(e, t, n, r) {
		let i = d(n)?.tiebreakSet?.tiebreakTo !== void 0;
		if (t) e.value.length > 2 && (e.value = e.value.slice(0, 2));
		else if (i) e.value.length > 3 && (e.value = e.value.slice(0, 3));
		else {
			let t = ue(n, r);
			(Number.parseInt(e.value) || 0) > t && (e.value = t.toString());
		}
	}
	function fe(e, t) {
		if (d(e)?.tiebreakSet?.tiebreakTo !== void 0) return;
		let n = t === "1" ? "2" : "1", r = k.querySelector(`input[data-set-index="${e}"][data-side="${n}"]`);
		if (r?.value.trim()) {
			let t = Number.parseInt(r.value) || 0, i = ue(e, n);
			t > i && (r.value = i.toString());
		}
	}
	function pe(e) {
		if (!se(e) || Fs(I, c(), u()) || !Os(I, t.matchUpFormat)) return;
		let n = I.length, r = k.querySelector(`input[data-set-index="${n}"]`);
		if (n < c() && !r) {
			let e = oe(n);
			k.appendChild(e), e.querySelectorAll("input").forEach((e) => {
				e.addEventListener("input", me), e.addEventListener("keydown", xe);
			}), ce();
		}
	}
	let me = (e) => {
		let t = e.target, n = t.dataset.type === "tiebreak";
		m !== Hs && t.value && R();
		let r = t.value.replace(/\D/g, "");
		r !== t.value && (t.value = r);
		let i = Number.parseInt(t.dataset.setIndex || "0"), a = t.dataset.side || "1";
		de(t, n, i, a), n || (le(i), fe(i, a)), L(), ce(), pe(i);
	}, z = (e) => {
		e.focus(), e.select();
	};
	function he(e) {
		let t = oe(e);
		k.appendChild(t);
		let n = t.querySelectorAll("input");
		n.forEach((e) => {
			e.addEventListener("input", me), e.addEventListener("keydown", xe);
		});
		let r = n[0];
		r instanceof HTMLInputElement && z(r), ce();
	}
	function ge(e, t, n) {
		let r = vs()?.smartComplements === !0, i = e.code.match(/^Digit(\d)$/);
		if (!i || t.value !== "") return !1;
		let a = Rs(Number.parseInt(i[1]), e.shiftKey, n, I, s, g, r);
		if (!a.shouldApply) return !1;
		e.preventDefault(), t.value = a.field1Value.toString();
		let o = k.querySelector(`input[data-set-index="${n}"][data-side="2"]`);
		return o && (o.value = a.field2Value.toString()), g.add(n), t.dispatchEvent(new Event("input", { bubbles: !0 })), setTimeout(() => {
			if (L(), Fs(I, c(), u())) return;
			let e = k.querySelector(`input[data-set-index="${n + 1}"][data-side="1"]`);
			e ? z(e) : n + 1 < c() && he(n + 1);
		}, 10), !0;
	}
	function _e(e, t, n) {
		if (n) {
			let t = k.querySelector(`input[data-set-index="${e}"][data-side="2"]`);
			t && z(t);
		} else if (t === "2") {
			let t = k.querySelector(`input[data-set-index="${e}"][data-side="1"]`);
			t && z(t);
		} else e > 0 && ve(e);
	}
	function ve(e) {
		let t = k.querySelector(`input[data-set-index="${e - 1}"][data-type="tiebreak"]`), n = k.querySelector(`input[data-set-index="${e - 1}"][data-side="2"]`), r = t?.closest(rc);
		t && r && r.style.display !== "none" ? z(t) : n && z(n);
	}
	function ye(e) {
		let t = k.querySelector(`input[data-set-index="${e}"][data-type="tiebreak"]`), n = t?.closest(rc);
		if (t && n && n.style.display !== "none") {
			z(t);
			return;
		}
		let r = k.querySelector(`input[data-set-index="${e + 1}"][data-side="1"]`);
		if (r) z(r);
		else if (e + 1 < c()) {
			if (!se(e) || Fs(I, c(), u())) return;
			he(e + 1);
		}
	}
	function be(e) {
		let t = k.querySelector(`input[data-set-index="${e + 1}"][data-side="1"]`);
		if (t) z(t);
		else if (e + 1 < c()) {
			if (!se(e) || (L(), Fs(I, c(), u()))) return;
			he(e + 1);
		}
	}
	let xe = (e) => {
		let t = e.target, n = Number.parseInt(t.dataset.setIndex || "0"), r = t.dataset.side || "1", i = t.dataset.type === "tiebreak";
		if (!(r === "1" && !i && ge(e, t, n))) {
			if (e.key === "Tab") if (e.preventDefault(), e.shiftKey) _e(n, r, i);
			else if (i) be(n);
			else if (r === "1") {
				let e = k.querySelector(`input[data-set-index="${n}"][data-side="2"]`);
				e && z(e);
			} else r === "2" && (L(), ye(n));
			if (e.key === "Enter") {
				let e = document.getElementById("submitScoreV2");
				e && !e.disabled && e.click();
			}
			e.key === "Backspace" && t.value === "" && (e.preventDefault(), _e(n, r, i));
		}
	}, Se = oe(0);
	if (k.appendChild(Se), Se.querySelectorAll("input").forEach((e) => {
		e.addEventListener("input", me), e.addEventListener("keydown", xe);
	}), _?.sets && _.sets.length > 0) {
		let e = Math.ceil(c() / 2), t = 0, n = 0, r = !1;
		_.sets.forEach((i, a) => {
			if (r) return;
			if (a > 0) {
				let e = oe(a);
				k.appendChild(e), e.querySelectorAll("input").forEach((e) => {
					e.addEventListener("input", me), e.addEventListener("keydown", xe);
				});
			}
			let o = k.querySelector(`input[data-set-index="${a}"][data-side="1"]`), s = k.querySelector(`input[data-set-index="${a}"][data-side="2"]`), c = k.querySelector(`input[data-set-index="${a}"][data-type="tiebreak"]`);
			if (o && s && (o.value = i.side1Score?.toString() || "", s.value = i.side2Score?.toString() || "", le(a), c && (i.side1TiebreakScore !== void 0 || i.side2TiebreakScore !== void 0) && (i.winningSide === 1 && i.side2TiebreakScore !== void 0 ? c.value = i.side2TiebreakScore.toString() : i.winningSide === 2 && i.side1TiebreakScore !== void 0 ? c.value = i.side1TiebreakScore.toString() : i.side1TiebreakScore === void 0 ? i.side2TiebreakScore !== void 0 && (c.value = i.side2TiebreakScore.toString()) : c.value = i.side1TiebreakScore.toString())), i.side1PointScore !== void 0 || i.side2PointScore !== void 0) {
				let e = i.side1PointScore?.toString() || "0", t = i.side2PointScore?.toString() || "0";
				setTimeout(() => {
					re(), j && (ne(e, t), P = !0, L(), P = !1);
				}, 0);
			}
			i.winningSide === 1 && t++, i.winningSide === 2 && n++, r = (t >= e || n >= e) && (!u() || a + 1 >= u());
		});
	} else ie();
	t.matchUpStatus && t.matchUpStatus !== Hs && [
		Us,
		Ws,
		Gs,
		Ks,
		qs
	].includes(t.matchUpStatus) && (t.matchUpStatus === Ks ? (m = Ws, h = void 0) : t.matchUpStatus === qs ? (m = Gs, h = void 0) : (m = t.matchUpStatus, h = t.winningSide), b.querySelectorAll(tc).forEach((e) => {
		e.value === m && (e.checked = !0);
	}), h && (b.querySelectorAll(nc).forEach((e) => {
		Number.parseInt(e.value) === h && (e.checked = !0);
	}), w.style.display = "block")), _?.sets && _.sets.length > 0 ? L() : m === Hs ? (b.style.display = "none", w.style.display = "none") : ie(), setTimeout(() => {
		let e = k.querySelector("input");
		e && e.focus();
	}, 100);
}
//#endregion
//#region src/components/scoring/approaches/dialPadLogic.ts
function ac(e, t) {
	let { matchUpFormat: n } = t;
	if (!e) return "";
	let r = l.parse(n), i = r?.setFormat?.bestOf || 3, a = (e) => e === i && r?.finalSetFormat ? r.finalSetFormat : r?.setFormat, o = "", s = 0, c = e.split(/[\s/]+|--+/).filter((e) => e.length > 0);
	for (let e of c) {
		let t = { pos: 0 };
		for (; t.pos < e.length && s < i;) {
			let n = uc(e, t, s, i, a);
			if (o && (o += " "), o += n.formatted, n.complete) s++;
			else break;
		}
	}
	return o;
}
function oc(e, t, n) {
	let r = n(e + 1), i = r?.tiebreakSet?.tiebreakTo, a = r?.setTo, o = !!i && !a, s = r?.timed === !0, c = s ? 999 : i || a || 6;
	return {
		isTiebreakOnly: o,
		isTimed: s,
		setTo: c,
		tiebreakAt: r?.tiebreakAt || c,
		maxScore: s ? 999 : c + 1
	};
}
function sc(e, t, n, r, i) {
	let a = "";
	for (; t.pos < e.length;) {
		let o = e[t.pos];
		if (o === "-") {
			if (!n) break;
			if (a.length > 0) {
				t.pos++;
				break;
			}
			break;
		}
		if (n) {
			a += o, t.pos++;
			continue;
		}
		if (Number.parseInt(a + o) > r + i || a.length >= 2) break;
		a += o, t.pos++;
		let s = Number.parseInt(a);
		if (a.length === 1 && s !== 1 && r < 10) {
			if (t.pos < e.length && e[t.pos] === "-") continue;
			break;
		}
	}
	return a;
}
function cc(e, t, n) {
	let r = !1, i = e, a = t;
	return i > n + 1 && (i = n, r = !0), a > n + 1 && (a = n, r = !0), i === n + 1 && a < n - 1 ? (i = n, r = !0) : a === n + 1 && i < n - 1 && (a = n, r = !0), {
		s1: i,
		s2: a,
		side1: i.toString(),
		side2: a.toString(),
		wasCoerced: r
	};
}
function lc(e, t) {
	let n = "";
	for (; t.pos < e.length;) {
		let r = e[t.pos];
		if (r === "-") {
			t.pos++;
			break;
		}
		n += r, t.pos++;
	}
	return n;
}
function uc(e, t, n, r, i) {
	let a = oc(n, r, i), o = a.isTiebreakOnly || a.isTimed, s = sc(e, t, o, a.maxScore, 0);
	t.pos < e.length && e[t.pos] === "-" && t.pos++;
	let c = sc(e, t, o, a.maxScore, 3);
	if (!c) return {
		formatted: s,
		complete: !1
	};
	let l = Number.parseInt(s), u = Number.parseInt(c), d = s, f = c, p = !1;
	if (!a.isTiebreakOnly && !a.isTimed) {
		let e = cc(l, u, a.setTo);
		l = e.s1, u = e.s2, d = e.side1, f = e.side2, p = e.wasCoerced;
	}
	let m = Math.abs(l - u), h = Math.max(l, u), g = a.isTimed || h >= a.setTo && m >= 2, _ = t.pos < e.length, v = l === a.tiebreakAt && u === a.tiebreakAt, y = l === a.tiebreakAt + 1 && u === a.tiebreakAt || u === a.tiebreakAt + 1 && l === a.tiebreakAt;
	if (!p && (v || y && _)) {
		let n = lc(e, t);
		return n ? {
			formatted: `${d}-${f}(${n})`,
			complete: !0
		} : {
			formatted: `${d}-${f}(`,
			complete: !1
		};
	}
	return a.isTiebreakOnly ? {
		formatted: `[${d}-${f}]`,
		complete: g
	} : {
		formatted: `${d}-${f}`,
		complete: g
	};
}
//#endregion
//#region src/components/scoring/approaches/dialPadApproach.ts
var { COMPLETED: dc, RETIRED: fc, WALKOVER: pc, DEFAULTED: mc, DOUBLE_WALKOVER: hc, DOUBLE_DEFAULT: gc } = u, _c = "SET3-S:6/TB7", vc = "var(--chc-text-secondary)", yc = "var(--chc-bg-secondary)", bc = "input[name=\"matchOutcome\"]", xc = "input[name=\"irregularWinner\"]";
function Sc(e) {
	if (!e?.sets || e.sets.length === 0) return "";
	let t = [];
	return e.sets.forEach((e, n) => {
		if (n > 0 && t.push(" "), t.push(e.side1Score?.toString() || "0"), t.push(e.side2Score?.toString() || "0"), e.side1TiebreakScore !== void 0 || e.side2TiebreakScore !== void 0) {
			let n = e.winningSide === 1 ? e.side2TiebreakScore : e.side1TiebreakScore;
			n !== void 0 && (t.push("-"), t.push(n.toString()));
		}
	}), t.join("");
}
function Cc(e) {
	let { matchUp: t, container: n, onScoreChange: r, labels: i = {} } = e;
	try {
		n.innerHTML = "", n.style.display = "flex", n.style.flexDirection = "column", n.style.gap = "1em";
		let e = l.parse(t.matchUpFormat || _c), a = e?.setFormat?.setTo || 6, o = e?.setFormat?.tiebreakAt || a, s = t.score ? { ...t.score } : void 0, c = t.winningSide, u = t.matchUpStatus, d = {
			digits: "",
			setTo: a,
			tiebreakAt: o,
			isMatchComplete: !1
		};
		if (s) {
			d.digits = Sc(s);
			let e = ac(d.digits, { matchUpFormat: t.matchUpFormat || _c });
			if (e && e.includes("-")) {
				let n = Ts(e, t.matchUpFormat);
				d.isMatchComplete = n.isValid && n.winningSide !== void 0 && (n.matchUpStatus === dc || n.matchUpStatus === void 0);
			}
		}
		let f = document.createElement("div");
		if (f.style.marginBottom = "0.5em", n.appendChild(f), e?.aggregate) {
			let e = document.createElement("div");
			e.style.fontSize = "0.75em", e.style.color = vc, e.style.marginTop = "0.25em", e.style.marginBottom = "0.5em", e.style.padding = "0.25em 0.5em", e.style.backgroundColor = yc, e.style.border = "1px solid var(--chc-status-warning)", e.style.borderRadius = "3px", e.textContent = "⚠️ Aggregate Scoring: Winner determined by total points across all sets", n.appendChild(e);
		}
		if (t.matchUpFormat) {
			let e = document.createElement("div");
			e.style.fontSize = "0.9em", e.style.marginBottom = "0.5em", e.style.display = "flex", e.style.alignItems = "center", e.style.gap = "0.5em";
			let a = document.createElement("span");
			a.textContent = (i.format || "Format") + ":", a.style.color = vc, e.appendChild(a);
			let o = document.createElement("button");
			o.textContent = t.matchUpFormat, o.className = "button is-small is-white", o.style.fontSize = "0.75em", o.style.padding = "0.2em 0.5em", o.style.cursor = "pointer", o.title = "Click to edit format", o.addEventListener("click", () => {
				try {
					Ra({
						existingMatchUpFormat: t.matchUpFormat,
						callback: (e) => {
							e && e !== t.matchUpFormat && (t.matchUpFormat = e, o.textContent = e, d.digits = "", n.innerHTML = "", Cc({
								matchUp: t,
								container: n,
								onScoreChange: r,
								labels: i
							}));
						},
						modalConfig: { style: {
							fontSize: "12px",
							border: "3px solid #0066cc"
						} }
					});
				} catch (e) {
					console.error("Error opening format selector:", e);
				}
			}), e.appendChild(o), n.appendChild(e);
		}
		let p = document.createElement("div");
		p.style.fontSize = "1.2em", p.style.color = "#64B5F6", p.style.textAlign = "center", p.style.padding = "0.25em 0.5em", p.style.fontWeight = "bold", p.style.minHeight = "1.5em", p.style.maxWidth = "300px", p.style.margin = "0 auto", p.textContent = "-", n.appendChild(p);
		let m = dc, h, g = document.createElement("div");
		g.style.display = "none", g.style.marginBottom = "0.8em", g.style.padding = "0.6em", g.style.backgroundColor = yc, g.style.border = "2px solid var(--chc-status-warning)", g.style.borderRadius = "4px";
		let _ = document.createElement("div");
		_.textContent = (i.irregularEnding || "Irregular Ending") + ":", _.style.fontSize = "0.8em", _.style.fontWeight = "600", _.style.marginBottom = "0.3em", _.style.color = vc, g.appendChild(_);
		let v = document.createElement("div");
		v.style.display = "none", v.style.marginTop = "0.3em";
		let y = document.createElement("div");
		y.textContent = (i.winner || "Winner") + ":", y.style.fontSize = "0.75em", y.style.fontWeight = "500", y.style.marginBottom = "0.2em", y.style.color = vc, v.appendChild(y);
		let b = document.createElement("div");
		b.style.display = "flex", b.style.gap = "0.5em", b.style.flexWrap = "wrap";
		let x = t.sides?.[0], S = t.sides?.[1];
		[1, 2].forEach((e) => {
			let t = document.createElement("label");
			t.style.display = "flex", t.style.alignItems = "center", t.style.gap = "0.3em", t.style.cursor = "pointer";
			let n = document.createElement("input");
			n.type = "radio", n.name = "irregularWinner", n.value = e.toString(), n.addEventListener("change", () => {
				n.checked && (h = e, E());
			});
			let r = document.createElement("span");
			r.textContent = (e === 1 ? x : S)?.participant?.participantName || `Side ${e}`, r.style.fontSize = "0.75em", r.style.color = vc, t.appendChild(n), t.appendChild(r), b.appendChild(t);
		}), v.appendChild(b), g.appendChild(v), n.appendChild(g);
		let C = document.createElement("div");
		C.style.display = "grid", C.style.gridTemplateColumns = "repeat(4, 1fr)", C.style.gap = "8px", C.style.width = "100%", C.style.maxWidth = "320px", C.style.margin = "0 auto", n.appendChild(C);
		let w = (e) => ac(e, { matchUpFormat: t.matchUpFormat || _c }), T = (e) => {
			f.innerHTML = "";
			let n = e?.scoreObject?.sets?.length > 0;
			e?.clearAll ? (s = void 0, c = void 0, u = void 0) : e != null && (n && (s = e?.scoreObject), "winningSide" in e && (c = e?.winningSide), "matchUpStatus" in e && (u = e?.matchUpStatus));
			let r = oi({
				matchUp: {
					...t,
					score: e?.clearAll ? void 0 : n ? s : void 0,
					winningSide: c,
					matchUpStatus: u
				},
				isLucky: !0,
				composition: yi[hs().composition || "Australian"] || yi.Australian
			});
			r && f.appendChild(r);
		}, E = (e = !1) => {
			let n = w(d.digits);
			if (n ? (p.style.display = "block", p.textContent = n) : (p.style.display = "block", p.textContent = "-"), m === fc || m === pc || m === mc ? (g.style.display = "block", v.style.display = "block") : (g.style.display = "none", v.style.display = "none"), e) {
				T({ clearAll: !0 });
				return;
			}
			let i = Ts(n, t.matchUpFormat);
			d.isMatchComplete = i.isValid && i.winningSide !== void 0 && (i.matchUpStatus === dc || i.matchUpStatus === void 0), m !== dc && (h ? (i.matchUpStatus = m, i.winningSide = h, i.isValid = !0) : m === pc ? (i.matchUpStatus = hc, i.isValid = !0) : m === mc ? (i.matchUpStatus = gc, i.isValid = !0) : (i.matchUpStatus = m, i.isValid = !1), d.isMatchComplete = !1), T(i), r(i);
			let a = document.getElementById("clearScoreV2");
			a && (a.disabled = d.digits.length === 0 && m === dc), A(), j();
		}, D = (e) => {
			m !== dc && typeof e == "number" && (m = dc, h = void 0, g.querySelectorAll(bc).forEach((e) => e.checked = !1), v.style.display = "none"), typeof e == "number" && d.digits === "" && e > a && (e = a);
			let n = w(d.digits), r = n.includes("(") && !n.includes(")"), i = d.digits.includes("-"), o = (d.digits.match(/-/g) || []).length, s = n.includes("[") && i && o === 1, c = (n ? Ts(n, t.matchUpFormat) : null)?.sets?.length || 0, u = l.parse(t.matchUpFormat), f = u?.setFormat?.bestOf || 3, p = (e) => {
				let t = e === f && u?.finalSetFormat ? u.finalSetFormat : u?.setFormat, n = t?.tiebreakSet?.tiebreakTo, r = t?.setTo;
				return !!n && !r;
			}, _ = c < f && p(c + 1), y = c > 0 && p(c), b = r || s || _ || y, x = w(e === "-" ? d.digits + "-" : d.digits + e.toString());
			if (n) {
				let r = Ts(n, t.matchUpFormat), i = r.sets?.[r.sets.length - 1], a = n.includes("("), o = x.includes("("), s = a && o && x !== n && x.startsWith(n.substring(0, n.lastIndexOf(")"))), c = i && (i.side1TiebreakScore === void 0 && i.side2TiebreakScore === void 0 || i.side1TiebreakScore == null && i.side2TiebreakScore == null || s) && i.side1Score !== void 0 && i.side2Score !== void 0 && (i.side1Score === i.side2Score || Math.abs(i.side1Score - i.side2Score) === 1);
				if (r.isValid && r.winningSide && !b && !c || !b && e !== "-" && x === n) return;
			}
			e === "-" ? d.digits.endsWith("-") || (d.digits += "-") : d.digits += e.toString(), E();
		}, O = () => {
			d.digits.length > 0 && (d.digits = d.digits.slice(0, -1), E());
		}, k = () => {
			d.digits = "", d.isMatchComplete = !1, m = dc, h = void 0, s = void 0, c = void 0, u = void 0, g.querySelectorAll(xc).forEach((e) => e.checked = !1), g.querySelectorAll(bc).forEach((e) => e.checked = !1), g.style.display = "none", v.style.display = "none", p.style.display = "block", p.textContent = "-", T({ clearAll: !0 }), j(), r({
				isValid: !1,
				sets: [],
				matchUpStatus: "TO_BE_PLAYED"
			});
		};
		globalThis.resetDialPad = k;
		let A = () => {
			let e = C.querySelector("[data-button=\"retired\"]"), t = C.querySelector("[data-button=\"defaulted\"]"), n = w(d.digits), r = !(n.includes("-") && n.length > 2) || d.isMatchComplete;
			e && (e.disabled = r), t && (t.disabled = r);
		}, j = () => {
			let e = m !== dc && h !== void 0 || d.isMatchComplete;
			C.querySelectorAll("button").forEach((t) => {
				let n = t.textContent || "";
				(n.match(/^[0-9]$/) || n === "-") && (t.disabled = e);
			});
		};
		[
			{
				label: "1",
				value: 1
			},
			{
				label: "2",
				value: 2
			},
			{
				label: "3",
				value: 3
			},
			{
				label: "RET",
				value: "retired",
				isSpecial: !0,
				requiresScore: !0
			},
			{
				label: "4",
				value: 4
			},
			{
				label: "5",
				value: 5
			},
			{
				label: "6",
				value: 6
			},
			{
				label: "WO",
				value: "walkover",
				isSpecial: !0
			},
			{
				label: "7",
				value: 7
			},
			{
				label: "8",
				value: 8
			},
			{
				label: "9",
				value: 9
			},
			{
				label: "DEF",
				value: "defaulted",
				isSpecial: !0,
				requiresScore: !0
			},
			{
				label: "⌫",
				value: "delete",
				isSpecial: !0
			},
			{
				label: "0",
				value: 0
			},
			{
				label: "-",
				value: "minus",
				isSpecial: !0
			},
			{
				label: "",
				value: "empty",
				isSpecial: !0,
				disabled: !0
			}
		].forEach((e) => {
			let t = document.createElement("button");
			t.className = "button is-white", t.textContent = e.label, t.style.cssText = "\n        height: 55px !important;\n        width: 100% !important;\n        padding: 0.5em !important;\n        color: var(--chc-text-primary) !important;\n        background-color: var(--chc-bg-elevated) !important;\n        border: 1px solid var(--chc-border-primary) !important;\n      ", e.label.length > 1 && !e.isSpecial ? t.style.fontSize = "1.3em" : e.isSpecial && [
				"RET",
				"WO",
				"DEF"
			].includes(e.label) ? (t.style.fontSize = "0.95em", t.style.setProperty("background-color", yc, "important")) : e.isSpecial ? (t.style.fontSize = "1.3em", t.style.setProperty("background-color", yc, "important")) : t.style.fontSize = "1.3em", (e.value === "retired" || e.value === "defaulted") && (t.dataset.button = e.value), e.disabled && (t.disabled = !0, t.style.visibility = "hidden"), e.requiresScore && (t.disabled = !0), t.onclick = () => {
				e.value === "delete" ? O() : e.value === "minus" ? D("-") : e.value === "retired" ? (m = fc, h = void 0, g.querySelectorAll(xc).forEach((e) => e.checked = !1), E()) : e.value === "walkover" ? (m = pc, h = void 0, d.digits = "", g.querySelectorAll(xc).forEach((e) => e.checked = !1), E(), j()) : e.value === "defaulted" ? (m = mc, h = void 0, g.querySelectorAll(xc).forEach((e) => e.checked = !1), E()) : e.value === "empty" || D(e.value);
			}, C.appendChild(t);
		});
		let M = (e) => {
			if (e.key >= "0" && e.key <= "9") e.preventDefault(), D(Number.parseInt(e.key));
			else if (e.key === "Backspace" || e.key === "Delete") e.preventDefault(), O();
			else if (e.key === "-" || e.key === " " || e.key === "/") e.preventDefault(), D("-");
			else if (e.key === ")") {
				e.preventDefault();
				let t = w(d.digits);
				t.includes("(") && !t.includes(")") && (d.digits += "-", E());
			}
		};
		n.setAttribute("tabindex", "-1"), n.style.outline = "none", n.addEventListener("keydown", M), setTimeout(() => n.focus(), 100), globalThis.cleanupDialPad = () => {
			n.removeEventListener("keydown", M);
		};
		let N = u === fc || u === pc || u === mc || u === hc || u === gc;
		N ? (u === hc ? (m = pc, h = void 0) : u === gc ? (m = mc, h = void 0) : (m = u, h = c), g.querySelectorAll(bc).forEach((e) => {
			e.value === m && (e.checked = !0);
		}), h && (g.querySelectorAll(xc).forEach((e) => {
			Number.parseInt(e.value) === h && (e.checked = !0);
		}), v.style.display = "block")) : !s && (!u || u === "TO_BE_PLAYED") && k(), d.digits || N ? (E(), setTimeout(() => {
			let e = document.getElementById("clearScoreV2");
			e && (e.disabled = !1), j();
		}, 0)) : (T(null), j());
	} catch (e) {
		console.error("Error rendering dial pad:", e), n.innerHTML = `<p style="color: red;">Error: ${e instanceof Error ? e.message : "Unknown error"}</p>`;
	}
}
//#endregion
//#region src/tools/freeScore/freeScore.ts
var { RETIRED: wc, WALKOVER: Tc, DEFAULTED: Ec, SUSPENDED: Dc, CANCELLED: Oc, INCOMPLETE: kc, DEAD_RUBBER: Ac, IN_PROGRESS: jc, AWAITING_RESULT: Mc } = u, J = /* @__PURE__ */ function(e) {
	return e.START = "START", e.PARSING_SIDE1 = "PARSING_SIDE1", e.PARSING_SIDE2 = "PARSING_SIDE2", e.PARSING_TIEBREAK_SIDE1 = "PARSING_TIEBREAK_SIDE1", e.PARSING_TIEBREAK_SIDE2 = "PARSING_TIEBREAK_SIDE2", e.SET_COMPLETE = "SET_COMPLETE", e.MATCH_COMPLETE = "MATCH_COMPLETE", e.ERROR = "ERROR", e;
}({});
function Nc(e, t) {
	let n = e.substring(t).trim().toLowerCase();
	return /^in(\s+p(rog(ress)?)?)?$/i.exec(n) ? {
		ending: jc,
		endPos: e.length
	} : /^inc(omp(lete?)?)?/i.exec(n) ? {
		ending: kc,
		endPos: e.length
	} : /^(dr|dead(\s*r(ubber)?)?)/i.exec(n) ? {
		ending: Ac,
		endPos: e.length
	} : /^r(et(ired?)?)?/i.exec(n) ? {
		ending: wc,
		endPos: e.length
	} : /^(w(\/o|o|alk(over?)?)?)/i.exec(n) ? {
		ending: Tc,
		endPos: e.length
	} : /^d(ef(aulted?)?)?/i.exec(n) ? {
		ending: Ec,
		endPos: e.length
	} : /^s(usp(ended?)?)?/i.exec(n) ? {
		ending: Dc,
		endPos: e.length
	} : /^c(anc(ell?ed?)?)?/i.exec(n) ? {
		ending: Oc,
		endPos: e.length
	} : /^a(wait(ing(\s*r(esult)?)?)?)?/i.exec(n) ? {
		ending: Mc,
		endPos: e.length
	} : { endPos: t };
}
function Pc(e, t) {
	return t === (e.bestOf || 3) - 1 && e.finalSetFormat ? e.finalSetFormat : e.setFormat;
}
function Fc(e) {
	return !!e?.tiebreakSet?.tiebreakTo && !e?.setTo;
}
function Ic(e) {
	return Fc(e) ? 0 : (e?.setTo || 6) + 1;
}
function Lc(e) {
	let t = e?.tiebreakSet, n = e?.tiebreakFormat;
	return t ? t.tiebreakTo || 10 : n && n.tiebreakTo || 7;
}
function Rc(e) {
	return e >= "0" && e <= "9";
}
function zc(e) {
	for (let t of e) if (!Rc(t)) return !1;
	return !0;
}
function Bc(e) {
	return !Rc(e) && !Vc(e) && !Hc(e);
}
function Vc(e) {
	return e === "(" || e === "[";
}
function Hc(e) {
	return e === ")" || e === "]";
}
function Uc(e, t, n) {
	let r = n?.tiebreakAt || n?.setTo || 6;
	return e === r && t === r;
}
function Wc(e, t, n) {
	let r = n?.setTo || 6, i = Math.max(e, t);
	return i < r ? !1 : i - Math.min(e, t) >= 2 ? !0 : (r + 1, !1);
}
function Gc(e, t, n) {
	let r = Lc(n), i = Math.max(e, t), a = Math.min(e, t);
	return n?.tiebreakSet?.NoAD || n?.tiebreakFormat?.NoAD ? i >= r : i < r ? !1 : i - a >= 2;
}
function Kc(e, t) {
	let n = e === "1-0" ? 1 : 0, r = e === "0-1" ? 1 : 0;
	return {
		side1TiebreakScore: n,
		side2TiebreakScore: r,
		setNumber: t,
		winningSide: n > r ? 1 : 2
	};
}
function qc(e, t, n) {
	let r = e.indexOf("-");
	if (r === -1) return n.push({
		position: 0,
		message: `Set ${t}: Invalid format "${e}". Expected "#-#" (e.g., "5-3")`,
		expected: "#-#",
		got: e
	}), null;
	let i = e.slice(0, r), a = e.slice(r + 1);
	return !i || !a || !zc(i) || !zc(a) ? (n.push({
		position: 0,
		message: `Set ${t}: Invalid format "${e}". Expected "#-#" (e.g., "5-3")`,
		expected: "#-#",
		got: e
	}), null) : {
		side1Score: Number.parseInt(i, 10),
		side2Score: Number.parseInt(a, 10),
		setNumber: t
	};
}
function Jc(e, t, n) {
	let r = e.indexOf("-");
	if (r === -1) return n.push({
		position: 0,
		message: `Final set: Invalid format "${e}". Expected TB format "1-0" or "0-1", or regular "#-#"`,
		expected: "1-0, 0-1, or #-#",
		got: e
	}), null;
	let i = e.slice(0, r), a = e.slice(r + 1);
	return !i || !a || !zc(i) || !zc(a) ? (n.push({
		position: 0,
		message: `Final set: Invalid format "${e}". Expected TB format "1-0" or "0-1", or regular "#-#"`,
		expected: "1-0, 0-1, or #-#",
		got: e
	}), null) : {
		side1Score: Number.parseInt(i, 10),
		side2Score: Number.parseInt(a, 10),
		setNumber: t
	};
}
function Yc(e, t) {
	return e.slice(0, t).reduce((e, t) => (e.side1 += t.side1Score || 0, e.side2 += t.side2Score || 0, e), {
		side1: 0,
		side2: 0
	});
}
function Xc(e, t, n) {
	let r = e.filter((e) => e.side1Score !== void 0), i = e.some((e) => e.side1TiebreakScore !== void 0);
	if (r.length < t) return;
	let a = Yc(r, t), o = a.side1 === a.side2, s = r.length > t;
	if (o && !i) if (s) {
		let e = r[t];
		n.push({
			position: 0,
			message: `Aggregate tied (${a.side1}-${a.side2}). Final set score "${e.side1Score}-${e.side2Score}" invalid. TB1 only accepts "1-0" or "0-1"`
		});
	} else n.push({
		position: 0,
		message: `Aggregate tied (${a.side1}-${a.side2}), final TB required`
	});
	else !o && i ? n.push({
		position: 0,
		message: `Aggregate not tied (${a.side1}-${a.side2}), final TB not allowed`
	}) : !o && s && n.push({
		position: 0,
		message: `Aggregate not tied (${a.side1}-${a.side2}), extra sets not allowed`
	});
}
function Zc(e, t, n, r) {
	let i = [];
	for (let a = 0; a < e.length; a++) {
		let o = e[a], s = a + 1, c = s === n, l = o === "1-0" || o === "0-1";
		if (t && c && l) i.push(Kc(o, s));
		else if (t && c && !l) {
			let e = Jc(o, s, r);
			e && i.push(e);
		} else {
			let e = qc(o, s, r);
			e && i.push(e);
		}
	}
	return i;
}
function Qc(e, t) {
	return {
		valid: !1,
		formattedScore: "",
		sets: [],
		confidence: 1,
		errors: [],
		warnings: [],
		ambiguities: [],
		suggestions: e ? [`Enter ${t - 1} timed sets (final TB only if tied)`] : [`Enter ${t} sets in format: #-# #-# ...`],
		incomplete: !0,
		matchComplete: !1
	};
}
function $c(e, t, n, r, i) {
	if (e > n) {
		let a = r ? `${t}-${n}` : `${n}`;
		i.push({
			position: 0,
			message: `Too many sets: got ${e}, expected ${a}`
		});
	}
}
function el(e, t, n, r, i) {
	if (!e) return [];
	if (t) {
		let e = n - r;
		return [`Enter ${e} more timed set${e === 1 ? "" : "s"} (or final TB if aggregate tied)`];
	}
	let a = i - r;
	return [`Need ${a} more set${a === 1 ? "" : "s"}`];
}
function tl(e) {
	return e.map((e) => e.side1TiebreakScore === void 0 ? `${e.side1Score}-${e.side2Score}` : `${e.side1TiebreakScore}-${e.side2TiebreakScore}`).join(" ");
}
function nl(e, t) {
	let n = t.exactly || t.bestOf || 1, r = e.trim(), i = !!t?.aggregate, a = t.finalSetFormat?.tiebreakSet?.tiebreakTo !== void 0, o = i && a;
	if (!r) return Qc(o, n);
	let s = r.split(/\s+/), c = [], l = o ? n - 1 : n, u = Zc(s, o, n, c);
	o && c.length === 0 && Xc(u, l, c);
	let d = o ? l : n, f = n;
	$c(u.length, d, f, o, c);
	let p = u.length < d && c.length === 0, m = (u.length === n || o && u.length === l) && c.length === 0, h = tl(u);
	return {
		valid: c.length === 0 && (u.length === d || u.length === f),
		formattedScore: h,
		sets: u,
		confidence: c.length === 0 ? 1 : 0,
		errors: c,
		warnings: [],
		ambiguities: [],
		suggestions: el(p, o, d, u.length, n),
		incomplete: p,
		matchComplete: m
	};
}
function rl(e, t) {
	let n = typeof t == "string" ? l.parse(t) : t;
	if (!n) return {
		valid: !1,
		formattedScore: "",
		sets: [],
		confidence: 0,
		errors: [{
			position: 0,
			message: "Invalid matchUpFormat"
		}],
		warnings: [],
		ambiguities: [],
		suggestions: [],
		incomplete: !1,
		matchComplete: !1
	};
	let r = !!(n.setFormat?.timed || n.finalSetFormat?.timed), i = !!n.exactly || n.bestOf === 1;
	if (r && i) return nl(e, n);
	let a = {
		input: e,
		position: 0,
		setIndex: 0,
		currentSide1Buffer: "",
		currentSide2Buffer: "",
		currentTiebreakSide1Buffer: "",
		currentTiebreakSide2Buffer: "",
		sets: [],
		parsedFormat: n,
		state: J.START,
		inTiebreak: !1,
		expectingTiebreakOnly: !1,
		isValid: !0,
		errors: [],
		warnings: [],
		confidence: 1,
		ambiguities: [],
		suggestions: []
	};
	for (Fc(Pc(n, 0)) ? (a.expectingTiebreakOnly = !0, a.inTiebreak = !0, a.state = J.PARSING_TIEBREAK_SIDE1) : a.state = J.PARSING_SIDE1; a.position < e.length && a.isValid;) il(a);
	wl(a);
	let o = a.sets, s;
	a.irregularEnding && (s = a.irregularEnding, (a.irregularEnding === Tc || a.irregularEnding === Oc || a.irregularEnding === Ac) && (o = []));
	let c = a.irregularEnding ? !1 : Tl(a), u = El(a);
	return {
		valid: a.isValid && a.errors.length === 0,
		formattedScore: u,
		sets: o,
		confidence: a.confidence,
		errors: a.errors,
		warnings: a.warnings,
		ambiguities: a.ambiguities,
		suggestions: a.suggestions,
		incomplete: !c && o.length > 0,
		matchComplete: c,
		matchUpStatus: s
	};
}
function il(e) {
	let t = e.input[e.position];
	if (!Rc(t) && !Vc(t) && !Hc(t)) {
		let t = Nc(e.input, e.position);
		if (t.ending) {
			e.irregularEnding = t.ending, e.irregularEndingPosition = e.position, e.position = t.endPos;
			return;
		}
	}
	if (Bc(t)) {
		al(e);
		return;
	}
	if (Vc(t)) {
		ol(e);
		return;
	}
	if (Hc(t)) {
		sl(e);
		return;
	}
	if (Rc(t)) {
		cl(e, t);
		return;
	}
	e.errors.push({
		position: e.position,
		message: `Unexpected character '${t}'`,
		got: t,
		context: Dl(e)
	}), e.isValid = !1;
}
function al(e) {
	if (e.state === J.PARSING_SIDE1 && e.currentSide1Buffer) {
		e.state = J.PARSING_SIDE2, e.position++;
		return;
	}
	if (e.state === J.PARSING_SIDE2 && e.currentSide2Buffer) {
		if (yl(Number.parseInt(e.currentSide1Buffer), Number.parseInt(e.currentSide2Buffer), Pc(e.parsedFormat, e.setIndex))) {
			e.inTiebreak = !0, e.state = J.PARSING_TIEBREAK_SIDE1, e.position++;
			return;
		}
		Sl(e), e.position++;
		return;
	}
	if (e.state === J.PARSING_TIEBREAK_SIDE1 && e.currentTiebreakSide1Buffer) if (e.currentSide1Buffer && e.currentSide2Buffer) {
		Sl(e), e.position++;
		return;
	} else {
		e.state = J.PARSING_TIEBREAK_SIDE2, e.position++;
		return;
	}
	e.position++;
}
function ol(e) {
	let t = Pc(e.parsedFormat, e.setIndex);
	if (Fc(t)) {
		e.inTiebreak = !0, e.state = J.PARSING_TIEBREAK_SIDE1, e.position++;
		return;
	}
	if (e.currentSide1Buffer && e.currentSide2Buffer && Uc(Number.parseInt(e.currentSide1Buffer), Number.parseInt(e.currentSide2Buffer), t)) {
		e.inTiebreak = !0, e.state = J.PARSING_TIEBREAK_SIDE1, e.position++;
		return;
	}
	e.warnings.push(`Tiebreak indicator at position ${e.position} may be ambiguous`), e.inTiebreak = !0, e.state = J.PARSING_TIEBREAK_SIDE1, e.position++;
}
function sl(e) {
	if (e.inTiebreak) {
		Cl(e), e.inTiebreak = !1, e.position++;
		return;
	}
	e.warnings.push(`Unexpected tiebreak closer at position ${e.position}`), e.position++;
}
function cl(e, t) {
	let n = Pc(e.parsedFormat, e.setIndex);
	e.inTiebreak ? hl(e, t, n) : fl(e, t, n);
}
function ll(e, t, n) {
	return Number.parseInt(e + t) > n;
}
function ul(e, t, n) {
	e.state = J.PARSING_SIDE1, e.currentSide1Buffer += t;
	let r = Number.parseInt(e.currentSide1Buffer), i = e.position + 1;
	if (i < e.input.length && Rc(e.input[i])) {
		let t = e.input[i];
		ll(e.currentSide1Buffer, t, n) && (e.warnings.push(`Potential score issue: "${e.currentSide1Buffer}${t}" would exceed max game score ${n}`), e.state = J.PARSING_SIDE2);
	} else e.state = J.PARSING_SIDE2;
	r > n && e.warnings.push(`Score ${r} exceeds max ${n} at position ${e.position}`), e.position++;
}
function dl(e, t, n, r) {
	e.currentSide2Buffer += t;
	let i = Number.parseInt(e.currentSide1Buffer), a = Number.parseInt(e.currentSide2Buffer);
	if (yl(i, a, n)) {
		e.inTiebreak = !0, e.state = J.PARSING_TIEBREAK_SIDE1, e.position++;
		return;
	}
	let o = e.position + 1;
	if (o < e.input.length && Rc(e.input[o])) {
		let t = e.input[o];
		ll(e.currentSide2Buffer, t, r) && (Wc(i, a, n) || Uc(i, a, n) || e.warnings.push(`Set ${e.setIndex + 1} may be incomplete: ${i}-${a}`), Sl(e));
	}
	e.position++;
}
function fl(e, t, n) {
	let r = Ic(n);
	if (e.state === J.PARSING_SIDE1 || e.state === J.START) {
		ul(e, t, r);
		return;
	}
	if (e.state === J.PARSING_SIDE2) {
		dl(e, t, n, r);
		return;
	}
	e.position++;
}
function pl(e, t) {
	e.currentTiebreakSide1Buffer += t, e.position++;
}
function ml(e, t, n) {
	e.currentTiebreakSide2Buffer += t;
	let r = Number.parseInt(e.currentTiebreakSide2Buffer), i = e.position + 1;
	if (i < e.input.length && Rc(e.input[i])) {
		let t = e.input[i], a = Number.parseInt(e.currentTiebreakSide2Buffer + t), o = Number.parseInt(e.currentTiebreakSide1Buffer);
		if (a > 999) {
			let t = r;
			Gc(o, t, n) || e.warnings.push(`Tiebreak may be incomplete: ${o}-${t}`), Sl(e);
		}
	}
	e.position++;
}
function hl(e, t, n) {
	if (e.state === J.PARSING_TIEBREAK_SIDE1) {
		pl(e, t);
		return;
	}
	if (e.state === J.PARSING_TIEBREAK_SIDE2) {
		ml(e, t, n);
		return;
	}
	e.position++;
}
function gl(e) {
	if (!e.currentTiebreakSide1Buffer || !e.currentTiebreakSide2Buffer) return null;
	let t = Number.parseInt(e.currentTiebreakSide1Buffer), n = Number.parseInt(e.currentTiebreakSide2Buffer);
	return {
		side1Score: 0,
		side2Score: 0,
		side1TiebreakScore: t,
		side2TiebreakScore: n,
		setNumber: e.setIndex + 1,
		winningSide: t > n ? 1 : 2
	};
}
function _l(e, t, n) {
	let r = t.currentTiebreakSide1Buffer, i = t.currentTiebreakSide2Buffer;
	r && i ? (e.side1TiebreakScore = Number.parseInt(r), e.side2TiebreakScore = Number.parseInt(i)) : (r || i) && vl(e, r, i, n);
}
function vl(e, t, n, r) {
	let i = Number.parseInt(t || n), a = Lc(r), o = r?.tiebreakFormat?.NoAD ? a : Math.max(a, i + 2);
	e.side1Score > e.side2Score ? (e.side1TiebreakScore = o, e.side2TiebreakScore = i) : (e.side1TiebreakScore = i, e.side2TiebreakScore = o);
}
function yl(e, t, n) {
	let r = n.tiebreakAt || n.setTo || 6;
	return e === r && t === r + 1 || t === r && e === r + 1;
}
function bl(e, t) {
	if (!e.currentSide1Buffer || !e.currentSide2Buffer) return null;
	let n = Number.parseInt(e.currentSide1Buffer), r = Number.parseInt(e.currentSide2Buffer);
	if (yl(n, r, t) && !e.currentTiebreakSide1Buffer && !e.currentTiebreakSide2Buffer) return null;
	let i = {
		side1Score: n,
		side2Score: r,
		setNumber: e.setIndex + 1
	};
	return (e.currentTiebreakSide1Buffer || e.currentTiebreakSide2Buffer) && _l(i, e, t), n > r ? i.winningSide = 1 : r > n && (i.winningSide = 2), i;
}
function xl(e) {
	e.currentSide1Buffer = "", e.currentSide2Buffer = "", e.currentTiebreakSide1Buffer = "", e.currentTiebreakSide2Buffer = "", e.setIndex++, e.inTiebreak = !1, e.state = J.PARSING_SIDE1, Fc(Pc(e.parsedFormat, e.setIndex)) && (e.expectingTiebreakOnly = !0, e.inTiebreak = !0, e.state = J.PARSING_TIEBREAK_SIDE1);
}
function Sl(e) {
	let t = Pc(e.parsedFormat, e.setIndex), n = Fc(t) ? gl(e) : bl(e, t);
	n && e.sets.push(n), xl(e);
}
function Cl(e) {
	Sl(e);
}
function wl(e) {
	(e.currentSide1Buffer || e.currentSide2Buffer || e.currentTiebreakSide1Buffer || e.currentTiebreakSide2Buffer) && Sl(e);
}
function Tl(e) {
	let t = e.parsedFormat.bestOf || 3, n = Math.ceil(t / 2), r = e.sets.filter((e) => e.winningSide === 1).length, i = e.sets.filter((e) => e.winningSide === 2).length;
	return r >= n || i >= n;
}
function El(e) {
	let t = [];
	for (let n of e.sets) if ((!n.side1Score || n.side1Score === 0) && (!n.side2Score || n.side2Score === 0) && (n.side1TiebreakScore !== void 0 || n.side2TiebreakScore !== void 0)) {
		let e = n.side1TiebreakScore ?? 0, r = n.side2TiebreakScore ?? 0;
		t.push(`[${e}-${r}]`);
	} else {
		let e = `${n.side1Score || 0}-${n.side2Score || 0}`;
		if (n.side1TiebreakScore !== void 0 || n.side2TiebreakScore !== void 0) {
			let t = n.side1TiebreakScore ?? 0, r = n.side2TiebreakScore ?? 0, i = n.winningSide === 1 ? r : t;
			e += `(${i})`;
		}
		t.push(e);
	}
	return t.join(" ");
}
function Dl(e) {
	let t = Math.max(0, e.position - 5), n = Math.min(e.input.length, e.position + 5), r = e.input.substring(t, e.position), i = e.input.substring(e.position + 1, n);
	return `...${r}[${e.input[e.position]}]${i}...`;
}
//#endregion
//#region src/components/scoring/utils/scoreFormatters.ts
var { RETIRED: Ol, WALKOVER: kl, DEFAULTED: Al, DOUBLE_WALKOVER: jl, DOUBLE_DEFAULT: Ml, SUSPENDED: Nl, CANCELLED: Pl, INCOMPLETE: Fl, DEAD_RUBBER: Il, IN_PROGRESS: Ll, AWAITING_RESULT: Rl, COMPLETED: zl, TO_BE_PLAYED: Bl } = u;
function Vl(e, t) {
	let n = "";
	if (e && (n = (e.sets || []).map((e) => {
		let t = `${e.side1Score || 0}-${e.side2Score || 0}`;
		if (e.side1TiebreakScore !== void 0 || e.side2TiebreakScore !== void 0) {
			let n = e.winningSide === 1 ? e.side2TiebreakScore : e.side1TiebreakScore;
			t += `(${n})`;
		}
		return t;
	}).join(" ")), t && t !== zl && t !== Bl) {
		let e = Hl(t);
		if (e) return n ? `${n} ${e}` : e;
	}
	return n;
}
function Hl(e) {
	return {
		[Ol]: "ret",
		[kl]: "wo",
		[Al]: "def",
		[jl]: "wo",
		[Ml]: "def",
		[Nl]: "susp",
		[Pl]: "canc",
		[Fl]: "inc",
		[Il]: "dr",
		[Ll]: "in",
		[Rl]: "await"
	}[e] || "";
}
//#endregion
//#region src/components/scoring/approaches/freeScoreApproach.ts
var { RETIRED: Ul, WALKOVER: Wl, DEFAULTED: Gl, SUSPENDED: Kl, CANCELLED: ql, INCOMPLETE: Jl, DEAD_RUBBER: Yl, IN_PROGRESS: Xl, AWAITING_RESULT: Zl, DOUBLE_WALKOVER: Ql, DOUBLE_DEFAULT: $l } = u, eu = "var(--chc-status-success)";
function tu(e) {
	let { matchUp: t, container: n, onScoreChange: r, labels: i = {} } = e;
	n.innerHTML = "", n.style.display = "flex", n.style.flexDirection = "column", n.style.gap = "1em";
	let a = t?.sides?.find((e) => e.sideNumber === 1), o = t?.sides?.find((e) => e.sideNumber === 2), s = t.score ? { ...t.score } : void 0, c = t.winningSide, d = t.matchUpStatus, f = document.createElement("div");
	f.style.marginBottom = "0.25em", n.appendChild(f);
	let p = document.createElement("div");
	p.style.display = "none", p.style.marginTop = "0.25em", p.style.padding = "0.35em 0.5em", p.style.backgroundColor = "var(--chc-bg-secondary)", p.style.borderRadius = "4px", p.style.flexDirection = "column", p.style.gap = "0.35em";
	let m = document.createElement("label");
	m.style.display = "flex", m.style.alignItems = "center", m.style.gap = "0.4em", m.style.cursor = "pointer";
	let h = document.createElement("input");
	h.type = "radio", h.name = "winnerSelection", h.value = "1";
	let g = document.createElement("span");
	g.textContent = a?.participant?.participantName || "Side 1", g.style.fontSize = "0.75em", m.appendChild(h), m.appendChild(g);
	let _ = document.createElement("label");
	_.style.display = "flex", _.style.alignItems = "center", _.style.gap = "0.4em", _.style.cursor = "pointer";
	let v = document.createElement("input");
	v.type = "radio", v.name = "winnerSelection", v.value = "2";
	let y = document.createElement("span");
	y.textContent = o?.participant?.participantName || "Side 2", y.style.fontSize = "0.75em", _.appendChild(v), _.appendChild(y), p.appendChild(m), p.appendChild(_), n.appendChild(p);
	let b = (e) => {
		let { WALKOVER: n, CANCELLED: r, DEAD_RUBBER: i } = u, a = [
			n,
			r,
			i
		], o = e?.matchUpStatus && a.includes(e.matchUpStatus), l;
		e?.clearAll || o ? (l = void 0, s = void 0) : e?.scoreObject ? (l = e.scoreObject, s = e.scoreObject) : l = s, e?.clearAll ? (c = void 0, d = void 0) : e != null && ("winningSide" in e && (c = e.winningSide), "matchUpStatus" in e && (d = e.matchUpStatus));
		let p = {
			...t,
			score: l,
			winningSide: c,
			matchUpStatus: d
		};
		f.innerHTML = "";
		let m = oi({
			matchUp: p,
			isLucky: !0,
			composition: yi[hs().composition || "Australian"] || yi.Australian
		});
		f.appendChild(m);
	};
	if (b(), t.matchUpFormat) {
		let e = document.createElement("div");
		e.style.fontSize = "0.9em", e.style.marginBottom = "0.5em", e.style.display = "flex", e.style.alignItems = "center", e.style.gap = "0.5em";
		let r = document.createElement("span");
		r.textContent = (i.format || "Format") + ":", r.style.color = "var(--chc-text-secondary)", e.appendChild(r);
		let a = document.createElement("button");
		a.textContent = t.matchUpFormat, a.className = "button is-small is-white", a.style.fontSize = "0.75em", a.style.padding = "0.2em 0.5em", a.style.cursor = "pointer", a.title = "Click to edit format", a.addEventListener("click", () => {
			try {
				Ra({
					existingMatchUpFormat: t.matchUpFormat,
					callback: (e) => {
						if (e && e !== t.matchUpFormat) {
							t.matchUpFormat = e, a.textContent = e;
							let n = document.getElementById("scoreInputV2");
							n && (n.value = "", n.dispatchEvent(new Event("input", { bubbles: !0 }))), T.textContent = "Score cleared - format changed", T.style.color = "var(--chc-text-muted)";
						}
					},
					modalConfig: { style: {
						fontSize: "12px",
						border: "3px solid #0066cc"
					} }
				});
			} catch (e) {
				console.error("[FreeScore] Error opening format selector:", e);
			}
		}), e.appendChild(a), n.appendChild(e);
	}
	let x = document.createElement("div");
	x.style.display = "flex", x.style.alignItems = "center", x.style.gap = "0.5em";
	let S = document.createElement("input");
	S.type = "text", S.className = "input", S.placeholder = "", S.style.flex = "1", S.id = "scoreInputV2", s && (S.value = Vl(s, d));
	let C = document.createElement("span");
	C.style.fontSize = "1.2em", C.style.minWidth = "1.5em", x.appendChild(S), x.appendChild(C), n.appendChild(x);
	let w = document.createElement("div");
	w.style.fontSize = "0.9em", w.style.color = "var(--chc-border-focus)", w.style.fontFamily = "monospace", w.style.minHeight = "1.5em", w.style.padding = "0.25em", n.appendChild(w);
	let T = document.createElement("div");
	T.style.fontSize = "0.9em", T.style.minHeight = "1.5em", n.appendChild(T);
	let E = c, D = () => {
		h.checked ? (E = 1, m.style.fontWeight = "bold", m.style.color = eu, _.style.fontWeight = "", _.style.color = "") : v.checked && (E = 2, _.style.fontWeight = "bold", _.style.color = eu, m.style.fontWeight = "", m.style.color = ""), M();
	};
	h.addEventListener("change", D), v.addEventListener("change", D);
	function O() {
		p.style.display = "none", h.checked = !1, v.checked = !1, m.style.fontWeight = "", m.style.color = "", _.style.fontWeight = "", _.style.color = "", E = void 0;
	}
	let k = {
		[Ul]: i.retired || "RETIRED",
		[Wl]: i.walkover || "WALKOVER",
		[Gl]: i.defaulted || "DEFAULTED",
		[Kl]: "SUSPENDED",
		[ql]: "CANCELLED",
		[Jl]: "INCOMPLETE",
		[Yl]: "DEAD RUBBER",
		[Xl]: "IN PROGRESS",
		[Zl]: "AWAITING RESULT"
	};
	function A(e) {
		let t = i.validScore || "Valid score", n = e && k[e];
		return n ? `${t} - ${n}` : t;
	}
	function j(e, t, n) {
		let i = e.matchUpStatus || t.matchUpStatus, a = [
			Ul,
			Wl,
			Gl
		].includes(i), o = [
			ql,
			Yl,
			Zl,
			Jl,
			Xl,
			Kl
		].includes(i);
		if (a) {
			p.style.display = "flex";
			let a = E;
			if (!a) {
				r(i === Wl ? {
					...e,
					isValid: !0,
					matchUpStatus: Ql,
					score: t.formattedScore || n
				} : i === Gl ? {
					...e,
					isValid: !0,
					matchUpStatus: $l,
					score: t.formattedScore || n
				} : {
					...e,
					isValid: !1,
					error: "Winner must be selected for irregular ending",
					matchUpStatus: i,
					score: t.formattedScore || n
				});
				return;
			}
			return a;
		}
		if (o) {
			O();
			return;
		}
		return O(), e.winningSide;
	}
	let M = () => {
		let e = S.value.trim();
		if (!e) {
			C.textContent = "", w.textContent = "", T.textContent = "", T.style.color = "", O(), b({ clearAll: !0 }), r({
				isValid: !1,
				sets: [],
				matchUpStatus: "TO_BE_PLAYED"
			});
			return;
		}
		let n = rl(e, t.matchUpFormat);
		w.textContent = n.formattedScore || "";
		let i = new Set([
			Ul,
			Wl,
			Gl,
			Kl,
			ql,
			Jl,
			Yl,
			Xl,
			Zl
		]), a = n.matchUpStatus && i.has(n.matchUpStatus), o = n.formattedScore ? Ts(n.formattedScore, t.matchUpFormat, n.matchUpStatus) : {
			isValid: !1,
			sets: [],
			error: "No score to validate"
		}, s = o.sets && o.sets.length > 0, c = E || o.winningSide;
		if ((s && o.scoreObject || a) && b({
			scoreObject: o.scoreObject,
			winningSide: c,
			matchUpStatus: o.matchUpStatus || n.matchUpStatus
		}), o.isValid || a) if (C.textContent = "✓", C.style.color = eu, T.textContent = A(o.matchUpStatus || n.matchUpStatus), T.style.color = eu, a) {
			let t = j(o, n, e);
			if (t === void 0 && [
				Ul,
				Wl,
				Gl
			].includes(o.matchUpStatus || n.matchUpStatus) && !E) return;
			r({
				...o,
				isValid: !0,
				winningSide: t,
				matchUpStatus: o.matchUpStatus || n.matchUpStatus,
				score: n.formattedScore || e
			});
		} else O(), r({
			...o,
			isValid: !0,
			winningSide: o.winningSide,
			matchUpStatus: o.matchUpStatus || n.matchUpStatus,
			score: n.formattedScore || e
		});
		else !o.isValid && s ? (C.textContent = "⋯", C.style.color = "var(--chc-status-warning)", T.textContent = o.error || "Score incomplete - continue typing", T.style.color = "var(--chc-status-warning)", O(), r(o)) : (C.textContent = "✗", C.style.color = "var(--chc-status-error)", T.textContent = o.error || "Invalid score", T.style.color = "var(--chc-status-error)", O(), b({
			scoreObject: void 0,
			winningSide: void 0,
			matchUpStatus: void 0
		}), r(o));
	}, N = !1;
	S.addEventListener("input", () => {
		M();
		let e = S.value, n = e.trim();
		if (!N && n) {
			let r = rl(n, t.matchUpFormat), i = r.formattedScore ? Ts(r.formattedScore, t.matchUpFormat, r.matchUpStatus) : {
				isValid: !1,
				winningSide: void 0
			}, a = i.isValid && i.winningSide !== void 0, o = e.length > 0 && /[\s-]$/.test(e), s = l.parse(t.matchUpFormat), c = !!s?.exactly || s?.bestOf === 1, u = s?.exactly || s?.bestOf || 3, d = r.sets?.length >= u;
			a && o && (!c || d) && (N = !0);
		} else if (N) {
			let t = e.length > 0 && /[\s-]$/.test(e);
			(n.length === 0 || !t) && (N = !1);
		}
	}), S.addEventListener("keydown", (e) => {
		N && ![
			"Backspace",
			"Delete",
			"ArrowLeft",
			"ArrowRight",
			"Tab"
		].includes(e.key) && e.preventDefault();
	}), S.addEventListener("keyup", (e) => {
		if (e.key === "Enter") {
			let e = document.getElementById("submitScoreV2");
			e && !e.disabled && e.click();
		}
	}), c === 1 ? (h.checked = !0, m.style.fontWeight = "bold", m.style.color = eu) : c === 2 && (v.checked = !0, _.style.fontWeight = "bold", _.style.color = eu), setTimeout(() => {
		S.focus(), d === Ql || d === $l ? (b({
			scoreObject: s,
			winningSide: c,
			matchUpStatus: d
		}), r({
			isValid: !0,
			sets: s?.sets || [],
			scoreObject: s,
			winningSide: c,
			matchUpStatus: d
		})) : (S.value || d && d !== "TO_BE_PLAYED" && d !== "COMPLETED") && M();
	}, 100), globalThis.resetFreeScore = () => {
		S.value = "", s = void 0, c = void 0, d = void 0, C.textContent = "", w.textContent = "", T.textContent = "", T.style.color = "", p.style.display = "none", h.checked = !1, v.checked = !1, m.style.fontWeight = "", m.style.color = "", _.style.fontWeight = "", _.style.color = "", E = void 0, N = !1, b({ clearAll: !0 }), r({
			isValid: !1,
			sets: [],
			matchUpStatus: "TO_BE_PLAYED"
		}), S.focus();
	};
}
//#endregion
//#region src/components/scoring/scoringModal.ts
var nu = "Irregular Endings:", ru = {
	dynamicSets: "Dynamic Sets",
	freeScore: "Free Score",
	dialPad: "Dial Pad",
	inlineScoring: "Inline Scoring"
}, iu = [
	"dynamicSets",
	"freeScore",
	"dialPad",
	"inlineScoring"
];
function au(e) {
	let { matchUp: t, callback: n, onClose: r, labels: i = {} } = e, a = hs().scoringApproach || "dynamicSets", o = !!(t.score?.sets?.length || t.matchUpStatus), s = null, c = !1, l = (e) => {
		s = e, c && (e.sets?.length > 0 || e.score) && (c = !1);
		let t = document.getElementById("submitScoreV2");
		t && (t.disabled = !(a === "inlineScoring" || e.isValid || c && o));
		let n = document.getElementById("clearScoreV2");
		if (n) {
			let t = document.getElementById("scoreInputV2");
			if (t) n.disabled = !t.value.trim();
			else {
				let t = e.sets && e.sets.length > 0, r = e.matchUpStatus && e.matchUpStatus !== "COMPLETED" && e.matchUpStatus !== "TO_BE_PLAYED";
				n.disabled = !(t || r);
			}
		}
	}, u = () => {
		window.cleanupDialPad && (window.cleanupDialPad(), window.cleanupDialPad = void 0), window.resetDialPad && (window.resetDialPad = void 0), window.resetDynamicSets && (window.resetDynamicSets = void 0), window.resetInlineScoring && (window.resetInlineScoring = void 0);
	}, d = (e) => {
		let n = document.createElement("div");
		return n.style.padding = "1em", e === "freeScore" ? tu({
			matchUp: t,
			container: n,
			onScoreChange: l,
			labels: i
		}) : e === "dynamicSets" ? ic({
			matchUp: t,
			container: n,
			onScoreChange: l,
			labels: i
		}) : e === "dialPad" ? Cc({
			matchUp: t,
			container: n,
			onScoreChange: l,
			labels: i
		}) : e === "inlineScoring" && ys({
			matchUp: t,
			container: n,
			onScoreChange: l,
			labels: i
		}), n;
	}, f = {
		freeScore: `
    <strong>${i.scoreTips || "Score Entry Tips:"}</strong><br><br>
    <strong>${i.setScores || "Set Scores:"}</strong> Space or dash-separated (e.g., "6-4 6-3")<br><br>
    <strong>${i.tiebreaks || "Tiebreaks:"}</strong> Auto-detected from digits (e.g., "67 3" becomes "6-7(3)")<br><br>
    <strong>${i.matchTiebreaks || "Match Tiebreaks:"}</strong> Use dash separator (e.g., "10-7")<br><br>
    <strong>${i.irregularEndings || nu}</strong><br>
    <strong>r</strong> = ${i.retired || "Retired"}<br>
    <strong>w</strong> = ${i.walkover || "Walkover"}<br>
    <strong>d</strong> = ${i.defaulted || "Defaulted"}<br>
    <strong>s</strong> = Suspended<br>
    <strong>c</strong> = Cancelled<br>
    <strong>a</strong> = Awaiting Result<br>
    <strong>in</strong> = In Progress<br>
    <strong>inc</strong> = Incomplete<br>
    <strong>dr</strong> = Dead Rubber
  `,
		dynamicSets: `
    <strong>${i.dynamicSetsTips || "Dynamic Sets Scoring:"}</strong><br><br>
    Enter scores set by set using individual inputs.<br><br>
    <strong>${i.tiebreaks || "Tiebreaks:"}</strong> Enter tiebreak score in the TB field when a set is tied<br><br>
    <strong>${i.irregularEndings || nu}</strong> Click Retired, Walkover, Default.
  `,
		dialPad: `
    <strong>${i.dialPadTips || "Dial Pad Scoring:"}</strong><br><br>
    Tap the number buttons to enter scores for each side.<br><br>
    <strong>${i.irregularEndings || nu}</strong> Retired, Walkover, Default available for irregular endings.
  `,
		inlineScoring: "\n    <strong>Inline Scoring:</strong><br><br>\n    Click on <strong>game scores</strong> to add a game for that side.<br><br>\n    Click on <strong>point scores</strong> to award a point.<br><br>\n    Use the <strong>LIVE</strong> pill to set an irregular ending (Retired, Walkover, etc.).<br><br>\n    <strong>Undo/Redo/Clear</strong> buttons control scoring history.\n  "
	}, p = () => iu.map((e) => ({
		label: ru[e],
		active: e === a,
		onClick: () => _(e)
	})), m = () => ({
		info: f[a],
		menu: { menuItems: p() }
	}), h = () => {
		setTimeout(() => {
			let e = document.getElementById("clearScoreV2");
			e && (e.style.backgroundColor = "var(--chc-clear-btn-bg)", e.style.color = "var(--chc-clear-btn-text)", o && (e.disabled = !1)), s && l(s);
		}, 0);
	}, g, _ = (e) => {
		e !== a && (u(), s = null, c = !1, a = e, gs({ scoringApproach: e }), g && (g.update({
			content: d(e),
			config: m()
		}), h()));
	};
	g = R.open({
		title: i.title || "Score Entry",
		content: d(a),
		config: m(),
		buttons: [
			{
				onClick: () => {
					u();
				},
				label: i.cancel || "Cancel",
				intent: "none",
				footer: {
					className: "button",
					style: "background-color: var(--chc-bg-primary); color: var(--chc-text-primary); border: 1px solid var(--chc-border-primary);"
				},
				close: !0
			},
			{
				id: "clearScoreV2",
				label: i.clear || "Clear",
				intent: "none",
				disabled: !0,
				close: !1,
				onClick: () => {
					if (c = !0, a === "freeScore") {
						let e = document.getElementById("scoreInputV2");
						e && (e.value = "", e.dispatchEvent(new Event("input", { bubbles: !0 })), e.focus());
					} else a === "dynamicSets" && window.resetDynamicSets ? window.resetDynamicSets() : a === "dialPad" && window.resetDialPad ? window.resetDialPad() : a === "inlineScoring" && window.resetInlineScoring && window.resetInlineScoring();
				}
			},
			{
				id: "submitScoreV2",
				label: i.submit || "Submit Score",
				intent: "is-primary",
				disabled: a !== "inlineScoring",
				onClick: () => {
					s && (a === "inlineScoring" || s.isValid || c && o) && (u(), n(s));
				},
				close: !0
			}
		],
		onClose: r ? () => r() : void 0
	}), h();
}
//#endregion
//#region node_modules/.pnpm/tabbable@6.4.0/node_modules/tabbable/dist/index.esm.js
var ou = [
	"input:not([inert]):not([inert] *)",
	"select:not([inert]):not([inert] *)",
	"textarea:not([inert]):not([inert] *)",
	"a[href]:not([inert]):not([inert] *)",
	"button:not([inert]):not([inert] *)",
	"[tabindex]:not(slot):not([inert]):not([inert] *)",
	"audio[controls]:not([inert]):not([inert] *)",
	"video[controls]:not([inert]):not([inert] *)",
	"[contenteditable]:not([contenteditable=\"false\"]):not([inert]):not([inert] *)",
	"details>summary:first-of-type:not([inert]):not([inert] *)",
	"details:not([inert]):not([inert] *)"
], su = /* @__PURE__ */ ou.join(","), cu = typeof Element > "u", lu = cu ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, uu = !cu && Element.prototype.getRootNode ? function(e) {
	return e?.getRootNode?.call(e);
} : function(e) {
	return e?.ownerDocument;
}, du = function(e, t) {
	t === void 0 && (t = !0);
	var n = e?.getAttribute?.call(e, "inert");
	return n === "" || n === "true" || t && e && (typeof e.closest == "function" ? e.closest("[inert]") : du(e.parentNode));
}, fu = function(e) {
	var t = e?.getAttribute?.call(e, "contenteditable");
	return t === "" || t === "true";
}, pu = function(e, t, n) {
	if (du(e)) return [];
	var r = Array.prototype.slice.apply(e.querySelectorAll(su));
	return t && lu.call(e, su) && r.unshift(e), r = r.filter(n), r;
}, mu = function(e, t, n) {
	for (var r = [], i = Array.from(e); i.length;) {
		var a = i.shift();
		if (!du(a, !1)) if (a.tagName === "SLOT") {
			var o = a.assignedElements(), s = mu(o.length ? o : a.children, !0, n);
			n.flatten ? r.push.apply(r, s) : r.push({
				scopeParent: a,
				candidates: s
			});
		} else {
			lu.call(a, su) && n.filter(a) && (t || !e.includes(a)) && r.push(a);
			var c = a.shadowRoot || typeof n.getShadowRoot == "function" && n.getShadowRoot(a), l = !du(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(a));
			if (c && l) {
				var u = mu(c === !0 ? a.children : c.children, !0, n);
				n.flatten ? r.push.apply(r, u) : r.push({
					scopeParent: a,
					candidates: u
				});
			} else i.unshift.apply(i, a.children);
		}
	}
	return r;
}, hu = function(e) {
	return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, gu = function(e) {
	if (!e) throw Error("No node provided");
	return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || fu(e)) && !hu(e) ? 0 : e.tabIndex;
}, _u = function(e, t) {
	var n = gu(e);
	return n < 0 && t && !hu(e) ? 0 : n;
}, vu = function(e, t) {
	return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, yu = function(e) {
	return e.tagName === "INPUT";
}, bu = function(e) {
	return yu(e) && e.type === "hidden";
}, xu = function(e) {
	return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(e) {
		return e.tagName === "SUMMARY";
	});
}, Su = function(e, t) {
	for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
}, Cu = function(e) {
	if (!e.name) return !0;
	var t = e.form || uu(e), n = function(e) {
		return t.querySelectorAll("input[type=\"radio\"][name=\"" + e + "\"]");
	}, r;
	if (typeof window < "u" && window.CSS !== void 0 && typeof window.CSS.escape == "function") r = n(window.CSS.escape(e.name));
	else try {
		r = n(e.name);
	} catch (e) {
		return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
	}
	var i = Su(r, e.form);
	return !i || i === e;
}, wu = function(e) {
	return yu(e) && e.type === "radio";
}, Tu = function(e) {
	return wu(e) && !Cu(e);
}, Eu = function(e) {
	var t = e && uu(e), n = t?.host, r = !1;
	if (t && t !== e) {
		var i, a, o;
		for (r = !!((i = n) != null && (a = i.ownerDocument) != null && a.contains(n) || e != null && (o = e.ownerDocument) != null && o.contains(e)); !r && n;) {
			var s, c;
			t = uu(n), n = t?.host, r = !!((s = n) != null && (c = s.ownerDocument) != null && c.contains(n));
		}
	}
	return r;
}, Du = function(e) {
	var t = e.getBoundingClientRect(), n = t.width, r = t.height;
	return n === 0 && r === 0;
}, Ou = function(e, t) {
	var n = t.displayCheck, r = t.getShadowRoot;
	if (n === "full-native" && "checkVisibility" in e) return !e.checkVisibility({
		checkOpacity: !1,
		opacityProperty: !1,
		contentVisibilityAuto: !0,
		visibilityProperty: !0,
		checkVisibilityCSS: !0
	});
	if (getComputedStyle(e).visibility === "hidden") return !0;
	var i = lu.call(e, "details>summary:first-of-type") ? e.parentElement : e;
	if (lu.call(i, "details:not([open]) *")) return !0;
	if (!n || n === "full" || n === "full-native" || n === "legacy-full") {
		if (typeof r == "function") {
			for (var a = e; e;) {
				var o = e.parentElement, s = uu(e);
				if (o && !o.shadowRoot && r(o) === !0) return Du(e);
				e = e.assignedSlot ? e.assignedSlot : !o && s !== e.ownerDocument ? s.host : o;
			}
			e = a;
		}
		if (Eu(e)) return !e.getClientRects().length;
		if (n !== "legacy-full") return !0;
	} else if (n === "non-zero-area") return Du(e);
	return !1;
}, ku = function(e) {
	if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
		if (t.tagName === "FIELDSET" && t.disabled) {
			for (var n = 0; n < t.children.length; n++) {
				var r = t.children.item(n);
				if (r.tagName === "LEGEND") return lu.call(t, "fieldset[disabled] *") ? !0 : !r.contains(e);
			}
			return !0;
		}
		t = t.parentElement;
	}
	return !1;
}, Au = function(e, t) {
	return !(t.disabled || bu(t) || Ou(t, e) || xu(t) || ku(t));
}, ju = function(e, t) {
	return !(Tu(t) || gu(t) < 0 || !Au(e, t));
}, Mu = function(e) {
	var t = parseInt(e.getAttribute("tabindex"), 10);
	return !!(isNaN(t) || t >= 0);
}, Nu = function(e) {
	var t = [], n = [];
	return e.forEach(function(e, r) {
		var i = !!e.scopeParent, a = i ? e.scopeParent : e, o = _u(a, i), s = i ? Nu(e.candidates) : a;
		o === 0 ? i ? t.push.apply(t, s) : t.push(a) : n.push({
			documentOrder: r,
			tabIndex: o,
			item: e,
			isScope: i,
			content: s
		});
	}), n.sort(vu).reduce(function(e, t) {
		return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
	}, []).concat(t);
}, Pu = function(e, t) {
	return t ||= {}, Nu(t.getShadowRoot ? mu([e], t.includeContainer, {
		filter: ju.bind(null, t),
		flatten: !1,
		getShadowRoot: t.getShadowRoot,
		shadowRootFilter: Mu
	}) : pu(e, t.includeContainer, ju.bind(null, t)));
}, Fu = function(e, t) {
	return t ||= {}, t.getShadowRoot ? mu([e], t.includeContainer, {
		filter: Au.bind(null, t),
		flatten: !0,
		getShadowRoot: t.getShadowRoot
	}) : pu(e, t.includeContainer, Au.bind(null, t));
}, Iu = function(e, t) {
	if (t ||= {}, !e) throw Error("No node provided");
	return lu.call(e, su) === !1 ? !1 : ju(t, e);
}, Lu = /* @__PURE__ */ ou.concat("iframe:not([inert]):not([inert] *)").join(","), Ru = function(e, t) {
	if (t ||= {}, !e) throw Error("No node provided");
	return lu.call(e, Lu) === !1 ? !1 : Au(t, e);
};
//#endregion
//#region node_modules/.pnpm/focus-trap@8.0.1/node_modules/focus-trap/dist/focus-trap.esm.js
function zu(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Bu(e) {
	if (Array.isArray(e)) return zu(e);
}
function Vu(e, t, n, r, i, a, o) {
	try {
		var s = e[a](o), c = s.value;
	} catch (e) {
		n(e);
		return;
	}
	s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function Hu(e) {
	return function() {
		var t = this, n = arguments;
		return new Promise(function(r, i) {
			var a = e.apply(t, n);
			function o(e) {
				Vu(a, r, i, o, s, "next", e);
			}
			function s(e) {
				Vu(a, r, i, o, s, "throw", e);
			}
			o(void 0);
		});
	};
}
function Uu(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (!n) {
		if (Array.isArray(e) || (n = ed(e)) || t) {
			n && (e = n);
			var r = 0, i = function() {};
			return {
				s: i,
				n: function() {
					return r >= e.length ? { done: !0 } : {
						done: !1,
						value: e[r++]
					};
				},
				e: function(e) {
					throw e;
				},
				f: i
			};
		}
		throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	var a, o = !0, s = !1;
	return {
		s: function() {
			n = n.call(e);
		},
		n: function() {
			var e = n.next();
			return o = e.done, e;
		},
		e: function(e) {
			s = !0, a = e;
		},
		f: function() {
			try {
				o || n.return == null || n.return();
			} finally {
				if (s) throw a;
			}
		}
	};
}
function Wu(e, t, n) {
	return (t = $u(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Gu(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ku() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function qu(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ju(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? qu(Object(n), !0).forEach(function(t) {
			Wu(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qu(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Yu() {
	var e, t, n = typeof Symbol == "function" ? Symbol : {}, r = n.iterator || "@@iterator", i = n.toStringTag || "@@toStringTag";
	function a(n, r, i, a) {
		var c = r && r.prototype instanceof s ? r : s, l = Object.create(c.prototype);
		return Xu(l, "_invoke", function(n, r, i) {
			var a, s, c, l = 0, u = i || [], d = !1, f = {
				p: 0,
				n: 0,
				v: e,
				a: p,
				f: p.bind(e, 4),
				d: function(t, n) {
					return a = t, s = 0, c = e, f.n = n, o;
				}
			};
			function p(n, r) {
				for (s = n, c = r, t = 0; !d && l && !i && t < u.length; t++) {
					var i, a = u[t], p = f.p, m = a[2];
					n > 3 ? (i = m === r) && (c = a[(s = a[4]) ? 5 : (s = 3, 3)], a[4] = a[5] = e) : a[0] <= p && ((i = n < 2 && p < a[1]) ? (s = 0, f.v = r, f.n = a[1]) : p < m && (i = n < 3 || a[0] > r || r > m) && (a[4] = n, a[5] = r, f.n = m, s = 0));
				}
				if (i || n > 1) return o;
				throw d = !0, r;
			}
			return function(i, u, m) {
				if (l > 1) throw TypeError("Generator is already running");
				for (d && u === 1 && p(u, m), s = u, c = m; (t = s < 2 ? e : c) || !d;) {
					a || (s ? s < 3 ? (s > 1 && (f.n = -1), p(s, c)) : f.n = c : f.v = c);
					try {
						if (l = 2, a) {
							if (s || (i = "next"), t = a[i]) {
								if (!(t = t.call(a, c))) throw TypeError("iterator result is not an object");
								if (!t.done) return t;
								c = t.value, s < 2 && (s = 0);
							} else s === 1 && (t = a.return) && t.call(a), s < 2 && (c = TypeError("The iterator does not provide a '" + i + "' method"), s = 1);
							a = e;
						} else if ((t = (d = f.n < 0) ? c : n.call(r, f)) !== o) break;
					} catch (t) {
						a = e, s = 1, c = t;
					} finally {
						l = 1;
					}
				}
				return {
					value: t,
					done: d
				};
			};
		}(n, i, a), !0), l;
	}
	var o = {};
	function s() {}
	function c() {}
	function l() {}
	t = Object.getPrototypeOf;
	var u = [][r] ? t(t([][r]())) : (Xu(t = {}, r, function() {
		return this;
	}), t), d = l.prototype = s.prototype = Object.create(u);
	function f(e) {
		return Object.setPrototypeOf ? Object.setPrototypeOf(e, l) : (e.__proto__ = l, Xu(e, i, "GeneratorFunction")), e.prototype = Object.create(d), e;
	}
	return c.prototype = l, Xu(d, "constructor", l), Xu(l, "constructor", c), c.displayName = "GeneratorFunction", Xu(l, i, "GeneratorFunction"), Xu(d), Xu(d, i, "Generator"), Xu(d, r, function() {
		return this;
	}), Xu(d, "toString", function() {
		return "[object Generator]";
	}), (Yu = function() {
		return {
			w: a,
			m: f
		};
	})();
}
function Xu(e, t, n, r) {
	var i = Object.defineProperty;
	try {
		i({}, "", {});
	} catch {
		i = 0;
	}
	Xu = function(e, t, n, r) {
		function a(t, n) {
			Xu(e, t, function(e) {
				return this._invoke(t, n, e);
			});
		}
		t ? i ? i(e, t, {
			value: n,
			enumerable: !r,
			configurable: !r,
			writable: !r
		}) : e[t] = n : (a("next", 0), a("throw", 1), a("return", 2));
	}, Xu(e, t, n, r);
}
function Zu(e) {
	return Bu(e) || Gu(e) || ed(e) || Ku();
}
function Qu(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t);
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function $u(e) {
	var t = Qu(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function ed(e, t) {
	if (e) {
		if (typeof e == "string") return zu(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zu(e, t) : void 0;
	}
}
var td = {
	getActiveTrap: function(e) {
		return e?.length > 0 ? e[e.length - 1] : null;
	},
	activateTrap: function(e, t) {
		t !== td.getActiveTrap(e) && td.pauseTrap(e);
		var n = e.indexOf(t);
		n === -1 || e.splice(n, 1), e.push(t);
	},
	deactivateTrap: function(e, t) {
		var n = e.indexOf(t);
		n !== -1 && e.splice(n, 1), td.unpauseTrap(e);
	},
	pauseTrap: function(e) {
		td.getActiveTrap(e)?._setPausedState(!0);
	},
	unpauseTrap: function(e) {
		var t = td.getActiveTrap(e);
		t && !t._isManuallyPaused() && t._setPausedState(!1);
	}
}, nd = function(e) {
	return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, rd = function(e) {
	return e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27;
}, id = function(e) {
	return e?.key === "Tab" || e?.keyCode === 9;
}, ad = function(e) {
	return id(e) && !e.shiftKey;
}, od = function(e) {
	return id(e) && e.shiftKey;
}, sd = function(e) {
	return setTimeout(e, 0);
}, cd = function(e) {
	var t = [...arguments].slice(1);
	return typeof e == "function" ? e.apply(void 0, t) : e;
}, ld = function(e) {
	return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, ud = [], dd = function(e, t) {
	var n = t?.document || document, r = t?.trapStack || ud, i = Ju({
		returnFocusOnDeactivate: !0,
		escapeDeactivates: !0,
		delayInitialFocus: !0,
		isolateSubtrees: !1,
		isKeyForward: ad,
		isKeyBackward: od
	}, t), a = {
		containers: [],
		containerGroups: [],
		tabbableGroups: [],
		adjacentElements: /* @__PURE__ */ new Set(),
		alreadySilent: /* @__PURE__ */ new Set(),
		nodeFocusedBeforeActivation: null,
		mostRecentlyFocusedNode: null,
		active: !1,
		paused: !1,
		manuallyPaused: !1,
		delayInitialFocusTimer: void 0,
		recentNavEvent: void 0
	}, o, s = function(e, t, n) {
		return e && e[t] !== void 0 ? e[t] : i[n || t];
	}, c = function(e, t) {
		var n = typeof t?.composedPath == "function" ? t.composedPath() : void 0;
		return a.containerGroups.findIndex(function(t) {
			var r = t.container, i = t.tabbableNodes;
			return r.contains(e) || n?.includes(r) || i.find(function(t) {
				return t === e;
			});
		});
	}, l = function(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.hasFallback, a = r === void 0 ? !1 : r, o = t.params, s = o === void 0 ? [] : o, c = i[e];
		if (typeof c == "function" && (c = c.apply(void 0, Zu(s))), c === !0 && (c = void 0), !c) {
			if (c === void 0 || c === !1) return c;
			throw Error(`\`${e}\` was specified but was not a node, or did not return a node`);
		}
		var l = c;
		if (typeof c == "string") {
			try {
				l = n.querySelector(c);
			} catch (t) {
				throw Error(`\`${e}\` appears to be an invalid selector; error="${t.message}"`);
			}
			if (!l && !a) throw Error(`\`${e}\` as selector refers to no known node`);
		}
		return l;
	}, u = function() {
		var e = l("initialFocus", { hasFallback: !0 });
		if (e === !1) return !1;
		if (e === void 0 || e && !Ru(e, i.tabbableOptions)) if (c(n.activeElement) >= 0) e = n.activeElement;
		else {
			var t = a.tabbableGroups[0];
			e = t && t.firstTabbableNode || l("fallbackFocus");
		}
		else e === null && (e = l("fallbackFocus"));
		if (!e) throw Error("Your focus-trap needs to have at least one focusable element");
		return e;
	}, d = function() {
		if (a.containerGroups = a.containers.map(function(e) {
			var t = Pu(e, i.tabbableOptions), n = Fu(e, i.tabbableOptions), r = t.length > 0 ? t[0] : void 0, a = t.length > 0 ? t[t.length - 1] : void 0, o = n.find(function(e) {
				return Iu(e);
			}), s = n.slice().reverse().find(function(e) {
				return Iu(e);
			});
			return {
				container: e,
				tabbableNodes: t,
				focusableNodes: n,
				posTabIndexesFound: !!t.find(function(e) {
					return gu(e) > 0;
				}),
				firstTabbableNode: r,
				lastTabbableNode: a,
				firstDomTabbableNode: o,
				lastDomTabbableNode: s,
				nextTabbableNode: function(e) {
					var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, i = t.indexOf(e);
					return i < 0 ? r ? n.slice(n.indexOf(e) + 1).find(function(e) {
						return Iu(e);
					}) : n.slice(0, n.indexOf(e)).reverse().find(function(e) {
						return Iu(e);
					}) : t[i + (r ? 1 : -1)];
				}
			};
		}), a.tabbableGroups = a.containerGroups.filter(function(e) {
			return e.tabbableNodes.length > 0;
		}), a.tabbableGroups.length <= 0 && !l("fallbackFocus")) throw Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
		if (a.containerGroups.find(function(e) {
			return e.posTabIndexesFound;
		}) && a.containerGroups.length > 1) throw Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
	}, f = function(e) {
		var t = e.activeElement;
		if (t) return t.shadowRoot && t.shadowRoot.activeElement !== null ? f(t.shadowRoot) : t;
	}, p = function(e) {
		if (e !== !1 && e !== f(document)) {
			if (!e || !e.focus) {
				p(u());
				return;
			}
			e.focus({ preventScroll: !!i.preventScroll }), a.mostRecentlyFocusedNode = e, nd(e) && e.select();
		}
	}, m = function(e) {
		var t = l("setReturnFocus", { params: [e] });
		return t || (t === !1 ? !1 : e);
	}, h = function(e) {
		var t = e.target, n = e.event, r = e.isBackward, o = r === void 0 ? !1 : r;
		t ||= ld(n), d();
		var s = null;
		if (a.tabbableGroups.length > 0) {
			var u = c(t, n), f = u >= 0 ? a.containerGroups[u] : void 0;
			if (u < 0) s = o ? a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : a.tabbableGroups[0].firstTabbableNode;
			else if (o) {
				var p = a.tabbableGroups.findIndex(function(e) {
					var n = e.firstTabbableNode;
					return t === n;
				});
				if (p < 0 && (f.container === t || Ru(t, i.tabbableOptions) && !Iu(t, i.tabbableOptions) && !f.nextTabbableNode(t, !1)) && (p = u), p >= 0) {
					var m = p === 0 ? a.tabbableGroups.length - 1 : p - 1, h = a.tabbableGroups[m];
					s = gu(t) >= 0 ? h.lastTabbableNode : h.lastDomTabbableNode;
				} else id(n) || (s = f.nextTabbableNode(t, !1));
			} else {
				var g = a.tabbableGroups.findIndex(function(e) {
					var n = e.lastTabbableNode;
					return t === n;
				});
				if (g < 0 && (f.container === t || Ru(t, i.tabbableOptions) && !Iu(t, i.tabbableOptions) && !f.nextTabbableNode(t)) && (g = u), g >= 0) {
					var _ = g === a.tabbableGroups.length - 1 ? 0 : g + 1, v = a.tabbableGroups[_];
					s = gu(t) >= 0 ? v.firstTabbableNode : v.firstDomTabbableNode;
				} else id(n) || (s = f.nextTabbableNode(t));
			}
		} else s = l("fallbackFocus");
		return s;
	}, g = function(e) {
		if (!(c(ld(e), e) >= 0)) {
			if (cd(i.clickOutsideDeactivates, e)) {
				o.deactivate({ returnFocus: i.returnFocusOnDeactivate });
				return;
			}
			cd(i.allowOutsideClick, e) || e.preventDefault();
		}
	}, _ = function(e) {
		var t = ld(e), n = c(t, e) >= 0;
		if (n || t instanceof Document) n && (a.mostRecentlyFocusedNode = t);
		else {
			e.stopImmediatePropagation();
			var r, o = !0;
			if (a.mostRecentlyFocusedNode) if (gu(a.mostRecentlyFocusedNode) > 0) {
				var s = c(a.mostRecentlyFocusedNode), l = a.containerGroups[s].tabbableNodes;
				if (l.length > 0) {
					var d = l.findIndex(function(e) {
						return e === a.mostRecentlyFocusedNode;
					});
					d >= 0 && (i.isKeyForward(a.recentNavEvent) ? d + 1 < l.length && (r = l[d + 1], o = !1) : d - 1 >= 0 && (r = l[d - 1], o = !1));
				}
			} else a.containerGroups.some(function(e) {
				return e.tabbableNodes.some(function(e) {
					return gu(e) > 0;
				});
			}) || (o = !1);
			else o = !1;
			o && (r = h({
				target: a.mostRecentlyFocusedNode,
				isBackward: i.isKeyBackward(a.recentNavEvent)
			})), p(r || a.mostRecentlyFocusedNode || u());
		}
		a.recentNavEvent = void 0;
	}, v = function(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
		a.recentNavEvent = e;
		var n = h({
			event: e,
			isBackward: t
		});
		n && (id(e) && e.preventDefault(), p(n));
	}, y = function(e) {
		(i.isKeyForward(e) || i.isKeyBackward(e)) && v(e, i.isKeyBackward(e));
	}, b = function(e) {
		rd(e) && cd(i.escapeDeactivates, e) !== !1 && (e.preventDefault(), o.deactivate());
	}, x = function(e) {
		c(ld(e), e) >= 0 || cd(i.clickOutsideDeactivates, e) || cd(i.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation());
	}, S = function() {
		if (!a.active) return Promise.resolve();
		td.activateTrap(r, o);
		var e;
		return i.delayInitialFocus ? e = new Promise(function(e) {
			a.delayInitialFocusTimer = sd(function() {
				p(u()), e();
			});
		}) : (e = Promise.resolve(), p(u())), n.addEventListener("focusin", _, !0), n.addEventListener("mousedown", g, {
			capture: !0,
			passive: !1
		}), n.addEventListener("touchstart", g, {
			capture: !0,
			passive: !1
		}), n.addEventListener("click", x, {
			capture: !0,
			passive: !1
		}), n.addEventListener("keydown", y, {
			capture: !0,
			passive: !1
		}), n.addEventListener("keydown", b), e;
	}, C = function(e) {
		a.active && !a.paused && o._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
		var t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = Uu(e), i;
		try {
			for (r.s(); !(i = r.n()).done;) {
				var s = i.value;
				t.add(s);
				for (var c = typeof ShadowRoot < "u" && s.getRootNode() instanceof ShadowRoot, l = s; l;) {
					t.add(l);
					var u = l.parentElement, d = [];
					u ? d = u.children : !u && c && (d = l.getRootNode().children, u = l.getRootNode().host, c = typeof ShadowRoot < "u" && u.getRootNode() instanceof ShadowRoot);
					var f = Uu(d), p;
					try {
						for (f.s(); !(p = f.n()).done;) {
							var m = p.value;
							n.add(m);
						}
					} catch (e) {
						f.e(e);
					} finally {
						f.f();
					}
					l = u;
				}
			}
		} catch (e) {
			r.e(e);
		} finally {
			r.f();
		}
		t.forEach(function(e) {
			n.delete(e);
		}), a.adjacentElements = n;
	}, w = function() {
		if (a.active) return n.removeEventListener("focusin", _, !0), n.removeEventListener("mousedown", g, !0), n.removeEventListener("touchstart", g, !0), n.removeEventListener("click", x, !0), n.removeEventListener("keydown", y, !0), n.removeEventListener("keydown", b), o;
	}, T = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(e) {
		e.some(function(e) {
			return Array.from(e.removedNodes).some(function(e) {
				return e === a.mostRecentlyFocusedNode;
			});
		}) && p(u());
	}) : void 0, E = function() {
		T && (T.disconnect(), a.active && !a.paused && a.containers.map(function(e) {
			T.observe(e, {
				subtree: !0,
				childList: !0
			});
		}));
	};
	return o = {
		get active() {
			return a.active;
		},
		get paused() {
			return a.paused;
		},
		activate: function(e) {
			if (a.active) return this;
			var t = s(e, "onActivate"), i = s(e, "onPostActivate"), c = s(e, "checkCanFocusTrap"), l = td.getActiveTrap(r), u = !1;
			if (l && !l.paused) {
				var p;
				(p = l._setSubtreeIsolation) == null || p.call(l, !1), u = !0;
			}
			try {
				c || d(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = f(n), t?.();
				var m = /* @__PURE__ */ function() {
					var e = Hu(/* @__PURE__ */ Yu().m(function e() {
						return Yu().w(function(e) {
							for (;;) switch (e.n) {
								case 0: return c && d(), e.n = 1, S();
								case 1: o._setSubtreeIsolation(!0), E(), i?.();
								case 2: return e.a(2);
							}
						}, e);
					}));
					return function() {
						return e.apply(this, arguments);
					};
				}();
				if (c) return c(a.containers.concat()).then(m, m), this;
				m();
			} catch (e) {
				if (l === td.getActiveTrap(r) && u) {
					var h;
					(h = l._setSubtreeIsolation) == null || h.call(l, !0);
				}
				throw e;
			}
			return this;
		},
		deactivate: function(e) {
			if (!a.active) return this;
			var t = Ju({
				onDeactivate: i.onDeactivate,
				onPostDeactivate: i.onPostDeactivate,
				checkCanReturnFocus: i.checkCanReturnFocus
			}, e);
			clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || o._setSubtreeIsolation(!1), a.alreadySilent.clear(), w(), a.active = !1, a.paused = !1, E(), td.deactivateTrap(r, o);
			var n = s(t, "onDeactivate"), c = s(t, "onPostDeactivate"), l = s(t, "checkCanReturnFocus"), u = s(t, "returnFocus", "returnFocusOnDeactivate");
			n?.();
			var d = function() {
				sd(function() {
					u && p(m(a.nodeFocusedBeforeActivation)), c?.();
				});
			};
			return u && l ? (l(m(a.nodeFocusedBeforeActivation)).then(d, d), this) : (d(), this);
		},
		pause: function(e) {
			return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, e)) : this;
		},
		unpause: function(e) {
			return !a.active || (a.manuallyPaused = !1, r[r.length - 1] !== this) ? this : this._setPausedState(!1, e);
		},
		updateContainerElements: function(e) {
			return a.containers = [].concat(e).filter(Boolean).map(function(e) {
				return typeof e == "string" ? n.querySelector(e) : e;
			}), i.isolateSubtrees && C(a.containers), a.active && (d(), a.paused || o._setSubtreeIsolation(!0)), E(), this;
		}
	}, Object.defineProperties(o, {
		_isManuallyPaused: { value: function() {
			return a.manuallyPaused;
		} },
		_setPausedState: { value: function(e, t) {
			if (a.paused === e) return this;
			if (a.paused = e, e) {
				var n = s(t, "onPause"), r = s(t, "onPostPause");
				n?.(), w(), o._setSubtreeIsolation(!1), E(), r?.();
			} else {
				var i = s(t, "onUnpause"), c = s(t, "onPostUnpause");
				i?.(), (/* @__PURE__ */ (function() {
					var e = Hu(/* @__PURE__ */ Yu().m(function e() {
						return Yu().w(function(e) {
							for (;;) switch (e.n) {
								case 0: return d(), e.n = 1, S();
								case 1: o._setSubtreeIsolation(!0), E(), c?.();
								case 2: return e.a(2);
							}
						}, e);
					}));
					return function() {
						return e.apply(this, arguments);
					};
				})())();
			}
			return this;
		} },
		_setSubtreeIsolation: { value: function(e) {
			i.isolateSubtrees && a.adjacentElements.forEach(function(t) {
				if (e) switch (i.isolateSubtrees) {
					case "aria-hidden":
						(t.ariaHidden === "true" || t.getAttribute("aria-hidden")?.toLowerCase() === "true") && a.alreadySilent.add(t), t.setAttribute("aria-hidden", "true");
						break;
					default:
						(t.inert || t.hasAttribute("inert")) && a.alreadySilent.add(t), t.setAttribute("inert", !0);
						break;
				}
				else if (!a.alreadySilent.has(t)) switch (i.isolateSubtrees) {
					case "aria-hidden":
						t.removeAttribute("aria-hidden");
						break;
					default:
						t.removeAttribute("inert");
						break;
				}
			});
		} }
	}), o.updateContainerElements(e), o;
}, fd = "left", pd = "right", md = "courthive-drawer", hd = (e) => typeof e == "function", gd = (e) => {
	for (; e.firstChild;) e.firstChild.remove();
};
function _d(e, t) {
	let n = t.parentNode;
	for (; n;) {
		if (n === e) return !0;
		n = n.parentNode;
	}
	return !1;
}
var vd = null, yd = !1, bd = (e = md) => {
	if (vd) return vd;
	let t = {
		selectorTrigger: "[data-drawer-trigger]",
		selectorTarget: "[data-drawer-target]",
		selectorClose: "[data-drawer-close]",
		leftAlignment: "drawer--left",
		visibleClass: "is-visible",
		activeClass: "is-active",
		speedClose: 350,
		speedOpen: 50
	}, n = {}, r = !1, i, a, o, s = !1, c = (e) => a = e, l = () => {
		hd(a) && (a?.(), a = void 0);
		let n = document.getElementById(e);
		n && (n.classList.remove(t.visibleClass), document.documentElement.style.overflow = "", setTimeout(function() {
			i ? (n.classList.add(t.visibleClass), document.documentElement.style.overflow = "hidden", hd(i?.callback) && i.callback()) : (n.classList.remove(t.activeClass), r = !1), i = !1, o?.deactivate();
		}, t.speedClose));
	}, u = (n) => {
		if (!e) return;
		let r = document.getElementById(e);
		r && (r.classList.contains(t.leftAlignment) || r.classList.add(t.leftAlignment), g(r, !1, n));
	}, d = (n) => {
		let r = document.getElementById(e);
		r && (r.classList.remove(t.leftAlignment), g(r, !1, n));
	}, f = (t) => {
		let n = document.getElementById(e)?.querySelector(".drawer__title");
		n && (n.innerHTML = t);
	}, p = (t) => {
		let r = document.getElementById(e)?.querySelector(".drawer__footer");
		r && (gd(r), hd(t) ? n.footer = t(r, l) : r.innerHTML = t || "");
	}, m = (t) => {
		let r = document.getElementById(e)?.querySelector(".drawer__content");
		r && (gd(r), hd(t) ? n.content = t(r, l) : r.innerHTML = t);
	}, h = (t) => {
		let n = document.getElementById(e)?.querySelector(".drawer__wrapper");
		n && (n.style.width = t);
	}, g = (e, n, i) => {
		r = !0, s = !0, e.classList.add(t.activeClass), document.documentElement.style.overflow = "hidden", n && (o = dd(e), o.activate()), hd(i) && i && i(), setTimeout(function() {
			e.classList.add(t.visibleClass), setTimeout(() => {
				s = !1;
			}, 100);
		}, t.speedOpen);
	};
	return yd ||= (document.addEventListener("click", function(t) {
		if (!e || !r || s) return;
		let n = t.target, i = document.querySelector(".drawer__wrapper");
		if (!i) return;
		let a = n.classList.contains("drawer__close") || n.closest(".drawer__close") || "drawerClose" in n.dataset || n.closest("[data-drawer-close]");
		(!_d(i, n) || a) && l();
	}, !1), document.addEventListener("keydown", (e) => {
		e.key === "Escape" && r && l();
	}, !1), !0), vd = {
		settings: t,
		open: (t = {}) => {
			let { title: n, content: a, side: o, width: s, footer: l, callback: _, onClose: v } = t;
			if (a && m(a), v && c(v), n && f(n), s && h(s), p(l), r) i = { callback: _ };
			else if (o) {
				if (o === pd) return d(_);
				if (o === fd) return u(_);
			} else {
				let t = document.getElementById(e);
				t && g(t, l, _);
			}
		},
		close: l,
		setTitle: f,
		setContent: m,
		setFooter: p,
		attributes: n
	}, vd;
};
function xd(e = md) {
	if (document.getElementById(e)) return;
	let t = `
    <div id="${e}" class="drawer" aria-hidden="true">
      <div class="drawer__overlay" tabindex="-1" data-drawer-close></div>
      <div class="drawer__wrapper" role="dialog" aria-modal="true">
        <div class="drawer__header">
          <div class="drawer__title"></div>
          <button class="drawer__close" aria-label="Close drawer" data-drawer-close>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="drawer__content"></div>
        <div class="drawer__footer"></div>
      </div>
    </div>
  `;
	document.body.insertAdjacentHTML("beforeend", t);
}
//#endregion
//#region src/components/forms/renderMenu.ts
function Sd(e, t, n) {
	if (!e) return {};
	let r = document.createElement("aside");
	r.classList.add("menu");
	let i = {}, a = (e) => n && e.close !== !1 ? (t) => {
		t.stopPropagation(), n(), e.onClick();
	} : (t) => {
		t.stopPropagation(), e.onClick();
	}, o = 0, s = () => (o += 1, o), c = (e) => e?.heading || e?.text || e?.label || `Item ${s()}`, l = (e) => {
		let t = document.createElement("li");
		if (t.className = "font-medium", e.style && (t.style.cssText = e.style), e.onClick) {
			let n = e.fontSize || "1em";
			if (e.divider) {
				let e = document.createElement("hr");
				e.classList.add("dropdown-divider"), t.appendChild(e);
			} else {
				let r = document.createElement("a"), i = e.disabled ? "0.4" : "1";
				r.style.cssText = `text-decoration: none; opacity: ${i}; font-size: ${n}`, e.class && r.classList.add(e.class), e.color && (r.style.color = e.color), e.heading && (r.style.fontWeight = "bold"), e.disabled || (r.onclick = a(e)), r.innerHTML = c(e), t.appendChild(r);
			}
		} else t.innerHTML = c(e), e.disabled || (t.onclick = e.onClick);
		return t;
	}, u;
	for (let e of t || []) if (!e.hide) {
		if (e.items) {
			if (e.text) {
				let t = document.createElement("p");
				t.className = "menu-label font-medium", t.innerHTML = e.text, r.appendChild(t);
			}
			let t = document.createElement("ul");
			t.className = "menu-list";
			for (let n of e.items) n.hide || t.appendChild(l(n));
			r.appendChild(t);
		} else if (e.type === "input") {
			let { field: t, inputElement: n } = Tn(e);
			e.focus && (u = n), i[e.field] = n, r.appendChild(t);
		} else if (e.type === "divider") {
			let e = document.createElement("hr");
			e.classList.add("dropdown-divider"), r.appendChild(e);
		}
	}
	return e.appendChild(r), { focusElement: u };
}
var Cd = "bottom", wd = "right", Td = "left", Ed = "auto", Dd = [
	"top",
	Cd,
	wd,
	Td
], Od = "start", kd = "clippingParents", Ad = "viewport", jd = "popper", Md = "reference", Nd = /* @__PURE__ */ Dd.reduce(function(e, t) {
	return e.concat([t + "-" + Od, t + "-end"]);
}, []), Pd = /* @__PURE__ */ [].concat(Dd, [Ed]).reduce(function(e, t) {
	return e.concat([
		t,
		t + "-" + Od,
		t + "-end"
	]);
}, []), Fd = [
	"beforeRead",
	"read",
	"afterRead",
	"beforeMain",
	"main",
	"afterMain",
	"beforeWrite",
	"write",
	"afterWrite"
];
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function Id(e) {
	return e ? (e.nodeName || "").toLowerCase() : null;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function Ld(e) {
	if (e == null) return window;
	if (e.toString() !== "[object Window]") {
		var t = e.ownerDocument;
		return t && t.defaultView || window;
	}
	return e;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
function Rd(e) {
	return e instanceof Ld(e).Element || e instanceof Element;
}
function zd(e) {
	return e instanceof Ld(e).HTMLElement || e instanceof HTMLElement;
}
function Bd(e) {
	return typeof ShadowRoot > "u" ? !1 : e instanceof Ld(e).ShadowRoot || e instanceof ShadowRoot;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/applyStyles.js
function Vd(e) {
	var t = e.state;
	Object.keys(t.elements).forEach(function(e) {
		var n = t.styles[e] || {}, r = t.attributes[e] || {}, i = t.elements[e];
		!zd(i) || !Id(i) || (Object.assign(i.style, n), Object.keys(r).forEach(function(e) {
			var t = r[e];
			t === !1 ? i.removeAttribute(e) : i.setAttribute(e, t === !0 ? "" : t);
		}));
	});
}
function Hd(e) {
	var t = e.state, n = {
		popper: {
			position: t.options.strategy,
			left: "0",
			top: "0",
			margin: "0"
		},
		arrow: { position: "absolute" },
		reference: {}
	};
	return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
		Object.keys(t.elements).forEach(function(e) {
			var r = t.elements[e], i = t.attributes[e] || {}, a = Object.keys(t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]).reduce(function(e, t) {
				return e[t] = "", e;
			}, {});
			!zd(r) || !Id(r) || (Object.assign(r.style, a), Object.keys(i).forEach(function(e) {
				r.removeAttribute(e);
			}));
		});
	};
}
var Ud = {
	name: "applyStyles",
	enabled: !0,
	phase: "write",
	fn: Vd,
	effect: Hd,
	requires: ["computeStyles"]
};
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getBasePlacement.js
function Wd(e) {
	return e.split("-")[0];
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/math.js
var Gd = Math.max, Kd = Math.min, qd = Math.round;
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/userAgent.js
function Jd() {
	var e = navigator.userAgentData;
	return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(e) {
		return e.brand + "/" + e.version;
	}).join(" ") : navigator.userAgent;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
function Yd() {
	return !/^((?!chrome|android).)*safari/i.test(Jd());
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function Xd(e, t, n) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	var r = e.getBoundingClientRect(), i = 1, a = 1;
	t && zd(e) && (i = e.offsetWidth > 0 && qd(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && qd(r.height) / e.offsetHeight || 1);
	var o = (Rd(e) ? Ld(e) : window).visualViewport, s = !Yd() && n, c = (r.left + (s && o ? o.offsetLeft : 0)) / i, l = (r.top + (s && o ? o.offsetTop : 0)) / a, u = r.width / i, d = r.height / a;
	return {
		width: u,
		height: d,
		top: l,
		right: c + u,
		bottom: l + d,
		left: c,
		x: c,
		y: l
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
function Zd(e) {
	var t = Xd(e), n = e.offsetWidth, r = e.offsetHeight;
	return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
		x: e.offsetLeft,
		y: e.offsetTop,
		width: n,
		height: r
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/contains.js
function Qd(e, t) {
	var n = t.getRootNode && t.getRootNode();
	if (e.contains(t)) return !0;
	if (n && Bd(n)) {
		var r = t;
		do {
			if (r && e.isSameNode(r)) return !0;
			r = r.parentNode || r.host;
		} while (r);
	}
	return !1;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
function $d(e) {
	return Ld(e).getComputedStyle(e);
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
function ef(e) {
	return [
		"table",
		"td",
		"th"
	].indexOf(Id(e)) >= 0;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
function tf(e) {
	return ((Rd(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
function nf(e) {
	return Id(e) === "html" ? e : e.assignedSlot || e.parentNode || (Bd(e) ? e.host : null) || tf(e);
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
function rf(e) {
	return !zd(e) || $d(e).position === "fixed" ? null : e.offsetParent;
}
function af(e) {
	var t = /firefox/i.test(Jd());
	if (/Trident/i.test(Jd()) && zd(e) && $d(e).position === "fixed") return null;
	var n = nf(e);
	for (Bd(n) && (n = n.host); zd(n) && ["html", "body"].indexOf(Id(n)) < 0;) {
		var r = $d(n);
		if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || t && r.willChange === "filter" || t && r.filter && r.filter !== "none") return n;
		n = n.parentNode;
	}
	return null;
}
function of(e) {
	for (var t = Ld(e), n = rf(e); n && ef(n) && $d(n).position === "static";) n = rf(n);
	return n && (Id(n) === "html" || Id(n) === "body" && $d(n).position === "static") ? t : n || af(e) || t;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function sf(e) {
	return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/within.js
function cf(e, t, n) {
	return Gd(e, Kd(t, n));
}
function lf(e, t, n) {
	var r = cf(e, t, n);
	return r > n ? n : r;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function uf() {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
function df(e) {
	return Object.assign({}, uf(), e);
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function ff(e, t) {
	return t.reduce(function(t, n) {
		return t[n] = e, t;
	}, {});
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/arrow.js
var pf = function(e, t) {
	return e = typeof e == "function" ? e(Object.assign({}, t.rects, { placement: t.placement })) : e, df(typeof e == "number" ? ff(e, Dd) : e);
};
function mf(e) {
	var t, n = e.state, r = e.name, i = e.options, a = n.elements.arrow, o = n.modifiersData.popperOffsets, s = Wd(n.placement), c = sf(s), l = ["left", "right"].indexOf(s) >= 0 ? "height" : "width";
	if (!(!a || !o)) {
		var u = pf(i.padding, n), d = Zd(a), f = c === "y" ? "top" : Td, p = c === "y" ? Cd : wd, m = n.rects.reference[l] + n.rects.reference[c] - o[c] - n.rects.popper[l], h = o[c] - n.rects.reference[c], g = of(a), _ = g ? c === "y" ? g.clientHeight || 0 : g.clientWidth || 0 : 0, v = m / 2 - h / 2, y = u[f], b = _ - d[l] - u[p], x = _ / 2 - d[l] / 2 + v, S = cf(y, x, b), C = c;
		n.modifiersData[r] = (t = {}, t[C] = S, t.centerOffset = S - x, t);
	}
}
function hf(e) {
	var t = e.state, n = e.options.element, r = n === void 0 ? "[data-popper-arrow]" : n;
	r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Qd(t.elements.popper, r) && (t.elements.arrow = r));
}
var gf = {
	name: "arrow",
	enabled: !0,
	phase: "main",
	fn: mf,
	effect: hf,
	requires: ["popperOffsets"],
	requiresIfExists: ["preventOverflow"]
};
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getVariation.js
function _f(e) {
	return e.split("-")[1];
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var vf = {
	top: "auto",
	right: "auto",
	bottom: "auto",
	left: "auto"
};
function yf(e, t) {
	var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
	return {
		x: qd(n * i) / i || 0,
		y: qd(r * i) / i || 0
	};
}
function bf(e) {
	var t, n = e.popper, r = e.popperRect, i = e.placement, a = e.variation, o = e.offsets, s = e.position, c = e.gpuAcceleration, l = e.adaptive, u = e.roundOffsets, d = e.isFixed, f = o.x, p = f === void 0 ? 0 : f, m = o.y, h = m === void 0 ? 0 : m, g = typeof u == "function" ? u({
		x: p,
		y: h
	}) : {
		x: p,
		y: h
	};
	p = g.x, h = g.y;
	var _ = o.hasOwnProperty("x"), v = o.hasOwnProperty("y"), y = Td, b = "top", x = window;
	if (l) {
		var S = of(n), C = "clientHeight", w = "clientWidth";
		if (S === Ld(n) && (S = tf(n), $d(S).position !== "static" && s === "absolute" && (C = "scrollHeight", w = "scrollWidth")), S = S, i === "top" || (i === "left" || i === "right") && a === "end") {
			b = Cd;
			var T = d && S === x && x.visualViewport ? x.visualViewport.height : S[C];
			h -= T - r.height, h *= c ? 1 : -1;
		}
		if (i === "left" || (i === "top" || i === "bottom") && a === "end") {
			y = wd;
			var E = d && S === x && x.visualViewport ? x.visualViewport.width : S[w];
			p -= E - r.width, p *= c ? 1 : -1;
		}
	}
	var D = Object.assign({ position: s }, l && vf), O = u === !0 ? yf({
		x: p,
		y: h
	}, Ld(n)) : {
		x: p,
		y: h
	};
	if (p = O.x, h = O.y, c) {
		var k;
		return Object.assign({}, D, (k = {}, k[b] = v ? "0" : "", k[y] = _ ? "0" : "", k.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + h + "px)" : "translate3d(" + p + "px, " + h + "px, 0)", k));
	}
	return Object.assign({}, D, (t = {}, t[b] = v ? h + "px" : "", t[y] = _ ? p + "px" : "", t.transform = "", t));
}
function xf(e) {
	var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, o = a === void 0 ? !0 : a, s = n.roundOffsets, c = s === void 0 ? !0 : s, l = {
		placement: Wd(t.placement),
		variation: _f(t.placement),
		popper: t.elements.popper,
		popperRect: t.rects.popper,
		gpuAcceleration: i,
		isFixed: t.options.strategy === "fixed"
	};
	t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, bf(Object.assign({}, l, {
		offsets: t.modifiersData.popperOffsets,
		position: t.options.strategy,
		adaptive: o,
		roundOffsets: c
	})))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, bf(Object.assign({}, l, {
		offsets: t.modifiersData.arrow,
		position: "absolute",
		adaptive: !1,
		roundOffsets: c
	})))), t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-placement": t.placement });
}
var Sf = {
	name: "computeStyles",
	enabled: !0,
	phase: "beforeWrite",
	fn: xf,
	data: {}
}, Cf = { passive: !0 };
function wf(e) {
	var t = e.state, n = e.instance, r = e.options, i = r.scroll, a = i === void 0 ? !0 : i, o = r.resize, s = o === void 0 ? !0 : o, c = Ld(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
	return a && l.forEach(function(e) {
		e.addEventListener("scroll", n.update, Cf);
	}), s && c.addEventListener("resize", n.update, Cf), function() {
		a && l.forEach(function(e) {
			e.removeEventListener("scroll", n.update, Cf);
		}), s && c.removeEventListener("resize", n.update, Cf);
	};
}
var Tf = {
	name: "eventListeners",
	enabled: !0,
	phase: "write",
	fn: function() {},
	effect: wf,
	data: {}
}, Ef = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function Df(e) {
	return e.replace(/left|right|bottom|top/g, function(e) {
		return Ef[e];
	});
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var Of = {
	start: "end",
	end: "start"
};
function kf(e) {
	return e.replace(/start|end/g, function(e) {
		return Of[e];
	});
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
function Af(e) {
	var t = Ld(e);
	return {
		scrollLeft: t.pageXOffset,
		scrollTop: t.pageYOffset
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
function jf(e) {
	return Xd(tf(e)).left + Af(e).scrollLeft;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
function Mf(e, t) {
	var n = Ld(e), r = tf(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		var l = Yd();
		(l || !l && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	return {
		width: a,
		height: o,
		x: s + jf(e),
		y: c
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js
function Nf(e) {
	var t = tf(e), n = Af(e), r = e.ownerDocument?.body, i = Gd(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), a = Gd(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), o = -n.scrollLeft + jf(e), s = -n.scrollTop;
	return $d(r || t).direction === "rtl" && (o += Gd(t.clientWidth, r ? r.clientWidth : 0) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
function Pf(e) {
	var t = $d(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
	return /auto|scroll|overlay|hidden/.test(n + i + r);
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
function Ff(e) {
	return [
		"html",
		"body",
		"#document"
	].indexOf(Id(e)) >= 0 ? e.ownerDocument.body : zd(e) && Pf(e) ? e : Ff(nf(e));
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
function If(e, t) {
	t === void 0 && (t = []);
	var n = Ff(e), r = n === e.ownerDocument?.body, i = Ld(n), a = r ? [i].concat(i.visualViewport || [], Pf(n) ? n : []) : n, o = t.concat(a);
	return r ? o : o.concat(If(nf(a)));
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function Lf(e) {
	return Object.assign({}, e, {
		left: e.x,
		top: e.y,
		right: e.x + e.width,
		bottom: e.y + e.height
	});
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
function Rf(e, t) {
	var n = Xd(e, !1, t === "fixed");
	return n.top += e.clientTop, n.left += e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function zf(e, t, n) {
	return t === "viewport" ? Lf(Mf(e, n)) : Rd(t) ? Rf(t, n) : Lf(Nf(tf(e)));
}
function Bf(e) {
	var t = If(nf(e)), n = ["absolute", "fixed"].indexOf($d(e).position) >= 0 && zd(e) ? of(e) : e;
	return Rd(n) ? t.filter(function(e) {
		return Rd(e) && Qd(e, n) && Id(e) !== "body";
	}) : [];
}
function Vf(e, t, n, r) {
	var i = t === "clippingParents" ? Bf(e) : [].concat(t), a = [].concat(i, [n]), o = a[0], s = a.reduce(function(t, n) {
		var i = zf(e, n, r);
		return t.top = Gd(i.top, t.top), t.right = Kd(i.right, t.right), t.bottom = Kd(i.bottom, t.bottom), t.left = Gd(i.left, t.left), t;
	}, zf(e, o, r));
	return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeOffsets.js
function Hf(e) {
	var t = e.reference, n = e.element, r = e.placement, i = r ? Wd(r) : null, a = r ? _f(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, c;
	switch (i) {
		case "top":
			c = {
				x: o,
				y: t.y - n.height
			};
			break;
		case Cd:
			c = {
				x: o,
				y: t.y + t.height
			};
			break;
		case wd:
			c = {
				x: t.x + t.width,
				y: s
			};
			break;
		case Td:
			c = {
				x: t.x - n.width,
				y: s
			};
			break;
		default: c = {
			x: t.x,
			y: t.y
		};
	}
	var l = i ? sf(i) : null;
	if (l != null) {
		var u = l === "y" ? "height" : "width";
		switch (a) {
			case Od:
				c[l] = c[l] - (t[u] / 2 - n[u] / 2);
				break;
			case "end":
				c[l] = c[l] + (t[u] / 2 - n[u] / 2);
				break;
			default:
		}
	}
	return c;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/detectOverflow.js
function Uf(e, t) {
	t === void 0 && (t = {});
	var n = t, r = n.placement, i = r === void 0 ? e.placement : r, a = n.strategy, o = a === void 0 ? e.strategy : a, s = n.boundary, c = s === void 0 ? kd : s, l = n.rootBoundary, u = l === void 0 ? Ad : l, d = n.elementContext, f = d === void 0 ? jd : d, p = n.altBoundary, m = p === void 0 ? !1 : p, h = n.padding, g = h === void 0 ? 0 : h, _ = df(typeof g == "number" ? ff(g, Dd) : g), v = f === "popper" ? Md : jd, y = e.rects.popper, b = e.elements[m ? v : f], x = Vf(Rd(b) ? b : b.contextElement || tf(e.elements.popper), c, u, o), S = Xd(e.elements.reference), C = Hf({
		reference: S,
		element: y,
		strategy: "absolute",
		placement: i
	}), w = Lf(Object.assign({}, y, C)), T = f === "popper" ? w : S, E = {
		top: x.top - T.top + _.top,
		bottom: T.bottom - x.bottom + _.bottom,
		left: x.left - T.left + _.left,
		right: T.right - x.right + _.right
	}, D = e.modifiersData.offset;
	if (f === "popper" && D) {
		var O = D[i];
		Object.keys(E).forEach(function(e) {
			var t = ["right", "bottom"].indexOf(e) >= 0 ? 1 : -1, n = ["top", "bottom"].indexOf(e) >= 0 ? "y" : "x";
			E[e] += O[n] * t;
		});
	}
	return E;
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js
function Wf(e, t) {
	t === void 0 && (t = {});
	var n = t, r = n.placement, i = n.boundary, a = n.rootBoundary, o = n.padding, s = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? Pd : c, u = _f(r), d = u ? s ? Nd : Nd.filter(function(e) {
		return _f(e) === u;
	}) : Dd, f = d.filter(function(e) {
		return l.indexOf(e) >= 0;
	});
	f.length === 0 && (f = d);
	var p = f.reduce(function(t, n) {
		return t[n] = Uf(e, {
			placement: n,
			boundary: i,
			rootBoundary: a,
			padding: o
		})[Wd(n)], t;
	}, {});
	return Object.keys(p).sort(function(e, t) {
		return p[e] - p[t];
	});
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/flip.js
function Gf(e) {
	if (Wd(e) === "auto") return [];
	var t = Df(e);
	return [
		kf(e),
		t,
		kf(t)
	];
}
function Kf(e) {
	var t = e.state, n = e.options, r = e.name;
	if (!t.modifiersData[r]._skip) {
		for (var i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !0 : o, c = n.fallbackPlacements, l = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.flipVariations, m = p === void 0 ? !0 : p, h = n.allowedAutoPlacements, g = t.options.placement, _ = Wd(g) === g, v = c || (_ || !m ? [Df(g)] : Gf(g)), y = [g].concat(v).reduce(function(e, n) {
			return e.concat(Wd(n) === "auto" ? Wf(t, {
				placement: n,
				boundary: u,
				rootBoundary: d,
				padding: l,
				flipVariations: m,
				allowedAutoPlacements: h
			}) : n);
		}, []), b = t.rects.reference, x = t.rects.popper, S = /* @__PURE__ */ new Map(), C = !0, w = y[0], T = 0; T < y.length; T++) {
			var E = y[T], D = Wd(E), O = _f(E) === Od, k = ["top", Cd].indexOf(D) >= 0, A = k ? "width" : "height", j = Uf(t, {
				placement: E,
				boundary: u,
				rootBoundary: d,
				altBoundary: f,
				padding: l
			}), M = k ? O ? wd : Td : O ? Cd : "top";
			b[A] > x[A] && (M = Df(M));
			var N = Df(M), P = [];
			if (a && P.push(j[D] <= 0), s && P.push(j[M] <= 0, j[N] <= 0), P.every(function(e) {
				return e;
			})) {
				w = E, C = !1;
				break;
			}
			S.set(E, P);
		}
		if (C) for (var F = m ? 3 : 1, ee = function(e) {
			var t = y.find(function(t) {
				var n = S.get(t);
				if (n) return n.slice(0, e).every(function(e) {
					return e;
				});
			});
			if (t) return w = t, "break";
		}, te = F; te > 0 && ee(te) !== "break"; te--);
		t.placement !== w && (t.modifiersData[r]._skip = !0, t.placement = w, t.reset = !0);
	}
}
var qf = {
	name: "flip",
	enabled: !0,
	phase: "main",
	fn: Kf,
	requiresIfExists: ["offset"],
	data: { _skip: !1 }
};
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/hide.js
function Jf(e, t, n) {
	return n === void 0 && (n = {
		x: 0,
		y: 0
	}), {
		top: e.top - t.height - n.y,
		right: e.right - t.width + n.x,
		bottom: e.bottom - t.height + n.y,
		left: e.left - t.width - n.x
	};
}
function Yf(e) {
	return [
		"top",
		wd,
		Cd,
		Td
	].some(function(t) {
		return e[t] >= 0;
	});
}
function Xf(e) {
	var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, a = t.modifiersData.preventOverflow, o = Uf(t, { elementContext: "reference" }), s = Uf(t, { altBoundary: !0 }), c = Jf(o, r), l = Jf(s, i, a), u = Yf(c), d = Yf(l);
	t.modifiersData[n] = {
		referenceClippingOffsets: c,
		popperEscapeOffsets: l,
		isReferenceHidden: u,
		hasPopperEscaped: d
	}, t.attributes.popper = Object.assign({}, t.attributes.popper, {
		"data-popper-reference-hidden": u,
		"data-popper-escaped": d
	});
}
var Zf = {
	name: "hide",
	enabled: !0,
	phase: "main",
	requiresIfExists: ["preventOverflow"],
	fn: Xf
};
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/offset.js
function Qf(e, t, n) {
	var r = Wd(e), i = ["left", "top"].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, { placement: e })) : n, o = a[0], s = a[1];
	return o ||= 0, s = (s || 0) * i, ["left", "right"].indexOf(r) >= 0 ? {
		x: s,
		y: o
	} : {
		x: o,
		y: s
	};
}
function $f(e) {
	var t = e.state, n = e.options, r = e.name, i = n.offset, a = i === void 0 ? [0, 0] : i, o = Pd.reduce(function(e, n) {
		return e[n] = Qf(n, t.rects, a), e;
	}, {}), s = o[t.placement], c = s.x, l = s.y;
	t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = o;
}
var ep = {
	name: "offset",
	enabled: !0,
	phase: "main",
	requires: ["popperOffsets"],
	fn: $f
};
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
function tp(e) {
	var t = e.state, n = e.name;
	t.modifiersData[n] = Hf({
		reference: t.rects.reference,
		element: t.rects.popper,
		strategy: "absolute",
		placement: t.placement
	});
}
var np = {
	name: "popperOffsets",
	enabled: !0,
	phase: "read",
	fn: tp,
	data: {}
};
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function rp(e) {
	return e === "x" ? "y" : "x";
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
function ip(e) {
	var t = e.state, n = e.options, r = e.name, i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !1 : o, c = n.boundary, l = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, p = f === void 0 ? !0 : f, m = n.tetherOffset, h = m === void 0 ? 0 : m, g = Uf(t, {
		boundary: c,
		rootBoundary: l,
		padding: d,
		altBoundary: u
	}), _ = Wd(t.placement), v = _f(t.placement), y = !v, b = sf(_), x = rp(b), S = t.modifiersData.popperOffsets, C = t.rects.reference, w = t.rects.popper, T = typeof h == "function" ? h(Object.assign({}, t.rects, { placement: t.placement })) : h, E = typeof T == "number" ? {
		mainAxis: T,
		altAxis: T
	} : Object.assign({
		mainAxis: 0,
		altAxis: 0
	}, T), D = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, O = {
		x: 0,
		y: 0
	};
	if (S) {
		if (a) {
			var k = b === "y" ? "top" : Td, A = b === "y" ? Cd : wd, j = b === "y" ? "height" : "width", M = S[b], N = M + g[k], P = M - g[A], F = p ? -w[j] / 2 : 0, ee = v === "start" ? C[j] : w[j], te = v === "start" ? -w[j] : -C[j], ne = t.elements.arrow, re = p && ne ? Zd(ne) : {
				width: 0,
				height: 0
			}, I = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : uf(), ie = I[k], ae = I[A], oe = cf(0, C[j], re[j]), se = y ? C[j] / 2 - F - oe - ie - E.mainAxis : ee - oe - ie - E.mainAxis, L = y ? -C[j] / 2 + F + oe + ae + E.mainAxis : te + oe + ae + E.mainAxis, ce = t.elements.arrow && of(t.elements.arrow), le = ce ? b === "y" ? ce.clientTop || 0 : ce.clientLeft || 0 : 0, ue = D?.[b] ?? 0, R = M + se - ue - le, de = M + L - ue, fe = cf(p ? Kd(N, R) : N, M, p ? Gd(P, de) : P);
			S[b] = fe, O[b] = fe - M;
		}
		if (s) {
			var pe = b === "x" ? "top" : Td, me = b === "x" ? Cd : wd, z = S[x], he = x === "y" ? "height" : "width", ge = z + g[pe], _e = z - g[me], ve = ["top", Td].indexOf(_) !== -1, ye = D?.[x] ?? 0, be = ve ? ge : z - C[he] - w[he] - ye + E.altAxis, xe = ve ? z + C[he] + w[he] - ye - E.altAxis : _e, Se = p && ve ? lf(be, z, xe) : cf(p ? be : ge, z, p ? xe : _e);
			S[x] = Se, O[x] = Se - z;
		}
		t.modifiersData[r] = O;
	}
}
var ap = {
	name: "preventOverflow",
	enabled: !0,
	phase: "main",
	fn: ip,
	requiresIfExists: ["offset"]
};
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function op(e) {
	return {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
function sp(e) {
	return e === Ld(e) || !zd(e) ? Af(e) : op(e);
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
function cp(e) {
	var t = e.getBoundingClientRect(), n = qd(t.width) / e.offsetWidth || 1, r = qd(t.height) / e.offsetHeight || 1;
	return n !== 1 || r !== 1;
}
function lp(e, t, n) {
	n === void 0 && (n = !1);
	var r = zd(t), i = zd(t) && cp(t), a = tf(t), o = Xd(e, i, n), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = {
		x: 0,
		y: 0
	};
	return (r || !r && !n) && ((Id(t) !== "body" || Pf(a)) && (s = sp(t)), zd(t) ? (c = Xd(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : a && (c.x = jf(a))), {
		x: o.left + s.scrollLeft - c.x,
		y: o.top + s.scrollTop - c.y,
		width: o.width,
		height: o.height
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/orderModifiers.js
function up(e) {
	var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
	e.forEach(function(e) {
		t.set(e.name, e);
	});
	function i(e) {
		n.add(e.name), [].concat(e.requires || [], e.requiresIfExists || []).forEach(function(e) {
			if (!n.has(e)) {
				var r = t.get(e);
				r && i(r);
			}
		}), r.push(e);
	}
	return e.forEach(function(e) {
		n.has(e.name) || i(e);
	}), r;
}
function dp(e) {
	var t = up(e);
	return Fd.reduce(function(e, n) {
		return e.concat(t.filter(function(e) {
			return e.phase === n;
		}));
	}, []);
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/debounce.js
function fp(e) {
	var t;
	return function() {
		return t ||= new Promise(function(n) {
			Promise.resolve().then(function() {
				t = void 0, n(e());
			});
		}), t;
	};
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergeByName.js
function pp(e) {
	var t = e.reduce(function(e, t) {
		var n = e[t.name];
		return e[t.name] = n ? Object.assign({}, n, t, {
			options: Object.assign({}, n.options, t.options),
			data: Object.assign({}, n.data, t.data)
		}) : t, e;
	}, {});
	return Object.keys(t).map(function(e) {
		return t[e];
	});
}
//#endregion
//#region node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/createPopper.js
var mp = {
	placement: "bottom",
	modifiers: [],
	strategy: "absolute"
};
function hp() {
	return ![...arguments].some(function(e) {
		return !(e && typeof e.getBoundingClientRect == "function");
	});
}
function gp(e) {
	e === void 0 && (e = {});
	var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, a = i === void 0 ? mp : i;
	return function(e, t, n) {
		n === void 0 && (n = a);
		var i = {
			placement: "bottom",
			orderedModifiers: [],
			options: Object.assign({}, mp, a),
			modifiersData: {},
			elements: {
				reference: e,
				popper: t
			},
			attributes: {},
			styles: {}
		}, o = [], s = !1, c = {
			state: i,
			setOptions: function(n) {
				var o = typeof n == "function" ? n(i.options) : n;
				u(), i.options = Object.assign({}, a, i.options, o), i.scrollParents = {
					reference: Rd(e) ? If(e) : e.contextElement ? If(e.contextElement) : [],
					popper: If(t)
				};
				var s = dp(pp([].concat(r, i.options.modifiers)));
				return i.orderedModifiers = s.filter(function(e) {
					return e.enabled;
				}), l(), c.update();
			},
			forceUpdate: function() {
				if (!s) {
					var e = i.elements, t = e.reference, n = e.popper;
					if (hp(t, n)) {
						i.rects = {
							reference: lp(t, of(n), i.options.strategy === "fixed"),
							popper: Zd(n)
						}, i.reset = !1, i.placement = i.options.placement, i.orderedModifiers.forEach(function(e) {
							return i.modifiersData[e.name] = Object.assign({}, e.data);
						});
						for (var r = 0; r < i.orderedModifiers.length; r++) {
							if (i.reset === !0) {
								i.reset = !1, r = -1;
								continue;
							}
							var a = i.orderedModifiers[r], o = a.fn, l = a.options, u = l === void 0 ? {} : l, d = a.name;
							typeof o == "function" && (i = o({
								state: i,
								options: u,
								name: d,
								instance: c
							}) || i);
						}
					}
				}
			},
			update: fp(function() {
				return new Promise(function(e) {
					c.forceUpdate(), e(i);
				});
			}),
			destroy: function() {
				u(), s = !0;
			}
		};
		if (!hp(e, t)) return c;
		c.setOptions(n).then(function(e) {
			!s && n.onFirstUpdate && n.onFirstUpdate(e);
		});
		function l() {
			i.orderedModifiers.forEach(function(e) {
				var t = e.name, n = e.options, r = n === void 0 ? {} : n, a = e.effect;
				if (typeof a == "function") {
					var s = a({
						state: i,
						name: t,
						instance: c,
						options: r
					});
					o.push(s || function() {});
				}
			});
		}
		function u() {
			o.forEach(function(e) {
				return e();
			}), o = [];
		}
		return c;
	};
}
var _p = /* @__PURE__ */ gp({ defaultModifiers: [
	Tf,
	np,
	Sf,
	Ud,
	ep,
	qf,
	ap,
	gf,
	Zf
] }), vp = "tippy-box", yp = "tippy-content", bp = "tippy-backdrop", xp = "tippy-arrow", Sp = "tippy-svg-arrow", Cp = {
	passive: !0,
	capture: !0
}, wp = function() {
	return document.body;
};
function Tp(e, t) {
	return {}.hasOwnProperty.call(e, t);
}
function Ep(e, t, n) {
	return Array.isArray(e) ? e[t] ?? (Array.isArray(n) ? n[t] : n) : e;
}
function Dp(e, t) {
	var n = {}.toString.call(e);
	return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function Op(e, t) {
	return typeof e == "function" ? e.apply(void 0, t) : e;
}
function kp(e, t) {
	if (t === 0) return e;
	var n;
	return function(r) {
		clearTimeout(n), n = setTimeout(function() {
			e(r);
		}, t);
	};
}
function Ap(e, t) {
	var n = Object.assign({}, e);
	return t.forEach(function(e) {
		delete n[e];
	}), n;
}
function jp(e) {
	return e.split(/\s+/).filter(Boolean);
}
function Mp(e) {
	return [].concat(e);
}
function Np(e, t) {
	e.indexOf(t) === -1 && e.push(t);
}
function Pp(e) {
	return e.filter(function(t, n) {
		return e.indexOf(t) === n;
	});
}
function Fp(e) {
	return e.split("-")[0];
}
function Ip(e) {
	return [].slice.call(e);
}
function Lp(e) {
	return Object.keys(e).reduce(function(t, n) {
		return e[n] !== void 0 && (t[n] = e[n]), t;
	}, {});
}
function Rp() {
	return document.createElement("div");
}
function zp(e) {
	return ["Element", "Fragment"].some(function(t) {
		return Dp(e, t);
	});
}
function Bp(e) {
	return Dp(e, "NodeList");
}
function Vp(e) {
	return Dp(e, "MouseEvent");
}
function Hp(e) {
	return !!(e && e._tippy && e._tippy.reference === e);
}
function Up(e) {
	return zp(e) ? [e] : Bp(e) ? Ip(e) : Array.isArray(e) ? e : Ip(document.querySelectorAll(e));
}
function Wp(e, t) {
	e.forEach(function(e) {
		e && (e.style.transitionDuration = t + "ms");
	});
}
function Gp(e, t) {
	e.forEach(function(e) {
		e && e.setAttribute("data-state", t);
	});
}
function Kp(e) {
	var t, n = Mp(e)[0];
	return n != null && (t = n.ownerDocument) != null && t.body ? n.ownerDocument : document;
}
function qp(e, t) {
	var n = t.clientX, r = t.clientY;
	return e.every(function(e) {
		var t = e.popperRect, i = e.popperState, a = e.props.interactiveBorder, o = Fp(i.placement), s = i.modifiersData.offset;
		if (!s) return !0;
		var c = o === "bottom" ? s.top.y : 0, l = o === "top" ? s.bottom.y : 0, u = o === "right" ? s.left.x : 0, d = o === "left" ? s.right.x : 0, f = t.top - r + c > a, p = r - t.bottom - l > a, m = t.left - n + u > a, h = n - t.right - d > a;
		return f || p || m || h;
	});
}
function Jp(e, t, n) {
	var r = t + "EventListener";
	["transitionend", "webkitTransitionEnd"].forEach(function(t) {
		e[r](t, n);
	});
}
function Yp(e, t) {
	for (var n = t; n;) {
		if (e.contains(n)) return !0;
		n = n.getRootNode == null ? void 0 : n.getRootNode()?.host;
	}
	return !1;
}
var Xp = { isTouch: !1 }, Zp = 0;
function Qp() {
	Xp.isTouch || (Xp.isTouch = !0, window.performance && document.addEventListener("mousemove", $p));
}
function $p() {
	var e = performance.now();
	e - Zp < 20 && (Xp.isTouch = !1, document.removeEventListener("mousemove", $p)), Zp = e;
}
function em() {
	var e = document.activeElement;
	if (Hp(e)) {
		var t = e._tippy;
		e.blur && !t.state.isVisible && e.blur();
	}
}
function tm() {
	document.addEventListener("touchstart", Qp, Cp), window.addEventListener("blur", em);
}
var nm = typeof window < "u" && typeof document < "u" ? !!window.msCrypto : !1;
function rm(e) {
	var t = e === "destroy" ? "n already-" : " ";
	return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function im(e) {
	return e.replace(/[ \t]{2,}/g, " ").replace(/^[ \t]*/gm, "").trim();
}
function am(e) {
	return im("\n  %ctippy.js\n\n  %c" + im(e) + "\n\n  %c👷‍ This is a development-only message. It will be removed in production.\n  ");
}
function om(e) {
	return [
		am(e),
		"color: #00C584; font-size: 1.3em; font-weight: bold;",
		"line-height: 1.5",
		"color: #a6a095;"
	];
}
var sm;
process.env.NODE_ENV !== "production" && cm();
function cm() {
	sm = /* @__PURE__ */ new Set();
}
function lm(e, t) {
	if (e && !sm.has(t)) {
		var n;
		sm.add(t), (n = console).warn.apply(n, om(t));
	}
}
function um(e, t) {
	if (e && !sm.has(t)) {
		var n;
		sm.add(t), (n = console).error.apply(n, om(t));
	}
}
function dm(e) {
	var t = !e, n = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
	um(t, [
		"tippy() was passed",
		"`" + String(e) + "`",
		"as its targets (first) argument. Valid types are: String, Element,",
		"Element[], or NodeList."
	].join(" ")), um(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var fm = {
	animateFill: !1,
	followCursor: !1,
	inlinePositioning: !1,
	sticky: !1
}, pm = Object.assign({
	appendTo: wp,
	aria: {
		content: "auto",
		expanded: "auto"
	},
	delay: 0,
	duration: [300, 250],
	getReferenceClientRect: null,
	hideOnClick: !0,
	ignoreAttributes: !1,
	interactive: !1,
	interactiveBorder: 2,
	interactiveDebounce: 0,
	moveTransition: "",
	offset: [0, 10],
	onAfterUpdate: function() {},
	onBeforeUpdate: function() {},
	onCreate: function() {},
	onDestroy: function() {},
	onHidden: function() {},
	onHide: function() {},
	onMount: function() {},
	onShow: function() {},
	onShown: function() {},
	onTrigger: function() {},
	onUntrigger: function() {},
	onClickOutside: function() {},
	placement: "top",
	plugins: [],
	popperOptions: {},
	render: null,
	showOnCreate: !1,
	touch: !0,
	trigger: "mouseenter focus",
	triggerTarget: null
}, fm, {
	allowHTML: !1,
	animation: "fade",
	arrow: !0,
	content: "",
	inertia: !1,
	maxWidth: 350,
	role: "tooltip",
	theme: "",
	zIndex: 9999
}), mm = Object.keys(pm), hm = function(e) {
	process.env.NODE_ENV !== "production" && ym(e, []), Object.keys(e).forEach(function(t) {
		pm[t] = e[t];
	});
};
function gm(e) {
	var t = (e.plugins || []).reduce(function(t, n) {
		var r = n.name, i = n.defaultValue;
		return r && (t[r] = e[r] === void 0 ? pm[r] ?? i : e[r]), t;
	}, {});
	return Object.assign({}, e, t);
}
function _m(e, t) {
	return (t ? Object.keys(gm(Object.assign({}, pm, { plugins: t }))) : mm).reduce(function(t, n) {
		var r = (e.getAttribute("data-tippy-" + n) || "").trim();
		if (!r) return t;
		if (n === "content") t[n] = r;
		else try {
			t[n] = JSON.parse(r);
		} catch {
			t[n] = r;
		}
		return t;
	}, {});
}
function vm(e, t) {
	var n = Object.assign({}, t, { content: Op(t.content, [e]) }, t.ignoreAttributes ? {} : _m(e, t.plugins));
	return n.aria = Object.assign({}, pm.aria, n.aria), n.aria = {
		expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
		content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
	}, n;
}
function ym(e, t) {
	e === void 0 && (e = {}), t === void 0 && (t = []), Object.keys(e).forEach(function(e) {
		var n = !Tp(Ap(pm, Object.keys(fm)), e);
		n &&= t.filter(function(t) {
			return t.name === e;
		}).length === 0, lm(n, [
			"`" + e + "`",
			"is not a valid prop. You may have spelled it incorrectly, or if it's",
			"a plugin, forgot to pass it in an array as props.plugins.",
			"\n\n",
			"All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
			"Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
		].join(" "));
	});
}
var bm = function() {
	return "innerHTML";
};
function xm(e, t) {
	e[bm()] = t;
}
function Sm(e) {
	var t = Rp();
	return e === !0 ? t.className = xp : (t.className = Sp, zp(e) ? t.appendChild(e) : xm(t, e)), t;
}
function Cm(e, t) {
	zp(t.content) ? (xm(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? xm(e, t.content) : e.textContent = t.content);
}
function wm(e) {
	var t = e.firstElementChild, n = Ip(t.children);
	return {
		box: t,
		content: n.find(function(e) {
			return e.classList.contains(yp);
		}),
		arrow: n.find(function(e) {
			return e.classList.contains(xp) || e.classList.contains(Sp);
		}),
		backdrop: n.find(function(e) {
			return e.classList.contains(bp);
		})
	};
}
function Tm(e) {
	var t = Rp(), n = Rp();
	n.className = vp, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
	var r = Rp();
	r.className = yp, r.setAttribute("data-state", "hidden"), Cm(r, e.props), t.appendChild(n), n.appendChild(r), i(e.props, e.props);
	function i(n, r) {
		var i = wm(t), a = i.box, o = i.content, s = i.arrow;
		r.theme ? a.setAttribute("data-theme", r.theme) : a.removeAttribute("data-theme"), typeof r.animation == "string" ? a.setAttribute("data-animation", r.animation) : a.removeAttribute("data-animation"), r.inertia ? a.setAttribute("data-inertia", "") : a.removeAttribute("data-inertia"), a.style.maxWidth = typeof r.maxWidth == "number" ? r.maxWidth + "px" : r.maxWidth, r.role ? a.setAttribute("role", r.role) : a.removeAttribute("role"), (n.content !== r.content || n.allowHTML !== r.allowHTML) && Cm(o, e.props), r.arrow ? s ? n.arrow !== r.arrow && (a.removeChild(s), a.appendChild(Sm(r.arrow))) : a.appendChild(Sm(r.arrow)) : s && a.removeChild(s);
	}
	return {
		popper: t,
		onUpdate: i
	};
}
Tm.$$tippy = !0;
var Em = 1, Dm = [], Om = [];
function km(e, t) {
	var n = vm(e, Object.assign({}, pm, gm(Lp(t)))), r, i, a, o = !1, s = !1, c = !1, l = !1, u, d, f, p = [], m = kp(R, n.interactiveDebounce), h, g = Em++, _ = null, v = Pp(n.plugins), y = {
		id: g,
		reference: e,
		popper: Rp(),
		popperInstance: _,
		props: n,
		state: {
			isEnabled: !0,
			isVisible: !1,
			isDestroyed: !1,
			isMounted: !1,
			isShown: !1
		},
		plugins: v,
		clearDelayTimeouts: xe,
		setProps: Se,
		setContent: Ce,
		show: we,
		hide: Te,
		hideWithInteractivity: Ee,
		enable: ye,
		disable: be,
		unmount: De,
		destroy: Oe
	};
	/* istanbul ignore if */
	if (!n.render) return process.env.NODE_ENV !== "production" && um(!0, "render() function has not been supplied."), y;
	var b = n.render(y), x = b.popper, S = b.onUpdate;
	x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + y.id, y.popper = x, e._tippy = y, x._tippy = y;
	var C = v.map(function(e) {
		return e.fn(y);
	}), w = e.hasAttribute("aria-expanded");
	return ce(), F(), M(), N("onCreate", [y]), n.showOnCreate && _e(), x.addEventListener("mouseenter", function() {
		y.props.interactive && y.state.isVisible && y.clearDelayTimeouts();
	}), x.addEventListener("mouseleave", function() {
		y.props.interactive && y.props.trigger.indexOf("mouseenter") >= 0 && k().addEventListener("mousemove", m);
	}), y;
	function T() {
		var e = y.props.touch;
		return Array.isArray(e) ? e : [e, 0];
	}
	function E() {
		return T()[0] === "hold";
	}
	function D() {
		var e;
		return !!((e = y.props.render) != null && e.$$tippy);
	}
	function O() {
		return h || e;
	}
	function k() {
		var e = O().parentNode;
		return e ? Kp(e) : document;
	}
	function A() {
		return wm(x);
	}
	function j(e) {
		return y.state.isMounted && !y.state.isVisible || Xp.isTouch || u && u.type === "focus" ? 0 : Ep(y.props.delay, e ? 0 : 1, pm.delay);
	}
	function M(e) {
		e === void 0 && (e = !1), x.style.pointerEvents = y.props.interactive && !e ? "" : "none", x.style.zIndex = "" + y.props.zIndex;
	}
	function N(e, t, n) {
		if (n === void 0 && (n = !0), C.forEach(function(n) {
			n[e] && n[e].apply(n, t);
		}), n) {
			var r;
			(r = y.props)[e].apply(r, t);
		}
	}
	function P() {
		var t = y.props.aria;
		if (t.content) {
			var n = "aria-" + t.content, r = x.id;
			Mp(y.props.triggerTarget || e).forEach(function(e) {
				var t = e.getAttribute(n);
				if (y.state.isVisible) e.setAttribute(n, t ? t + " " + r : r);
				else {
					var i = t && t.replace(r, "").trim();
					i ? e.setAttribute(n, i) : e.removeAttribute(n);
				}
			});
		}
	}
	function F() {
		w || !y.props.aria.expanded || Mp(y.props.triggerTarget || e).forEach(function(e) {
			y.props.interactive ? e.setAttribute("aria-expanded", y.state.isVisible && e === O() ? "true" : "false") : e.removeAttribute("aria-expanded");
		});
	}
	function ee() {
		k().removeEventListener("mousemove", m), Dm = Dm.filter(function(e) {
			return e !== m;
		});
	}
	function te(t) {
		if (!(Xp.isTouch && (c || t.type === "mousedown"))) {
			var n = t.composedPath && t.composedPath()[0] || t.target;
			if (!(y.props.interactive && Yp(x, n))) {
				if (Mp(y.props.triggerTarget || e).some(function(e) {
					return Yp(e, n);
				})) {
					if (Xp.isTouch || y.state.isVisible && y.props.trigger.indexOf("click") >= 0) return;
				} else N("onClickOutside", [y, t]);
				y.props.hideOnClick === !0 && (y.clearDelayTimeouts(), y.hide(), s = !0, setTimeout(function() {
					s = !1;
				}), y.state.isMounted || ie());
			}
		}
	}
	function ne() {
		c = !0;
	}
	function re() {
		c = !1;
	}
	function I() {
		var e = k();
		e.addEventListener("mousedown", te, !0), e.addEventListener("touchend", te, Cp), e.addEventListener("touchstart", re, Cp), e.addEventListener("touchmove", ne, Cp);
	}
	function ie() {
		var e = k();
		e.removeEventListener("mousedown", te, !0), e.removeEventListener("touchend", te, Cp), e.removeEventListener("touchstart", re, Cp), e.removeEventListener("touchmove", ne, Cp);
	}
	function ae(e, t) {
		se(e, function() {
			!y.state.isVisible && x.parentNode && x.parentNode.contains(x) && t();
		});
	}
	function oe(e, t) {
		se(e, t);
	}
	function se(e, t) {
		var n = A().box;
		function r(e) {
			e.target === n && (Jp(n, "remove", r), t());
		}
		if (e === 0) return t();
		Jp(n, "remove", d), Jp(n, "add", r), d = r;
	}
	function L(t, n, r) {
		r === void 0 && (r = !1), Mp(y.props.triggerTarget || e).forEach(function(e) {
			e.addEventListener(t, n, r), p.push({
				node: e,
				eventType: t,
				handler: n,
				options: r
			});
		});
	}
	function ce() {
		E() && (L("touchstart", ue, { passive: !0 }), L("touchend", de, { passive: !0 })), jp(y.props.trigger).forEach(function(e) {
			if (e !== "manual") switch (L(e, ue), e) {
				case "mouseenter":
					L("mouseleave", de);
					break;
				case "focus":
					L(nm ? "focusout" : "blur", fe);
					break;
				case "focusin":
					L("focusout", fe);
					break;
			}
		});
	}
	function le() {
		p.forEach(function(e) {
			var t = e.node, n = e.eventType, r = e.handler, i = e.options;
			t.removeEventListener(n, r, i);
		}), p = [];
	}
	function ue(e) {
		var t = !1;
		if (!(!y.state.isEnabled || pe(e) || s)) {
			var n = u?.type === "focus";
			u = e, h = e.currentTarget, F(), !y.state.isVisible && Vp(e) && Dm.forEach(function(t) {
				return t(e);
			}), e.type === "click" && (y.props.trigger.indexOf("mouseenter") < 0 || o) && y.props.hideOnClick !== !1 && y.state.isVisible ? t = !0 : _e(e), e.type === "click" && (o = !t), t && !n && ve(e);
		}
	}
	function R(e) {
		var t = e.target, r = O().contains(t) || x.contains(t);
		e.type === "mousemove" && r || qp(ge().concat(x).map(function(e) {
			var t = e._tippy.popperInstance?.state;
			return t ? {
				popperRect: e.getBoundingClientRect(),
				popperState: t,
				props: n
			} : null;
		}).filter(Boolean), e) && (ee(), ve(e));
	}
	function de(e) {
		if (!(pe(e) || y.props.trigger.indexOf("click") >= 0 && o)) {
			if (y.props.interactive) {
				y.hideWithInteractivity(e);
				return;
			}
			ve(e);
		}
	}
	function fe(e) {
		y.props.trigger.indexOf("focusin") < 0 && e.target !== O() || y.props.interactive && e.relatedTarget && x.contains(e.relatedTarget) || ve(e);
	}
	function pe(e) {
		return Xp.isTouch ? E() !== e.type.indexOf("touch") >= 0 : !1;
	}
	function me() {
		z();
		var t = y.props, n = t.popperOptions, r = t.placement, i = t.offset, a = t.getReferenceClientRect, o = t.moveTransition, s = D() ? wm(x).arrow : null, c = a ? {
			getBoundingClientRect: a,
			contextElement: a.contextElement || O()
		} : e, l = [
			{
				name: "offset",
				options: { offset: i }
			},
			{
				name: "preventOverflow",
				options: { padding: {
					top: 2,
					bottom: 2,
					left: 5,
					right: 5
				} }
			},
			{
				name: "flip",
				options: { padding: 5 }
			},
			{
				name: "computeStyles",
				options: { adaptive: !o }
			},
			{
				name: "$$tippy",
				enabled: !0,
				phase: "beforeWrite",
				requires: ["computeStyles"],
				fn: function(e) {
					var t = e.state;
					if (D()) {
						var n = A().box;
						[
							"placement",
							"reference-hidden",
							"escaped"
						].forEach(function(e) {
							e === "placement" ? n.setAttribute("data-placement", t.placement) : t.attributes.popper["data-popper-" + e] ? n.setAttribute("data-" + e, "") : n.removeAttribute("data-" + e);
						}), t.attributes.popper = {};
					}
				}
			}
		];
		D() && s && l.push({
			name: "arrow",
			options: {
				element: s,
				padding: 3
			}
		}), l.push.apply(l, n?.modifiers || []), y.popperInstance = _p(c, x, Object.assign({}, n, {
			placement: r,
			onFirstUpdate: f,
			modifiers: l
		}));
	}
	function z() {
		y.popperInstance &&= (y.popperInstance.destroy(), null);
	}
	function he() {
		var e = y.props.appendTo, t, n = O();
		/* istanbul ignore else */
		t = y.props.interactive && e === wp || e === "parent" ? n.parentNode : Op(e, [n]), t.contains(x) || t.appendChild(x), y.state.isMounted = !0, me(), process.env.NODE_ENV !== "production" && lm(y.props.interactive && e === pm.appendTo && n.nextElementSibling !== x, [
			"Interactive tippy element may not be accessible via keyboard",
			"navigation because it is not directly after the reference element",
			"in the DOM source order.",
			"\n\n",
			"Using a wrapper <div> or <span> tag around the reference element",
			"solves this by creating a new parentNode context.",
			"\n\n",
			"Specifying `appendTo: document.body` silences this warning, but it",
			"assumes you are using a focus management solution to handle",
			"keyboard navigation.",
			"\n\n",
			"See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"
		].join(" "));
	}
	function ge() {
		return Ip(x.querySelectorAll("[data-tippy-root]"));
	}
	function _e(e) {
		y.clearDelayTimeouts(), e && N("onTrigger", [y, e]), I();
		var t = j(!0), n = T(), i = n[0], a = n[1];
		Xp.isTouch && i === "hold" && a && (t = a), t ? r = setTimeout(function() {
			y.show();
		}, t) : y.show();
	}
	function ve(e) {
		if (y.clearDelayTimeouts(), N("onUntrigger", [y, e]), !y.state.isVisible) {
			ie();
			return;
		}
		if (!(y.props.trigger.indexOf("mouseenter") >= 0 && y.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(e.type) >= 0 && o)) {
			var t = j(!1);
			t ? i = setTimeout(function() {
				y.state.isVisible && y.hide();
			}, t) : a = requestAnimationFrame(function() {
				y.hide();
			});
		}
	}
	function ye() {
		y.state.isEnabled = !0;
	}
	function be() {
		y.hide(), y.state.isEnabled = !1;
	}
	function xe() {
		clearTimeout(r), clearTimeout(i), cancelAnimationFrame(a);
	}
	function Se(t) {
		/* istanbul ignore else */
		if (process.env.NODE_ENV !== "production" && lm(y.state.isDestroyed, rm("setProps")), !y.state.isDestroyed) {
			N("onBeforeUpdate", [y, t]), le();
			var n = y.props, r = vm(e, Object.assign({}, n, Lp(t), { ignoreAttributes: !0 }));
			y.props = r, ce(), n.interactiveDebounce !== r.interactiveDebounce && (ee(), m = kp(R, r.interactiveDebounce)), n.triggerTarget && !r.triggerTarget ? Mp(n.triggerTarget).forEach(function(e) {
				e.removeAttribute("aria-expanded");
			}) : r.triggerTarget && e.removeAttribute("aria-expanded"), F(), M(), S && S(n, r), y.popperInstance && (me(), ge().forEach(function(e) {
				requestAnimationFrame(e._tippy.popperInstance.forceUpdate);
			})), N("onAfterUpdate", [y, t]);
		}
	}
	function Ce(e) {
		y.setProps({ content: e });
	}
	function we() {
		/* istanbul ignore else */
		process.env.NODE_ENV !== "production" && lm(y.state.isDestroyed, rm("show"));
		var e = y.state.isVisible, t = y.state.isDestroyed, n = !y.state.isEnabled, r = Xp.isTouch && !y.props.touch, i = Ep(y.props.duration, 0, pm.duration);
		if (!(e || t || n || r) && !O().hasAttribute("disabled") && (N("onShow", [y], !1), y.props.onShow(y) !== !1)) {
			if (y.state.isVisible = !0, D() && (x.style.visibility = "visible"), M(), I(), y.state.isMounted || (x.style.transition = "none"), D()) {
				var a = A(), o = a.box, s = a.content;
				Wp([o, s], 0);
			}
			f = function() {
				var e;
				if (!(!y.state.isVisible || l)) {
					if (l = !0, x.offsetHeight, x.style.transition = y.props.moveTransition, D() && y.props.animation) {
						var t = A(), n = t.box, r = t.content;
						Wp([n, r], i), Gp([n, r], "visible");
					}
					P(), F(), Np(Om, y), (e = y.popperInstance) == null || e.forceUpdate(), N("onMount", [y]), y.props.animation && D() && oe(i, function() {
						y.state.isShown = !0, N("onShown", [y]);
					});
				}
			}, he();
		}
	}
	function Te() {
		/* istanbul ignore else */
		process.env.NODE_ENV !== "production" && lm(y.state.isDestroyed, rm("hide"));
		var e = !y.state.isVisible, t = y.state.isDestroyed, n = !y.state.isEnabled, r = Ep(y.props.duration, 1, pm.duration);
		if (!(e || t || n) && (N("onHide", [y], !1), y.props.onHide(y) !== !1)) {
			if (y.state.isVisible = !1, y.state.isShown = !1, l = !1, o = !1, D() && (x.style.visibility = "hidden"), ee(), ie(), M(!0), D()) {
				var i = A(), a = i.box, s = i.content;
				y.props.animation && (Wp([a, s], r), Gp([a, s], "hidden"));
			}
			P(), F(), y.props.animation ? D() && ae(r, y.unmount) : y.unmount();
		}
	}
	function Ee(e) {
		process.env.NODE_ENV !== "production" && lm(y.state.isDestroyed, rm("hideWithInteractivity")), k().addEventListener("mousemove", m), Np(Dm, m), m(e);
	}
	function De() {
		/* istanbul ignore else */
		process.env.NODE_ENV !== "production" && lm(y.state.isDestroyed, rm("unmount")), y.state.isVisible && y.hide(), y.state.isMounted && (z(), ge().forEach(function(e) {
			e._tippy.unmount();
		}), x.parentNode && x.parentNode.removeChild(x), Om = Om.filter(function(e) {
			return e !== y;
		}), y.state.isMounted = !1, N("onHidden", [y]));
	}
	function Oe() {
		/* istanbul ignore else */
		process.env.NODE_ENV !== "production" && lm(y.state.isDestroyed, rm("destroy")), !y.state.isDestroyed && (y.clearDelayTimeouts(), y.unmount(), le(), delete e._tippy, y.state.isDestroyed = !0, N("onDestroy", [y]));
	}
}
function Am(e, t) {
	t === void 0 && (t = {});
	var n = pm.plugins.concat(t.plugins || []);
	process.env.NODE_ENV !== "production" && (dm(e), ym(t, n)), tm();
	var r = Object.assign({}, t, { plugins: n }), i = Up(e);
	/* istanbul ignore else */
	if (process.env.NODE_ENV !== "production") {
		var a = zp(r.content), o = i.length > 1;
		lm(a && o, [
			"tippy() was passed an Element as the `content` prop, but more than",
			"one tippy instance was created by this invocation. This means the",
			"content element will only be appended to the last tippy instance.",
			"\n\n",
			"Instead, pass the .innerHTML of the element, or use a function that",
			"returns a cloned version of the element instead.",
			"\n\n",
			"1) content: element.innerHTML\n",
			"2) content: () => element.cloneNode(true)"
		].join(" "));
	}
	var s = i.reduce(function(e, t) {
		var n = t && km(t, r);
		return n && e.push(n), e;
	}, []);
	return zp(e) ? s[0] : s;
}
Am.defaultProps = pm, Am.setDefaultProps = hm, Am.currentInput = Xp, Object.assign({}, Ud, { effect: function(e) {
	var t = e.state, n = {
		popper: {
			position: t.options.strategy,
			left: "0",
			top: "0",
			margin: "0"
		},
		arrow: { position: "absolute" },
		reference: {}
	};
	Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow);
} }), Am.setDefaultProps({ render: Tm });
//#endregion
//#region src/components/popover/tipster.ts
function jm(e) {
	return typeof e == "function";
}
var Mm;
function Nm(e) {
	Mm &&= (Mm?.destroy(!0), void 0), e?.remove && e.remove();
}
function Pm(e) {
	let { title: t, options: n, menuItems: r = [], coords: i, callback: a, config: o } = e, { target: s, items: c } = e;
	if (!n?.length && !c?.length && !r) return;
	Nm();
	let l = document.createElement("div"), u;
	return s ||= i?.evt?.target, s && (Mm = Am(s, {
		content: () => (c = c?.filter((e) => !e.hide && !e.disabled).map((e) => ({
			...e,
			onClick: () => {
				Nm(l), jm(e.onClick) && e.onClick();
			}
		})) || n?.filter((e) => !e.hide && !e.disabled).map((e) => ({
			text: typeof e == "object" ? e.option : e,
			style: e.style,
			onClick: () => {
				e.subMenu ? Mm.setContent("IMPLEMENT SUB MENU") : jm(e.onClick) ? (Nm(l), e.onClick()) : jm(a) && a && (Nm(l), a(typeof e == "object" ? {
					...e,
					coords: i
				} : e));
			}
		})), u = Sd(l, [{
			text: t,
			items: c
		}, ...r]).focusElement, l),
		theme: "light-border",
		trigger: "click",
		onShown: () => {
			u && setTimeout(() => u?.focus(), 0);
		},
		...o
	}), Mm.show(), Mm.setProps({ interactive: !0 })), Mm;
}
//#endregion
//#region src/components/courts/courts.ts
var Y = "court-line";
function X(e, t) {
	let n = document.createElementNS("http://www.w3.org/2000/svg", e);
	for (let [e, r] of Object.entries(t)) n.setAttribute(e, r);
	return n;
}
function Fm(e, t) {
	let n = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	return n.setAttribute("viewBox", e), n.setAttribute("class", t), n.setAttribute("fill", "none"), n.style.width = "100%", n.style.height = "auto", n.style.display = "block", n;
}
function Im(e) {
	let t = Fm("0 0 360 780", e);
	for (let e of [
		"M 0 0 L 360 0 L 360 780 L 0 780 Z",
		"M 45 0 L 45 780",
		"M 315 0 L 315 780",
		"M 0 390 L 360 390",
		"M 45 210 L 315 210",
		"M 45 570 L 315 570",
		"M 180 210 L 180 570",
		"M 180 0 L 180 20",
		"M 180 760 L 180 780"
	]) t.appendChild(X("path", {
		d: e,
		class: Y
	}));
	return t;
}
function Lm(e) {
	let t = Fm("0 0 500 470", e), n = [
		X("rect", {
			x: "0",
			y: "0",
			width: "500",
			height: "470",
			class: Y
		}),
		X("circle", {
			cx: "250",
			cy: "470",
			r: "60",
			class: Y
		}),
		X("line", {
			x1: "0",
			y1: "470",
			x2: "500",
			y2: "470",
			class: Y
		}),
		X("rect", {
			x: "170",
			y: "0",
			width: "160",
			height: "190",
			class: Y
		}),
		X("circle", {
			cx: "250",
			cy: "190",
			r: "60",
			class: Y
		}),
		X("line", {
			x1: "220",
			y1: "40",
			x2: "280",
			y2: "40",
			class: Y
		}),
		X("circle", {
			cx: "250",
			cy: "52",
			r: "12",
			class: Y
		}),
		X("path", {
			d: "M 30 0 L 30 90 A 220 220 0 0 0 470 90 L 470 0",
			class: Y
		})
	];
	for (let e of n) t.appendChild(e);
	return t;
}
function Rm(e) {
	let t = Fm("0 0 500 440", e), n = [
		X("path", {
			d: "M 20 170 A 350 400 0 0 1 480 170",
			class: Y
		}),
		X("line", {
			x1: "250",
			y1: "400",
			x2: "20",
			y2: "170",
			class: Y
		}),
		X("line", {
			x1: "250",
			y1: "400",
			x2: "480",
			y2: "170",
			class: Y
		}),
		X("path", {
			d: "M 250 400 L 314 336 L 250 273 L 186 336 Z",
			class: Y
		}),
		X("path", {
			d: "M 340 355 A 100 100 0 0 1 160 355",
			class: Y
		}),
		X("line", {
			x1: "340",
			y1: "355",
			x2: "265",
			y2: "405",
			class: Y
		}),
		X("line", {
			x1: "160",
			y1: "355",
			x2: "235",
			y2: "405",
			class: Y
		}),
		X("path", {
			d: "M 235 405 A 18 18 0 0 1 265 405",
			class: Y
		}),
		X("circle", {
			cx: "250",
			cy: "340",
			r: "9",
			class: Y
		}),
		X("line", {
			x1: "247",
			y1: "339",
			x2: "253",
			y2: "339",
			class: Y
		}),
		X("path", {
			d: "M 244 398 L 244 404 L 250 408 L 256 404 L 256 398 Z",
			class: Y
		}),
		X("rect", {
			x: "310",
			y: "332",
			width: "8",
			height: "8",
			transform: "rotate(45 314 336)",
			class: Y
		}),
		X("rect", {
			x: "246",
			y: "269",
			width: "8",
			height: "8",
			transform: "rotate(45 250 273)",
			class: Y
		}),
		X("rect", {
			x: "182",
			y: "332",
			width: "8",
			height: "8",
			transform: "rotate(45 186 336)",
			class: Y
		}),
		X("rect", {
			x: "230",
			y: "393",
			width: "8",
			height: "18",
			class: Y
		}),
		X("rect", {
			x: "262",
			y: "393",
			width: "8",
			height: "18",
			class: Y
		})
	];
	for (let e of n) t.appendChild(e);
	return t;
}
function zm(e) {
	let t = Fm("0 0 850 2000", e), n = [
		X("rect", {
			x: "0",
			y: "0",
			width: "850",
			height: "2000",
			rx: "280",
			ry: "280",
			class: Y
		}),
		X("line", {
			x1: "0",
			y1: "1000",
			x2: "850",
			y2: "1000",
			class: Y
		}),
		X("circle", {
			cx: "425",
			cy: "1000",
			r: "60",
			class: Y
		}),
		X("line", {
			x1: "0",
			y1: "650",
			x2: "850",
			y2: "650",
			class: Y
		}),
		X("line", {
			x1: "0",
			y1: "1350",
			x2: "850",
			y2: "1350",
			class: Y
		}),
		X("line", {
			x1: "140",
			y1: "300",
			x2: "710",
			y2: "300",
			class: Y
		}),
		X("line", {
			x1: "140",
			y1: "1700",
			x2: "710",
			y2: "1700",
			class: Y
		}),
		X("path", {
			d: "M 395 300 A 40 40 0 0 1 455 300",
			class: Y
		}),
		X("path", {
			d: "M 395 1700 A 40 40 0 0 0 455 1700",
			class: Y
		}),
		X("circle", {
			cx: "270",
			cy: "650",
			r: "50",
			class: Y
		}),
		X("circle", {
			cx: "580",
			cy: "650",
			r: "50",
			class: Y
		}),
		X("circle", {
			cx: "270",
			cy: "1350",
			r: "50",
			class: Y
		}),
		X("circle", {
			cx: "580",
			cy: "1350",
			r: "50",
			class: Y
		})
	];
	for (let e of n) t.appendChild(e);
	return t;
}
function Bm(e) {
	let t = Fm("0 0 200 440", e);
	for (let e of [
		"M 0 0 L 200 0 L 200 440 L 0 440 Z",
		"M 0 220 L 200 220",
		"M 0 150 L 200 150",
		"M 0 290 L 200 290",
		"M 100 0 L 100 150",
		"M 100 290 L 100 440"
	]) t.appendChild(X("path", {
		d: e,
		class: Y
	}));
	return t;
}
function Vm(e) {
	let t = Fm("0 0 200 440", e);
	for (let e of [
		"M 0 0 L 200 0 L 200 440 L 0 440 Z",
		"M 18 0 L 18 440",
		"M 182 0 L 182 440",
		"M 0 220 L 200 220",
		"M 0 146 L 200 146",
		"M 0 294 L 200 294",
		"M 0 30 L 200 30",
		"M 0 410 L 200 410",
		"M 100 146 L 100 220",
		"M 100 220 L 100 294"
	]) t.appendChild(X("path", {
		d: e,
		class: Y
	}));
	return t;
}
function Hm(e) {
	let t = Fm("0 0 100 200", e);
	for (let e of [
		"M 0 0 L 100 0 L 100 200 L 0 200 Z",
		"M 0 100 L 100 100",
		"M 0 69.5 L 100 69.5",
		"M 0 130.5 L 100 130.5",
		"M 50 69.5 L 50 67.5",
		"M 50 130.5 L 50 132.5"
	]) t.appendChild(X("path", {
		d: e,
		class: Y
	}));
	return t;
}
//#endregion
//#region src/version.ts
function Um() {
	return "0.9.28-beta.34";
}
//#endregion
//#region src/constants/matchUpFormats.ts
var Wm = {
	SET3_S6_TB7: "SET3-S:6/TB7",
	SET3_S6_TB7_F_TB10: "SET3-S:6/TB7-F:TB10",
	SET3_S6_TB10: "SET3-S:6/TB10",
	SET3_S6_F_TB10: "SET3-S:6-F:TB10",
	SET3_S6_TB7_NOAD: "SET3-S:6/TB7NOAD",
	SET3_S8_TB7: "SET3-S:8/TB7",
	SET3_S8_TB7_AT7: "SET3-S:8/TB7@7",
	SET3_S4_TB7: "SET3-S:4/TB7",
	SET3_S4_TB7_F_TB10: "SET3-S:4/TB7-F:TB10",
	SET3_S4_TB5_AT3_F_TB10: "SET3-S:4/TB5@3-F:TB10",
	SET5_S6_TB7: "SET5-S:6/TB7",
	SET5_S6_TB7_F_TB10: "SET5-S:6/TB7-F:TB10",
	SET1_S6_TB7: "SET1-S:6/TB7",
	SET1_S6_TB10: "SET1-S:6/TB10",
	SET1_S6_TB7_AT5: "SET1-S:6/TB7@5",
	SET1_S8_TB7: "SET1-S:8/TB7",
	SET1_S4_TB7: "SET1-S:4/TB7",
	SET1_S5_TB9_AT4: "SET1-S:5/TB9@4",
	SET1_S_TB7: "SET1-S:T7",
	SET1_S_TB10: "SET1-S:TB10",
	SET1_S_TB21: "SET1-S:T21",
	SET1_S8: "SET1-S:8",
	SET1_S10: "SET1-S:10",
	FAST4: "SET5-S:4/NOAD",
	SET3X_T10A_TB1: "SET3XA-S:T10-F:TB1",
	SET3X_T10A_TB1_NOAD: "SET3XA-S:T10-F:TB1NOAD",
	SET4X_T10A_TB1: "SET4XA-S:T10-F:TB1"
};
//#endregion
//#region src/components/forms/renderButtons.ts
function Gm(e, t, n) {
	if (!e) return { elements: {} };
	let r = {};
	for (let i of t || []) {
		if (!i?.label || i.hide) continue;
		let t = document.createElement("button");
		i.id && (r[i.id] = t, t.id = i.id), t.style.marginRight = ".5em", t.className = "button font-medium", i.intent && t.classList.add(i.intent), t.innerHTML = i.label, i.disabled && (t.disabled = !0), t.onclick = (e) => {
			e.stopPropagation(), !e.target.disabled && z(i.onClick) && i.onClick(), n && z(n) && n();
		}, e.appendChild(t);
	}
	return { elements: r };
}
//#endregion
//#region src/validators/nameValidator.ts
var Km = (e, t) => (n) => n?.trim().length >= e && (!t || n?.trim().length <= t);
//#endregion
//#region src/validators/numericValidator.ts
function qm(e) {
	return h.isConvertableInteger(e) && parseInt(e.toString()) >= 0;
}
//#endregion
//#region src/validators/numericRange.ts
var Jm = (e, t) => (n) => qm(n) && Number(n) >= e && Number(n) <= t, Ym = (e) => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-]).{8,12}$/.test(e);
//#endregion
//#region src/validators/dateValidator.ts
function Xm(e) {
	return h.dateTime.dateValidation.test(e);
}
//#endregion
//#region src/validators/wordValidator.ts
var Zm = (e, t) => (n) => {
	let r = (n || "").trim().split(" ").length;
	return r >= e && (!t || r <= t);
}, Qm = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, $m = (e) => Qm.exec(e), eh = /* @__PURE__ */ w({
	dateValidator: () => Xm,
	emailValidator: () => $m,
	nameValidator: () => Km,
	numericRange: () => Jm,
	numericValidator: () => qm,
	passwordValidator: () => Ym,
	wordValidator: () => Zm
}), th = class {
	constructor({ tournamentRecord: e, drawId: t, structureId: n, eventId: r }) {
		this.tournamentRecord = e, this.drawId = t, this.structureId = n, this.eventId = r || e.events?.[0]?.eventId, g.setState(e);
	}
	setRenderCallback(e) {
		this.renderCallback = e;
	}
	getDrawEntryParticipantIds() {
		let { event: e, drawDefinition: t } = g.getEvent({ drawId: this.drawId }) || {};
		if (!e) return [];
		let { flightProfile: n } = g.getFlightProfile({ eventId: this.eventId }) || {};
		return (n?.flights?.find((e) => e.drawId === this.drawId)?.drawEntries || t?.entries || []).map((e) => e.participantId).filter(Boolean);
	}
	getAllParticipants() {
		g.setState(this.tournamentRecord);
		let e = this.getDrawEntryParticipantIds();
		if (!e.length) return [];
		let { participants: t = [] } = g.getParticipants({ participantFilters: { participantIds: e } }) || {};
		return t.map((e) => ({
			participantId: e.participantId,
			participantName: e.participantName,
			participantType: e.participantType,
			person: e.person,
			individualParticipants: e.individualParticipants
		}));
	}
	getAvailableParticipants() {
		g.setState(this.tournamentRecord);
		let e = this.getAllParticipants(), { assignedParticipantIds: t = [] } = g.getAssignedParticipantIds({ drawId: this.drawId }) || {};
		return e.filter((e) => !t.includes(e.participantId));
	}
	removeAssignment({ drawPosition: e }) {
		g.setState(this.tournamentRecord);
		let t = this.getMatchUps().find((t) => t.sides?.some((t) => t.drawPosition === e))?.sides?.find((t) => t.drawPosition === e)?.bye === !0, n = g.removeDrawPositionAssignment({
			drawId: this.drawId,
			structureId: this.structureId,
			drawPosition: e
		});
		if (n.error) return {
			success: !1,
			error: n.error
		};
		let { tournamentRecord: r } = g.getState() || {};
		return this.tournamentRecord = r, t && this.renderCallback && this.renderCallback(), { success: !0 };
	}
	assignParticipant({ drawPosition: e, participantId: t }) {
		g.setState(this.tournamentRecord);
		let n = g.assignDrawPosition({
			drawId: this.drawId,
			structureId: this.structureId,
			drawPosition: e,
			participantId: t
		});
		if (n.error) return {
			success: !1,
			error: n.error
		};
		let { tournamentRecord: r } = g.getState() || {};
		return this.tournamentRecord = r, this.focusDrawPosition = e + 1, this.renderCallback && this.renderCallback(), { success: !0 };
	}
	getAndClearFocusDrawPosition() {
		let e = this.focusDrawPosition;
		return this.focusDrawPosition = void 0, e;
	}
	assignBye({ drawPosition: e }) {
		g.setState(this.tournamentRecord);
		let t = g.assignDrawPositionBye({
			drawId: this.drawId,
			structureId: this.structureId,
			drawPosition: e
		});
		if (t.error) return {
			success: !1,
			error: t.error
		};
		let { tournamentRecord: n } = g.getState() || {};
		return this.tournamentRecord = n, this.focusDrawPosition = e + 1, this.renderCallback && this.renderCallback(), { success: !0 };
	}
	assignQualifier({ drawPosition: e }) {
		g.setState(this.tournamentRecord);
		let t = g.assignDrawPosition({
			drawId: this.drawId,
			structureId: this.structureId,
			drawPosition: e,
			qualifier: !0
		});
		if (t.error) return {
			success: !1,
			error: t.error
		};
		let { tournamentRecord: n } = g.getState() || {};
		return this.tournamentRecord = n, this.focusDrawPosition = e + 1, this.renderCallback && this.renderCallback(), { success: !0 };
	}
	getMatchUps() {
		g.setState(this.tournamentRecord);
		let { eventData: e } = g.getEventData({ eventId: this.eventId }) || {}, t = (e?.drawsData?.find((e) => e.drawId === this.drawId))?.structures?.find((e) => e.structureId === this.structureId)?.roundMatchUps;
		return t ? Object.values(t).flat() : [];
	}
	getState() {
		return this.tournamentRecord;
	}
	getContext() {
		return {
			drawId: this.drawId,
			structureId: this.structureId
		};
	}
};
//#endregion
//#region node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ascending.js
function nh(e, t) {
	return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
//#endregion
//#region node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/descending.js
function rh(e, t) {
	return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
//#endregion
//#region node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisector.js
function ih(e) {
	let t, n, r;
	e.length === 2 ? (t = e === nh || e === rh ? e : ah, n = e, r = e) : (t = nh, n = (t, n) => nh(e(t), n), r = (t, n) => e(t) - n);
	function i(e, r, i = 0, a = e.length) {
		if (i < a) {
			if (t(r, r) !== 0) return a;
			do {
				let t = i + a >>> 1;
				n(e[t], r) < 0 ? i = t + 1 : a = t;
			} while (i < a);
		}
		return i;
	}
	function a(e, r, i = 0, a = e.length) {
		if (i < a) {
			if (t(r, r) !== 0) return a;
			do {
				let t = i + a >>> 1;
				n(e[t], r) <= 0 ? i = t + 1 : a = t;
			} while (i < a);
		}
		return i;
	}
	function o(e, t, n = 0, a = e.length) {
		let o = i(e, t, n, a - 1);
		return o > n && r(e[o - 1], t) > -r(e[o], t) ? o - 1 : o;
	}
	return {
		left: i,
		center: o,
		right: a
	};
}
function ah() {
	return 0;
}
//#endregion
//#region node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/number.js
function oh(e) {
	return e === null ? NaN : +e;
}
//#endregion
//#region node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisect.js
var sh = ih(nh), ch = sh.right;
sh.left, ih(oh).center;
//#endregion
//#region node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ticks.js
var lh = Math.sqrt(50), uh = Math.sqrt(10), dh = Math.sqrt(2);
function fh(e, t, n) {
	let r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = r / 10 ** i, o = a >= lh ? 10 : a >= uh ? 5 : a >= dh ? 2 : 1, s, c, l;
	return i < 0 ? (l = 10 ** -i / o, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = 10 ** i * o, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && .5 <= n && n < 2 ? fh(e, t, n * 2) : [
		s,
		c,
		l
	];
}
function ph(e, t, n) {
	if (t = +t, e = +e, n = +n, !(n > 0)) return [];
	if (e === t) return [e];
	let r = t < e, [i, a, o] = r ? fh(t, e, n) : fh(e, t, n);
	if (!(a >= i)) return [];
	let s = a - i + 1, c = Array(s);
	if (r) if (o < 0) for (let e = 0; e < s; ++e) c[e] = (a - e) / -o;
	else for (let e = 0; e < s; ++e) c[e] = (a - e) * o;
	else if (o < 0) for (let e = 0; e < s; ++e) c[e] = (i + e) / -o;
	else for (let e = 0; e < s; ++e) c[e] = (i + e) * o;
	return c;
}
function mh(e, t, n) {
	return t = +t, e = +e, n = +n, fh(e, t, n)[2];
}
function hh(e, t, n) {
	t = +t, e = +e, n = +n;
	let r = t < e, i = r ? mh(t, e, n) : mh(e, t, n);
	return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
//#endregion
//#region node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/range.js
function gh(e, t, n) {
	e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
	for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = Array(i); ++r < i;) a[r] = e + r * n;
	return a;
}
//#endregion
//#region node_modules/.pnpm/d3-dispatch@3.0.1/node_modules/d3-dispatch/src/dispatch.js
var _h = { value: () => {} };
function vh() {
	for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
		if (!(r = arguments[e] + "") || r in n || /[\s.]/.test(r)) throw Error("illegal type: " + r);
		n[r] = [];
	}
	return new yh(n);
}
function yh(e) {
	this._ = e;
}
function bh(e, t) {
	return e.trim().split(/^|\s+/).map(function(e) {
		var n = "", r = e.indexOf(".");
		if (r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), e && !t.hasOwnProperty(e)) throw Error("unknown type: " + e);
		return {
			type: e,
			name: n
		};
	});
}
yh.prototype = vh.prototype = {
	constructor: yh,
	on: function(e, t) {
		var n = this._, r = bh(e + "", n), i, a = -1, o = r.length;
		if (arguments.length < 2) {
			for (; ++a < o;) if ((i = (e = r[a]).type) && (i = xh(n[i], e.name))) return i;
			return;
		}
		if (t != null && typeof t != "function") throw Error("invalid callback: " + t);
		for (; ++a < o;) if (i = (e = r[a]).type) n[i] = Sh(n[i], e.name, t);
		else if (t == null) for (i in n) n[i] = Sh(n[i], e.name, null);
		return this;
	},
	copy: function() {
		var e = {}, t = this._;
		for (var n in t) e[n] = t[n].slice();
		return new yh(e);
	},
	call: function(e, t) {
		if ((i = arguments.length - 2) > 0) for (var n = Array(i), r = 0, i, a; r < i; ++r) n[r] = arguments[r + 2];
		if (!this._.hasOwnProperty(e)) throw Error("unknown type: " + e);
		for (a = this._[e], r = 0, i = a.length; r < i; ++r) a[r].value.apply(t, n);
	},
	apply: function(e, t, n) {
		if (!this._.hasOwnProperty(e)) throw Error("unknown type: " + e);
		for (var r = this._[e], i = 0, a = r.length; i < a; ++i) r[i].value.apply(t, n);
	}
};
function xh(e, t) {
	for (var n = 0, r = e.length, i; n < r; ++n) if ((i = e[n]).name === t) return i.value;
}
function Sh(e, t, n) {
	for (var r = 0, i = e.length; r < i; ++r) if (e[r].name === t) {
		e[r] = _h, e = e.slice(0, r).concat(e.slice(r + 1));
		break;
	}
	return n != null && e.push({
		name: t,
		value: n
	}), e;
}
var Ch = {
	svg: "http://www.w3.org/2000/svg",
	xhtml: "http://www.w3.org/1999/xhtml",
	xlink: "http://www.w3.org/1999/xlink",
	xml: "http://www.w3.org/XML/1998/namespace",
	xmlns: "http://www.w3.org/2000/xmlns/"
};
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/namespace.js
function wh(e) {
	var t = e += "", n = t.indexOf(":");
	return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), Ch.hasOwnProperty(t) ? {
		space: Ch[t],
		local: e
	} : e;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/creator.js
function Th(e) {
	return function() {
		var t = this.ownerDocument, n = this.namespaceURI;
		return n === "http://www.w3.org/1999/xhtml" && t.documentElement.namespaceURI === "http://www.w3.org/1999/xhtml" ? t.createElement(e) : t.createElementNS(n, e);
	};
}
function Eh(e) {
	return function() {
		return this.ownerDocument.createElementNS(e.space, e.local);
	};
}
function Dh(e) {
	var t = wh(e);
	return (t.local ? Eh : Th)(t);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selector.js
function Oh() {}
function kh(e) {
	return e == null ? Oh : function() {
		return this.querySelector(e);
	};
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/select.js
function Ah(e) {
	typeof e != "function" && (e = kh(e));
	for (var t = this._groups, n = t.length, r = Array(n), i = 0; i < n; ++i) for (var a = t[i], o = a.length, s = r[i] = Array(o), c, l, u = 0; u < o; ++u) (c = a[u]) && (l = e.call(c, c.__data__, u, a)) && ("__data__" in c && (l.__data__ = c.__data__), s[u] = l);
	return new v_(r, this._parents);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/array.js
function jh(e) {
	return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selectorAll.js
function Mh() {
	return [];
}
function Nh(e) {
	return e == null ? Mh : function() {
		return this.querySelectorAll(e);
	};
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectAll.js
function Ph(e) {
	return function() {
		return jh(e.apply(this, arguments));
	};
}
function Fh(e) {
	e = typeof e == "function" ? Ph(e) : Nh(e);
	for (var t = this._groups, n = t.length, r = [], i = [], a = 0; a < n; ++a) for (var o = t[a], s = o.length, c, l = 0; l < s; ++l) (c = o[l]) && (r.push(e.call(c, c.__data__, l, o)), i.push(c));
	return new v_(r, i);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/matcher.js
function Ih(e) {
	return function() {
		return this.matches(e);
	};
}
function Lh(e) {
	return function(t) {
		return t.matches(e);
	};
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChild.js
var Rh = Array.prototype.find;
function zh(e) {
	return function() {
		return Rh.call(this.children, e);
	};
}
function Bh() {
	return this.firstElementChild;
}
function Vh(e) {
	return this.select(e == null ? Bh : zh(typeof e == "function" ? e : Lh(e)));
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/selectChildren.js
var Hh = Array.prototype.filter;
function Uh() {
	return Array.from(this.children);
}
function Wh(e) {
	return function() {
		return Hh.call(this.children, e);
	};
}
function Gh(e) {
	return this.selectAll(e == null ? Uh : Wh(typeof e == "function" ? e : Lh(e)));
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/filter.js
function Kh(e) {
	typeof e != "function" && (e = Ih(e));
	for (var t = this._groups, n = t.length, r = Array(n), i = 0; i < n; ++i) for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l) (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
	return new v_(r, this._parents);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sparse.js
function qh(e) {
	return Array(e.length);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/enter.js
function Jh() {
	return new v_(this._enter || this._groups.map(qh), this._parents);
}
function Yh(e, t) {
	this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
Yh.prototype = {
	constructor: Yh,
	appendChild: function(e) {
		return this._parent.insertBefore(e, this._next);
	},
	insertBefore: function(e, t) {
		return this._parent.insertBefore(e, t);
	},
	querySelector: function(e) {
		return this._parent.querySelector(e);
	},
	querySelectorAll: function(e) {
		return this._parent.querySelectorAll(e);
	}
};
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/constant.js
function Xh(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/data.js
function Zh(e, t, n, r, i, a) {
	for (var o = 0, s, c = t.length, l = a.length; o < l; ++o) (s = t[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new Yh(e, a[o]);
	for (; o < c; ++o) (s = t[o]) && (i[o] = s);
}
function Qh(e, t, n, r, i, a, o) {
	var s, c, l = /* @__PURE__ */ new Map(), u = t.length, d = a.length, f = Array(u), p;
	for (s = 0; s < u; ++s) (c = t[s]) && (f[s] = p = o.call(c, c.__data__, s, t) + "", l.has(p) ? i[s] = c : l.set(p, c));
	for (s = 0; s < d; ++s) p = o.call(e, a[s], s, a) + "", (c = l.get(p)) ? (r[s] = c, c.__data__ = a[s], l.delete(p)) : n[s] = new Yh(e, a[s]);
	for (s = 0; s < u; ++s) (c = t[s]) && l.get(f[s]) === c && (i[s] = c);
}
function $h(e) {
	return e.__data__;
}
function eg(e, t) {
	if (!arguments.length) return Array.from(this, $h);
	var n = t ? Qh : Zh, r = this._parents, i = this._groups;
	typeof e != "function" && (e = Xh(e));
	for (var a = i.length, o = Array(a), s = Array(a), c = Array(a), l = 0; l < a; ++l) {
		var u = r[l], d = i[l], f = d.length, p = tg(e.call(u, u && u.__data__, l, r)), m = p.length, h = s[l] = Array(m), g = o[l] = Array(m);
		n(u, d, h, g, c[l] = Array(f), p, t);
		for (var _ = 0, v = 0, y, b; _ < m; ++_) if (y = h[_]) {
			for (_ >= v && (v = _ + 1); !(b = g[v]) && ++v < m;);
			y._next = b || null;
		}
	}
	return o = new v_(o, r), o._enter = s, o._exit = c, o;
}
function tg(e) {
	return typeof e == "object" && "length" in e ? e : Array.from(e);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/exit.js
function ng() {
	return new v_(this._exit || this._groups.map(qh), this._parents);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/join.js
function rg(e, t, n) {
	var r = this.enter(), i = this, a = this.exit();
	return typeof e == "function" ? (r = e(r), r &&= r.selection()) : r = r.append(e + ""), t != null && (i = t(i), i &&= i.selection()), n == null ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/merge.js
function ig(e) {
	for (var t = e.selection ? e.selection() : e, n = this._groups, r = t._groups, i = n.length, a = r.length, o = Math.min(i, a), s = Array(i), c = 0; c < o; ++c) for (var l = n[c], u = r[c], d = l.length, f = s[c] = Array(d), p, m = 0; m < d; ++m) (p = l[m] || u[m]) && (f[m] = p);
	for (; c < i; ++c) s[c] = n[c];
	return new v_(s, this._parents);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/order.js
function ag() {
	for (var e = this._groups, t = -1, n = e.length; ++t < n;) for (var r = e[t], i = r.length - 1, a = r[i], o; --i >= 0;) (o = r[i]) && (a && o.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(o, a), a = o);
	return this;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/sort.js
function og(e) {
	e ||= sg;
	function t(t, n) {
		return t && n ? e(t.__data__, n.__data__) : !t - !n;
	}
	for (var n = this._groups, r = n.length, i = Array(r), a = 0; a < r; ++a) {
		for (var o = n[a], s = o.length, c = i[a] = Array(s), l, u = 0; u < s; ++u) (l = o[u]) && (c[u] = l);
		c.sort(t);
	}
	return new v_(i, this._parents).order();
}
function sg(e, t) {
	return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/call.js
function cg() {
	var e = arguments[0];
	return arguments[0] = this, e.apply(null, arguments), this;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/nodes.js
function lg() {
	return Array.from(this);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/node.js
function ug() {
	for (var e = this._groups, t = 0, n = e.length; t < n; ++t) for (var r = e[t], i = 0, a = r.length; i < a; ++i) {
		var o = r[i];
		if (o) return o;
	}
	return null;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/size.js
function dg() {
	let e = 0;
	for (let t of this) ++e;
	return e;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/empty.js
function fg() {
	return !this.node();
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/each.js
function pg(e) {
	for (var t = this._groups, n = 0, r = t.length; n < r; ++n) for (var i = t[n], a = 0, o = i.length, s; a < o; ++a) (s = i[a]) && e.call(s, s.__data__, a, i);
	return this;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/attr.js
function mg(e) {
	return function() {
		this.removeAttribute(e);
	};
}
function hg(e) {
	return function() {
		this.removeAttributeNS(e.space, e.local);
	};
}
function gg(e, t) {
	return function() {
		this.setAttribute(e, t);
	};
}
function _g(e, t) {
	return function() {
		this.setAttributeNS(e.space, e.local, t);
	};
}
function vg(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
	};
}
function yg(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
	};
}
function bg(e, t) {
	var n = wh(e);
	if (arguments.length < 2) {
		var r = this.node();
		return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
	}
	return this.each((t == null ? n.local ? hg : mg : typeof t == "function" ? n.local ? yg : vg : n.local ? _g : gg)(n, t));
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/window.js
function xg(e) {
	return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/style.js
function Sg(e) {
	return function() {
		this.style.removeProperty(e);
	};
}
function Cg(e, t, n) {
	return function() {
		this.style.setProperty(e, t, n);
	};
}
function wg(e, t, n) {
	return function() {
		var r = t.apply(this, arguments);
		r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
	};
}
function Tg(e, t, n) {
	return arguments.length > 1 ? this.each((t == null ? Sg : typeof t == "function" ? wg : Cg)(e, t, n ?? "")) : Eg(this.node(), e);
}
function Eg(e, t) {
	return e.style.getPropertyValue(t) || xg(e).getComputedStyle(e, null).getPropertyValue(t);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/property.js
function Dg(e) {
	return function() {
		delete this[e];
	};
}
function Og(e, t) {
	return function() {
		this[e] = t;
	};
}
function kg(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		n == null ? delete this[e] : this[e] = n;
	};
}
function Ag(e, t) {
	return arguments.length > 1 ? this.each((t == null ? Dg : typeof t == "function" ? kg : Og)(e, t)) : this.node()[e];
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/classed.js
function jg(e) {
	return e.trim().split(/^|\s+/);
}
function Mg(e) {
	return e.classList || new Ng(e);
}
function Ng(e) {
	this._node = e, this._names = jg(e.getAttribute("class") || "");
}
Ng.prototype = {
	add: function(e) {
		this._names.indexOf(e) < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
	},
	remove: function(e) {
		var t = this._names.indexOf(e);
		t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
	},
	contains: function(e) {
		return this._names.indexOf(e) >= 0;
	}
};
function Pg(e, t) {
	for (var n = Mg(e), r = -1, i = t.length; ++r < i;) n.add(t[r]);
}
function Fg(e, t) {
	for (var n = Mg(e), r = -1, i = t.length; ++r < i;) n.remove(t[r]);
}
function Ig(e) {
	return function() {
		Pg(this, e);
	};
}
function Lg(e) {
	return function() {
		Fg(this, e);
	};
}
function Rg(e, t) {
	return function() {
		(t.apply(this, arguments) ? Pg : Fg)(this, e);
	};
}
function zg(e, t) {
	var n = jg(e + "");
	if (arguments.length < 2) {
		for (var r = Mg(this.node()), i = -1, a = n.length; ++i < a;) if (!r.contains(n[i])) return !1;
		return !0;
	}
	return this.each((typeof t == "function" ? Rg : t ? Ig : Lg)(n, t));
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/text.js
function Bg() {
	this.textContent = "";
}
function Vg(e) {
	return function() {
		this.textContent = e;
	};
}
function Hg(e) {
	return function() {
		this.textContent = e.apply(this, arguments) ?? "";
	};
}
function Ug(e) {
	return arguments.length ? this.each(e == null ? Bg : (typeof e == "function" ? Hg : Vg)(e)) : this.node().textContent;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/html.js
function Wg() {
	this.innerHTML = "";
}
function Gg(e) {
	return function() {
		this.innerHTML = e;
	};
}
function Kg(e) {
	return function() {
		this.innerHTML = e.apply(this, arguments) ?? "";
	};
}
function qg(e) {
	return arguments.length ? this.each(e == null ? Wg : (typeof e == "function" ? Kg : Gg)(e)) : this.node().innerHTML;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/raise.js
function Jg() {
	this.nextSibling && this.parentNode.appendChild(this);
}
function Yg() {
	return this.each(Jg);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/lower.js
function Xg() {
	this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Zg() {
	return this.each(Xg);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/append.js
function Qg(e) {
	var t = typeof e == "function" ? e : Dh(e);
	return this.select(function() {
		return this.appendChild(t.apply(this, arguments));
	});
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/insert.js
function $g() {
	return null;
}
function e_(e, t) {
	var n = typeof e == "function" ? e : Dh(e), r = t == null ? $g : typeof t == "function" ? t : kh(t);
	return this.select(function() {
		return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
	});
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/remove.js
function t_() {
	var e = this.parentNode;
	e && e.removeChild(this);
}
function n_() {
	return this.each(t_);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/clone.js
function r_() {
	var e = this.cloneNode(!1), t = this.parentNode;
	return t ? t.insertBefore(e, this.nextSibling) : e;
}
function i_() {
	var e = this.cloneNode(!0), t = this.parentNode;
	return t ? t.insertBefore(e, this.nextSibling) : e;
}
function a_(e) {
	return this.select(e ? i_ : r_);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/datum.js
function o_(e) {
	return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/on.js
function s_(e) {
	return function(t) {
		e.call(this, t, this.__data__);
	};
}
function c_(e) {
	return e.trim().split(/^|\s+/).map(function(e) {
		var t = "", n = e.indexOf(".");
		return n >= 0 && (t = e.slice(n + 1), e = e.slice(0, n)), {
			type: e,
			name: t
		};
	});
}
function l_(e) {
	return function() {
		var t = this.__on;
		if (t) {
			for (var n = 0, r = -1, i = t.length, a; n < i; ++n) a = t[n], (!e.type || a.type === e.type) && a.name === e.name ? this.removeEventListener(a.type, a.listener, a.options) : t[++r] = a;
			++r ? t.length = r : delete this.__on;
		}
	};
}
function u_(e, t, n) {
	return function() {
		var r = this.__on, i, a = s_(t);
		if (r) {
			for (var o = 0, s = r.length; o < s; ++o) if ((i = r[o]).type === e.type && i.name === e.name) {
				this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = n), i.value = t;
				return;
			}
		}
		this.addEventListener(e.type, a, n), i = {
			type: e.type,
			name: e.name,
			value: t,
			listener: a,
			options: n
		}, r ? r.push(i) : this.__on = [i];
	};
}
function d_(e, t, n) {
	var r = c_(e + ""), i, a = r.length, o;
	if (arguments.length < 2) {
		var s = this.node().__on;
		if (s) {
			for (var c = 0, l = s.length, u; c < l; ++c) for (i = 0, u = s[c]; i < a; ++i) if ((o = r[i]).type === u.type && o.name === u.name) return u.value;
		}
		return;
	}
	for (s = t ? u_ : l_, i = 0; i < a; ++i) this.each(s(r[i], t, n));
	return this;
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/dispatch.js
function f_(e, t, n) {
	var r = xg(e), i = r.CustomEvent;
	typeof i == "function" ? i = new i(t, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(t, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(t, !1, !1)), e.dispatchEvent(i);
}
function p_(e, t) {
	return function() {
		return f_(this, e, t);
	};
}
function m_(e, t) {
	return function() {
		return f_(this, e, t.apply(this, arguments));
	};
}
function h_(e, t) {
	return this.each((typeof t == "function" ? m_ : p_)(e, t));
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/iterator.js
function* g_() {
	for (var e = this._groups, t = 0, n = e.length; t < n; ++t) for (var r = e[t], i = 0, a = r.length, o; i < a; ++i) (o = r[i]) && (yield o);
}
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/selection/index.js
var __ = [null];
function v_(e, t) {
	this._groups = e, this._parents = t;
}
function y_() {
	return new v_([[document.documentElement]], __);
}
function b_() {
	return this;
}
v_.prototype = y_.prototype = {
	constructor: v_,
	select: Ah,
	selectAll: Fh,
	selectChild: Vh,
	selectChildren: Gh,
	filter: Kh,
	data: eg,
	enter: Jh,
	exit: ng,
	join: rg,
	merge: ig,
	selection: b_,
	order: ag,
	sort: og,
	call: cg,
	nodes: lg,
	node: ug,
	size: dg,
	empty: fg,
	each: pg,
	attr: bg,
	style: Tg,
	property: Ag,
	classed: zg,
	text: Ug,
	html: qg,
	raise: Yg,
	lower: Zg,
	append: Qg,
	insert: e_,
	remove: n_,
	clone: a_,
	datum: o_,
	on: d_,
	dispatch: h_,
	[Symbol.iterator]: g_
};
//#endregion
//#region node_modules/.pnpm/d3-selection@3.0.0/node_modules/d3-selection/src/select.js
function x_(e) {
	return typeof e == "string" ? new v_([[document.querySelector(e)]], [document.documentElement]) : new v_([[e]], __);
}
//#endregion
//#region node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/define.js
function S_(e, t, n) {
	e.prototype = t.prototype = n, n.constructor = e;
}
function C_(e, t) {
	var n = Object.create(e.prototype);
	for (var r in t) n[r] = t[r];
	return n;
}
//#endregion
//#region node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/color.js
function w_() {}
var T_ = .7, E_ = 1 / T_, D_ = "\\s*([+-]?\\d+)\\s*", O_ = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", k_ = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", A_ = /^#([0-9a-f]{3,8})$/, j_ = RegExp(`^rgb\\(${D_},${D_},${D_}\\)$`), M_ = RegExp(`^rgb\\(${k_},${k_},${k_}\\)$`), N_ = RegExp(`^rgba\\(${D_},${D_},${D_},${O_}\\)$`), P_ = RegExp(`^rgba\\(${k_},${k_},${k_},${O_}\\)$`), F_ = RegExp(`^hsl\\(${O_},${k_},${k_}\\)$`), I_ = RegExp(`^hsla\\(${O_},${k_},${k_},${O_}\\)$`), L_ = {
	aliceblue: 15792383,
	antiquewhite: 16444375,
	aqua: 65535,
	aquamarine: 8388564,
	azure: 15794175,
	beige: 16119260,
	bisque: 16770244,
	black: 0,
	blanchedalmond: 16772045,
	blue: 255,
	blueviolet: 9055202,
	brown: 10824234,
	burlywood: 14596231,
	cadetblue: 6266528,
	chartreuse: 8388352,
	chocolate: 13789470,
	coral: 16744272,
	cornflowerblue: 6591981,
	cornsilk: 16775388,
	crimson: 14423100,
	cyan: 65535,
	darkblue: 139,
	darkcyan: 35723,
	darkgoldenrod: 12092939,
	darkgray: 11119017,
	darkgreen: 25600,
	darkgrey: 11119017,
	darkkhaki: 12433259,
	darkmagenta: 9109643,
	darkolivegreen: 5597999,
	darkorange: 16747520,
	darkorchid: 10040012,
	darkred: 9109504,
	darksalmon: 15308410,
	darkseagreen: 9419919,
	darkslateblue: 4734347,
	darkslategray: 3100495,
	darkslategrey: 3100495,
	darkturquoise: 52945,
	darkviolet: 9699539,
	deeppink: 16716947,
	deepskyblue: 49151,
	dimgray: 6908265,
	dimgrey: 6908265,
	dodgerblue: 2003199,
	firebrick: 11674146,
	floralwhite: 16775920,
	forestgreen: 2263842,
	fuchsia: 16711935,
	gainsboro: 14474460,
	ghostwhite: 16316671,
	gold: 16766720,
	goldenrod: 14329120,
	gray: 8421504,
	green: 32768,
	greenyellow: 11403055,
	grey: 8421504,
	honeydew: 15794160,
	hotpink: 16738740,
	indianred: 13458524,
	indigo: 4915330,
	ivory: 16777200,
	khaki: 15787660,
	lavender: 15132410,
	lavenderblush: 16773365,
	lawngreen: 8190976,
	lemonchiffon: 16775885,
	lightblue: 11393254,
	lightcoral: 15761536,
	lightcyan: 14745599,
	lightgoldenrodyellow: 16448210,
	lightgray: 13882323,
	lightgreen: 9498256,
	lightgrey: 13882323,
	lightpink: 16758465,
	lightsalmon: 16752762,
	lightseagreen: 2142890,
	lightskyblue: 8900346,
	lightslategray: 7833753,
	lightslategrey: 7833753,
	lightsteelblue: 11584734,
	lightyellow: 16777184,
	lime: 65280,
	limegreen: 3329330,
	linen: 16445670,
	magenta: 16711935,
	maroon: 8388608,
	mediumaquamarine: 6737322,
	mediumblue: 205,
	mediumorchid: 12211667,
	mediumpurple: 9662683,
	mediumseagreen: 3978097,
	mediumslateblue: 8087790,
	mediumspringgreen: 64154,
	mediumturquoise: 4772300,
	mediumvioletred: 13047173,
	midnightblue: 1644912,
	mintcream: 16121850,
	mistyrose: 16770273,
	moccasin: 16770229,
	navajowhite: 16768685,
	navy: 128,
	oldlace: 16643558,
	olive: 8421376,
	olivedrab: 7048739,
	orange: 16753920,
	orangered: 16729344,
	orchid: 14315734,
	palegoldenrod: 15657130,
	palegreen: 10025880,
	paleturquoise: 11529966,
	palevioletred: 14381203,
	papayawhip: 16773077,
	peachpuff: 16767673,
	peru: 13468991,
	pink: 16761035,
	plum: 14524637,
	powderblue: 11591910,
	purple: 8388736,
	rebeccapurple: 6697881,
	red: 16711680,
	rosybrown: 12357519,
	royalblue: 4286945,
	saddlebrown: 9127187,
	salmon: 16416882,
	sandybrown: 16032864,
	seagreen: 3050327,
	seashell: 16774638,
	sienna: 10506797,
	silver: 12632256,
	skyblue: 8900331,
	slateblue: 6970061,
	slategray: 7372944,
	slategrey: 7372944,
	snow: 16775930,
	springgreen: 65407,
	steelblue: 4620980,
	tan: 13808780,
	teal: 32896,
	thistle: 14204888,
	tomato: 16737095,
	turquoise: 4251856,
	violet: 15631086,
	wheat: 16113331,
	white: 16777215,
	whitesmoke: 16119285,
	yellow: 16776960,
	yellowgreen: 10145074
};
S_(w_, H_, {
	copy(e) {
		return Object.assign(new this.constructor(), this, e);
	},
	displayable() {
		return this.rgb().displayable();
	},
	hex: R_,
	formatHex: R_,
	formatHex8: z_,
	formatHsl: B_,
	formatRgb: V_,
	toString: V_
});
function R_() {
	return this.rgb().formatHex();
}
function z_() {
	return this.rgb().formatHex8();
}
function B_() {
	return tv(this).formatHsl();
}
function V_() {
	return this.rgb().formatRgb();
}
function H_(e) {
	var t, n;
	return e = (e + "").trim().toLowerCase(), (t = A_.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? U_(t) : n === 3 ? new q_(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? W_(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? W_(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = j_.exec(e)) ? new q_(t[1], t[2], t[3], 1) : (t = M_.exec(e)) ? new q_(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = N_.exec(e)) ? W_(t[1], t[2], t[3], t[4]) : (t = P_.exec(e)) ? W_(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = F_.exec(e)) ? ev(t[1], t[2] / 100, t[3] / 100, 1) : (t = I_.exec(e)) ? ev(t[1], t[2] / 100, t[3] / 100, t[4]) : L_.hasOwnProperty(e) ? U_(L_[e]) : e === "transparent" ? new q_(NaN, NaN, NaN, 0) : null;
}
function U_(e) {
	return new q_(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function W_(e, t, n, r) {
	return r <= 0 && (e = t = n = NaN), new q_(e, t, n, r);
}
function G_(e) {
	return e instanceof w_ || (e = H_(e)), e ? (e = e.rgb(), new q_(e.r, e.g, e.b, e.opacity)) : new q_();
}
function K_(e, t, n, r) {
	return arguments.length === 1 ? G_(e) : new q_(e, t, n, r ?? 1);
}
function q_(e, t, n, r) {
	this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
S_(q_, K_, C_(w_, {
	brighter(e) {
		return e = e == null ? E_ : E_ ** +e, new q_(this.r * e, this.g * e, this.b * e, this.opacity);
	},
	darker(e) {
		return e = e == null ? T_ : T_ ** +e, new q_(this.r * e, this.g * e, this.b * e, this.opacity);
	},
	rgb() {
		return this;
	},
	clamp() {
		return new q_(Q_(this.r), Q_(this.g), Q_(this.b), Z_(this.opacity));
	},
	displayable() {
		return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
	},
	hex: J_,
	formatHex: J_,
	formatHex8: Y_,
	formatRgb: X_,
	toString: X_
}));
function J_() {
	return `#${$_(this.r)}${$_(this.g)}${$_(this.b)}`;
}
function Y_() {
	return `#${$_(this.r)}${$_(this.g)}${$_(this.b)}${$_((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function X_() {
	let e = Z_(this.opacity);
	return `${e === 1 ? "rgb(" : "rgba("}${Q_(this.r)}, ${Q_(this.g)}, ${Q_(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Z_(e) {
	return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Q_(e) {
	return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function $_(e) {
	return e = Q_(e), (e < 16 ? "0" : "") + e.toString(16);
}
function ev(e, t, n, r) {
	return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new rv(e, t, n, r);
}
function tv(e) {
	if (e instanceof rv) return new rv(e.h, e.s, e.l, e.opacity);
	if (e instanceof w_ || (e = H_(e)), !e) return new rv();
	if (e instanceof rv) return e;
	e = e.rgb();
	var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, c = (a + i) / 2;
	return s ? (o = t === a ? (n - r) / s + (n < r) * 6 : n === a ? (r - t) / s + 2 : (t - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new rv(o, s, c, e.opacity);
}
function nv(e, t, n, r) {
	return arguments.length === 1 ? tv(e) : new rv(e, t, n, r ?? 1);
}
function rv(e, t, n, r) {
	this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
S_(rv, nv, C_(w_, {
	brighter(e) {
		return e = e == null ? E_ : E_ ** +e, new rv(this.h, this.s, this.l * e, this.opacity);
	},
	darker(e) {
		return e = e == null ? T_ : T_ ** +e, new rv(this.h, this.s, this.l * e, this.opacity);
	},
	rgb() {
		var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < .5 ? n : 1 - n) * t, i = 2 * n - r;
		return new q_(ov(e >= 240 ? e - 240 : e + 120, i, r), ov(e, i, r), ov(e < 120 ? e + 240 : e - 120, i, r), this.opacity);
	},
	clamp() {
		return new rv(iv(this.h), av(this.s), av(this.l), Z_(this.opacity));
	},
	displayable() {
		return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
	},
	formatHsl() {
		let e = Z_(this.opacity);
		return `${e === 1 ? "hsl(" : "hsla("}${iv(this.h)}, ${av(this.s) * 100}%, ${av(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
	}
}));
function iv(e) {
	return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function av(e) {
	return Math.max(0, Math.min(1, e || 0));
}
function ov(e, t, n) {
	return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/constant.js
var sv = (e) => () => e;
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/color.js
function cv(e, t) {
	return function(n) {
		return e + n * t;
	};
}
function lv(e, t, n) {
	return e **= +n, t = t ** +n - e, n = 1 / n, function(r) {
		return (e + r * t) ** +n;
	};
}
function uv(e) {
	return (e = +e) == 1 ? dv : function(t, n) {
		return n - t ? lv(t, n, e) : sv(isNaN(t) ? n : t);
	};
}
function dv(e, t) {
	var n = t - e;
	return n ? cv(e, n) : sv(isNaN(e) ? t : e);
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/rgb.js
var fv = (function e(t) {
	var n = uv(t);
	function r(e, t) {
		var r = n((e = K_(e)).r, (t = K_(t)).r), i = n(e.g, t.g), a = n(e.b, t.b), o = dv(e.opacity, t.opacity);
		return function(t) {
			return e.r = r(t), e.g = i(t), e.b = a(t), e.opacity = o(t), e + "";
		};
	}
	return r.gamma = e, r;
})(1);
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/numberArray.js
function pv(e, t) {
	t ||= [];
	var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
	return function(a) {
		for (i = 0; i < n; ++i) r[i] = e[i] * (1 - a) + t[i] * a;
		return r;
	};
}
function mv(e) {
	return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/array.js
function hv(e, t) {
	var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = Array(r), a = Array(n), o;
	for (o = 0; o < r; ++o) i[o] = wv(e[o], t[o]);
	for (; o < n; ++o) a[o] = t[o];
	return function(e) {
		for (o = 0; o < r; ++o) a[o] = i[o](e);
		return a;
	};
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/date.js
function gv(e, t) {
	var n = /* @__PURE__ */ new Date();
	return e = +e, t = +t, function(r) {
		return n.setTime(e * (1 - r) + t * r), n;
	};
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/number.js
function _v(e, t) {
	return e = +e, t = +t, function(n) {
		return e * (1 - n) + t * n;
	};
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/object.js
function vv(e, t) {
	var n = {}, r = {}, i;
	for (i in (typeof e != "object" || !e) && (e = {}), (typeof t != "object" || !t) && (t = {}), t) i in e ? n[i] = wv(e[i], t[i]) : r[i] = t[i];
	return function(e) {
		for (i in n) r[i] = n[i](e);
		return r;
	};
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/string.js
var yv = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, bv = new RegExp(yv.source, "g");
function xv(e) {
	return function() {
		return e;
	};
}
function Sv(e) {
	return function(t) {
		return e(t) + "";
	};
}
function Cv(e, t) {
	var n = yv.lastIndex = bv.lastIndex = 0, r, i, a, o = -1, s = [], c = [];
	for (e += "", t += ""; (r = yv.exec(e)) && (i = bv.exec(t));) (a = i.index) > n && (a = t.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, c.push({
		i: o,
		x: _v(r, i)
	})), n = bv.lastIndex;
	return n < t.length && (a = t.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? c[0] ? Sv(c[0].x) : xv(t) : (t = c.length, function(e) {
		for (var n = 0, r; n < t; ++n) s[(r = c[n]).i] = r.x(e);
		return s.join("");
	});
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/value.js
function wv(e, t) {
	var n = typeof t, r;
	return t == null || n === "boolean" ? sv(t) : (n === "number" ? _v : n === "string" ? (r = H_(t)) ? (t = r, fv) : Cv : t instanceof H_ ? fv : t instanceof Date ? gv : mv(t) ? pv : Array.isArray(t) ? hv : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? vv : _v)(e, t);
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/round.js
function Tv(e, t) {
	return e = +e, t = +t, function(n) {
		return Math.round(e * (1 - n) + t * n);
	};
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/decompose.js
var Ev = 180 / Math.PI, Dv = {
	translateX: 0,
	translateY: 0,
	rotate: 0,
	skewX: 0,
	scaleX: 1,
	scaleY: 1
};
function Ov(e, t, n, r, i, a) {
	var o, s, c;
	return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (c = e * n + t * r) && (n -= e * c, r -= t * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), e * r < t * n && (e = -e, t = -t, c = -c, o = -o), {
		translateX: i,
		translateY: a,
		rotate: Math.atan2(t, e) * Ev,
		skewX: Math.atan(c) * Ev,
		scaleX: o,
		scaleY: s
	};
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/parse.js
var kv;
function Av(e) {
	let t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
	return t.isIdentity ? Dv : Ov(t.a, t.b, t.c, t.d, t.e, t.f);
}
function jv(e) {
	return e == null || (kv ||= document.createElementNS("http://www.w3.org/2000/svg", "g"), kv.setAttribute("transform", e), !(e = kv.transform.baseVal.consolidate())) ? Dv : (e = e.matrix, Ov(e.a, e.b, e.c, e.d, e.e, e.f));
}
//#endregion
//#region node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/transform/index.js
function Mv(e, t, n, r) {
	function i(e) {
		return e.length ? e.pop() + " " : "";
	}
	function a(e, r, i, a, o, s) {
		if (e !== i || r !== a) {
			var c = o.push("translate(", null, t, null, n);
			s.push({
				i: c - 4,
				x: _v(e, i)
			}, {
				i: c - 2,
				x: _v(r, a)
			});
		} else (i || a) && o.push("translate(" + i + t + a + n);
	}
	function o(e, t, n, a) {
		e === t ? t && n.push(i(n) + "rotate(" + t + r) : (e - t > 180 ? t += 360 : t - e > 180 && (e += 360), a.push({
			i: n.push(i(n) + "rotate(", null, r) - 2,
			x: _v(e, t)
		}));
	}
	function s(e, t, n, a) {
		e === t ? t && n.push(i(n) + "skewX(" + t + r) : a.push({
			i: n.push(i(n) + "skewX(", null, r) - 2,
			x: _v(e, t)
		});
	}
	function c(e, t, n, r, a, o) {
		if (e !== n || t !== r) {
			var s = a.push(i(a) + "scale(", null, ",", null, ")");
			o.push({
				i: s - 4,
				x: _v(e, n)
			}, {
				i: s - 2,
				x: _v(t, r)
			});
		} else (n !== 1 || r !== 1) && a.push(i(a) + "scale(" + n + "," + r + ")");
	}
	return function(t, n) {
		var r = [], i = [];
		return t = e(t), n = e(n), a(t.translateX, t.translateY, n.translateX, n.translateY, r, i), o(t.rotate, n.rotate, r, i), s(t.skewX, n.skewX, r, i), c(t.scaleX, t.scaleY, n.scaleX, n.scaleY, r, i), t = n = null, function(e) {
			for (var t = -1, n = i.length, a; ++t < n;) r[(a = i[t]).i] = a.x(e);
			return r.join("");
		};
	};
}
var Nv = Mv(Av, "px, ", "px)", "deg)"), Pv = Mv(jv, ", ", ")", ")"), Fv = 0, Iv = 0, Lv = 0, Rv = 1e3, zv, Bv, Vv = 0, Hv = 0, Uv = 0, Wv = typeof performance == "object" && performance.now ? performance : Date, Gv = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
	setTimeout(e, 17);
};
function Kv() {
	return Hv ||= (Gv(qv), Wv.now() + Uv);
}
function qv() {
	Hv = 0;
}
function Jv() {
	this._call = this._time = this._next = null;
}
Jv.prototype = Yv.prototype = {
	constructor: Jv,
	restart: function(e, t, n) {
		if (typeof e != "function") throw TypeError("callback is not a function");
		n = (n == null ? Kv() : +n) + (t == null ? 0 : +t), !this._next && Bv !== this && (Bv ? Bv._next = this : zv = this, Bv = this), this._call = e, this._time = n, ey();
	},
	stop: function() {
		this._call && (this._call = null, this._time = Infinity, ey());
	}
};
function Yv(e, t, n) {
	var r = new Jv();
	return r.restart(e, t, n), r;
}
function Xv() {
	Kv(), ++Fv;
	for (var e = zv, t; e;) (t = Hv - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
	--Fv;
}
function Zv() {
	Hv = (Vv = Wv.now()) + Uv, Fv = Iv = 0;
	try {
		Xv();
	} finally {
		Fv = 0, $v(), Hv = 0;
	}
}
function Qv() {
	var e = Wv.now(), t = e - Vv;
	t > Rv && (Uv -= t, Vv = e);
}
function $v() {
	for (var e, t = zv, n, r = Infinity; t;) t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : zv = n);
	Bv = e, ey(r);
}
function ey(e) {
	Fv || (Iv &&= clearTimeout(Iv), e - Hv > 24 ? (e < Infinity && (Iv = setTimeout(Zv, e - Wv.now() - Uv)), Lv &&= clearInterval(Lv)) : (Lv ||= (Vv = Wv.now(), setInterval(Qv, Rv)), Fv = 1, Gv(Zv)));
}
//#endregion
//#region node_modules/.pnpm/d3-timer@3.0.1/node_modules/d3-timer/src/timeout.js
function ty(e, t, n) {
	var r = new Jv();
	return t = t == null ? 0 : +t, r.restart((n) => {
		r.stop(), e(n + t);
	}, t, n), r;
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/schedule.js
var ny = vh("start", "end", "cancel", "interrupt"), ry = [];
function iy(e, t, n, r, i, a) {
	var o = e.__transition;
	if (!o) e.__transition = {};
	else if (n in o) return;
	cy(e, n, {
		name: t,
		index: r,
		group: i,
		on: ny,
		tween: ry,
		time: a.time,
		delay: a.delay,
		duration: a.duration,
		ease: a.ease,
		timer: null,
		state: 0
	});
}
function ay(e, t) {
	var n = sy(e, t);
	if (n.state > 0) throw Error("too late; already scheduled");
	return n;
}
function oy(e, t) {
	var n = sy(e, t);
	if (n.state > 3) throw Error("too late; already running");
	return n;
}
function sy(e, t) {
	var n = e.__transition;
	if (!n || !(n = n[t])) throw Error("transition not found");
	return n;
}
function cy(e, t, n) {
	var r = e.__transition, i;
	r[t] = n, n.timer = Yv(a, 0, n.time);
	function a(e) {
		n.state = 1, n.timer.restart(o, n.delay, n.time), n.delay <= e && o(e - n.delay);
	}
	function o(a) {
		var l, u, d, f;
		if (n.state !== 1) return c();
		for (l in r) if (f = r[l], f.name === n.name) {
			if (f.state === 3) return ty(o);
			f.state === 4 ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", e, e.__data__, f.index, f.group), delete r[l]) : +l < t && (f.state = 6, f.timer.stop(), f.on.call("cancel", e, e.__data__, f.index, f.group), delete r[l]);
		}
		if (ty(function() {
			n.state === 3 && (n.state = 4, n.timer.restart(s, n.delay, n.time), s(a));
		}), n.state = 2, n.on.call("start", e, e.__data__, n.index, n.group), n.state === 2) {
			for (n.state = 3, i = Array(d = n.tween.length), l = 0, u = -1; l < d; ++l) (f = n.tween[l].value.call(e, e.__data__, n.index, n.group)) && (i[++u] = f);
			i.length = u + 1;
		}
	}
	function s(t) {
		for (var r = t < n.duration ? n.ease.call(null, t / n.duration) : (n.timer.restart(c), n.state = 5, 1), a = -1, o = i.length; ++a < o;) i[a].call(e, r);
		n.state === 5 && (n.on.call("end", e, e.__data__, n.index, n.group), c());
	}
	function c() {
		for (var i in n.state = 6, n.timer.stop(), delete r[t], r) return;
		delete e.__transition;
	}
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/interrupt.js
function ly(e, t) {
	var n = e.__transition, r, i, a = !0, o;
	if (n) {
		for (o in t = t == null ? null : t + "", n) {
			if ((r = n[o]).name !== t) {
				a = !1;
				continue;
			}
			i = r.state > 2 && r.state < 5, r.state = 6, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", e, e.__data__, r.index, r.group), delete n[o];
		}
		a && delete e.__transition;
	}
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/interrupt.js
function uy(e) {
	return this.each(function() {
		ly(this, e);
	});
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/tween.js
function dy(e, t) {
	var n, r;
	return function() {
		var i = oy(this, e), a = i.tween;
		if (a !== n) {
			r = n = a;
			for (var o = 0, s = r.length; o < s; ++o) if (r[o].name === t) {
				r = r.slice(), r.splice(o, 1);
				break;
			}
		}
		i.tween = r;
	};
}
function fy(e, t, n) {
	var r, i;
	if (typeof n != "function") throw Error();
	return function() {
		var a = oy(this, e), o = a.tween;
		if (o !== r) {
			i = (r = o).slice();
			for (var s = {
				name: t,
				value: n
			}, c = 0, l = i.length; c < l; ++c) if (i[c].name === t) {
				i[c] = s;
				break;
			}
			c === l && i.push(s);
		}
		a.tween = i;
	};
}
function py(e, t) {
	var n = this._id;
	if (e += "", arguments.length < 2) {
		for (var r = sy(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i) if ((o = r[i]).name === e) return o.value;
		return null;
	}
	return this.each((t == null ? dy : fy)(n, e, t));
}
function my(e, t, n) {
	var r = e._id;
	return e.each(function() {
		var e = oy(this, r);
		(e.value ||= {})[t] = n.apply(this, arguments);
	}), function(e) {
		return sy(e, r).value[t];
	};
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/interpolate.js
function hy(e, t) {
	var n;
	return (typeof t == "number" ? _v : t instanceof H_ ? fv : (n = H_(t)) ? (t = n, fv) : Cv)(e, t);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attr.js
function gy(e) {
	return function() {
		this.removeAttribute(e);
	};
}
function _y(e) {
	return function() {
		this.removeAttributeNS(e.space, e.local);
	};
}
function vy(e, t, n) {
	var r, i = n + "", a;
	return function() {
		var o = this.getAttribute(e);
		return o === i ? null : o === r ? a : a = t(r = o, n);
	};
}
function yy(e, t, n) {
	var r, i = n + "", a;
	return function() {
		var o = this.getAttributeNS(e.space, e.local);
		return o === i ? null : o === r ? a : a = t(r = o, n);
	};
}
function by(e, t, n) {
	var r, i, a;
	return function() {
		var o, s = n(this), c;
		return s == null ? void this.removeAttribute(e) : (o = this.getAttribute(e), c = s + "", o === c ? null : o === r && c === i ? a : (i = c, a = t(r = o, s)));
	};
}
function xy(e, t, n) {
	var r, i, a;
	return function() {
		var o, s = n(this), c;
		return s == null ? void this.removeAttributeNS(e.space, e.local) : (o = this.getAttributeNS(e.space, e.local), c = s + "", o === c ? null : o === r && c === i ? a : (i = c, a = t(r = o, s)));
	};
}
function Sy(e, t) {
	var n = wh(e), r = n === "transform" ? Pv : hy;
	return this.attrTween(e, typeof t == "function" ? (n.local ? xy : by)(n, r, my(this, "attr." + e, t)) : t == null ? (n.local ? _y : gy)(n) : (n.local ? yy : vy)(n, r, t));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/attrTween.js
function Cy(e, t) {
	return function(n) {
		this.setAttribute(e, t.call(this, n));
	};
}
function wy(e, t) {
	return function(n) {
		this.setAttributeNS(e.space, e.local, t.call(this, n));
	};
}
function Ty(e, t) {
	var n, r;
	function i() {
		var i = t.apply(this, arguments);
		return i !== r && (n = (r = i) && wy(e, i)), n;
	}
	return i._value = t, i;
}
function Ey(e, t) {
	var n, r;
	function i() {
		var i = t.apply(this, arguments);
		return i !== r && (n = (r = i) && Cy(e, i)), n;
	}
	return i._value = t, i;
}
function Dy(e, t) {
	var n = "attr." + e;
	if (arguments.length < 2) return (n = this.tween(n)) && n._value;
	if (t == null) return this.tween(n, null);
	if (typeof t != "function") throw Error();
	var r = wh(e);
	return this.tween(n, (r.local ? Ty : Ey)(r, t));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/delay.js
function Oy(e, t) {
	return function() {
		ay(this, e).delay = +t.apply(this, arguments);
	};
}
function ky(e, t) {
	return t = +t, function() {
		ay(this, e).delay = t;
	};
}
function Ay(e) {
	var t = this._id;
	return arguments.length ? this.each((typeof e == "function" ? Oy : ky)(t, e)) : sy(this.node(), t).delay;
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/duration.js
function jy(e, t) {
	return function() {
		oy(this, e).duration = +t.apply(this, arguments);
	};
}
function My(e, t) {
	return t = +t, function() {
		oy(this, e).duration = t;
	};
}
function Ny(e) {
	var t = this._id;
	return arguments.length ? this.each((typeof e == "function" ? jy : My)(t, e)) : sy(this.node(), t).duration;
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/ease.js
function Py(e, t) {
	if (typeof t != "function") throw Error();
	return function() {
		oy(this, e).ease = t;
	};
}
function Fy(e) {
	var t = this._id;
	return arguments.length ? this.each(Py(t, e)) : sy(this.node(), t).ease;
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/easeVarying.js
function Iy(e, t) {
	return function() {
		var n = t.apply(this, arguments);
		if (typeof n != "function") throw Error();
		oy(this, e).ease = n;
	};
}
function Ly(e) {
	if (typeof e != "function") throw Error();
	return this.each(Iy(this._id, e));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/filter.js
function Ry(e) {
	typeof e != "function" && (e = Ih(e));
	for (var t = this._groups, n = t.length, r = Array(n), i = 0; i < n; ++i) for (var a = t[i], o = a.length, s = r[i] = [], c, l = 0; l < o; ++l) (c = a[l]) && e.call(c, c.__data__, l, a) && s.push(c);
	return new pb(r, this._parents, this._name, this._id);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/merge.js
function zy(e) {
	if (e._id !== this._id) throw Error();
	for (var t = this._groups, n = e._groups, r = t.length, i = n.length, a = Math.min(r, i), o = Array(r), s = 0; s < a; ++s) for (var c = t[s], l = n[s], u = c.length, d = o[s] = Array(u), f, p = 0; p < u; ++p) (f = c[p] || l[p]) && (d[p] = f);
	for (; s < r; ++s) o[s] = t[s];
	return new pb(o, this._parents, this._name, this._id);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/on.js
function By(e) {
	return (e + "").trim().split(/^|\s+/).every(function(e) {
		var t = e.indexOf(".");
		return t >= 0 && (e = e.slice(0, t)), !e || e === "start";
	});
}
function Vy(e, t, n) {
	var r, i, a = By(t) ? ay : oy;
	return function() {
		var o = a(this, e), s = o.on;
		s !== r && (i = (r = s).copy()).on(t, n), o.on = i;
	};
}
function Hy(e, t) {
	var n = this._id;
	return arguments.length < 2 ? sy(this.node(), n).on.on(e) : this.each(Vy(n, e, t));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/remove.js
function Uy(e) {
	return function() {
		var t = this.parentNode;
		for (var n in this.__transition) if (+n !== e) return;
		t && t.removeChild(this);
	};
}
function Wy() {
	return this.on("end.remove", Uy(this._id));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/select.js
function Gy(e) {
	var t = this._name, n = this._id;
	typeof e != "function" && (e = kh(e));
	for (var r = this._groups, i = r.length, a = Array(i), o = 0; o < i; ++o) for (var s = r[o], c = s.length, l = a[o] = Array(c), u, d, f = 0; f < c; ++f) (u = s[f]) && (d = e.call(u, u.__data__, f, s)) && ("__data__" in u && (d.__data__ = u.__data__), l[f] = d, iy(l[f], t, n, f, l, sy(u, n)));
	return new pb(a, this._parents, t, n);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selectAll.js
function Ky(e) {
	var t = this._name, n = this._id;
	typeof e != "function" && (e = Nh(e));
	for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) for (var c = r[s], l = c.length, u, d = 0; d < l; ++d) if (u = c[d]) {
		for (var f = e.call(u, u.__data__, d, c), p, m = sy(u, n), h = 0, g = f.length; h < g; ++h) (p = f[h]) && iy(p, t, n, h, f, m);
		a.push(f), o.push(u);
	}
	return new pb(a, o, t, n);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/selection.js
var qy = y_.prototype.constructor;
function Jy() {
	return new qy(this._groups, this._parents);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/style.js
function Yy(e, t) {
	var n, r, i;
	return function() {
		var a = Eg(this, e), o = (this.style.removeProperty(e), Eg(this, e));
		return a === o ? null : a === n && o === r ? i : i = t(n = a, r = o);
	};
}
function Xy(e) {
	return function() {
		this.style.removeProperty(e);
	};
}
function Zy(e, t, n) {
	var r, i = n + "", a;
	return function() {
		var o = Eg(this, e);
		return o === i ? null : o === r ? a : a = t(r = o, n);
	};
}
function Qy(e, t, n) {
	var r, i, a;
	return function() {
		var o = Eg(this, e), s = n(this), c = s + "";
		return s ?? (c = s = (this.style.removeProperty(e), Eg(this, e))), o === c ? null : o === r && c === i ? a : (i = c, a = t(r = o, s));
	};
}
function $y(e, t) {
	var n, r, i, a = "style." + t, o = "end." + a, s;
	return function() {
		var c = oy(this, e), l = c.on, u = c.value[a] == null ? s ||= Xy(t) : void 0;
		(l !== n || i !== u) && (r = (n = l).copy()).on(o, i = u), c.on = r;
	};
}
function eb(e, t, n) {
	var r = (e += "") == "transform" ? Nv : hy;
	return t == null ? this.styleTween(e, Yy(e, r)).on("end.style." + e, Xy(e)) : typeof t == "function" ? this.styleTween(e, Qy(e, r, my(this, "style." + e, t))).each($y(this._id, e)) : this.styleTween(e, Zy(e, r, t), n).on("end.style." + e, null);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/styleTween.js
function tb(e, t, n) {
	return function(r) {
		this.style.setProperty(e, t.call(this, r), n);
	};
}
function nb(e, t, n) {
	var r, i;
	function a() {
		var a = t.apply(this, arguments);
		return a !== i && (r = (i = a) && tb(e, a, n)), r;
	}
	return a._value = t, a;
}
function rb(e, t, n) {
	var r = "style." + (e += "");
	if (arguments.length < 2) return (r = this.tween(r)) && r._value;
	if (t == null) return this.tween(r, null);
	if (typeof t != "function") throw Error();
	return this.tween(r, nb(e, t, n ?? ""));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/text.js
function ib(e) {
	return function() {
		this.textContent = e;
	};
}
function ab(e) {
	return function() {
		this.textContent = e(this) ?? "";
	};
}
function ob(e) {
	return this.tween("text", typeof e == "function" ? ab(my(this, "text", e)) : ib(e == null ? "" : e + ""));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/textTween.js
function sb(e) {
	return function(t) {
		this.textContent = e.call(this, t);
	};
}
function cb(e) {
	var t, n;
	function r() {
		var r = e.apply(this, arguments);
		return r !== n && (t = (n = r) && sb(r)), t;
	}
	return r._value = e, r;
}
function lb(e) {
	var t = "text";
	if (arguments.length < 1) return (t = this.tween(t)) && t._value;
	if (e == null) return this.tween(t, null);
	if (typeof e != "function") throw Error();
	return this.tween(t, cb(e));
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/transition.js
function ub() {
	for (var e = this._name, t = this._id, n = hb(), r = this._groups, i = r.length, a = 0; a < i; ++a) for (var o = r[a], s = o.length, c, l = 0; l < s; ++l) if (c = o[l]) {
		var u = sy(c, t);
		iy(c, e, n, l, o, {
			time: u.time + u.delay + u.duration,
			delay: 0,
			duration: u.duration,
			ease: u.ease
		});
	}
	return new pb(r, this._parents, e, n);
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/end.js
function db() {
	var e, t, n = this, r = n._id, i = n.size();
	return new Promise(function(a, o) {
		var s = { value: o }, c = { value: function() {
			--i === 0 && a();
		} };
		n.each(function() {
			var n = oy(this, r), i = n.on;
			i !== e && (t = (e = i).copy(), t._.cancel.push(s), t._.interrupt.push(s), t._.end.push(c)), n.on = t;
		}), i === 0 && a();
	});
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/transition/index.js
var fb = 0;
function pb(e, t, n, r) {
	this._groups = e, this._parents = t, this._name = n, this._id = r;
}
function mb(e) {
	return y_().transition(e);
}
function hb() {
	return ++fb;
}
var gb = y_.prototype;
pb.prototype = mb.prototype = {
	constructor: pb,
	select: Gy,
	selectAll: Ky,
	selectChild: gb.selectChild,
	selectChildren: gb.selectChildren,
	filter: Ry,
	merge: zy,
	selection: Jy,
	transition: ub,
	call: gb.call,
	nodes: gb.nodes,
	node: gb.node,
	size: gb.size,
	empty: gb.empty,
	each: gb.each,
	on: Hy,
	attr: Sy,
	attrTween: Dy,
	style: eb,
	styleTween: rb,
	text: ob,
	textTween: lb,
	remove: Wy,
	tween: py,
	delay: Ay,
	duration: Ny,
	ease: Fy,
	easeVarying: Ly,
	end: db,
	[Symbol.iterator]: gb[Symbol.iterator]
};
//#endregion
//#region node_modules/.pnpm/d3-ease@3.0.1/node_modules/d3-ease/src/cubic.js
function _b(e) {
	return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
//#endregion
//#region node_modules/.pnpm/d3-transition@3.0.1_d3-selection@3.0.0/node_modules/d3-transition/src/selection/transition.js
var vb = {
	time: null,
	delay: 0,
	duration: 250,
	ease: _b
};
function yb(e, t) {
	for (var n; !(n = e.__transition) || !(n = n[t]);) if (!(e = e.parentNode)) throw Error(`transition ${t} not found`);
	return n;
}
function bb(e) {
	var t, n;
	e instanceof pb ? (t = e._id, e = e._name) : (t = hb(), (n = vb).time = Kv(), e = e == null ? null : e + "");
	for (var r = this._groups, i = r.length, a = 0; a < i; ++a) for (var o = r[a], s = o.length, c, l = 0; l < s; ++l) (c = o[l]) && iy(c, e, t, l, o, n || yb(c, t));
	return new pb(r, this._parents, e, t);
}
y_.prototype.interrupt = uy, y_.prototype.transition = bb;
//#endregion
//#region node_modules/.pnpm/d3-brush@3.0.0/node_modules/d3-brush/src/brush.js
var { abs: xb, max: Sb, min: Cb } = Math;
["w", "e"].map(wb), ["n", "s"].map(wb), [
	"n",
	"w",
	"e",
	"s",
	"nw",
	"ne",
	"sw",
	"se"
].map(wb);
function wb(e) {
	return { type: e };
}
//#endregion
//#region node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/path.js
var Tb = Math.PI, Eb = 2 * Tb, Db = 1e-6, Ob = Eb - Db;
function kb(e) {
	this._ += e[0];
	for (let t = 1, n = e.length; t < n; ++t) this._ += arguments[t] + e[t];
}
function Ab(e) {
	let t = Math.floor(e);
	if (!(t >= 0)) throw Error(`invalid digits: ${e}`);
	if (t > 15) return kb;
	let n = 10 ** t;
	return function(e) {
		this._ += e[0];
		for (let t = 1, r = e.length; t < r; ++t) this._ += Math.round(arguments[t] * n) / n + e[t];
	};
}
var jb = class {
	constructor(e) {
		this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "", this._append = e == null ? kb : Ab(e);
	}
	moveTo(e, t) {
		this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}`;
	}
	closePath() {
		this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
	}
	lineTo(e, t) {
		this._append`L${this._x1 = +e},${this._y1 = +t}`;
	}
	quadraticCurveTo(e, t, n, r) {
		this._append`Q${+e},${+t},${this._x1 = +n},${this._y1 = +r}`;
	}
	bezierCurveTo(e, t, n, r, i, a) {
		this._append`C${+e},${+t},${+n},${+r},${this._x1 = +i},${this._y1 = +a}`;
	}
	arcTo(e, t, n, r, i) {
		if (e = +e, t = +t, n = +n, r = +r, i = +i, i < 0) throw Error(`negative radius: ${i}`);
		let a = this._x1, o = this._y1, s = n - e, c = r - t, l = a - e, u = o - t, d = l * l + u * u;
		if (this._x1 === null) this._append`M${this._x1 = e},${this._y1 = t}`;
		else if (d > Db) if (!(Math.abs(u * s - c * l) > Db) || !i) this._append`L${this._x1 = e},${this._y1 = t}`;
		else {
			let f = n - a, p = r - o, m = s * s + c * c, h = f * f + p * p, g = Math.sqrt(m), _ = Math.sqrt(d), v = i * Math.tan((Tb - Math.acos((m + d - h) / (2 * g * _))) / 2), y = v / _, b = v / g;
			Math.abs(y - 1) > Db && this._append`L${e + y * l},${t + y * u}`, this._append`A${i},${i},0,0,${+(u * f > l * p)},${this._x1 = e + b * s},${this._y1 = t + b * c}`;
		}
	}
	arc(e, t, n, r, i, a) {
		if (e = +e, t = +t, n = +n, a = !!a, n < 0) throw Error(`negative radius: ${n}`);
		let o = n * Math.cos(r), s = n * Math.sin(r), c = e + o, l = t + s, u = 1 ^ a, d = a ? r - i : i - r;
		this._x1 === null ? this._append`M${c},${l}` : (Math.abs(this._x1 - c) > Db || Math.abs(this._y1 - l) > Db) && this._append`L${c},${l}`, n && (d < 0 && (d = d % Eb + Eb), d > Ob ? this._append`A${n},${n},0,1,${u},${e - o},${t - s}A${n},${n},0,1,${u},${this._x1 = c},${this._y1 = l}` : d > Db && this._append`A${n},${n},0,${+(d >= Tb)},${u},${this._x1 = e + n * Math.cos(i)},${this._y1 = t + n * Math.sin(i)}`);
	}
	rect(e, t, n, r) {
		this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}h${n = +n}v${+r}h${-n}Z`;
	}
	toString() {
		return this._;
	}
};
function Mb() {
	return new jb();
}
Mb.prototype = jb.prototype;
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatDecimal.js
function Nb(e) {
	return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Pb(e, t) {
	if (!isFinite(e) || e === 0) return null;
	var n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e"), r = e.slice(0, n);
	return [r.length > 1 ? r[0] + r.slice(2) : r, +e.slice(n + 1)];
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/exponent.js
function Fb(e) {
	return e = Pb(Math.abs(e)), e ? e[1] : NaN;
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatGroup.js
function Ib(e, t) {
	return function(n, r) {
		for (var i = n.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(n.substring(i -= s, i + s)), !((c += s + 1) > r));) s = e[o = (o + 1) % e.length];
		return a.reverse().join(t);
	};
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatNumerals.js
function Lb(e) {
	return function(t) {
		return t.replace(/[0-9]/g, function(t) {
			return e[+t];
		});
	};
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatSpecifier.js
var Rb = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function zb(e) {
	if (!(t = Rb.exec(e))) throw Error("invalid format: " + e);
	var t;
	return new Bb({
		fill: t[1],
		align: t[2],
		sign: t[3],
		symbol: t[4],
		zero: t[5],
		width: t[6],
		comma: t[7],
		precision: t[8] && t[8].slice(1),
		trim: t[9],
		type: t[10]
	});
}
zb.prototype = Bb.prototype;
function Bb(e) {
	this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Bb.prototype.toString = function() {
	return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTrim.js
function Vb(e) {
	out: for (var t = e.length, n = 1, r = -1, i; n < t; ++n) switch (e[n]) {
		case ".":
			r = i = n;
			break;
		case "0":
			r === 0 && (r = n), i = n;
			break;
		default:
			if (!+e[n]) break out;
			r > 0 && (r = 0);
			break;
	}
	return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatPrefixAuto.js
var Hb;
function Ub(e, t) {
	var n = Pb(e, t);
	if (!n) return Hb = void 0, e.toPrecision(t);
	var r = n[0], i = n[1], a = i - (Hb = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
	return a === o ? r : a > o ? r + Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + Array(1 - a).join("0") + Pb(e, Math.max(0, t + a - 1))[0];
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatRounded.js
function Wb(e, t) {
	var n = Pb(e, t);
	if (!n) return e + "";
	var r = n[0], i = n[1];
	return i < 0 ? "0." + Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + Array(i - r.length + 2).join("0");
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/formatTypes.js
var Gb = {
	"%": (e, t) => (e * 100).toFixed(t),
	b: (e) => Math.round(e).toString(2),
	c: (e) => e + "",
	d: Nb,
	e: (e, t) => e.toExponential(t),
	f: (e, t) => e.toFixed(t),
	g: (e, t) => e.toPrecision(t),
	o: (e) => Math.round(e).toString(8),
	p: (e, t) => Wb(e * 100, t),
	r: Wb,
	s: Ub,
	X: (e) => Math.round(e).toString(16).toUpperCase(),
	x: (e) => Math.round(e).toString(16)
};
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/identity.js
function Kb(e) {
	return e;
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/locale.js
var qb = Array.prototype.map, Jb = [
	"y",
	"z",
	"a",
	"f",
	"p",
	"n",
	"µ",
	"m",
	"",
	"k",
	"M",
	"G",
	"T",
	"P",
	"E",
	"Z",
	"Y"
];
function Yb(e) {
	var t = e.grouping === void 0 || e.thousands === void 0 ? Kb : Ib(qb.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? Kb : Lb(qb.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
	function l(e, l) {
		e = zb(e);
		var u = e.fill, d = e.align, f = e.sign, p = e.symbol, m = e.zero, h = e.width, g = e.comma, _ = e.precision, v = e.trim, y = e.type;
		y === "n" ? (g = !0, y = "g") : Gb[y] || (_ === void 0 && (_ = 12), v = !0, y = "g"), (m || u === "0" && d === "=") && (m = !0, u = "0", d = "=");
		var b = (l && l.prefix !== void 0 ? l.prefix : "") + (p === "$" ? n : p === "#" && /[boxX]/.test(y) ? "0" + y.toLowerCase() : ""), x = (p === "$" ? r : /[%p]/.test(y) ? o : "") + (l && l.suffix !== void 0 ? l.suffix : ""), S = Gb[y], C = /[defgprs%]/.test(y);
		_ = _ === void 0 ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
		function w(e) {
			var n = b, r = x, o, l, p;
			if (y === "c") r = S(e) + r, e = "";
			else {
				e = +e;
				var w = e < 0 || 1 / e < 0;
				if (e = isNaN(e) ? c : S(Math.abs(e), _), v && (e = Vb(e)), w && +e == 0 && f !== "+" && (w = !1), n = (w ? f === "(" ? f : s : f === "-" || f === "(" ? "" : f) + n, r = (y === "s" && !isNaN(e) && Hb !== void 0 ? Jb[8 + Hb / 3] : "") + r + (w && f === "(" ? ")" : ""), C) {
					for (o = -1, l = e.length; ++o < l;) if (p = e.charCodeAt(o), 48 > p || p > 57) {
						r = (p === 46 ? i + e.slice(o + 1) : e.slice(o)) + r, e = e.slice(0, o);
						break;
					}
				}
			}
			g && !m && (e = t(e, Infinity));
			var T = n.length + e.length + r.length, E = T < h ? Array(h - T + 1).join(u) : "";
			switch (g && m && (e = t(E + e, E.length ? h - r.length : Infinity), E = ""), d) {
				case "<":
					e = n + e + r + E;
					break;
				case "=":
					e = n + E + e + r;
					break;
				case "^":
					e = E.slice(0, T = E.length >> 1) + n + e + r + E.slice(T);
					break;
				default:
					e = E + n + e + r;
					break;
			}
			return a(e);
		}
		return w.toString = function() {
			return e + "";
		}, w;
	}
	function u(e, t) {
		var n = Math.max(-8, Math.min(8, Math.floor(Fb(t) / 3))) * 3, r = 10 ** -n, i = l((e = zb(e), e.type = "f", e), { suffix: Jb[8 + n / 3] });
		return function(e) {
			return i(r * e);
		};
	}
	return {
		format: l,
		formatPrefix: u
	};
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/defaultLocale.js
var Xb, Zb, Qb;
$b({
	thousands: ",",
	grouping: [3],
	currency: ["$", ""]
});
function $b(e) {
	return Xb = Yb(e), Zb = Xb.format, Qb = Xb.formatPrefix, Xb;
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionFixed.js
function ex(e) {
	return Math.max(0, -Fb(Math.abs(e)));
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionPrefix.js
function tx(e, t) {
	return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Fb(t) / 3))) * 3 - Fb(Math.abs(e)));
}
//#endregion
//#region node_modules/.pnpm/d3-format@3.1.2/node_modules/d3-format/src/precisionRound.js
function nx(e, t) {
	return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Fb(t) - Fb(e)) + 1;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/count.js
function rx(e) {
	var t = 0, n = e.children, r = n && n.length;
	if (!r) t = 1;
	else for (; --r >= 0;) t += n[r].value;
	e.value = t;
}
function ix() {
	return this.eachAfter(rx);
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/each.js
function ax(e, t) {
	let n = -1;
	for (let r of this) e.call(t, r, ++n, this);
	return this;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/eachBefore.js
function ox(e, t) {
	for (var n = this, r = [n], i, a, o = -1; n = r.pop();) if (e.call(t, n, ++o, this), i = n.children) for (a = i.length - 1; a >= 0; --a) r.push(i[a]);
	return this;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/eachAfter.js
function sx(e, t) {
	for (var n = this, r = [n], i = [], a, o, s, c = -1; n = r.pop();) if (i.push(n), a = n.children) for (o = 0, s = a.length; o < s; ++o) r.push(a[o]);
	for (; n = i.pop();) e.call(t, n, ++c, this);
	return this;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/find.js
function cx(e, t) {
	let n = -1;
	for (let r of this) if (e.call(t, r, ++n, this)) return r;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/sum.js
function lx(e) {
	return this.eachAfter(function(t) {
		for (var n = +e(t.data) || 0, r = t.children, i = r && r.length; --i >= 0;) n += r[i].value;
		t.value = n;
	});
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/sort.js
function ux(e) {
	return this.eachBefore(function(t) {
		t.children && t.children.sort(e);
	});
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/path.js
function dx(e) {
	for (var t = this, n = fx(t, e), r = [t]; t !== n;) t = t.parent, r.push(t);
	for (var i = r.length; e !== n;) r.splice(i, 0, e), e = e.parent;
	return r;
}
function fx(e, t) {
	if (e === t) return e;
	var n = e.ancestors(), r = t.ancestors(), i = null;
	for (e = n.pop(), t = r.pop(); e === t;) i = e, e = n.pop(), t = r.pop();
	return i;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/ancestors.js
function px() {
	for (var e = this, t = [e]; e = e.parent;) t.push(e);
	return t;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/descendants.js
function mx() {
	return Array.from(this);
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/leaves.js
function hx() {
	var e = [];
	return this.eachBefore(function(t) {
		t.children || e.push(t);
	}), e;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/links.js
function gx() {
	var e = this, t = [];
	return e.each(function(n) {
		n !== e && t.push({
			source: n.parent,
			target: n
		});
	}), t;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/iterator.js
function* _x() {
	var e = this, t, n = [e], r, i, a;
	do
		for (t = n.reverse(), n = []; e = t.pop();) if (yield e, r = e.children) for (i = 0, a = r.length; i < a; ++i) n.push(r[i]);
	while (n.length);
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/hierarchy/index.js
function vx(e, t) {
	e instanceof Map ? (e = [void 0, e], t === void 0 && (t = xx)) : t === void 0 && (t = bx);
	for (var n = new wx(e), r, i = [n], a, o, s, c; r = i.pop();) if ((o = t(r.data)) && (c = (o = Array.from(o)).length)) for (r.children = o, s = c - 1; s >= 0; --s) i.push(a = o[s] = new wx(o[s])), a.parent = r, a.depth = r.depth + 1;
	return n.eachBefore(Cx);
}
function yx() {
	return vx(this).eachBefore(Sx);
}
function bx(e) {
	return e.children;
}
function xx(e) {
	return Array.isArray(e) ? e[1] : null;
}
function Sx(e) {
	e.data.value !== void 0 && (e.value = e.data.value), e.data = e.data.data;
}
function Cx(e) {
	var t = 0;
	do
		e.height = t;
	while ((e = e.parent) && e.height < ++t);
}
function wx(e) {
	this.data = e, this.depth = this.height = 0, this.parent = null;
}
wx.prototype = vx.prototype = {
	constructor: wx,
	count: ix,
	each: ax,
	eachAfter: sx,
	eachBefore: ox,
	find: cx,
	sum: lx,
	sort: ux,
	path: dx,
	ancestors: px,
	descendants: mx,
	leaves: hx,
	links: gx,
	copy: yx,
	[Symbol.iterator]: _x
};
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/round.js
function Tx(e) {
	e.x0 = Math.round(e.x0), e.y0 = Math.round(e.y0), e.x1 = Math.round(e.x1), e.y1 = Math.round(e.y1);
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/treemap/dice.js
function Ex(e, t, n, r, i) {
	for (var a = e.children, o, s = -1, c = a.length, l = e.value && (r - t) / e.value; ++s < c;) o = a[s], o.y0 = n, o.y1 = i, o.x0 = t, o.x1 = t += o.value * l;
}
//#endregion
//#region node_modules/.pnpm/d3-hierarchy@3.1.2/node_modules/d3-hierarchy/src/partition.js
function Dx() {
	var e = 1, t = 1, n = 0, r = !1;
	function i(i) {
		var o = i.height + 1;
		return i.x0 = i.y0 = n, i.x1 = e, i.y1 = t / o, i.eachBefore(a(t, o)), r && i.eachBefore(Tx), i;
	}
	function a(e, t) {
		return function(r) {
			r.children && Ex(r, r.x0, e * (r.depth + 1) / t, r.x1, e * (r.depth + 2) / t);
			var i = r.x0, a = r.y0, o = r.x1 - n, s = r.y1 - n;
			o < i && (i = o = (i + o) / 2), s < a && (a = s = (a + s) / 2), r.x0 = i, r.y0 = a, r.x1 = o, r.y1 = s;
		};
	}
	return i.round = function(e) {
		return arguments.length ? (r = !!e, i) : r;
	}, i.size = function(n) {
		return arguments.length ? (e = +n[0], t = +n[1], i) : [e, t];
	}, i.padding = function(e) {
		return arguments.length ? (n = +e, i) : n;
	}, i;
}
//#endregion
//#region node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/init.js
function Ox(e, t) {
	switch (arguments.length) {
		case 0: break;
		case 1:
			this.range(e);
			break;
		default:
			this.range(t).domain(e);
			break;
	}
	return this;
}
//#endregion
//#region node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/constant.js
function kx(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/number.js
function Ax(e) {
	return +e;
}
//#endregion
//#region node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/continuous.js
var jx = [0, 1];
function Mx(e) {
	return e;
}
function Nx(e, t) {
	return (t -= e = +e) ? function(n) {
		return (n - e) / t;
	} : kx(isNaN(t) ? NaN : .5);
}
function Px(e, t) {
	var n;
	return e > t && (n = e, e = t, t = n), function(n) {
		return Math.max(e, Math.min(t, n));
	};
}
function Fx(e, t, n) {
	var r = e[0], i = e[1], a = t[0], o = t[1];
	return i < r ? (r = Nx(i, r), a = n(o, a)) : (r = Nx(r, i), a = n(a, o)), function(e) {
		return a(r(e));
	};
}
function Ix(e, t, n) {
	var r = Math.min(e.length, t.length) - 1, i = Array(r), a = Array(r), o = -1;
	for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < r;) i[o] = Nx(e[o], e[o + 1]), a[o] = n(t[o], t[o + 1]);
	return function(t) {
		var n = ch(e, t, 1, r) - 1;
		return a[n](i[n](t));
	};
}
function Lx(e, t) {
	return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Rx() {
	var e = jx, t = jx, n = wv, r, i, a, o = Mx, s, c, l;
	function u() {
		var n = Math.min(e.length, t.length);
		return o !== Mx && (o = Px(e[0], e[n - 1])), s = n > 2 ? Ix : Fx, c = l = null, d;
	}
	function d(i) {
		return i == null || isNaN(i = +i) ? a : (c ||= s(e.map(r), t, n))(r(o(i)));
	}
	return d.invert = function(n) {
		return o(i((l ||= s(t, e.map(r), _v))(n)));
	}, d.domain = function(t) {
		return arguments.length ? (e = Array.from(t, Ax), u()) : e.slice();
	}, d.range = function(e) {
		return arguments.length ? (t = Array.from(e), u()) : t.slice();
	}, d.rangeRound = function(e) {
		return t = Array.from(e), n = Tv, u();
	}, d.clamp = function(e) {
		return arguments.length ? (o = e ? !0 : Mx, u()) : o !== Mx;
	}, d.interpolate = function(e) {
		return arguments.length ? (n = e, u()) : n;
	}, d.unknown = function(e) {
		return arguments.length ? (a = e, d) : a;
	}, function(e, t) {
		return r = e, i = t, u();
	};
}
function zx() {
	return Rx()(Mx, Mx);
}
//#endregion
//#region node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/tickFormat.js
function Bx(e, t, n, r) {
	var i = hh(e, t, n), a;
	switch (r = zb(r ?? ",f"), r.type) {
		case "s":
			var o = Math.max(Math.abs(e), Math.abs(t));
			return r.precision == null && !isNaN(a = tx(i, o)) && (r.precision = a), Qb(r, o);
		case "":
		case "e":
		case "g":
		case "p":
		case "r":
			r.precision == null && !isNaN(a = nx(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = a - (r.type === "e"));
			break;
		case "f":
		case "%":
			r.precision == null && !isNaN(a = ex(i)) && (r.precision = a - (r.type === "%") * 2);
			break;
	}
	return Zb(r);
}
//#endregion
//#region node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/linear.js
function Vx(e) {
	var t = e.domain;
	return e.ticks = function(e) {
		var n = t();
		return ph(n[0], n[n.length - 1], e ?? 10);
	}, e.tickFormat = function(e, n) {
		var r = t();
		return Bx(r[0], r[r.length - 1], e ?? 10, n);
	}, e.nice = function(n) {
		n ??= 10;
		var r = t(), i = 0, a = r.length - 1, o = r[i], s = r[a], c, l, u = 10;
		for (s < o && (l = o, o = s, s = l, l = i, i = a, a = l); u-- > 0;) {
			if (l = mh(o, s, n), l === c) return r[i] = o, r[a] = s, t(r);
			if (l > 0) o = Math.floor(o / l) * l, s = Math.ceil(s / l) * l;
			else if (l < 0) o = Math.ceil(o * l) / l, s = Math.floor(s * l) / l;
			else break;
			c = l;
		}
		return e;
	}, e;
}
function Hx() {
	var e = zx();
	return e.copy = function() {
		return Lx(e, Hx());
	}, Ox.apply(e, arguments), Vx(e);
}
//#endregion
//#region node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/constant.js
function Ux(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/math.js
var Wx = Math.abs, Gx = Math.atan2, Kx = Math.cos, qx = Math.max, Jx = Math.min, Yx = Math.sin, Xx = Math.sqrt, Zx = Math.PI, Qx = Zx / 2, $x = 2 * Zx;
function eS(e) {
	return e > 1 ? 0 : e < -1 ? Zx : Math.acos(e);
}
function tS(e) {
	return e >= 1 ? Qx : e <= -1 ? -Qx : Math.asin(e);
}
//#endregion
//#region node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/path.js
function nS(e) {
	let t = 3;
	return e.digits = function(n) {
		if (!arguments.length) return t;
		if (n == null) t = null;
		else {
			let e = Math.floor(n);
			if (!(e >= 0)) throw RangeError(`invalid digits: ${n}`);
			t = e;
		}
		return e;
	}, () => new jb(t);
}
//#endregion
//#region node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/arc.js
function rS(e) {
	return e.innerRadius;
}
function iS(e) {
	return e.outerRadius;
}
function aS(e) {
	return e.startAngle;
}
function oS(e) {
	return e.endAngle;
}
function sS(e) {
	return e && e.padAngle;
}
function cS(e, t, n, r, i, a, o, s) {
	var c = n - e, l = r - t, u = o - i, d = s - a, f = d * c - u * l;
	if (!(f * f < 1e-12)) return f = (u * (t - a) - d * (e - i)) / f, [e + f * c, t + f * l];
}
function lS(e, t, n, r, i, a, o) {
	var s = e - n, c = t - r, l = (o ? a : -a) / Xx(s * s + c * c), u = l * c, d = -l * s, f = e + u, p = t + d, m = n + u, h = r + d, g = (f + m) / 2, _ = (p + h) / 2, v = m - f, y = h - p, b = v * v + y * y, x = i - a, S = f * h - m * p, C = (y < 0 ? -1 : 1) * Xx(qx(0, x * x * b - S * S)), w = (S * y - v * C) / b, T = (-S * v - y * C) / b, E = (S * y + v * C) / b, D = (-S * v + y * C) / b, O = w - g, k = T - _, A = E - g, j = D - _;
	return O * O + k * k > A * A + j * j && (w = E, T = D), {
		cx: w,
		cy: T,
		x01: -u,
		y01: -d,
		x11: w * (i / x - 1),
		y11: T * (i / x - 1)
	};
}
function uS() {
	var e = rS, t = iS, n = Ux(0), r = null, i = aS, a = oS, o = sS, s = null, c = nS(l);
	function l() {
		var l, u, d = +e.apply(this, arguments), f = +t.apply(this, arguments), p = i.apply(this, arguments) - Qx, m = a.apply(this, arguments) - Qx, h = Wx(m - p), g = m > p;
		if (s ||= l = c(), f < d && (u = f, f = d, d = u), !(f > 1e-12)) s.moveTo(0, 0);
		else if (h > $x - 1e-12) s.moveTo(f * Kx(p), f * Yx(p)), s.arc(0, 0, f, p, m, !g), d > 1e-12 && (s.moveTo(d * Kx(m), d * Yx(m)), s.arc(0, 0, d, m, p, g));
		else {
			var _ = p, v = m, y = p, b = m, x = h, S = h, C = o.apply(this, arguments) / 2, w = C > 1e-12 && (r ? +r.apply(this, arguments) : Xx(d * d + f * f)), T = Jx(Wx(f - d) / 2, +n.apply(this, arguments)), E = T, D = T, O, k;
			if (w > 1e-12) {
				var A = tS(w / d * Yx(C)), j = tS(w / f * Yx(C));
				(x -= A * 2) > 1e-12 ? (A *= g ? 1 : -1, y += A, b -= A) : (x = 0, y = b = (p + m) / 2), (S -= j * 2) > 1e-12 ? (j *= g ? 1 : -1, _ += j, v -= j) : (S = 0, _ = v = (p + m) / 2);
			}
			var M = f * Kx(_), N = f * Yx(_), P = d * Kx(b), F = d * Yx(b);
			if (T > 1e-12) {
				var ee = f * Kx(v), te = f * Yx(v), ne = d * Kx(y), re = d * Yx(y), I;
				if (h < Zx) if (I = cS(M, N, ne, re, ee, te, P, F)) {
					var ie = M - I[0], ae = N - I[1], oe = ee - I[0], se = te - I[1], L = 1 / Yx(eS((ie * oe + ae * se) / (Xx(ie * ie + ae * ae) * Xx(oe * oe + se * se))) / 2), ce = Xx(I[0] * I[0] + I[1] * I[1]);
					E = Jx(T, (d - ce) / (L - 1)), D = Jx(T, (f - ce) / (L + 1));
				} else E = D = 0;
			}
			S > 1e-12 ? D > 1e-12 ? (O = lS(ne, re, M, N, f, D, g), k = lS(ee, te, P, F, f, D, g), s.moveTo(O.cx + O.x01, O.cy + O.y01), D < T ? s.arc(O.cx, O.cy, D, Gx(O.y01, O.x01), Gx(k.y01, k.x01), !g) : (s.arc(O.cx, O.cy, D, Gx(O.y01, O.x01), Gx(O.y11, O.x11), !g), s.arc(0, 0, f, Gx(O.cy + O.y11, O.cx + O.x11), Gx(k.cy + k.y11, k.cx + k.x11), !g), s.arc(k.cx, k.cy, D, Gx(k.y11, k.x11), Gx(k.y01, k.x01), !g))) : (s.moveTo(M, N), s.arc(0, 0, f, _, v, !g)) : s.moveTo(M, N), !(d > 1e-12) || !(x > 1e-12) ? s.lineTo(P, F) : E > 1e-12 ? (O = lS(P, F, ee, te, d, -E, g), k = lS(M, N, ne, re, d, -E, g), s.lineTo(O.cx + O.x01, O.cy + O.y01), E < T ? s.arc(O.cx, O.cy, E, Gx(O.y01, O.x01), Gx(k.y01, k.x01), !g) : (s.arc(O.cx, O.cy, E, Gx(O.y01, O.x01), Gx(O.y11, O.x11), !g), s.arc(0, 0, d, Gx(O.cy + O.y11, O.cx + O.x11), Gx(k.cy + k.y11, k.cx + k.x11), g), s.arc(k.cx, k.cy, E, Gx(k.y11, k.x11), Gx(k.y01, k.x01), !g))) : s.arc(0, 0, d, b, y, g);
		}
		if (s.closePath(), l) return s = null, l + "" || null;
	}
	return l.centroid = function() {
		var n = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, r = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - Zx / 2;
		return [Kx(r) * n, Yx(r) * n];
	}, l.innerRadius = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : Ux(+t), l) : e;
	}, l.outerRadius = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : Ux(+e), l) : t;
	}, l.cornerRadius = function(e) {
		return arguments.length ? (n = typeof e == "function" ? e : Ux(+e), l) : n;
	}, l.padRadius = function(e) {
		return arguments.length ? (r = e == null ? null : typeof e == "function" ? e : Ux(+e), l) : r;
	}, l.startAngle = function(e) {
		return arguments.length ? (i = typeof e == "function" ? e : Ux(+e), l) : i;
	}, l.endAngle = function(e) {
		return arguments.length ? (a = typeof e == "function" ? e : Ux(+e), l) : a;
	}, l.padAngle = function(e) {
		return arguments.length ? (o = typeof e == "function" ? e : Ux(+e), l) : o;
	}, l.context = function(e) {
		return arguments.length ? (s = e ?? null, l) : s;
	}, l;
}
//#endregion
//#region node_modules/.pnpm/d3-zoom@3.0.0/node_modules/d3-zoom/src/transform.js
function dS(e, t, n) {
	this.k = e, this.x = t, this.y = n;
}
dS.prototype = {
	constructor: dS,
	scale: function(e) {
		return e === 1 ? this : new dS(this.k * e, this.x, this.y);
	},
	translate: function(e, t) {
		return e === 0 & t === 0 ? this : new dS(this.k, this.x + this.k * e, this.y + this.k * t);
	},
	apply: function(e) {
		return [e[0] * this.k + this.x, e[1] * this.k + this.y];
	},
	applyX: function(e) {
		return e * this.k + this.x;
	},
	applyY: function(e) {
		return e * this.k + this.y;
	},
	invert: function(e) {
		return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
	},
	invertX: function(e) {
		return (e - this.x) / this.k;
	},
	invertY: function(e) {
		return (e - this.y) / this.k;
	},
	rescaleX: function(e) {
		return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
	},
	rescaleY: function(e) {
		return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
	},
	toString: function() {
		return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	}
};
var fS = new dS(1, 0, 0);
pS.prototype = dS.prototype;
function pS(e) {
	for (; !e.__zoom;) if (!(e = e.parentNode)) return fS;
	return e.__zoom;
}
//#endregion
//#region src/components/burstChart/textHelpers.ts
function mS(e, t = 15) {
	let n = e.split(" "), r = [], i = [], a = 0;
	return n.forEach((e) => {
		a + e.length > t ? (i.length && r.push(i.join(" ")), i = [e], a = e.length) : (i.push(e), a += e.length + (i.length > 0 ? 1 : 0));
	}), i.length && r.push(i.join(" ")), r;
}
//#endregion
//#region src/components/burstChart/burstChart.ts
var { WILDCARD: hS, QUALIFIER: gS, LUCKY_LOSER: _S } = n, vS = "text-anchor", yS = "dominant-baseline", bS = "fill-opacity", xS = Object.assign({}, ...o.countries.filter((e) => e.ioc).map((e) => ({ [e.ioc]: e.iso2 })), ...o.countries.filter((e) => e.iso).map((e) => ({ [e.iso]: e.iso2 })));
function SS(e) {
	let t = Math.floor(e.length / 2), n = e.slice(0, t), r = e.slice(t).reverse();
	return [...n, ...r];
}
function CS(e) {
	if (e) switch (e) {
		case hS: return "WC";
		case gS: return "Q";
		case _S: return "LL";
		default: return e;
	}
}
function wS(e, t) {
	let n = [];
	for (let r of e) for (let e of r.sides) {
		let i = r.matchUpStatus === "BYE" && !e.participantName;
		n.push({
			name: e.participantName || (i ? "BYE" : ""),
			participantName: e.participantName || (i ? "BYE" : void 0),
			drawPosition: e.drawPosition,
			seedNumber: e.seedNumber,
			entryStatus: CS(e.entryStatus),
			nationalityCode: e.nationalityCode,
			matchUp: r,
			depth: t,
			value: 1
		});
	}
	return n;
}
function TS(e, t) {
	let n = e.winningSide !== void 0 && e.winningSide !== null ? e.sides.find((t) => t.sideNumber === e.winningSide) : void 0;
	!n && e.matchUpStatus === "BYE" && (n = e.sides.find((e) => e.participantName));
	let r = n?.participantName, i = r ? t.get(r) : void 0;
	return {
		winnerName: r,
		winnerSide: n,
		winnerLookup: i
	};
}
function ES(e, t, n, r) {
	return e.map((e, i) => {
		let a = i * 2, o = [t[a], t[a + 1]].filter(Boolean), { winnerName: s, winnerSide: c, winnerLookup: l } = TS(e, r);
		return {
			name: s || "",
			participantName: s,
			drawPosition: l?.drawPosition ?? c?.drawPosition,
			seedNumber: c?.seedNumber ?? l?.seedNumber,
			entryStatus: CS(c?.entryStatus) ?? l?.entryStatus,
			nationalityCode: c?.nationalityCode ?? l?.nationalityCode,
			scoreString: e.scoreString,
			matchUpStatus: e.matchUpStatus,
			matchUp: e,
			depth: n,
			children: o.length > 0 ? o : void 0
		};
	});
}
function DS(e) {
	let { roundMatchUps: t } = e, n = Object.keys(t).map(Number).sort((e, t) => e - t);
	if (n.length === 0) throw Error("No round data found in draw");
	let r = t[n[0]], i = SS(wS(r, n.length)), a = /* @__PURE__ */ new Map();
	for (let e of i) e.participantName && e.participantName !== "BYE" && a.set(e.participantName, e);
	let o = ES(SS(r), i, n.length - 1, a);
	for (let e = 1; e < n.length; e++) o = ES(SS(t[n[e]]), o, n.length - 1 - e, a);
	return o.length === 1 ? o[0] : {
		name: "Tournament",
		depth: 0,
		children: o
	};
}
function OS(e, t) {
	if (!e) return;
	let { seedNumber: n, entryStatus: r, drawPosition: i, participantName: a } = e, o;
	if (a?.trim().toUpperCase() === "BYE") o = "#B0BEC5";
	else if (n) {
		let e = Number(n), t = Hx().domain([1, 32]).range(["0", "1"]);
		o = Hx().domain(gh(0, 1, 1 / 7)).range([
			"#81D4FA",
			"#42A5F5",
			"#1E88E5",
			"#1565C0",
			"#5C6BC0",
			"#673AB7",
			"#9C27B0"
		])(Number(t(e)));
	} else if (r?.toUpperCase() === "WC") o = "red";
	else if (r && (r === "Q" || r === "LL")) o = Hx().domain(gh(0, 1, 1 / 3)).range([
		"#FFF176",
		"#FBC02D",
		"#FF9800"
	])(t(i));
	else {
		let e = [
			"#C8E6C9",
			"#81C784",
			"#66BB6A",
			"#4CAF50",
			"#43A047",
			"#388E3C",
			"#2E7D32",
			"#1B5E20",
			"#A5D6A7",
			"#90CAF9",
			"#64B5F6",
			"#42A5F5",
			"#2196F3",
			"#1E88E5",
			"#1976D2",
			"#1565C0"
		];
		o = Hx().domain(gh(0, 1, 1 / e.length)).range(e)(t(i));
	}
	e.color = o, e.children && e.children.forEach((n) => {
		n.participantName === e.participantName && (n.color = o), OS(n, t);
	});
}
function kS(e, t) {
	let n = [];
	return e.seedNumber ? n.push(`Seed ${e.seedNumber}`) : e.entryStatus && n.push(e.entryStatus), t === 7 && e.drawPosition && n.push(`Draw ${e.drawPosition}`), n.length > 0 ? n.join(" • ") : void 0;
}
function AS(e, t) {
	let n = e.find((e) => e.data.participantName && e.data.participantName !== t);
	return n?.data.participantName ? n.data : void 0;
}
function jS(e, t) {
	let n = [e.participantName], r;
	if (t.children && t.children.length > 0) e.scoreString && n.push(e.scoreString), r = AS(t.children, e.participantName), r && n.push(r.participantName);
	else {
		let r = kS(e, t.depth);
		r && n.push(r);
	}
	return {
		messageLines: n,
		opponentData: r
	};
}
function MS(e, t) {
	return -(e * t / 2) + t / 2;
}
function NS(e, t, n) {
	let r = x_(e).append("svg").attr("width", t).attr("height", n).style("display", "block"), i = r.append("g").attr("transform", `translate(${t / 2}, ${n / 2})`);
	return {
		svg: r,
		g: i,
		flagsGroup: i.append("g").attr("class", "flags-group"),
		winningFlagsGroup: i.append("g").attr("class", "winning-flags-group"),
		losingFlagsGroup: i.append("g").attr("class", "losing-flags-group")
	};
}
function PS(e, t, n, r, i) {
	let a = e.append("text").attr("x", t / 2).attr("y", n / 2).attr(vS, "middle").attr(yS, "middle").attr("font-size", `${r}px`).attr("font-weight", "bold").style("fill", "var(--chc-text-primary, #333)").attr("pointer-events", "none"), o = r + i * .5;
	return {
		centerText: a,
		centerText2: e.append("text").attr("x", t / 2).attr("y", n / 2 + o).attr(vS, "middle").attr(yS, "middle").attr("font-size", `${i}px`).style("fill", "var(--chc-text-secondary, #666)").attr("pointer-events", "none")
	};
}
function FS(e, t, n, r, i, a, o) {
	n && (i ? (t.flagsGroup.selectAll("text").remove(), t.winningFlagsGroup.selectAll("text").remove(), t.losingFlagsGroup.selectAll("text").remove()) : e.selectAll("text").remove(), e.append("text").attr("font-size", `${o}px`).attr(vS, "middle").attr(yS, "middle").attr("transform", `translate(0, ${r * a})`).text(zS(n)));
}
function IS(e, t, n, r = {}) {
	let i = r.width || 800, a = r.height || 800, s = Math.min(i, a) / 800 * (r.textScaleFactor ?? 1), c = 28 * s, l = 24 * s, u = 30 * s, d = n || r.title || "Tournament", f = Object.assign({}, ...o.countries.filter((e) => e.label).map((e) => ({ [e.ioc]: e.label }))), p = DS(t), m = vx(p, (e) => e.children).sum((e) => e.value || 0), h = Math.min(i, a) / 2, g = h / 2, _ = (e) => e * h / 200;
	Dx().size([2 * Math.PI, h - g])(m), OS(p, Hx().domain([0, t.drawSize || 128]).range([0, 1]));
	let v = m.descendants(), y = uS().startAngle((e) => e.x0).endAngle((e) => e.x1).innerRadius((e) => e.y0 + g).outerRadius((e) => e.y1 + g), { svg: b, g: x, flagsGroup: S, winningFlagsGroup: C, losingFlagsGroup: w } = NS(e, i, a), T = /* @__PURE__ */ new Set(), E = (e) => {
		e.nationalityCode && T.add(e.nationalityCode), e.children && e.children.forEach(E);
	};
	E(p);
	let D = Array.from(T), { centerText: O, centerText2: k } = PS(b, i, a, c, l);
	function A() {
		let e = mS(d, 15);
		O.text(""), O.selectAll("tspan").remove(), k.text(""), k.selectAll("tspan").remove(), O.selectAll("tspan").data(e).join("tspan").attr("x", i / 2).attr("dy", (e, t) => t === 0 ? 0 : u).text((e) => e);
		let t = -(e.length * u / 2) + u / 2;
		O.attr("y", a / 2 + t), O.style("display", "block"), k.style("display", "none");
	}
	function j() {
		if (S.selectAll("text").remove(), C.selectAll("text").remove(), w.selectAll("text").remove(), D.length === 0) return;
		let e = Hx().domain([0, D.length]).range([0, Math.PI * 2]), t = _(20), n = g - t + 10;
		S.selectAll("text").data(D).join("text").attr("font-size", `${t}px`).attr(vS, "middle").attr(yS, "middle").attr("transform", (t, r) => {
			let i = e(r);
			return `translate(${Math.cos(i) * n}, ${Math.sin(i) * n})`;
		}).text((e) => zS(e)).style("cursor", "pointer").on("mouseover", function(e, t) {
			let n = f[t] || t;
			O.selectAll("tspan").remove(), O.attr("y", a / 2), O.text(n).style("display", "block"), k.selectAll("tspan").remove(), k.text("").style("display", "none"), N || x.selectAll("path").attr(bS, (e) => e.data.nationalityCode === t ? .9 : .3);
		}).on("mouseout", function() {
			N || x.selectAll("path").attr(bS, .8), A();
		});
	}
	j(), A();
	let M = r.eventHandlers?.clickCenter;
	M && x.insert("circle", ":first-child").attr("r", g).attr("fill", "transparent").style("cursor", "pointer").on("click", M);
	let N = !1, P;
	function F(e, t) {
		let n = t.data;
		if (n.participantName) {
			let { messageLines: e, opponentData: r } = jS(n, t);
			r && (n.opponent = r), O.selectAll("tspan").remove(), O.text(""), O.selectAll("tspan").data(e).join("tspan").attr("x", i / 2).attr("dy", (e, t) => t === 0 ? 0 : u).text((e) => e);
			let o = MS(e.length, u);
			O.attr("y", a / 2 + o), O.style("display", "block"), k.style("display", "none");
		}
		N ? n.participantName?.toLowerCase() !== P?.toLowerCase() && x_(e.currentTarget).attr(bS, .9) : x.selectAll("path").attr(bS, (e) => e.data.participantName === t.data.participantName ? .9 : .3);
		let r = _(30), o = g - r - 10, s = {
			flagsGroup: S,
			winningFlagsGroup: C,
			losingFlagsGroup: w
		};
		FS(C, s, n.nationalityCode, -1, !0, o, r), n.opponent && FS(w, s, n.opponent.nationalityCode, 1, !1, o, r);
	}
	function ee(e, t) {
		if (N) {
			let n = t.data.participantName?.toLowerCase() === P?.toLowerCase();
			x_(e.currentTarget).attr(bS, n ? 1 : .2);
		} else x.selectAll("path").attr(bS, .8);
		j(), A();
	}
	let te = r.eventHandlers?.clickSegment;
	function ne(e, t) {
		if (!te) return;
		let n = t.data;
		te({
			participantName: n.participantName,
			drawPosition: n.drawPosition,
			seedNumber: n.seedNumber,
			entryStatus: n.entryStatus,
			nationalityCode: n.nationalityCode,
			scoreString: n.scoreString,
			matchUpStatus: n.matchUpStatus,
			roundName: n.roundName,
			depth: n.depth,
			matchUp: n.matchUp
		});
	}
	let re = x.selectAll("path").data(v).join("path").attr("d", (e) => y(e)).attr("fill", (e) => e.data.color || "#ccc").attr(bS, .8).attr("stroke", "#fff").attr("stroke-width", 1).on("mouseover", F).on("mouseout", ee);
	te && re.style("cursor", "pointer").on("click", ne), re.append("title").text((e) => {
		let t = e.data;
		return t.participantName ? `${t.participantName}\nDraw: ${t.drawPosition || "N/A"}` : `${t.name}\nDepth: ${e.depth}`;
	});
	function I(e) {
		let t = 0;
		return N = !!e, P = e, x.selectAll("path").attr(bS, (n) => e ? n.data.participantName?.toLowerCase() === e.toLowerCase() ? (t += 1, 1) : .2 : .8), t;
	}
	function ie(e) {
		b.style("display", e ? "none" : "block");
	}
	return {
		highlightPlayer: I,
		hide: ie
	};
}
function LS(e = {}) {
	return { render: (t, n, r) => IS(t, n, r, e) };
}
function RS(e) {
	return e?.length === 2 ? e && String.fromCodePoint !== void 0 ? e.toUpperCase().replaceAll(/./g, (e) => String.fromCodePoint((e.codePointAt(0) ?? 0) + 127397)) : e : "";
}
function zS(e) {
	return RS(xS[e] || e);
}
//#endregion
//#region src/components/burstChart/matchUpTransform.ts
var { LUCKY_LOSER: BS, WILDCARD: VS, QUALIFIER: HS } = n;
function US(e) {
	let t = {};
	for (let [n, r] of Object.entries(e.roundMatchUps)) t[Number(n)] = r.map((e) => ({
		...e,
		winningSide: e.winningSide,
		drawPositions: e.drawPositions || [],
		scoreString: e.winningSide === 1 ? e.score?.scoreStringSide1 : e.winningSide === 2 ? e.score?.scoreStringSide2 : void 0,
		sides: (e.sides || []).map((e) => ({
			sideNumber: e.sideNumber,
			drawPosition: e.drawPosition,
			participantName: e.participant?.participantName,
			nationalityCode: e.participant?.person?.nationalityCode,
			seedNumber: e.seedNumber,
			entryStatus: e.participant?.entryStatus
		}))
	}));
	return {
		drawSize: (t[1]?.length || 0) * 2,
		roundMatchUps: t,
		seedAssignments: e.seedAssignments
	};
}
var WS = {
	LL: BS,
	WC: VS,
	Q: HS
}, GS = [
	"R128",
	"R64",
	"R32",
	"R16",
	"QF",
	"SF",
	"F"
];
function KS(e) {
	let t = qS(e);
	if (t.length === 0) return {
		drawSize: 0,
		roundMatchUps: {}
	};
	let n = t[0].data, r = n.length, i = JS(n), a = YS(t, e), o = {};
	o[1] = ZS(n, a, t);
	for (let e = 1; e < t.length; e++) o[e + 1] = QS(e, t, a, i);
	return {
		drawSize: r,
		roundMatchUps: o
	};
}
function qS(e) {
	let t = [], n = !1;
	for (let r of GS) {
		let i = e[r];
		i && i.length > 0 && (n = !0), n && i && i.length > 0 && t.push({
			key: r,
			data: i
		});
	}
	return t;
}
function JS(e) {
	let t = /* @__PURE__ */ new Map();
	return e.forEach((e, n) => {
		let r = $S(e.player);
		r && r !== "BYE" && t.set(r, {
			drawPosition: e.Draw ?? n + 1,
			country: e.country,
			seed: e.seed,
			entry: e.entry
		});
	}), t;
}
function YS(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let r = 0; r < e.length; r++) {
		let i = r + 1 < e.length ? e[r + 1].data : t.W || [], a = /* @__PURE__ */ new Set();
		for (let e of i) {
			let t = $S(e.player);
			t && a.add(t);
		}
		n.set(e[r].key, a);
	}
	return n;
}
function XS(e, t, n) {
	if (e === "BYE" || t === "BYE") return e === "BYE" ? 2 : 1;
	if (n.has(e)) return 1;
	if (n.has(t)) return 2;
}
function ZS(e, t, n) {
	let r = [], i = t.get(n[0].key) || /* @__PURE__ */ new Set();
	for (let t = 0; t < e.length; t += 2) {
		let a = e[t], o = e[t + 1], s = $S(a?.player), c = $S(o?.player), l = s === "BYE" || c === "BYE", u = XS(s, c, i), d;
		if (!l && n.length > 1) {
			let e = n[1].data, t = u === 1 ? s : c;
			d = e.find((e) => $S(e.player) === t)?.score;
		}
		let f = l ? "BYE" : u ? "COMPLETED" : "TO_BE_PLAYED";
		r.push({
			roundNumber: 1,
			matchUpStatus: f,
			winningSide: u,
			drawPositions: [a?.Draw ?? t + 1, o?.Draw ?? t + 2],
			scoreString: d,
			sides: [tC(1, a, t + 1), tC(2, o, t + 2)]
		});
	}
	return r;
}
function QS(e, t, n, r) {
	let i = e + 1, a = t[e].data, o = n.get(t[e].key) || /* @__PURE__ */ new Set(), s = [];
	for (let e = 0; e < a.length; e += 2) {
		let t = a[e], n = a[e + 1], c = $S(t?.player), l = $S(n?.player), u = o.has(c) ? 1 : o.has(l) ? 2 : void 0, d = (u === 1 ? t : u === 2 ? n : void 0)?.score, f = u ? "COMPLETED" : "TO_BE_PLAYED";
		s.push({
			roundNumber: i,
			matchUpStatus: f,
			winningSide: u,
			drawPositions: [r.get(c)?.drawPosition ?? 0, r.get(l)?.drawPosition ?? 0],
			scoreString: d,
			sides: [nC(1, t, r), nC(2, n, r)]
		});
	}
	return s;
}
function $S(e) {
	if (!e) return "";
	let t = e.trim();
	return t.toUpperCase() === "BYE" ? "BYE" : t;
}
function eC(e) {
	if (e) return WS[e.toUpperCase()] || e;
}
function tC(e, t, n) {
	if (!t) return {
		sideNumber: e,
		drawPosition: n
	};
	let r = $S(t.player);
	return {
		sideNumber: e,
		drawPosition: t.Draw ?? n,
		participantName: r || void 0,
		nationalityCode: t.country || void 0,
		seedNumber: t.seed ? Number(t.seed) : void 0,
		entryStatus: eC(t.entry)
	};
}
function nC(e, t, n) {
	if (!t) return {
		sideNumber: e,
		drawPosition: 0
	};
	let r = $S(t.player), i = n.get(r);
	return {
		sideNumber: e,
		drawPosition: i?.drawPosition ?? 0,
		participantName: r || void 0,
		nationalityCode: t.country || i?.country || void 0,
		seedNumber: t.seed ? Number(t.seed) : i?.seed ? Number(i.seed) : void 0,
		entryStatus: eC(t.entry || i?.entry)
	};
}
//#endregion
//#region src/components/button/dropDownButton.ts
var rC = "right", iC = "font-medium";
function aC({ target: e, button: t, stateChange: n }) {
	let r = 0, i = () => (r += 1, `Item${r}`), a = document.createElement("div");
	t.class && a.classList.add(t.class), a.classList.add("dropdown"), t.id && (a.id = t.id), t.align === rC ? (a.classList.add("is-right"), a.style.cssText = "margin-left: 1em") : a.style.cssText = "margin-right: 1em";
	let o = (e) => e.classList.contains("is-active"), s = () => {
		o(a) && a.classList.remove("is-active");
	}, c = (e) => o(e) ? (e.classList.remove("is-active"), !1) : (e.classList.add("is-active"), !0);
	a.onmouseleave = s, a.onclick = () => c(a);
	let l = document.createElement("div");
	l.classList.add("dropdown-trigger");
	let u = document.createElement("button");
	u.className = "button font-medium", t.intent && u.classList.add(t.intent), u.setAttribute("aria-haspopup", "true");
	let d = document.createElement("span");
	z(t.onClick) && (d.onclick = t.onClick), d.style.cssText = "margin-right: 1em", d.innerHTML = t.label, u.appendChild(d);
	let f = document.createElement("span");
	z(t.onClick) && (f.onclick = t.onClick), f.innerHTML = "\n      <span class=\"icon is-small font-medium\">\n        <i class=\"fas fa-angle-down font-medium\" aria-hidden=\"true\"></i>\n      </span>\n  ", u.appendChild(f), l.appendChild(u), a.appendChild(l);
	let p = document.createElement("div");
	p.classList.add("dropdown-menu"), p.setAttribute("z-index", "99998");
	let m = document.createElement("div");
	m.classList.add("dropdown-content");
	let h = () => {
		let e = p.querySelectorAll(".dropdown-item");
		for (let t of Array.from(e)) t.classList.remove("is-active");
	}, g = (e) => {
		let r = document.createElement("a");
		r.className = iC;
		let l = e.disabled ? "0.4" : "1";
		return r.style.cssText = `text-decoration: none; opacity: ${l};`, e.color && (r.style.color = e.color), r.classList.add("dropdown-item"), e.isActive && r.classList.add("is-active"), e.value && (r.value = e.value), e.class && r.classList.add(e.class), r.onclick = (l) => {
			if (e.disabled) return;
			e.value && (u.value = e.value, a.value = e.value), l.stopPropagation(), z(e.onClick) && (z(n) && n(), e.onClick(l)), e.close && s();
			let f = o(r);
			h(), f ? d.innerHTML = t.label : (t.selection && c(r), t.modifyLabel && e.modifyLabel !== !1 && (d.innerHTML = `${t.append ? t.label + ": " : ""}${e?.label || i()}`));
		}, r.innerHTML = e?.label || i(), r;
	};
	for (let e of t.options || []) if (e.heading) {
		let t = document.createElement("div");
		t.style.cssText = "font-weight: bold", t.classList.add("dropdown-item", iC), t.innerHTML = e.heading, m.appendChild(t);
	} else if (e.divider) {
		let e = document.createElement("hr");
		e.classList.add("dropdown-divider", iC), m.appendChild(e);
	} else e.hide || m.appendChild(g(e));
	return t.options?.length && (t.options[0].value && (a.value = t.options[0].value), p.appendChild(m)), a.appendChild(p), e && e.appendChild(a), a;
}
//#endregion
//#region src/components/modal/selectItem.ts
var oC = "left";
function sC(e) {
	let { title: t, placeholder: n, options: r, selectionLimit: i, createTable: a, createFilter: o } = e, s = "selectionControl", c = "selectionTable", l, u, d = [{
		label: "Cancel",
		intent: "is-none",
		close: !0
	}], f = () => {
		u ? u() : l?.destroy && l.destroy(), l = void 0;
	}, p = `
    <div style='min-height: 420px'>
      <div id='${s}'></div>
      <div id='${c}'></div>
    </div>
  `;
	R.open({
		title: t,
		content: p,
		buttons: d,
		onClose: f
	});
	let m = (e) => {
		e?.[0]?.onClick && (e[0].onClick(), R.close());
	};
	if (a) {
		let e = a({
			anchorId: c,
			data: r,
			selectionLimit: i,
			onSelected: m
		});
		l = e.table, u = e.destroy;
		let t = o ? o(l) : () => {}, d = [{
			onKeyDown: (e) => e.keyCode === 8 && e.target.value.length === 1 && t(""),
			onChange: (e) => t(e.target.value),
			onKeyUp: (e) => t(e.target.value),
			clearSearch: () => t(""),
			placeholder: n || "Search",
			location: oC,
			search: !0
		}], f = document.getElementById(s) || void 0;
		kC({
			table: l,
			target: f,
			items: d
		});
	} else {
		let e = document.getElementById(c);
		if (e) {
			cC({
				container: e,
				options: r,
				onSelected: m
			});
			let t = (t) => {
				let n = e.querySelectorAll("[data-select-item]"), r = t.toLowerCase();
				n.forEach((e) => {
					let n = e.textContent?.toLowerCase() || "";
					e.style.display = !t || n.includes(r) ? "" : "none";
				});
			}, i = [{
				onKeyUp: (e) => t(e.target.value),
				clearSearch: () => t(""),
				placeholder: n || "Search",
				location: oC,
				search: !0
			}];
			kC({
				target: document.getElementById(s) || void 0,
				items: i
			});
		}
	}
}
function cC({ container: e, options: t, onSelected: n }) {
	let r = document.createElement("div");
	r.style.cssText = "max-height: 380px; overflow-y: auto; padding: 0.5em 0;";
	for (let e of t) {
		let t = document.createElement("a");
		t.setAttribute("data-select-item", ""), t.className = "panel-block font-medium", t.style.cssText = "cursor: pointer; padding: 0.5em 1em; display: block; text-decoration: none; color: inherit;", t.innerHTML = e.label, t.onmouseenter = () => t.style.backgroundColor = "#f5f5f5", t.onmouseleave = () => t.style.backgroundColor = "", t.onclick = (t) => {
			t.stopPropagation(), n([e]);
		}, r.appendChild(t);
	}
	e.appendChild(r);
}
//#endregion
//#region src/components/button/barButton.ts
var lC = "none", uC = "right";
function dC(e) {
	let t = document.createElement("button");
	return t.className = "button font-medium", e.disabled && (t.disabled = !0), e.class && t.classList.add(e.class), e.id && (t.id = e.id), e.location === uC ? t.style.marginLeft = "1em" : t.style.marginRight = "1em", e.intent && t.classList.add(e.intent), e.toolTip?.content && Am(t, e.toolTip), t.innerHTML = e.label, e.visible === !1 && (t.style.display = lC), t;
}
//#endregion
//#region src/components/controlBar/toggleOverlay.ts
var fC = "center", pC = "", mC = "flex", hC = "left", gC = "none", _C = "overlay", vC = "right", yC = ({ target: e }) => (t = []) => {
	e.style.backgroundColor = t?.length ? "var(--chc-hover-bg)" : pC;
	let n = (n, r, i) => {
		let a = e.getElementsByClassName(`options_${n}`)[0];
		a && (a.style.display = t?.length ? r : i);
	};
	n(_C, mC, gC), n(hC, gC, mC), n(fC, gC, mC), n(vC, gC, mC);
}, bC = "center", xC = "header", SC = "", CC = "left", wC = "none", TC = "overlay", EC = "right", DC = "buttonBar", OC = "top";
function kC(e) {
	let { table: t, targetClassName: n, items: r = [], onSelection: i, selectItemFn: a } = e, { target: o } = e, s = !!o;
	if (!o && n && (o = document.getElementsByClassName(n)?.[0]), !o) return {
		elements: {},
		inputs: {}
	};
	let c = 0, l = 0, u = {}, d = {}, f;
	if (s) {
		ue(o);
		let e = LC();
		Object.assign(u, e.elements), o.appendChild(e.anchor);
	}
	let p = Object.assign({}, ...[
		TC,
		CC,
		bC,
		EC,
		xC
	].map((e) => {
		let t = o.getElementsByClassName(`options_${e}`)?.[0];
		return ue(t), { [e]: t };
	}).filter(Boolean)), m = yC({
		table: t,
		target: o
	}), h = (e, n) => {
		z(n.onClick) && (e.stopPropagation(), n.disabled || n.onClick(e, t), n.stateChange && m());
	}, g = {
		onClick: () => {},
		location: EC
	};
	for (let e of r) {
		let t = { ...g };
		he(e) && Object.assign(t, e);
		let n = p[t.location];
		if (!n) {
			console.log(t.location, p);
			continue;
		}
		t.location === TC && (c += 1), t.location === xC && (AC(t, o), l += 1);
		let r = jC(e, t, n, m, h, a, u, d);
		r?.focus && (f = r.focus);
	}
	let _ = o.getElementsByClassName("panelHeader")[0];
	return _ && (_.style.display = l ? SC : wC), t?.on("rowSelectionChanged", (e, t) => {
		z(i) && i(t), c && m(t);
	}), m(), f && setTimeout(() => f.focus(), 200), {
		elements: u,
		inputs: d
	};
}
function AC(e, t) {
	if (z(e.headerClick)) {
		let n = t.getElementsByClassName("panelHeader")[0];
		n && (n.onclick = e.headerClick);
	}
}
function jC(e, t, n, r, i, a, o, s) {
	if (!t.hide && (t.input || t.placeholder || t.search)) {
		let r = MC(e, t);
		return t.id && (s[t.id] = r.input), t.id && (o[t.id] = r.elem, r.elem.id = t.id), n?.appendChild(r.elem), t.focus ? { focus: r.input } : void 0;
	}
	if (!t.hide && t.text) {
		let e = document.createElement("div");
		e.className = "font-medium", t.id && (o[t.id] = e, e.id = t.id), e.innerHTML = t.text, e.onclick = (e) => i(e, t), n?.appendChild(e);
		return;
	}
	!t.id && (!t?.label || t.hide) || (PC(t, n, r, i, a, o), (!(t?.label || t.tabs) || t.hide) && o[t.id] && (o[t.id].style.display = wC));
}
function MC(e, t) {
	let n = document.createElement("p");
	n.style.cssText = "margin-right: 1em", n.className = `control ${t.search ? "has-icons-left has-icons-right" : ""}`;
	let r = document.createElement("input");
	if (r.className = "input font-medium", r.setAttribute("type", "text"), r.setAttribute("autocomplete", "off"), r.setAttribute("placeholder", e.placeholder || SC), t.id && r.setAttribute("id", t.id), t.onKeyDown && r.addEventListener("keydown", (e) => t.onKeyDown(e, t)), t.onChange && r.addEventListener("change", (e) => t.onChange(e, t)), t.onKeyUp && r.addEventListener("keyup", (e) => {
		t.clearSearch && e.key === "Escape" && (e.stopPropagation(), r.value = "", t.clearSearch()), t.onKeyUp(e, t);
	}), t.class && r.classList.add(t.class), t.visible === !1 && (n.style.display = wC), t.value && (r.value = t.value), n.appendChild(r), t.search && NC(n, r, t), e.validator) {
		let t = document.createElement("p");
		t.className = "help font-medium", n.appendChild(t), r.addEventListener("input", (n) => xn(e, n, r, t, e.validator));
	}
	return {
		elem: n,
		input: r
	};
}
function NC(e, t, n) {
	let r = document.createElement("span");
	if (r.className = "icon is-small is-left font-medium", r.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"16\" height=\"16\" fill=\"currentColor\"><path d=\"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z\"/></svg>", e.appendChild(r), z(n.clearSearch)) {
		let r = document.createElement("span");
		r.className = "icon is-small is-right font-medium", r.style.pointerEvents = "all", r.style.cursor = "pointer", r.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"16\" height=\"16\" fill=\"#dddada\"><path d=\"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z\"/></svg>", r.onclick = (e) => {
			e.stopPropagation(), t.value = "", n.clearSearch();
		}, e.appendChild(r);
	}
}
function PC(e, t, n, r, i, a) {
	if (e.options) {
		let r = aC({
			target: t,
			button: e,
			stateChange: n
		});
		e.visible === !1 && (r.style.display = wC), e.id && (a[e.id] = r);
	} else if (he(e.selection)) FC(e, t, n, i, a);
	else if (e.tabs) IC(e, t, a);
	else {
		let n = dC(e);
		n.onclick = (t) => r(t, e), e.id && (a[e.id] = n), t?.appendChild(n);
	}
}
function FC(e, t, n, r, i) {
	let { selection: { options: a, actions: o }, actionPlacement: s, threshold: c = 8, ...l } = e;
	if (a?.length < c) {
		a.length && (s === OC ? a.unshift({ divider: !0 }) : a.push({ divider: !0 })), o.forEach((e) => {
			let { label: t, ...n } = e, r = {
				...n,
				label: `<p style="font-weight: bold">${t}</p>`
			};
			s === OC ? a.unshift(r) : a.push(r);
		});
		let r = {
			...l,
			options: a
		}, c = aC({
			target: t,
			button: r,
			stateChange: n
		});
		r.visible === !1 && (c.style.display = wC), r.id && (i[e.id] = c);
	} else {
		let n = dC(e), o = r || sC;
		n.onclick = (t) => {
			t.stopPropagation(), o({
				title: e.selectionTitle || "Select",
				options: a
			});
		}, e.id && (i[e.id] = n), t?.appendChild(n);
	}
}
function IC(e, t, n) {
	let r = document.createElement("div");
	r.className = "tabs is-toggle is-toggle-rounded";
	let i = document.createElement("ul");
	r.appendChild(i), e.tabs.forEach((t) => {
		let n = document.createElement("li");
		t.active && n.classList.add("is-active");
		let r = document.createElement("a");
		n.appendChild(r), r.onclick = (r) => {
			i.querySelectorAll("li").forEach((e) => e.classList.remove("is-active")), n.classList.add("is-active"), z(t.onClick) && t.onClick(r, e);
		};
		let a = document.createElement("span");
		a.innerHTML = t.label, r.appendChild(a), i.appendChild(n);
	}), e.id && (n[e.id] = r), t.appendChild(r);
}
function LC() {
	let e = document.createElement("div");
	e.className = "panel_container flexcol flexcenter";
	let t = document.createElement("div");
	t.className = "panelHeader options_header", t.style.display = wC, e.appendChild(t);
	let n = document.createElement("div");
	n.className = DC;
	let r = {
		optionsOverlay: document.createElement("div"),
		optionsLeft: document.createElement("div"),
		optionsCenter: document.createElement("div"),
		optionsRight: document.createElement("div")
	};
	r.optionsOverlay.className = "options_overlay", r.optionsCenter.className = "options_center", r.optionsRight.className = "options_right", r.optionsLeft.className = "options_left";
	for (let e of Object.values(r)) n.appendChild(e);
	return e.appendChild(n), {
		elements: r,
		anchor: e,
		header: t
	};
}
//#endregion
//#region src/components/scheduling-profile/ui/styles.ts
var RC = () => "sp-layout", zC = () => "sp-column", BC = () => "sp-panel", VC = () => "sp-panel-header", HC = () => "sp-panel-title", UC = () => "sp-panel-meta", WC = () => "sp-date-strip", GC = () => "sp-date-chip", KC = () => "sp-badges", qC = () => "sp-badge", JC = () => "sp-chips", YC = () => "sp-chip", XC = () => "sp-board", ZC = () => "sp-venue", QC = () => "sp-venue-header", $C = () => "sp-venue-title", ew = () => "sp-venue-sub", tw = () => "sp-dropzone", nw = () => "sp-card", rw = () => "sp-card-title", iw = () => "sp-card-meta", aw = () => "sp-issues", ow = () => "sp-issue", sw = () => "sp-issue-code", cw = () => "sp-issue-msg", lw = () => "sp-issue-actions", uw = () => "sp-btn sp-btn--sm", dw = () => "sp-catalog", fw = () => "sp-catalog-toolbar", pw = () => "sp-input", mw = () => "sp-select", hw = () => "sp-group", gw = () => "sp-group-header", _w = () => "sp-group-body", vw = () => "sp-catalog-item", yw = () => "sp-inspector", bw = () => "sp-kv", xw = () => "sp-kv-key", Sw = () => "sp-kv-value", Cw = () => "sp-small", ww = () => "sp-popover-item", Tw = () => "sp-popover-delete", Ew = () => "sp-popover-divider", Dw = () => "sp-insertion-line", Ow = () => "sp-group-chevron";
//#endregion
//#region src/components/scheduling-profile/ui/schedulingProfileLayout.ts
function kw(e, t) {
	let n = !!t?.hideLeft, r = t?.catalogSide === "left", i = document.createElement("div");
	if (i.className = RC(), n) r ? i.classList.add("sp-catalog-left") : i.classList.add("sp-no-left");
	else {
		let t = document.createElement("div");
		t.className = zC(), t.appendChild(e.dateStrip.element), e.issuesPanel.element.style.flex = "1", e.issuesPanel.element.style.minHeight = "0", t.appendChild(e.issuesPanel.element), i.appendChild(t);
	}
	let a = document.createElement("div");
	a.className = zC(), e.venueBoard.element.style.flex = "1", e.venueBoard.element.style.minHeight = "0", a.appendChild(e.venueBoard.element);
	let o = document.createElement("div");
	o.className = zC(), e.roundCatalog.element.style.flex = "1", e.roundCatalog.element.style.minHeight = "0", o.appendChild(e.roundCatalog.element), o.appendChild(e.inspectorPanel.element), r && n ? (i.appendChild(o), i.appendChild(a)) : (i.appendChild(a), i.appendChild(o));
	function s(t) {
		n || (e.dateStrip.update(t), e.issuesPanel.update(t)), e.venueBoard.update(t), e.roundCatalog.update(t), e.inspectorPanel.update(t);
	}
	return {
		element: i,
		update: s
	};
}
//#endregion
//#region src/components/scheduling-profile/ui/cardPopover.ts
function Aw(e) {
	let t = null, n = null;
	function r(e) {
		return `${e.date}|${e.venueId}|${e.index}`;
	}
	function i() {
		t && (t.destroy(), t = null, n = null);
	}
	function a(t) {
		let n = document.createElement("div");
		n.style.cssText = "font-family:sans-serif; font-size:13px; min-width:150px;";
		let r = document.createElement("div");
		r.className = ww(), r.textContent = "Set Not Before Time", r.addEventListener("click", () => {
			i(), e.onSetNotBeforeTime(t);
		}), n.appendChild(r);
		let a = document.createElement("div");
		a.className = Ew(), n.appendChild(a);
		let o = document.createElement("div");
		return o.className = Tw(), o.textContent = "Remove Round", o.addEventListener("click", () => {
			i(), e.onDelete(t);
		}), n.appendChild(o), n;
	}
	return {
		show(e, o) {
			let s = r(o);
			if (n === s) {
				i();
				return;
			}
			i();
			let c = Am(e, {
				content: a(o),
				allowHTML: !0,
				interactive: !0,
				trigger: "manual",
				placement: "bottom",
				appendTo: document.body,
				onHidden: () => {
					t = null, n = null;
				}
			});
			t = c, n = s, c.show();
		},
		destroy() {
			i();
		},
		isActiveFor(e) {
			return n === r(e);
		}
	};
}
//#endregion
//#region src/components/scheduling-profile/domain/utils.ts
function jw(e) {
	return structuredClone(e);
}
function Mw(e, t, n) {
	return Math.max(t, Math.min(n, e));
}
function Nw(e) {
	return `${e.tournamentId}|${e.eventId}|${e.drawId}|${e.structureId}|${e.roundNumber}`;
}
function Pw(e) {
	return `${e.eventName ? `${e.eventName} \u2013 ` : ""}${e.roundName ?? `Round ${e.roundNumber}`}${e.roundSegment ? ` (seg ${e.roundSegment.segmentNumber}/${e.roundSegment.segmentsCount})` : ""}`;
}
function Fw(e, t) {
	return !e || !t ? !1 : e.date === t.date && e.venueId === t.venueId && e.index === t.index;
}
function Iw(e) {
	return {
		tournamentId: e.tournamentId,
		eventId: e.eventId,
		drawId: e.drawId,
		structureId: e.structureId,
		roundNumber: e.roundNumber
	};
}
//#endregion
//#region src/components/scheduling-profile/domain/profileProjections.ts
function Lw(e, t, n) {
	return e.find((e) => e.scheduleDate === t)?.venues?.find((e) => e.venueId === n)?.rounds ?? [];
}
function Rw(e, t) {
	return (e.find((e) => e.scheduleDate === t.date)?.venues?.find((e) => e.venueId === t.venueId))?.rounds?.[t.index] ?? null;
}
function zw(e, t) {
	return e.filter((e) => Bw(e.context?.locator, t) || Bw(e.context?.prerequisite, t));
}
function Bw(e, t) {
	return !!e && e.date === t.date && e.venueId === t.venueId && e.index === t.index;
}
function Vw(e) {
	return e.length ? e.some((e) => e.severity === "ERROR") ? "ERROR" : e.some((e) => e.severity === "WARN") ? "WARN" : "INFO" : null;
}
function Hw(e, t) {
	let n = Nw(t);
	for (let t of e) for (let e of t.venues) for (let r = 0; r < e.rounds.length; r++) {
		let i = e.rounds[r];
		if (Nw(Iw(i)) === n) return {
			date: t.scheduleDate,
			venueId: e.venueId,
			index: r,
			roundKey: Iw(i),
			roundSegment: i.roundSegment
		};
	}
	return null;
}
//#endregion
//#region src/components/scheduling-profile/ui/inspectorPanel.ts
function Uw() {
	let e = document.createElement("div");
	e.className = BC();
	let t = document.createElement("div");
	t.className = VC();
	let n = document.createElement("div");
	n.className = HC(), n.textContent = "Inspector", t.appendChild(n), e.appendChild(t);
	let r = document.createElement("div");
	r.className = yw(), e.appendChild(r);
	function i(e) {
		r.innerHTML = "";
		let t = e.selectedLocator;
		if (!t) {
			let e = document.createElement("div");
			e.className = Cw(), e.textContent = "Select a round card on the board to see details and context.", r.appendChild(e);
			return;
		}
		let n = Rw(e.profileDraft, t);
		if (!n) {
			let e = document.createElement("div");
			e.className = Cw(), e.textContent = "Selection no longer exists.", r.appendChild(e);
			return;
		}
		let i = zw(e.ruleResults, t), a = Vw(i);
		if (Ww(r, "Event", n.eventName ?? ""), Ww(r, "Draw", n.drawName || ""), Ww(r, "Round", n.roundName && !/^rn=/.test(n.roundName) ? n.roundName : "Round " + n.roundNumber), Ww(r, "Segment", n.roundSegment ? `${n.roundSegment.segmentNumber}/${n.roundSegment.segmentsCount}` : "—"), Ww(r, "Not before", n.notBeforeTime ?? "—"), Ww(r, "Status", a ?? "OK"), i.length) {
			let e = document.createElement("div");
			e.className = Cw(), e.style.marginTop = "8px", e.textContent = "Issues for this item:", r.appendChild(e);
			for (let e of i) {
				let t = document.createElement("div");
				t.className = Cw(), t.innerHTML = `\u2022 <b>${Gw(e.code)}</b>: ${Gw(e.message)}`, r.appendChild(t);
			}
		} else {
			let e = document.createElement("div");
			e.className = Cw(), e.style.marginTop = "8px", e.textContent = "No issues associated with this card.", r.appendChild(e);
		}
	}
	return {
		element: e,
		update: i
	};
}
function Ww(e, t, n) {
	let r = document.createElement("div");
	r.className = bw();
	let i = document.createElement("div");
	i.className = xw(), i.textContent = t;
	let a = document.createElement("div");
	a.className = Sw(), a.textContent = n, r.appendChild(i), r.appendChild(a), e.appendChild(r);
}
function Gw(e) {
	return e.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
//#endregion
//#region src/components/scheduling-profile/domain/catalogProjections.ts
function Kw(e, t, n, r = "dim") {
	let i = t.toLowerCase().trim();
	return e.filter((e) => r === "hide" && n.has(Nw(e)) ? !1 : i ? `${e.eventName} ${e.drawName ?? ""} ${e.roundName ?? ""} ${e.drawId}`.toLowerCase().includes(i) : !0).map((e) => ({
		...e,
		isPlanned: n.has(Nw(e))
	}));
}
function qw(e, t) {
	let n = /* @__PURE__ */ new Map(), r = (e) => t === "draw" ? `${e.eventName} \u2014 ${e.drawName ?? e.drawId}` : t === "round" ? e.roundName ?? `Round ${e.roundNumber}` : e.eventName;
	for (let t of e) {
		let e = r(t), i = n.get(e);
		i ? i.push(t) : n.set(e, [t]);
	}
	return new Map([...n.entries()].sort((e, t) => e[0].localeCompare(t[0])));
}
function Jw(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) for (let e of n.venues) for (let n of e.rounds) n.roundSegment || t.add(Nw(n));
	return t;
}
//#endregion
//#region src/components/scheduling-profile/ui/roundCatalog.ts
var Yw = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function Xw(e) {
	return Yw.test(e);
}
function Zw(e) {
	let t = document.createElement("div");
	t.className = BC(), t.style.overflowY = "auto", t.style.scrollbarWidth = "thin", t.style.scrollbarColor = "var(--sp-scrollbar) transparent";
	let n = /* @__PURE__ */ new Set(), r = null, i = document.createElement("div");
	i.className = VC();
	let a = document.createElement("div");
	a.className = HC(), a.textContent = "Round Catalog";
	let o = document.createElement("div");
	o.className = UC(), i.appendChild(a), i.appendChild(o), t.appendChild(i);
	let s = document.createElement("div");
	s.className = fw();
	let c = document.createElement("input");
	c.type = "text", c.placeholder = "Search rounds...", c.className = pw(), c.addEventListener("input", () => e.onSearchChange(c.value));
	let l = document.createElement("select");
	l.className = mw();
	for (let [e, t] of [
		["event", "By Event"],
		["draw", "By Draw"],
		["round", "By Round"]
	]) {
		let n = document.createElement("option");
		n.value = e, n.textContent = t, l.appendChild(n);
	}
	l.addEventListener("change", () => e.onGroupByChange(l.value)), s.appendChild(c), s.appendChild(l), t.appendChild(s);
	let u = document.createElement("div");
	u.className = dw(), t.appendChild(u), u.addEventListener("dragover", (e) => {
		e.preventDefault(), u.classList.add("over"), e.dataTransfer.dropEffect = "move";
	}), u.addEventListener("dragleave", (e) => {
		u.contains(e.relatedTarget) || u.classList.remove("over");
	}), u.addEventListener("drop", (t) => {
		if (u.classList.remove("over"), t.preventDefault(), !e.onDropRemove) return;
		let n;
		try {
			n = JSON.parse(t.dataTransfer.getData("application/json"));
		} catch {
			return;
		}
		n.type === "PLANNED_ROUND" && e.onDropRemove(n.locator);
	});
	function d(t, n) {
		let r = document.createElement("div");
		r.className = vw(), t.isPlanned ? (r.classList.add(n === "navigate" ? "navigate" : "dimmed"), r.draggable = !1, n === "navigate" && r.addEventListener("click", () => {
			e.onNavigateToPlanned?.(t);
		})) : (r.draggable = !0, r.addEventListener("dragstart", (e) => {
			e.stopPropagation(), e.dataTransfer.setDragImage(r, r.offsetWidth / 2, 20), e.dataTransfer.setData("application/json", JSON.stringify({
				type: "CATALOG_ROUND",
				roundRef: t
			})), e.dataTransfer.effectAllowed = "copyMove";
		}));
		let i = document.createElement("div");
		i.className = rw();
		let a = t.roundName && !t.roundName.startsWith("rn=") ? t.roundName : "Round " + t.roundNumber;
		i.textContent = `${t.eventName} \u2014 ${a}`;
		let o = document.createElement("div");
		o.className = iw();
		let s = t.matchCountEstimate ? " · " + t.matchCountEstimate + " matches" : "", c = t.drawName && !Xw(t.drawName) ? t.drawName : "";
		if (o.textContent = c ? `${c}${s}` : s.replace(" · ", "") || "", r.appendChild(i), r.appendChild(o), t.isPlanned && n !== "navigate") {
			let e = document.createElement("span");
			e.className = "sp-catalog-check", e.textContent = "✓", r.appendChild(e);
		}
		return r;
	}
	function f(e) {
		r = e;
		let t = e.plannedRoundBehavior, i = Jw(e.profileDraft), a = Kw(e.roundCatalog, e.catalogSearchQuery, i, t), s = qw(a, e.catalogGroupBy);
		o.textContent = `${a.length} rounds`, c.value !== e.catalogSearchQuery && (c.value = e.catalogSearchQuery), l.value !== e.catalogGroupBy && (l.value = e.catalogGroupBy), u.innerHTML = "";
		for (let [e, i] of s) {
			let a = document.createElement("div");
			a.className = hw();
			let o = n.has(e), s = document.createElement("div");
			s.className = gw();
			let c = document.createElement("span");
			c.className = Ow(), c.textContent = o ? "▶" : "▼";
			let l = document.createElement("span");
			l.textContent = e, s.appendChild(c), s.appendChild(l), s.addEventListener("click", () => {
				n.has(e) ? n.delete(e) : n.add(e), r && f(r);
			});
			let p = document.createElement("div");
			p.className = _w(), o && (p.style.display = "none");
			for (let e of i) p.appendChild(d(e, t));
			a.appendChild(s), a.appendChild(p), u.appendChild(a);
		}
	}
	return {
		element: t,
		update: f
	};
}
//#endregion
//#region src/components/scheduling-profile/ui/issuesPanel.ts
function Qw(e) {
	let t = document.createElement("div");
	t.className = BC();
	let n = document.createElement("div");
	n.className = VC();
	let r = document.createElement("div");
	r.className = HC(), r.textContent = "Issues";
	let i = document.createElement("div");
	i.className = UC(), n.appendChild(r), n.appendChild(i), t.appendChild(n);
	let a = document.createElement("div");
	a.className = aw(), t.appendChild(a);
	function o(t) {
		let n = t.issueIndex.all;
		if (i.textContent = `${n.length} total (${t.issueIndex.bySeverity.ERROR.length} errors)`, a.innerHTML = "", !n.length) {
			let e = document.createElement("div");
			e.className = Cw(), e.textContent = "No issues. Drag rounds into the board to build a profile.", a.appendChild(e);
			return;
		}
		for (let t of n.slice(0, 30)) {
			let n = document.createElement("div");
			n.className = ow(), t.severity === "ERROR" ? n.classList.add("error") : t.severity === "WARN" ? n.classList.add("warn") : n.classList.add("info");
			let r = document.createElement("div");
			r.className = sw(), r.textContent = `${t.severity} \u00b7 ${t.code}`;
			let i = document.createElement("div");
			if (i.className = cw(), i.textContent = t.message, n.appendChild(r), n.appendChild(i), t.fixActions?.length) {
				let r = document.createElement("div");
				r.className = lw();
				for (let n of t.fixActions) {
					let t = document.createElement("button");
					t.className = uw(), t.textContent = n.label ?? n.kind, t.addEventListener("click", () => e.onFixAction(n)), r.appendChild(t);
				}
				n.appendChild(r);
			}
			a.appendChild(n);
		}
	}
	return {
		element: t,
		update: o
	};
}
//#endregion
//#region src/components/scheduling-profile/domain/validateProfile.ts
var { ROUND_ROBIN: $w, ROUND_ROBIN_WITH_PLAYOFF: eT } = t, tT = "Jump to prerequisite";
function nT({ profile: e, temporal: t, dependencies: n, venueOrder: r }) {
	let i = [];
	if (t?.isDateAvailable) for (let n of e) {
		let e = t.isDateAvailable(n.scheduleDate);
		e.ok || i.push({
			code: "DATE_UNAVAILABLE",
			severity: "ERROR",
			message: `Can't schedule on ${n.scheduleDate} \u2014 day is unavailable${e.reason ? ": " + e.reason : ""}.`,
			context: { date: n.scheduleDate },
			fixActions: [{
				kind: "OPEN_TEMPORAL_GRID",
				date: n.scheduleDate,
				label: "Open Temporal Grid"
			}]
		});
	}
	let a = uT(e);
	for (let e of a) {
		let t = e.round.roundSegment;
		t && (Number.isInteger(t.segmentNumber) && Number.isInteger(t.segmentsCount) && t.segmentsCount >= 2 && t.segmentNumber >= 1 && t.segmentNumber <= t.segmentsCount || i.push({
			code: "INVALID_SEGMENT_CONFIG",
			severity: "ERROR",
			message: `Invalid segment configuration for ${Pw(e.round)}.`,
			context: {
				locator: e.locator,
				date: e.locator.date,
				venueId: e.locator.venueId
			}
		}));
	}
	let o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
	for (let e of a) {
		let t = e.round, n = Nw(t);
		if (!t.roundSegment) o.has(n) ? i.push({
			code: "DUPLICATE_ROUND",
			severity: "ERROR",
			message: `Round is planned more than once: ${Pw(t)}.`,
			context: {
				scope: `${t.drawId}|${t.structureId}`,
				locator: e.locator,
				date: e.locator.date,
				venueId: e.locator.venueId
			},
			fixActions: [{
				kind: "JUMP_TO_ITEM",
				locator: o.get(n),
				label: "Jump to existing"
			}]
		}) : o.set(n, e.locator);
		else {
			let r = `${n}|${t.roundSegment.segmentNumber}/${t.roundSegment.segmentsCount}`;
			s.has(r) ? i.push({
				code: "DUPLICATE_SEGMENT",
				severity: "ERROR",
				message: `Segment planned more than once: ${Pw(t)}.`,
				context: {
					scope: `${t.drawId}|${t.structureId}`,
					locator: e.locator,
					date: e.locator.date,
					venueId: e.locator.venueId
				},
				fixActions: [{
					kind: "JUMP_TO_ITEM",
					locator: s.get(r),
					label: "Jump to existing"
				}]
			}) : s.set(r, e.locator);
		}
	}
	return i.push(...iT({
		profile: e,
		venueOrder: r
	})), n?.getRoundDependencies && i.push(...cT(a, n)), i;
}
var rT = new Set([$w, eT]);
function iT({ profile: e }) {
	let t = uT(e), n = aT(t), r = oT(t);
	return fT([...n, ...r]);
}
function aT(e) {
	let t = [], n = dT(e, (e) => `${e.round.structureId}|${e.locator.date}|${e.locator.venueId}`);
	for (let [e, r] of n.entries()) {
		let n = r[0]?.round.structureType;
		if (!(n && rT.has(n))) {
			r.sort((e, t) => e.locator.index - t.locator.index);
			for (let n = 0; n < r.length; n++) {
				let i = r[n], a = null;
				for (let e = n - 1; e >= 0; e--) if (r[e].round.roundNumber > i.round.roundNumber) {
					a = r[e];
					break;
				}
				if (!a) continue;
				let o = lT(r, n, a);
				t.push({
					code: "ROUND_ORDER_VIOLATION",
					severity: "ERROR",
					message: `Cannot place ${Pw(i.round)} before ${Pw(a.round)} in this venue.`,
					context: {
						scope: e,
						drawId: i.round.drawId,
						structureId: i.round.structureId,
						date: i.locator.date,
						venueId: i.locator.venueId,
						locator: i.locator,
						prerequisite: a.locator
					},
					fixActions: [
						{
							kind: "JUMP_TO_ITEM",
							locator: a.locator,
							label: tT
						},
						...o.moveOffenderAfter ? [{
							kind: "MOVE_ITEM_AFTER",
							locator: i.locator,
							after: o.moveOffenderAfter,
							label: "Move offending round after prerequisite set"
						}] : [],
						...o.movePrereqBefore ? [{
							kind: "MOVE_ITEM_BEFORE",
							locator: a.locator,
							before: o.movePrereqBefore,
							label: "Move prerequisite before offending round"
						}] : []
					]
				});
			}
		}
	}
	return t;
}
function oT(e) {
	let t = [], n = dT(e, (e) => e.round.structureId);
	for (let [e, r] of n.entries()) {
		let n = r[0]?.round.structureType;
		if (n && rT.has(n)) continue;
		let i = /* @__PURE__ */ new Map();
		for (let e of r) {
			let t = e.locator.date, n = i.get(t);
			n ? n.push(e) : i.set(t, [e]);
		}
		let a = [...i.keys()].sort();
		if (a.length < 2) continue;
		let o = -Infinity, s = null;
		for (let n of a) {
			let r = i.get(n);
			for (let i of r) i.round.roundNumber < o && s && t.push({
				code: "ROUND_ORDER_VIOLATION",
				severity: "ERROR",
				message: `${Pw(s.round)} is scheduled on ${s.locator.date} but its prerequisite ${Pw(i.round)} is on the later date ${n}.`,
				context: {
					scope: `cross-date|${e}`,
					drawId: s.round.drawId,
					structureId: e,
					date: s.locator.date,
					venueId: s.locator.venueId,
					locator: s.locator,
					prerequisite: i.locator,
					reason: "cross-date"
				},
				fixActions: [{
					kind: "JUMP_TO_ITEM",
					locator: i.locator,
					label: tT
				}]
			});
			for (let e of r) e.round.roundNumber > o && (o = e.round.roundNumber, s = e);
		}
	}
	return t;
}
function sT(e, t) {
	if (!(e.round.structureId === t.round.structureId && e.locator.date === t.locator.date && e.locator.venueId === t.locator.venueId)) {
		if (e.locator.date < t.locator.date) return {
			code: "DEPENDENCY_VIOLATION",
			severity: "ERROR",
			message: `${Pw(e.round)} is scheduled on ${e.locator.date} but depends on ${Pw(t.round)} which is on the later date ${t.locator.date}.`,
			context: {
				date: e.locator.date,
				venueId: e.locator.venueId,
				locator: e.locator,
				prerequisite: t.locator,
				reason: "cross-date"
			},
			fixActions: [{
				kind: "JUMP_TO_ITEM",
				locator: t.locator,
				label: tT
			}]
		};
		if (e.locator.date === t.locator.date && e.locator.venueId === t.locator.venueId && e.locator.index < t.locator.index) return {
			code: "DEPENDENCY_VIOLATION",
			severity: "ERROR",
			message: `${Pw(e.round)} is listed before its prerequisite ${Pw(t.round)} in the same venue on ${e.locator.date}.`,
			context: {
				date: e.locator.date,
				venueId: e.locator.venueId,
				locator: e.locator,
				prerequisite: t.locator,
				reason: "cross-structure-same-day"
			},
			fixActions: [
				{
					kind: "JUMP_TO_ITEM",
					locator: t.locator,
					label: tT
				},
				{
					kind: "MOVE_ITEM_AFTER",
					locator: e.locator,
					after: t.locator,
					label: "Move after prerequisite"
				},
				{
					kind: "MOVE_ITEM_BEFORE",
					locator: t.locator,
					before: e.locator,
					label: "Move prerequisite before"
				}
			]
		};
	}
}
function cT(e, t) {
	let n = [], r = dT(e, (e) => Nw(e.round));
	for (let [e, i] of r.entries()) {
		let a = t.getRoundDependencies(e);
		if (a.length) for (let e of a) {
			let t = r.get(e);
			if (t) for (let e of i) for (let r of t) {
				let t = sT(e, r);
				t && n.push(t);
			}
		}
	}
	return fT(n);
}
function lT(e, t, n) {
	let r = e[t], i = e.indexOf(n);
	for (let t = i + 1; t < e.length; t++) e[t].round.roundNumber >= n.round.roundNumber && (i = t);
	return {
		moveOffenderAfter: e[i].locator,
		movePrereqBefore: r.locator
	};
}
function uT(e) {
	let t = [];
	for (let n of e) for (let e of n.venues) for (let r = 0; r < e.rounds.length; r++) {
		let i = e.rounds[r];
		t.push({
			round: i,
			locator: {
				date: n.scheduleDate,
				venueId: e.venueId,
				index: r,
				roundKey: Iw(i),
				roundSegment: i.roundSegment
			}
		});
	}
	return t;
}
function dT(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let r of e) {
		let e = t(r), i = n.get(e);
		i ? i.push(r) : n.set(e, [r]);
	}
	return n;
}
function fT(e) {
	let t = /* @__PURE__ */ new Set(), n = [];
	for (let r of e) {
		let e = r.code + "|" + r.message + "|" + (r.context?.scope ?? "") + "|" + JSON.stringify(r.context?.locator ?? {});
		t.has(e) || (t.add(e), n.push(r));
	}
	return n;
}
//#endregion
//#region src/components/scheduling-profile/domain/issueIndex.ts
function pT(e) {
	let t = {
		ERROR: [],
		WARN: [],
		INFO: []
	}, n = {}, r = {}, i = {}, a = {
		total: e.length,
		ERROR: 0,
		WARN: 0,
		INFO: 0,
		byDate: {},
		byVenue: {},
		byDraw: {}
	}, o = (e) => e === "ERROR" ? 0 : e === "WARN" ? 1 : 2, s = (e, t) => o(e.severity) - o(t.severity) || e.code.localeCompare(t.code) || e.message.localeCompare(t.message);
	for (let o of e) {
		t[o.severity].push(o), a[o.severity]++;
		let e = o.context?.date ?? o.context?.locator?.date, s = o.context?.venueId ?? o.context?.locator?.venueId, c = o.context?.scope ?? (o.context?.drawId && o.context?.structureId ? `${o.context.drawId}|${o.context.structureId}` : void 0);
		e && (n[e] ??= []).push(o), s && (r[s] ??= []).push(o), c && (i[c] ??= []).push(o), mT(a.byDate, e, o.severity), mT(a.byVenue, s, o.severity), mT(a.byDraw, c, o.severity);
	}
	for (let e of Object.keys(t)) t[e].sort(s);
	for (let e of [
		n,
		r,
		i
	]) for (let t of Object.keys(e)) e[t].sort(s);
	return {
		all: e,
		bySeverity: t,
		byDate: n,
		byVenue: r,
		byDraw: i,
		counts: a
	};
}
function mT(e, t, n) {
	if (!t) return;
	let r = e[t] ??= {
		total: 0,
		ERROR: 0,
		WARN: 0,
		INFO: 0
	};
	r.total++, r[n]++;
}
//#endregion
//#region src/components/scheduling-profile/domain/dndApply.ts
function hT(e, t, n) {
	let r = jw(e), { date: i, venueId: a } = n, o = _T(gT(r, i), a);
	if (t.type === "CATALOG_ROUND") {
		let e = {
			tournamentId: t.roundRef.tournamentId,
			eventId: t.roundRef.eventId,
			eventName: t.roundRef.eventName,
			drawId: t.roundRef.drawId,
			drawName: t.roundRef.drawName,
			structureId: t.roundRef.structureId,
			structureType: t.roundRef.structureType,
			roundNumber: t.roundRef.roundNumber,
			roundName: t.roundRef.roundName
		}, i = Mw(n.index, 0, o.rounds.length);
		return o.rounds.splice(i, 0, e), vT(o.rounds), {
			ok: !0,
			profile: r
		};
	}
	if (t.type === "PLANNED_ROUND") {
		let { locator: e } = t, s = _T(gT(r, e.date), e.venueId), [c] = s.rounds.splice(e.index, 1);
		vT(s.rounds);
		let l = n.index;
		return e.date === i && e.venueId === a && e.index < l && --l, l = Mw(l, 0, o.rounds.length), o.rounds.splice(l, 0, c), vT(o.rounds), {
			ok: !0,
			profile: r
		};
	}
	return {
		ok: !1,
		profile: e
	};
}
function gT(e, t) {
	let n = e.find((e) => e.scheduleDate === t);
	return n || (n = {
		scheduleDate: t,
		venues: []
	}, e.push(n), e.sort((e, t) => e.scheduleDate.localeCompare(t.scheduleDate))), n;
}
function _T(e, t) {
	let n = e.venues.find((e) => e.venueId === t);
	return n || (n = {
		venueId: t,
		rounds: []
	}, e.venues.push(n)), n;
}
function vT(e) {
	for (let t = 0; t < e.length; t++) e[t].sortOrder = t + 1;
}
//#endregion
//#region src/components/scheduling-profile/engine/profileStore.ts
var yT = class {
	constructor(e) {
		this.listeners = /* @__PURE__ */ new Set(), this.config = e, this.state = {
			profileDraft: jw(e.initialProfile ?? []),
			venues: e.venues,
			roundCatalog: e.roundCatalog,
			schedulableDates: e.schedulableDates,
			activeDates: e.activeDates,
			selectedDate: e.selectedDate ?? e.schedulableDates[0] ?? null,
			selectedLocator: null,
			ruleResults: [],
			issueIndex: {
				all: [],
				bySeverity: {
					ERROR: [],
					WARN: [],
					INFO: []
				},
				byDate: {},
				byVenue: {},
				byDraw: {},
				counts: {
					total: 0,
					ERROR: 0,
					WARN: 0,
					INFO: 0,
					byDate: {},
					byVenue: {},
					byDraw: {}
				}
			},
			catalogSearchQuery: "",
			catalogGroupBy: "event",
			plannedRoundBehavior: e.plannedRoundBehavior ?? "dim"
		}, this.revalidate();
	}
	getState() {
		return this.state;
	}
	getSchedulingProfile() {
		return jw(this.state.profileDraft);
	}
	selectDate(e) {
		this.state.selectedDate !== e && this.setState({
			selectedDate: e,
			selectedLocator: null
		});
	}
	selectCard(e) {
		this.setState({ selectedLocator: e });
	}
	setCatalogSearch(e) {
		this.setState({ catalogSearchQuery: e });
	}
	setCatalogGroupBy(e) {
		this.setState({ catalogGroupBy: e });
	}
	navigateToRound(e) {
		let t = Hw(this.state.profileDraft, {
			tournamentId: e.tournamentId,
			eventId: e.eventId,
			drawId: e.drawId,
			structureId: e.structureId,
			roundNumber: e.roundNumber
		});
		t && this.setState({
			selectedDate: t.date,
			selectedLocator: t
		});
	}
	dropRound(e, t) {
		try {
			let n = hT(this.state.profileDraft, e, t);
			if (!n.ok) return {
				ok: !1,
				errorMessage: "Invalid drop operation"
			};
			let r = new Set(this.state.ruleResults.filter((e) => e.severity === "ERROR").map(bT)), i = nT({
				profile: n.profile,
				temporal: this.config.temporalAdapter,
				dependencies: this.config.dependencyAdapter,
				venueOrder: this.config.venueOrder
			}).filter((e) => e.severity === "ERROR").filter((e) => !r.has(bT(e)));
			return i.length ? (this.addRejectionNotice(i[0].message), {
				ok: !1,
				errorMessage: i[0].message
			}) : (this.commitProfile(n.profile), { ok: !0 });
		} catch (e) {
			return {
				ok: !1,
				errorMessage: String(e)
			};
		}
	}
	removeRound(e) {
		let t = jw(this.state.profileDraft), n = t.find((t) => t.scheduleDate === e.date);
		if (!n) return;
		let r = n.venues.find((t) => t.venueId === e.venueId);
		if (r && !(e.index < 0 || e.index >= r.rounds.length)) {
			r.rounds.splice(e.index, 1);
			for (let e = 0; e < r.rounds.length; e++) r.rounds[e].sortOrder = e + 1;
			this.commitProfile(t), this.state.selectedLocator?.date === e.date && this.state.selectedLocator?.venueId === e.venueId && this.state.selectedLocator?.index === e.index && this.setState({ selectedLocator: null });
		}
	}
	setNotBeforeTime(e, t) {
		let n = jw(this.state.profileDraft), r = n.find((t) => t.scheduleDate === e.date);
		if (!r) return;
		let i = r.venues.find((t) => t.venueId === e.venueId);
		if (!i) return;
		let a = i.rounds[e.index];
		a && (t ? a.notBeforeTime = t : delete a.notBeforeTime, this.commitProfile(n));
	}
	applyFixAction(e) {
		if (e.kind === "JUMP_TO_ITEM" && e.locator) {
			this.setState({
				selectedDate: e.locator.date,
				selectedLocator: e.locator
			});
			return;
		}
		if (e.kind === "OPEN_TEMPORAL_GRID") {
			this.config.onFixAction?.(e);
			return;
		}
		if (e.kind === "MOVE_ITEM_AFTER" && e.locator && e.after) {
			let t = xT(this.state.profileDraft, e.locator, e.after);
			this.commitProfile(t);
			return;
		}
		if (e.kind === "MOVE_ITEM_BEFORE" && e.locator && e.before) {
			let t = ST(this.state.profileDraft, e.locator, e.before);
			this.commitProfile(t);
			return;
		}
		this.config.onFixAction?.(e);
	}
	subscribe(e) {
		return this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	setState(e) {
		this.state = {
			...this.state,
			...e
		}, this.emit();
	}
	commitProfile(e) {
		this.state = {
			...this.state,
			profileDraft: e
		}, this.revalidate(), this.config.onProfileChanged?.(jw(e));
	}
	addRejectionNotice(e) {
		let t = {
			code: "DROP_REJECTED",
			severity: "WARN",
			message: `Drop rejected: ${e}`,
			context: {}
		}, n = [...this.state.ruleResults.filter((e) => e.code !== "DROP_REJECTED"), t], r = pT(n);
		this.state = {
			...this.state,
			ruleResults: n,
			issueIndex: r
		}, this.emit();
	}
	revalidate() {
		let e = nT({
			profile: this.state.profileDraft,
			temporal: this.config.temporalAdapter,
			dependencies: this.config.dependencyAdapter,
			venueOrder: this.config.venueOrder
		}), t = pT(e);
		this.state = {
			...this.state,
			ruleResults: e,
			issueIndex: t
		}, this.emit();
	}
	emit() {
		for (let e of this.listeners) e(this.state);
	}
};
function bT(e) {
	return `${e.code}|${e.context?.scope ?? ""}|${e.context?.structureId ?? ""}|${e.context?.date ?? ""}`;
}
function xT(e, t, n) {
	let r = jw(e), i = CT(r, t);
	if (!i) return e;
	let a = wT(r, n.date, n.venueId), o = Math.min(a.length, n.index + 1);
	return a.splice(o, 0, i), r;
}
function ST(e, t, n) {
	let r = jw(e), i = CT(r, t);
	if (!i) return e;
	let a = wT(r, n.date, n.venueId), o = Math.max(0, Math.min(a.length, n.index));
	return a.splice(o, 0, i), r;
}
function CT(e, t) {
	let n = e.find((e) => e.scheduleDate === t.date);
	if (!n) return null;
	let r = n.venues.find((e) => e.venueId === t.venueId);
	return !r || t.index < 0 || t.index >= r.rounds.length ? null : r.rounds.splice(t.index, 1)[0];
}
function wT(e, t, n) {
	let r = e.find((e) => e.scheduleDate === t);
	r || (r = {
		scheduleDate: t,
		venues: []
	}, e.push(r));
	let i = r.venues.find((e) => e.venueId === n);
	return i || (i = {
		venueId: n,
		rounds: []
	}, r.venues.push(i)), i.rounds;
}
//#endregion
//#region src/components/scheduling-profile/ui/roundCard.ts
function TT(e, t) {
	let { round: n, locator: r, isSelected: i, severity: a } = e, o = document.createElement("div");
	o.className = nw(), i && o.classList.add("selected"), a === "ERROR" ? o.classList.add("error") : a === "WARN" && o.classList.add("warn"), o.draggable = !0, o.addEventListener("dragstart", (e) => {
		e.stopPropagation(), e.dataTransfer.setDragImage(o, o.offsetWidth / 2, 20), e.dataTransfer.setData("application/json", JSON.stringify({
			type: "PLANNED_ROUND",
			locator: r
		})), e.dataTransfer.effectAllowed = "copyMove";
	}), o.addEventListener("click", (e) => {
		e.stopPropagation(), t.onClick(r);
	}), t.onContextMenu && o.addEventListener("contextmenu", (e) => {
		e.preventDefault(), e.stopPropagation(), t.onContextMenu(r, o);
	});
	let s = document.createElement("div");
	s.className = rw();
	let c = n.roundName && !n.roundName.startsWith("rn=") ? n.roundName : "Round " + n.roundNumber;
	s.textContent = (n.eventName ? n.eventName + " — " : "") + c, o.appendChild(s);
	let l = document.createElement("div");
	l.className = iw(), l.textContent = [n.drawName || "", n.matchCountEstimate ? `${n.matchCountEstimate} matches` : ""].filter(Boolean).join(" · "), o.appendChild(l);
	let u = document.createElement("div");
	return u.className = JC(), n.roundSegment && u.appendChild(ET(`Seg ${n.roundSegment.segmentNumber}/${n.roundSegment.segmentsCount}`, "seg")), n.notBeforeTime && u.appendChild(ET(`NB ${n.notBeforeTime}`, "nb")), a === "ERROR" ? u.appendChild(ET("Error", "err")) : a === "WARN" && u.appendChild(ET("Warn", "warn")), u.children.length && o.appendChild(u), o;
}
function ET(e, t) {
	let n = document.createElement("div");
	return n.className = YC() + " " + t, n.textContent = e, n;
}
//#endregion
//#region src/components/scheduling-profile/ui/venueBoard.ts
function DT(e) {
	let t = document.createElement("div");
	t.className = BC();
	let n = document.createElement("div");
	n.className = VC();
	let r = document.createElement("div");
	r.className = HC(), r.textContent = "Day Plan";
	let i = document.createElement("div");
	i.className = UC(), n.appendChild(r), n.appendChild(i), t.appendChild(n);
	let a = document.createElement("div");
	a.className = XC(), t.appendChild(a);
	function o(t) {
		let n = t.selectedDate;
		i.textContent = n ? `Selected: ${n}` : "Select a date", a.innerHTML = "";
		let r = Math.max(1, t.venues.length);
		r > 4 ? (a.classList.add("sp-board-scroll"), a.style.gridTemplateColumns = "") : (a.classList.remove("sp-board-scroll"), a.style.gridTemplateColumns = `repeat(${r}, 1fr)`);
		for (let r of t.venues) {
			let i = document.createElement("div");
			i.className = ZC();
			let o = document.createElement("div");
			o.className = QC();
			let s = document.createElement("div"), c = document.createElement("div");
			c.className = $C(), c.textContent = r.name;
			let l = document.createElement("div");
			l.className = ew(), l.textContent = "", s.appendChild(c), s.appendChild(l);
			let u = t.issueIndex.counts.byVenue[r.venueId], d = document.createElement("div");
			d.className = qC(), u?.ERROR ? (d.classList.add("err"), d.textContent = `${u.ERROR} err`) : u?.WARN ? (d.classList.add("warn"), d.textContent = `${u.WARN} warn`) : (d.classList.add("ok"), d.textContent = "OK"), o.appendChild(s), o.appendChild(d);
			let f = document.createElement("div");
			if (f.className = tw(), f.dataset.venue = r.venueId, n) {
				let i = Lw(t.profileDraft, n, r.venueId);
				if (!i.length) {
					let e = document.createElement("div");
					e.className = Cw(), e.textContent = "Drop rounds here.", f.appendChild(e);
				}
				i.forEach((i, a) => {
					let o = {
						date: n,
						venueId: r.venueId,
						index: a,
						roundKey: Iw(i),
						roundSegment: i.roundSegment
					}, s = Vw(zw(t.ruleResults, o)), c = TT({
						round: i,
						locator: o,
						isSelected: Fw(t.selectedLocator, o),
						severity: s
					}, {
						onClick: e.onCardClick,
						onContextMenu: e.onCardContextMenu
					});
					f.appendChild(c);
				});
			} else {
				let e = document.createElement("div");
				e.className = Cw(), e.textContent = "Select a date to plan.", f.appendChild(e);
			}
			let p = document.createElement("div");
			p.className = Dw(), p.style.display = "none", f.addEventListener("dragover", (e) => {
				if (!n) return;
				e.preventDefault(), f.classList.add("over"), e.dataTransfer.dropEffect = "move";
				let t = kT(f, e.clientY, p), r = OT(f, p);
				p.style.display = "", t < r.length ? f.insertBefore(p, r[t]) : f.appendChild(p);
			}), f.addEventListener("dragleave", (e) => {
				f.contains(e.relatedTarget) || (f.classList.remove("over"), p.style.display = "none");
			}), f.addEventListener("drop", (t) => {
				if (f.classList.remove("over"), p.style.display = "none", t.preventDefault(), !n) return;
				let i;
				try {
					i = JSON.parse(t.dataTransfer.getData("application/json"));
				} catch {
					return;
				}
				let a = kT(f, t.clientY, p), o = {
					date: n,
					venueId: r.venueId,
					index: a
				};
				e.onDrop(i, o);
			}), i.appendChild(o), i.appendChild(f), a.appendChild(i);
		}
	}
	return {
		element: t,
		update: o
	};
}
function OT(e, t) {
	return Array.from(e.querySelectorAll("[draggable=\"true\"]")).filter((e) => e !== t);
}
function kT(e, t, n) {
	let r = OT(e, n);
	for (let e = 0; e < r.length; e++) {
		let n = r[e].getBoundingClientRect();
		if (t < n.top + n.height / 2) return e;
	}
	return r.length;
}
//#endregion
//#region src/components/scheduling-profile/ui/dateStrip.ts
function AT(e) {
	let t = document.createElement("div");
	t.className = BC();
	let n = document.createElement("div");
	n.className = VC();
	let r = document.createElement("div");
	r.className = HC(), r.textContent = "Dates";
	let i = document.createElement("div");
	i.className = UC(), n.appendChild(r), n.appendChild(i), t.appendChild(n);
	let a = document.createElement("div");
	a.className = WC(), t.appendChild(a);
	function o(t) {
		i.textContent = `${t.schedulableDates.length} schedulable`, a.innerHTML = "";
		let n = t.activeDates ? new Set(t.activeDates) : null;
		for (let r of t.schedulableDates) {
			let i = !n || n.has(r), o = t.issueIndex.counts.byDate[r], s = document.createElement("div");
			s.className = GC(), r === t.selectedDate && s.classList.add("selected"), i || s.classList.add("inactive"), s.setAttribute("data-date", r);
			let c = document.createElement("div"), l = document.createElement("div");
			l.style.cssText = "font-weight:800;font-size:12px", l.textContent = r;
			let u = document.createElement("div");
			u.style.cssText = "font-size:11px;color:var(--sp-muted)", u.textContent = i ? "Active" : "Inactive", c.appendChild(l), c.appendChild(u);
			let d = document.createElement("div");
			d.className = KC(), o?.ERROR && d.appendChild(jT(`${o.ERROR} err`, "err")), o?.WARN && d.appendChild(jT(`${o.WARN} warn`, "warn")), !o?.ERROR && !o?.WARN && d.appendChild(jT("OK", "ok")), s.appendChild(c), s.appendChild(d), s.addEventListener("click", () => e.onDateSelected(r)), a.appendChild(s);
		}
	}
	return {
		element: t,
		update: o
	};
}
function jT(e, t) {
	let n = document.createElement("div");
	return n.className = qC() + " " + t, n.textContent = e, n;
}
//#endregion
//#region src/components/scheduling-profile/controller/schedulingProfileControl.ts
var MT = class {
	constructor(e) {
		this.container = null, this.store = new yT(e), this.popover = Aw({
			onDelete: (e) => {
				this.store.removeRound(e);
			},
			onSetNotBeforeTime: (e) => {
				let t = prompt("Enter not-before time (HH:MM):", "10:00");
				t !== null && this.store.setNotBeforeTime(e, t || void 0);
			}
		}), this.layout = kw({
			dateStrip: AT({ onDateSelected: (e) => this.store.selectDate(e) }),
			issuesPanel: Qw({ onFixAction: (e) => this.store.applyFixAction(e) }),
			venueBoard: DT({
				onDrop: (e, t) => {
					this.store.dropRound(e, t);
				},
				onCardClick: (e) => this.store.selectCard(e),
				onCardContextMenu: (e, t) => {
					this.popover.show(t, e);
				}
			}),
			roundCatalog: Zw({
				onSearchChange: (e) => this.store.setCatalogSearch(e),
				onGroupByChange: (e) => this.store.setCatalogGroupBy(e),
				onDropRemove: (e) => this.store.removeRound(e),
				onNavigateToPlanned: (e) => this.store.navigateToRound(e)
			}),
			inspectorPanel: Uw()
		}, {
			hideLeft: e.hideLeft,
			catalogSide: e.catalogSide
		}), this.unsubscribe = this.store.subscribe((e) => {
			this.layout.update(e);
		}), this.layout.update(this.store.getState());
	}
	render(e) {
		this.container = e, e.appendChild(this.layout.element);
	}
	destroy() {
		this.unsubscribe(), this.popover.destroy(), this.container && this.layout.element.parentNode === this.container && this.layout.element.remove(), this.container = null;
	}
	getProfile() {
		return this.store.getSchedulingProfile();
	}
	getStore() {
		return this.store;
	}
};
//#endregion
//#region src/components/scheduling-profile/index.ts
function NT(e, t) {
	let n = new MT(e);
	return n.render(t), n;
}
//#endregion
//#region src/components/temporal-grid/engine/viewState.ts
var PT = class {
	constructor() {
		this.selectedDay = null, this.selectedVenue = null, this.selectedCourt = null, this.layerVisibility = /* @__PURE__ */ new Map(), this.listeners = /* @__PURE__ */ new Set();
	}
	setSelectedDay(e) {
		this.selectedDay !== e && (this.selectedDay = e, this.emit({ selectedDay: e }));
	}
	getSelectedDay() {
		return this.selectedDay;
	}
	setSelectedVenue(e) {
		this.selectedVenue !== e && (this.selectedVenue = e, this.emit({ selectedVenue: e }));
	}
	getSelectedVenue() {
		return this.selectedVenue;
	}
	setSelectedCourt(e) {
		this.selectedCourt !== e && (this.selectedCourt = e, this.emit({ selectedCourt: e }));
	}
	getSelectedCourt() {
		return this.selectedCourt;
	}
	setLayerVisibility(e, t) {
		this.layerVisibility.set(e, t), this.emit({ layerVisibility: new Map(this.layerVisibility) });
	}
	getLayerVisibility() {
		return new Map(this.layerVisibility);
	}
	isLayerVisible(e) {
		return this.layerVisibility.get(e) ?? !0;
	}
	getSnapshot() {
		return {
			selectedDay: this.selectedDay,
			selectedVenue: this.selectedVenue,
			selectedCourt: this.selectedCourt,
			layerVisibility: new Map(this.layerVisibility)
		};
	}
	subscribe(e) {
		return this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	emit(e) {
		let t = {
			type: "VIEW_CHANGED",
			payload: e
		};
		for (let e of this.listeners) e(t);
	}
}, FT = {
	AVAILABLE: "rgba(33, 141, 141, 0.15)",
	BLOCKED: "#95a5a6",
	PRACTICE: "#9b59b6",
	MAINTENANCE: "#f39c12",
	RESERVED: "#3498db",
	CLOSED: "#2c3e50",
	SCHEDULED: "#27ae60",
	SOFT_BLOCK: "#5dade2",
	HARD_BLOCK: "#e74c3c",
	LOCKED: "#34495e",
	UNSPECIFIED: "#ecf0f1"
};
function IT(e, t, n = {}) {
	let r = [], i = /* @__PURE__ */ new Map();
	for (let e of t) {
		let t = BT(e.ref);
		i.set(t, e);
	}
	let a = /* @__PURE__ */ new Set();
	for (let t of e) for (let e of t.rails) a.add(BT(e.court));
	for (let e of a) {
		let t = i.get(e);
		if (!t) continue;
		let n = {
			id: e,
			content: t.name,
			courtRef: t.ref,
			surface: t.surface,
			indoor: t.indoor,
			hasLights: t.hasLights,
			tags: t.tags
		};
		r.push(n);
	}
	return r;
}
function LT(e, t = {}) {
	let { layerVisibility: n = /* @__PURE__ */ new Map(), showSegmentLabels: r = !1, colorScheme: i = FT } = t, a = [];
	for (let t of e) for (let e of t.rails) {
		let t = BT(e.court);
		for (let o of e.segments) {
			if (!(n.get(o.status) ?? !0)) continue;
			let e = `${t}-${o.start}-${o.status}`, s = i[o.status];
			a.push({
				id: e,
				group: t,
				content: r ? RT(o) : "",
				start: o.start,
				end: o.end,
				type: "background",
				className: `temporal-segment segment-${o.status.toLowerCase()}`,
				style: s === "transparent" ? void 0 : `background-color: ${s};`,
				title: `${o.status} segment`,
				editable: !1,
				selectable: !1,
				status: o.status,
				contributingBlocks: o.contributingBlocks,
				isSegment: !0
			});
		}
	}
	return a;
}
function RT(e) {
	let t = Math.round((new Date(e.end).getTime() - new Date(e.start).getTime()) / (1e3 * 60));
	return `${e.status} (${t}m)`;
}
function zT(e, t = {}) {
	let { colorScheme: n = FT } = t, r = [];
	for (let t of e) {
		let e = BT(t.court), i = n[t.type], a = VT(i, -20);
		r.push({
			id: `block-${t.id}`,
			group: e,
			content: t.reason || t.type,
			start: t.start,
			end: t.end,
			type: "range",
			className: `temporal-block block-${t.type.toLowerCase()}`,
			style: `background-color: ${i}; border-color: ${a};`,
			title: t.reason || t.type,
			editable: {
				updateTime: !0,
				updateGroup: !0,
				remove: !1
			},
			blockId: t.id,
			status: t.type,
			reason: t.reason,
			isBlock: !0
		});
	}
	return r;
}
function BT(e) {
	return `${e.tournamentId}|${e.venueId}|${e.courtId}`;
}
function VT(e, t) {
	if (!e || !e.startsWith("#")) return e;
	let n = parseInt(e.replace("#", ""), 16), r = Math.round(2.55 * t), i = (n >> 16) + r, a = (n >> 8 & 255) + r, o = (n & 255) + r;
	return "#" + (16777216 + (i < 255 ? i < 1 ? 0 : i : 255) * 65536 + (a < 255 ? a < 1 ? 0 : a : 255) * 256 + (o < 255 ? o < 1 ? 0 : o : 255)).toString(16).slice(1);
}
function HT(e) {
	let t = e.split("|");
	return t.length === 3 ? {
		tournamentId: t[0],
		venueId: t[1],
		courtId: t[2]
	} : null;
}
function UT(e) {
	let t = String(e);
	return t.startsWith("block-") ? t.slice(6) : null;
}
function WT(e) {
	let t = /* @__PURE__ */ new Date(`${e.day}T${e.dayStartTime}:00`), n = /* @__PURE__ */ new Date(`${e.day}T${e.dayEndTime}:00`);
	return {
		start: t,
		end: n,
		min: t,
		max: n,
		zoomMin: e.slotMinutes * 4 * 60 * 1e3,
		zoomMax: (n.getTime() - t.getTime()) * 1.5
	};
}
//#endregion
//#region src/components/temporal-grid/ui/modernTimePicker.ts
var GT, KT, qT, JT = !1;
async function YT() {
	if (!GT) {
		let e = await import("./dist-B9gd8_9-.mjs");
		GT = e.TimepickerUI, KT = e.PluginRegistry, qT = (await import("./range-B1T9TbVf.mjs")).RangePlugin, !JT && KT && qT && (KT.register(qT), JT = !0);
	}
}
var XT = class {
	constructor(e) {
		if (this.config = {
			dayStartTime: "00:00",
			dayEndTime: "23:59",
			minuteIncrement: 5,
			clockType: "12h",
			...e
		}, this.selectedStart = this.extractTimeAsHHMM(e.startTime), e.endTime) this.selectedEnd = this.extractTimeAsHHMM(e.endTime);
		else {
			let e = /* @__PURE__ */ new Date(`2000-01-01T${this.selectedStart}:00Z`), t = new Date(e.getTime() + 3600 * 1e3);
			this.selectedEnd = h.dateTime.extractTime(t.toISOString());
		}
		this.inputElement = document.createElement("input"), this.container = this.createUI();
	}
	extractTimeAsHHMM(e) {
		return e.includes("T") ? h.dateTime.extractTime(e) : e;
	}
	createUI() {
		let e = document.createElement("div");
		return e.style.cssText = "\n      position: fixed;\n      left: -9999px;\n      top: -9999px;\n      opacity: 0;\n      pointer-events: none;\n    ", this.inputElement.type = "text", this.inputElement.value = `${this.selectedStart} - ${this.selectedEnd}`, this.inputElement.style.cssText = "\n      position: absolute;\n      left: 0;\n      top: 0;\n    ", e.appendChild(this.inputElement), e;
	}
	async initTimePicker() {
		await YT();
		let e = this.config.clockType ?? "12h", [t, n] = this.selectedStart.split(":").map(Number), [r, i] = this.selectedEnd.split(":").map(Number);
		if (e === "24h") {
			let e = `${String(t).padStart(2, "0")}:${String(n).padStart(2, "0")}`, a = `${String(r).padStart(2, "0")}:${String(i).padStart(2, "0")}`;
			this.inputElement.value = `${e} - ${a}`, this.inputElement.dataset.timeFrom = e, this.inputElement.dataset.timeTo = a;
		} else {
			let e = t >= 12 ? "PM" : "AM", a = t === 0 ? 12 : t > 12 ? t - 12 : t, o = `${String(a).padStart(2, "0")}:${String(n).padStart(2, "0")} ${e}`, s = r >= 12 ? "PM" : "AM", c = r === 0 ? 12 : r > 12 ? r - 12 : r, l = `${String(c).padStart(2, "0")}:${String(i).padStart(2, "0")} ${s}`;
			this.inputElement.value = `${o} - ${l}`, this.inputElement.dataset.timeFrom = `${String(a).padStart(2, "0")}:${String(n).padStart(2, "0")}`, this.inputElement.dataset.timeTo = `${String(c).padStart(2, "0")}:${String(i).padStart(2, "0")}`, this.inputElement.dataset.typeFrom = e, this.inputElement.dataset.typeTo = s;
		}
		let a = {
			enabled: !0,
			fromLabel: "Start",
			toLabel: "End"
		};
		this.config.minDuration !== void 0 && (a.minDuration = this.config.minDuration), this.config.maxDuration !== void 0 && (a.maxDuration = this.config.maxDuration), this.picker = new GT(this.inputElement, {
			range: a,
			clock: {
				type: e,
				incrementMinutes: this.config.minuteIncrement || 5
			},
			ui: { theme: "crane" },
			callbacks: {
				onRangeConfirm: (e) => {
					try {
						let t = e.from, n = e.to;
						if (t && n) {
							let e = (e) => {
								let t = e.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
								if (t) {
									let e = parseInt(t[1], 10), n = t[2], r = t[3].toUpperCase();
									return r === "PM" && e !== 12 ? e += 12 : r === "AM" && e === 12 && (e = 0), `${String(e).padStart(2, "0")}:${n}`;
								}
								let n = e.match(/(\d{1,2}):(\d{2})/);
								return n ? `${n[1].padStart(2, "0")}:${n[2]}` : "00:00";
							};
							this.selectedStart = e(t), this.selectedEnd = e(n), this.config.onConfirm(this.selectedStart, this.selectedEnd), this.destroy();
						}
					} catch (e) {
						console.error("[ModernTimePicker] Error in onRangeConfirm:", e);
					}
				},
				onCancel: () => {
					try {
						this.config.onCancel(), this.destroy();
					} catch (e) {
						console.error("[ModernTimePicker] Error in onCancel:", e);
					}
				}
			}
		}), this.picker.create(), setTimeout(() => {
			this.picker && this.picker.open();
		}, 100);
	}
	async show() {
		document.body.appendChild(this.container), await this.initTimePicker();
	}
	destroy() {
		this.picker && this.picker.destroy && this.picker.destroy(), this.container.parentNode && this.container.parentNode.removeChild(this.container);
	}
};
async function ZT(e) {
	let t = new XT(e);
	return await t.show(), t;
}
//#endregion
//#region src/components/temporal-grid/ui/blockPopover.ts
var { BLOCK_TYPES: QT } = m, $T = "padding:6px 12px; cursor:pointer; display:flex; align-items:center; gap:8px;", eE = "var(--chc-hover-bg)", tE = "var(--chc-text-primary)", nE = [
	[QT.MAINTENANCE, "Maintenance"],
	[QT.PRACTICE, "Practice"],
	[QT.RESERVED, "Reserved"],
	[QT.BLOCKED, "Blocked"]
];
function rE() {
	let e = null, t = null;
	function n() {
		e && (e.destroy(), e = null, t = null);
	}
	function r(e) {
		let t = document.createElement("div");
		t.style.cssText = "font-family:sans-serif; font-size:13px; min-width:150px;";
		for (let r of e.blockTypes) {
			let i = document.createElement("div");
			i.style.cssText = $T, i.innerHTML = `
        <span style="width:10px;height:10px;border-radius:2px;background:${r.color};display:inline-block;"></span>
        ${r.label}
      `, i.addEventListener("mouseenter", () => {
				i.style.background = eE, i.style.color = tE;
			}), i.addEventListener("mouseleave", () => {
				i.style.background = "transparent", i.style.color = "";
			}), i.addEventListener("click", () => {
				e.onTypeSelected(r.type), n();
			}), t.appendChild(i);
		}
		if (e.onAdjustTime || e.onDelete) {
			let e = document.createElement("div");
			e.style.cssText = "border-top:1px solid var(--chc-border-primary); margin:4px 0;", t.appendChild(e);
		}
		if (e.onAdjustTime) {
			let r = document.createElement("div");
			r.style.cssText = $T, r.innerHTML = "<span style=\"font-size:14px;\">&#128339;</span> Adjust Time", r.addEventListener("mouseenter", () => {
				r.style.background = eE, r.style.color = tE;
			}), r.addEventListener("mouseleave", () => {
				r.style.background = "transparent", r.style.color = "";
			}), r.addEventListener("click", () => {
				let t = e.onAdjustTime;
				n(), e.startTime && e.endTime && ZT({
					startTime: e.startTime,
					endTime: e.endTime,
					dayStartTime: "06:00",
					dayEndTime: "22:00",
					minuteIncrement: 5,
					onConfirm: (e, n) => t(e, n),
					onCancel: () => {}
				});
			}), t.appendChild(r);
		}
		if (e.onDelete) {
			let r = document.createElement("div");
			r.style.cssText = "padding:6px 12px; cursor:pointer; display:flex; align-items:center; gap:8px; color:#e74c3c;", r.innerHTML = "<span style=\"font-size:14px;\">&#128465;</span> Delete", r.addEventListener("mouseenter", () => {
				r.style.background = "#fdecea";
			}), r.addEventListener("mouseleave", () => {
				r.style.background = "transparent";
			}), r.addEventListener("click", () => {
				let t = e.onDelete;
				n(), t();
			}), t.appendChild(r);
		}
		return t;
	}
	function i(e) {
		let { blockId: t, engine: r, day: i, onBlockChanged: a } = e, o = document.createElement("div");
		o.style.cssText = "font-family:sans-serif; font-size:13px; min-width:150px;";
		for (let [e, s] of nE) {
			let c = FT[e], l = document.createElement("div");
			l.style.cssText = $T, l.innerHTML = `
        <span style="width:10px;height:10px;border-radius:2px;background:${c};display:inline-block;"></span>
        ${s}
      `, l.addEventListener("mouseenter", () => {
				l.style.background = eE, l.style.color = tE;
			}), l.addEventListener("mouseleave", () => {
				l.style.background = "transparent", l.style.color = "";
			}), l.addEventListener("click", () => {
				let o = r.getDayBlocks(i).find((e) => e.id === t);
				o && (r.removeBlock(t), r.applyBlock({
					courts: [o.court],
					timeRange: {
						start: o.start,
						end: o.end
					},
					type: e,
					reason: s
				}), a()), n();
			}), o.appendChild(l);
		}
		let s = document.createElement("div");
		s.style.cssText = "border-top:1px solid var(--chc-border-primary); margin:4px 0;", o.appendChild(s);
		let c = document.createElement("div");
		c.style.cssText = $T, c.innerHTML = "<span style=\"font-size:14px;\">&#128339;</span> Adjust Time", c.addEventListener("mouseenter", () => {
			c.style.background = eE, c.style.color = tE;
		}), c.addEventListener("mouseleave", () => {
			c.style.background = "transparent", c.style.color = "";
		}), c.addEventListener("click", () => {
			n();
			let e = r.getDayBlocks(i).find((e) => e.id === t);
			e && ZT({
				startTime: e.start,
				endTime: e.end,
				dayStartTime: "06:00",
				dayEndTime: "22:00",
				minuteIncrement: 5,
				onConfirm: (n, i) => {
					let o = e.start.slice(0, 10);
					r.resizeBlock({
						blockId: t,
						newTimeRange: {
							start: `${o}T${n}:00`,
							end: `${o}T${i}:00`
						}
					}), a();
				},
				onCancel: () => {}
			});
		}), o.appendChild(c);
		let l = document.createElement("div");
		return l.style.cssText = "padding:6px 12px; cursor:pointer; display:flex; align-items:center; gap:8px; color:#e74c3c;", l.innerHTML = "<span style=\"font-size:14px;\">&#128465;</span> Delete", l.addEventListener("mouseenter", () => {
			l.style.background = "#fdecea";
		}), l.addEventListener("mouseleave", () => {
			l.style.background = "transparent";
		}), l.addEventListener("click", () => {
			r.removeBlock(t), a(), n();
		}), o.appendChild(l), o;
	}
	function a(r, i, a) {
		n();
		let o = Am(r, {
			content: i,
			allowHTML: !0,
			interactive: !0,
			trigger: "manual",
			placement: "bottom",
			appendTo: document.body,
			onHidden: () => {
				e = null, t = null;
			}
		});
		e = o, t = a, o.show();
	}
	return {
		show(e, i) {
			if (t === i.itemId) {
				n();
				return;
			}
			a(e, r(i), i.itemId);
		},
		showForEngineBlock(e, r) {
			if (t === r.itemId) {
				n();
				return;
			}
			a(e, i(r), r.itemId);
		},
		destroy() {
			n();
		},
		isActiveFor(e) {
			return t === e;
		}
	};
}
//#endregion
//#region src/components/temporal-grid/ui/viewToolbar.ts
var iE = {
	day: {
		label: "1 Day",
		days: 1,
		timeAxis: {
			scale: "hour",
			step: 1
		}
	},
	days3: {
		label: "3 Days",
		days: 3,
		timeAxis: {
			scale: "hour",
			step: 3
		}
	},
	week: {
		label: "Week",
		days: 7,
		timeAxis: {
			scale: "hour",
			step: 6
		}
	},
	all: {
		label: "Tournament",
		days: 0,
		timeAxis: {
			scale: "hour",
			step: 6
		}
	}
};
function aE(e, t, n, r) {
	let i = r?.labels, a = document.createElement("div");
	a.className = "tg-view-toolbar";
	let o = document.createElement("span");
	o.textContent = (i?.view ?? "View") + ":", o.className = "tg-view-toolbar-label", a.appendChild(o);
	let s = document.createElement("input");
	s.type = "text", s.readOnly = !0, s.className = "tg-view-toolbar-date", n && s.addEventListener("changeDate", () => {
		let e = s.value;
		e && n(e);
	}), a.appendChild(s);
	let c = {
		day: i?.day1 ?? "1 Day",
		days3: i?.days3 ?? "3 Days",
		week: i?.week ?? "Week",
		all: i?.tournament ?? "Tournament"
	}, l = [], u = [], d = t || "day", f = (e) => {
		l.forEach((t, n) => {
			u[n] === e ? t.className = "sp-btn sp-btn--active" : t.className = "sp-btn";
		});
	};
	for (let [t] of Object.entries(iE)) {
		let n = document.createElement("button");
		n.textContent = c[t], n.className = t === d ? "sp-btn sp-btn--active" : "sp-btn", n.addEventListener("click", () => {
			f(t), e(t);
		}), l.push(n), u.push(t), a.appendChild(n);
	}
	if (r?.onSetDefaultAvailability || r?.onSave) {
		let e = document.createElement("div");
		e.className = "tg-view-toolbar-spacer", a.appendChild(e);
	}
	if (r?.onSetDefaultAvailability) {
		let e = document.createElement("button");
		e.textContent = i?.setDefaultAvailability ?? "Set Default Availability", e.className = "sp-btn sp-btn--fill-muted", e.addEventListener("click", r.onSetDefaultAvailability), a.appendChild(e);
	}
	let p = null;
	return r?.onSave && (p = document.createElement("button"), p.textContent = i?.saveToTournament ?? "Save to Tournament", p.className = "sp-btn sp-btn--fill", p.disabled = !0, p.addEventListener("click", r.onSave), a.appendChild(p)), {
		element: a,
		dateInput: s,
		setActiveView: f,
		setDate: (e) => {
			s.value = e;
		},
		setSaveEnabled: (e) => {
			p && (p.disabled = !e);
		}
	};
}
//#endregion
//#region src/components/temporal-grid/timeline/TimeScale.ts
var oE = class {
	constructor(e, t, n) {
		this._dailyStartMin = 0, this._dailyEndMin = 1440, this._useDailyBounds = !1, this._visibleDays = null, this._visibleDayMs = null, this._start = e.getTime(), this._end = t.getTime(), this._width = Math.max(n, 1), this._min = this._start, this._max = this._end, this._zoomMin = 900 * 1e3, this._zoomMax = (this._end - this._start) * 2;
	}
	get start() {
		return new Date(this._start);
	}
	get end() {
		return new Date(this._end);
	}
	get width() {
		return this._width;
	}
	get duration() {
		return this._end - this._start;
	}
	get msPerPx() {
		if (!this._useDailyBounds) return this.duration / this._width;
		let e = this.toCollapsedMin(new Date(this._start)), t = this.toCollapsedMin(new Date(this._end)) - e;
		return t <= 0 ? 1 : t * 60 * 1e3 / this._width;
	}
	getDailyBounds() {
		return this._useDailyBounds ? {
			startMin: this._dailyStartMin,
			endMin: this._dailyEndMin
		} : null;
	}
	getVisibleDays() {
		return this._visibleDays;
	}
	timeToX(e) {
		if (!this._useDailyBounds) return (e.getTime() - this._start) / this.duration * this._width;
		let t = this.toCollapsedMin(e), n = this.toCollapsedMin(new Date(this._start)), r = this.toCollapsedMin(new Date(this._end)) - n;
		return r <= 0 ? 0 : (t - n) / r * this._width;
	}
	xToTime(e) {
		if (!this._useDailyBounds) {
			let t = e / this._width * this.duration;
			return new Date(this._start + t);
		}
		let t = this.toCollapsedMin(new Date(this._start)), n = this.toCollapsedMin(new Date(this._end)) - t;
		if (n <= 0) return new Date(this._start);
		let r = t + e / this._width * n;
		return this.fromCollapsedMin(r);
	}
	snap(e, t) {
		let n = e.getTime(), r = t * 60 * 1e3;
		return new Date(Math.round(n / r) * r);
	}
	setWindow(e, t) {
		this._start = e.getTime(), this._end = t.getTime(), this.clampBounds();
	}
	setLimits(e) {
		e.min !== void 0 && (this._min = e.min.getTime()), e.max !== void 0 && (this._max = e.max.getTime()), e.zoomMin !== void 0 && (this._zoomMin = e.zoomMin), e.zoomMax !== void 0 && (this._zoomMax = e.zoomMax);
	}
	setWidth(e) {
		this._width = Math.max(e, 1);
	}
	setDailyBounds(e, t) {
		let [n, r] = e.split(":").map(Number), [i, a] = t.split(":").map(Number);
		this._dailyStartMin = n * 60 + r, this._dailyEndMin = i * 60 + a, this._useDailyBounds = !0;
	}
	clearDailyBounds() {
		this._useDailyBounds = !1, this._dailyStartMin = 0, this._dailyEndMin = 1440, this._visibleDays = null, this._visibleDayMs = null;
	}
	setVisibleDays(e) {
		this._visibleDays = e, this._visibleDayMs = e.map((e) => (/* @__PURE__ */ new Date(e + "T00:00:00")).getTime());
	}
	clearVisibleDays() {
		this._visibleDays = null, this._visibleDayMs = null;
	}
	pan(e) {
		if (this._visibleDays) return;
		if (this._useDailyBounds) {
			let t = this.toCollapsedMin(new Date(this._start)), n = this.toCollapsedMin(new Date(this._end)), r = n - t;
			if (r <= 0) return;
			let i = e / this._width * r, a = this.fromCollapsedMin(t + i), o = this.fromCollapsedMin(n + i);
			this._start = a.getTime(), this._end = o.getTime(), this.clampBounds();
			return;
		}
		let t = e * this.msPerPx, n = this._start + t, r = this._end + t;
		if (n < this._min) {
			let e = this._min - n;
			n += e, r += e;
		}
		if (r > this._max) {
			let e = r - this._max;
			n -= e, r -= e;
		}
		this._start = n, this._end = r;
	}
	zoom(e, t) {
		if (this._visibleDays) return;
		if (this._useDailyBounds) {
			let n = this.toCollapsedMin(new Date(this._start)), r = this.toCollapsedMin(new Date(this._end)) - n, i = n + t / this._width * r, a = r * e, o = this._zoomMin / (60 * 1e3), s = this._zoomMax / (60 * 1e3);
			a = Math.max(o, Math.min(s, a));
			let c = t / this._width, l = this.fromCollapsedMin(i - a * c), u = this.fromCollapsedMin(i + a * (1 - c));
			this._start = l.getTime(), this._end = u.getTime(), this.clampBounds();
			return;
		}
		let n = this._start + t / this._width * this.duration, r = this.duration * e;
		r = Math.max(this._zoomMin, Math.min(this._zoomMax, r));
		let i = t / this._width;
		this._start = n - r * i, this._end = n + r * (1 - i), this.clampBounds();
	}
	toCollapsedMin(e) {
		let t = this._dailyEndMin - this._dailyStartMin;
		if (t <= 0) return 0;
		let n = e.getHours() * 60 + e.getMinutes() + e.getSeconds() / 60, r = Math.max(this._dailyStartMin, Math.min(this._dailyEndMin, n)) - this._dailyStartMin;
		if (this._visibleDays && this._visibleDayMs) {
			let n = new Date(e);
			n.setHours(0, 0, 0, 0);
			let i = n.getTime(), a = -1;
			for (let e = 0; e < this._visibleDayMs.length; e++) if (this._visibleDayMs[e] === i) {
				a = e;
				break;
			}
			if (a === -1) {
				if (i < this._visibleDayMs[0]) return 0;
				if (i > this._visibleDayMs[this._visibleDayMs.length - 1]) return this._visibleDayMs.length * t;
				for (let e = 0; e < this._visibleDayMs.length - 1; e++) if (i > this._visibleDayMs[e] && i < this._visibleDayMs[e + 1]) return (e + 1) * t;
				return 0;
			}
			return a * t + r;
		}
		let i = new Date(this._start);
		i.setHours(0, 0, 0, 0);
		let a = new Date(e);
		return a.setHours(0, 0, 0, 0), Math.round((a.getTime() - i.getTime()) / (1440 * 60 * 1e3)) * t + r;
	}
	fromCollapsedMin(e) {
		let t = this._dailyEndMin - this._dailyStartMin;
		if (t <= 0) return new Date(this._start);
		let n = Math.floor(e / t), r = e - n * t;
		if (this._visibleDays && this._visibleDayMs) {
			let e = Math.max(0, Math.min(n, this._visibleDayMs.length - 1)), t = new Date(this._visibleDayMs[e]), i = this._dailyStartMin + r;
			return t.setHours(Math.floor(i / 60), Math.round(i % 60), 0, 0), t;
		}
		let i = new Date(this._start);
		i.setHours(0, 0, 0, 0);
		let a = new Date(i);
		a.setDate(a.getDate() + n);
		let o = this._dailyStartMin + r;
		return a.setHours(Math.floor(o / 60), Math.round(o % 60), 0, 0), a;
	}
	clampBounds() {
		let e = this._end - this._start;
		this._start < this._min && (this._start = this._min, this._end = this._min + e), this._end > this._max && (this._end = this._max, this._start = this._max - e), this._start < this._min && (this._start = this._min), this._end > this._max && (this._end = this._max);
	}
}, sE = "tg-tick-day", cE = "tg-tick-hour", lE = class {
	constructor(e, t) {
		this.scale = e, this.tickConfig = uE(t), this.dayEl = document.createElement("div"), this.dayEl.className = "tg-day-axis", this.dayEl.setAttribute("role", "presentation"), this.hourEl = document.createElement("div"), this.hourEl.className = "tg-hour-axis", this.hourEl.setAttribute("role", "presentation"), this.dayEl.addEventListener("click", (e) => {
			let t = (e.target.closest?.(`.${sE}`))?.dataset.day;
			t && this.onDayClick && this.onDayClick(t);
		});
	}
	getDayElement() {
		return this.dayEl;
	}
	getHourElement() {
		return this.hourEl;
	}
	setTimeAxisOptions(e) {
		this.tickConfig = uE(e);
	}
	render() {
		this.renderDayLabels(), this.renderHourTicks();
	}
	renderDayLabels() {
		this.dayEl.innerHTML = "";
		let { dayFormat: e } = this.tickConfig, t = this.tickConfig.scale, n = this.scale.getDailyBounds();
		if (n && t === "hour") {
			this.renderDayLabelsWithBounds(n, e);
			return;
		}
		if (t === "hour") {
			let t = this.scale.start.getTime(), n = fE(t, this.scale.end.getTime());
			if (n.length === 0) {
				let n = new Date(t);
				n.setHours(0, 0, 0, 0);
				let r = document.createElement("div");
				r.className = sE, r.style.left = "0px", r.style.maxWidth = `${this.scale.width}px`, r.dataset.day = dE(n), r.textContent = e.format(n), this.dayEl.appendChild(r);
				return;
			}
			for (let t of n) {
				let n = this.scale.timeToX(t), r = document.createElement("div");
				r.className = sE, r.style.left = `${n}px`, r.dataset.day = dE(t), r.textContent = e.format(t), this.dayEl.appendChild(r);
			}
		} else if (t === "day") {
			let e = mE(this.scale.start.getTime(), this.scale.end.getTime());
			for (let t of e) {
				let e = this.scale.timeToX(t), n = document.createElement("div");
				n.className = sE, n.style.left = `${e}px`, n.dataset.day = dE(t), n.textContent = this.tickConfig.dayFormat.format(t), this.dayEl.appendChild(n);
			}
		}
	}
	renderDayLabelsWithBounds(e, t) {
		let n = this.getVisibleDayDates(e), r = this.scale.getVisibleDays(), i = n.length, a = i > 0 ? this.scale.width / i : this.scale.width, o = a < 150 ? new Intl.DateTimeFormat(void 0, {
			weekday: "short",
			day: "numeric"
		}) : t;
		if (r && r.length > 0) for (let t of n) {
			let n = new Date(t);
			n.setHours(0, 0, 0, 0), n.setMinutes(e.startMin);
			let r = this.scale.timeToX(n), i = document.createElement("div");
			i.className = sE, i.style.left = `${r}px`, i.style.maxWidth = `${Math.floor(a) - 4}px`, i.dataset.day = dE(t), i.textContent = o.format(n), this.dayEl.appendChild(i);
		}
		else {
			let t = this.scale.width;
			for (let r of n) {
				let n = new Date(r);
				n.setHours(0, 0, 0, 0), n.setMinutes(e.startMin);
				let i = new Date(r);
				i.setHours(0, 0, 0, 0), i.setDate(i.getDate() + 1), i.setMinutes(e.startMin);
				let a = this.scale.timeToX(n), s = this.scale.timeToX(i), c = Math.max(a, 0), l = Math.min(s, t) - c;
				if (l <= 0) continue;
				let u = document.createElement("div");
				u.className = sE, u.style.left = `${c}px`, u.style.maxWidth = `${l}px`, u.dataset.day = dE(r), u.textContent = o.format(n), this.dayEl.appendChild(u);
			}
		}
	}
	renderHourTicks() {
		this.hourEl.innerHTML = "";
		let { hourFormat: e } = this.tickConfig, t = this.tickConfig.scale, n = this.tickConfig.step, r = this.scale.getDailyBounds();
		if (r && t === "hour") {
			this.renderHourTicksWithBounds(r, n, e);
			return;
		}
		let i = this.scale.start.getTime(), a = this.scale.end.getTime();
		if (t === "hour") {
			let t = new Set(fE(i, a).map((e) => e.getTime())), r = pE(i, a, n);
			for (let n of r) {
				if (t.has(n.getTime())) continue;
				let r = this.scale.timeToX(n), i = document.createElement("div");
				i.className = cE, i.style.left = `${r}px`, i.textContent = e.format(n), this.hourEl.appendChild(i);
			}
		} else if (t === "day") {
			let e = new Set(mE(i, a).map((e) => e.getTime())), t = fE(i, a);
			for (let n of t) {
				if (e.has(n.getTime())) continue;
				let t = this.scale.timeToX(n), r = document.createElement("div");
				r.className = cE, r.style.left = `${t}px`, r.textContent = new Intl.DateTimeFormat(void 0, {
					weekday: "short",
					day: "numeric"
				}).format(n), this.hourEl.appendChild(r);
			}
		}
	}
	renderHourTicksWithBounds(e, t, n) {
		let r = this.getVisibleDayDates(e);
		for (let i of r) {
			let r = new Date(i);
			r.setHours(0, 0, 0, 0), r.setMinutes(e.startMin);
			let a = new Date(i);
			a.setHours(0, 0, 0, 0), a.setMinutes(e.endMin);
			let o = Math.ceil(e.startMin / 60), s = new Date(i);
			for (s.setHours(o, 0, 0, 0), s.getHours() % t !== 0 && s.setHours(s.getHours() + (t - s.getHours() % t)); s.getTime() <= a.getTime();) {
				if (s.getTime() !== r.getTime()) {
					let e = this.scale.timeToX(s), t = document.createElement("div");
					t.className = cE, t.style.left = `${e}px`, t.textContent = n.format(s), this.hourEl.appendChild(t);
				}
				s.setHours(s.getHours() + t);
			}
		}
	}
	getVisibleDayDates(e) {
		let t = this.scale.getVisibleDays();
		if (t && t.length > 0) return t.map((e) => /* @__PURE__ */ new Date(e + "T00:00:00"));
		let n = this.scale.start.getTime(), r = this.scale.end.getTime(), i = [], a = new Date(n);
		for (a.setHours(0, 0, 0, 0);;) {
			let t = new Date(a);
			if (t.setHours(0, 0, 0, 0), t.setMinutes(e.endMin), t.getTime() < n) {
				a.setDate(a.getDate() + 1);
				continue;
			}
			let o = new Date(a);
			if (o.setHours(0, 0, 0, 0), o.setMinutes(e.startMin), o.getTime() > r) break;
			i.push(new Date(a)), a.setDate(a.getDate() + 1);
		}
		return i;
	}
	renderGridlines(e, t) {
		e.querySelectorAll(".tg-gridline").forEach((e) => e.remove());
		let n = this.computeTickPositions();
		for (let { x: r, isMajor: i } of n) {
			let n = document.createElement("div");
			n.className = i ? "tg-gridline tg-gridline-major" : "tg-gridline", n.style.left = `${r}px`, n.style.height = `${t}px`, e.appendChild(n);
		}
	}
	computeTickPositions() {
		let e = [], t = this.tickConfig.scale, n = this.tickConfig.step, r = this.scale.getDailyBounds(), i = this.scale.start.getTime(), a = this.scale.end.getTime();
		if (r && t === "hour") {
			let t = this.getVisibleDayDates(r);
			for (let i of t) {
				let t = new Date(i);
				t.setHours(0, 0, 0, 0), t.setMinutes(r.startMin);
				let a = new Date(i);
				a.setHours(0, 0, 0, 0), a.setMinutes(r.endMin), e.push({
					x: this.scale.timeToX(t),
					isMajor: !0
				});
				let o = Math.ceil(r.startMin / 60), s = new Date(i);
				for (s.setHours(o, 0, 0, 0), s.getHours() % n !== 0 && s.setHours(s.getHours() + (n - s.getHours() % n)); s.getTime() <= a.getTime();) s.getTime() !== t.getTime() && e.push({
					x: this.scale.timeToX(s),
					isMajor: !1
				}), s.setHours(s.getHours() + n);
			}
		} else if (t === "hour") {
			let t = fE(i, a), r = new Set(t.map((e) => e.getTime()));
			for (let n of t) e.push({
				x: this.scale.timeToX(n),
				isMajor: !0
			});
			for (let t of pE(i, a, n)) r.has(t.getTime()) || e.push({
				x: this.scale.timeToX(t),
				isMajor: !1
			});
		} else if (t === "day") {
			let t = mE(i, a), n = new Set(t.map((e) => e.getTime()));
			for (let n of t) e.push({
				x: this.scale.timeToX(n),
				isMajor: !0
			});
			for (let t of fE(i, a)) n.has(t.getTime()) || e.push({
				x: this.scale.timeToX(t),
				isMajor: !1
			});
		}
		return e;
	}
	destroy() {
		this.dayEl.remove(), this.hourEl.remove();
	}
};
function uE(e) {
	let t = e?.scale ?? "hour", n = e?.step ?? 1;
	switch (t) {
		case "hour": return {
			scale: t,
			step: n,
			hourFormat: new Intl.DateTimeFormat(void 0, {
				hour: "2-digit",
				minute: "2-digit",
				hour12: !1
			}),
			dayFormat: new Intl.DateTimeFormat(void 0, {
				weekday: "short",
				day: "numeric",
				month: "short"
			})
		};
		case "day": return {
			scale: t,
			step: n,
			hourFormat: new Intl.DateTimeFormat(void 0, {
				weekday: "short",
				day: "numeric"
			}),
			dayFormat: new Intl.DateTimeFormat(void 0, {
				month: "long",
				year: "numeric"
			})
		};
		default: return {
			scale: "hour",
			step: 1,
			hourFormat: new Intl.DateTimeFormat(void 0, {
				hour: "2-digit",
				minute: "2-digit",
				hour12: !1
			}),
			dayFormat: new Intl.DateTimeFormat(void 0, {
				weekday: "short",
				day: "numeric",
				month: "short"
			})
		};
	}
}
function dE(e) {
	return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, "0")}-${String(e.getDate()).padStart(2, "0")}`;
}
function fE(e, t) {
	let n = [], r = new Date(e);
	for (r.setHours(0, 0, 0, 0); r.getTime() <= t;) r.getTime() >= e && n.push(new Date(r)), r.setDate(r.getDate() + 1);
	return n;
}
function pE(e, t, n) {
	let r = [], i = new Date(e);
	i.setMinutes(0, 0, 0);
	let a = i.getHours();
	for (i.setHours(a - a % n); i.getTime() <= t;) i.getTime() >= e && r.push(new Date(i)), i.setHours(i.getHours() + n);
	return r;
}
function mE(e, t) {
	let n = [], r = new Date(e);
	r.setHours(0, 0, 0, 0);
	let i = r.getDay(), a = i === 0 ? 6 : i - 1;
	for (r.setDate(r.getDate() - a); r.getTime() <= t;) r.getTime() >= e && n.push(new Date(r)), r.setDate(r.getDate() + 7);
	return n;
}
//#endregion
//#region src/components/temporal-grid/timeline/RowLayout.ts
var hE = class {
	constructor(e = 40) {
		this.groups = [], this.groupIndex = /* @__PURE__ */ new Map(), this.rowHeight = e, this.labelPanel = document.createElement("div"), this.labelPanel.className = "tg-label-panel", this.labelPanel.setAttribute("role", "rowheader"), this.contentArea = document.createElement("div"), this.contentArea.className = "tg-content", this.contentArea.setAttribute("role", "grid");
	}
	getLabelPanel() {
		return this.labelPanel;
	}
	getContentArea() {
		return this.contentArea;
	}
	getRowHeight() {
		return this.rowHeight;
	}
	getGroups() {
		return this.groups;
	}
	getGroupCount() {
		return this.groups.length;
	}
	getGroupAtIndex(e) {
		return this.groups[e];
	}
	yToGroupId(e) {
		let t = Math.floor(e / this.rowHeight);
		return t < 0 || t >= this.groups.length ? null : this.groups[t].id;
	}
	groupIdToRowIndex(e) {
		return this.groupIndex.get(e) ?? -1;
	}
	getRowRange(e, t) {
		let n = Math.max(0, Math.floor(Math.min(e, t) / this.rowHeight)), r = Math.min(this.groups.length - 1, Math.floor(Math.max(e, t) / this.rowHeight)), i = [];
		for (let e = n; e <= r; e++) i.push(this.groups[e].id);
		return i;
	}
	getRowTop(e) {
		return e * this.rowHeight;
	}
	setGroups(e) {
		this.groups = e.slice().sort((e, t) => e.order !== void 0 && t.order !== void 0 ? e.order - t.order : e.order === void 0 ? t.order === void 0 ? e.content.localeCompare(t.content) : 1 : -1), this.groupIndex.clear();
		for (let e = 0; e < this.groups.length; e++) this.groupIndex.set(this.groups[e].id, e);
	}
	render() {
		this.renderLabels(), this.renderRows();
	}
	renderLabels() {
		this.labelPanel.innerHTML = "";
		for (let e of this.groups) {
			let t = document.createElement("div");
			t.className = "tg-label", t.style.height = `${this.rowHeight}px`, t.textContent = e.content, t.title = e.content, t.dataset.groupId = e.id, this.labelPanel.appendChild(t);
		}
	}
	renderRows() {
		this.contentArea.querySelectorAll(".tg-row").forEach((e) => e.remove());
		for (let e = 0; e < this.groups.length; e++) {
			let t = document.createElement("div");
			t.className = "tg-row", t.style.height = `${this.rowHeight}px`, t.style.top = `${e * this.rowHeight}px`, t.dataset.groupId = this.groups[e].id, this.contentArea.appendChild(t);
		}
		this.contentArea.style.height = `${this.groups.length * this.rowHeight}px`;
	}
	destroy() {
		this.labelPanel.remove(), this.contentArea.remove();
	}
}, gE = class {
	constructor(e, t) {
		this.items = [], this.itemElements = /* @__PURE__ */ new Map(), this.ghostEl = null, this.ghostCountBadge = null, this.scale = e, this.layout = t, this.contentArea = t.getContentArea();
	}
	setItems(e) {
		this.items = e;
	}
	render() {
		for (let e of this.itemElements.values()) e.remove();
		this.itemElements.clear(), this.contentArea.querySelectorAll("[data-item-id]").forEach((e) => {
			e.dataset.itemId !== "__ghost__" && e.remove();
		});
		for (let e of this.items) {
			let t = this.renderItem(e);
			t && (this.contentArea.appendChild(t), this.itemElements.set(e.id, t));
		}
	}
	renderItem(e) {
		let t = this.layout.groupIdToRowIndex(e.group);
		if (t === -1) return null;
		let n = e.start instanceof Date ? e.start : new Date(e.start), r = e.end ? e.end instanceof Date ? e.end : new Date(e.end) : n, i = this.scale.timeToX(n), a = this.scale.timeToX(r) - i, o = this.layout.getRowTop(t), s = this.layout.getRowHeight();
		if (a < .5) return null;
		let c = document.createElement("div");
		if (c.dataset.itemId = e.id, c.title = e.title || e.content, e.type === "background" || e.isSegment) c.className = `tg-item-background ${e.className || ""}`.trim(), e.style && (c.style.cssText = e.style), c.style.position = "absolute", c.style.left = `${i}px`, c.style.top = `${o}px`, c.style.width = `${a}px`, c.style.height = `${s}px`, c.style.pointerEvents = "none";
		else {
			c.className = `tg-item tg-item-range ${e.className || ""}`.trim(), e.style && (c.style.cssText += e.style), c.style.position = "absolute", c.style.left = `${i}px`, c.style.top = `${o + 2}px`, c.style.width = `${a}px`, c.style.height = `${s - 4}px`, c.style.cursor = "move";
			let t = document.createElement("span");
			t.className = "tg-item-content", t.textContent = e.content, c.appendChild(t);
			let n = document.createElement("div");
			n.className = "tg-resize-handle tg-resize-left", n.dataset.handle = "left", c.appendChild(n);
			let r = document.createElement("div");
			r.className = "tg-resize-handle tg-resize-right", r.dataset.handle = "right", c.appendChild(r);
		}
		return c;
	}
	updateItemPosition(e, t, n, r) {
		let i = this.itemElements.get(e);
		i && (i.style.left = `${t}px`, i.style.top = `${n + 2}px`, i.style.width = `${r}px`);
	}
	showGhost(e) {
		if (!this.ghostEl) {
			this.ghostEl = document.createElement("div"), this.ghostEl.className = "tg-ghost", this.ghostEl.dataset.itemId = "__ghost__";
			for (let e of [
				"left",
				"right",
				"top",
				"bottom"
			]) {
				let t = document.createElement("div");
				t.className = `tg-resize-handle tg-resize-${e}`, t.dataset.handle = e, this.ghostEl.appendChild(t);
			}
			this.ghostCountBadge = document.createElement("div"), this.ghostCountBadge.className = "tg-ghost-count", this.ghostEl.appendChild(this.ghostCountBadge), this.contentArea.appendChild(this.ghostEl);
		}
		let t = this.scale.timeToX(e.startTime), n = this.scale.timeToX(e.endTime) - t, r = this.layout.getRowHeight(), i = e.topRowIndex * r, a = (e.bottomRowIndex - e.topRowIndex + 1) * r, o = e.bottomRowIndex - e.topRowIndex + 1;
		this.ghostEl.style.left = `${t}px`, this.ghostEl.style.top = `${i}px`, this.ghostEl.style.width = `${n}px`, this.ghostEl.style.height = `${a}px`, this.ghostEl.style.display = "block", this.ghostCountBadge && (this.ghostCountBadge.textContent = `${o} court${o > 1 ? "s" : ""}`, this.ghostCountBadge.style.display = o > 1 ? "flex" : "none");
	}
	clearGhost() {
		this.ghostEl && (this.ghostEl.remove(), this.ghostEl = null, this.ghostCountBadge = null);
	}
	isGhostVisible() {
		return this.ghostEl !== null && this.ghostEl.style.display !== "none";
	}
	highlightRows(e) {
		this.clearHighlights();
		for (let t of e) {
			let e = this.contentArea.querySelectorAll(".tg-row");
			e[t] && e[t].classList.add("tg-row-highlight");
		}
	}
	clearHighlights() {
		this.contentArea.querySelectorAll(".tg-row-highlight").forEach((e) => {
			e.classList.remove("tg-row-highlight");
		});
	}
	static hitTest(e) {
		if (!(e instanceof HTMLElement)) return {
			itemId: null,
			handle: null
		};
		let t = e.closest(".tg-resize-handle")?.dataset.handle ?? null;
		return {
			itemId: e.closest("[data-item-id]")?.dataset.itemId ?? null,
			handle: t
		};
	}
	destroy() {
		this.clearGhost(), this.clearHighlights();
		for (let e of this.itemElements.values()) e.remove();
		this.itemElements.clear();
	}
}, _E = 3, vE = 30, yE = 8, bE = 3600 * 1e3, xE = class {
	constructor(e, t, n, r, i = 5, a = !1) {
		this.mode = "IDLE", this.gesture = null, this.items = [], this.ghostStartTime = null, this.ghostEndTime = null, this.ghostTopRow = 0, this.ghostBottomRow = 0, this.justDragged = !1, this.autoScrollRaf = null, this.autoScrollDelta = 0, this.scrollContainer = null, this.onPointerDown = (e) => {
			if (e.button !== 0) return;
			let { itemId: t, handle: n } = gE.hitTest(e.target);
			if (this.mode === "GHOST_EDITING") {
				if (t === "__ghost__" && n) {
					this.startGesture(e, "__ghost__", n === "left" ? "RESIZING_LEFT" : n === "right" ? "RESIZING_RIGHT" : n === "top" ? "RESIZING_TOP" : "RESIZING_BOTTOM");
					return;
				}
				if (t === "__ghost__" && !n) {
					this.confirmGhost();
					return;
				}
				this.cancelGhost();
				return;
			}
			if (t) if (n === "left") this.startGesture(e, t, "RESIZING_LEFT");
			else if (n === "right") this.startGesture(e, t, "RESIZING_RIGHT");
			else {
				let n = this.items.find((e) => e.id === t);
				if (!n || n.isSegment || n.type === "background") return;
				this.startGesture(e, t, "DRAGGING");
			}
		}, this.onPointerMove = (e) => {
			if (this.gesture) {
				if (this.gesture.currentX = e.clientX, this.gesture.currentY = e.clientY, !this.gesture.thresholdExceeded) {
					let t = Math.abs(e.clientX - this.gesture.startX), n = Math.abs(e.clientY - this.gesture.startY);
					if (t < _E && n < _E) return;
					this.gesture.thresholdExceeded = !0;
				}
				switch (this.checkAutoScroll(e), this.mode) {
					case "DRAGGING":
						this.handleDragMove(e);
						break;
					case "RESIZING_LEFT":
					case "RESIZING_RIGHT":
						this.gesture.itemId === "__ghost__" ? this.handleGhostTimeResize(e) : this.handleResizeMove(e);
						break;
					case "RESIZING_TOP":
					case "RESIZING_BOTTOM":
						this.handleGhostRowResize(e);
						break;
				}
			}
		}, this.onPointerUp = (e) => {
			if (document.removeEventListener("pointermove", this.onPointerMove), document.removeEventListener("pointerup", this.onPointerUp), this.stopAutoScroll(), !this.gesture) {
				this.mode = "IDLE";
				return;
			}
			let t = this.gesture.itemId === "__ghost__";
			if (!this.gesture.thresholdExceeded && !t) {
				this.gesture.itemId && this.callbacks.onItemClick?.(this.gesture.itemId, e), this.gesture = null, this.mode = "IDLE", this.renderer.clearHighlights();
				return;
			}
			if (t) {
				this.gesture = null, this.mode = "GHOST_EDITING";
				return;
			}
			if (this.gesture.itemId && this.gesture.thresholdExceeded) {
				this.justDragged = !0, setTimeout(() => this.justDragged = !1, 300);
				let t = (e.clientX - this.gesture.startX) * this.scale.msPerPx, n = this.gesture.originalEnd.getTime() - this.gesture.originalStart.getTime(), r, i, a = this.gesture.originalGroup;
				if (this.mode === "DRAGGING") {
					r = this.scale.snap(new Date(this.gesture.originalStart.getTime() + t), this.snapMinutes), i = new Date(r.getTime() + n);
					let o = this.contentArea.getBoundingClientRect(), s = e.clientY - o.top + this.contentArea.scrollTop;
					a = this.layout.yToGroupId(s) || this.gesture.originalGroup;
				} else this.mode === "RESIZING_LEFT" ? (r = this.scale.snap(new Date(this.gesture.originalStart.getTime() + t), this.snapMinutes), i = this.gesture.originalEnd, r >= i && (r = /* @__PURE__ */ new Date(i.getTime() - this.snapMinutes * 60 * 1e3))) : (r = this.gesture.originalStart, i = this.scale.snap(new Date(this.gesture.originalEnd.getTime() + t), this.snapMinutes), i <= r && (i = new Date(r.getTime() + this.snapMinutes * 60 * 1e3)));
				this.callbacks.onMove?.({
					id: this.gesture.itemId,
					group: a,
					start: r,
					end: i
				});
			}
			this.gesture = null, this.mode = "IDLE", this.renderer.clearHighlights();
		}, this.onDblClick = (e) => {
			if (this.justDragged) return;
			let { itemId: t } = gE.hitTest(e.target);
			if (t) return;
			let n = this.contentArea.getBoundingClientRect(), r = e.clientX - n.left + this.contentArea.scrollLeft, i = e.clientY - n.top + this.contentArea.scrollTop, a = this.scale.xToTime(r), o = this.scale.snap(a, this.snapMinutes), s = new Date(o.getTime() + bE), c = this.layout.yToGroupId(i);
			if (!c) return;
			let l = this.layout.groupIdToRowIndex(c);
			l < 0 || (this.ghostStartTime = o, this.ghostEndTime = s, this.ghostTopRow = l, this.ghostBottomRow = l, this.mode = "GHOST_EDITING", this.renderer.showGhost({
				startTime: o,
				endTime: s,
				topRowIndex: l,
				bottomRowIndex: l
			}), this.renderer.highlightRows([l]));
		}, this.onWheel = (e) => {
			if (!((e.ctrlKey || e.metaKey) && !this.enablePinchZoom)) {
				if (e.preventDefault(), (e.ctrlKey || e.metaKey) && this.enablePinchZoom) {
					let t = e.deltaY > 0 ? 1.15 : .87, n = this.contentArea.getBoundingClientRect(), r = e.clientX - n.left;
					this.scale.zoom(t, r);
				} else if (e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
					let t = e.deltaX || e.deltaY;
					this.scale.pan(t);
				} else {
					this.scrollContainer && (this.scrollContainer.scrollTop += e.deltaY);
					return;
				}
				this.onScaleChanged?.();
			}
		}, this.onScaleChanged = null, this.onKeyDown = (e) => {
			e.key === "Escape" && this.mode === "GHOST_EDITING" && this.cancelGhost();
		}, this.scale = e, this.layout = t, this.renderer = n, this.contentArea = t.getContentArea(), this.wheelTarget = this.contentArea, this.callbacks = r, this.snapMinutes = i, this.enablePinchZoom = a;
	}
	setItems(e) {
		this.items = e;
	}
	setScrollContainer(e) {
		this.scrollContainer = e;
	}
	setWheelTarget(e) {
		this.wheelTarget = e;
	}
	attach() {
		this.contentArea.addEventListener("pointerdown", this.onPointerDown), this.contentArea.addEventListener("dblclick", this.onDblClick), this.wheelTarget.addEventListener("wheel", this.onWheel, { passive: !1 }), document.addEventListener("keydown", this.onKeyDown);
	}
	detach() {
		this.contentArea.removeEventListener("pointerdown", this.onPointerDown), this.contentArea.removeEventListener("dblclick", this.onDblClick), this.wheelTarget.removeEventListener("wheel", this.onWheel), document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("pointermove", this.onPointerMove), document.removeEventListener("pointerup", this.onPointerUp), this.stopAutoScroll();
	}
	getMode() {
		return this.mode;
	}
	startGesture(e, t, n) {
		e.preventDefault();
		let r = this.items.find((e) => e.id === t), i, a, o;
		if (t === "__ghost__") i = this.ghostStartTime, a = this.ghostEndTime, o = "";
		else if (r) i = r.start instanceof Date ? r.start : new Date(r.start), a = r.end ? r.end instanceof Date ? r.end : new Date(r.end) : i, o = r.group;
		else return;
		this.gesture = {
			mode: n,
			itemId: t,
			startX: e.clientX,
			startY: e.clientY,
			originalStart: i,
			originalEnd: a,
			originalGroup: o,
			currentX: e.clientX,
			currentY: e.clientY,
			thresholdExceeded: !1
		}, this.mode = n, this.contentArea.setPointerCapture(e.pointerId), document.addEventListener("pointermove", this.onPointerMove), document.addEventListener("pointerup", this.onPointerUp);
	}
	handleDragMove(e) {
		if (!this.gesture || !this.gesture.itemId) return;
		let t = (e.clientX - this.gesture.startX) * this.scale.msPerPx, n = this.gesture.originalEnd.getTime() - this.gesture.originalStart.getTime(), r = this.scale.snap(new Date(this.gesture.originalStart.getTime() + t), this.snapMinutes), i = new Date(r.getTime() + n), a = this.contentArea.getBoundingClientRect(), o = e.clientY - a.top + this.contentArea.scrollTop, s = this.layout.yToGroupId(o) || this.gesture.originalGroup;
		if (this.callbacks.onMoving) {
			let e = this.callbacks.onMoving({
				id: this.gesture.itemId,
				group: s,
				start: r,
				end: i
			});
			if (e === null) return;
			r = e.start, i = e.end;
		}
		let c = this.scale.timeToX(r), l = this.scale.timeToX(i) - c, u = this.layout.groupIdToRowIndex(s), d = this.layout.getRowTop(u >= 0 ? u : 0);
		this.renderer.updateItemPosition(this.gesture.itemId, c, d, l), u >= 0 && this.renderer.highlightRows([u]);
	}
	handleResizeMove(e) {
		if (!this.gesture || !this.gesture.itemId) return;
		let t = (e.clientX - this.gesture.startX) * this.scale.msPerPx, n = this.gesture.originalStart, r = this.gesture.originalEnd;
		if (this.mode === "RESIZING_LEFT" ? (n = this.scale.snap(new Date(this.gesture.originalStart.getTime() + t), this.snapMinutes), n >= r && (n = /* @__PURE__ */ new Date(r.getTime() - this.snapMinutes * 60 * 1e3))) : (r = this.scale.snap(new Date(this.gesture.originalEnd.getTime() + t), this.snapMinutes), r <= n && (r = new Date(n.getTime() + this.snapMinutes * 60 * 1e3))), this.callbacks.onMoving) {
			let e = this.callbacks.onMoving({
				id: this.gesture.itemId,
				group: this.gesture.originalGroup,
				start: n,
				end: r
			});
			if (e === null) return;
			n = e.start, r = e.end;
		}
		let i = this.scale.timeToX(n), a = this.scale.timeToX(r) - i, o = this.layout.groupIdToRowIndex(this.gesture.originalGroup), s = this.layout.getRowTop(o >= 0 ? o : 0);
		this.renderer.updateItemPosition(this.gesture.itemId, i, s, a);
	}
	handleGhostTimeResize(e) {
		if (!this.gesture) return;
		let t = this.contentArea.getBoundingClientRect(), n = e.clientX - t.left + this.contentArea.scrollLeft, r = this.scale.snap(this.scale.xToTime(n), this.snapMinutes);
		this.mode === "RESIZING_LEFT" ? r < this.ghostEndTime && (this.ghostStartTime = r) : r > this.ghostStartTime && (this.ghostEndTime = r), this.updateGhostDisplay();
	}
	handleGhostRowResize(e) {
		if (!this.gesture) return;
		let t = this.contentArea.getBoundingClientRect(), n = e.clientY - t.top + this.contentArea.scrollTop, r = Math.floor(n / this.layout.getRowHeight()), i = Math.max(0, Math.min(this.layout.getGroupCount() - 1, r));
		this.mode === "RESIZING_TOP" ? i <= this.ghostBottomRow && (this.ghostTopRow = i) : i >= this.ghostTopRow && (this.ghostBottomRow = i), this.updateGhostDisplay();
	}
	updateGhostDisplay() {
		this.renderer.showGhost({
			startTime: this.ghostStartTime,
			endTime: this.ghostEndTime,
			topRowIndex: this.ghostTopRow,
			bottomRowIndex: this.ghostBottomRow
		});
		let e = [];
		for (let t = this.ghostTopRow; t <= this.ghostBottomRow; t++) e.push(t);
		this.renderer.highlightRows(e);
	}
	confirmGhost() {
		if (!this.ghostStartTime || !this.ghostEndTime) {
			this.cancelGhost();
			return;
		}
		let e = [];
		for (let t = this.ghostTopRow; t <= this.ghostBottomRow; t++) {
			let n = this.layout.getGroupAtIndex(t);
			n && e.push(n.id);
		}
		if (e.length === 0) {
			this.cancelGhost();
			return;
		}
		let t = {
			groupIds: e,
			topRowIndex: this.ghostTopRow,
			bottomRowIndex: this.ghostBottomRow,
			startTime: this.ghostStartTime,
			endTime: this.ghostEndTime
		};
		this.renderer.clearGhost(), this.renderer.clearHighlights(), this.mode = "IDLE", this.callbacks.onMultiRowCreate?.(t), this.ghostStartTime = null, this.ghostEndTime = null;
	}
	cancelGhost() {
		this.renderer.clearGhost(), this.renderer.clearHighlights(), this.mode = "IDLE", this.ghostStartTime = null, this.ghostEndTime = null;
	}
	checkAutoScroll(e) {
		if (!this.scrollContainer) return;
		let t = this.scrollContainer.getBoundingClientRect(), n = t.bottom - e.clientY, r = e.clientY - t.top;
		n < vE ? (this.autoScrollDelta = yE * (1 - n / vE), this.startAutoScroll()) : r < vE ? (this.autoScrollDelta = -yE * (1 - r / vE), this.startAutoScroll()) : this.stopAutoScroll();
	}
	startAutoScroll() {
		if (this.autoScrollRaf !== null) return;
		let e = () => {
			this.scrollContainer && (this.scrollContainer.scrollTop += this.autoScrollDelta, this.autoScrollRaf = requestAnimationFrame(e));
		};
		this.autoScrollRaf = requestAnimationFrame(e);
	}
	stopAutoScroll() {
		this.autoScrollRaf !== null && (cancelAnimationFrame(this.autoScrollRaf), this.autoScrollRaf = null), this.autoScrollDelta = 0;
	}
}, SE = class {
	constructor(e, t, n, r = {}) {
		this.callbacks = {}, this.resizeObserver = null, this._batchUpdating = !1, this.eventListeners = /* @__PURE__ */ new Map(), this.options = {
			rowHeight: 40,
			...r
		};
		let i = /* @__PURE__ */ new Date();
		this.scale = new oE(r.start || i, r.end || new Date(i.getTime() + 720 * 60 * 1e3), e.clientWidth || 800), (r.min || r.max || r.zoomMin || r.zoomMax) && this.scale.setLimits({
			min: r.min,
			max: r.max,
			zoomMin: r.zoomMin,
			zoomMax: r.zoomMax
		}), this.timeAxis = new lE(this.scale, r.timeAxis), this.layout = new hE(this.options.rowHeight), this.renderer = new gE(this.scale, this.layout), this.interaction = new xE(this.scale, this.layout, this.renderer, this.callbacks, 5, r.enablePinchZoom ?? !1), this.rootEl = document.createElement("div"), this.rootEl.className = "tg-timeline", r.height && (this.rootEl.style.height = r.height);
		let a = document.createElement("div");
		a.className = "tg-axis-header";
		let o = document.createElement("div");
		o.className = "tg-axis-spacer", a.appendChild(o), a.appendChild(this.timeAxis.getDayElement()), a.appendChild(this.timeAxis.getHourElement()), this.rootEl.appendChild(a), this.bodyEl = document.createElement("div"), this.bodyEl.className = "tg-body", this.bodyEl.appendChild(this.layout.getLabelPanel());
		let s = document.createElement("div");
		s.className = "tg-scroll-wrapper", s.appendChild(this.layout.getContentArea()), this.bodyEl.appendChild(s), this.rootEl.appendChild(this.bodyEl), e.appendChild(this.rootEl), s.addEventListener("scroll", () => {
			this.layout.getLabelPanel().scrollTop = s.scrollTop;
		}), this.interaction.setScrollContainer(s), this.interaction.setWheelTarget(this.rootEl), this.interaction.onScaleChanged = () => this.renderAll(), this.layout.setGroups(n), this.renderer.setItems(t), this.interaction.setItems(t), this.interaction.attach(), this.renderAll(), this.resizeObserver = new ResizeObserver(() => {
			let t = s.clientWidth || e.clientWidth;
			this.scale.setWidth(t), this.renderAll();
		}), this.resizeObserver.observe(s);
	}
	setGroups(e) {
		this.layout.setGroups(e), this.renderAll();
	}
	setItems(e) {
		this.renderer.setItems(e), this.interaction.setItems(e), this.renderAll();
	}
	setWindow(e, t, n) {
		this.scale.setWindow(e, t), this.renderAll();
	}
	setOptions(e) {
		(e.min !== void 0 || e.max !== void 0 || e.zoomMin !== void 0 || e.zoomMax !== void 0) && this.scale.setLimits({
			min: e.min,
			max: e.max,
			zoomMin: e.zoomMin,
			zoomMax: e.zoomMax
		}), e.timeAxis && this.timeAxis.setTimeAxisOptions(e.timeAxis), e.rowHeight !== void 0 && (this.options.rowHeight = e.rowHeight), Object.assign(this.options, e), this.renderAll();
	}
	on(e, t) {
		this.eventListeners.has(e) || this.eventListeners.set(e, /* @__PURE__ */ new Set()), this.eventListeners.get(e).add(t), e === "click" && (this.callbacks.onItemClick = (e, t) => {
			this.emit("click", {
				item: e,
				event: t
			});
		});
	}
	off(e, t) {
		this.eventListeners.get(e)?.delete(t);
	}
	emit(e, t) {
		let n = this.eventListeners.get(e);
		if (n) for (let e of n) e(t);
	}
	onMultiRowCreate(e) {
		this.callbacks.onMultiRowCreate = e;
	}
	onAdd(e) {
		this.callbacks.onAdd = e;
	}
	onMove(e) {
		this.callbacks.onMove = e;
	}
	onMoving(e) {
		this.callbacks.onMoving = e;
	}
	onDayClick(e) {
		this.timeAxis.onDayClick = e;
	}
	getContentElement() {
		return this.layout.getContentArea();
	}
	setDailyBounds(e, t) {
		this.scale.setDailyBounds(e, t), this.renderAll();
	}
	clearDailyBounds() {
		this.scale.clearDailyBounds(), this.renderAll();
	}
	setVisibleDays(e) {
		this.scale.setVisibleDays(e), this.renderAll();
	}
	clearVisibleDays() {
		this.scale.clearVisibleDays(), this.renderAll();
	}
	beginBatchUpdate() {
		this._batchUpdating = !0;
	}
	endBatchUpdate() {
		this._batchUpdating = !1, this.renderAll();
	}
	renderAll() {
		if (this._batchUpdating) return;
		this.timeAxis.render(), this.layout.render(), this.renderer.render();
		let e = this.layout.getContentArea(), t = this.layout.getGroupCount() * (this.options.rowHeight ?? 40);
		this.timeAxis.renderGridlines(e, t);
	}
	destroy() {
		this.interaction.detach(), this.resizeObserver?.disconnect(), this.timeAxis.destroy(), this.layout.destroy(), this.renderer.destroy(), this.rootEl.remove(), this.eventListeners.clear();
	}
}, { BLOCK_TYPES: CE } = m, wE = class {
	constructor(e, t) {
		this.timeline = null, this.unsubscribe = null, this.currentItems = /* @__PURE__ */ new Map(), this.isRendering = !1, this.popoverManager = rE(), this.viewState = new PT(), this.currentDay = null, this.currentView = "day", this.selectedCourts = /* @__PURE__ */ new Set(), this.visibleCourts = null, this.handleOnMove = (e) => {
			let t = UT(e.id);
			if (!t) return !1;
			let n = HT(e.group), r = this.toLocalISO(e.start), i = this.toLocalISO(e.end), a = this.engine.moveBlock({
				blockId: t,
				newTimeRange: {
					start: r,
					end: i
				},
				newCourt: n || void 0
			});
			return a.conflicts.some((e) => e.severity === "ERROR") ? (this.showConflictDialog(a.conflicts), !1) : (this.render(), !0);
		}, this.handleOnMoving = (e) => {
			this.popoverManager.destroy();
			let t = this.currentItems.get(e.id);
			if (t && (t.isSegment || t.type === "background")) return null;
			let { start: n, end: r } = e, i = HT(e.group);
			if (i) {
				let e = n.toISOString().slice(0, 10), t = this.engine.getCourtAvailability(i, e), a = /* @__PURE__ */ new Date(`${e}T${t.startTime}:00`), o = /* @__PURE__ */ new Date(`${e}T${t.endTime}:00`);
				n < a && (n = a), r > o && (r = o);
			}
			return {
				start: n,
				end: r
			};
		}, this.handleTimelineClick = (e) => {
			let t = e.item;
			if (!t) {
				this.popoverManager.destroy();
				return;
			}
			let n = this.currentItems.get(t);
			if (!n) {
				this.popoverManager.destroy();
				return;
			}
			if (n.isSegment || n.type === "background") {
				this.popoverManager.destroy();
				return;
			}
			if (this.popoverManager.isActiveFor(t)) {
				this.popoverManager.destroy();
				return;
			}
			let r = UT(t);
			if (!r) return;
			let i = (e.event?.target)?.closest?.(".tg-item") ?? this.config.container.querySelector(`[data-item-id="${t}"]`);
			if (i) {
				let e = String(n.start).slice(0, 10);
				this.popoverManager.showForEngineBlock(i, {
					itemId: t,
					blockId: r,
					engine: this.engine,
					day: e,
					onBlockChanged: () => this.render()
				});
			}
			this.config.onBlockSelected && this.config.onBlockSelected(r);
		}, this.handleMultiRowCreate = (e) => {
			let t = [];
			for (let n of e.groupIds) {
				let e = HT(n);
				e && t.push(e);
			}
			if (t.length === 0) return;
			let n = this.toLocalISO(e.startTime), r = this.toLocalISO(e.endTime), i = this.engine.applyBlock({
				courts: t,
				timeRange: {
					start: n,
					end: r
				},
				type: CE.BLOCKED,
				reason: "New Block"
			});
			if (this.render(), i.applied.length > 0) {
				let e = i.applied[0].block.id, t = `block-${e}`, r = n.slice(0, 10);
				setTimeout(() => {
					let n = this.config.container.querySelector(`[data-item-id="${t}"]`);
					n && this.popoverManager.showForEngineBlock(n, {
						itemId: t,
						blockId: e,
						engine: this.engine,
						day: r,
						onBlockChanged: () => this.render()
					});
				}, 50);
			}
			this.config.onTimeRangeSelected && this.config.onTimeRangeSelected({
				courts: t,
				start: n,
				end: r
			});
		}, this.handleEngineEvent = (e) => {
			switch (e.type) {
				case "STATE_CHANGED":
				case "BLOCKS_CHANGED":
					this.render(), e.type === "BLOCKS_CHANGED" && this.config.onBlocksChanged && this.config.onBlocksChanged();
					break;
				case "CONFLICTS_CHANGED":
					this.config.showConflicts && this.render();
					break;
				case "AVAILABILITY_CHANGED":
					this.updateTimelineWindow(), this.render();
					break;
			}
		}, this.engine = e, this.config = {
			groupingMode: "BY_VENUE",
			showConflicts: !0,
			showSegmentLabels: !1,
			colorScheme: FT,
			...t
		}, this.initialize();
	}
	initialize() {
		if (this.config.initialDay) this.currentDay = this.config.initialDay;
		else {
			let e = this.engine.getActiveDays();
			this.currentDay = e.length > 0 ? e[0] : h.dateTime.extractDate((/* @__PURE__ */ new Date()).toISOString());
		}
		this.viewState.setSelectedDay(this.currentDay), this.config.initialView && (this.currentView = this.config.initialView), this.unsubscribe = this.engine.subscribe(this.handleEngineEvent), this.ensureTimeline();
	}
	ensureTimeline() {
		this.timeline || setTimeout(() => {
			this.timeline || this.createTimelineWithData();
		}, 0);
	}
	getViewDays() {
		if (!this.currentDay) return [];
		let e = iE[this.currentView], t = e ? e.days : 1;
		if (t <= 0) return this.engine.getActiveDays();
		if (t <= 1) return [this.currentDay];
		let n = this.engine.getActiveDays(), r = n.indexOf(this.currentDay);
		return r === -1 ? [this.currentDay] : n.slice(r, r + t);
	}
	buildViewData() {
		if (!this.currentDay) return {
			groups: [],
			items: []
		};
		let e = this.getViewDays(), t = this.engine.listCourtMeta(), n = this.viewState.getLayerVisibility(), r = {
			groupingMode: this.config.groupingMode,
			layerVisibility: n,
			showSegmentLabels: this.config.showSegmentLabels,
			colorScheme: this.config.colorScheme
		}, i = IT(this.engine.getDayTimeline(e[0]), t, r);
		this.visibleCourts !== null && this.visibleCourts.size > 0 && (i = i.filter((e) => this.visibleCourts.has(String(e.id))));
		let a = this.visibleCourts !== null && this.visibleCourts.size > 0 && i.length > 0 ? new Set(i.map((e) => String(e.id))) : null, o = e.length <= 1 ? this.engine.getActiveDays() : e, s = [], c = [];
		for (let e of o) {
			let t = this.engine.getDayTimeline(e);
			s.push(...LT(t, r)), c.push(...zT(this.engine.getDayBlocks(e), r));
		}
		let l = a ? s.filter((e) => a.has(String(e.group))) : s, u = a ? c.filter((e) => a.has(String(e.group))) : c, d = [...l, ...u];
		return {
			groups: i.map((e, t) => ({
				id: String(e.id),
				content: typeof e.content == "string" ? e.content : "",
				order: t,
				courtRef: e.courtRef,
				surface: e.surface,
				indoor: e.indoor,
				hasLights: e.hasLights,
				tags: e.tags
			})),
			items: d.map((e) => ({
				id: String(e.id),
				group: String(e.group),
				content: e.content,
				start: e.start,
				end: e.end,
				type: e.type === "background" ? "background" : "range",
				className: e.className,
				style: e.style,
				title: e.title,
				editable: e.editable,
				blockId: e.blockId,
				status: e.status,
				reason: e.reason,
				isBlock: e.isBlock,
				isSegment: e.isSegment,
				isConflict: e.isConflict
			}))
		};
	}
	createTimelineWithData() {
		let e = this.engine.getConfig(), t = this.currentDay || h.dateTime.extractDate((/* @__PURE__ */ new Date()).toISOString()), n = this.getViewDays(), r = n[0] || t, i = n[n.length - 1] || t, a = this.engine.getVisibleTimeRange(r), o = this.engine.getVisibleTimeRange(i), s = WT({
			dayStartTime: a.startTime,
			dayEndTime: a.endTime,
			slotMinutes: e.slotMinutes,
			day: r
		}), c = iE[this.currentView], l = n.length > 1 ? /* @__PURE__ */ new Date(`${i}T${o.endTime}:00`) : s.end, u = this.engine.getActiveDays(), d = u[0] || r, f = u[u.length - 1] || i, p = this.engine.getVisibleTimeRange(d), m = this.engine.getVisibleTimeRange(f), g = /* @__PURE__ */ new Date(`${d}T${p.startTime}:00`), _ = /* @__PURE__ */ new Date(`${f}T${m.endTime}:00`), { groups: v, items: y } = this.buildViewData();
		this.currentItems.clear();
		for (let e of y) this.currentItems.set(e.id, e);
		this.timeline = new SE(this.config.container, y, v, {
			start: s.start,
			end: l,
			min: g,
			max: _,
			zoomMin: s.zoomMin,
			zoomMax: _.getTime() - g.getTime(),
			snap: (e) => this.snapToMinutes(e, 5),
			rowHeight: 40,
			height: "100%",
			timeAxis: c ? c.timeAxis : {
				scale: "hour",
				step: 1
			},
			showTooltips: !0
		}), this.timeline.setDailyBounds(a.startTime, a.endTime), n.length > 1 && this.timeline.setVisibleDays(n), this.timeline.on("click", this.handleTimelineClick), this.timeline.onMove(this.handleOnMove), this.timeline.onMoving(this.handleOnMoving), this.timeline.onMultiRowCreate(this.handleMultiRowCreate), this.timeline.onDayClick((e) => {
			this.setDay(e), this.setViewPreset("day"), this.config.onDayNavigate?.(e);
		}), this.config.onBlocksChanged?.();
	}
	setDay(e) {
		this.currentDay !== e && (this.currentDay = e, this.viewState.setSelectedDay(e), this.updateTimelineWindow(), this.render());
	}
	getDay() {
		return this.currentDay;
	}
	setView(e) {
		this.currentView = e, this.updateTimelineWindow();
	}
	setViewPreset(e) {
		let t = iE[e];
		if (!t || !this.timeline || !this.currentDay) return;
		this.currentView = e;
		let n = this.getViewDays(), r = n[0], i = n[n.length - 1], a = this.engine.getVisibleTimeRange(r), o = this.engine.getVisibleTimeRange(i);
		this.timeline.beginBatchUpdate();
		let s = t.days === 0 || t.days > 1;
		this.timeline.setDailyBounds(a.startTime, a.endTime), s ? this.timeline.setVisibleDays(n) : this.timeline.clearVisibleDays();
		let c = /* @__PURE__ */ new Date(`${r}T${a.startTime}:00`), l = /* @__PURE__ */ new Date(`${i}T${o.endTime}:00`);
		this.timeline.setWindow(c, l, { animation: !1 }), this.timeline.setOptions({ timeAxis: t.timeAxis });
		let { groups: u, items: d } = this.buildViewData();
		this.currentItems.clear();
		for (let e of d) this.currentItems.set(e.id, e);
		this.timeline.setGroups(u), this.timeline.setItems(d), this.timeline.endBatchUpdate(), this.config.onBlocksChanged?.();
	}
	setSelectedCourts(e) {
		this.selectedCourts = new Set(e);
	}
	getSelectedCourts() {
		return Array.from(this.selectedCourts);
	}
	setVisibleCourts(e) {
		e && e.size === 0 ? this.visibleCourts = null : this.visibleCourts = e, this.render();
	}
	setLayerVisibility(e, t) {
		this.viewState.setLayerVisibility(e, t), this.render();
	}
	refresh() {
		this.updateTimelineWindow(), this.render();
	}
	destroy() {
		this.popoverManager.destroy(), this.unsubscribe && this.unsubscribe(), this.timeline &&= (this.timeline.destroy(), null);
	}
	updateTimelineWindow() {
		if (!this.timeline || !this.currentDay) return;
		let e = this.engine.getConfig(), t = this.getViewDays(), n = t[0] || this.currentDay, r = t[t.length - 1] || this.currentDay, i = this.engine.getVisibleTimeRange(n), a = this.engine.getVisibleTimeRange(r), o = WT({
			dayStartTime: i.startTime,
			dayEndTime: i.endTime,
			slotMinutes: e.slotMinutes,
			day: n
		}), s = iE[this.currentView], c = t.length > 1 ? /* @__PURE__ */ new Date(`${r}T${a.endTime}:00`) : o.end, l = this.engine.getActiveDays(), u = l[0] || n, d = l[l.length - 1] || r, f = this.engine.getVisibleTimeRange(u), p = this.engine.getVisibleTimeRange(d), m = /* @__PURE__ */ new Date(`${u}T${f.startTime}:00`), h = /* @__PURE__ */ new Date(`${d}T${p.endTime}:00`);
		this.timeline.beginBatchUpdate(), this.timeline.setDailyBounds(i.startTime, i.endTime), t.length > 1 ? this.timeline.setVisibleDays(t) : this.timeline.clearVisibleDays(), this.timeline.setOptions({
			min: m,
			max: h
		}), this.timeline.setWindow(o.start, c, { animation: !1 }), s && this.timeline.setOptions({ timeAxis: s.timeAxis }), this.timeline.endBatchUpdate();
	}
	render() {
		if (this.currentDay && !this.isRendering) {
			if (!this.timeline) {
				this.ensureTimeline();
				return;
			}
			this.isRendering = !0;
			try {
				let { groups: e, items: t } = this.buildViewData();
				this.currentItems.clear();
				for (let e of t) this.currentItems.set(e.id, e);
				this.timeline.setGroups(e), this.timeline.setItems(t);
			} finally {
				this.isRendering = !1;
			}
		}
	}
	getPopoverManager() {
		return this.popoverManager;
	}
	snapToMinutes(e, t) {
		let n = e.getTime(), r = t * 60 * 1e3, i = Math.round(n / r) * r;
		return new Date(i);
	}
	toLocalISO(e) {
		let t = (e) => e.toString().padStart(2, "0");
		return `${e.getFullYear()}-${t(e.getMonth() + 1)}-${t(e.getDate())}T${t(e.getHours())}:${t(e.getMinutes())}:${t(e.getSeconds())}`;
	}
	showConflictDialog(e) {
		let t = e.filter((e) => e.severity === "ERROR").map((e) => e.message).join("\n");
		alert(`Cannot complete operation:\n\n${t}`);
	}
	getTimeline() {
		return this.timeline;
	}
	getEngine() {
		return this.engine;
	}
	getViewState() {
		return this.viewState;
	}
};
//#endregion
//#region src/components/temporal-grid/ui/statsBar.ts
function TE(e) {
	let t = e?.totalHours ?? "Total Hours", n = e?.blocked ?? "Blocked", r = e?.available ?? "Available", i = e?.avgPerCourt ?? "Avg Avail/Court", a = document.createElement("div");
	a.className = "tg-stats-bar";
	let o = (e) => {
		let t = document.createElement("span");
		return t.innerHTML = `${e}: <b>&mdash;</b>`, a.appendChild(t), t;
	}, s = o(t), c = o(n), l = o(r), u = o(i);
	return {
		element: a,
		update: (e) => {
			s.innerHTML = `${t}: <b>${e.totalHours.toFixed(1)}h</b>`, c.innerHTML = `${n}: <b>${e.blockedHours.toFixed(1)}h</b>`, l.innerHTML = `${r}: <b>${e.availableHours.toFixed(1)}h</b>`, u.innerHTML = `${i}: <b>${e.avgPerCourt.toFixed(1)}h</b>`;
		}
	};
}
//#endregion
//#region src/components/temporal-grid/ui/courtAvailabilityModal.ts
var EE, DE, OE, kE = !1;
async function AE() {
	if (!EE) {
		let e = await import("./dist-B9gd8_9-.mjs");
		EE = e.TimepickerUI, DE = e.PluginRegistry, OE = (await import("./range-B1T9TbVf.mjs")).RangePlugin, !kE && DE && OE && (DE.register(OE), kE = !0);
	}
}
var jE = 0;
async function ME(e) {
	let { title: t, currentDay: n, currentStartTime: r, currentEndTime: i, showScopeToggle: a = !0, venueBounds: o, onConfirm: s, onCancel: c, labels: l = {} } = e;
	await AE();
	let u = (/* @__PURE__ */ new Date(n + "T12:00:00")).toLocaleDateString("en-US", {
		month: "short",
		day: "numeric"
	}), d = `tp-court-avail-${++jE}`, f = a ? "current-day" : "all-days", p = document.createElement("div");
	p.className = "tg-modal", p.style.cssText = "\n    position: fixed; top: 0; left: 0; right: 0; bottom: 0;\n    background: var(--chc-bg-overlay); z-index: 10000;\n    display: flex; align-items: center; justify-content: center;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  ";
	let m = document.createElement("div");
	m.style.cssText = "max-width: 90vw;";
	let h = document.createElement("style");
	h.textContent = `
    #${d} .tp-ui--inline .tp-ui-wrapper {
      max-width: none !important;
      width: 328px !important;
      box-shadow: 0 8px 32px rgba(0,0,0,0.2) !important;
    }
  `, m.appendChild(h);
	let g = document.createElement("input");
	g.type = "text", g.value = `${r} - ${i}`, g.dataset.timeFrom = r, g.dataset.timeTo = i, g.style.cssText = "position: absolute; opacity: 0; pointer-events: none; height: 0; width: 0;", m.appendChild(g);
	let _ = document.createElement("div");
	_.id = d, m.appendChild(_);
	let v = document.createElement("div");
	if (v.style.cssText = "padding: 12px 24px 0;", o) {
		let e = document.createElement("div");
		e.className = "tp-court-avail-warning", e.style.cssText = "\n      display: none; padding: 8px 12px; margin-bottom: 12px; border-radius: 6px;\n      background: #fef3c7; border: 1px solid #f59e0b; color: #92400e;\n      font-size: 12px; line-height: 1.4;\n    ", v.appendChild(e), v.dataset.venueBoundsStart = o.startTime, v.dataset.venueBoundsEnd = o.endTime;
	}
	if (a) {
		let e = document.createElement("div");
		e.style.cssText = "margin-bottom: 8px;";
		let t = document.createElement("div");
		t.textContent = (l.applyTo || "Apply to") + ":", t.style.cssText = "font-size: 12px; color: var(--chc-text-secondary); margin-bottom: 6px; font-weight: 500;", e.appendChild(t);
		let n = `availability-scope-${d}`, r = (t, r, i) => {
			let a = document.createElement("label");
			a.style.cssText = "display: flex; align-items: center; gap: 8px; padding: 3px 0; cursor: pointer; font-size: 13px; color: var(--chc-text-primary);";
			let o = document.createElement("input");
			o.type = "radio", o.name = n, o.value = t, o.checked = i, o.style.cursor = "pointer", o.addEventListener("change", () => {
				o.checked && (f = t);
			});
			let s = document.createElement("span");
			s.textContent = r, a.appendChild(o), a.appendChild(s), e.appendChild(a);
		};
		r("current-day", l.currentDayOnly ? l.currentDayOnly.replace("${day}", u) : `Current day only (${u})`, !0), r("all-days", l.allDays || "All tournament days", !1), v.appendChild(e);
	}
	p.appendChild(m), p.addEventListener("click", (e) => {
		e.target === p && (C(), c?.());
	}), document.body.appendChild(p);
	let y = new EE(g, {
		range: {
			enabled: !0,
			fromLabel: l.startTime || "Start",
			toLabel: l.endTime || "End"
		},
		clock: {
			type: "12h",
			incrementMinutes: 5
		},
		ui: {
			theme: "crane",
			inline: {
				enabled: !0,
				containerId: d,
				showButtons: !0
			}
		},
		labels: {
			ok: l.apply || "Apply",
			cancel: l.cancel || "Cancel"
		},
		callbacks: {
			onRangeConfirm: (e) => {
				let t = e.from || r, n = e.to || i;
				C(), s({
					startTime: t,
					endTime: n,
					scope: f
				});
			},
			onCancel: () => {
				C(), c?.();
			}
		}
	});
	y.create();
	let b = _.querySelector(".tp-ui-wrapper"), x = b?.querySelector(".tp-ui-footer"), S = document.createElement("div");
	if (S.textContent = t, S.style.cssText = "\n    text-align: center; font-size: 16px; font-weight: 600;\n    padding: 12px 24px 4px;\n    background: var(--tp-bg); color: var(--tp-text);\n  ", b ? b.prepend(S) : _.prepend(S), x && b ? x.before(v) : m.appendChild(v), o) {
		let e = v.querySelector(".tp-court-avail-warning");
		((t, n) => {
			if (!e || !t || !n || t === "--:--" || n === "--:--") return;
			let r = t < o.startTime, i = n > o.endTime;
			r || i ? (e.textContent = (l.venueWarning || "Venue hours are ${startTime}–${endTime}. The venue will be widened to accommodate this change.").replace("${startTime}", o.startTime).replace("${endTime}", o.endTime), e.style.display = "block") : e.style.display = "none";
		})(r, i);
	}
	function C() {
		y?.destroy && y.destroy(), p.remove();
	}
}
//#endregion
//#region src/components/temporal-grid/ui/temporalGrid.ts
var { calculateCapacityStats: NE } = m, PE = class {
	constructor(t) {
		this.control = null, this.rootElement = null, this.venueTreeElement = null, this.calendarElement = null, this.capacityElement = null, this.statsBarInstance = null, this.viewToolbarResult = null, this.datepicker = null, this.visibleCourts = /* @__PURE__ */ new Set(), this.initialSnapshot = "", this.isDirty = !1, this.handleEngineEvent = (e) => {
			e.type === "BLOCKS_CHANGED" && (this.updateCapacityStats(), this.updateStatsBar(), this.checkDirtyState(), this.config.onMutationsApplied && this.config.onMutationsApplied(e.payload.mutations)), e.type === "AVAILABILITY_CHANGED" && this.checkDirtyState();
		}, this.handleBlockSelected = (e) => {}, this.handleCourtSelected = (e) => {}, this.handleTimeRangeSelected = (e) => {}, this.handleCourtCheckboxChange = (e) => {
			let t = e.target, n = t.dataset.courtId, r = t.dataset.venueId, i = t.dataset.tournamentId;
			if (!n || !r || !i) return;
			let a = `${i}|${r}|${n}`;
			t.checked ? this.visibleCourts.add(a) : this.visibleCourts.delete(a), this.updateVenueCheckboxState(r);
			let o = new Set(this.visibleCourts);
			this.control?.setVisibleCourts(o);
		}, this.handleVenueCheckboxChange = (e) => {
			let t = e.target, n = t.dataset.venue, r = t.dataset.tournamentId;
			if (!n || !r) return;
			this.engine.listCourtMeta().filter((e) => e.ref.venueId === n).forEach((e) => {
				let n = `${e.ref.tournamentId}|${e.ref.venueId}|${e.ref.courtId}`;
				t.checked ? this.visibleCourts.add(n) : this.visibleCourts.delete(n);
			}), (this.venueTreeElement?.querySelectorAll(`.court-checkbox[data-venue-id="${n}"]`))?.forEach((e) => {
				e.checked = t.checked;
			});
			let i = new Set(this.visibleCourts);
			this.control?.setVisibleCourts(i);
		}, this.config = {
			showVenueTree: !0,
			showCapacity: !0,
			showToolbar: !0,
			groupingMode: "BY_VENUE",
			showConflicts: !0,
			showSegmentLabels: !1,
			...t
		}, this.engine = new e(), this.engine.init(t.tournamentRecord, t.engineConfig), this.initialSnapshot = this.takeSnapshot(), this.engine.subscribe(this.handleEngineEvent);
	}
	render(e) {
		e.innerHTML = "", this.rootElement = this.createRootElement(), e.appendChild(this.rootElement), this.config.showToolbar && this.renderToolbar(), this.config.showCapacity && this.renderCapacityIndicator();
		let t = this.rootElement.querySelector(".temporal-grid-main");
		if (!t) return;
		let n = document.createElement("div");
		n.className = "temporal-grid-layout", t.appendChild(n), this.config.showVenueTree && this.renderVenueTree(n), this.renderCalendar(n), this.calendarElement && (this.control = new wE(this.engine, {
			container: this.calendarElement,
			initialDay: this.config.initialDay,
			initialView: this.config.initialView,
			groupingMode: this.config.groupingMode,
			showConflicts: this.config.showConflicts,
			showSegmentLabels: this.config.showSegmentLabels,
			onBlockSelected: this.handleBlockSelected,
			onCourtSelected: this.handleCourtSelected,
			onTimeRangeSelected: this.handleTimeRangeSelected,
			onBlocksChanged: () => {
				this.updateCapacityStats(), this.updateStatsBar();
			},
			onDayNavigate: (e) => {
				this.viewToolbarResult?.setActiveView("day"), this.viewToolbarResult?.setDate(e), this.datepicker && this.datepicker.setDate(e, { clear: !0 }), this.updateCapacityStats(), this.updateStatsBar();
			}
		}), this.config.showToolbar && this.initDatepicker());
	}
	destroy() {
		this.datepicker &&= (this.datepicker.destroy(), null), this.control &&= (this.control.destroy(), null), this.rootElement && this.rootElement.parentNode && this.rootElement.parentNode.removeChild(this.rootElement), this.rootElement = null, this.venueTreeElement = null, this.calendarElement = null, this.capacityElement = null, this.viewToolbarResult = null;
	}
	createRootElement() {
		let e = document.createElement("div");
		return e.className = "temporal-grid-root", e.innerHTML = "\n      <div class=\"temporal-grid-header\"></div>\n      <div class=\"temporal-grid-main\"></div>\n    ", e;
	}
	renderToolbar() {
		let e = this.rootElement?.querySelector(".temporal-grid-header");
		if (!e) return;
		let t = this.config.labels;
		this.viewToolbarResult = aE((e) => this.control?.setViewPreset(e), this.config.initialView || "day", (e) => this.handleDateChange(e), {
			labels: t,
			onSetDefaultAvailability: this.config.onSetDefaultAvailability,
			onSave: this.config.onSave
		}), e.appendChild(this.viewToolbarResult.element);
		let n = this.engine.getActiveDays(), r = this.config.initialDay || (n.length > 0 ? n[0] : "");
		r && this.viewToolbarResult.setDate(r), this.statsBarInstance = TE(t), e.appendChild(this.statsBarInstance.element);
	}
	initDatepicker() {
		if (this.datepicker || !this.viewToolbarResult) return;
		let e = this.engine.getActiveDays(), t = new Set(e);
		this.datepicker = new gn(this.viewToolbarResult.dateInput, {
			format: "yyyy-mm-dd",
			language: this.config.language || "en",
			autohide: !0,
			beforeShowDay: (e) => {
				let n = e.getFullYear(), r = String(e.getMonth() + 1).padStart(2, "0"), i = String(e.getDate()).padStart(2, "0");
				return t.has(`${n}-${r}-${i}`) ? { classes: "tg-datepicker-active-day" } : {};
			}
		});
		let n = this.config.initialDay || (e.length > 0 ? e[0] : "");
		n && this.datepicker.setDate(n, { clear: !0 });
	}
	handleDateChange(e) {
		let t = this.engine.getActiveDays();
		if (t.length === 0) return;
		let n = e;
		t.includes(e) || (n = t.reduce((t, n) => Math.abs(new Date(n).getTime() - new Date(e).getTime()) < Math.abs(new Date(t).getTime() - new Date(e).getTime()) ? n : t, t[0])), this.control?.setDay(n), this.updateCapacityStats(), this.updateStatsBar(), this.viewToolbarResult && this.viewToolbarResult.setDate(n), this.datepicker && this.datepicker.setDate(n, { clear: !0 });
	}
	renderCapacityIndicator() {
		let e = this.rootElement?.querySelector(".temporal-grid-header");
		if (!e) return;
		let t = this.config.labels, n = t?.courtAvailability ?? "Court Availability", r = t?.totalHours ?? "Total Hours", i = t?.avgPerCourt ?? "Avg/Court", a = document.createElement("div");
		a.className = "temporal-grid-capacity", a.innerHTML = `
      <div class="capacity-label">${n}:</div>
      <div class="capacity-stats">
        <div class="stat">
          <span class="stat-label">${r}:</span>
          <span class="stat-value" id="total-hours">-</span>
        </div>
        <div class="stat">
          <span class="stat-label">${i}:</span>
          <span class="stat-value" id="avg-hours">-</span>
        </div>
      </div>
    `, e.appendChild(a), this.capacityElement = a, this.updateCapacityStats();
	}
	renderVenueTree(e) {
		let t = document.createElement("div");
		t.className = "temporal-grid-venue-tree", t.innerHTML = "\n      <div class=\"tree-header\">\n        <h3>Venues & Courts</h3>\n      </div>\n      <div class=\"tree-content\" id=\"venue-tree-content\">\n        <!-- Tree will be populated dynamically -->\n      </div>\n    ", e.appendChild(t), this.venueTreeElement = t, this.updateVenueTree();
	}
	renderCalendar(e) {
		let t = document.createElement("div");
		t.className = "temporal-grid-calendar", e.appendChild(t), this.calendarElement = t;
	}
	takeSnapshot() {
		let e = this.engine.getActiveDays(), t = this.engine.listCourtMeta(), n = [];
		for (let r of e) {
			let e = this.engine.getDayBlocks(r).map((e) => ({
				id: e.id,
				type: e.type,
				start: e.start,
				end: e.end,
				court: `${e.court?.venueId}|${e.court?.courtId}`
			})), i = t.map((e) => {
				let t = this.engine.getCourtAvailability(e.ref, r);
				return {
					ref: `${e.ref.venueId}|${e.ref.courtId}`,
					s: t.startTime,
					e: t.endTime
				};
			});
			n.push({
				day: r,
				blocks: e,
				avails: i
			});
		}
		return JSON.stringify(n);
	}
	checkDirtyState() {
		let e = this.takeSnapshot(), t = this.isDirty;
		this.isDirty = e !== this.initialSnapshot, this.isDirty !== t && (this.viewToolbarResult?.setSaveEnabled(this.isDirty), this.config.onDirtyChange && this.config.onDirtyChange(this.isDirty));
	}
	resetDirtyState() {
		this.initialSnapshot = this.takeSnapshot(), this.isDirty = !1, this.viewToolbarResult?.setSaveEnabled(!1), this.config.onDirtyChange && this.config.onDirtyChange(!1);
	}
	updateStatsBar() {
		if (!this.statsBarInstance || !this.control) return;
		let e = this.control.getViewDays();
		if (e.length === 0) return;
		let t = 0, n = 0, r = 0, i = 0;
		for (let a of e) {
			let e = NE(this.engine.getCapacityCurve(a));
			t += e.totalCourtHours, n += e.totalUnavailableHours ?? 0, r += e.totalAvailableHours ?? 0, i = e.totalCourts ?? 0;
		}
		let a = i || 1;
		this.statsBarInstance.update({
			totalHours: t,
			blockedHours: n,
			availableHours: r,
			avgPerCourt: r / a
		});
	}
	updateCapacityStats() {
		if (!this.capacityElement || !this.control) return;
		let e = this.control.getViewDays();
		if (e.length === 0) return;
		let t = 0, n = 0;
		for (let r of e) {
			let e = NE(this.engine.getCapacityCurve(r));
			t += e.totalAvailableHours ?? 0, n = e.totalCourts ?? 0;
		}
		let r = this.capacityElement.querySelector("#total-hours"), i = this.capacityElement.querySelector("#avg-hours");
		r && (r.textContent = `${t.toFixed(1)}h`);
		let a = n > 0 ? t / n : 0;
		i && (i.textContent = `${a.toFixed(1)}h`);
	}
	updateVenueTree() {
		if (!this.venueTreeElement) return;
		let e = this.venueTreeElement.querySelector("#venue-tree-content");
		if (!e) return;
		let t = this.engine.listCourtMeta(), n = this.engine.getConfig().tournamentId;
		this.visibleCourts.size === 0 && t.forEach((e) => {
			let t = `${e.ref.tournamentId}|${e.ref.venueId}|${e.ref.courtId}`;
			this.visibleCourts.add(t);
		});
		let r = /* @__PURE__ */ new Map();
		for (let e of this.config.tournamentRecord?.venues || []) {
			let t = e.venueId;
			t && r.set(t, e.venueName || e.venueAbbreviation || t);
		}
		let i = /* @__PURE__ */ new Map();
		for (let e of t) {
			let t = e.ref.venueId;
			i.has(t) || i.set(t, []), i.get(t).push(e);
		}
		let a = "";
		for (let [e, t] of i) {
			let i = t.every((e) => {
				let t = `${e.ref.tournamentId}|${e.ref.venueId}|${e.ref.courtId}`;
				return this.visibleCourts.has(t);
			}), o = r.get(e) || e;
			a += `
        <div class="venue-group">
          <div class="venue-header">
            <input type="checkbox" class="venue-checkbox"
                   data-venue="${e}"
                   data-tournament-id="${n}"
                   ${i ? "checked" : ""} />
            <span class="venue-name">${o}</span>
            <button class="sp-btn-icon sp-btn-icon--ghost venue-edit-icon"
                    data-venue="${e}" data-tournament-id="${n}"
                    data-venue-name="${o}"
                    title="Edit venue defaults">&#9998;</button>
          </div>
          <div class="courts-list">
            ${t.map((e) => {
				let t = `${e.ref.tournamentId}|${e.ref.venueId}|${e.ref.courtId}`, n = this.visibleCourts.has(t);
				return `
                <div class="court-item">
                  <input type="checkbox" class="court-checkbox"
                         data-court-id="${e.ref.courtId}"
                         data-venue-id="${e.ref.venueId}"
                         data-tournament-id="${e.ref.tournamentId}"
                         ${n ? "checked" : ""} />
                  <span class="court-name">${e.name}</span>
                  <span class="court-meta">${e.surface}${e.indoor ? " (Indoor)" : ""}</span>
                  <button class="sp-btn-icon sp-btn-icon--ghost court-edit-icon"
                          data-court-id="${e.ref.courtId}" data-venue-id="${e.ref.venueId}"
                          data-tournament-id="${e.ref.tournamentId}"
                          data-court-name="${e.name}"
                          title="Edit court availability">&#9998;</button>
                </div>
              `;
			}).join("")}
          </div>
        </div>
      `;
		}
		e.innerHTML = a, e.querySelectorAll(".court-checkbox").forEach((e) => {
			e.addEventListener("change", this.handleCourtCheckboxChange);
		}), e.querySelectorAll(".venue-checkbox").forEach((e) => {
			e.addEventListener("change", this.handleVenueCheckboxChange);
		}), e.querySelectorAll(".venue-edit-icon").forEach((e) => {
			e.addEventListener("click", (e) => {
				e.stopPropagation();
				let t = e.currentTarget, n = t.dataset.venue, r = t.dataset.tournamentId, i = t.dataset.venueName || n, a = this.control?.getDay() || this.engine.getActiveDays()[0] || "2026-01-01", o = this.engine.getVenueAvailability(r, n), s = this.engine.getConfig();
				ME({
					title: `Venue Defaults \u2014 ${i}`,
					currentDay: a,
					currentStartTime: o?.startTime || s.dayStartTime,
					currentEndTime: o?.endTime || s.dayEndTime,
					showScopeToggle: !1,
					onConfirm: ({ startTime: e, endTime: t }) => {
						this.engine.setVenueDefaultAvailability(r, n, {
							startTime: e,
							endTime: t
						}), this.engine.clearCourtAvailabilityForVenue(r, n), this.control?.refresh();
					}
				});
			});
		}), e.querySelectorAll(".court-edit-icon").forEach((e) => {
			e.addEventListener("click", (e) => {
				e.stopPropagation();
				let t = e.currentTarget, n = t.dataset.courtId, r = t.dataset.venueId, i = t.dataset.tournamentId, a = t.dataset.courtName || n, o = {
					tournamentId: i,
					venueId: r,
					courtId: n
				}, s = this.control?.getDay() || this.engine.getActiveDays()[0] || "2026-01-01", c = this.engine.getCourtAvailability(o, s);
				ME({
					title: `Court \u2014 ${a}`,
					currentDay: s,
					currentStartTime: c.startTime,
					currentEndTime: c.endTime,
					showScopeToggle: !0,
					onConfirm: ({ startTime: e, endTime: t, scope: n }) => {
						n === "all-days" ? this.engine.setCourtAvailabilityAllDays(o, {
							startTime: e,
							endTime: t
						}) : this.engine.setCourtAvailability(o, s, {
							startTime: e,
							endTime: t
						}), this.control?.refresh();
					}
				});
			});
		});
	}
	updateVenueCheckboxState(e) {
		let t = this.engine.listCourtMeta().filter((t) => t.ref.venueId === e), n = t.filter((e) => {
			let t = `${e.ref.tournamentId}|${e.ref.venueId}|${e.ref.courtId}`;
			return this.visibleCourts.has(t);
		}).length, r = this.venueTreeElement?.querySelector(`.venue-checkbox[data-venue="${e}"]`);
		r && (n === 0 ? (r.checked = !1, r.indeterminate = !1) : n === t.length ? (r.checked = !0, r.indeterminate = !1) : (r.checked = !1, r.indeterminate = !0));
	}
	getEngine() {
		return this.engine;
	}
	getControl() {
		return this.control;
	}
	setDay(e) {
		this.control?.setDay(e), this.updateCapacityStats();
	}
	refresh() {
		this.control?.refresh(), this.updateCapacityStats(), this.updateVenueTree();
	}
};
function FE(e, t) {
	let n = new PE(e);
	return n.render(t), n;
}
//#endregion
//#region src/components/topology-builder/domain/feedRounds.ts
var { LUCKY_DRAW: IE, ROUND_ROBIN: LE, AD_HOC: RE } = t;
function zE(e) {
	let t = Math.max(2, e), n = 2 ** Math.floor(Math.log2(t)), r = t - n;
	if (r <= 0) return /* @__PURE__ */ new Map();
	let i = /* @__PURE__ */ new Map(), a = 0, o = n / 2;
	for (; o >= 1;) a++, r & o && (a++, i.set(a, o)), o = Math.floor(o / 2);
	return i;
}
function BE(e) {
	let t = Math.max(2, e), n = 2 ** Math.floor(Math.log2(t)), r = t - n, i = 0, a = n / 2;
	for (; a >= 1;) i++, r & a && i++, a = Math.floor(a / 2);
	return i;
}
function VE(e) {
	let t = Math.max(2, e), n = t % 2 ? t + 1 : t, r = !!(Math.ceil(n / 2) % 2), i = [{
		participantsCount: n,
		preFeedRound: r
	}];
	for (; n > 2;) {
		let e = Math.ceil(n / 2), t = e === 1, r = !!(!t && e % 2);
		n = !t && r ? e + 1 : e;
		let a = !!(n !== 2 && Math.ceil(n / 2) % 2);
		i.push({
			participantsCount: n,
			preFeedRound: a,
			feedRound: r
		});
	}
	return i;
}
function HE(e) {
	let t = Math.max(2, e);
	return t & t - 1 ? VE(e).length : Math.ceil(Math.log2(t));
}
function UE(e, t) {
	let n = Math.max(2, e);
	if (!(n & n - 1)) return Math.floor(n / 2 ** t);
	let r = VE(e), i = t - 1;
	if (i < 0 || i >= r.length) return 0;
	let { participantsCount: a, preFeedRound: o } = r[i], s = a / 2, c = o ? s - 1 : s;
	if (t === 1 && n % 2 != 0) {
		let e = a - n;
		c -= e;
	}
	return c;
}
function WE(e, t, n) {
	return e === LE ? (n?.groupSize || Math.min(t, 4)) - 1 : e === RE ? n?.roundsCount || 1 : e === IE ? HE(t) : BE(t);
}
function GE(e, t, n) {
	return e === IE ? UE(t, n) : Math.floor(t / 2 ** n);
}
//#endregion
//#region src/components/topology-builder/domain/previewGenerator.ts
var { ROUND_ROBIN: KE, AD_HOC: qE, LUCKY_DRAW: JE } = t, YE = 0;
function XE({ structureType: e, drawSize: t, stage: n, structureId: r, qualifyingPositions: i, structureOptions: a }) {
	return e === KE ? QE({
		drawSize: t,
		stage: n,
		structureId: r,
		structureOptions: a
	}) : e === qE ? eD({
		drawSize: t,
		stage: n,
		structureId: r,
		roundsCount: a?.roundsCount || 1
	}) : e === JE ? $E({
		drawSize: t,
		stage: n,
		structureId: r
	}) : ZE({
		drawSize: t,
		stage: n,
		structureId: r,
		qualifyingPositions: i
	});
}
function ZE({ drawSize: e, stage: t, structureId: n, qualifyingPositions: r }) {
	let i = Math.max(2, e), a = 2 ** Math.floor(Math.log2(i)), o = i - a, s = [], c = a / 2;
	for (; c >= 1;) s.push({
		count: c,
		isFeed: !1
	}), o & c && s.push({
		count: c,
		isFeed: !0
	}), c = Math.floor(c / 2);
	if (r && r > 0 && e > r) {
		let t = Math.round(Math.log2(e / r));
		t > 0 && s.length > t && (s.length = t);
	}
	let l = s.length, u = [], d = 1, f = 0, p = /* @__PURE__ */ new Set();
	for (let e = 0; e < l - 1; e++) !s[e].isFeed && s[e + 1].isFeed && p.add(e);
	for (let e = 0; e < l; e++) {
		let { count: r, isFeed: i } = s[e], a = e + 1, o = i ? 2 ** Math.max(0, f - 1) : 2 ** f, c = i || p.has(e);
		for (let s = 1; s <= r; s++) {
			let r = a === 1 && !i;
			u.push({
				matchUpId: `preview-${++YE}`,
				roundNumber: a,
				roundPosition: s,
				drawPositions: r ? [(s - 1) * 2 + 1, (s - 1) * 2 + 2] : i ? [d++] : [],
				finishingRound: l - e,
				roundFactor: o,
				preFeedRound: c,
				stage: t,
				structureId: n
			});
		}
		i || f++;
	}
	return u;
}
function QE({ drawSize: e, stage: t, structureId: n, structureOptions: r }) {
	let i = [], a = r?.groupSize || Math.min(e, 4), o = Math.ceil(e / a), s = a - 1;
	for (let e = 0; e < o; e++) for (let r = 1; r <= s; r++) {
		let o = Math.floor(a / 2);
		for (let a = 1; a <= o; a++) i.push({
			matchUpId: `preview-${++YE}`,
			roundNumber: r,
			roundPosition: e * o + a,
			isRoundRobin: !0,
			stage: t,
			structureId: `${n}-g${e}`
		});
	}
	return i;
}
function $E({ drawSize: e, stage: t, structureId: n }) {
	let r = Math.max(2, e);
	if (!(r & r - 1)) return ZE({
		drawSize: e,
		stage: t,
		structureId: n
	});
	let i = VE(r), a = i.length, o = [], s = 1;
	for (let e = 0; e < a; e++) {
		let { participantsCount: r, preFeedRound: c } = i[e], l = r / 2, u = e + 1;
		for (let r = 1; r <= l; r++) {
			let i = u === 1;
			o.push({
				matchUpId: `preview-${++YE}`,
				roundNumber: u,
				roundPosition: r,
				drawPositions: i ? [s++, s++] : [],
				finishingRound: a - e,
				roundFactor: 1,
				preFeedRound: !!c,
				stage: t,
				structureId: n
			});
		}
	}
	return o;
}
function eD({ drawSize: e, stage: t, structureId: n, roundsCount: r = 1 }) {
	let i = [];
	if (e < 2) return i;
	let a = Math.floor(e / 2);
	for (let e = 1; e <= r; e++) for (let r = 1; r <= a; r++) i.push({
		matchUpId: `preview-${++YE}`,
		roundNumber: e,
		roundPosition: r,
		finishingRound: 1,
		stage: t,
		structureId: n
	});
	return i;
}
//#endregion
//#region src/components/topology-builder/domain/playoffProfilesCache.ts
var { ROUND_ROBIN: tD } = t, nD = /* @__PURE__ */ new Map();
function rD(e, t, n) {
	let r = `${e}:${t}:${n || ""}`, i = nD.get(r);
	if (i) return i;
	try {
		let i = {
			drawSize: t,
			drawType: e
		};
		n && (i.structureOptions = { groupSize: n });
		let { tournamentRecord: a } = d.generateTournamentRecord({ drawProfiles: [i] });
		g.setState(a);
		let o = a?.events?.[0]?.drawDefinitions?.[0];
		if (!o) return iD(r, {});
		let s = o.drawId, c = (o.structures || [])[0];
		if (!c) return iD(r, {});
		let l = c.structureType === "CONTAINER", u = {};
		if (l || e === tD) {
			let { availablePlayoffProfiles: e } = g.getAvailablePlayoffProfiles({ drawId: s }), t = e?.[0];
			t && (u = {
				playoffFinishingPositionRanges: t.playoffFinishingPositionRanges,
				finishingPositionsAvailable: t.finishingPositionsAvailable
			});
		} else {
			let e = c.structureId, { playoffRounds: t, playoffRoundsRanges: n } = g.getAvailablePlayoffProfiles({
				drawId: s,
				structureId: e
			});
			u = {
				playoffRounds: t,
				playoffRoundsRanges: n
			};
		}
		return iD(r, u);
	} catch {
		return iD(r, {});
	}
}
function iD(e, t) {
	return nD.set(e, t), t;
}
//#endregion
//#region src/components/topology-builder/ui/structureCard.ts
var { MAIN: aD, QUALIFYING: oD, CONSOLATION: sD, PLAY_OFF: cD, ROUND_ROBIN: lD, AD_HOC: uD, LUCKY_DRAW: dD, WINNER: fD, LOSER: pD } = t, mD = 240, hD = 48, gD = 16;
function _D(e) {
	if (e.structureType === lD) return (e.structureOptions?.groupSize || Math.min(e.drawSize, 4)) - 1;
	if (e.structureType === uD) return e.structureOptions?.roundsCount || 1;
	if (e.structureType === dD) return HE(e.drawSize);
	let t = Math.max(2, e.drawSize), n = 2 ** Math.floor(Math.log2(t)), r = t - n, i = 0, a = n / 2;
	for (; a >= 1;) i++, r & a && i++, a = Math.floor(a / 2);
	if (e.qualifyingPositions && e.qualifyingPositions > 0 && e.drawSize > e.qualifyingPositions) {
		let t = Math.round(Math.log2(e.drawSize / e.qualifyingPositions));
		t > 0 && t < i && (i = t);
	}
	return i;
}
function vD(e) {
	let t = _D(e);
	return Math.max(mD, t * hD + gD);
}
var yD = {
	[aD]: "tb-card-badge--main",
	[oD]: "tb-card-badge--qualifying",
	[sD]: "tb-card-badge--consolation",
	[cD]: "tb-card-badge--playoff"
};
function bD(e, t, n, r, i, a, o, s) {
	let c = a && a.length > 0, l = document.createElement("div");
	l.className = `tb-card${n ? " tb-card--selected" : ""}${c ? " tb-card--warning" : ""}`, l.style.left = `${e.position.x}px`, l.style.top = `${e.position.y}px`, l.style.minWidth = `${vD(e)}px`, l.setAttribute("data-node-id", e.id);
	let u = document.createElement("div");
	u.className = "tb-card-header";
	let d = document.createElement("span");
	d.className = `tb-card-badge ${yD[e.stage] || "tb-card-badge--main"}`, d.textContent = e.stage.substring(0, 4);
	let f = document.createElement("span");
	f.className = "tb-card-name", f.textContent = e.structureName;
	let p = document.createElement("span");
	if (p.className = "tb-card-size", p.textContent = `\u00d7${e.drawSize}`, u.appendChild(d), u.appendChild(f), u.appendChild(p), o) {
		let e = document.createElement("div");
		e.className = "tb-card-advance", e.textContent = o, u.appendChild(e);
	}
	let m = document.createElement("div");
	m.className = "tb-card-preview";
	let h = e.matchUps || XE({
		structureType: e.structureType,
		drawSize: e.drawSize,
		stage: e.stage,
		structureId: e.id,
		qualifyingPositions: e.qualifyingPositions,
		structureOptions: e.structureOptions
	});
	if (h.length > 0) try {
		let t = Ti({
			matchUps: h,
			structureId: e.id,
			showHeaders: !1
		});
		t.style.transform = "scale(0.8)", t.style.transformOrigin = "top left", m.appendChild(t);
	} catch {
		m.textContent = `${e.structureType} \u00d7${e.drawSize}`, m.style.cssText += "font-size:11px;color:var(--chc-text-muted);display:flex;align-items:center;justify-content:center;";
	}
	if (i?.length && m.querySelector(".chc-schematic-structure")) {
		let e = m.querySelectorAll(".chc-schematic-round-container[data-round-number]");
		for (let n of e) {
			let e = parseInt(n.getAttribute("data-round-number") || "0"), r = i.filter((t) => t.roundNumber === e);
			if (!r.length) continue;
			let a = r.find((e) => e.isSelected) || r.find((e) => e.linkType === pD) || r.find((e) => e.linkType === fD) || r[0];
			n.classList.add("tb-round-linked"), n.classList.add(`tb-round-linked--${a.linkType.toLowerCase()}`), n.classList.add(`tb-round-linked--${a.direction}`), a.isSelected && n.classList.add("tb-round-linked--active"), n.style.cursor = "pointer", n.addEventListener("click", (e) => {
				e.stopPropagation(), t.onSelectEdge(a.edgeId);
			}), n.title = r.map((t) => `R${e} ${t.linkType} ${t.direction === "source" ? "out" : "in"}`).join(", ");
		}
	}
	let g = rD(e.structureType, e.drawSize, e.structureOptions?.groupSize), _ = null;
	g.playoffRoundsRanges?.length ? (_ = document.createElement("div"), _.className = "tb-card-rounds", _.textContent = g.playoffRoundsRanges.map((e) => `R${e.roundNumber}:${e.finishingPositionRange}`).join(" ")) : g.playoffFinishingPositionRanges?.length && (_ = document.createElement("div"), _.className = "tb-card-rounds", _.textContent = g.playoffFinishingPositionRanges.map((e) => `P${e.finishingPosition}:${e.finishingPositionRange}`).join(" "));
	let v = document.createElement("div");
	v.className = "tb-card-ports";
	let y = document.createElement("div");
	y.className = "tb-port tb-port--input", y.title = "Input", y.addEventListener("mouseup", () => {
		t.onPortMouseUp(e.id);
	});
	let b = document.createElement("div");
	b.className = "tb-port-group";
	let x = document.createElement("div");
	x.className = `tb-port tb-port--winner${r ? " tb-port--connected" : ""}`, x.title = r ? "Winner linked" : "Winner output", r || x.addEventListener("mousedown", (n) => {
		n.stopPropagation(), t.onPortMouseDown(e.id, "winner");
	});
	let S = document.createElement("div");
	if (S.className = "tb-port tb-port--loser", S.title = "Loser output", S.addEventListener("mousedown", (n) => {
		n.stopPropagation(), t.onPortMouseDown(e.id, "loser");
	}), b.appendChild(x), b.appendChild(S), v.appendChild(y), v.appendChild(b), l.appendChild(u), l.appendChild(m), s?.length) {
		let e = document.createElement("div");
		e.className = "tb-card-chips";
		for (let n of s) {
			let r = document.createElement("span");
			r.className = "tb-card-chip", r.textContent = `P${n.position}`, r.title = `Position ${n.position} → ${n.targetName}`, r.addEventListener("click", (e) => {
				e.stopPropagation(), t.onSelectEdge(n.edgeId);
			}), e.appendChild(r);
		}
		l.appendChild(e);
	}
	if (_ && l.appendChild(_), c) {
		let e = document.createElement("div");
		e.className = "tb-card-warning", e.textContent = "⚠ Issue";
		let t = document.createElement("div");
		t.className = "tb-card-warning-detail", t.textContent = a.join("; "), e.appendChild(t), e.addEventListener("click", (t) => {
			t.stopPropagation(), e.classList.toggle("tb-card-warning--open");
		}), l.appendChild(e);
	}
	return l.appendChild(v), l.addEventListener("mouseup", () => {
		t.onPortMouseUp(e.id);
	}), l.addEventListener("click", (n) => {
		n.stopPropagation(), t.onSelect(e.id);
	}), t.onDoubleClick && l.addEventListener("dblclick", (n) => {
		n.stopPropagation(), t.onDoubleClick(e.id);
	}), l.addEventListener("mousedown", (n) => {
		n.target.classList.contains("tb-port") || t.onDragStart(e.id, n.clientX, n.clientY);
	}), l;
}
function xD(e, t) {
	let n = vD(e);
	switch (t) {
		case "input": return {
			x: e.position.x,
			y: e.position.y + 160 / 2
		};
		case "winner": return {
			x: e.position.x + n,
			y: e.position.y + 160 / 2 - 8
		};
		case "loser": return {
			x: e.position.x + n,
			y: e.position.y + 160 / 2 + 8
		};
	}
}
//#endregion
//#region src/components/topology-builder/engine/topologyStore.ts
var { MAIN: SD, QUALIFYING: CD, CONSOLATION: wD, WINNER: TD, LOSER: ED, ROUND_ROBIN: DD } = t, OD = "POSITION", kD = 0;
function AD(e) {
	return `${e}-${++kD}-${Date.now().toString(36)}`;
}
function jD(e) {
	let t = 2;
	for (; t * 2 <= e;) t *= 2;
	return t;
}
var MD = 160, ND = 60, PD = 30, FD = class {
	constructor(e) {
		this.listeners = /* @__PURE__ */ new Set(), this.state = {
			nodes: [],
			edges: [],
			selectedNodeId: null,
			selectedEdgeId: null,
			drawName: "New Draw",
			...e
		};
	}
	getState() {
		return { ...this.state };
	}
	subscribe(e) {
		return this.listeners.add(e), () => this.listeners.delete(e);
	}
	notify() {
		let e = this.getState();
		for (let t of this.listeners) t(e);
	}
	setDrawName(e) {
		this.state.drawName = e, this.notify();
	}
	addNode(e) {
		let t = {
			...e,
			id: AD("node"),
			position: this.nextNodePosition()
		};
		return this.state.nodes.push(t), this.state.templateName = void 0, this.notify(), t;
	}
	updateNode(e, t) {
		let n = this.state.nodes.find((t) => t.id === e);
		n && (Object.keys(t).some((e) => e !== "position") && (this.state.templateName = void 0), Object.assign(n, t), this.notify());
	}
	removeNode(e) {
		let t = this.state.edges.filter((t) => t.sourceNodeId === e).map((e) => e.targetNodeId);
		this.state.nodes = this.state.nodes.filter((t) => t.id !== e), this.state.edges = this.state.edges.filter((t) => t.sourceNodeId !== e && t.targetNodeId !== e), this.state.selectedNodeId === e && (this.state.selectedNodeId = null), this.state.templateName = void 0;
		for (let e of t) this.clampConsolationDrawSize(e);
		this.notify();
	}
	addEdge(e) {
		if (e.linkType === TD && this.state.edges.find((t) => t.sourceNodeId === e.sourceNodeId && t.linkType === TD)) return null;
		let t = this.state.nodes.find((t) => t.id === e.sourceNodeId), n = this.state.nodes.find((t) => t.id === e.targetNodeId);
		if (t?.structureType === DD && e.linkType !== OD || t?.stage === CD && n && n.stage !== CD && n.stage !== SD || n?.stage === CD && t && t.stage !== CD) return null;
		let r = {
			...e,
			id: AD("edge"),
			targetRoundNumber: e.targetRoundNumber || 1,
			label: this.computeEdgeLabel(e)
		};
		return this.state.edges.push(r), this.state.templateName = void 0, this.clampConsolationDrawSize(r.targetNodeId), this.notify(), r;
	}
	updateEdge(e, t) {
		let n = this.state.edges.find((t) => t.id === e);
		n && (Object.assign(n, t), n.label = this.computeEdgeLabel(n), this.state.templateName = void 0, this.notify());
	}
	removeEdge(e) {
		let t = this.state.edges.find((t) => t.id === e);
		this.state.edges = this.state.edges.filter((t) => t.id !== e), this.state.selectedEdgeId === e && (this.state.selectedEdgeId = null), this.state.templateName = void 0, t && this.clampConsolationDrawSize(t.targetNodeId), this.notify();
	}
	selectNode(e) {
		this.state.selectedNodeId = e, this.state.selectedEdgeId = null, this.notify();
	}
	selectEdge(e) {
		this.state.selectedEdgeId = e, this.state.selectedNodeId = null, this.notify();
	}
	clampConsolationDrawSize(e) {
		let t = this.state.nodes.find((t) => t.id === e);
		if (!t || t.stage !== wD) return;
		let n = this.inboundCapacity(e);
		n > 0 && t.drawSize > n && (t.drawSize = jD(n));
	}
	inboundCapacity(e) {
		let t = this.state.edges.filter((t) => t.targetNodeId === e), n = 0;
		for (let e of t) {
			let t = this.state.nodes.find((t) => t.id === e.sourceNodeId);
			if (t) if (e.linkType === ED) {
				let r = e.sourceRoundNumber || 1;
				n += GE(t.structureType, t.drawSize, r);
			} else n += t.qualifyingPositions || Math.floor(t.drawSize / 2);
		}
		return n;
	}
	nextNodePosition() {
		if (this.state.nodes.length === 0) return {
			x: 40,
			y: 40
		};
		let e = 0;
		for (let t of this.state.nodes) e = Math.max(e, t.position.x + vD(t));
		return {
			x: e + ND,
			y: 40
		};
	}
	autoLayout() {
		let e = this.state.nodes, t = this.state.edges;
		if (!e.length) return;
		let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
		for (let e of t) r.has(e.sourceNodeId) || r.set(e.sourceNodeId, []), r.get(e.sourceNodeId).push(e.targetNodeId), n.has(e.targetNodeId) || n.set(e.targetNodeId, []), n.get(e.targetNodeId).push(e.sourceNodeId);
		let i = e.filter((e) => !n.has(e.id) || n.get(e.id).length === 0);
		if (!i.length) {
			let t = e.filter((e) => e.stage === SD);
			i.push(...t.length ? t : [e[0]]);
		}
		let a = /* @__PURE__ */ new Map(), o = new Set(e.filter((e) => e.stage === CD).map((e) => e.id)), s = [];
		for (let e of i) o.has(e.id) ? a.set(e.id, -1) : a.set(e.id, 0), s.push(e.id);
		for (; s.length;) {
			let e = s.shift(), t = a.get(e), n = r.get(e) || [];
			for (let e of n) {
				let n = t + 1, r = a.get(e);
				(r === void 0 || n > r) && (a.set(e, n), s.push(e));
			}
		}
		for (let t of e) a.has(t.id) || a.set(t.id, 0);
		let c = Math.min(...a.values());
		if (c < 0) for (let [e, t] of a) a.set(e, t - c);
		let l = /* @__PURE__ */ new Map();
		for (let t of e) {
			let e = a.get(t.id);
			l.has(e) || l.set(e, []), l.get(e).push(t);
		}
		let u = [...l.keys()].sort((e, t) => e - t), d = 40;
		for (let e of u) {
			let t = l.get(e), n = Math.max(...t.map((e) => vD(e)));
			t.forEach((e, t) => {
				e.position = {
					x: d,
					y: t * (MD + PD) + 40
				};
			}), d += n + ND;
		}
	}
	loadState(e) {
		this.state = { ...e }, this.notify();
	}
	computeEdgeLabel(e) {
		let t = e.linkType || "LINK", n = "";
		return e.sourceRoundNumber && (n += `R${e.sourceRoundNumber} `), n += t.toLowerCase(), e.targetRoundNumber && (n += ` \u2192 R${e.targetRoundNumber}`), e.qualifyingPositions && (n += ` (${e.qualifyingPositions}Q)`), e.finishingPositions?.length && (n += ` [${e.finishingPositions.join(",")}]`), n;
	}
}, { WINNER: ID, LOSER: LD, QUALIFYING: RD, CONSOLATION: zD, ROUND_ROBIN: BD } = t, VD = "POSITION", HD = (e) => e === BD;
function UD(e, t) {
	if (!HD(e.structureType)) return;
	let n = t.edges.filter((t) => t.sourceNodeId === e.id && t.linkType === VD);
	if (!n.length) return;
	let r = new Set(n.flatMap((e) => e.finishingPositions || [])), i = e.structureOptions?.groupSize || 4;
	return `${r.size} of ${i} advance`;
}
var WD = "http://www.w3.org/2000/svg", GD = {
	[ID]: "tb-edge--winner",
	[LD]: "tb-edge--loser",
	[VD]: "tb-edge--position"
};
function KD(e) {
	let t = document.createElement("div");
	t.className = "tb-canvas";
	let n = document.createElementNS(WD, "svg");
	n.classList.add("tb-canvas-svg");
	let r = document.createElementNS(WD, "defs");
	for (let [e, t] of Object.entries(GD)) {
		let n = document.createElementNS(WD, "marker");
		n.setAttribute("id", `arrowhead-${e}`), n.setAttribute("markerWidth", "8"), n.setAttribute("markerHeight", "6"), n.setAttribute("refX", "8"), n.setAttribute("refY", "3"), n.setAttribute("orient", "auto");
		let i = document.createElementNS(WD, "polygon");
		i.setAttribute("points", "0 0, 8 3, 0 6"), i.setAttribute("class", t), i.style.fill = "currentColor", n.appendChild(i), r.appendChild(n);
	}
	n.appendChild(r);
	let i = document.createElement("div");
	i.className = "tb-canvas-nodes";
	let a = document.createElement("div");
	a.className = "tb-canvas-spacer", t.appendChild(n), t.appendChild(i), t.appendChild(a);
	let o = null, s = null, c = null, l = !1, u = null;
	t.addEventListener("click", () => {
		l || (e.onSelectNode(null), e.onSelectEdge(null));
	}), t.addEventListener("mousemove", (n) => {
		if (s && !c) {
			let e = n.clientX - s.startX, t = n.clientY - s.startY;
			Math.abs(e) + Math.abs(t) >= 4 && (c = s, s = null);
		}
		if (c && u) {
			let t = n.clientX - c.startX, r = n.clientY - c.startY;
			e.onMoveNode(c.nodeId, Math.max(0, c.origX + t), Math.max(0, c.origY + r));
		}
		if (o?.tempLine) {
			let e = t.getBoundingClientRect();
			o.tempLine.setAttribute("x2", String(n.clientX - e.left + t.scrollLeft)), o.tempLine.setAttribute("y2", String(n.clientY - e.top + t.scrollTop));
		}
	}), t.addEventListener("mouseup", () => {
		c && (l = !0, c = null, setTimeout(() => {
			l = !1;
		}, 0)), s = null, o?.tempLine && (n.removeChild(o.tempLine), o = null);
	});
	function d(e) {
		return new Set(e.edges.filter((e) => e.linkType === ID).map((e) => e.sourceNodeId).filter((t) => {
			let n = e.nodes.find((e) => e.id === t);
			return n && n.stage === RD && !HD(n.structureType);
		}));
	}
	function f(e) {
		let t = /* @__PURE__ */ new Map();
		for (let n of e.edges) {
			let r = n.sourceRoundNumber, i = n.targetRoundNumber, a = n.id === e.selectedEdgeId;
			if (!r && n.linkType === ID) {
				let t = e.nodes.find((e) => e.id === n.sourceNodeId);
				t && (r = _D(t));
			}
			r && (t.has(n.sourceNodeId) || t.set(n.sourceNodeId, []), t.get(n.sourceNodeId).push({
				roundNumber: r,
				linkType: n.linkType,
				direction: "source",
				edgeId: n.id,
				isSelected: a
			})), i && (t.has(n.targetNodeId) || t.set(n.targetNodeId, []), t.get(n.targetNodeId).push({
				roundNumber: i,
				linkType: n.linkType,
				direction: "target",
				edgeId: n.id,
				isSelected: a
			}));
		}
		return t;
	}
	function p(e) {
		let t = /* @__PURE__ */ new Map();
		for (let n of e.edges) {
			if (n.linkType !== ID) continue;
			let r = n.targetRoundNumber || 1;
			if (r <= 1) continue;
			let i = e.nodes.find((e) => e.id === n.sourceNodeId);
			if (!i || i.stage !== RD) continue;
			t.has(n.targetNodeId) || t.set(n.targetNodeId, []);
			let a = i.qualifyingPositions || Math.floor(i.drawSize / 4);
			t.get(n.targetNodeId).push({
				targetRound: r,
				qp: a,
				warning: `Round ${r} needs fed drawPositions to accommodate ${i.structureName} link`
			});
		}
		let n = /* @__PURE__ */ new Map();
		for (let [r, i] of t) {
			let t = e.nodes.find((e) => e.id === r);
			if (!t) continue;
			let a = zE(t.drawSize), o = /* @__PURE__ */ new Map();
			for (let e of i) o.set(e.targetRound, (o.get(e.targetRound) || 0) + e.qp);
			let s = [];
			for (let e of i) (a.get(e.targetRound) || 0) < (o.get(e.targetRound) || 0) && s.push(e.warning);
			s.length > 0 && n.set(r, s);
		}
		return n;
	}
	function m(e) {
		let t = /* @__PURE__ */ new Map();
		for (let n of e.nodes) {
			if (!HD(n.structureType)) continue;
			let r = e.edges.filter((e) => e.sourceNodeId === n.id && e.linkType === VD);
			if (!r.length) continue;
			let i = [];
			for (let t of r) {
				let n = e.nodes.find((e) => e.id === t.targetNodeId);
				for (let e of t.finishingPositions || []) i.push({
					position: e,
					edgeId: t.id,
					targetName: n?.structureName || "?"
				});
			}
			i.sort((e, t) => e.position - t.position), t.set(n.id, i);
		}
		return t;
	}
	function h(e, t, n) {
		return e && HD(e.structureType) ? VD : n === "loser" || t?.stage === zD ? LD : ID;
	}
	function g(t) {
		return {
			onSelect: (t) => {
				e.onSelectNode(t);
			},
			onSelectEdge: (t) => {
				e.onSelectEdge(t);
			},
			onDoubleClick: e.onDoubleClickNode ? (t) => e.onDoubleClickNode(t) : void 0,
			onPortMouseDown: (e, r) => {
				let i = t.nodes.find((t) => t.id === e);
				if (!i) return;
				let a = xD(i, r), s = document.createElementNS(WD, "line");
				s.setAttribute("x1", String(a.x)), s.setAttribute("y1", String(a.y)), s.setAttribute("x2", String(a.x)), s.setAttribute("y2", String(a.y)), s.setAttribute("stroke", r === "winner" ? "green" : "red"), s.setAttribute("stroke-width", "2"), s.setAttribute("stroke-dasharray", "4 2"), n.appendChild(s), o = {
					sourceNodeId: e,
					portType: r,
					tempLine: s
				};
			},
			onPortMouseUp: (r) => {
				if (o && o.sourceNodeId !== r) {
					let n = h(t.nodes.find((e) => e.id === o.sourceNodeId), t.nodes.find((e) => e.id === r), o.portType);
					e.onCreateEdge(o.sourceNodeId, r, n);
				}
				o?.tempLine && n.removeChild(o.tempLine), o = null;
			},
			onDragStart: (e, n, r) => {
				let i = t.nodes.find((t) => t.id === e);
				i && (s = {
					nodeId: e,
					startX: n,
					startY: r,
					origX: i.position.x,
					origY: i.position.y
				});
			}
		};
	}
	function _(e) {
		u = e, i.innerHTML = "";
		let t = d(e), r = f(e), o = p(e), s = m(e), c = g(e);
		for (let n of e.nodes) {
			let a = bD(n, c, e.selectedNodeId === n.id, t.has(n.id), r.get(n.id), o.get(n.id), UD(n, e), s.get(n.id));
			i.appendChild(a);
		}
		n.querySelectorAll("path, text.tb-edge-label, path.tb-edge-hit").forEach((e) => n.removeChild(e));
		let l = /* @__PURE__ */ new Map();
		for (let t of e.edges) {
			let e = `${t.sourceNodeId}:${t.targetNodeId}`;
			l.has(e) || l.set(e, []), l.get(e).push(t);
		}
		for (let t of l.values()) {
			let r = t.length;
			t.forEach((t, i) => {
				v(n, t, e, r > 1 ? (i - (r - 1) / 2) * 14 : 0);
			});
		}
		let h = 600, _ = 400;
		for (let t of e.nodes) h = Math.max(h, t.position.x + vD(t) + 40), _ = Math.max(_, t.position.y + 180);
		n.setAttribute("width", String(h)), n.setAttribute("height", String(_)), i.style.width = `${h}px`, i.style.height = `${_}px`, a.style.width = `${h}px`, a.style.height = `${_}px`;
	}
	function v(t, n, r, i = 0) {
		let a = r.nodes.find((e) => e.id === n.sourceNodeId), o = r.nodes.find((e) => e.id === n.targetNodeId);
		if (!a || !o) return;
		let s = xD(a, n.linkType === LD ? "loser" : "winner"), c = xD(o, "input"), l = s.y + i, u = c.y + i, d = c.x - s.x, f = `M ${s.x},${l} C ${s.x + d / 2},${l} ${s.x + d / 2},${u} ${c.x},${u}`, p = document.createElementNS(WD, "path");
		p.setAttribute("d", f), p.classList.add("tb-edge-hit"), p.addEventListener("click", (t) => {
			t.stopPropagation(), e.onSelectEdge(n.id);
		}), t.appendChild(p);
		let m = document.createElementNS(WD, "path");
		if (m.setAttribute("d", f), m.classList.add(GD[n.linkType] || "tb-edge--winner"), r.selectedEdgeId === n.id && m.classList.add("tb-edge--selected"), m.setAttribute("marker-end", `url(#arrowhead-${n.linkType})`), m.addEventListener("click", (t) => {
			t.stopPropagation(), e.onSelectEdge(n.id);
		}), t.appendChild(m), n.label) {
			let e = (s.x + c.x) / 2, r = (l + u) / 2 - 8, i = document.createElementNS(WD, "text");
			i.classList.add("tb-edge-label"), i.setAttribute("x", String(e)), i.setAttribute("y", String(r)), i.setAttribute("text-anchor", "middle"), i.textContent = n.label, t.appendChild(i);
		}
	}
	return {
		element: t,
		update: _
	};
}
//#endregion
//#region src/components/topology-builder/ui/nodeEditor.ts
var { SINGLE_ELIMINATION: qD, ROUND_ROBIN: JD, FEED_IN: YD, FEED_IN_CHAMPIONSHIP: XD, FIRST_MATCH_LOSER_CONSOLATION: ZD, COMPASS: QD, OLYMPIC: $D, AD_HOC: eO, LUCKY_DRAW: tO, MAIN: nO, QUALIFYING: rO, CONSOLATION: iO, PLAY_OFF: aO, WINNER: oO } = t, sO = "POSITION", cO = [
	{
		label: "Single Elimination",
		value: qD
	},
	{
		label: "Round Robin",
		value: JD
	},
	{
		label: "Feed-In Championship",
		value: XD
	},
	{
		label: "FMLC",
		value: ZD
	},
	{
		label: "Compass",
		value: QD
	},
	{
		label: "Olympic",
		value: $D
	},
	{
		label: "Ad-hoc",
		value: eO
	}
], lO = [
	{
		label: "Single Elimination",
		value: qD
	},
	{
		label: "Round Robin",
		value: JD
	},
	{
		label: "Lucky Draw",
		value: tO
	},
	{
		label: "Staggered Entry",
		value: YD
	},
	{
		label: "Ad-hoc",
		value: eO
	}
], uO = [
	{
		label: "Main",
		value: nO
	},
	{
		label: "Qualifying",
		value: rO
	},
	{
		label: "Consolation",
		value: iO
	},
	{
		label: "Playoff",
		value: aO
	}
];
function dO(e) {
	let t = [], n = Math.floor(e / 2);
	for (; n >= 1;) t.push(n), n = Math.floor(n / 2);
	return t;
}
function fO(e, t = 8) {
	let n = [];
	for (let r = 3; r <= t; r++) {
		let t = Math.ceil(e / r), i = t * r - e, a = Math.ceil(e / t), o = Math.ceil(i / t);
		(!i || i < r) && a === r && a >= 3 && o < 2 && n.push(r);
	}
	return n;
}
function pO(e, t, n, r, i, a) {
	let o = fO(e.drawSize), s = e.structureOptions?.groupSize || 4, c = o.includes(s) ? o : [s, ...o].sort((e, t) => e - t), l = Math.ceil(e.drawSize / s);
	i.push({
		label: "Group Size",
		field: "groupSize",
		value: String(s),
		disabled: n,
		options: c.map((e) => ({
			label: String(e),
			value: String(e),
			selected: e === s
		}))
	}), i.push({
		label: "Groups",
		field: "groupCount",
		value: String(l),
		disabled: !0
	}), n || a.push({
		control: "groupSize",
		onChange: ({ e: t }) => {
			let n = parseInt(t.target.value);
			r.onUpdateNode(e.id, { structureOptions: {
				...e.structureOptions,
				groupSize: n
			} });
		}
	});
	let u = t.edges.filter((t) => t.sourceNodeId === e.id && t.linkType === sO), d = new Set(u.flatMap((e) => e.finishingPositions || [])), f = d.size || 0, p = Array.from({ length: s }, (e, t) => t + 1);
	i.push({
		label: "Advance Per Group",
		field: "advancePerGroup",
		value: String(f),
		disabled: n || u.length === 0,
		options: p.map((e) => ({
			label: String(e),
			value: String(e),
			selected: e === f
		}))
	}), !n && u.length > 0 && a.push({
		control: "advancePerGroup",
		onChange: ({ e }) => {
			let t = parseInt(e.target.value), n = d.size;
			if (t !== n) if (t > n) {
				let e = u.at(-1), n = [];
				for (let e = 1; e <= s && d.size + n.length < t; e++) d.has(e) || n.push(e);
				n.length > 0 && r.onUpdateEdge(e.id, { finishingPositions: [...e.finishingPositions || [], ...n].sort((e, t) => e - t) });
			} else {
				let e = [...d].sort((e, t) => t - e), i = new Set(e.slice(0, n - t));
				for (let e of u) {
					let t = (e.finishingPositions || []).filter((e) => !i.has(e));
					t.length !== (e.finishingPositions || []).length && r.onUpdateEdge(e.id, { finishingPositions: t });
				}
			}
		}
	}), u.length > 0 && f > 0 && mO(u, t, l, i);
}
function mO(e, t, n, r) {
	let i = /* @__PURE__ */ new Map();
	for (let t of e) i.has(t.targetNodeId) || i.set(t.targetNodeId, []), i.get(t.targetNodeId).push(...t.finishingPositions || []);
	let a = [];
	for (let [e, r] of i) {
		let i = t.nodes.find((t) => t.id === e), o = [...new Set(r)].sort(), s = o.length === 1 ? `P${o[0]}` : `P${o.join(",")}`;
		a.push(`${s} → ${i?.structureName || "?"} (${o.length * n})`);
	}
	a.length > 0 && r.push({
		label: "Playoff Groups",
		field: "playoffSummary",
		value: a.join("\n"),
		disabled: !0
	});
}
function hO(e, t, n, r, i, a) {
	let o = t.edges.find((t) => t.targetNodeId === e.id && t.linkType === sO);
	if (!o || t.nodes.find((e) => e.id === o.sourceNodeId)?.structureType !== JD) return;
	let s = e.structureOptions?.playoffDrawType || qD;
	if (i.push({
		label: "Playoff Draw Type",
		field: "playoffDrawType",
		value: s,
		disabled: n,
		options: cO.map((e) => ({
			...e,
			selected: e.value === s
		}))
	}), n || a.push({
		control: "playoffDrawType",
		onChange: ({ e: t }) => r.onUpdateNode(e.id, { structureOptions: {
			...e.structureOptions,
			playoffDrawType: t.target.value
		} })
	}), s === JD) {
		let t = e.structureOptions?.groupSize || 4;
		i.push({
			label: "Playoff Group Size",
			field: "playoffGroupSize",
			value: String(t),
			disabled: n,
			options: [
				3,
				4,
				5,
				6,
				8
			].map((e) => ({
				label: String(e),
				value: String(e),
				selected: e === t
			}))
		}), n || a.push({
			control: "playoffGroupSize",
			onChange: ({ e: t }) => r.onUpdateNode(e.id, { structureOptions: {
				...e.structureOptions,
				groupSize: parseInt(t.target.value)
			} })
		});
	}
}
function gO(e, t, n, r, i) {
	let a = dO(e.drawSize), o = e.qualifyingPositions ?? a[0];
	r.push({
		label: "Qualifying Positions",
		field: "qualifyingPositions",
		value: String(o),
		disabled: t,
		options: a.map((e) => ({
			label: String(e),
			value: String(e),
			selected: e === o
		}))
	}), t || i.push({
		control: "qualifyingPositions",
		onChange: ({ e: t }) => n.onUpdateNode(e.id, { qualifyingPositions: parseInt(t.target.value) })
	});
}
function _O(e, t, n) {
	let r = zE(e.drawSize), i = /* @__PURE__ */ new Map(), a = [];
	for (let n of t.edges) {
		if (n.linkType !== oO || n.targetNodeId !== e.id) continue;
		let r = n.targetRoundNumber || 1;
		if (r <= 1) continue;
		let o = t.nodes.find((e) => e.id === n.sourceNodeId);
		if (!o || o.stage !== rO) continue;
		let s = o.qualifyingPositions || Math.floor(o.drawSize / 4);
		i.set(r, (i.get(r) || 0) + s), a.push({
			targetRound: r,
			qp: s,
			sourceName: o.structureName
		});
	}
	let o = [];
	for (let e of a) {
		let t = r.get(e.targetRound) || 0;
		t >= (i.get(e.targetRound) || 0) || (t === 0 ? o.push(`Round ${e.targetRound} is not a feed round — ${e.sourceName} sends ${e.qp} qualifiers`) : o.push(`Round ${e.targetRound} has ${t} feed positions but ${e.sourceName} sends ${e.qp} qualifiers`));
	}
	if (o.length > 0) {
		let e = document.createElement("div");
		e.className = "tb-editor-warning";
		for (let t of o) {
			let n = document.createElement("div");
			n.textContent = `\u26a0 ${t}`, e.appendChild(n);
		}
		let t = document.createElement("div");
		t.style.marginTop = "6px", t.textContent = "Change the target round to a feed round, or increase the draw size to create feed positions at that round.", e.appendChild(t), n.appendChild(e);
	}
}
function vO(e) {
	let t = document.createElement("div"), n = !!e.readOnly;
	function r(r) {
		t.innerHTML = "";
		let i = r.selectedNodeId ? r.nodes.find((e) => e.id === r.selectedNodeId) : null;
		if (!i) return;
		let a = document.createElement("div");
		a.className = "tb-editor-header", a.textContent = "Structure Properties", t.appendChild(a);
		let o = document.createElement("div");
		o.className = "tb-editor-body";
		let s = [
			{
				label: "Name",
				field: "structureName",
				value: i.structureName,
				...n ? { disabled: !0 } : {
					validator: Km(1),
					error: "Name required"
				}
			},
			{
				label: "Stage",
				field: "stage",
				value: i.stage,
				disabled: n,
				options: uO.map((e) => ({
					...e,
					selected: e.value === i.stage
				}))
			},
			{
				label: "Structure Type",
				field: "structureType",
				value: i.structureType,
				disabled: n,
				options: lO.map((e) => ({
					...e,
					selected: e.value === i.structureType
				}))
			},
			{
				label: i.stage === nO ? "Draw Size" : "Structure Size",
				field: "drawSize",
				type: "number",
				value: String(i.drawSize),
				...n ? { disabled: !0 } : i.structureType === eO ? {
					validator: Jm(0, 256),
					error: "Must be 0-256"
				} : {
					validator: Jm(2, 256),
					error: "Must be 2-256"
				}
			}
		], c = n ? [] : [
			{
				control: "structureName",
				onChange: ({ inputs: t }) => e.onUpdateNode(i.id, { structureName: t.structureName.value })
			},
			{
				control: "stage",
				onChange: ({ e: t }) => e.onUpdateNode(i.id, { stage: t.target.value })
			},
			{
				control: "structureType",
				onChange: ({ e: t }) => e.onUpdateNode(i.id, { structureType: t.target.value })
			},
			{
				control: "drawSize",
				onChange: ({ inputs: t }) => {
					let n = parseInt(t.drawSize.value);
					if (n < (i.structureType === eO ? 0 : 2)) return;
					let r = { drawSize: n };
					if (i.structureType === JD) {
						let e = i.structureOptions?.groupSize || 4, t = fO(n);
						!t.includes(e) && t.length > 0 && (r.structureOptions = {
							...i.structureOptions,
							groupSize: t[0]
						});
					}
					e.onUpdateNode(i.id, r);
				}
			}
		];
		i.structureType === JD && pO(i, r, n, e, s, c), i.stage === aO && hO(i, r, n, e, s, c), i.stage === rO && gO(i, n, e, s, c), Ei(o, s, c);
		let l = document.createElement("div");
		l.className = "field font-medium", l.style.cssText = "flex-grow: 1";
		let u = document.createElement("label");
		u.style.cssText = "font-weight: bold; font-size: larger;", u.textContent = "MatchUp Format", l.appendChild(u);
		let d = document.createElement("div");
		if (d.className = "tb-format-trigger", d.textContent = i.matchUpFormat || "Not set", n ? (d.style.cursor = "default", d.style.opacity = "0.7") : d.onclick = () => {
			Ra({
				existingMatchUpFormat: i.matchUpFormat,
				callback: (t) => {
					e.onUpdateNode(i.id, { matchUpFormat: t || void 0 }), d.textContent = t || "Not set";
				}
			});
		}, l.appendChild(d), o.appendChild(l), _O(i, r, o), !n && !e.hideDelete) {
			let t = document.createElement("button");
			t.className = "sp-btn sp-btn--danger sp-btn--full", t.style.marginTop = "12px", t.textContent = "Delete Structure", t.onclick = () => e.onDeleteNode(i.id), o.appendChild(t);
		}
		t.appendChild(o);
	}
	return {
		element: t,
		update: r
	};
}
//#endregion
//#region src/components/topology-builder/ui/edgeEditor.ts
var { WINNER: yO, LOSER: bO, TOP_DOWN: xO, BOTTOM_UP: SO, QUALIFYING: CO, ROUND_ROBIN: wO } = t, TO = "POSITION", EO = "ALTERNATING", DO = (e) => e === wO, OO = [
	{
		label: "Winner",
		value: yO
	},
	{
		label: "Loser",
		value: bO
	},
	{
		label: "Position",
		value: TO
	}
], kO = [
	{
		label: "Top-Down",
		value: xO
	},
	{
		label: "Bottom-Up",
		value: SO
	},
	{
		label: "Alternating",
		value: EO
	}
];
function AO(e) {
	let t = document.createElement("div"), n = !!e.readOnly;
	function r(t, r, i, a, o, s) {
		let c = [], l = [], u = r ? rD(r.structureType, r.drawSize, r.structureOptions?.groupSize) : {}, d = u.playoffRoundsRanges && u.playoffRoundsRanges.length > 0;
		if (d) {
			let e = u.playoffRoundsRanges.map((e) => ({
				label: `R${e.roundNumber} (${e.finishingPositionRange})`,
				value: String(e.roundNumber),
				selected: e.roundNumber === (t.sourceRoundNumber || a)
			}));
			c.push({
				label: "Source Round",
				field: "sourceRoundNumber",
				value: String(t.sourceRoundNumber || a),
				disabled: n,
				options: e
			});
		} else c.push({
			label: "Source Round",
			field: "sourceRoundNumber",
			type: "number",
			value: String(t.sourceRoundNumber || a),
			disabled: n
		});
		return c.push({
			label: s ? "Enter at Round" : "Target Round",
			field: "targetRoundNumber",
			type: "number",
			value: String(t.targetRoundNumber || 0),
			disabled: n
		}), n || (d ? l.push({
			control: "sourceRoundNumber",
			onChange: ({ e: n }) => {
				let r = Number.parseInt(n.target.value) || 0;
				e.onUpdateEdge(t.id, { sourceRoundNumber: r || void 0 });
			}
		}) : l.push({
			control: "sourceRoundNumber",
			onChange: ({ inputs: n }) => {
				let r = Number.parseInt(n.sourceRoundNumber.value) || 0, i = Math.max(0, Math.min(r, a));
				e.onUpdateEdge(t.id, { sourceRoundNumber: i || void 0 });
			}
		}), l.push({
			control: "targetRoundNumber",
			onChange: ({ inputs: n }) => {
				let r = Number.parseInt(n.targetRoundNumber.value) || 0, i = Math.max(0, Math.min(r, o));
				e.onUpdateEdge(t.id, { targetRoundNumber: i || void 0 });
			}
		})), {
			items: c,
			relationships: l
		};
	}
	function i(t, r, i) {
		let a = r.structureOptions?.groupSize || 4, o = new Set(t.finishingPositions || []), s = i.edges.filter((e) => e.id !== t.id && e.sourceNodeId === t.sourceNodeId && e.linkType === TO), c = /* @__PURE__ */ new Set();
		for (let e of s) for (let t of e.finishingPositions || []) c.add(t);
		let l = document.createElement("div");
		l.className = "field", l.style.marginBottom = "10px";
		let u = document.createElement("label");
		u.style.cssText = "font-size:11px;font-weight:600;color:var(--chc-text-secondary);margin-bottom:3px;display:block;", u.textContent = "Finishing Positions", l.appendChild(u);
		for (let r = 1; r <= a; r++) {
			let i = document.createElement("label");
			i.style.cssText = "display:flex;align-items:center;gap:4px;font-size:12px;padding:2px 0;cursor:pointer;";
			let a = document.createElement("input");
			a.type = "checkbox", a.checked = o.has(r);
			let s = c.has(r);
			n || s ? a.disabled = !0 : a.addEventListener("change", () => {
				let n = new Set(o);
				a.checked ? n.add(r) : n.delete(r), e.onUpdateEdge(t.id, { finishingPositions: Array.from(n).sort() });
			});
			let u = document.createElement("span");
			u.textContent = `Position ${r}`, s && (u.style.color = "var(--chc-text-muted, #999)", u.title = "Used by another link", i.style.opacity = "0.5", i.style.cursor = "not-allowed"), i.appendChild(a), i.appendChild(u), l.appendChild(i);
		}
		return l;
	}
	function a(a) {
		t.innerHTML = "";
		let o = a.selectedEdgeId ? a.edges.find((e) => e.id === a.selectedEdgeId) : null;
		if (!o) return;
		let s = a.nodes.find((e) => e.id === o.sourceNodeId), c = a.nodes.find((e) => e.id === o.targetNodeId), l = document.createElement("div");
		l.className = "tb-editor-header", l.textContent = "Link Properties", t.appendChild(l);
		let u = document.createElement("div");
		u.className = "tb-editor-body";
		let d = document.createElement("div");
		d.style.cssText = "font-size:11px;color:var(--chc-text-muted);margin-bottom:8px;", d.textContent = `${s?.structureName || "Source"} → ${c?.structureName || "Target"}`, u.appendChild(d);
		let f = o.linkType === yO && s?.stage === CO, p = s ? WE(s.structureType, s.drawSize, s.structureOptions) : 8, m = c ? WE(c.structureType, c.drawSize, c.structureOptions) : 8, h = o.linkType === TO && s && DO(s.structureType), g = [{
			label: "Link Type",
			field: "linkType",
			value: o.linkType,
			disabled: n,
			options: OO.map((e) => ({
				...e,
				selected: e.value === o.linkType
			}))
		}], _ = n ? [] : [{
			control: "linkType",
			onChange: ({ e: t }) => e.onUpdateEdge(o.id, { linkType: t.target.value })
		}];
		if (!h) {
			let e = r(o, s, c, p, m, f);
			g.push(...e.items), _.push(...e.relationships);
		}
		if (f && s) {
			let t = Math.floor(s.drawSize / 2), r = Math.floor(s.drawSize / 4), i = o.qualifyingPositions || r;
			g.push({
				label: "Qualifying Positions",
				field: "qualifyingPositions",
				type: "number",
				value: String(i),
				disabled: n
			}), n || _.push({
				control: "qualifyingPositions",
				onChange: ({ inputs: n }) => {
					let r = Number.parseInt(n.qualifyingPositions.value) || 1, i = Math.max(1, Math.min(r, t));
					e.onUpdateEdge(o.id, { qualifyingPositions: i });
				}
			});
		}
		if (o.linkType === bO && (g.push({
			label: "Feed Profile",
			field: "feedProfile",
			value: o.feedProfile || xO,
			disabled: n,
			options: kO.map((e) => ({
				...e,
				selected: e.value === (o.feedProfile || xO)
			}))
		}), n || _.push({
			control: "feedProfile",
			onChange: ({ e: t }) => e.onUpdateEdge(o.id, { feedProfile: t.target.value })
		})), o.linkType === TO && !h && (g.push({
			label: "Finishing Positions",
			field: "finishingPositions",
			value: (o.finishingPositions || []).join(", "),
			placeholder: "e.g., 1, 2",
			disabled: n
		}), n || _.push({
			control: "finishingPositions",
			onChange: ({ inputs: t }) => {
				let n = t.finishingPositions.value.split(",").map((e) => Number.parseInt(e.trim())).filter((e) => !Number.isNaN(e));
				e.onUpdateEdge(o.id, { finishingPositions: n });
			}
		})), Ei(u, g, _), h && s && u.appendChild(i(o, s, a)), !n) {
			let t = document.createElement("button");
			t.className = "sp-btn sp-btn--danger sp-btn--full", t.style.marginTop = "12px", t.textContent = "Delete Link", t.onclick = () => e.onDeleteEdge(o.id), u.appendChild(t);
		}
		t.appendChild(u);
	}
	return {
		element: t,
		update: a
	};
}
//#endregion
//#region src/components/topology-builder/domain/topologyValidator.ts
var { MAIN: jO, QUALIFYING: MO, CONSOLATION: NO, WINNER: PO, LOSER: FO, SINGLE_ELIMINATION: IO, ROUND_ROBIN: LO, AD_HOC: RO } = t, zO = "POSITION";
function BO(e) {
	let t = [], n = VO(e, t);
	return UO(e, HO(e), t), WO(e, t), GO(e, t), KO(e, t), qO(e, n, t), JO(e, t), YO(e, t), ZO(e, t), QO(e, t), $O(e) && t.push({
		severity: "error",
		message: "Circular dependency detected between structures"
	}), t;
}
function VO(e, t) {
	let n = e.nodes.filter((e) => e.stage === jO);
	return n.length === 0 ? t.push({
		severity: "error",
		message: "A main draw structure is required"
	}) : n.length > 1 && t.push({
		severity: "error",
		message: "Only one main draw structure is allowed"
	}), n;
}
function HO(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e.edges) n.linkType === PO && (n.targetRoundNumber || 1) > 1 && e.nodes.find((e) => e.id === n.sourceNodeId)?.stage === MO && t.add(n.targetNodeId);
	let n = /* @__PURE__ */ new Map();
	for (let t of e.edges) t.linkType === FO && n.set(t.targetNodeId, (n.get(t.targetNodeId) || 0) + 1);
	for (let [e, r] of n) r > 1 && t.add(e);
	return t;
}
function UO(e, t, n) {
	for (let r of e.nodes) {
		if (r.structureType === IO && !t.has(r.id)) {
			let t = e.edges.some((e) => e.targetNodeId === r.id);
			(r.stage === jO || r.stage === MO) && !t && (r.drawSize > 0 && !(r.drawSize & r.drawSize - 1) || n.push({
				severity: "error",
				message: `"${r.structureName}" draw size must be a power of 2`,
				nodeId: r.id
			}));
		}
		let i = r.structureType === RO ? 0 : 2;
		r.drawSize < i && n.push({
			message: `"${r.structureName}" draw size must be at least ${i}`,
			severity: "error",
			nodeId: r.id
		});
	}
}
function WO(e, t) {
	for (let n of e.edges) {
		let r = e.nodes.find((e) => e.id === n.sourceNodeId), i = e.nodes.find((e) => e.id === n.targetNodeId);
		if (r || t.push({
			severity: "error",
			message: "Edge references missing source node",
			edgeId: n.id
		}), i || t.push({
			severity: "error",
			message: "Edge references missing target node",
			edgeId: n.id
		}), r && n.sourceRoundNumber) {
			let e = WE(r.structureType, r.drawSize, r.structureOptions);
			(n.sourceRoundNumber > e || n.sourceRoundNumber < 1) && t.push({
				severity: "warning",
				message: `Edge source round ${n.sourceRoundNumber} is outside "${r.structureName}" range (1-${e})`,
				edgeId: n.id
			});
		}
		if (i && n.targetRoundNumber) {
			let e = WE(i.structureType, i.drawSize, i.structureOptions);
			(n.targetRoundNumber > e || n.targetRoundNumber < 1) && t.push({
				severity: "warning",
				message: `Edge target round ${n.targetRoundNumber} is outside "${i.structureName}" range (1-${e})`,
				edgeId: n.id
			});
		}
	}
}
function GO(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let t of e.edges) t.linkType === PO && (n.has(t.sourceNodeId) || n.set(t.sourceNodeId, []), n.get(t.sourceNodeId).push(t.id));
	for (let [r, i] of n) if (i.length > 1) {
		let n = e.nodes.find((e) => e.id === r)?.structureName || "Unknown";
		for (let e of i) t.push({
			severity: "error",
			message: `"${n}" has multiple winner links (only one allowed)`,
			edgeId: e
		});
	}
}
function KO(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let t of e.edges) t.sourceRoundNumber && (n.has(t.sourceNodeId) || n.set(t.sourceNodeId, []), n.get(t.sourceNodeId).push({
		round: t.sourceRoundNumber,
		edgeId: t.id
	}));
	for (let [r, i] of n) {
		let n = /* @__PURE__ */ new Map(), a = e.nodes.find((e) => e.id === r)?.structureName || "Unknown";
		for (let { round: e, edgeId: r } of i) n.has(e) ? t.push({
			severity: "error",
			message: `"${a}" has multiple links from round ${e}`,
			edgeId: r
		}) : n.set(e, r);
	}
}
function qO(e, t, n) {
	let r = e.nodes.filter((e) => e.stage === MO);
	for (let i of r) {
		let r = e.edges.find((e) => e.sourceNodeId === i.id && e.linkType === PO && t.some((t) => t.id === e.targetNodeId));
		if (r || n.push({
			severity: "warning",
			message: `Qualifying structure "${i.structureName}" has no winner link to a main structure`,
			nodeId: i.id
		}), r?.qualifyingPositions) {
			let e = Math.floor(i.drawSize / 2);
			r.qualifyingPositions > e && n.push({
				severity: "warning",
				message: `Qualifying positions (${r.qualifyingPositions}) exceeds half of "${i.structureName}" draw size (${e})`,
				edgeId: r.id
			});
		}
	}
}
function JO(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let t of e.edges) {
		if (t.linkType !== PO) continue;
		let r = t.targetRoundNumber || 1;
		if (r <= 1) continue;
		let i = e.nodes.find((e) => e.id === t.sourceNodeId);
		if (!i || i.stage !== MO) continue;
		n.has(t.targetNodeId) || n.set(t.targetNodeId, []);
		let a = i.qualifyingPositions || Math.floor(i.drawSize / 4);
		n.get(t.targetNodeId).push({
			edgeId: t.id,
			targetRound: r,
			qp: a,
			sourceName: i.structureName
		});
	}
	for (let [r, i] of n) {
		let n = e.nodes.find((e) => e.id === r);
		if (!n) continue;
		let a = zE(n.drawSize), o = /* @__PURE__ */ new Map();
		for (let e of i) o.set(e.targetRound, (o.get(e.targetRound) || 0) + e.qp);
		for (let { edgeId: e, targetRound: s, sourceName: c } of i) (a.get(s) || 0) < (o.get(s) || 0) && t.push({
			severity: "warning",
			message: `"${n.structureName}" round ${s} is not a feed round or has insufficient capacity for ${c} link`,
			nodeId: r,
			edgeId: e
		});
	}
}
function YO(e, t) {
	for (let n of e.edges) {
		if (n.linkType !== FO) continue;
		let r = e.nodes.find((e) => e.id === n.sourceNodeId), i = e.nodes.find((e) => e.id === n.targetNodeId);
		if (!r || !i) continue;
		let a = n.sourceRoundNumber || 1, o = n.targetRoundNumber || 1, s = GE(r.structureType, r.drawSize, a), c = zE(i.drawSize);
		o !== 1 && XO(c, o, s, r, i, a, n.id, t);
	}
}
function XO(e, t, n, r, i, a, o, s) {
	let c = e.get(t);
	c === void 0 ? s.push({
		severity: "error",
		message: `"${i.structureName}" R${t} is not a feed round — cannot receive ${n} losers from "${r.structureName}" R${a}`,
		edgeId: o
	}) : n > c ? s.push({
		severity: "error",
		message: `"${r.structureName}" R${a} produces ${n} losers but "${i.structureName}" R${t} only has ${c} feed positions`,
		edgeId: o
	}) : n < c && s.push({
		severity: "warning",
		message: `"${r.structureName}" R${a} produces ${n} losers but "${i.structureName}" R${t} has ${c} feed positions — ${c - n} will be empty`,
		edgeId: o
	});
}
function ZO(e, t) {
	let n = e.nodes.filter((e) => e.stage === NO);
	for (let r of n) {
		let n = e.edges.filter((e) => e.targetNodeId === r.id);
		if (n.length === 0) continue;
		let i = 0;
		for (let t of n) {
			let n = e.nodes.find((e) => e.id === t.sourceNodeId);
			if (n) if (t.linkType === FO) {
				let e = t.sourceRoundNumber || 1;
				i += GE(n.structureType, n.drawSize, e);
			} else i += n.qualifyingPositions || Math.floor(n.drawSize / 2);
		}
		i > 0 && r.drawSize > i && t.push({
			severity: "warning",
			message: `"${r.structureName}" draw size (${r.drawSize}) exceeds inbound capacity (${i})`,
			nodeId: r.id
		}), i > 0 && i > r.drawSize && t.push({
			severity: "error",
			message: `"${r.structureName}" receives ${i} participants but only has ${r.drawSize} positions`,
			nodeId: r.id
		});
	}
}
function QO(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let r of e.edges) {
		if (r.linkType !== zO) continue;
		n.has(r.sourceNodeId) || n.set(r.sourceNodeId, []), n.get(r.sourceNodeId).push({
			edgeId: r.id,
			positions: r.finishingPositions || []
		});
		let i = e.nodes.find((e) => e.id === r.sourceNodeId);
		if (i && i.structureType === LO) {
			let e = i.structureOptions?.groupSize || 4;
			for (let n of r.finishingPositions || []) (n < 1 || n > e) && t.push({
				severity: "error",
				message: `Position ${n} is outside valid range (1-${e}) for "${i.structureName}"`,
				edgeId: r.id
			});
		}
	}
	for (let [r, i] of n) {
		if (i.length < 2) continue;
		let n = e.nodes.find((e) => e.id === r)?.structureName || "Unknown", a = /* @__PURE__ */ new Map();
		for (let { edgeId: e, positions: r } of i) for (let i of r) a.has(i) ? t.push({
			severity: "warning",
			message: `Position ${i} from "${n}" is used by multiple POSITION links`,
			edgeId: e
		}) : a.set(i, e);
	}
}
function $O(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e.nodes) t.set(n.id, []);
	for (let n of e.edges) {
		let e = t.get(n.sourceNodeId);
		e && e.push(n.targetNodeId);
	}
	let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
	function i(e) {
		if (r.has(e)) return !0;
		if (n.has(e)) return !1;
		n.add(e), r.add(e);
		for (let n of t.get(e) || []) if (i(n)) return !0;
		return r.delete(e), !1;
	}
	for (let t of e.nodes) if (i(t.id)) return !0;
	return !1;
}
//#endregion
//#region src/components/topology-builder/ui/toolbar.ts
var { MAIN: ek, QUALIFYING: tk, CONSOLATION: nk, PLAY_OFF: rk, LUCKY_DRAW: ik } = t;
function ak(e, t, n = {}) {
	let r = document.createElement("div");
	r.className = "tb-toolbar-wrapper";
	let i = document.createElement("div");
	i.className = "tb-toolbar-row";
	let a = document.createElement("div");
	a.style.flex = "1", a.style.minWidth = "0", i.appendChild(a), r.appendChild(i);
	let o = document.createElement("div");
	o.className = "tb-validation", o.style.display = "none", r.appendChild(o);
	let s = null, c = () => {
		if (!s) return;
		let e = BO(s);
		if (o.innerHTML = "", e.length === 0) {
			o.style.display = "block";
			let e = document.createElement("div");
			e.className = "tb-validation-item", e.innerHTML = "<span style=\"color:var(--chc-status-success)\">&#10003; Valid topology</span>", o.appendChild(e);
		} else {
			o.style.display = "block";
			for (let t of e) {
				let e = document.createElement("div");
				e.className = "tb-validation-item";
				let n = document.createElement("span");
				n.className = `tb-validation-icon tb-validation-icon--${t.severity}`, n.textContent = t.severity === "error" ? "!" : "?";
				let r = document.createElement("span");
				r.textContent = t.message, e.appendChild(n), e.appendChild(r), o.appendChild(e);
			}
		}
		setTimeout(() => {
			o.style.display = "none";
		}, 5e3);
	}, l = [];
	if (!n.readOnly) {
		let t = [
			{
				label: "Main",
				value: ek,
				onClick: () => e.onAddStructure(ek),
				close: !0
			},
			{
				label: "Lucky Draw",
				value: ik,
				onClick: () => e.onAddStructure(ek, ik),
				close: !0
			},
			{
				label: "Qualifying",
				value: tk,
				onClick: () => e.onAddStructure(tk),
				close: !0
			},
			{
				label: "Consolation",
				value: nk,
				onClick: () => e.onAddStructure(nk),
				close: !0
			},
			{
				label: "Playoff",
				value: rk,
				onClick: () => e.onAddStructure(rk),
				close: !0
			}
		];
		l.push({
			label: "Add Structure",
			location: "right",
			options: t
		});
	}
	if (!n.hideTemplates && t.length > 0) {
		let n = t.map((n) => ({
			label: n.name,
			value: n.name,
			onClick: () => {
				let r = t.find((e) => e.name === n.name);
				r && e.onLoadTemplate(r);
			},
			close: !0
		}));
		l.push({
			label: "Templates",
			location: "right",
			options: n
		});
	}
	!n.readOnly && e.onClear && l.push({
		label: "Clear",
		location: "right",
		onClick: () => e.onClear()
	}), n.readOnly || l.push({
		label: "Auto Layout",
		location: "right",
		onClick: () => e.onAutoLayout()
	}, {
		label: "Validate",
		location: "right",
		onClick: () => c()
	}), !n.readOnly && e.onSaveTemplate && l.push({
		label: "Save Template",
		location: "right",
		intent: "is-success",
		onClick: () => e.onSaveTemplate()
	}), !n.readOnly && !n.hideGenerate && l.push({
		label: "Generate Draw",
		location: "right",
		intent: "is-success",
		onClick: () => e.onGenerate()
	}), kC({
		target: a,
		items: l
	});
	function u(e) {
		s = e;
	}
	return {
		element: r,
		update: u
	};
}
//#endregion
//#region src/components/topology-builder/ui/topologyBuilderLayout.ts
function ok({ toolbar: e, canvas: t, nodeEditor: n, edgeEditor: r }) {
	let i = document.createElement("div");
	i.className = "tb-layout", i.appendChild(e.element);
	let a = document.createElement("div");
	a.className = "tb-body", a.appendChild(t.element);
	let o = document.createElement("div");
	o.className = "tb-editor", o.appendChild(n.element), o.appendChild(r.element), a.appendChild(o), i.appendChild(a);
	function s(i) {
		if (e.update(i), t.update(i), n.element.style.display = i.selectedNodeId ? "" : "none", r.element.style.display = i.selectedEdgeId ? "" : "none", !i.selectedNodeId && !i.selectedEdgeId) {
			if (!o.querySelector(".tb-editor-empty")) {
				let e = document.createElement("div");
				e.className = "tb-editor-empty", e.textContent = "Select a structure or link to view properties", o.appendChild(e);
			}
		} else {
			let e = o.querySelector(".tb-editor-empty");
			e && e.remove();
		}
		n.update(i), r.update(i);
	}
	function c() {
		e.destroy?.(), t.destroy?.(), n.destroy?.(), r.destroy?.();
	}
	return {
		element: i,
		update: s,
		destroy: c
	};
}
//#endregion
//#region src/components/topology-builder/domain/templates.ts
var { SINGLE_ELIMINATION: Z, FEED_IN: sk, ROUND_ROBIN: ck, LUCKY_DRAW: lk, MAIN: uk, QUALIFYING: dk, CONSOLATION: fk, PLAY_OFF: pk } = t, mk = "WINNER", hk = "LOSER", gk = "POSITION", _k = "tpl-edge-1", vk = "tpl-edge-2", yk = "tpl-edge-3", bk = "tpl-edge-4", xk = "tpl-edge-5", Sk = "tpl-edge-6", Ck = "tpl-edge-7", wk = "R1 losers → R1", Tk = [
	{
		name: "Single Elimination + Qualifying",
		description: "Standard SE main draw with one qualifying structure",
		state: {
			drawName: "SE + Qualifying",
			nodes: [{
				id: "tpl-main",
				structureName: "Main Draw",
				stage: uk,
				structureType: Z,
				drawSize: 32,
				position: {
					x: 320,
					y: 40
				}
			}, {
				id: "tpl-qual",
				structureName: "Qualifying",
				stage: dk,
				structureType: Z,
				drawSize: 16,
				qualifyingPositions: 4,
				position: {
					x: 40,
					y: 40
				}
			}],
			edges: [{
				id: _k,
				sourceNodeId: "tpl-qual",
				targetNodeId: "tpl-main",
				linkType: mk,
				targetRoundNumber: 1,
				qualifyingPositions: 4,
				label: "winners → R1 (4Q)"
			}]
		}
	},
	{
		name: "FMLC (First Match Loser Consolation)",
		description: "Main draw with first match loser consolation",
		state: {
			drawName: "FMLC",
			nodes: [{
				id: "tpl-main",
				structureName: "Main Draw",
				stage: uk,
				structureType: Z,
				drawSize: 32,
				position: {
					x: 40,
					y: 40
				}
			}, {
				id: "tpl-cons",
				structureName: "Consolation",
				stage: fk,
				structureType: Z,
				drawSize: 16,
				position: {
					x: 320,
					y: 40
				}
			}],
			edges: [{
				id: _k,
				sourceNodeId: "tpl-main",
				targetNodeId: "tpl-cons",
				linkType: hk,
				sourceRoundNumber: 1,
				targetRoundNumber: 1,
				label: wk
			}]
		}
	},
	{
		name: "Feed-In Championship (FIC)",
		description: "Main draw with multi-round fed consolation",
		state: {
			drawName: "FIC",
			nodes: [{
				id: "tpl-main",
				structureName: "Main Draw",
				stage: uk,
				structureType: Z,
				drawSize: 32,
				position: {
					x: 40,
					y: 40
				}
			}, {
				id: "tpl-cons",
				structureName: "Consolation",
				stage: fk,
				structureType: sk,
				drawSize: 31,
				position: {
					x: 460,
					y: 40
				}
			}],
			edges: [
				{
					id: _k,
					sourceNodeId: "tpl-main",
					targetNodeId: "tpl-cons",
					linkType: hk,
					sourceRoundNumber: 1,
					targetRoundNumber: 1,
					label: wk
				},
				{
					id: vk,
					sourceNodeId: "tpl-main",
					targetNodeId: "tpl-cons",
					linkType: hk,
					sourceRoundNumber: 2,
					targetRoundNumber: 2,
					label: "R2 losers → R2"
				},
				{
					id: yk,
					sourceNodeId: "tpl-main",
					targetNodeId: "tpl-cons",
					linkType: hk,
					sourceRoundNumber: 3,
					targetRoundNumber: 4,
					label: "R3 losers → R4"
				},
				{
					id: bk,
					sourceNodeId: "tpl-main",
					targetNodeId: "tpl-cons",
					linkType: hk,
					sourceRoundNumber: 4,
					targetRoundNumber: 6,
					label: "R4 losers → R6"
				},
				{
					id: xk,
					sourceNodeId: "tpl-main",
					targetNodeId: "tpl-cons",
					linkType: hk,
					sourceRoundNumber: 5,
					targetRoundNumber: 8,
					label: "R5 losers → R8"
				}
			]
		}
	},
	{
		name: "Compass",
		description: "8-draw compass structure",
		state: {
			drawName: "Compass",
			nodes: [
				{
					id: "tpl-east",
					structureName: "East",
					stage: uk,
					structureType: Z,
					drawSize: 32,
					position: {
						x: 40,
						y: 40
					}
				},
				{
					id: "tpl-west",
					structureName: "West",
					stage: fk,
					structureType: Z,
					drawSize: 16,
					position: {
						x: 400,
						y: 40
					}
				},
				{
					id: "tpl-north",
					structureName: "North",
					stage: fk,
					structureType: Z,
					drawSize: 8,
					position: {
						x: 400,
						y: 210
					}
				},
				{
					id: "tpl-ne",
					structureName: "Northeast",
					stage: fk,
					structureType: Z,
					drawSize: 4,
					position: {
						x: 400,
						y: 380
					}
				},
				{
					id: "tpl-south",
					structureName: "South",
					stage: fk,
					structureType: Z,
					drawSize: 8,
					position: {
						x: 680,
						y: 40
					}
				},
				{
					id: "tpl-sw",
					structureName: "Southwest",
					stage: fk,
					structureType: Z,
					drawSize: 4,
					position: {
						x: 680,
						y: 210
					}
				},
				{
					id: "tpl-nw",
					structureName: "Northwest",
					stage: fk,
					structureType: Z,
					drawSize: 4,
					position: {
						x: 680,
						y: 380
					}
				},
				{
					id: "tpl-se",
					structureName: "Southeast",
					stage: fk,
					structureType: Z,
					drawSize: 4,
					position: {
						x: 960,
						y: 40
					}
				}
			],
			edges: [
				{
					id: _k,
					sourceNodeId: "tpl-east",
					targetNodeId: "tpl-west",
					linkType: hk,
					sourceRoundNumber: 1,
					targetRoundNumber: 1,
					label: wk
				},
				{
					id: vk,
					sourceNodeId: "tpl-east",
					targetNodeId: "tpl-north",
					linkType: hk,
					sourceRoundNumber: 2,
					targetRoundNumber: 1,
					label: "R2 losers → R1"
				},
				{
					id: yk,
					sourceNodeId: "tpl-east",
					targetNodeId: "tpl-ne",
					linkType: hk,
					sourceRoundNumber: 3,
					targetRoundNumber: 1,
					label: "R3 losers → R1"
				},
				{
					id: bk,
					sourceNodeId: "tpl-west",
					targetNodeId: "tpl-south",
					linkType: hk,
					sourceRoundNumber: 1,
					targetRoundNumber: 1,
					label: wk
				},
				{
					id: xk,
					sourceNodeId: "tpl-west",
					targetNodeId: "tpl-sw",
					linkType: hk,
					sourceRoundNumber: 2,
					targetRoundNumber: 1,
					label: "R2 losers → R1"
				},
				{
					id: Sk,
					sourceNodeId: "tpl-north",
					targetNodeId: "tpl-nw",
					linkType: hk,
					sourceRoundNumber: 1,
					targetRoundNumber: 1,
					label: wk
				},
				{
					id: Ck,
					sourceNodeId: "tpl-south",
					targetNodeId: "tpl-se",
					linkType: hk,
					sourceRoundNumber: 1,
					targetRoundNumber: 1,
					label: wk
				}
			]
		}
	},
	{
		name: "Round Robin + Playoff",
		description: "Round robin groups with winners and consolation playoffs",
		state: {
			drawName: "RR + Playoff",
			nodes: [
				{
					id: "tpl-main",
					structureName: "Main Draw",
					stage: uk,
					structureType: ck,
					drawSize: 16,
					structureOptions: { groupSize: 4 },
					position: {
						x: 40,
						y: 40
					}
				},
				{
					id: "tpl-playoff-gold",
					structureName: "Gold Flight",
					stage: pk,
					structureType: Z,
					drawSize: 8,
					position: {
						x: 320,
						y: 40
					}
				},
				{
					id: "tpl-playoff-silver",
					structureName: "Silver Flight",
					stage: pk,
					structureType: Z,
					drawSize: 8,
					position: {
						x: 320,
						y: 220
					}
				}
			],
			edges: [{
				id: _k,
				sourceNodeId: "tpl-main",
				targetNodeId: "tpl-playoff-gold",
				linkType: gk,
				finishingPositions: [1, 2],
				label: "positions 1,2"
			}, {
				id: vk,
				sourceNodeId: "tpl-main",
				targetNodeId: "tpl-playoff-silver",
				linkType: gk,
				finishingPositions: [3, 4],
				label: "positions 3,4"
			}]
		}
	},
	{
		name: "Lucky Draw + Consolation",
		description: "Lucky draw main with consolation receiving R1 losers",
		state: {
			drawName: "Lucky + Consolation",
			nodes: [{
				id: "tpl-main",
				structureName: "Main Draw",
				stage: uk,
				structureType: lk,
				drawSize: 11,
				position: {
					x: 40,
					y: 40
				}
			}, {
				id: "tpl-cons",
				structureName: "Consolation",
				stage: fk,
				structureType: Z,
				drawSize: 4,
				position: {
					x: 340,
					y: 40
				}
			}],
			edges: [{
				id: _k,
				sourceNodeId: "tpl-main",
				targetNodeId: "tpl-cons",
				linkType: hk,
				sourceRoundNumber: 1,
				targetRoundNumber: 1,
				label: wk
			}]
		}
	},
	{
		name: "Lucky Draw → Round Robin",
		description: "Lucky draw main with R1 losers feeding into round robin consolation",
		state: {
			drawName: "Lucky → RR",
			nodes: [{
				id: "tpl-main",
				structureName: "Main Draw",
				stage: uk,
				structureType: lk,
				drawSize: 25,
				position: {
					x: 40,
					y: 40
				}
			}, {
				id: "tpl-cons-rr",
				structureName: "Consolation RR",
				stage: fk,
				structureType: ck,
				drawSize: 12,
				structureOptions: { groupSize: 4 },
				position: {
					x: 500,
					y: 40
				}
			}],
			edges: [{
				id: _k,
				sourceNodeId: "tpl-main",
				targetNodeId: "tpl-cons-rr",
				linkType: hk,
				sourceRoundNumber: 1,
				targetRoundNumber: 1,
				label: wk
			}]
		}
	},
	{
		name: "Adaptive (drawSize 11)",
		description: "Compass-like multi-structure topology with lucky draw structures",
		state: {
			drawName: "Adaptive",
			nodes: [
				{
					id: "tpl-east",
					structureName: "East",
					stage: uk,
					structureType: lk,
					drawSize: 11,
					position: {
						x: 40,
						y: 40
					}
				},
				{
					id: "tpl-west",
					structureName: "West",
					stage: fk,
					structureType: lk,
					drawSize: 6,
					position: {
						x: 340,
						y: 40
					}
				},
				{
					id: "tpl-north",
					structureName: "North",
					stage: fk,
					structureType: Z,
					drawSize: 2,
					position: {
						x: 340,
						y: 250
					}
				},
				{
					id: "tpl-south",
					structureName: "South",
					stage: fk,
					structureType: Z,
					drawSize: 2,
					position: {
						x: 600,
						y: 40
					}
				}
			],
			edges: [
				{
					id: _k,
					sourceNodeId: "tpl-east",
					targetNodeId: "tpl-west",
					linkType: hk,
					sourceRoundNumber: 1,
					targetRoundNumber: 1,
					label: "R1 losers → R1 (6 losers)"
				},
				{
					id: vk,
					sourceNodeId: "tpl-east",
					targetNodeId: "tpl-north",
					linkType: hk,
					sourceRoundNumber: 2,
					targetRoundNumber: 1,
					label: "R2 losers → R1 (2 losers)"
				},
				{
					id: yk,
					sourceNodeId: "tpl-west",
					targetNodeId: "tpl-south",
					linkType: hk,
					sourceRoundNumber: 1,
					targetRoundNumber: 1,
					label: "R1 losers → R1 (2 losers)"
				}
			]
		}
	}
], { MAIN: Ek, QUALIFYING: Dk, CONSOLATION: Ok, PLAY_OFF: kk, SINGLE_ELIMINATION: Ak, LUCKY_DRAW: jk, WINNER: Mk, LOSER: Nk } = t, Pk = "POSITION", Fk = class {
	constructor(e = {}) {
		this.config = e, this.store = new FD(e.initialState);
		let t = [...Tk, ...e.templates || []], n = !!e.readOnly;
		this.layout = ok({
			toolbar: this.buildToolbarPanel(t, n),
			canvas: this.buildCanvasPanel(n),
			nodeEditor: vO({
				onUpdateNode: n ? () => {} : (e, t) => this.store.updateNode(e, t),
				onUpdateEdge: n ? () => {} : (e, t) => this.store.updateEdge(e, t),
				onDeleteNode: n ? () => {} : (e) => this.store.removeNode(e),
				readOnly: n,
				hideDelete: e.hideDelete
			}),
			edgeEditor: AO({
				onUpdateEdge: n ? () => {} : (e, t) => this.store.updateEdge(e, t),
				onDeleteEdge: n ? () => {} : (e) => this.store.removeEdge(e),
				readOnly: n
			})
		}), this.unsubscribe = this.store.subscribe((e) => {
			this.layout.update(e);
		}), this.layout.update(this.store.getState());
	}
	buildToolbarPanel(e, t) {
		return ak({
			onAddStructure: (e, t) => this.addDefaultStructure(e, t),
			onLoadTemplate: (e) => {
				this.store.loadState({
					...e.state,
					selectedNodeId: null,
					selectedEdgeId: null,
					templateName: e.name
				});
			},
			onAutoLayout: () => {
				this.store.autoLayout();
				let e = this.store.getState();
				this.store.loadState(e);
			},
			onGenerate: () => this.handleGenerate(),
			onSaveTemplate: this.config.onSaveTemplate ? () => this.config.onSaveTemplate(this.store.getState()) : void 0,
			onClear: this.config.onClear
		}, e, {
			hideTemplates: this.config.hideTemplates,
			hideGenerate: this.config.hideGenerate,
			readOnly: t
		});
	}
	buildCanvasPanel(e) {
		return KD({
			onSelectNode: (e) => this.store.selectNode(e),
			onSelectEdge: (e) => this.store.selectEdge(e),
			onDoubleClickNode: this.config.onDoubleClickNode ? (e) => {
				let t = this.store.getState(), n = t.nodes.find((t) => t.id === e);
				n && this.config.onDoubleClickNode(n, t);
			} : void 0,
			onMoveNode: (e, t, n) => this.store.updateNode(e, { position: {
				x: t,
				y: n
			} }),
			onCreateEdge: e ? () => {} : (e, t, n) => {
				this.handleCreateEdge(e, t, n);
			},
			onPortMouseDown: () => {}
		});
	}
	handleCreateEdge(e, t, n) {
		let r = this.store.getState().nodes.find((t) => t.id === e);
		if (n === Pk) {
			let i = this.store.getState().edges.filter((t) => t.sourceNodeId === e && t.linkType === Pk), a = new Set(i.flatMap((e) => e.finishingPositions || [])), o = r?.structureOptions?.groupSize || 4, s = 1;
			for (let e = 1; e <= o; e++) if (!a.has(e)) {
				s = e;
				break;
			}
			this.store.addEdge({
				sourceNodeId: e,
				targetNodeId: t,
				linkType: n,
				finishingPositions: [s]
			});
		} else if (n === Nk) {
			let i = this.store.getState().edges.filter((t) => t.sourceNodeId === e && t.linkType === Nk), a = new Set(i.map((e) => e.sourceRoundNumber)), o = r ? WE(r.structureType, r.drawSize, r.structureOptions) : 1, s = 1;
			for (let e = 1; e <= o; e++) if (!a.has(e)) {
				s = e;
				break;
			}
			this.store.addEdge({
				sourceNodeId: e,
				targetNodeId: t,
				linkType: n,
				sourceRoundNumber: s
			});
		} else {
			let i = n === Mk && r?.stage === Dk;
			this.store.addEdge({
				sourceNodeId: e,
				targetNodeId: t,
				linkType: n,
				...i && { targetRoundNumber: 1 }
			});
		}
	}
	render(e) {
		e.appendChild(this.layout.element);
	}
	destroy() {
		this.unsubscribe(), this.layout.destroy?.(), this.layout.element.remove();
	}
	autoLayout() {
		this.store.autoLayout();
		let e = this.store.getState();
		this.store.loadState(e);
	}
	getState() {
		return this.store.getState();
	}
	loadState(e) {
		this.store.loadState(e);
	}
	addDefaultStructure(e, t) {
		let n = t === jk, r = this.store.getState().nodes.filter((t) => t.stage === e).length, i = {
			[Ek]: n ? "Lucky Draw" : "Main Draw",
			[Dk]: `Qualifying ${r + 1}`,
			[Ok]: "Consolation",
			[kk]: `Playoff ${r + 1}`
		}, a = {
			[Ek]: n ? 11 : 32,
			[Dk]: 16,
			[Ok]: 16,
			[kk]: 4
		}[e] || 16, o = this.store.addNode({
			structureName: i[e] || e,
			stage: e,
			structureType: t || Ak,
			drawSize: a,
			...e === Dk && { qualifyingPositions: Math.floor(a / 4) }
		});
		this.scrollCanvasToNode(o);
	}
	scrollCanvasToNode(e) {
		let t = this.layout.element.querySelector(".tb-canvas");
		t && requestAnimationFrame(() => {
			let n = e.position.x + vD(e) + 40;
			n > t.scrollLeft + t.clientWidth && t.scrollTo({
				left: n - t.clientWidth,
				behavior: "smooth"
			});
		});
	}
	handleGenerate() {
		let e = this.store.getState(), t = BO(e);
		t.some((e) => e.severity === "error") && console.warn("Topology validation errors:", t), this.config.onGenerate && this.config.onGenerate(e);
	}
}, { MAIN: Ik, CONSOLATION: Lk, QUALIFYING: Rk, PLAY_OFF: zk, SINGLE_ELIMINATION: Bk, FEED_IN: Vk, FIRST_MATCH_LOSER_CONSOLATION: Hk, FEED_IN_CHAMPIONSHIP: Uk, COMPASS: Wk, WINNER: Gk, LOSER: Kk, ROUND_ROBIN: qk, AD_HOC: Jk, LUCKY_DRAW: Yk } = t, Xk = "POSITION";
function Zk(e, t) {
	let n = e.nodes.filter((e) => e.stage === Lk), r = e.nodes.filter((e) => e.stage === Rk), i = e.nodes.filter((e) => e.stage === zk);
	if (t.structureType === qk) return e.edges.some((n) => n.sourceNodeId === t.id && n.linkType === Xk && e.nodes.some((e) => e.id === n.targetNodeId && e.stage === zk)) ? "ROUND_ROBIN_WITH_PLAYOFF" : qk;
	if (t.structureType === Jk) return Jk;
	if (t.structureType === Vk) return Vk;
	if (t.structureType === Yk) return Yk;
	if (n.length === 7 && r.length === 0 && i.length === 0) {
		let n = e.edges.filter((e) => e.linkType === Kk && e.sourceNodeId === t.id), r = new Set(n.map((e) => e.sourceRoundNumber));
		if (r.has(1) && r.has(2) && r.has(3)) return Wk;
	}
	if (n.length === 1 && r.length === 0 && i.length === 0) {
		let r = n[0], i = e.edges.filter((e) => e.linkType === Kk && e.sourceNodeId === t.id && e.targetNodeId === r.id);
		if (r.structureType === Vk || i.length > 1) return Uk;
		if (i.length === 1 && i[0].sourceRoundNumber === 1) return Hk;
	}
	return Bk;
}
function Qk(e) {
	let t = e.nodes.find((e) => e.stage === Ik);
	if (!t) throw Error("No main structure node found");
	let n = e.nodes.filter((e) => e.stage === Rk), r = e.nodes.filter((e) => e.stage === zk), i = Zk(e, t);
	i === Bk && !rA(t.drawSize) && (i = Vk);
	let a = {
		drawName: e.drawName,
		drawType: i,
		drawSize: t.drawSize,
		matchUpFormat: t.matchUpFormat || void 0,
		structureOptions: t.structureOptions || void 0,
		automated: !0
	};
	n.length > 0 && tA(a, n, e.edges);
	let o = [];
	return $k(e, t, i, o), eA(e, t, r, a), {
		drawOptions: a,
		postGenerationMethods: o
	};
}
function $k(e, t, n, r) {
	let i = e.nodes.filter((e) => e.stage === Lk), a = e.edges.filter((e) => e.linkType === Kk && e.sourceNodeId === t.id && i.some((t) => t.id === e.targetNodeId)), o = [
		Hk,
		Uk,
		Wk
	];
	if (a.length === 0 || o.includes(n)) return;
	let s = /* @__PURE__ */ new Map();
	for (let e of a) s.has(e.targetNodeId) || s.set(e.targetNodeId, []), s.get(e.targetNodeId).push(e);
	for (let [e, t] of s) {
		let n = i.find((t) => t.id === e);
		if (!n) continue;
		let a = t.map((e) => ({
			sourceRoundNumber: e.sourceRoundNumber || 1,
			targetRoundNumber: e.targetRoundNumber || 1
		}));
		r.push({
			method: "attachConsolationStructures",
			params: {
				structureName: n.structureName,
				structureType: n.structureType,
				drawSize: n.drawSize,
				matchUpFormat: n.matchUpFormat || void 0,
				structureOptions: n.structureOptions || void 0,
				links: a
			}
		});
	}
}
function eA(e, t, n, r) {
	let i = t.structureType === qk, a = i ? e.edges.filter((e) => e.sourceNodeId === t.id && e.linkType === Xk && n.some((t) => t.id === e.targetNodeId)) : [];
	if (i && a.length > 0) {
		let e = /* @__PURE__ */ new Map();
		for (let t of a) e.has(t.targetNodeId) || e.set(t.targetNodeId, []), e.get(t.targetNodeId).push(t);
		let t = [];
		for (let [r, i] of e) {
			let e = n.find((e) => e.id === r);
			if (!e) continue;
			let a = Array.from(new Set(i.flatMap((e) => e.finishingPositions || []))).sort(), o = e.structureOptions?.playoffDrawType || Bk, s = {
				finishingPositions: a,
				structureName: e.structureName,
				drawType: o
			};
			o === qk && e.structureOptions?.groupSize && (s.structureOptions = { groupSize: e.structureOptions.groupSize }), t.push(s);
		}
		t.length > 0 && (r.structureOptions = {
			...r.structureOptions,
			playoffGroups: t
		});
	} else if (n.length > 0) {
		let i = nA(t.id, n, e.edges);
		i && (r.withPlayoffs = i);
	}
}
function tA(e, t, n) {
	let r = n.filter((e) => e.linkType === Gk && t.some((t) => t.id === e.sourceNodeId)), i = {};
	for (let e of t) {
		let t = r.find((t) => t.sourceNodeId === e.id), n = t?.targetRoundNumber || 1;
		i[n] || (i[n] = []), i[n].push({
			node: e,
			edge: t
		});
	}
	let a = 0;
	e.qualifyingProfiles = Object.entries(i).map(([e, t]) => {
		let n = t.map(({ node: e, edge: t }) => {
			let n = e.qualifyingPositions || t?.qualifyingPositions || Math.floor(e.drawSize / 4);
			return a += n, {
				structureName: e.structureName,
				drawType: e.structureType,
				drawSize: e.drawSize,
				qualifyingPositions: n,
				seedsCount: 0
			};
		});
		return {
			roundTarget: Number(e),
			structureProfiles: n
		};
	}), e.qualifiersCount = a, e.qualifyingPlaceholder = !0;
}
function nA(e, t, n) {
	let r = n.filter((n) => n.sourceNodeId === e && n.linkType === Kk && t.some((e) => e.id === n.targetNodeId));
	if (!r.length) return;
	let i = [], a = {}, o = {};
	for (let e of r) {
		if (!e.sourceRoundNumber) continue;
		let r = t.find((t) => t.id === e.targetNodeId);
		if (!r) continue;
		i.push({ [e.sourceRoundNumber]: 1 });
		let s = `0-${i.length}`;
		a[s] = {
			name: r.structureName,
			abbreviation: r.structureName.substring(0, 3)
		};
		let c = nA(r.id, t, n);
		c && (o[e.sourceRoundNumber] = c);
	}
	if (i.length) return {
		roundProfiles: i,
		...Object.keys(a).length > 0 && { playoffAttributes: a },
		...Object.keys(o).length > 0 && { roundPlayoffs: o }
	};
}
function rA(e) {
	return e > 0 && (e & e - 1) == 0;
}
//#endregion
//#region src/components/topology-builder/domain/generateDrawFromTopology.ts
var { MAIN: iA } = t, aA = () => "spl-layout", oA = () => "spl-left", sA = () => "spl-toggle", cA = () => "spl-center", lA = () => "spl-center-header", uA = () => "spl-center-title", dA = () => "spl-center-meta", fA = () => "spl-grid-slot", pA = () => "spl-right", mA = () => "spl-matchup-card", hA = () => "spl-card-title", gA = () => "spl-card-sides", _A = () => "spl-card-meta", vA = () => "spl-card-chips", yA = () => "spl-card-chip", bA = () => "sp-panel", xA = () => "sp-panel-header", SA = () => "sp-panel-title", CA = () => "sp-panel-meta", wA = () => "sp-date-strip", TA = () => "sp-date-chip", EA = () => "sp-badges", DA = () => "sp-catalog", OA = () => "sp-catalog-toolbar", kA = () => "sp-input", AA = () => "sp-select", jA = () => "sp-group", MA = () => "sp-group-header", NA = () => "sp-group-body", PA = () => "sp-group-chevron", FA = () => "sp-issues", IA = () => "sp-issue", LA = () => "sp-issue-code", RA = () => "sp-issue-msg", zA = () => "sp-inspector", BA = () => "sp-kv", VA = () => "sp-kv-key", HA = () => "sp-kv-value", UA = () => "sp-small";
//#endregion
//#region src/components/schedule-page/ui/schedulePageLayout.ts
function WA(e, t, n) {
	let r = !!n?.hideLeft, i = n?.catalogSide === "left", a = document.createElement("div");
	a.className = aA();
	let o = null, s = null;
	if (r) i ? a.classList.add("spl-catalog-left") : a.classList.add("spl-no-left");
	else {
		o = document.createElement("div"), o.className = oA(), s = document.createElement("button"), s.className = sA(), s.textContent = "◀", s.title = "Toggle sidebar", s.addEventListener("click", () => t.onToggleLeft()), o.appendChild(s);
		let n = document.createElement("div");
		n.className = "spl-left-content", n.style.cssText = "display:flex;flex-direction:column;gap:12px;flex:1;min-height:0", e.dateStrip.element.style.flex = "1", e.dateStrip.element.style.minHeight = "0", e.dateStrip.element.style.overflow = "auto", n.appendChild(e.dateStrip.element), e.issuesPanel.element.style.flex = "1", e.issuesPanel.element.style.minHeight = "0", e.issuesPanel.element.style.overflow = "auto", n.appendChild(e.issuesPanel.element), o.appendChild(n);
	}
	let c = e.courtGridSlot.element, l = document.createElement("div");
	l.className = pA(), e.matchUpCatalog.element.style.flex = "3", e.matchUpCatalog.element.style.minHeight = "0", e.matchUpCatalog.element.style.overflow = "auto", l.appendChild(e.matchUpCatalog.element), e.inspectorPanel.element.style.flex = "1", e.inspectorPanel.element.style.minHeight = "120px", e.inspectorPanel.element.style.overflow = "auto", l.appendChild(e.inspectorPanel.element), o && a.appendChild(o), i && r ? (a.appendChild(l), a.appendChild(c)) : (a.appendChild(c), a.appendChild(l));
	function u(t) {
		r || (t.leftCollapsed ? (a.classList.add("spl-left-collapsed"), s && (s.textContent = "▶")) : (a.classList.remove("spl-left-collapsed"), s && (s.textContent = "◀")), e.dateStrip.update(t), e.issuesPanel.update(t)), e.courtGridSlot.update(t), e.matchUpCatalog.update(t), e.inspectorPanel.update(t);
	}
	return {
		element: a,
		update: u
	};
}
//#endregion
//#region src/components/schedule-page/domain/utils.ts
function GA(e) {
	let t = e.sides;
	if (t?.length === 2) {
		let e = KA(t[0]), n = KA(t[1]);
		if (e && n) return `${e} vs ${n}`;
		if (e) return `${e} vs TBD`;
		if (n) return `TBD vs ${n}`;
	}
	return "TBD vs TBD";
}
function KA(e) {
	return e ? `${e.participantName ?? ""}${e.seedNumber ? ` [${e.seedNumber}]` : ""}` : "";
}
function qA(e) {
	let t = [
		e.eventName,
		e.drawName ?? "",
		e.roundName ?? ""
	];
	if (e.sides) for (let n of e.sides) n.participantName && t.push(n.participantName);
	return t.join(" ").toLowerCase();
}
//#endregion
//#region src/components/schedule-page/ui/inspectorPanel.ts
function JA() {
	let e = document.createElement("div");
	e.className = bA();
	let t = document.createElement("div");
	t.className = xA();
	let n = document.createElement("div");
	n.className = SA(), n.textContent = "Inspector", t.appendChild(n), e.appendChild(t);
	let r = document.createElement("div");
	r.className = zA(), e.appendChild(r);
	function i(e) {
		r.innerHTML = "";
		let t = e.selectedMatchUp;
		if (!t) {
			let e = document.createElement("div");
			e.className = UA(), e.textContent = "Select a matchUp in the catalog to see details.", r.appendChild(e);
			return;
		}
		if (YA(r, "Event", t.eventName), YA(r, "Draw", t.drawName ?? t.drawId), YA(r, "Round", t.roundName ?? `Round ${t.roundNumber}`), YA(r, "Type", t.matchUpType ?? "—"), YA(r, "Format", t.matchUpFormat ?? "—"), YA(r, "Scheduled", t.isScheduled ? "Yes" : "No"), t.scheduledTime && YA(r, "Time", t.scheduledTime), t.scheduledCourtName && YA(r, "Court", t.scheduledCourtName), t.sides?.length) {
			let e = document.createElement("div");
			e.className = UA(), e.style.marginTop = "8px", e.textContent = "Participants:", r.appendChild(e);
			let n = document.createElement("div");
			n.className = "spl-inspector-sides";
			for (let e of t.sides) {
				let t = document.createElement("div");
				t.className = "spl-inspector-side";
				let r = document.createElement("span");
				if (r.textContent = KA(e) || "TBD", t.appendChild(r), e.ranking) {
					let n = document.createElement("span");
					n.className = "spl-inspector-seed", n.textContent = `#${e.ranking}`, t.appendChild(n);
				}
				n.appendChild(t);
			}
			r.appendChild(n);
		}
	}
	return {
		element: e,
		update: i
	};
}
function YA(e, t, n) {
	let r = document.createElement("div");
	r.className = BA();
	let i = document.createElement("div");
	i.className = VA(), i.textContent = t;
	let a = document.createElement("div");
	a.className = HA(), a.textContent = n, r.appendChild(i), r.appendChild(a), e.appendChild(r);
}
//#endregion
//#region src/components/schedule-page/domain/matchUpCatalogProjections.ts
var XA = new Set([
	"COMPLETED",
	"RETIRED",
	"WALKOVER",
	"DEFAULTED",
	"DOUBLE_WALKOVER",
	"DOUBLE_DEFAULT",
	"CANCELLED",
	"ABANDONED",
	"DEAD_RUBBER"
]);
function ZA(e) {
	return !!e && XA.has(e);
}
function QA(e, t, n = "dim", r, i = !1) {
	let a = t.toLowerCase().trim();
	return e.filter((e) => n === "hide" && e.isScheduled || !i && ZA(e.matchUpStatus) || r && (r.eventType && e.matchUpType !== r.eventType || r.eventName && e.eventName !== r.eventName || r.drawName && (e.drawName ?? e.drawId) !== r.drawName || r.gender && e.gender !== r.gender || r.roundName && e.roundName !== r.roundName) ? !1 : a ? qA(e).includes(a) : !0);
}
function $A(e, t) {
	let n = /* @__PURE__ */ new Map(), r = (e) => t === "draw" ? `${e.eventName} \u2014 ${e.drawName ?? e.drawId}` : t === "round" ? e.roundName ?? `Round ${e.roundNumber}` : t === "structure" ? `${e.eventName} \u2014 ${e.structureId}` : e.eventName;
	for (let t of e) {
		let e = r(t), i = n.get(e);
		i ? i.push(t) : n.set(e, [t]);
	}
	return new Map([...n.entries()].sort((e, t) => e[0].localeCompare(t[0])));
}
//#endregion
//#region src/components/schedule-page/ui/matchUpCard.ts
function ej(e, t) {
	let n = document.createElement("div");
	n.className = mA(), n.setAttribute("data-matchup-id", e.matchUpId);
	let r = ZA(e.matchUpStatus);
	e.isScheduled ? (n.classList.add("scheduled"), n.draggable = !1) : r ? (n.classList.add("completed"), n.draggable = !1) : (n.draggable = !0, n.addEventListener("dragstart", (t) => {
		t.stopPropagation(), t.dataTransfer.setDragImage(n, n.offsetWidth / 2, 20), t.dataTransfer.setData("application/json", JSON.stringify({
			type: "CATALOG_MATCHUP",
			matchUp: e
		})), t.dataTransfer.effectAllowed = "copyMove";
	})), t.onClick && n.addEventListener("click", (n) => {
		n.stopPropagation(), t.onClick(e);
	});
	let i = document.createElement("div");
	i.className = hA(), i.textContent = `${e.eventName} \u2014 ${e.roundName ?? "Round " + e.roundNumber}`, n.appendChild(i);
	let a = document.createElement("div");
	a.className = gA(), a.textContent = GA(e), n.appendChild(a);
	let o = document.createElement("div");
	o.className = _A();
	let s = [];
	e.drawName && s.push(e.drawName), e.matchUpType && s.push(e.matchUpType.toLowerCase()), o.textContent = s.join(" · "), n.appendChild(o);
	let c = document.createElement("div");
	if (c.className = vA(), e.scheduledTime && c.appendChild(tj(e.scheduledTime, "time")), e.scheduledCourtName && c.appendChild(tj(e.scheduledCourtName, "court")), e.matchUpFormat && c.appendChild(tj(e.matchUpFormat, "type")), r && e.matchUpStatus) {
		let t = e.matchUpStatus.replace(/_/g, " ");
		c.appendChild(tj(t, "status"));
	}
	if (c.children.length && n.appendChild(c), e.isScheduled) {
		let e = document.createElement("span");
		e.className = "spl-matchup-check", e.textContent = "✓", n.appendChild(e);
	}
	return n;
}
function tj(e, t) {
	let n = document.createElement("div");
	return n.className = yA() + " " + t, n.textContent = e, n;
}
//#endregion
//#region src/components/schedule-page/ui/matchUpCatalog.ts
function nj(e, t) {
	let n = /* @__PURE__ */ new Set();
	for (let r of e) {
		let e = t(r);
		e && n.add(e);
	}
	return [...n].sort();
}
function rj(e) {
	let t = document.createElement("div");
	t.className = bA();
	let n = "spl-catalog-drop-over", r = /* @__PURE__ */ new Set(), i = null, a, o = {};
	t.addEventListener("dragover", (e) => {
		e.preventDefault(), t.classList.add(n), e.dataTransfer.dropEffect = "move";
	}), t.addEventListener("dragleave", (e) => {
		t.contains(e.relatedTarget) || t.classList.remove(n);
	}), t.addEventListener("drop", (r) => {
		if (t.classList.remove(n), r.preventDefault(), !e.onDropRemove) return;
		let i;
		try {
			i = JSON.parse(r.dataTransfer.getData("application/json"));
		} catch {
			return;
		}
		(i.type === "CATALOG_MATCHUP" || i.type === "GRID_MATCHUP") && e.onDropRemove(i.matchUp.matchUpId);
	});
	let s = document.createElement("div");
	s.className = xA();
	let c = document.createElement("div");
	c.className = "spl-catalog-title-row";
	let l = document.createElement("div");
	l.className = SA(), l.textContent = "MatchUp Catalog";
	let u = document.createElement("button");
	u.className = "spl-catalog-filter-btn", u.title = "Filter matchUps", u.innerHTML = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polygon points=\"22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3\"/></svg>", c.appendChild(l), c.appendChild(u);
	let d = document.createElement("div");
	d.className = CA(), s.appendChild(c), s.appendChild(d), t.appendChild(s);
	let f = document.createElement("div");
	f.className = OA();
	let p = document.createElement("input");
	p.type = "text", p.placeholder = "Search matchUps...", p.className = kA(), p.addEventListener("input", () => e.onSearchChange(p.value));
	let m = document.createElement("select");
	m.className = AA();
	for (let [e, t] of [
		["event", "By Event"],
		["draw", "By Draw"],
		["round", "By Round"],
		["structure", "By Structure"]
	]) {
		let n = document.createElement("option");
		n.value = e, n.textContent = t, m.appendChild(n);
	}
	m.addEventListener("change", () => e.onGroupByChange(m.value)), f.appendChild(p), f.appendChild(m), t.appendChild(f);
	function h() {
		a &&= (a.destroy(), void 0);
	}
	function g() {
		return !!(o.eventType || o.eventName || o.drawName || o.gender || o.roundName);
	}
	function _() {
		u.classList.toggle("active", g());
	}
	function v() {
		let t = i?.matchUpCatalog ?? [], n = document.createElement("div");
		n.className = "spl-filter-popover";
		let r = document.createElement("div");
		r.className = "spl-filter-header";
		let a = document.createElement("button");
		a.className = "spl-filter-clear-btn", a.textContent = "Clear All", a.addEventListener("click", (t) => {
			t.stopPropagation(), o = {}, e.onFilterChange(o), _();
			for (let e of n.querySelectorAll("select")) e.value = "";
		}), r.appendChild(a);
		let s = document.createElement("button");
		s.className = "spl-filter-close-btn", s.textContent = "×", s.addEventListener("click", (e) => {
			e.stopPropagation(), h();
		}), r.appendChild(s), n.appendChild(r);
		let c = [
			{
				label: "All Event Types",
				key: "eventType",
				values: nj(t, (e) => e.matchUpType)
			},
			{
				label: "All Events",
				key: "eventName",
				values: nj(t, (e) => e.eventName)
			},
			{
				label: "All Flights",
				key: "drawName",
				values: nj(t, (e) => e.drawName)
			},
			{
				label: "All Genders",
				key: "gender",
				values: nj(t, (e) => e.gender)
			},
			{
				label: "All Rounds",
				key: "roundName",
				values: nj(t, (e) => e.roundName)
			}
		];
		for (let t of c) {
			if (t.values.length < 2) continue;
			let r = document.createElement("label");
			r.className = "spl-filter-label", r.textContent = t.label, n.appendChild(r);
			let i = document.createElement("select");
			i.className = "spl-filter-select";
			let a = document.createElement("option");
			a.value = "", a.textContent = t.label, i.appendChild(a);
			for (let e of t.values) {
				let t = document.createElement("option");
				t.value = e, t.textContent = e, i.appendChild(t);
			}
			i.value = o[t.key] ?? "", i.addEventListener("change", () => {
				o = {
					...o,
					[t.key]: i.value || void 0
				}, e.onFilterChange(o), _();
			}), n.appendChild(i);
		}
		let l = document.createElement("label");
		l.className = "spl-filter-toggle";
		let u = document.createElement("input");
		u.type = "checkbox", u.checked = i?.showScheduled ?? !1, u.addEventListener("change", () => {
			e.onShowScheduledChange?.(u.checked);
		}), l.appendChild(u), l.appendChild(document.createTextNode(" Show assigned")), n.appendChild(l);
		let d = document.createElement("label");
		d.className = "spl-filter-toggle";
		let f = document.createElement("input");
		return f.type = "checkbox", f.checked = i?.showCompleted ?? !1, f.addEventListener("change", () => {
			e.onShowCompletedChange(f.checked);
		}), d.appendChild(f), d.appendChild(document.createTextNode(" Show completed")), n.appendChild(d), n;
	}
	u.addEventListener("click", () => {
		h(), a = Am(u, {
			content: v(),
			placement: "bottom-start",
			interactive: !0,
			trigger: "manual",
			appendTo: () => t,
			onClickOutside: () => h(),
			theme: ""
		}), a.show();
	});
	let y = document.createElement("div");
	y.className = DA(), t.appendChild(y);
	function b(t) {
		i = t, o = t.catalogFilters ?? {}, _();
		let n = t.showScheduled ? t.scheduledBehavior : "hide", a = QA(t.matchUpCatalog, t.catalogSearchQuery, n, t.catalogFilters, t.showCompleted), s = $A(a, t.catalogGroupBy);
		d.textContent = `${a.filter((e) => !e.isScheduled).length} unscheduled`, p.value !== t.catalogSearchQuery && (p.value = t.catalogSearchQuery), m.value !== t.catalogGroupBy && (m.value = t.catalogGroupBy), y.innerHTML = "";
		for (let [n, a] of s) {
			let o = document.createElement("div");
			o.className = jA();
			let s = r.has(n), c = document.createElement("div");
			c.className = MA();
			let l = document.createElement("span");
			l.className = PA(), l.textContent = s ? "▶" : "▼";
			let u = document.createElement("span");
			u.textContent = `${n} (${a.length})`, c.appendChild(l), c.appendChild(u), c.addEventListener("click", () => {
				r.has(n) ? r.delete(n) : r.add(n), i && b(i);
			});
			let d = document.createElement("div");
			d.className = NA(), s && (d.style.display = "none");
			for (let n of a) {
				let r = ej(n, { onClick: (t) => e.onMatchUpSelected?.(t) });
				t.selectedMatchUp?.matchUpId === n.matchUpId && r.classList.add("selected"), d.appendChild(r);
			}
			o.appendChild(c), o.appendChild(d), y.appendChild(o);
		}
	}
	return {
		element: t,
		update: b
	};
}
//#endregion
//#region src/components/schedule-page/domain/scheduleIssues.ts
function ij(e) {
	let t = {
		ERROR: [],
		WARN: [],
		INFO: []
	}, n = {}, r = {
		total: e.length,
		ERROR: 0,
		WARN: 0,
		INFO: 0
	}, i = {}, a = (e) => e === "ERROR" ? 0 : e === "WARN" ? 1 : 2;
	for (let a of e) if (t[a.severity].push(a), r[a.severity]++, a.date) {
		(n[a.date] ??= []).push(a);
		let e = i[a.date] ??= {
			total: 0,
			ERROR: 0,
			WARN: 0,
			INFO: 0
		};
		e.total++, e[a.severity]++;
	}
	let o = (e, t) => a(e.severity) - a(t.severity) || e.message.localeCompare(t.message), s = [...e].sort(o);
	for (let e of Object.keys(t)) t[e].sort(o);
	for (let e of Object.keys(n)) n[e].sort(o);
	return {
		all: s,
		bySeverity: t,
		byDate: n,
		counts: r,
		countsByDate: i
	};
}
//#endregion
//#region src/components/schedule-page/ui/issuesPanel.ts
var aj = "spl-cell--issue-pulse";
function oj() {
	let e = document.createElement("div");
	e.className = bA();
	let t = document.createElement("div");
	t.className = xA();
	let n = document.createElement("div");
	n.className = SA(), n.textContent = "Issues";
	let r = document.createElement("div");
	r.className = CA(), t.appendChild(n), t.appendChild(r), e.appendChild(t);
	let i = document.createElement("div");
	i.className = FA(), e.appendChild(i);
	function a(e) {
		let t = ij(e.issues);
		if (r.textContent = `${t.counts.total} total (${t.counts.ERROR} errors)`, i.innerHTML = "", !t.all.length) {
			let e = document.createElement("div");
			e.className = UA(), e.textContent = "No scheduling conflicts.", i.appendChild(e);
			return;
		}
		for (let e of t.all.slice(0, 30)) {
			let t = document.createElement("div");
			t.className = IA(), e.severity === "ERROR" ? t.classList.add("error") : e.severity === "WARN" ? t.classList.add("warn") : t.classList.add("info");
			let n = document.createElement("div");
			n.className = LA(), n.textContent = e.severity;
			let r = document.createElement("div");
			if (r.className = RA(), e.participants) {
				if (e.prefix) {
					let t = document.createElement("span");
					t.textContent = e.prefix, t.style.opacity = "0.7", r.appendChild(t);
				}
				let t = document.createElement("span");
				t.textContent = (e.issueType || "") + ": ", t.style.opacity = "0.7", r.appendChild(t);
				let n = document.createElement("span");
				if (n.textContent = e.participants, n.style.color = "var(--spl-issue-participant1, #4fc3f7)", n.style.fontWeight = "600", r.appendChild(n), e.conflictParticipants?.length) {
					let t = document.createElement("span");
					t.textContent = " conflicts with ", t.style.opacity = "0.7", r.appendChild(t), e.conflictParticipants.forEach((e, t) => {
						if (t > 0) {
							let e = document.createElement("span");
							e.textContent = ", ", e.style.opacity = "0.7", r.appendChild(e);
						}
						let n = document.createElement("span");
						n.textContent = e, n.style.color = "var(--spl-issue-participant2, #ffb74d)", n.style.fontWeight = "600", r.appendChild(n);
					});
				}
			} else r.textContent = e.message;
			if (e.matchUpId) {
				t.style.cursor = "pointer";
				let n = e.matchUpId;
				t.addEventListener("click", () => {
					console.log("[issuesPanel] clicked issue row, matchUpId:", n), o(n);
				});
			} else console.log("[issuesPanel] issue has no matchUpId:", e.message);
			t.appendChild(n), t.appendChild(r), i.appendChild(t);
		}
	}
	function o(e) {
		let t = `.spl-grid-cell[data-matchup-id="${e}"]`, n = document.querySelector(t);
		console.log("[issuesPanel] scrollToMatchUp selector:", t, "found:", !!n), n && (n.scrollIntoView({
			behavior: "smooth",
			block: "center",
			inline: "center"
		}), n.classList.remove(aj), n.offsetWidth, n.classList.add(aj), n.addEventListener("animationend", () => n.classList.remove(aj), { once: !0 }));
	}
	return {
		element: e,
		update: a
	};
}
//#endregion
//#region src/components/schedule-page/ui/dateStrip.ts
function sj(e) {
	let t = document.createElement("div");
	t.className = bA();
	let n = document.createElement("div");
	n.className = xA();
	let r = document.createElement("div");
	r.className = SA(), r.textContent = "Dates";
	let i = document.createElement("div");
	i.className = CA(), n.appendChild(r), n.appendChild(i), t.appendChild(n);
	let a = document.createElement("div");
	a.className = wA(), t.appendChild(a);
	function o(t) {
		let n = t.scheduleDates;
		i.textContent = `${n.length} dates`, a.innerHTML = "";
		for (let r of n) {
			let n = document.createElement("div");
			n.className = TA(), r.date === t.selectedDate && n.classList.add("selected"), r.isActive || n.classList.add("inactive"), n.setAttribute("data-date", r.date);
			let i = document.createElement("div"), o = document.createElement("div");
			o.style.cssText = "font-weight:800;font-size:0.75rem", o.textContent = r.date;
			let s = document.createElement("div");
			s.style.cssText = "font-size:0.6875rem;color:var(--sp-muted)", s.textContent = r.isActive ? "Active" : "Inactive", i.appendChild(o), i.appendChild(s);
			let c = document.createElement("div");
			if (c.className = EA(), r.matchUpCount != null) {
				let e = document.createElement("div");
				e.className = "spl-date-badge matchups", e.textContent = `${r.matchUpCount} matchUps`, c.appendChild(e);
			}
			if (r.issueCount && r.issueCount > 0) {
				let e = document.createElement("div");
				e.className = "spl-date-badge issues", e.textContent = `${r.issueCount} issues`, c.appendChild(e);
			}
			n.appendChild(i), n.appendChild(c), n.addEventListener("click", () => e.onDateSelected(r.date)), a.appendChild(n);
		}
	}
	return {
		element: t,
		update: o
	};
}
//#endregion
//#region src/components/schedule-page/ui/courtGridSlot.ts
function cj(e, t, n) {
	let r = document.createElement("div");
	r.className = cA();
	let i = document.createElement("div");
	i.className = lA();
	let a = document.createElement("div");
	a.className = uA(), a.textContent = "Court Grid";
	let o = document.createElement("div");
	o.className = dA(), i.appendChild(a), i.appendChild(o), r.appendChild(i);
	let s = document.createElement("div");
	s.className = fA(), n?.gridMaxHeight && (s.style.maxHeight = n.gridMaxHeight), e && s.appendChild(e), s.addEventListener("dragover", (e) => {
		e.preventDefault(), e.dataTransfer.dropEffect = "move";
	}), s.addEventListener("drop", (e) => {
		if (e.preventDefault(), !t.onMatchUpDrop) return;
		let n;
		try {
			n = JSON.parse(e.dataTransfer.getData("application/json"));
		} catch {
			return;
		}
		(n.type === "CATALOG_MATCHUP" || n.type === "GRID_MATCHUP") && t.onMatchUpDrop(n, e);
	}), r.appendChild(s);
	function c(e) {
		o.textContent = e.selectedDate ?? "No date selected";
	}
	return {
		element: r,
		update: c
	};
}
//#endregion
//#region src/components/schedule-page/engine/schedulePageStore.ts
var lj = class {
	constructor(e) {
		this.listeners = /* @__PURE__ */ new Set(), this.config = e, this.state = {
			matchUpCatalog: e.matchUpCatalog,
			scheduleDates: e.scheduleDates,
			issues: e.issues ?? [],
			selectedDate: e.scheduleDates[0]?.date ?? null,
			selectedMatchUp: null,
			catalogSearchQuery: "",
			catalogGroupBy: "event",
			catalogFilters: {},
			showCompleted: !1,
			showScheduled: !1,
			scheduledBehavior: e.scheduledBehavior ?? "dim",
			schedulingMode: e.schedulingMode ?? "immediate",
			pendingActions: [],
			hasUnsavedChanges: !1,
			leftCollapsed: !!e.hideLeft,
			hideLeft: !!e.hideLeft
		};
	}
	getState() {
		return this.state;
	}
	setMatchUpCatalog(e) {
		this.setState({ matchUpCatalog: e }), this.state.selectedMatchUp && (e.some((e) => e.matchUpId === this.state.selectedMatchUp?.matchUpId) || this.setState({ selectedMatchUp: null }));
	}
	setScheduleDates(e) {
		this.setState({ scheduleDates: e });
	}
	setIssues(e) {
		this.setState({ issues: e });
	}
	handleMatchUpDrop(e, t) {
		if (this.state.schedulingMode === "immediate") this.config.onMatchUpDrop?.(e, t);
		else {
			let n = {
				kind: "schedule",
				matchUpId: e.matchUp.matchUpId,
				matchUp: e.matchUp,
				event: t
			};
			this.setState({
				pendingActions: [...this.state.pendingActions, n],
				hasUnsavedChanges: !0
			});
		}
	}
	handleMatchUpRemove(e) {
		if (this.state.schedulingMode === "immediate") this.config.onMatchUpRemove?.(e);
		else {
			let t = this.state.pendingActions.findIndex((t) => t.kind === "schedule" && t.matchUpId === e);
			if (t >= 0) {
				let e = [...this.state.pendingActions];
				e.splice(t, 1), this.setState({
					pendingActions: e,
					hasUnsavedChanges: e.length > 0
				});
			} else {
				let t = {
					kind: "unschedule",
					matchUpId: e
				};
				this.setState({
					pendingActions: [...this.state.pendingActions, t],
					hasUnsavedChanges: !0
				});
			}
		}
	}
	save() {
		let e = this.state.pendingActions;
		return e.length ? (this.config.onBulkSave?.(e), this.setState({
			pendingActions: [],
			hasUnsavedChanges: !1
		}), e) : [];
	}
	discardPending() {
		this.setState({
			pendingActions: [],
			hasUnsavedChanges: !1
		});
	}
	getPendingActions() {
		return this.state.pendingActions;
	}
	selectDate(e) {
		this.state.selectedDate !== e && (this.setState({ selectedDate: e }), this.config.onDateSelected?.(e));
	}
	selectMatchUp(e) {
		this.setState({ selectedMatchUp: e }), this.config.onMatchUpSelected?.(e);
	}
	setCatalogSearch(e) {
		this.setState({ catalogSearchQuery: e });
	}
	setCatalogGroupBy(e) {
		this.setState({ catalogGroupBy: e });
	}
	setCatalogFilters(e) {
		this.setState({ catalogFilters: e });
	}
	setShowCompleted(e) {
		this.setState({ showCompleted: e });
	}
	setShowScheduled(e) {
		this.setState({ showScheduled: e });
	}
	toggleLeftPanel() {
		this.setState({ leftCollapsed: !this.state.leftCollapsed });
	}
	subscribe(e) {
		return this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	setState(e) {
		this.state = {
			...this.state,
			...e
		}, this.emit();
	}
	emit() {
		for (let e of this.listeners) e(this.state);
	}
}, uj = class {
	constructor(e) {
		this.container = null, this.store = new lj(e), this.layout = WA({
			dateStrip: sj({ onDateSelected: (e) => this.store.selectDate(e) }),
			issuesPanel: oj(),
			courtGridSlot: cj(e.courtGridElement, { onMatchUpDrop: (e, t) => {
				this.store.handleMatchUpDrop(e, t);
			} }, { gridMaxHeight: e.gridMaxHeight }),
			matchUpCatalog: rj({
				onSearchChange: (e) => this.store.setCatalogSearch(e),
				onGroupByChange: (e) => this.store.setCatalogGroupBy(e),
				onFilterChange: (e) => this.store.setCatalogFilters(e),
				onShowCompletedChange: (e) => this.store.setShowCompleted(e),
				onShowScheduledChange: (e) => this.store.setShowScheduled(e),
				onMatchUpSelected: (e) => this.store.selectMatchUp(e),
				onDropRemove: (e) => {
					this.store.handleMatchUpRemove(e);
				}
			}),
			inspectorPanel: JA()
		}, { onToggleLeft: () => this.store.toggleLeftPanel() }, {
			hideLeft: e.hideLeft,
			catalogSide: e.catalogSide
		}), this.unsubscribe = this.store.subscribe((e) => {
			this.layout.update(e);
		}), this.layout.update(this.store.getState());
	}
	render(e) {
		this.container = e, e.appendChild(this.layout.element);
	}
	destroy() {
		this.unsubscribe(), this.container && this.layout.element.parentNode === this.container && this.layout.element.remove(), this.container = null;
	}
	setMatchUpCatalog(e) {
		this.store.setMatchUpCatalog(e);
	}
	setScheduleDates(e) {
		this.store.setScheduleDates(e);
	}
	setIssues(e) {
		this.store.setIssues(e);
	}
	save() {
		return this.store.save();
	}
	discardPending() {
		this.store.discardPending();
	}
	get hasUnsavedChanges() {
		return this.store.getState().hasUnsavedChanges;
	}
	getStore() {
		return this.store;
	}
}, dj = "spl-cell--conflict-highlight", fj = "spl-cell--complete", pj = {
	header: ["time"],
	body: ["eventRound", "participants"],
	footer: ["score"],
	participantDisplay: {
		nameFormat: "full",
		showSeed: !1,
		showRanking: !1,
		showNationality: !1,
		boldWinner: !0,
		showPotentials: !0
	}
};
function mj(e, t) {
	let n = t ?? pj;
	return e.isBlocked ? hj(e) : e.matchUpId ? _j(e, n) : gj();
}
function hj(e) {
	let t = document.createElement("div");
	t.className = "spl-grid-cell spl-cell--blocked";
	let n = e.booking?.bookingType || "BLOCKED";
	t.dataset.bookingType = n;
	let r = document.createElement("div");
	r.className = "spl-grid-cell__block-label";
	let i = document.createElement("div");
	if (i.className = "spl-grid-cell__block-type", i.textContent = n, r.appendChild(i), e.booking?.rowCount) {
		let t = document.createElement("div");
		t.className = "spl-grid-cell__block-rows", t.textContent = `${e.booking.rowCount} rows`, r.appendChild(t);
	}
	if (e.booking?.notes) {
		let t = document.createElement("div");
		t.className = "spl-grid-cell__block-notes", t.textContent = e.booking.notes, r.appendChild(t);
	}
	return t.appendChild(r), t;
}
function gj() {
	let e = document.createElement("div");
	return e.className = "spl-grid-cell spl-cell--empty", e;
}
function _j(e, t) {
	let n = document.createElement("div");
	if (n.className = "spl-grid-cell", n.dataset.matchupId = e.matchUpId, e.drawId && (n.dataset.drawId = e.drawId), e.gender && (n.dataset.gender = e.gender), vj(n, e), t.header.length) {
		let r = document.createElement("div");
		r.className = "spl-grid-cell__header", yj(r, t.header, e, t), n.appendChild(r);
	}
	if (t.body.length) {
		let r = document.createElement("div");
		r.className = "spl-grid-cell__body", yj(r, t.body, e, t), n.appendChild(r);
	}
	if (t.footer.length) {
		let r = document.createElement("div");
		r.className = "spl-grid-cell__footer", yj(r, t.footer, e, t), n.appendChild(r);
	}
	return e.issueIds?.length && (n.addEventListener("mouseenter", () => {
		n.classList.add(dj);
		for (let t of e.issueIds) document.querySelectorAll(`[data-matchup-id="${t}"]`).forEach((e) => e.classList.add(dj));
	}), n.addEventListener("mouseleave", () => {
		n.classList.remove(dj);
		for (let t of e.issueIds) document.querySelectorAll(`[data-matchup-id="${t}"]`).forEach((e) => e.classList.remove(dj));
	})), n;
}
function vj(e, t) {
	let n = t.matchUpStatus?.toUpperCase();
	n === "COMPLETED" || n === "RETIRED" || n === "DEFAULTED" || n === "WALKOVER" ? e.classList.add(fj) : n === "IN_PROGRESS" ? e.classList.add("spl-cell--inprogress") : n === "ABANDONED" ? e.classList.add("spl-cell--abandoned") : n === "CANCELLED" ? e.classList.add("spl-cell--cancelled") : n === "DOUBLE_WALKOVER" && e.classList.add("spl-cell--double-walkover");
	let r = t.scheduleState?.toUpperCase();
	r === "SCHEDULE_ERROR" || r === "ERROR" ? e.classList.add("spl-cell--error") : r === "SCHEDULE_CONFLICT" || r === "CONFLICT" ? e.classList.add("spl-cell--conflict") : r === "SCHEDULE_WARNING" || r === "WARNING" ? e.classList.add("spl-cell--warning") : (r === "SCHEDULE_ISSUE" || r === "ISSUE") && e.classList.add("spl-cell--issue"), (t.issueType === "DOUBLE_BOOKING" || t.issueType === "courtDoubleBooking") && e.classList.add("spl-cell--double-booking");
}
function yj(e, t, n, r) {
	for (let i of t) {
		let t = bj(i, n, r);
		t && e.appendChild(t);
	}
}
function bj(e, t, n) {
	switch (e) {
		case "time": return xj(t);
		case "eventRound": return Sj(t);
		case "participants": return Cj(t, n.participantDisplay);
		case "score": return Oj(t);
		case "matchUpStatus": return kj(t);
		case "matchUpFormat": return Aj(t);
		case "umpire": return jj(t);
		default: return null;
	}
}
function xj(e) {
	let t = e.schedule?.scheduledTime || e.schedule?.startTime, n = e.schedule?.timeModifiers, r = e.schedule?.courtAnnotation;
	if (!t && !n?.length && !r) return null;
	let i = document.createElement("div");
	i.className = "spl-grid-cell__time";
	let a = [];
	if (n?.length && a.push(n.join(" ")), t && a.push(t), i.textContent = a.join(" ") || "", r) {
		let e = document.createElement("span");
		e.className = "spl-grid-cell__court-annotation", e.textContent = ` ${r}`, i.appendChild(e);
	}
	return i;
}
function Sj(e) {
	let t = [e.eventName, e.roundName].filter(Boolean);
	if (!t.length) return null;
	let n = document.createElement("div");
	return n.className = "spl-grid-cell__event-round", n.textContent = t.join(" "), n;
}
function Cj(e, t) {
	let n = t ?? pj.participantDisplay, r = document.createElement("div");
	r.className = "spl-grid-cell__participants";
	let i = e.sides || [], a = e.matchUpStatus?.toUpperCase() === "BYE", o = i.some((e) => e.bye);
	if (i.length === 0 && n.showPotentials !== !1 && e.potentialParticipants?.length) {
		for (let t = 0; t < e.potentialParticipants.length; t++) {
			t > 0 && r.appendChild(Ej());
			let n = e.potentialParticipants[t].map((e) => e?.participantName || "TBD").join(" / "), i = document.createElement("div");
			i.className = "spl-grid-cell__side spl-grid-cell__potential", i.textContent = n || "TBD", r.appendChild(i);
		}
		return r;
	}
	if (i.length === 0) return null;
	for (let t = 0; t < i.length; t++) {
		let a = i[t];
		a.bye ? r.appendChild(Tj()) : (t > 0 && !i[t - 1]?.bye && r.appendChild(Ej()), r.appendChild(wj(a, e, n, a.sideNumber ?? t + 1)));
	}
	return (a || o) && i.length === 1 && !i[0].bye && r.appendChild(Tj()), r;
}
function wj(e, t, n, r) {
	let i = document.createElement("div");
	i.className = "spl-grid-cell__side";
	let a = document.createElement("span");
	a.className = "spl-grid-cell__name";
	let o = Dj(e.participantName, n.nameFormat) || "TBD";
	if (n.showSeed && e.seedNumber && (o += ` [${e.seedNumber}]`), n.showRanking && e.ranking && (o += ` (#${e.ranking})`), n.showNationality && e.nationality && (o += ` ${e.nationality}`), a.textContent = o, n.boldWinner !== !1 && t.winningSide === r && (a.style.fontWeight = "bold"), i.appendChild(a), e.teamName) {
		let t = document.createElement("div");
		t.className = "spl-grid-cell__team-name", t.textContent = e.teamName, i.appendChild(t);
	}
	return i;
}
function Tj() {
	let e = document.createElement("div");
	return e.className = "spl-grid-cell__bye", e.textContent = "BYE", e;
}
function Ej() {
	let e = document.createElement("div");
	return e.className = "spl-grid-cell__vs", e.textContent = "vs.", e;
}
function Dj(e, t) {
	if (!e) return "";
	switch (t) {
		case "last": return e.includes(",") ? e.split(",")[0].trim() : e.trim().split(/\s+/).at(-1);
		case "lastFirst": {
			if (e.includes(",")) return e.trim();
			let t = e.trim().split(/\s+/);
			return t.length < 2 ? e : `${t.at(-1)}, ${t.slice(0, -1).join(" ")}`;
		}
		case "firstLast": {
			if (!e.includes(",")) return e.trim();
			let [t, ...n] = e.split(",");
			return `${n.join(",").trim()} ${t.trim()}`;
		}
		default: return e;
	}
}
function Oj(e) {
	let t = e.score?.scoreStringSide1, n = e.matchUpStatus?.toUpperCase(), r = n === "WALKOVER" ? "WALKOVER" : n === "DEFAULTED" ? "DEFAULT" : n === "RETIRED" ? "RET." : n === "DOUBLE_WALKOVER" ? "D.W/O" : n === "ABANDONED" ? "ABN." : null;
	if (!t && !r) return null;
	let i = document.createElement("div");
	return i.className = "spl-grid-cell__score", i.textContent = t || r || "", i;
}
function kj(e) {
	if (!e.matchUpStatus) return null;
	let t = document.createElement("div");
	t.className = "spl-grid-cell__status-badge";
	let n = e.matchUpStatus.toUpperCase();
	return n === "IN_PROGRESS" ? (t.textContent = "LIVE", t.classList.add("spl-grid-cell__status-badge--live")) : n === "COMPLETED" || n === "RETIRED" || n === "DEFAULTED" || n === "WALKOVER" ? (t.textContent = "DONE", t.classList.add("spl-grid-cell__status-badge--done")) : t.textContent = e.matchUpStatus.replaceAll("_", " "), t;
}
function Aj(e) {
	if (!e.matchUpFormat) return null;
	let t = document.createElement("div");
	return t.className = "spl-grid-cell__format", t.textContent = e.matchUpFormat, t;
}
function jj(e) {
	if (!e.umpire) return null;
	let t = document.createElement("div");
	return t.className = "spl-grid-cell__umpire", t.textContent = e.umpire, t;
}
function Mj(e) {
	if (!e) return { matchUpId: "" };
	if (e.isBlocked) return {
		matchUpId: "",
		isBlocked: !0,
		booking: e.booking
	};
	let t = (e.sides || []).map((e, t) => ({
		sideNumber: e.sideNumber ?? t + 1,
		participantName: e.participant?.participantName ?? e.participantName,
		participantId: e.participantId ?? e.participant?.participantId,
		seedNumber: e.seedValue ?? e.seedNumber,
		ranking: e.ranking,
		nationality: e.participant?.nationalityCode ?? e.participant?.person?.nationalityCode ?? e.nationalityCode,
		teamName: e.teamParticipant?.participantName ?? e.teamName,
		bye: e.bye || void 0
	}));
	return {
		matchUpId: e.matchUpId,
		drawId: e.drawId,
		eventName: e.eventName,
		roundName: e.roundName,
		matchUpFormat: e.matchUpFormat,
		matchUpType: e.matchUpType,
		matchUpStatus: e.matchUpStatus,
		winningSide: e.winningSide,
		gender: e.gender ?? e.eventGender,
		sides: t,
		potentialParticipants: e.potentialParticipants,
		schedule: e.schedule ? {
			scheduledTime: e.schedule.scheduledTime,
			startTime: e.schedule.startTime,
			timeModifiers: e.schedule.timeModifiers,
			courtAnnotation: e.schedule.courtAnnotation,
			courtId: e.schedule.courtId,
			courtOrder: e.schedule.courtOrder,
			venueId: e.schedule.venueId
		} : void 0,
		score: e.score ? {
			scoreStringSide1: e.score.scoreStringSide1,
			scoreStringSide2: e.score.scoreStringSide2
		} : void 0,
		umpire: e.umpire?.participantName ?? e.umpireName,
		scheduleState: e.scheduleState,
		issueType: e.issueType,
		issueIds: e.issueIds
	};
}
//#endregion
//#region src/components/schedule-page/ui/scheduleCellTypeAhead.ts
function Nj({ cell: e, listProvider: t, onSelect: n, onCancel: r }) {
	let i = e.innerHTML, a = [], o = !1, s = !1;
	e.classList.add("spl-cell--typeahead"), e.innerHTML = "";
	let c = document.createElement("div");
	c.className = "spl-cell--typeahead-wrapper", e.appendChild(c);
	let l = document.createElement("input");
	l.type = "text", l.placeholder = "Search matchUps...", l.setAttribute("inputmode", "search"), l.setAttribute("autocapitalize", "off"), l.setAttribute("enterkeyhint", "search"), l.setAttribute("autocomplete", "off"), c.appendChild(l);
	let u = e, d = 0;
	for (; u && d < 10;) {
		let e = window.getComputedStyle(u);
		(e.overflow !== "visible" || e.overflowX !== "visible" || e.overflowY !== "visible") && (a.push({
			el: u,
			overflow: u.style.overflow,
			overflowX: u.style.overflowX,
			overflowY: u.style.overflowY
		}), u.style.setProperty("overflow", "visible", "important"), u.style.setProperty("overflow-x", "visible", "important"), u.style.setProperty("overflow-y", "visible", "important")), u = u.parentElement, d++;
	}
	_e({
		list: t(),
		element: l,
		listProvider: t,
		callback: (e) => {
			e && !s && (o = !0, p(), n(e));
		}
	}), l.addEventListener("keydown", (e) => {
		e.key === "Escape" && (e.preventDefault(), e.stopPropagation(), p(), r?.());
	}), l.addEventListener("blur", () => {
		setTimeout(() => {
			!o && !s && (p(), r?.());
		}, 200);
	});
	let f = (e) => {
		e.target !== l && !c.contains(e.target) && (e.preventDefault(), l.blur());
	};
	e.addEventListener("mousedown", f), c.addEventListener("click", (e) => {
		e.stopPropagation();
	}), setTimeout(() => l.focus(), 0);
	function p() {
		if (!s) {
			s = !0, e.removeEventListener("mousedown", f), e.classList.remove("spl-cell--typeahead"), e.innerHTML = i;
			for (let { el: e, overflow: t, overflowX: n, overflowY: r } of a) t ? e.style.overflow = t : e.style.removeProperty("overflow"), n ? e.style.overflowX = n : e.style.removeProperty("overflow-x"), r ? e.style.overflowY = r : e.style.removeProperty("overflow-y");
		}
	}
	return { destroy: p };
}
//#endregion
//#region src/components/schedule-page/index.ts
function Pj(e, t) {
	let n = new uj(e);
	return n.render(t), n;
}
//#endregion
//#region src/components/composition-editor/compositionEditorStore.ts
var Fj = class {
	constructor(e) {
		this.listeners = /* @__PURE__ */ new Set(), this.config = e, this.state = {
			compositionName: e.compositionName || "Custom",
			theme: e.composition?.theme || "",
			configuration: { ...e.composition?.configuration || {} },
			expandedSections: new Set(["theme", "display"]),
			isDirty: !1,
			readOnly: e.readOnly || !1
		};
	}
	getState() {
		return this.state;
	}
	subscribe(e) {
		return this.listeners.add(e), () => this.listeners.delete(e);
	}
	toggleSection(e) {
		let t = new Set(this.state.expandedSections);
		t.has(e) ? t.delete(e) : t.add(e), this.setState({ expandedSections: t });
	}
	setTheme(e) {
		this.setState({
			theme: e,
			isDirty: !0
		}), this.notifyChange();
	}
	setCompositionName(e) {
		this.setState({
			compositionName: e,
			isDirty: !0
		});
	}
	setConfigField(e, t) {
		let n = {
			...this.state.configuration,
			[e]: t
		};
		this.setState({
			configuration: n,
			isDirty: !0
		}), this.notifyChange();
	}
	setConfigNestedField(e, t, n) {
		let r = {
			...this.state.configuration[e] || {},
			[t]: n
		};
		this.setConfigField(e, r);
	}
	setConfiguration(e) {
		this.setState({
			configuration: { ...e },
			isDirty: !0
		}), this.notifyChange();
	}
	loadComposition(e, t, n) {
		this.setState({
			compositionName: e,
			theme: t,
			configuration: { ...n },
			isDirty: !1
		}), this.notifyChange();
	}
	resetToInitial() {
		this.setState({
			compositionName: this.config.compositionName || "Custom",
			theme: this.config.composition?.theme || "",
			configuration: { ...this.config.composition?.configuration || {} },
			isDirty: !1
		}), this.notifyChange();
	}
	setState(e) {
		this.state = {
			...this.state,
			...e
		}, this.emit();
	}
	emit() {
		for (let e of this.listeners) e(this.state);
	}
	notifyChange() {
		this.config.onChange?.({
			theme: this.state.theme,
			configuration: this.state.configuration
		});
	}
}, Ij = () => "ce-layout", Lj = () => "ce-left", Rj = () => "ce-right", zj = () => "ce-name-row", Bj = () => "ce-name-label", Vj = () => "ce-name-input", Hj = () => "ce-section", Uj = () => "ce-section-header", Wj = () => "ce-section-chevron", Gj = () => "ce-section-body", Kj = () => "ce-field", qj = () => "ce-field-label", Jj = () => "ce-field-control", Yj = () => "ce-select", Xj = () => "ce-text-input", Zj = () => "ce-color-input", Qj = () => "ce-toggle", $j = () => "ce-toggle-track", eM = () => "ce-preview", tM = () => "ce-preview-header", nM = () => "ce-preview-body", rM = () => "ce-preview-matchup", iM = () => "ce-subgroup", aM = () => "ce-subgroup-title";
//#endregion
//#region src/components/composition-editor/sections/sectionBuilder.ts
function oM(e, t) {
	let n = document.createElement("div");
	n.className = Hj();
	let r = document.createElement("div");
	r.className = Uj();
	let i = document.createElement("span");
	i.className = Wj();
	let a = document.createElement("span");
	a.textContent = e.label, r.appendChild(i), r.appendChild(a), r.addEventListener("click", () => t.toggleSection(e.id));
	let o = document.createElement("div");
	o.className = Gj();
	let s = e.factory(t);
	o.appendChild(s.element), n.appendChild(r), n.appendChild(o);
	function c(t) {
		let n = t.expandedSections.has(e.id);
		i.textContent = n ? "▼" : "▶", o.style.display = n ? "block" : "none", n && s.update(t);
	}
	return {
		element: n,
		update: c
	};
}
//#endregion
//#region src/components/composition-editor/sections/fieldBuilders.ts
function sM(e, t, n, r = !1) {
	let i = document.createElement("div");
	i.className = Kj();
	let a = document.createElement("span");
	a.className = qj(), a.textContent = e, i.appendChild(a);
	let o = document.createElement("label");
	o.className = Qj();
	let s = document.createElement("input");
	s.type = "checkbox", s.checked = t, s.disabled = r, s.addEventListener("change", () => n(s.checked));
	let c = document.createElement("span");
	c.className = $j(), o.appendChild(s), o.appendChild(c);
	let l = document.createElement("div");
	return l.className = Jj(), l.appendChild(o), i.appendChild(l), {
		element: i,
		setChecked: (e) => {
			s.checked = e;
		},
		setDisabled: (e) => {
			s.disabled = e;
		}
	};
}
function cM(e, t, n, r, i = !1) {
	let a = document.createElement("div");
	a.className = Kj();
	let o = document.createElement("span");
	o.className = qj(), o.textContent = e, a.appendChild(o);
	let s = document.createElement("select");
	s.className = Yj(), s.disabled = i;
	for (let e of t) {
		let t = document.createElement("option");
		t.value = e.value, t.textContent = e.label, e.value === n && (t.selected = !0), s.appendChild(t);
	}
	s.addEventListener("change", () => r(s.value));
	let c = document.createElement("div");
	return c.className = Jj(), c.appendChild(s), a.appendChild(c), {
		element: a,
		setValue: (e) => {
			s.value = e;
		}
	};
}
function lM(e, t, n, r = "", i = !1) {
	let a = document.createElement("div");
	a.className = Kj();
	let o = document.createElement("span");
	o.className = qj(), o.textContent = e, a.appendChild(o);
	let s = document.createElement("input");
	s.type = "text", s.className = Xj(), s.value = t, s.placeholder = r, s.disabled = i, s.addEventListener("input", () => n(s.value));
	let c = document.createElement("div");
	return c.className = Jj(), c.appendChild(s), a.appendChild(c), {
		element: a,
		setValue: (e) => {
			s.value = e;
		}
	};
}
function uM(e, t, n, r = !1) {
	let i = document.createElement("div");
	i.className = Kj();
	let a = document.createElement("span");
	a.className = qj(), a.textContent = e, i.appendChild(a);
	let o = document.createElement("input");
	o.type = "color", o.className = Zj(), o.value = t || "#000000", o.disabled = r, o.addEventListener("input", () => n(o.value));
	let s = document.createElement("div");
	return s.className = Jj(), s.appendChild(o), i.appendChild(s), {
		element: i,
		setValue: (e) => {
			o.value = e || "#000000";
		}
	};
}
//#endregion
//#region src/components/composition-editor/sections/themeSection.ts
var dM = [], fM = /* @__PURE__ */ new Set();
for (let [, e] of Object.entries(yi)) if (!fM.has(e.theme)) {
	fM.add(e.theme);
	let t = e.theme.replace("chc-theme-", "").replace(/-/g, " ").replace(/\b\w/g, (e) => e.toUpperCase());
	dM.push({
		value: e.theme,
		label: t
	});
}
function pM(e) {
	let t = document.createElement("div"), n = cM("Load preset", [{
		value: "",
		label: "— Load preset —"
	}, ...Object.keys(yi).map((e) => ({
		value: e,
		label: e
	}))], "", (t) => {
		if (!t) return;
		let r = yi[t];
		r && e.loadComposition(t, r.theme, r.configuration || {}), n.setValue("");
	}, e.getState().readOnly);
	t.appendChild(n.element);
	let r = document.createElement("div");
	r.style.cssText = "font-size:0.7rem; color:var(--chc-text-secondary, #999); padding:0 0 0.3rem; line-height:1.3;", r.textContent = "Replaces all settings with a built-in composition.", t.appendChild(r);
	let i = cM("Color theme", dM, e.getState().theme, (t) => e.setTheme(t), e.getState().readOnly);
	t.appendChild(i.element);
	let a = document.createElement("div");
	a.style.cssText = "font-size:0.7rem; color:var(--chc-text-secondary, #999); padding:0 0 0.3rem; line-height:1.3;", a.textContent = "Changes only the color scheme, not the display settings.", t.appendChild(a);
	function o(e) {
		i.setValue(e.theme);
	}
	return {
		element: t,
		update: o
	};
}
//#endregion
//#region src/components/composition-editor/sections/displaySection.ts
function mM(e) {
	let t = document.createElement("div"), n = e.getState().readOnly, r = e.getState().configuration, i = sM("Nationality flags", !!r.flags, (t) => e.setConfigField("flags", t), n), a = cM("Seeding style", [
		{
			value: "",
			label: "None"
		},
		{
			value: "true",
			label: "Parentheses"
		},
		{
			value: "square",
			label: "Square brackets"
		}
	], r.bracketedSeeds === "square" ? "square" : r.bracketedSeeds ? "true" : "", (t) => {
		t === "square" ? e.setConfigField("bracketedSeeds", "square") : t === "true" ? e.setConfigField("bracketedSeeds", !0) : e.setConfigField("bracketedSeeds", void 0);
	}, n), o = cM("Seed element", [
		{
			value: "",
			label: "Default"
		},
		{
			value: "sup",
			label: "Superscript"
		},
		{
			value: "span",
			label: "Inline"
		}
	], r.seedingElement || "", (t) => e.setConfigField("seedingElement", t || void 0), n), s = sM("Draw positions (1st round)", !!r.drawPositions, (t) => e.setConfigField("drawPositions", t), n), c = sM("Draw positions (all rounds)", !!r.allDrawPositions, (t) => e.setConfigField("allDrawPositions", t), n), l = sM("Team logo", r.teamLogo !== !1, (t) => e.setConfigField("teamLogo", t), n);
	t.appendChild(i.element), t.appendChild(a.element), t.appendChild(o.element), t.appendChild(s.element), t.appendChild(c.element), t.appendChild(l.element);
	function u(e) {
		let t = e.configuration;
		i.setChecked(!!t.flags), a.setValue(t.bracketedSeeds === "square" ? "square" : t.bracketedSeeds ? "true" : ""), o.setValue(t.seedingElement || ""), s.setChecked(!!t.drawPositions), c.setChecked(!!t.allDrawPositions), l.setChecked(t.teamLogo !== !1);
	}
	return {
		element: t,
		update: u
	};
}
//#endregion
//#region src/components/composition-editor/sections/scoreSection.ts
function hM(e) {
	let t = document.createElement("div"), n = e.getState().readOnly, r = e.getState().configuration, i = sM("Score box", !!r.scoreBox, (t) => e.setConfigField("scoreBox", t), n), a = sM("Game score only", !!r.gameScoreOnly, (t) => e.setConfigField("gameScoreOnly", t), n);
	t.appendChild(i.element), t.appendChild(a.element);
	let o = document.createElement("div");
	o.className = iM();
	let s = document.createElement("div");
	s.className = aM(), s.textContent = "Game Score Display", o.appendChild(s);
	let c = cM("Position", [
		{
			value: "",
			label: "Default"
		},
		{
			value: "leading",
			label: "Leading"
		},
		{
			value: "trailing",
			label: "Trailing"
		}
	], r.gameScore?.position || "", (t) => e.setConfigNestedField("gameScore", "position", t || void 0), n), l = sM("Inverted", !!r.gameScore?.inverted, (t) => e.setConfigNestedField("gameScore", "inverted", t), n);
	o.appendChild(c.element), o.appendChild(l.element), t.appendChild(o);
	function u(e) {
		let t = e.configuration;
		i.setChecked(!!t.scoreBox), a.setChecked(!!t.gameScoreOnly), c.setValue(t.gameScore?.position || ""), l.setChecked(!!t.gameScore?.inverted);
	}
	return {
		element: t,
		update: u
	};
}
//#endregion
//#region src/components/composition-editor/sections/participantSection.ts
function gM(e) {
	let t = document.createElement("div"), n = e.getState().readOnly, r = e.getState().configuration, i = sM("Gender color", !!r.genderColor, (t) => e.setConfigField("genderColor", t), n), a = sM("Winner color", !!r.winnerColor, (t) => e.setConfigField("winnerColor", t), n), o = cM("Detail", [
		{
			value: "",
			label: "Default"
		},
		{
			value: "TEAM",
			label: "Team"
		},
		{
			value: "ADDRESS",
			label: "Address"
		}
	], r.participantDetail || "", (t) => {
		e.setConfigField("participantDetail", t || void 0), e.setConfigField("showAddress", t === "ADDRESS");
	}, n), s = lM("Position color", r.drawPositionColor || "", (t) => e.setConfigField("drawPositionColor", t || void 0), "#999", n);
	t.appendChild(i.element), t.appendChild(a.element), t.appendChild(o.element), t.appendChild(s.element);
	function c(e) {
		let t = e.configuration;
		i.setChecked(!!t.genderColor), a.setChecked(!!t.winnerColor), o.setValue(t.participantDetail || ""), s.setValue(t.drawPositionColor || "");
	}
	return {
		element: t,
		update: c
	};
}
//#endregion
//#region src/components/composition-editor/sections/placeholderSection.ts
function _M(e) {
	let t = document.createElement("div"), n = e.getState().readOnly, r = e.getState().configuration, i = lM("TBD text", r.placeHolders?.tbd || "", (t) => e.setConfigNestedField("placeHolders", "tbd", t || void 0), "TBD", n), a = lM("Bye text", r.placeHolders?.bye || "", (t) => e.setConfigNestedField("placeHolders", "bye", t || void 0), "Bye", n), o = lM("Qualifier text", r.placeHolders?.qualifier || "", (t) => e.setConfigNestedField("placeHolders", "qualifier", t || void 0), "Qualifier", n);
	t.appendChild(i.element), t.appendChild(a.element), t.appendChild(o.element);
	function s(e) {
		let t = e.configuration;
		i.setValue(t.placeHolders?.tbd || ""), a.setValue(t.placeHolders?.bye || ""), o.setValue(t.placeHolders?.qualifier || "");
	}
	return {
		element: t,
		update: s
	};
}
//#endregion
//#region src/components/composition-editor/scaleConstants.ts
var vM = [
	{
		scaleName: "WTN",
		accessor: "wtnRating",
		label: "WTN"
	},
	{
		scaleName: "UTR",
		accessor: "utrRating",
		label: "UTR"
	},
	{
		scaleName: "NTRP",
		accessor: "ntrpRating",
		label: "NTRP"
	},
	{
		scaleName: "ELO",
		accessor: "eloRating",
		label: "ELO"
	}
];
//#endregion
//#region src/components/composition-editor/sections/scaleSection.ts
function yM(e) {
	let t = document.createElement("div"), n = e.getState().readOnly, r = e.getState().configuration.scaleAttributes || {}, i = cM("Scale type", [
		{
			value: "",
			label: "None"
		},
		{
			value: "RATING",
			label: "Rating"
		},
		{
			value: "RANKING",
			label: "Ranking"
		},
		{
			value: "SEEDING",
			label: "Seeding"
		}
	], r.scaleType || "", (t) => e.setConfigNestedField("scaleAttributes", "scaleType", t || void 0), n), a = cM("Scale name", [{
		value: "",
		label: "None"
	}, ...vM.map((e) => ({
		value: e.scaleName,
		label: e.label
	}))], r.scaleName || "", (t) => {
		e.setConfigNestedField("scaleAttributes", "scaleName", t || void 0);
		let n = vM.find((e) => e.scaleName === t);
		e.setConfigNestedField("scaleAttributes", "accessor", n?.accessor || void 0);
	}, n), o = uM("Color", r.scaleColor || "#ff0000", (t) => e.setConfigNestedField("scaleAttributes", "scaleColor", t), n), s = cM("Event type", [
		{
			value: "",
			label: "Any"
		},
		{
			value: "SINGLES",
			label: "Singles"
		},
		{
			value: "DOUBLES",
			label: "Doubles"
		}
	], r.eventType || "", (t) => e.setConfigNestedField("scaleAttributes", "eventType", t || void 0), n), c = sM("Fallback", !!r.fallback, (t) => e.setConfigNestedField("scaleAttributes", "fallback", t), n), l = sM("Right of name", r.scalePosition === "right", (t) => e.setConfigNestedField("scaleAttributes", "scalePosition", t ? "right" : "left"), n);
	t.appendChild(i.element), t.appendChild(a.element), t.appendChild(o.element), t.appendChild(s.element), t.appendChild(c.element), t.appendChild(l.element);
	function u(e) {
		let t = e.configuration.scaleAttributes || {}, n = !!e.configuration.flags;
		i.setValue(t.scaleType || ""), a.setValue(t.scaleName || ""), o.setValue(t.scaleColor || "#ff0000"), s.setValue(t.eventType || ""), c.setChecked(!!t.fallback), n ? (l.setChecked(!0), l.setDisabled(!0)) : (l.setChecked(t.scalePosition === "right"), l.setDisabled(!1));
	}
	return {
		element: t,
		update: u
	};
}
//#endregion
//#region src/components/composition-editor/sections/layoutSection.ts
function bM(e) {
	let t = document.createElement("div"), n = e.getState().readOnly, r = e.getState().configuration, i = sM("Schedule info", !!r.scheduleInfo, (t) => e.setConfigField("scheduleInfo", t), n), a = sM("MatchUp footer", !!r.matchUpFooter, (t) => e.setConfigField("matchUpFooter", t), n), o = sM("Center info", !!r.centerInfo, (t) => e.setConfigField("centerInfo", t), n), s = sM("Set number", !!r.resultsInfo, (t) => e.setConfigField("resultsInfo", t), n), c = sM("Winner chevron", !!r.winnerChevron, (t) => e.setConfigField("winnerChevron", t), n);
	t.appendChild(i.element), t.appendChild(a.element), t.appendChild(o.element), t.appendChild(s.element), t.appendChild(c.element);
	function l(e) {
		let t = e.configuration;
		i.setChecked(!!t.scheduleInfo), a.setChecked(!!t.matchUpFooter), o.setChecked(!!t.centerInfo), s.setChecked(!!t.resultsInfo), c.setChecked(!!t.winnerChevron);
	}
	return {
		element: t,
		update: l
	};
}
//#endregion
//#region src/data/generateMatchUps.ts
var { DOUBLES: xM, SINGLES: SM } = r, { AD_HOC: CM } = t, { INDIVIDUAL: wM } = f;
function TM({ matchUpFormat: e = "SET5-S:6/TB7", randomWinningSide: t = !0, qualifyingProfiles: n, participantsCount: r, completionGoal: i, drawSize: a = 4, eventType: o, outcomes: s, drawType: c, withRatings: l, withAllRatings: u } = {}) {
	let f = i < 100 ? Math.floor(a * .01 * i) : void 0, p = "venueId", m = [{
		venueName: "Challenge Courts",
		venueAbbreviation: "CC",
		startTime: "08:00",
		endTime: "20:00",
		venueId: p,
		courtNames: [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8
		],
		courtIds: [
			"c1",
			"c2",
			"c3",
			"c4"
		],
		courtsCount: 8
	}], h = {
		eventType: o === xM ? xM : SM,
		completionGoal: f,
		qualifyingProfiles: n,
		participantsCount: r,
		seedsCount: 8,
		matchUpFormat: e,
		drawSize: a,
		drawType: c,
		outcomes: s
	};
	c === CM && Object.assign(h, {
		drawMatic: !0,
		roundsCount: 3
	});
	let { tournamentRecord: _ } = d.generateTournamentRecord({
		drawProfiles: [h],
		completeAllMatchUps: !0,
		randomWinningSide: t,
		venueProfiles: m
	});
	g.setState(_), g.createTeamsFromParticipantAttributes({
		personAttribute: "nationalityCode",
		addParticipants: !0
	});
	let v = u || (l ? [{
		...l,
		accessor: l.scaleName
	}] : []);
	if (v.length > 0) {
		let { participants: e } = g.getParticipants({ participantFilters: { participantTypes: [wM] } });
		for (let t of v) e.forEach((e) => {
			let n = +(10 + Math.random() * 6).toFixed(2);
			g.setParticipantScaleItem({
				participantId: e.participantId,
				scaleItem: {
					scaleValue: { [t.accessor]: n },
					scaleName: t.scaleName,
					scaleType: t.scaleType || "RATING",
					eventType: t.eventType || SM
				}
			});
		});
	}
	let { matchUps: y } = g.allTournamentMatchUps({ participantsProfile: { withGroupings: !0 } }), b = y.map(({ matchUpId: e }) => e), x = {
		startTime: "08:00",
		endTime: "10:00",
		scheduledTime: "07:00",
		scheduledDate: "2021-01-01",
		courtId: "c1",
		venueId: p
	};
	g.bulkScheduleMatchUps({
		matchUpIds: b,
		schedule: x
	});
	let { matchUps: S } = g.allTournamentMatchUps({ participantsProfile: {
		withISO2: !0,
		withIOC: !0,
		withScaleValues: !!(l || u)
	} });
	return { matchUps: S };
}
//#endregion
//#region src/components/composition-editor/compositionPreview.ts
var EM = null;
function DM() {
	if (!EM) {
		let { matchUps: e } = TM({
			drawSize: 8,
			eventType: "SINGLES",
			randomWinningSide: !0,
			matchUpFormat: "SET3-S:6/TB7",
			withAllRatings: vM.map((e) => ({
				scaleName: e.scaleName,
				accessor: e.accessor
			}))
		}), t = e.filter((e) => e.roundNumber === 1).slice(0, 2), n = t[0]?.sides?.[0]?.participant, r = t[0]?.sides?.[1]?.participant, i = {
			matchUpId: "preview-in-progress",
			matchUpType: "SINGLES",
			matchUpStatus: "IN_PROGRESS",
			roundNumber: 1,
			sides: [{
				sideNumber: 1,
				drawPosition: 5,
				seedNumber: 3,
				seedValue: "3",
				participant: n
			}, {
				sideNumber: 2,
				drawPosition: 6,
				seedNumber: 6,
				seedValue: "6",
				participant: r
			}],
			score: {
				scoreStringSide1: "6-4 3-2",
				scoreStringSide2: "4-6 2-3",
				sets: [{
					setNumber: 1,
					side1Score: 6,
					side2Score: 4,
					winningSide: 1
				}, {
					setNumber: 2,
					side1Score: 3,
					side2Score: 2,
					side1PointScore: "30",
					side2PointScore: "15"
				}]
			}
		}, a = {
			matchUpId: "preview-bye",
			matchUpType: "SINGLES",
			matchUpStatus: "BYE",
			roundNumber: 1,
			sides: [{
				sideNumber: 1,
				drawPosition: 7,
				seedNumber: 2,
				seedValue: "2",
				participant: n
			}, {
				sideNumber: 2,
				drawPosition: 8,
				bye: !0
			}]
		}, o = {
			matchUpId: "preview-tbd",
			matchUpType: "SINGLES",
			matchUpStatus: "TO_BE_PLAYED",
			roundNumber: 1,
			sides: [{
				sideNumber: 1,
				drawPosition: 9,
				seedNumber: 3,
				seedValue: "3",
				participant: n
			}, {
				sideNumber: 2,
				drawPosition: 10
			}]
		}, s = {
			matchUpId: "preview-qualifier",
			matchUpType: "SINGLES",
			matchUpStatus: "TO_BE_PLAYED",
			roundNumber: 1,
			sides: [{
				sideNumber: 1,
				drawPosition: 11,
				qualifier: !0
			}, {
				sideNumber: 2,
				drawPosition: 12,
				seedNumber: 4,
				seedValue: "4",
				participant: n
			}]
		};
		EM = [
			...t,
			i,
			a,
			o,
			s
		];
	}
	return EM;
}
function OM() {
	let e = document.createElement("div");
	e.className = eM();
	let t = document.createElement("div");
	t.className = tM(), t.textContent = "Preview", e.appendChild(t);
	let n = document.createElement("div");
	n.className = nM(), e.appendChild(n);
	let r = "", i = "";
	function a(e) {
		let t = JSON.stringify(e.configuration);
		if (e.theme === r && t === i) return;
		r = e.theme, i = t, n.innerHTML = "";
		let a = {
			theme: e.theme,
			configuration: { ...e.configuration }
		}, o = DM();
		for (let e of o) {
			let t = document.createElement("div");
			t.className = rM();
			let r = oi({
				matchUp: e,
				composition: a,
				isLucky: !0
			});
			t.appendChild(r), n.appendChild(t);
		}
	}
	return {
		element: e,
		update: a
	};
}
//#endregion
//#region src/components/composition-editor/compositionEditor.ts
var kM = [
	{
		id: "theme",
		label: "Theme & Preset",
		factory: pM
	},
	{
		id: "display",
		label: "Display",
		factory: mM
	},
	{
		id: "score",
		label: "Score",
		factory: hM
	},
	{
		id: "participant",
		label: "Participant",
		factory: gM
	},
	{
		id: "placeholder",
		label: "Placeholders",
		factory: _M
	},
	{
		id: "scale",
		label: "Scale Attributes",
		factory: yM
	},
	{
		id: "layout",
		label: "Layout & Info",
		factory: bM
	}
];
function AM(e, t) {
	let n = new Fj(t), r = document.createElement("div");
	r.className = Ij();
	let i = document.createElement("div");
	i.className = Lj();
	let a = document.createElement("div");
	a.className = zj();
	let o = document.createElement("span");
	o.className = Bj(), o.textContent = "Name";
	let s = document.createElement("input");
	s.type = "text", s.className = Vj(), s.value = n.getState().compositionName, s.disabled = n.getState().readOnly, s.addEventListener("input", () => n.setCompositionName(s.value)), a.appendChild(o), a.appendChild(s), i.appendChild(a);
	let c = kM.map((e) => {
		let t = oM(e, n);
		return i.appendChild(t.element), t;
	}), l = document.createElement("div");
	l.className = Rj();
	let u = OM();
	l.appendChild(u.element), r.appendChild(i), r.appendChild(l), e.appendChild(r);
	let d = n.subscribe((e) => {
		s.value = e.compositionName;
		for (let t of c) t.update(e);
		u.update(e);
	}), f = n.getState();
	for (let e of c) e.update(f);
	return u.update(f), {
		destroy: () => {
			d(), e.contains(r) && e.removeChild(r);
		},
		getComposition: () => {
			let e = n.getState(), { participantProvider: t, persistInputFields: r, inlineAssignment: i, ...a } = e.configuration;
			return {
				compositionName: e.compositionName,
				theme: e.theme,
				configuration: a,
				version: 1
			};
		}
	};
}
//#endregion
//#region src/components/scorecard/renderScorecard.ts
var jM = "chc-scorecard-side-score--winner";
function MM({ matchUp: e, composition: t, eventHandlers: n }) {
	let r = document.createElement("div");
	r.className = "chc-scorecard";
	let i = NM({
		side1Name: RM(e, 1) || "",
		side2Name: RM(e, 2) || "",
		sets: e.score?.sets,
		winningSide: e.winningSide,
		side1Id: "chc-sc-side1",
		side2Id: "chc-sc-side2"
	});
	r.appendChild(i);
	let a = e.tieFormat?.collectionDefinitions?.slice().sort((e, t) => (e.collectionOrder || 0) - (t.collectionOrder || 0)) || [];
	for (let i of a) {
		let a = LM({
			collectionDefinition: i,
			collectionMatchUps: (e.tieMatchUps || []).filter((e) => e.collectionId === i.collectionId).sort((e, t) => (e.collectionPosition || 0) - (t.collectionPosition || 0)),
			composition: t,
			eventHandlers: n
		});
		r.appendChild(a);
	}
	return r;
}
function NM({ side1Name: e, side2Name: t, sets: n, winningSide: r, side1Id: i, side2Id: a }) {
	let o = document.createElement("div");
	o.className = "chc-scorecard-header";
	let s = document.createElement("div");
	s.className = "chc-scorecard-header-body";
	let c = FM(e, "end"), l = FM(t, "start"), u = IM(n, 1, r, i), d = IM(n, 2, r, a), f = document.createElement("div");
	f.className = "chc-scorecard-score-box";
	let p = document.createElement("div");
	p.className = "chc-scorecard-score-flex";
	let m = document.createElement("div");
	return m.className = "chc-scorecard-vs", m.textContent = "vs", p.appendChild(u), p.appendChild(m), p.appendChild(d), f.appendChild(p), s.appendChild(c), s.appendChild(f), s.appendChild(l), o.appendChild(s), o;
}
function PM(e, t = "chc-sc-side1", n = "chc-sc-side2") {
	let r = e?.score?.sets?.[0];
	if (!r) return;
	let i = document.getElementById(t), a = document.getElementById(n);
	!i || !a || (i.classList.remove(jM), a.classList.remove(jM), i.textContent = String(r.side1Score ?? 0), a.textContent = String(r.side2Score ?? 0), e.winningSide === 1 && i.classList.add(jM), e.winningSide === 2 && a.classList.add(jM));
}
function FM(e, t) {
	let n = document.createElement("div");
	n.className = `chc-scorecard-side chc-scorecard-side--${t}`;
	let r = document.createElement("div");
	return r.className = "chc-scorecard-side-name", r.textContent = e, n.appendChild(r), n;
}
function IM(e, t, n, r) {
	let i = e?.[0]?.[`side${t}Score`] ?? 0, a = document.createElement("span");
	return a.className = "chc-scorecard-side-score", r && (a.id = r), t === 1 ? a.style.paddingLeft = "1rem" : a.style.paddingRight = "1rem", t === n && a.classList.add(jM), a.textContent = String(i), a;
}
function LM({ collectionDefinition: e, collectionMatchUps: t, composition: n, eventHandlers: r }) {
	let i = document.createElement("div");
	i.className = "chc-scorecard-panel";
	let a = document.createElement("div");
	a.className = "chc-scorecard-panel-header";
	let o = document.createElement("div");
	o.className = "chc-scorecard-panel-name", o.textContent = e.collectionName || "Collection";
	let s = document.createElement("div");
	s.className = "chc-scorecard-panel-meta";
	let c = (e.matchUpType || "").toUpperCase(), l = document.createElement("span");
	l.className = `chc-scorecard-type-badge chc-scorecard-type-badge--${c === "DOUBLES" ? "doubles" : "singles"}`, l.textContent = c === "DOUBLES" ? "D" : "S";
	let u = document.createElement("span");
	u.className = "chc-scorecard-count-badge", u.textContent = String(t.length), s.appendChild(l), s.appendChild(u), a.appendChild(o), a.appendChild(s), i.appendChild(a);
	let d = document.createElement("div");
	d.className = "chc-scorecard-grid";
	for (let e of t) {
		let t = oi({
			matchUp: e,
			isLucky: !0,
			eventHandlers: r,
			composition: n
		});
		t.classList.add("chc-scorecard-card"), d.appendChild(t);
	}
	return i.appendChild(d), i;
}
function RM(e, t) {
	return e.sides?.find((e) => e.sideNumber === t)?.participant?.participantName;
}
//#endregion
//#region src/components/inline-scoring/inlineScoringFooter.ts
function zM(e) {
	let { matchUpId: t, manager: n, baseMatchUp: r, onUpdate: i, showSituation: a } = e, o = document.createElement("div");
	o.className = "chc-inline-scoring-footer";
	let s = document.createElement("div");
	s.className = "chc-inline-scoring-buttons";
	let c = (e, t) => {
		let n = document.createElement("button");
		return n.textContent = e, n.className = `chc-inline-scoring-btn ${t}`, n;
	}, l = c("Undo", "chc-is-undo"), u = c("Redo", "chc-is-redo"), d = c("Clear", "chc-is-clear"), f = c("Submit", "chc-is-submit"), p;
	a && (p = document.createElement("span"), p.className = "chc-inline-scoring-situation"), l.onclick = (e) => {
		e.stopPropagation();
		let a = n.undo(t, r);
		a && (i(a), m());
	}, u.onclick = (e) => {
		e.stopPropagation();
		let a = n.redo(t, r);
		a && (i(a), m());
	}, d.onclick = (e) => {
		e.stopPropagation();
		let a = n.reset(t, r);
		a && (i(a), m());
	}, f.onclick = (e) => {
		e.stopPropagation();
		let i = n.get(t);
		if (i) {
			let e = n.getMatchUp(t, r);
			n.callbacks?.onSubmit?.({
				matchUpId: t,
				matchUp: e,
				engine: i.engine
			});
		}
	}, s.append(l, u, d, f), o.appendChild(s), p && o.appendChild(p);
	function m() {
		let e = n.canUndo(t), r = n.canRedo(t), i = n.isComplete(t);
		if (l.disabled = !e, u.disabled = !r, d.disabled = !e && !r, p) {
			let e = n.getSituation(t);
			if (e && !i) {
				let t = [
					e.isTiebreak && "TB",
					e.isBreakPoint && "Break",
					e.isGamePoint && "Game",
					e.isSetPoint && "Set",
					e.isMatchPoint && "Match"
				].filter(Boolean);
				p.textContent = t.length ? t.join(" • ") : "";
			} else p.textContent = i ? "Complete" : "";
		}
	}
	return m(), {
		element: o,
		update: m
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/domain/emptyRankingPolicy.ts
function BM() {
	return {
		policyName: "New Ranking Policy",
		policyVersion: "1.0",
		awardProfiles: [{
			profileName: "Default",
			finishingPositionRanges: {
				1: 100,
				2: 70,
				4: 50,
				8: 30,
				16: 15,
				32: 8
			}
		}],
		requireWinForPoints: !0,
		doublesAttribution: "fullToEach"
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/rankingPointsEditorStore.ts
function Q(e) {
	return structuredClone(e);
}
var VM = class {
	constructor(e) {
		this.listeners = /* @__PURE__ */ new Set(), this.config = e;
		let t = Q(e.initialPolicy ?? BM()), n = t.awardProfiles?.length ?? 0;
		this.state = {
			draft: t,
			expandedSections: new Set(n > 5 ? ["awardProfiles"] : [
				"metadata",
				"awardProfiles",
				"qualityWinProfiles",
				"aggregationRules"
			]),
			expandedProfiles: new Set(n <= 5 ? Array.from({ length: n }, (e, t) => t) : []),
			profileFilter: "",
			dirty: !1,
			readonly: e.readonly ?? !1
		};
	}
	getState() {
		return this.state;
	}
	getData() {
		return Q(this.state.draft);
	}
	setData(e) {
		let t = e.awardProfiles?.length ?? 0;
		this.state = {
			...this.state,
			draft: Q(e),
			expandedProfiles: new Set(t <= 5 ? Array.from({ length: t }, (e, t) => t) : []),
			profileFilter: "",
			dirty: !1
		}, this.emit();
	}
	toggleSection(e) {
		let t = new Set(this.state.expandedSections);
		t.has(e) ? t.delete(e) : t.add(e), this.state = {
			...this.state,
			expandedSections: t
		}, this.emit();
	}
	toggleProfile(e) {
		let t = new Set(this.state.expandedProfiles);
		t.has(e) ? t.delete(e) : t.add(e), this.state = {
			...this.state,
			expandedProfiles: t
		}, this.emit();
	}
	setProfileFilter(e) {
		this.state = {
			...this.state,
			profileFilter: e
		}, this.emit();
	}
	setPolicyName(e) {
		let t = Q(this.state.draft);
		t.policyName = e, this.commitDraft(t);
	}
	setPolicyVersion(e) {
		let t = Q(this.state.draft);
		t.policyVersion = e, this.commitDraft(t);
	}
	setValidDateRange(e, t) {
		let n = Q(this.state.draft);
		n.validDateRange ||= {}, n.validDateRange[e] = t || void 0, this.commitDraft(n);
	}
	setGlobalFlag(e, t) {
		let n = Q(this.state.draft);
		n[e] = t, this.commitDraft(n);
	}
	setDoublesAttribution(e) {
		let t = Q(this.state.draft);
		t.doublesAttribution = e || void 0, this.commitDraft(t);
	}
	setCategoryResolution(e) {
		let t = Q(this.state.draft);
		t.categoryResolution = e || void 0, this.commitDraft(t);
	}
	addProfile() {
		let e = Q(this.state.draft);
		e.awardProfiles ||= [], e.awardProfiles.push({
			profileName: `Profile ${e.awardProfiles.length + 1}`,
			finishingPositionRanges: {
				1: 100,
				2: 70,
				4: 50,
				8: 30
			}
		});
		let t = new Set(this.state.expandedProfiles);
		t.add(e.awardProfiles.length - 1), this.state = {
			...this.state,
			expandedProfiles: t
		}, this.commitDraft(e);
	}
	removeProfile(e) {
		let t = Q(this.state.draft);
		if (!t.awardProfiles || e < 0 || e >= t.awardProfiles.length) return;
		t.awardProfiles.splice(e, 1);
		let n = /* @__PURE__ */ new Set();
		for (let t of this.state.expandedProfiles) t < e ? n.add(t) : t > e && n.add(t - 1);
		this.state = {
			...this.state,
			expandedProfiles: n
		}, this.commitDraft(t);
	}
	duplicateProfile(e) {
		let t = Q(this.state.draft);
		if (!t.awardProfiles || e < 0 || e >= t.awardProfiles.length) return;
		let n = Q(t.awardProfiles[e]);
		n.profileName = `${n.profileName ?? "Profile"} (Copy)`, t.awardProfiles.splice(e + 1, 0, n);
		let r = /* @__PURE__ */ new Set();
		for (let t of this.state.expandedProfiles) t <= e ? r.add(t) : r.add(t + 1);
		r.add(e + 1), this.state = {
			...this.state,
			expandedProfiles: r
		}, this.commitDraft(t);
	}
	moveProfile(e, t) {
		let n = Q(this.state.draft);
		if (!n.awardProfiles || e < 0 || e >= n.awardProfiles.length || t < 0 || t >= n.awardProfiles.length) return;
		let [r] = n.awardProfiles.splice(e, 1);
		n.awardProfiles.splice(t, 0, r), this.commitDraft(n);
	}
	setProfileName(e, t) {
		let n = Q(this.state.draft);
		n.awardProfiles?.[e] && (n.awardProfiles[e].profileName = t, this.commitDraft(n));
	}
	setProfileFlag(e, t, n) {
		let r = Q(this.state.draft);
		r.awardProfiles?.[e] && (n === void 0 ? delete r.awardProfiles[e][t] : r.awardProfiles[e][t] = n, this.commitDraft(r));
	}
	setFlatPositionPoints(e, t, n) {
		let r = Q(this.state.draft), i = r.awardProfiles?.[e];
		i && (i.finishingPositionRanges ||= {}, i.finishingPositionRanges[t] = n, this.commitDraft(r));
	}
	addPositionRow(e, t) {
		let n = Q(this.state.draft), r = n.awardProfiles?.[e];
		r && (r.finishingPositionRanges ||= {}, r.finishingPositionRanges[t] === void 0 && (r.finishingPositionRanges[t] = 0, this.commitDraft(n)));
	}
	removePositionRow(e, t) {
		let n = Q(this.state.draft), r = n.awardProfiles?.[e];
		r?.finishingPositionRanges && (delete r.finishingPositionRanges[t], this.commitDraft(n));
	}
	setPointsPerWin(e, t) {
		let n = Q(this.state.draft), r = n.awardProfiles?.[e];
		r && (t === void 0 ? delete r.pointsPerWin : r.pointsPerWin = t, this.commitDraft(n));
	}
	addBonusPoint(e) {
		let t = Q(this.state.draft), n = t.awardProfiles?.[e];
		n && (n.bonusPoints ||= [], n.bonusPoints.push({
			finishingPositions: [1],
			value: 0
		}), this.commitDraft(t));
	}
	removeBonusPoint(e, t) {
		let n = Q(this.state.draft), r = n.awardProfiles?.[e];
		r?.bonusPoints && (r.bonusPoints.splice(t, 1), r.bonusPoints.length || delete r.bonusPoints, this.commitDraft(n));
	}
	setBonusPointPositions(e, t, n) {
		let r = Q(this.state.draft), i = r.awardProfiles?.[e]?.bonusPoints?.[t];
		i && (i.finishingPositions = n, this.commitDraft(r));
	}
	setBonusPointValue(e, t, n) {
		let r = Q(this.state.draft), i = r.awardProfiles?.[e]?.bonusPoints?.[t];
		i && (i.value = n, this.commitDraft(r));
	}
	setLevelPositionPoints(e, t, n, r) {
		let i = Q(this.state.draft), a = i.awardProfiles?.[e];
		if (!a) return;
		a.finishingPositionRanges ||= {};
		let o = a.finishingPositionRanges[t];
		o && typeof o == "object" && o.level && (o.level[n] = r), this.commitDraft(i);
	}
	addLevel(e, t) {
		let n = Q(this.state.draft), r = n.awardProfiles?.[e];
		if (r?.finishingPositionRanges) {
			for (let e of Object.keys(r.finishingPositionRanges)) {
				let n = r.finishingPositionRanges[e];
				n && typeof n == "object" && n.level && n.level[t] === void 0 && (n.level[t] = 0);
			}
			r.levels && !r.levels.includes(t) && (r.levels.push(t), r.levels.sort((e, t) => e - t)), this.commitDraft(n);
		}
	}
	removeLevel(e, t) {
		let n = Q(this.state.draft), r = n.awardProfiles?.[e];
		if (r?.finishingPositionRanges) {
			for (let e of Object.keys(r.finishingPositionRanges)) {
				let n = r.finishingPositionRanges[e];
				n && typeof n == "object" && n.level && delete n.level[t];
			}
			r.levels &&= r.levels.filter((e) => e !== t), this.commitDraft(n);
		}
	}
	setProfileScope(e, t, n) {
		let r = Q(this.state.draft), i = r.awardProfiles?.[e];
		i && (n.length ? i[t] = n : delete i[t], this.commitDraft(r));
	}
	setProfileField(e, t, n) {
		let r = Q(this.state.draft), i = r.awardProfiles?.[e];
		i && (n === void 0 || n === "" ? delete i[t] : i[t] = n, this.commitDraft(r));
	}
	addQualityWinProfile() {
		let e = Q(this.state.draft);
		e.qualityWinProfiles ||= [], e.qualityWinProfiles.push({
			rankingScaleName: "New Profile",
			rankingRanges: [{
				rankRange: [1, 10],
				value: 10
			}]
		}), this.commitDraft(e);
	}
	removeQualityWinProfile(e) {
		let t = Q(this.state.draft);
		t.qualityWinProfiles && (t.qualityWinProfiles.splice(e, 1), t.qualityWinProfiles.length || delete t.qualityWinProfiles, this.commitDraft(t));
	}
	setQualityWinField(e, t, n) {
		let r = Q(this.state.draft), i = r.qualityWinProfiles?.[e];
		i && (n === void 0 || n === "" ? delete i[t] : i[t] = n, this.commitDraft(r));
	}
	addQualityWinRange(e) {
		let t = Q(this.state.draft), n = t.qualityWinProfiles?.[e];
		if (!n) return;
		let r = n.rankingRanges.at(-1), i = r ? r.rankRange[1] + 1 : 1;
		n.rankingRanges.push({
			rankRange: [i, i + 9],
			value: 0
		}), this.commitDraft(t);
	}
	removeQualityWinRange(e, t) {
		let n = Q(this.state.draft), r = n.qualityWinProfiles?.[e];
		r && (r.rankingRanges.splice(t, 1), this.commitDraft(n));
	}
	setQualityWinRange(e, t, n, r) {
		let i = Q(this.state.draft), a = i.qualityWinProfiles?.[e]?.rankingRanges?.[t];
		a && (n === "rankRange" ? a.rankRange = r : a.value = r, this.commitDraft(i));
	}
	setAggregationField(e, t) {
		let n = Q(this.state.draft);
		n.aggregationRules ||= {}, t === void 0 || t === "" ? delete n.aggregationRules[e] : n.aggregationRules[e] = t, this.commitDraft(n);
	}
	addTiebreakCriterion(e) {
		let t = Q(this.state.draft);
		t.aggregationRules ||= {}, t.aggregationRules.tiebreakCriteria || (t.aggregationRules.tiebreakCriteria = []), t.aggregationRules.tiebreakCriteria.push(e), this.commitDraft(t);
	}
	removeTiebreakCriterion(e) {
		let t = Q(this.state.draft);
		t.aggregationRules?.tiebreakCriteria && (t.aggregationRules.tiebreakCriteria.splice(e, 1), t.aggregationRules.tiebreakCriteria.length || delete t.aggregationRules.tiebreakCriteria, this.commitDraft(t));
	}
	addCountingBucket() {
		let e = Q(this.state.draft);
		e.aggregationRules ||= {}, e.aggregationRules.countingBuckets || (e.aggregationRules.countingBuckets = []), e.aggregationRules.countingBuckets.push({ bucketName: "New Bucket" }), this.commitDraft(e);
	}
	removeCountingBucket(e) {
		let t = Q(this.state.draft);
		t.aggregationRules?.countingBuckets && (t.aggregationRules.countingBuckets.splice(e, 1), t.aggregationRules.countingBuckets.length || delete t.aggregationRules.countingBuckets, this.commitDraft(t));
	}
	setCountingBucketField(e, t, n) {
		let r = Q(this.state.draft), i = r.aggregationRules?.countingBuckets?.[e];
		i && (n === void 0 || n === "" ? delete i[t] : i[t] = n, this.commitDraft(r));
	}
	subscribe(e) {
		return this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	commitDraft(e) {
		this.state = {
			...this.state,
			draft: e,
			dirty: !0
		}, this.emit(), this.config.onChange?.(Q(e));
	}
	emit() {
		for (let e of this.listeners) e(this.state);
	}
}, HM = () => "re-section", UM = () => "re-section-header", WM = () => "re-section-chevron", GM = () => "re-section-count", KM = () => "re-section-body", qM = () => "re-field-row", JM = () => "re-field-label", YM = () => "re-field-input re-field-input--text", XM = () => "re-field-input re-field-input--number", ZM = () => "re-field-input re-field-input--date", QM = () => "re-field-select", $M = () => "re-checkbox-row", eN = () => "re-points-input", tN = () => "re-profile-card", nN = () => "re-profile-header", rN = () => "re-profile-name-input", iN = () => "re-profile-body", aN = () => "re-profile-actions", oN = () => "re-icon-btn", sN = () => "re-icon-btn re-icon-btn--danger", cN = () => "re-empty", lN = () => "re-editor", uN = [
	"totalPoints",
	"bestResult",
	"headToHead",
	"numberOfWins",
	"recentResults",
	"drawSize",
	"numberOfResults"
];
function dN(e) {
	let t = document.createElement("div"), n = "";
	function r(t, n, r, i, a, o) {
		let s = document.createElement("div");
		s.className = qM();
		let c = document.createElement("div");
		if (c.className = JM(), c.textContent = n, s.appendChild(c), o) {
			let e = document.createElement("span");
			e.style.cssText = "font-size:0.85rem;color:var(--sp-text)", e.textContent = String(i), s.appendChild(e);
		} else if (r === "select") {
			let n = document.createElement("select");
			n.className = QM();
			let r = document.createElement("option");
			r.value = "", r.textContent = "(none)", n.appendChild(r);
			for (let e of a ?? []) {
				let t = document.createElement("option");
				t.value = e, t.textContent = e, n.appendChild(t);
			}
			n.value = i ?? "", n.addEventListener("change", () => e.setAggregationField(t, n.value || void 0)), s.appendChild(n);
		} else {
			let n = document.createElement("input");
			n.type = "number", n.className = XM(), n.value = i === void 0 ? "" : String(i), n.placeholder = "—", n.addEventListener("change", () => {
				let r = n.value.trim();
				e.setAggregationField(t, r ? Number.parseInt(r, 10) : void 0);
			}), s.appendChild(n);
		}
		return s;
	}
	function i(n, r) {
		let i = document.createElement("div");
		if (i.style.cssText = "font-weight:600;font-size:0.8rem;margin:0.5rem 0 0.3rem;color:var(--sp-text)", i.textContent = "Tiebreak Order", t.appendChild(i), n.length) {
			let i = document.createElement("ol");
			i.style.cssText = "font-size:0.8rem;margin:0;padding-left:1.5rem;color:var(--sp-text)";
			for (let t = 0; t < n.length; t++) {
				let a = document.createElement("li");
				a.style.cssText = "display:flex;align-items:center;gap:6px;margin-bottom:2px";
				let o = document.createElement("span");
				if (o.textContent = n[t], a.appendChild(o), !r) {
					let n = document.createElement("span");
					n.className = sN(), n.textContent = "×", n.style.cursor = "pointer", n.addEventListener("click", () => e.removeTiebreakCriterion(t)), a.appendChild(n);
				}
				i.appendChild(a);
			}
			t.appendChild(i);
		} else if (r) {
			let e = document.createElement("div");
			e.className = cN(), e.textContent = "No tiebreak criteria", t.appendChild(e);
		}
		if (!r) {
			let r = document.createElement("div");
			r.style.cssText = "display:flex;align-items:center;gap:4px;margin-top:4px";
			let i = document.createElement("select");
			i.className = QM(), i.style.fontSize = "0.75rem";
			let a = new Set(n), o = uN.filter((e) => !a.has(e));
			for (let e of o) {
				let t = document.createElement("option");
				t.value = e, t.textContent = e, i.appendChild(t);
			}
			let s = document.createElement("button");
			s.className = "sp-btn sp-btn--sm sp-btn--outline", s.textContent = "+ Add", s.addEventListener("click", () => {
				i.value && e.addTiebreakCriterion(i.value);
			}), o.length && (r.appendChild(i), r.appendChild(s), t.appendChild(r));
		}
	}
	function a(t, n, r) {
		let i = document.createElement("div");
		i.style.cssText = "border:1px solid var(--sp-border);border-radius:8px;padding:0.4rem;margin-bottom:0.4rem;font-size:0.8rem";
		let a = document.createElement("div");
		if (a.style.cssText = "display:flex;align-items:center;gap:6px;margin-bottom:0.2rem", r) {
			let e = document.createElement("span");
			e.style.cssText = "font-weight:600;color:var(--sp-text)", e.textContent = t.bucketName || "Bucket", a.appendChild(e);
		} else {
			let r = document.createElement("input");
			r.type = "text", r.className = "re-field-input re-field-input--text", r.style.cssText = "width:120px;font-size:0.75rem;font-weight:600", r.value = t.bucketName || "", r.placeholder = "Bucket name", r.addEventListener("change", () => e.setCountingBucketField(n, "bucketName", r.value)), a.appendChild(r);
			let i = document.createElement("div");
			i.style.flexGrow = "1", a.appendChild(i);
			let o = document.createElement("span");
			o.className = sN(), o.textContent = "✕", o.style.cursor = "pointer", o.addEventListener("click", () => e.removeCountingBucket(n)), a.appendChild(o);
		}
		i.appendChild(a);
		let o = [];
		if (t.eventTypes?.length && o.push(`Events: ${t.eventTypes.join(", ")}`), t.bestOfCount !== void 0 && o.push(`Best of: ${t.bestOfCount}`), t.levels?.length && o.push(`Levels: ${t.levels.join(", ")}`), t.minResults !== void 0 && o.push(`Min: ${t.minResults}`), r && o.length) {
			let e = document.createElement("div");
			e.style.cssText = "color:var(--sp-muted);font-size:0.75rem", e.textContent = o.join(" | "), i.appendChild(e);
		} else if (!r) {
			let r = document.createElement("div");
			r.className = qM();
			let a = document.createElement("div");
			a.className = JM(), a.style.cssText = "min-width:70px;font-size:0.75rem", a.textContent = "Best of", r.appendChild(a);
			let o = document.createElement("input");
			o.type = "number", o.className = XM(), o.style.fontSize = "0.75rem", o.value = t.bestOfCount === void 0 ? "" : String(t.bestOfCount), o.addEventListener("change", () => {
				let t = o.value.trim();
				e.setCountingBucketField(n, "bestOfCount", t ? Number.parseInt(t, 10) : void 0);
			}), r.appendChild(o), i.appendChild(r);
		}
		return i;
	}
	function o(n) {
		let o = n.draft.aggregationRules;
		if (t.innerHTML = "", !o && n.readonly) {
			let e = document.createElement("div");
			e.className = cN(), e.textContent = "No aggregation rules defined (all results summed)", t.appendChild(e);
			return;
		}
		let s = [
			[
				"rollingPeriodDays",
				"Rolling period (days)",
				"number",
				o?.rollingPeriodDays
			],
			[
				"bestOfCount",
				"Best of count",
				"number",
				o?.bestOfCount
			],
			[
				"minCountableResults",
				"Min countable results",
				"number",
				o?.minCountableResults
			],
			[
				"decayFunction",
				"Decay function",
				"select",
				o?.decayFunction,
				[
					"none",
					"linear",
					"exponential",
					"step"
				]
			]
		];
		for (let [e, i, a, o, c] of s) o === void 0 && n.readonly || t.appendChild(r(e, i, a, o, c, n.readonly));
		let c = [[
			"separateByGender",
			"Separate by gender",
			o?.separateByGender
		], [
			"perCategory",
			"Per category",
			o?.perCategory
		]];
		for (let [r, i, a] of c) {
			if (a === void 0 && n.readonly) continue;
			let o = document.createElement("div");
			o.className = $M();
			let s = document.createElement("input");
			s.type = "checkbox", s.checked = a ?? !1, s.disabled = n.readonly, s.addEventListener("change", () => e.setAggregationField(r, s.checked));
			let c = document.createElement("label");
			c.textContent = i, o.appendChild(s), o.appendChild(c), t.appendChild(o);
		}
		i(o?.tiebreakCriteria ?? [], n.readonly);
		let l = o?.countingBuckets ?? [];
		if (l.length || !n.readonly) {
			let r = document.createElement("div");
			r.style.cssText = "font-weight:600;font-size:0.8rem;margin:0.5rem 0 0.3rem;color:var(--sp-text)", r.textContent = "Counting Buckets", t.appendChild(r);
			for (let e = 0; e < l.length; e++) t.appendChild(a(l[e], e, n.readonly));
			if (!n.readonly) {
				let n = document.createElement("button");
				n.className = "sp-btn sp-btn--sm sp-btn--outline re-add-btn", n.textContent = "+ Add Bucket", n.addEventListener("click", () => e.addCountingBucket()), t.appendChild(n);
			}
		}
	}
	function s(e) {
		let t = JSON.stringify(e.draft.aggregationRules ?? {});
		t !== n && (n = t, o(e));
	}
	return {
		element: t,
		update: s
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/qualityWinSection.ts
function fN(e) {
	let t = document.createElement("div"), n = "";
	function r(t, n, r) {
		let i = document.createElement("div");
		if (i.style.cssText = "display:flex;align-items:center;gap:0.5rem;margin-bottom:0.4rem", r) {
			let e = document.createElement("span");
			e.style.cssText = "font-weight:600;font-size:0.85rem;color:var(--sp-text)", e.textContent = n.rankingScaleName, i.appendChild(e);
		} else {
			let r = document.createElement("input");
			r.type = "text", r.className = YM(), r.style.cssText = "width:150px;font-weight:600", r.value = n.rankingScaleName, r.addEventListener("change", () => e.setQualityWinField(t, "rankingScaleName", r.value)), i.appendChild(r);
			let a = document.createElement("div");
			a.style.flexGrow = "1", i.appendChild(a);
			let o = document.createElement("span");
			o.className = sN(), o.textContent = "✕", o.title = "Delete profile", o.style.cursor = "pointer", o.addEventListener("click", () => e.removeQualityWinProfile(t)), i.appendChild(o);
		}
		return i;
	}
	let i = "text-align:right;padding:2px 4px", a = "text-align:right;width:4rem";
	function o(t, n, r, a) {
		let o = document.createElement("tr");
		if (a) for (let e of [
			r.rankRange[0],
			r.rankRange[1],
			r.value
		]) {
			let t = document.createElement("td");
			t.style.cssText = "text-align:right;font-variant-numeric:tabular-nums;padding:2px 4px", t.textContent = e.toLocaleString(), o.appendChild(t);
		}
		else {
			let a = document.createElement("td");
			a.style.cssText = i, a.appendChild(pN(r.rankRange[0], (i) => {
				e.setQualityWinRange(t, n, "rankRange", [i, r.rankRange[1]]);
			})), o.appendChild(a);
			let s = document.createElement("td");
			s.style.cssText = i, s.appendChild(pN(r.rankRange[1], (i) => {
				e.setQualityWinRange(t, n, "rankRange", [r.rankRange[0], i]);
			})), o.appendChild(s);
			let c = document.createElement("td");
			c.style.cssText = i, c.appendChild(pN(r.value, (r) => {
				e.setQualityWinRange(t, n, "value", r);
			})), o.appendChild(c);
			let l = document.createElement("td");
			l.style.cssText = "text-align:center;padding:2px";
			let u = document.createElement("span");
			u.className = sN(), u.textContent = "×", u.style.cursor = "pointer", u.addEventListener("click", () => e.removeQualityWinRange(t, n)), l.appendChild(u), o.appendChild(l);
		}
		return o;
	}
	function s(e, t, n) {
		let r = document.createElement("table");
		r.style.cssText = "font-size:0.8rem;margin-bottom:0.3rem;border-collapse:collapse";
		let i = document.createElement("thead"), s = document.createElement("tr");
		for (let [e, t] of [
			["From", a],
			["To", a],
			["Bonus", a]
		]) {
			let n = document.createElement("th");
			n.textContent = e, n.style.cssText = t + ";padding:2px 4px", s.appendChild(n);
		}
		if (!n) {
			let e = document.createElement("th");
			e.style.cssText = "width:2rem;padding:2px", s.appendChild(e);
		}
		i.appendChild(s), r.appendChild(i);
		let c = document.createElement("tbody");
		for (let r = 0; r < t.rankingRanges.length; r++) c.appendChild(o(e, r, t.rankingRanges[r], n));
		return r.appendChild(c), r;
	}
	function c(t, n, r, i, a) {
		let o = document.createElement("div");
		o.className = qM();
		let s = document.createElement("div");
		if (s.className = JM(), s.style.minWidth = "100px", s.style.fontSize = "0.75rem", s.textContent = r, o.appendChild(s), a) {
			let e = document.createElement("span");
			e.style.cssText = "font-size:0.75rem;color:var(--sp-muted)", e.textContent = String(i), o.appendChild(e);
		} else {
			let r = document.createElement("input");
			r.type = typeof i == "number" ? "number" : "text", r.className = typeof i == "number" ? XM() : YM(), r.style.fontSize = "0.75rem", r.value = i === void 0 ? "" : String(i), r.addEventListener("change", () => {
				let a = r.value.trim();
				typeof i == "number" || n === "maxBonusPerTournament" ? e.setQualityWinField(t, n, a ? Number.parseFloat(a) : void 0) : e.setQualityWinField(t, n, a || void 0);
			}), o.appendChild(r);
		}
		return o;
	}
	function l(n) {
		let i = n.draft.qualityWinProfiles;
		if (t.innerHTML = "", !i?.length) {
			let r = document.createElement("div");
			if (r.className = cN(), r.textContent = "No quality win profiles defined", t.appendChild(r), !n.readonly) {
				let n = document.createElement("button");
				n.className = "sp-btn sp-btn--sm sp-btn--outline re-add-btn", n.textContent = "+ Add Quality Win Profile", n.addEventListener("click", () => e.addQualityWinProfile()), t.appendChild(n);
			}
			return;
		}
		for (let a = 0; a < i.length; a++) {
			let o = i[a], l = document.createElement("div");
			if (l.style.cssText = "border:1px solid var(--sp-border);border-radius:10px;padding:0.5rem;margin-bottom:0.5rem", l.appendChild(r(a, o, n.readonly)), o.rankingRanges?.length && (l.appendChild(s(a, o, n.readonly)), !n.readonly)) {
				let t = document.createElement("button");
				t.className = "sp-btn sp-btn--sm sp-btn--outline", t.textContent = "+ Range", t.style.marginBottom = "0.3rem", t.addEventListener("click", () => e.addQualityWinRange(a)), l.appendChild(t);
			}
			let u = [[
				"maxBonusPerTournament",
				"Max bonus/tournament",
				o.maxBonusPerTournament
			], [
				"rankingSnapshot",
				"Ranking snapshot",
				o.rankingSnapshot
			]];
			for (let [e, t, r] of u) r === void 0 && n.readonly || l.appendChild(c(a, e, t, r, n.readonly));
			if (o.includeWalkovers !== void 0 || !n.readonly) {
				let t = document.createElement("div");
				t.className = $M();
				let r = document.createElement("input");
				r.type = "checkbox", r.checked = o.includeWalkovers ?? !1, r.disabled = n.readonly, r.addEventListener("change", () => e.setQualityWinField(a, "includeWalkovers", r.checked));
				let i = document.createElement("label");
				i.textContent = "Include walkovers", i.style.fontSize = "0.75rem", t.appendChild(r), t.appendChild(i), l.appendChild(t);
			}
			t.appendChild(l);
		}
		if (!n.readonly) {
			let n = document.createElement("button");
			n.className = "sp-btn sp-btn--sm sp-btn--outline re-add-btn", n.textContent = "+ Add Quality Win Profile", n.addEventListener("click", () => e.addQualityWinProfile()), t.appendChild(n);
		}
	}
	function u(e) {
		let t = JSON.stringify(e.draft.qualityWinProfiles ?? []);
		t !== n && (n = t, l(e));
	}
	return {
		element: t,
		update: u
	};
}
function pN(e, t) {
	let n = document.createElement("input");
	return n.type = "number", n.className = eN(), n.value = String(e), n.addEventListener("change", () => {
		let e = Number.parseFloat(n.value);
		Number.isNaN(e) || t(e);
	}), n;
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/metadataSection.ts
function mN(e) {
	let t = document.createElement("div"), n = document.createElement("div");
	n.className = qM();
	let r = document.createElement("div");
	r.className = JM(), r.textContent = "Name";
	let i = document.createElement("input");
	i.type = "text", i.className = YM(), i.placeholder = "Policy name", i.addEventListener("change", () => e.setPolicyName(i.value)), n.appendChild(r), n.appendChild(i), t.appendChild(n);
	let a = document.createElement("div");
	a.className = qM();
	let o = document.createElement("div");
	o.className = JM(), o.textContent = "Version";
	let s = document.createElement("input");
	s.type = "text", s.className = YM(), s.placeholder = "1.0", s.style.width = "80px", s.addEventListener("change", () => e.setPolicyVersion(s.value)), a.appendChild(o), a.appendChild(s), t.appendChild(a);
	let c = document.createElement("div");
	c.className = qM();
	let l = document.createElement("div");
	l.className = JM(), l.textContent = "Valid from";
	let u = document.createElement("input");
	u.type = "date", u.className = ZM(), u.addEventListener("change", () => e.setValidDateRange("startDate", u.value)), c.appendChild(l), c.appendChild(u), t.appendChild(c);
	let d = document.createElement("div");
	d.className = qM();
	let f = document.createElement("div");
	f.className = JM(), f.textContent = "Valid until";
	let p = document.createElement("input");
	p.type = "date", p.className = ZM(), p.addEventListener("change", () => e.setValidDateRange("endDate", p.value)), d.appendChild(f), d.appendChild(p), t.appendChild(d);
	let m = document.createElement("div");
	m.className = qM();
	let h = document.createElement("div");
	h.className = JM(), h.textContent = "Doubles attribution";
	let g = document.createElement("select");
	g.className = QM();
	for (let [e, t] of [
		["", "(none)"],
		["fullToEach", "Full to each"],
		["halfToEach", "Half to each"],
		["split", "Split"]
	]) {
		let n = document.createElement("option");
		n.value = e, n.textContent = t, g.appendChild(n);
	}
	g.addEventListener("change", () => e.setDoublesAttribution(g.value)), m.appendChild(h), m.appendChild(g), t.appendChild(m);
	let _ = document.createElement("div");
	_.className = qM();
	let v = document.createElement("div");
	v.className = JM(), v.textContent = "Category resolution";
	let y = document.createElement("select");
	y.className = QM();
	for (let [e, t] of [
		["", "(none)"],
		["matchCategory", "Match category"],
		["eventCategory", "Event category"]
	]) {
		let n = document.createElement("option");
		n.value = e, n.textContent = t, y.appendChild(n);
	}
	y.addEventListener("change", () => e.setCategoryResolution(y.value)), _.appendChild(v), _.appendChild(y), t.appendChild(_);
	let b = document.createElement("div");
	b.className = $M();
	let x = document.createElement("input");
	x.type = "checkbox", x.id = "re-require-win";
	let S = document.createElement("label");
	S.htmlFor = "re-require-win", S.textContent = "Require win for points", x.addEventListener("change", () => e.setGlobalFlag("requireWinForPoints", x.checked)), b.appendChild(x), b.appendChild(S), t.appendChild(b);
	let C = document.createElement("div");
	C.className = $M();
	let w = document.createElement("input");
	w.type = "checkbox", w.id = "re-require-win-r1";
	let T = document.createElement("label");
	T.htmlFor = "re-require-win-r1", T.textContent = "Require win in first round", w.addEventListener("change", () => e.setGlobalFlag("requireWinFirstRound", w.checked)), C.appendChild(w), C.appendChild(T), t.appendChild(C);
	let E = [
		i,
		s,
		u,
		p
	], D = [g, y], O = [x, w];
	function k(e) {
		let { draft: t } = e;
		document.activeElement !== i && (i.value = t.policyName ?? ""), document.activeElement !== s && (s.value = t.policyVersion ?? ""), document.activeElement !== u && (u.value = t.validDateRange?.startDate ?? ""), document.activeElement !== p && (p.value = t.validDateRange?.endDate ?? ""), document.activeElement !== g && (g.value = t.doublesAttribution ?? ""), document.activeElement !== y && (y.value = t.categoryResolution ?? ""), x.checked = t.requireWinForPoints ?? !1, w.checked = t.requireWinFirstRound ?? !1;
		let n = e.readonly;
		for (let e of E) e.disabled = n;
		for (let e of D) e.disabled = n;
		for (let e of O) e.disabled = n;
	}
	return {
		element: t,
		update: k
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/domain/rankingProjections.ts
var hN = {
	1: "W",
	2: "F",
	4: "SF",
	8: "QF",
	16: "R16",
	32: "R32",
	64: "R64",
	128: "R128",
	256: "R256"
}, gN = "level-keyed";
function _N(e) {
	return hN[e] ?? `R${e}`;
}
function vN(e) {
	if (!e) return { type: "flat" };
	let t = Object.values(e);
	if (!t.length || t.every((e) => typeof e == "number")) return { type: "flat" };
	let n = yN(t);
	return n.hasConditionalArray ? { type: "conditional" } : n.hasLevelFlightNesting ? bN(t, n.allLevels) : n.allLevels.size > 0 ? {
		type: "level-columns",
		levels: [...n.allLevels].sort((e, t) => e - t)
	} : n.allFlights.size > 0 ? {
		type: "flight-columns",
		flights: [...n.allFlights].sort((e, t) => e - t)
	} : { type: "flat" };
}
function yN(e) {
	let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
	for (let a of e) {
		let e = xN(a);
		if (e.type === gN) {
			for (let n of e.levels) t.add(n);
			e.hasFlightNesting && (i = !0);
		} else if (e.type === "flight-keyed") for (let t = 0; t < e.flightCount; t++) n.add(t + 1);
		else e.type === "conditional-array" && (r = !0);
	}
	return {
		allLevels: t,
		allFlights: n,
		hasConditionalArray: r,
		hasLevelFlightNesting: i
	};
}
function bN(e, t) {
	let n = {}, r = [...t].sort((e, t) => e - t);
	for (let t of e) {
		let e = xN(t);
		if (e.type === gN && e.flightDetails) for (let [t, r] of Object.entries(e.flightDetails)) {
			let e = Number(t);
			n[e] || (n[e] = []);
			for (let t of r) n[e].includes(t) || n[e].push(t);
		}
	}
	return {
		type: "level-flight-tabs",
		levels: r,
		flightsPerLevel: n
	};
}
function xN(e) {
	if (typeof e == "number") return {
		type: "flat",
		levels: [],
		flightCount: 0,
		hasFlightNesting: !1
	};
	if (Array.isArray(e)) return {
		type: "conditional-array",
		levels: [],
		flightCount: 0,
		hasFlightNesting: !1
	};
	if (typeof e != "object" || !e) return {
		type: "flat",
		levels: [],
		flightCount: 0,
		hasFlightNesting: !1
	};
	if (e.level !== void 0) {
		if (Array.isArray(e.level)) return {
			type: gN,
			levels: e.level.map((e, t) => t + 1),
			flightCount: 0,
			hasFlightNesting: !1
		};
		if (typeof e.level == "object") {
			let t = Object.keys(e.level).map(Number).filter((e) => !Number.isNaN(e)), n = !1, r = {};
			for (let [t, i] of Object.entries(e.level)) typeof i == "object" && i && i.flights && (n = !0, r[Number(t)] = i.flights.map((e, t) => t + 1));
			return {
				type: gN,
				levels: t,
				flightCount: 0,
				hasFlightNesting: n,
				flightDetails: r
			};
		}
	}
	return e.flights !== void 0 || e.f !== void 0 ? {
		type: "flight-keyed",
		levels: [],
		flightCount: (e.flights ?? e.f ?? []).length,
		hasFlightNesting: !1
	} : e.value === void 0 ? {
		type: "flat",
		levels: [],
		flightCount: 0,
		hasFlightNesting: !1
	} : {
		type: "explicit-flat",
		levels: [],
		flightCount: 0,
		hasFlightNesting: !1
	};
}
function SN(e, t = {}) {
	if (typeof e == "number") return e;
	if (e != null) {
		if (Array.isArray(e)) return CN(e, t);
		if (typeof e == "object") {
			if (e.level !== void 0 && t.level !== void 0) return wN(e, t);
			if (t.flight !== void 0) {
				let n = e.flights ?? e.f;
				if (Array.isArray(n)) return n[t.flight - 1];
			}
			if (e.value !== void 0) return e.value;
		}
	}
}
function CN(e, t) {
	for (let n of e) {
		if (n.drawSizes && t.drawSize && n.drawSizes.includes(t.drawSize)) return SN(n, t);
		if (n.drawSize !== void 0 && t.drawSize !== void 0 && (n.threshold ? t.drawSize >= n.drawSize : t.drawSize === n.drawSize)) return SN({
			...n,
			drawSize: void 0,
			drawSizes: void 0,
			threshold: void 0
		}, t);
		if (n.drawSize === void 0 && n.drawSizes === void 0) return SN(n, t);
	}
}
function wN(e, t) {
	let n = Array.isArray(e.level) ? e.level[t.level - 1] : e.level[t.level];
	if (n !== void 0) return typeof n == "object" && n ? SN(n, t) : typeof n == "number" ? n : void 0;
}
function TN(e) {
	let t = [], n = Object.keys(e.finishingPositionRanges ?? {}).length;
	return n && t.push(`${n} positions`), (e.perWinPoints || e.pointsPerWin) && t.push("per-win"), e.bonusPoints?.length && t.push(`${e.bonusPoints.length} bonus`), t.join(", ") || "empty";
}
function EN(e) {
	let t = [];
	for (let n of e.eventTypes ?? []) t.push({
		label: n,
		intent: "re-badge--accent"
	});
	for (let n of e.stages ?? []) t.push({
		label: n,
		intent: "re-badge--success"
	});
	for (let n of e.levels ?? []) t.push({
		label: `L${n}`,
		intent: "re-badge--warn"
	});
	for (let n of e.drawTypes ?? []) t.push({
		label: n.replaceAll("_", " "),
		intent: "re-badge--primary"
	});
	return e.participationOrder !== void 0 && t.push({
		label: `PO:${e.participationOrder}`,
		intent: "re-badge--info"
	}), t;
}
function DN(e) {
	return e == null ? "--" : e.toLocaleString();
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/positionPointsTable.ts
var ON = [
	1,
	2,
	4,
	8,
	16,
	32,
	64,
	128
], kN = "font-size:0.8rem;margin-bottom:0;border-collapse:collapse", AN = "width:3.5rem;text-align:center";
function jN(e, t) {
	let n = document.createElement("div");
	n.style.cssText = "overflow-x:auto";
	let r = "";
	function i(r) {
		let i = r.draft.awardProfiles?.[t]?.finishingPositionRanges;
		if (n.innerHTML = "", !i || !Object.keys(i).length) {
			let i = document.createElement("div");
			if (i.className = cN(), i.textContent = "No finishing position points defined", !r.readonly) {
				let n = document.createElement("button");
				n.className = "sp-btn sp-btn--sm sp-btn--outline re-add-btn", n.textContent = "+ Add position", n.style.marginLeft = "8px", n.addEventListener("click", () => e.addPositionRow(t, 1)), i.appendChild(n);
			}
			n.appendChild(i);
			return;
		}
		let a = vN(i), o = Object.keys(i).map(Number).sort((e, t) => e - t);
		a.type === "flat" ? MN(n, o, i, r.readonly, e, t) : a.type === "level-columns" ? NN(n, o, i, a.levels, r.readonly, e, t) : PN(n, o, i, a);
	}
	function a(e) {
		let n = e.draft.awardProfiles?.[t], a = JSON.stringify(n?.finishingPositionRanges ?? {});
		a !== r && (r = a, i(e));
	}
	return {
		element: n,
		update: a
	};
}
function MN(e, t, n, r, i, a) {
	let o = document.createElement("table");
	o.style.cssText = kN;
	let s = document.createElement("thead"), c = document.createElement("tr");
	FN(c, "Pos", AN), FN(c, "Points", "text-align:right"), r || FN(c, "", "width:2rem"), s.appendChild(c), o.appendChild(s);
	let l = document.createElement("tbody");
	for (let e of t) {
		let t = document.createElement("tr");
		IN(t, e);
		let o = document.createElement("td");
		o.style.cssText = "text-align:right;padding:2px 4px", r ? (o.style.fontVariantNumeric = "tabular-nums", o.textContent = DN(typeof n[e] == "number" ? n[e] : SN(n[e]))) : o.appendChild(RN(typeof n[e] == "number" ? n[e] : SN(n[e]) ?? 0, (t) => i.setFlatPositionPoints(a, e, t))), t.appendChild(o), r || LN(t, () => i.removePositionRow(a, e)), l.appendChild(t);
	}
	o.appendChild(l), e.appendChild(o), r || zN(e, t, i, a);
}
function NN(e, t, n, r, i, a, o) {
	let s = document.createElement("table");
	s.style.cssText = kN;
	let c = document.createElement("thead"), l = document.createElement("tr");
	FN(l, "Pos", AN);
	for (let e of r) {
		let t = document.createElement("th");
		if (t.style.cssText = "text-align:right;min-width:3.5rem;padding:2px 4px", i) t.textContent = `L${e}`;
		else {
			let n = document.createElement("div");
			n.style.cssText = "display:flex;align-items:center;justify-content:flex-end;gap:4px";
			let r = document.createElement("span");
			r.textContent = `L${e}`, n.appendChild(r);
			let i = document.createElement("span");
			i.className = sN(), i.textContent = "×", i.title = `Remove level ${e}`, i.style.cssText = "cursor:pointer;font-size:0.65rem", i.addEventListener("click", () => a.removeLevel(o, e)), n.appendChild(i), t.appendChild(n);
		}
		l.appendChild(t);
	}
	i || FN(l, "", "width:2rem"), c.appendChild(l), s.appendChild(c);
	let u = document.createElement("tbody");
	for (let e of t) {
		let t = document.createElement("tr");
		IN(t, e);
		for (let s of r) {
			let r = document.createElement("td");
			r.style.cssText = "text-align:right;padding:2px 4px";
			let c = SN(n[e], { level: s });
			i ? (r.style.fontVariantNumeric = "tabular-nums", r.textContent = DN(c), c === void 0 && (r.style.color = "var(--sp-muted)")) : r.appendChild(RN(c ?? 0, (t) => a.setLevelPositionPoints(o, e, s, t))), t.appendChild(r);
		}
		i || LN(t, () => a.removePositionRow(o, e)), u.appendChild(t);
	}
	if (s.appendChild(u), e.appendChild(s), !i) {
		let n = document.createElement("div");
		n.style.cssText = "display:flex;gap:8px;margin-top:6px;flex-wrap:wrap";
		let i = document.createElement("div");
		i.style.cssText = "display:flex;align-items:center;gap:4px";
		let s = document.createElement("input");
		s.type = "number", s.className = eN(), s.style.width = "50px", s.placeholder = "L#", s.min = "1";
		let c = document.createElement("button");
		c.className = "sp-btn sp-btn--sm sp-btn--outline", c.textContent = "+ Level", c.addEventListener("click", () => {
			let e = Number.parseInt(s.value, 10);
			!Number.isNaN(e) && e > 0 && !r.includes(e) && (a.addLevel(o, e), s.value = "");
		}), i.appendChild(s), i.appendChild(c), n.appendChild(i), BN(n, t, a, o), e.appendChild(n);
	}
}
function PN(e, t, n, r) {
	let i = document.createElement("div");
	i.style.cssText = "font-size:0.7rem;color:var(--sp-muted);margin-bottom:4px;font-style:italic", i.textContent = `(${r.type} layout — view only)`, e.appendChild(i);
	let a = document.createElement("table");
	a.style.cssText = kN;
	let o = document.createElement("thead"), s = document.createElement("tr");
	if (FN(s, "Pos", AN), r.type === "flight-columns") for (let e of r.flights) FN(s, `F${e}`, "text-align:right;min-width:3.5rem");
	else FN(s, "Points", "text-align:right");
	o.appendChild(s), a.appendChild(o);
	let c = document.createElement("tbody");
	for (let e of t) {
		let t = document.createElement("tr");
		IN(t, e);
		let i = n[e];
		if (r.type === "flight-columns") for (let e of r.flights) {
			let n = document.createElement("td");
			n.style.cssText = "text-align:right;font-variant-numeric:tabular-nums;padding:2px 4px";
			let r = SN(i, { flight: e });
			n.textContent = DN(r), r === void 0 && (n.style.color = "var(--sp-muted)"), t.appendChild(n);
		}
		else {
			let e = document.createElement("td");
			if (e.style.cssText = "text-align:right;font-variant-numeric:tabular-nums;padding:2px 4px", e.textContent = DN(SN(i)), Array.isArray(i)) {
				let t = document.createElement("span");
				t.style.cssText = "margin-left:0.3rem;font-size:0.65rem;color:var(--sp-muted)", t.textContent = `${i.length} variants`, t.title = JSON.stringify(i, null, 2), e.appendChild(t);
			}
			t.appendChild(e);
		}
		c.appendChild(t);
	}
	a.appendChild(c), e.appendChild(a);
}
function FN(e, t, n) {
	let r = document.createElement("th");
	r.textContent = t, r.style.cssText = n + ";padding:2px 4px", e.appendChild(r);
}
function IN(e, t) {
	let n = document.createElement("td");
	n.style.cssText = "text-align:center;font-weight:600;color:var(--sp-text);padding:2px 4px", n.textContent = _N(t), e.appendChild(n);
}
function LN(e, t) {
	let n = document.createElement("td");
	n.style.cssText = "text-align:center;vertical-align:middle;padding:2px";
	let r = document.createElement("span");
	r.className = sN(), r.textContent = "×", r.title = "Remove position", r.style.cursor = "pointer", r.addEventListener("click", t), n.appendChild(r), e.appendChild(n);
}
function RN(e, t) {
	let n = document.createElement("input");
	return n.type = "number", n.className = eN(), n.value = String(e), n.addEventListener("change", () => {
		let e = Number.parseFloat(n.value);
		Number.isNaN(e) || t(e);
	}), n;
}
function zN(e, t, n, r) {
	let i = document.createElement("div");
	i.style.cssText = "display:flex;gap:8px;margin-top:6px;flex-wrap:wrap", BN(i, t, n, r), e.appendChild(i);
}
function BN(e, t, n, r) {
	let i = new Set(t), a = ON.filter((e) => !i.has(e));
	if (!a.length) return;
	let o = document.createElement("div");
	o.style.cssText = "display:flex;align-items:center;gap:4px";
	let s = document.createElement("select");
	s.className = "re-field-select", s.style.cssText = "min-width:80px;font-size:11px;padding:4px 6px";
	for (let e of a) {
		let t = document.createElement("option");
		t.value = String(e), t.textContent = _N(e), s.appendChild(t);
	}
	let c = document.createElement("button");
	c.className = "sp-btn sp-btn--sm sp-btn--outline", c.textContent = "+ Position", c.addEventListener("click", () => {
		let e = Number.parseInt(s.value, 10);
		Number.isNaN(e) || n.addPositionRow(r, e);
	}), o.appendChild(s), o.appendChild(c), e.appendChild(o);
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/perWinPointsRow.ts
function VN(e, t) {
	let n = document.createElement("div");
	n.style.cssText = "padding:0.25rem 0;font-size:0.8rem";
	let r = document.createElement("div");
	r.className = qM();
	let i = document.createElement("div");
	i.className = JM(), i.textContent = "Per-Win", i.style.minWidth = "80px";
	let a = document.createElement("input");
	a.type = "number", a.className = eN(), a.placeholder = "—", a.addEventListener("change", () => {
		let n = a.value.trim();
		e.setPointsPerWin(t, n === "" ? void 0 : parseFloat(n));
	});
	let o = document.createElement("div");
	o.style.cssText = "font-size:0.75rem;color:var(--sp-muted)", r.appendChild(i), r.appendChild(a), n.appendChild(r), n.appendChild(o);
	function s(e) {
		let r = e.draft.awardProfiles?.[t];
		if (!r) {
			n.style.display = "none";
			return;
		}
		let i = r.perWinPoints, s = r.pointsPerWin;
		if (!i && s === void 0) {
			n.style.display = "none";
			return;
		}
		if (n.style.display = "", a.disabled = e.readonly, s !== void 0 && typeof s == "number" ? (a.style.display = "", o.style.display = "none", document.activeElement !== a && (a.value = String(s))) : s === void 0 ? i && (a.style.display = "none", o.style.display = "", o.textContent = (Array.isArray(i) ? i : [i]).map((e) => {
			let t = [];
			return e.participationOrders?.length && t.push(`PO:${e.participationOrders.join(",")}`), e.value !== void 0 && t.push(`${e.value} pts/win`), e.limit !== void 0 && t.push(`limit: ${e.limit}`), t.join(" | ");
		}).join("; ")) : (a.style.display = "none", o.style.display = "", o.textContent = `${DN(SN(s))} pts/win (complex)`), r.maxCountableMatches !== void 0) {
			let e = typeof r.maxCountableMatches == "number" ? r.maxCountableMatches : "level-keyed";
			o.style.display = "";
			let t = o.textContent;
			o.textContent = t ? `${t} — max countable: ${e}` : `Max countable: ${e}`;
		}
	}
	return {
		element: n,
		update: s
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/bonusPointsRow.ts
function HN(e, t) {
	let n = document.createElement("div");
	n.style.cssText = "padding:0.25rem 0;font-size:0.8rem";
	let r = "";
	function i(r) {
		let i = r.draft.awardProfiles?.[t]?.bonusPoints;
		if (n.innerHTML = "", !i?.length && r.readonly) {
			n.style.display = "none";
			return;
		}
		n.style.display = "";
		let a = document.createElement("div");
		if (a.style.cssText = "font-weight:600;color:var(--sp-text);margin-bottom:4px", a.textContent = "Bonus Points", n.appendChild(a), i?.length) for (let a = 0; a < i.length; a++) {
			let o = i[a], s = document.createElement("div");
			if (s.style.cssText = "display:flex;align-items:center;gap:6px;margin-bottom:4px;padding-left:0.5rem", r.readonly) {
				let e = o.finishingPositions.map(_N).join(", "), t = document.createElement("span");
				t.textContent = `${e}: `, s.appendChild(t);
				let n = document.createElement("span");
				n.style.fontVariantNumeric = "tabular-nums", n.textContent = typeof o.value == "number" ? o.value.toLocaleString() : String(o.value ?? "—"), s.appendChild(n);
			} else {
				let n = document.createElement("span");
				n.style.cssText = "font-size:0.75rem;color:var(--sp-muted);min-width:30px", n.textContent = "Pos:", s.appendChild(n);
				let r = document.createElement("input");
				r.type = "text", r.className = eN(), r.style.width = "80px", r.value = o.finishingPositions.join(", "), r.title = "Comma-separated positions (e.g. 1, 2)", r.addEventListener("change", () => {
					let n = r.value.split(",").map((e) => Number.parseInt(e.trim(), 10)).filter((e) => !Number.isNaN(e) && e > 0);
					n.length && e.setBonusPointPositions(t, a, n);
				}), s.appendChild(r);
				let i = document.createElement("span");
				i.style.cssText = "font-size:0.75rem;color:var(--sp-muted)", i.textContent = "Pts:", s.appendChild(i);
				let c = document.createElement("input");
				c.type = "number", c.className = eN(), c.value = typeof o.value == "number" ? String(o.value) : "", c.addEventListener("change", () => {
					let n = Number.parseFloat(c.value);
					Number.isNaN(n) || e.setBonusPointValue(t, a, n);
				}), s.appendChild(c);
				let l = document.createElement("span");
				l.className = sN(), l.textContent = "×", l.title = "Remove bonus", l.style.cursor = "pointer", l.addEventListener("click", () => e.removeBonusPoint(t, a)), s.appendChild(l);
			}
			n.appendChild(s);
		}
		if (!r.readonly) {
			let r = document.createElement("button");
			r.className = "sp-btn sp-btn--sm sp-btn--outline", r.textContent = "+ Add bonus", r.style.cssText = "margin-top:4px;margin-left:0.5rem", r.addEventListener("click", () => e.addBonusPoint(t)), n.appendChild(r);
		}
	}
	function a(e) {
		let n = e.draft.awardProfiles?.[t], a = JSON.stringify(n?.bonusPoints ?? []);
		a !== r && (r = a, i(e));
	}
	return {
		element: n,
		update: a
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/scopeBadges.ts
function UN(e) {
	let t = document.createElement("div");
	t.style.cssText = "display:inline-flex;gap:0.25rem;flex-wrap:wrap;margin-bottom:0";
	let n = EN(e);
	if (!n.length) {
		let e = document.createElement("span");
		return e.className = "re-badge re-badge--neutral", e.textContent = "All", t.appendChild(e), t;
	}
	for (let e of n) {
		let n = document.createElement("span");
		n.className = `re-badge ${e.intent}`, n.textContent = e.label, t.appendChild(n);
	}
	return t;
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/scopeEditor.ts
var WN = [
	{
		field: "eventTypes",
		label: "Event types",
		options: [
			"SINGLES",
			"DOUBLES",
			"TEAM"
		]
	},
	{
		field: "drawTypes",
		label: "Draw types",
		options: [
			"SINGLE_ELIMINATION",
			"DOUBLE_ELIMINATION",
			"ROUND_ROBIN",
			"COMPASS",
			"FEED_IN",
			"AD_HOC",
			"LUCKY_DRAW"
		]
	},
	{
		field: "stages",
		label: "Stages",
		options: [
			"MAIN",
			"QUALIFYING",
			"CONSOLATION",
			"PLAY_OFF"
		]
	},
	{
		field: "levels",
		label: "Levels",
		options: [],
		isNumeric: !0
	}
], GN = [
	["maxDrawSize", "Max draw size"],
	["maxLevel", "Max level"],
	["priority", "Priority"],
	["participationOrder", "Participation order"]
];
function KN(e, t) {
	let n = document.createElement("div");
	n.style.cssText = "padding:0.25rem 0";
	let r = document.createElement("div");
	r.style.cssText = "font-weight:600;font-size:0.8rem;color:var(--sp-text);margin-bottom:4px", r.textContent = "Scope", n.appendChild(r);
	let i = document.createElement("div");
	n.appendChild(i);
	let a = "";
	function o(n, r) {
		if (n.isNumeric) {
			let i = document.createElement("input");
			return i.type = "number", i.min = "1", i.placeholder = "+", i.style.cssText = "width:36px;font-size:0.7rem;padding:2px 4px;border:1px dashed var(--sp-border);border-radius:4px;background:transparent;color:var(--sp-text);outline:none;text-align:center", i.addEventListener("keydown", (a) => {
				if (a.key === "Enter") {
					let a = Number.parseInt(i.value, 10);
					!Number.isNaN(a) && a > 0 && !r.includes(a) && (e.setProfileScope(t, n.field, [...r, a].sort((e, t) => e - t)), i.value = "");
				}
			}), i;
		}
		let i = n.options.filter((e) => !r.includes(e));
		if (!i.length) return;
		let a = document.createElement("select");
		a.style.cssText = "font-size:0.65rem;padding:2px 4px;border:1px dashed var(--sp-border);border-radius:4px;background:transparent;color:var(--sp-muted);outline:none;cursor:pointer";
		let o = document.createElement("option");
		o.value = "", o.textContent = "+", a.appendChild(o);
		for (let e of i) {
			let t = document.createElement("option");
			t.value = e, t.textContent = e, a.appendChild(t);
		}
		return a.addEventListener("change", () => {
			a.value && e.setProfileScope(t, n.field, [...r, a.value]);
		}), a;
	}
	function s(n, r, i) {
		let a = document.createElement("div");
		a.style.cssText = "margin-bottom:6px";
		let s = document.createElement("div");
		s.style.cssText = "font-size:0.7rem;color:var(--sp-muted);margin-bottom:2px", s.textContent = n.label, a.appendChild(s);
		let c = document.createElement("div");
		c.style.cssText = "display:flex;flex-wrap:wrap;gap:4px;align-items:center";
		for (let a of r) {
			let o = document.createElement("span");
			if (o.className = "re-badge re-badge--accent", o.style.cssText = "display:inline-flex;align-items:center;gap:3px", o.textContent = n.isNumeric ? `L${a}` : String(a), !i) {
				let i = document.createElement("span");
				i.style.cssText = "cursor:pointer;font-size:0.6rem;opacity:0.7", i.textContent = "×", i.addEventListener("click", () => {
					e.setProfileScope(t, n.field, r.filter((e) => e !== a));
				}), o.appendChild(i);
			}
			c.appendChild(o);
		}
		if (!i) {
			let e = o(n, r);
			e && c.appendChild(e);
		}
		return a.appendChild(c), a;
	}
	function c(r) {
		i.innerHTML = "";
		let a = r.draft.awardProfiles?.[t];
		if (!a) return;
		let o = r.readonly;
		for (let e of WN) {
			let t = a[e.field] ?? [];
			o && !t.length || i.appendChild(s(e, t, o));
		}
		for (let [n, r] of GN) {
			let s = a[n];
			if (o && s === void 0) continue;
			let c = document.createElement("div");
			c.className = qM();
			let l = document.createElement("div");
			if (l.className = JM(), l.style.cssText = "min-width:110px;font-size:0.75rem", l.textContent = r, c.appendChild(l), o) {
				let e = document.createElement("span");
				e.style.cssText = "font-size:0.75rem;color:var(--sp-text)", e.textContent = String(s), c.appendChild(e);
			} else {
				let r = document.createElement("input");
				r.type = "number", r.className = XM(), r.style.fontSize = "0.75rem", r.value = s === void 0 ? "" : String(s), r.placeholder = "—", r.addEventListener("change", () => {
					let i = r.value.trim();
					e.setProfileField(t, n, i ? Number.parseInt(i, 10) : void 0);
				}), c.appendChild(r);
			}
			i.appendChild(c);
		}
		let c = i.children.length > 0;
		n.style.display = c ? "" : "none";
	}
	function l(e) {
		let n = e.draft.awardProfiles?.[t], r = WN.map((e) => n?.[e.field] ?? []), i = GN.map(([e]) => n?.[e]), o = JSON.stringify([
			r,
			i,
			e.readonly
		]);
		o !== a && (a = o, c(e));
	}
	return {
		element: n,
		update: l
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/sections/profileCard.ts
function qN(e, t) {
	let n = document.createElement("div");
	n.className = tN();
	let r = document.createElement("div");
	r.className = nN();
	let i = document.createElement("span");
	i.className = WM(), i.style.flexShrink = "0", r.appendChild(i);
	let a = document.createElement("input");
	a.type = "text", a.className = rN(), a.addEventListener("click", (e) => e.stopPropagation()), a.addEventListener("change", () => e.setProfileName(t, a.value)), r.appendChild(a);
	let o = document.createElement("div");
	o.style.cssText = "flex-grow:1;display:inline-flex;gap:0.25rem;flex-wrap:wrap", r.appendChild(o);
	let s = document.createElement("span");
	s.style.cssText = "font-size:0.75rem;color:var(--sp-muted);white-space:nowrap;flex-shrink:0", r.appendChild(s);
	let c = document.createElement("div");
	c.className = aN();
	let l = document.createElement("button");
	l.className = oN(), l.textContent = "⎘", l.title = "Duplicate profile", l.addEventListener("click", (n) => {
		n.stopPropagation(), e.duplicateProfile(t);
	});
	let u = document.createElement("button");
	u.className = sN(), u.textContent = "✕", u.title = "Delete profile", u.addEventListener("click", (n) => {
		n.stopPropagation(), e.removeProfile(t);
	}), c.appendChild(l), c.appendChild(u), r.appendChild(c), r.addEventListener("click", () => e.toggleProfile(t)), n.appendChild(r);
	let d = document.createElement("div");
	d.className = iN();
	let f = document.createElement("div");
	f.style.cssText = "font-weight:600;font-size:0.85rem;color:var(--sp-text);margin-bottom:6px", d.appendChild(f);
	let p = jN(e, t);
	d.appendChild(p.element);
	let m = VN(e, t);
	d.appendChild(m.element);
	let h = HN(e, t);
	d.appendChild(h.element);
	let g = KN(e, t);
	d.appendChild(g.element);
	let _ = document.createElement("div");
	_.style.cssText = "padding:0.25rem 0;font-size:0.75rem;color:var(--sp-muted)", d.appendChild(_), n.appendChild(d);
	function v(e) {
		let r = e.draft.awardProfiles?.[t];
		if (!r) {
			n.style.display = "none";
			return;
		}
		n.style.display = "";
		let l = e.expandedProfiles.has(t), u = e.readonly;
		i.textContent = l ? "▼" : "▶";
		let v = r.profileName || `Profile ${t + 1}`;
		document.activeElement !== a && (a.value = v), a.title = v, a.disabled = u, o.innerHTML = "";
		let y = UN(r);
		if (y.style.flexGrow = "1", o.appendChild(y), s.textContent = l ? "" : TN(r), c.style.display = u ? "none" : "flex", d.style.display = l ? "" : "none", l) {
			f.textContent = v, p.update(e), m.update(e), h.update(e), g.update(e);
			let t = [];
			r.requireWinForPoints !== void 0 && t.push(`requireWin: ${r.requireWinForPoints}`), r.requireWinFirstRound !== void 0 && t.push(`requireWinR1: ${r.requireWinFirstRound}`), _.textContent = t.join(" | "), _.style.display = t.length ? "" : "none";
		}
	}
	return {
		element: n,
		update: v
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/rankingPointsEditorPanel.ts
function JN(e, t) {
	let n = document.createElement("div");
	n.className = lN();
	let r = mN(e), i = fN(e), a = dN(e), o = [
		{
			id: "metadata",
			label: "Metadata"
		},
		{
			id: "awardProfiles",
			label: "Award Profiles",
			countFn: (e) => e.draft.awardProfiles?.length ?? 0
		},
		{
			id: "qualityWinProfiles",
			label: "Quality Win Profiles",
			countFn: (e) => e.draft.qualityWinProfiles?.length ?? 0
		},
		{
			id: "aggregationRules",
			label: "Aggregation Rules"
		}
	], s = [];
	for (let t of o) {
		let o = document.createElement("div");
		o.className = HM();
		let c = document.createElement("div");
		c.className = UM();
		let l = document.createElement("span");
		l.className = WM();
		let u = document.createElement("span");
		u.textContent = t.label;
		let d = document.createElement("span");
		d.className = GM(), c.appendChild(l), c.appendChild(u), c.appendChild(d), c.addEventListener("click", () => e.toggleSection(t.id));
		let f = document.createElement("div");
		f.className = KM(), t.id === "metadata" && f.appendChild(r.element), t.id === "qualityWinProfiles" && f.appendChild(i.element), t.id === "aggregationRules" && f.appendChild(a.element), o.appendChild(c), o.appendChild(f), n.appendChild(o), s.push({
			id: t.id,
			chevron: l,
			countEl: d,
			bodyEl: f
		});
	}
	let c = [], l = -1, u = "", d = null;
	function f(e, t) {
		for (let n = 0; n < o.length; n++) {
			let r = o[n], i = s[n], a = e.has(r.id);
			if (i.chevron.textContent = a ? "▼" : "▶", i.bodyEl.style.display = a ? "block" : "none", r.countFn) {
				let e = r.countFn(t);
				i.countEl.textContent = e ? `(${e})` : "";
			}
		}
	}
	function p(t, n) {
		let r = s[1].bodyEl;
		r.innerHTML = "", c = [];
		let i = t.draft.awardProfiles ?? [], a = 0;
		for (let t = 0; t < i.length; t++) {
			let o = i[t];
			if (n && ![
				o.profileName ?? "",
				...o.eventTypes ?? [],
				...o.stages ?? [],
				...(o.levels ?? []).map((e) => `L${e}`),
				...o.drawTypes ?? []
			].join(" ").toLowerCase().includes(n)) continue;
			let s = qN(e, t);
			c.push(s), r.appendChild(s.element), a++;
		}
		if (!a) {
			let e = document.createElement("div");
			e.className = cN(), e.textContent = n ? "No profiles match filter" : "No award profiles defined", r.appendChild(e);
		}
		t.readonly || (d = document.createElement("button"), d.className = "sp-btn sp-btn--sm sp-btn--outline re-add-btn", d.textContent = "+ Add Profile", d.addEventListener("click", () => e.addProfile()), r.appendChild(d));
	}
	return {
		element: n,
		update: (e) => {
			let { draft: t, expandedSections: n, profileFilter: o } = e;
			if (f(n, e), n.has("metadata") && r.update(e), n.has("awardProfiles")) {
				let n = t.awardProfiles?.length ?? 0, r = o.toLowerCase();
				(n !== l || r !== u) && (l = n, u = r, p(e, r));
				for (let t of c) t.update(e);
				d && (d.style.display = e.readonly ? "none" : "");
			}
			n.has("qualityWinProfiles") && i.update(e), n.has("aggregationRules") && a.update(e);
		}
	};
}
//#endregion
//#region src/components/policy-catalog/editors/ranking/rankingPointsEditorControl.ts
var YN = class e {
	constructor(e) {
		this.container = null, this.store = new VM(e), this.panel = JN(this.store, e), this.unsubscribe = this.store.subscribe((e) => {
			this.panel.update(e);
		}), this.panel.update(this.store.getState());
	}
	render(e) {
		this.container = e, e.appendChild(this.panel.element);
	}
	destroy() {
		this.unsubscribe(), this.container && this.panel.element.parentNode === this.container && this.panel.element.remove(), this.container = null;
	}
	getData() {
		return this.store.getData();
	}
	setData(e) {
		this.store.setData(e);
	}
	getStore() {
		return this.store;
	}
	static createEditorInstance(t) {
		let n = new e({
			initialPolicy: t.initialData,
			onChange: (e) => t.onChange(e),
			readonly: t.readonly
		});
		return {
			element: n.panel.element,
			setData(e) {
				n.setData(e);
			},
			getData() {
				return n.getData();
			},
			destroy() {
				n.destroy();
			}
		};
	}
};
//#endregion
//#region src/components/policy-catalog/editors/scheduling/domain/schedulingProjections.ts
function XN(e) {
	return ZN[e] ?? e;
}
var ZN = {
	"SET3-S:6/TB7": "Best of 3 TB sets",
	"SET3-S:6/TB7-F:TB10": "2 TB sets, MTB10",
	"SET3-S:6/TB7-F:TB7": "2 TB sets, MTB7",
	"SET3-S:4NOAD-F:TB7": "2 short sets (4, NOAD), MTB7",
	"SET3-S:4/TB7": "Best of 3 short sets (4)",
	"SET3-S:4/TB7-F:TB7": "2 short sets (4), MTB7",
	"SET3-S:4/TB7-F:TB10": "2 short sets (4), MTB10",
	"SET3-S:4/TB5@3": "3 short sets (4), TB5@3",
	"SET1-S:8/TB7": "8-game pro-set, TB7",
	"SET1-S:8/TB7@7": "8-game pro-set, TB7@7",
	"SET1-S:5/TB9@4": "1 set to 5, TB9@4",
	"SET1-S:6/TB7": "1 TB set",
	"SET1-S:6NOAD": "1 set to 6, NOAD",
	"SET1-S:4/TB7": "1 short set (4), TB7",
	"SET1-S:4/TB5@3": "1 short set (4), TB5@3",
	"SET1-S:4NOAD": "1 short set (4), NOAD",
	"SET3-S:TB10": "Best of 3 TB10 games",
	"SET1-S:T20": "Timed 20 min",
	"SET1-S:TB10": "1 TB10 game",
	"SET5-S:6/TB7": "Best of 5 TB sets",
	"SET5-S:6/TB7-F:TB10": "5 sets, MTB10",
	"SET1-S:6/TB10": "1 set, TB10",
	"SET1-S:8": "Pro-set to 8",
	"SET1-S:10": "Pro-set to 10",
	"SET1-S:T7": "TB7 only",
	"SET1-S:T21": "TB21 only"
};
function QN() {
	return {
		allowModificationWhenMatchUpsScheduled: {
			courts: !1,
			venues: !1
		},
		defaultTimes: {
			averageTimes: [{
				categoryNames: [],
				minutes: { default: 90 }
			}],
			recoveryTimes: [{ minutes: { default: 60 } }]
		},
		defaultDailyLimits: {
			SINGLES: 2,
			DOUBLES: 2,
			total: 3
		},
		matchUpAverageTimes: [],
		matchUpRecoveryTimes: [],
		matchUpDailyLimits: []
	};
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/schedulingEditorStore.ts
function $(e) {
	return structuredClone(e);
}
var $N = class {
	constructor(e) {
		this.listeners = /* @__PURE__ */ new Set(), this.config = e, this.state = {
			draft: $(e.initialPolicy ?? QN()),
			expandedSections: new Set([
				"modificationFlags",
				"dailyLimits",
				"defaultTimes",
				"averageTimes",
				"recoveryTimes"
			]),
			dirty: !1
		};
	}
	getState() {
		return this.state;
	}
	getData() {
		return $(this.state.draft);
	}
	setData(e) {
		this.state = {
			...this.state,
			draft: $(e),
			dirty: !1
		}, this.emit();
	}
	toggleSection(e) {
		let t = new Set(this.state.expandedSections);
		t.has(e) ? t.delete(e) : t.add(e), this.state = {
			...this.state,
			expandedSections: t
		}, this.emit();
	}
	setModificationFlag(e, t) {
		let n = $(this.state.draft);
		n.allowModificationWhenMatchUpsScheduled ||= {
			courts: !1,
			venues: !1
		}, n.allowModificationWhenMatchUpsScheduled[e] = t, this.commitDraft(n);
	}
	setDailyLimit(e, t) {
		let n = $(this.state.draft);
		n.defaultDailyLimits ||= {}, n.defaultDailyLimits[e] = t, this.commitDraft(n);
	}
	setDefaultAverageTime(e, t, n) {
		let r = $(this.state.draft);
		r.defaultTimes ||= {}, r.defaultTimes.averageTimes || (r.defaultTimes.averageTimes = [{
			categoryNames: [],
			minutes: { default: 90 }
		}]);
		let i = r.defaultTimes.averageTimes[e];
		i && (t === "DOUBLES" ? n === void 0 ? delete i.minutes.DOUBLES : i.minutes.DOUBLES = n : i.minutes.default = n ?? 0, this.commitDraft(r));
	}
	setDefaultRecoveryTime(e, t, n) {
		let r = $(this.state.draft);
		r.defaultTimes ||= {}, r.defaultTimes.recoveryTimes || (r.defaultTimes.recoveryTimes = [{ minutes: { default: 60 } }]);
		let i = r.defaultTimes.recoveryTimes[e];
		i && (t === "DOUBLES" ? n === void 0 ? delete i.minutes.DOUBLES : i.minutes.DOUBLES = n : i.minutes.default = n ?? 0, this.commitDraft(r));
	}
	addAverageFormatGroup() {
		let e = $(this.state.draft);
		e.matchUpAverageTimes ||= [], e.matchUpAverageTimes.push({
			matchUpFormatCodes: [],
			averageTimes: [{
				categoryNames: [],
				minutes: { default: 60 }
			}]
		}), this.commitDraft(e);
	}
	removeAverageFormatGroup(e) {
		let t = $(this.state.draft);
		t.matchUpAverageTimes && (t.matchUpAverageTimes.splice(e, 1), this.commitDraft(t));
	}
	setAverageFormatCodes(e, t) {
		let n = $(this.state.draft), r = n.matchUpAverageTimes?.[e];
		r && (r.matchUpFormatCodes = t, this.commitDraft(n));
	}
	setAverageTime(e, t, n, r) {
		let i = $(this.state.draft), a = i.matchUpAverageTimes?.[e]?.averageTimes?.[t];
		a && (n === "DOUBLES" ? r === void 0 ? delete a.minutes.DOUBLES : a.minutes.DOUBLES = r : a.minutes.default = r ?? 0, this.commitDraft(i));
	}
	addAverageCategoryOverride(e) {
		let t = $(this.state.draft), n = t.matchUpAverageTimes?.[e];
		n && (n.averageTimes.push({
			categoryTypes: [],
			minutes: { default: 60 }
		}), this.commitDraft(t));
	}
	removeAverageCategoryOverride(e, t) {
		let n = $(this.state.draft), r = n.matchUpAverageTimes?.[e];
		r && (r.averageTimes.splice(t, 1), this.commitDraft(n));
	}
	setAverageOverrideCategories(e, t, n, r) {
		let i = $(this.state.draft), a = i.matchUpAverageTimes?.[e]?.averageTimes?.[t];
		a && (n === "categoryNames" ? (delete a.categoryTypes, a.categoryNames = r) : (delete a.categoryNames, a.categoryTypes = r), this.commitDraft(i));
	}
	addRecoveryFormatGroup() {
		let e = $(this.state.draft);
		e.matchUpRecoveryTimes ||= [], e.matchUpRecoveryTimes.push({
			matchUpFormatCodes: [],
			recoveryTimes: [{
				categoryNames: [],
				minutes: { default: 30 }
			}]
		}), this.commitDraft(e);
	}
	removeRecoveryFormatGroup(e) {
		let t = $(this.state.draft);
		t.matchUpRecoveryTimes && (t.matchUpRecoveryTimes.splice(e, 1), this.commitDraft(t));
	}
	setRecoveryFormatCodes(e, t) {
		let n = $(this.state.draft), r = n.matchUpRecoveryTimes?.[e];
		r && (r.matchUpFormatCodes = t, this.commitDraft(n));
	}
	setRecoveryTime(e, t, n, r) {
		let i = $(this.state.draft), a = i.matchUpRecoveryTimes?.[e]?.recoveryTimes?.[t];
		a && (n === "DOUBLES" ? r === void 0 ? delete a.minutes.DOUBLES : a.minutes.DOUBLES = r : a.minutes.default = r ?? 0, this.commitDraft(i));
	}
	addRecoveryCategoryOverride(e) {
		let t = $(this.state.draft), n = t.matchUpRecoveryTimes?.[e];
		n && (n.recoveryTimes.push({
			categoryTypes: [],
			minutes: { default: 30 }
		}), this.commitDraft(t));
	}
	removeRecoveryCategoryOverride(e, t) {
		let n = $(this.state.draft), r = n.matchUpRecoveryTimes?.[e];
		r && (r.recoveryTimes.splice(t, 1), this.commitDraft(n));
	}
	setRecoveryOverrideCategories(e, t, n, r) {
		let i = $(this.state.draft), a = i.matchUpRecoveryTimes?.[e]?.recoveryTimes?.[t];
		a && (n === "categoryNames" ? (delete a.categoryTypes, a.categoryNames = r) : (delete a.categoryNames, a.categoryTypes = r), this.commitDraft(i));
	}
	subscribe(e) {
		return this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	commitDraft(e) {
		this.state = {
			...this.state,
			draft: e,
			dirty: !0
		}, this.emit(), this.config.onChange?.($(e));
	}
	emit() {
		for (let e of this.listeners) e(this.state);
	}
}, eP = () => "se-section", tP = () => "se-section-header", nP = () => "se-section-chevron", rP = () => "se-section-body", iP = () => "se-field-row", aP = () => "se-field-label", oP = () => "se-field-input", sP = () => "se-field-unit", cP = () => "se-checkbox-row", lP = () => "se-format-group", uP = () => "se-format-group-header", dP = () => "se-format-group-label", fP = () => "se-tag-picker", pP = () => "sp-chip", mP = () => "sp-chip__remove", hP = () => "se-tag-add-wrap", gP = () => "sp-btn-icon", _P = () => "se-override-row", vP = () => "se-override-categories", yP = () => "se-override-remove", bP = () => "sp-btn sp-btn--sm sp-btn--outline se-add-btn", xP = () => "sp-btn-icon sp-btn-icon--danger", SP = () => "se-editor";
//#endregion
//#region src/components/policy-catalog/editors/scheduling/sections/modificationFlagsSection.ts
function CP(e) {
	let t = document.createElement("div"), n = document.createElement("div");
	n.className = cP();
	let r = document.createElement("input");
	r.type = "checkbox", r.id = "se-mod-courts";
	let i = document.createElement("label");
	i.htmlFor = "se-mod-courts", i.textContent = "Allow court modifications when matchUps scheduled", r.addEventListener("change", () => {
		e.setModificationFlag("courts", r.checked);
	}), n.appendChild(r), n.appendChild(i);
	let a = document.createElement("div");
	a.className = cP();
	let o = document.createElement("input");
	o.type = "checkbox", o.id = "se-mod-venues";
	let s = document.createElement("label");
	s.htmlFor = "se-mod-venues", s.textContent = "Allow venue modifications when matchUps scheduled", o.addEventListener("change", () => {
		e.setModificationFlag("venues", o.checked);
	}), a.appendChild(o), a.appendChild(s), t.appendChild(n), t.appendChild(a);
	function c(e) {
		let t = e.draft.allowModificationWhenMatchUpsScheduled;
		r.checked = t?.courts ?? !1, o.checked = t?.venues ?? !1;
	}
	return {
		element: t,
		update: c
	};
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/sections/dailyLimitsSection.ts
var wP = "is-success", TP = "is-danger";
function EP(e) {
	if (e === "") return !0;
	let t = parseInt(e, 10);
	return !isNaN(t) && t >= 0 && String(t) === e.trim();
}
function DP(e, t) {
	if (t === "") {
		e.classList.remove(wP, TP);
		return;
	}
	EP(t) ? (e.classList.remove(TP), e.classList.add(wP)) : (e.classList.remove(wP), e.classList.add(TP));
}
function OP(e) {
	let t = document.createElement("div"), n = [];
	for (let [r, i] of [
		["SINGLES", "Singles limit"],
		["DOUBLES", "Doubles limit"],
		["total", "Total limit"]
	]) {
		let a = document.createElement("div");
		a.className = iP();
		let o = document.createElement("div");
		o.className = aP(), o.textContent = i;
		let s = document.createElement("input");
		s.type = "text", s.className = oP(), s.placeholder = "0", s.addEventListener("input", () => {
			DP(s, s.value);
		}), s.addEventListener("change", () => {
			let t = parseInt(s.value, 10);
			!isNaN(t) && t >= 0 && e.setDailyLimit(r, t);
		}), a.appendChild(o), a.appendChild(s), t.appendChild(a), n.push({
			key: r,
			label: i,
			input: s
		});
	}
	function r(e) {
		let t = e.draft.defaultDailyLimits;
		for (let e of n) {
			let n = t?.[e.key];
			document.activeElement !== e.input && (e.input.value = n === void 0 ? "" : String(n));
		}
	}
	return {
		element: t,
		update: r
	};
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/sections/defaultTimesSection.ts
var kP = "is-success", AP = "is-danger";
function jP(e) {
	if (e === "") return !0;
	let t = parseInt(e, 10);
	return !isNaN(t) && t >= 0 && String(t) === e.trim();
}
function MP(e, t, n) {
	if (t === "" && n) {
		e.classList.remove(kP, AP);
		return;
	}
	jP(t) && (t !== "" || n) ? (e.classList.remove(AP), e.classList.add(kP)) : (e.classList.remove(kP), e.classList.add(AP));
}
function NP(e) {
	let t = document.createElement("div"), n = document.createElement("div");
	n.style.cssText = "font-size:11px;font-weight:700;color:var(--sp-muted);margin-bottom:6px;", n.textContent = "Default Average Times", t.appendChild(n);
	let r = PP("Default", "min", !1), i = PP("Doubles override", "min", !0);
	t.appendChild(r.row), t.appendChild(i.row), r.input.addEventListener("input", () => {
		MP(r.input, r.input.value, !1);
	}), r.input.addEventListener("change", () => {
		let t = parseInt(r.input.value, 10);
		!isNaN(t) && t >= 0 && e.setDefaultAverageTime(0, "default", t);
	}), i.input.addEventListener("input", () => {
		MP(i.input, i.input.value, !0);
	}), i.input.addEventListener("change", () => {
		let t = i.input.value.trim();
		if (t === "" || t === "-") e.setDefaultAverageTime(0, "DOUBLES", void 0);
		else {
			let n = parseInt(t, 10);
			!isNaN(n) && n >= 0 && e.setDefaultAverageTime(0, "DOUBLES", n);
		}
	});
	let a = document.createElement("div");
	a.style.height = "12px", t.appendChild(a);
	let o = document.createElement("div");
	o.style.cssText = "font-size:11px;font-weight:700;color:var(--sp-muted);margin-bottom:6px;", o.textContent = "Default Recovery Times", t.appendChild(o);
	let s = PP("Default", "min", !1), c = PP("Doubles override", "min", !0);
	t.appendChild(s.row), t.appendChild(c.row), s.input.addEventListener("input", () => {
		MP(s.input, s.input.value, !1);
	}), s.input.addEventListener("change", () => {
		let t = parseInt(s.input.value, 10);
		!isNaN(t) && t >= 0 && e.setDefaultRecoveryTime(0, "default", t);
	}), c.input.addEventListener("input", () => {
		MP(c.input, c.input.value, !0);
	}), c.input.addEventListener("change", () => {
		let t = c.input.value.trim();
		if (t === "" || t === "-") e.setDefaultRecoveryTime(0, "DOUBLES", void 0);
		else {
			let n = parseInt(t, 10);
			!isNaN(n) && n >= 0 && e.setDefaultRecoveryTime(0, "DOUBLES", n);
		}
	});
	function l(e) {
		let t = e.draft.defaultTimes?.averageTimes?.[0];
		document.activeElement !== r.input && (r.input.value = t ? String(t.minutes.default) : ""), document.activeElement !== i.input && (i.input.value = t?.minutes.DOUBLES === void 0 ? "" : String(t.minutes.DOUBLES)), i.input.placeholder = "—";
		let n = e.draft.defaultTimes?.recoveryTimes?.[0];
		document.activeElement !== s.input && (s.input.value = n ? String(n.minutes.default) : ""), document.activeElement !== c.input && (c.input.value = n?.minutes.DOUBLES === void 0 ? "" : String(n.minutes.DOUBLES)), c.input.placeholder = "—";
	}
	return {
		element: t,
		update: l
	};
}
function PP(e, t, n) {
	let r = document.createElement("div");
	r.className = iP();
	let i = document.createElement("div");
	i.className = aP(), i.textContent = e;
	let a = document.createElement("input");
	a.type = "text", a.className = oP(), a.placeholder = n ? "—" : "0";
	let o = document.createElement("div");
	return o.className = sP(), o.textContent = t, r.appendChild(i), r.appendChild(a), r.appendChild(o), {
		row: r,
		input: a
	};
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/sections/formatTimeRow.ts
var FP = "is-success", IP = "is-danger";
function LP(e) {
	if (e === "") return !0;
	let t = parseInt(e, 10);
	return !isNaN(t) && t >= 0 && String(t) === e.trim();
}
function RP(e, t, n) {
	if (t === "" && n) {
		e.classList.remove(FP, IP);
		return;
	}
	LP(t) && (t !== "" || n) ? (e.classList.remove(IP), e.classList.add(FP)) : (e.classList.remove(FP), e.classList.add(IP));
}
function zP(e) {
	let t = document.createElement("div");
	t.className = lP();
	let n = document.createElement("div");
	n.className = uP();
	let r = document.createElement("div");
	r.style.flex = "1";
	let i = document.createElement("div");
	i.className = dP(), i.textContent = "Formats", r.appendChild(i);
	let a = document.createElement("div");
	a.className = fP();
	for (let t of e.formatCodes) {
		let n = document.createElement("span");
		n.className = pP(), n.title = `${t} — click to edit`;
		let r = document.createElement("span");
		r.textContent = XN(t), n.addEventListener("click", () => {
			Ra({
				existingMatchUpFormat: t,
				callback: (n) => {
					if (!n || n === t) return;
					let r = e.formatCodes.map((e) => e === t ? n : e);
					e.onFormatCodesChange(r);
				}
			});
		});
		let i = document.createElement("span");
		i.className = mP(), i.textContent = "×", i.addEventListener("click", (n) => {
			n.stopPropagation(), e.onFormatCodesChange(e.formatCodes.filter((e) => e !== t));
		}), n.appendChild(r), n.appendChild(i), a.appendChild(n);
	}
	let o = document.createElement("div");
	o.className = hP();
	let s = document.createElement("button");
	s.className = gP(), s.textContent = "+", s.type = "button", s.title = "Add format code", s.addEventListener("click", (t) => {
		t.stopPropagation(), Ra({
			existingMatchUpFormat: "SET3-S:6/TB7",
			callback: (t) => {
				t && !e.formatCodes.includes(t) && e.onFormatCodesChange([...e.formatCodes, t]);
			}
		});
	}), o.appendChild(s), a.appendChild(o), r.appendChild(a);
	let c = document.createElement("button");
	c.className = xP(), c.textContent = "×", c.type = "button", c.title = "Remove format group", c.addEventListener("click", () => e.onRemoveGroup()), n.appendChild(r), n.appendChild(c), t.appendChild(n);
	for (let n = 0; n < e.overrides.length; n++) {
		let r = e.overrides[n], i = document.createElement("div");
		i.className = _P();
		let a = document.createElement("div");
		a.className = `${vP()}${r.isDefault ? " all" : ""}`, a.textContent = r.categoryLabel;
		let o = document.createElement("input");
		o.type = "text", o.className = oP(), o.value = String(r.defaultMinutes), o.placeholder = "0";
		let s = n;
		o.addEventListener("input", () => {
			RP(o, o.value, !1);
		}), o.addEventListener("change", () => {
			let t = parseInt(o.value, 10);
			!isNaN(t) && t >= 0 && e.onTimeChange(s, "default", t);
		});
		let c = document.createElement("span");
		c.className = sP(), c.textContent = "min";
		let l = document.createElement("span");
		l.style.cssText = "font-size:11px;color:var(--sp-muted);margin-left:8px;", l.textContent = "Doubles:";
		let u = document.createElement("input");
		if (u.type = "text", u.className = oP(), u.value = r.doublesMinutes === void 0 ? "" : String(r.doublesMinutes), u.placeholder = "—", u.addEventListener("input", () => {
			RP(u, u.value, !0);
		}), u.addEventListener("change", () => {
			let t = u.value.trim();
			if (t === "" || t === "-") e.onTimeChange(s, "DOUBLES", void 0);
			else {
				let n = parseInt(t, 10);
				!isNaN(n) && n >= 0 && e.onTimeChange(s, "DOUBLES", n);
			}
		}), i.appendChild(a), i.appendChild(o), i.appendChild(c), i.appendChild(l), i.appendChild(u), !r.isDefault) {
			let t = document.createElement("span");
			t.className = yP(), t.textContent = "×", t.addEventListener("click", () => e.onRemoveOverride(s)), i.appendChild(t);
		}
		t.appendChild(i);
	}
	let l = document.createElement("button");
	return l.className = bP(), l.textContent = "+ Add Override", l.type = "button", l.addEventListener("click", () => e.onAddOverride()), t.appendChild(l), t;
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/sections/averageTimesSection.ts
function BP(e, t) {
	let n = document.createElement("div"), r = document.createElement("div");
	n.appendChild(r);
	let i = document.createElement("button");
	i.className = bP(), i.textContent = "+ Add Format Group", i.type = "button", i.addEventListener("click", () => e.addAverageFormatGroup()), n.appendChild(i);
	function a(n) {
		r.innerHTML = "";
		let i = n.draft.matchUpAverageTimes ?? [];
		for (let n = 0; n < i.length; n++) {
			let a = i[n], o = a.averageTimes.map((e, t) => {
				let n = e.categoryTypes ?? e.categoryNames ?? [];
				return {
					categoryLabel: n.length === 0 && t === 0 ? "All categories" : n.join(", ") || "All categories",
					isDefault: n.length === 0 && t === 0,
					defaultMinutes: e.minutes.default,
					doublesMinutes: e.minutes.DOUBLES
				};
			}), s = n, c = zP({
				formatCodes: a.matchUpFormatCodes,
				overrides: o,
				availableFormats: t.matchUpFormatCodes ?? VP(),
				onFormatCodesChange: (t) => e.setAverageFormatCodes(s, t),
				onTimeChange: (t, n, r) => e.setAverageTime(s, t, n, r),
				onAddOverride: () => e.addAverageCategoryOverride(s),
				onRemoveOverride: (t) => e.removeAverageCategoryOverride(s, t),
				onRemoveGroup: () => e.removeAverageFormatGroup(s)
			});
			r.appendChild(c);
		}
		if (i.length === 0) {
			let e = document.createElement("div");
			e.style.cssText = "font-size:12px;color:var(--sp-muted);padding:8px 0;", e.textContent = "No format-specific average times configured. Add a format group to set per-format times.", r.appendChild(e);
		}
	}
	return {
		element: n,
		update: a
	};
}
function VP() {
	return [
		"SET3-S:6/TB7",
		"SET3-S:6/TB7-F:TB10",
		"SET3-S:6/TB7-F:TB7",
		"SET3-S:4NOAD-F:TB7",
		"SET3-S:4/TB7",
		"SET3-S:4/TB7-F:TB7",
		"SET3-S:4/TB7-F:TB10",
		"SET3-S:4/TB5@3",
		"SET1-S:8/TB7",
		"SET1-S:8/TB7@7",
		"SET1-S:5/TB9@4",
		"SET1-S:6/TB7",
		"SET1-S:6NOAD",
		"SET1-S:4/TB7",
		"SET1-S:4/TB5@3",
		"SET1-S:4NOAD",
		"SET3-S:TB10",
		"SET1-S:T20",
		"SET1-S:TB10"
	];
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/sections/recoveryTimesSection.ts
function HP(e, t) {
	let n = document.createElement("div"), r = document.createElement("div");
	n.appendChild(r);
	let i = document.createElement("button");
	i.className = bP(), i.textContent = "+ Add Format Group", i.type = "button", i.addEventListener("click", () => e.addRecoveryFormatGroup()), n.appendChild(i);
	function a(n) {
		r.innerHTML = "";
		let i = n.draft.matchUpRecoveryTimes ?? [];
		for (let n = 0; n < i.length; n++) {
			let a = i[n], o = a.recoveryTimes.map((e, t) => {
				let n = e.categoryTypes ?? e.categoryNames ?? [];
				return {
					categoryLabel: n.length === 0 && t === 0 ? "All categories" : n.join(", ") || "All categories",
					isDefault: n.length === 0 && t === 0,
					defaultMinutes: e.minutes.default,
					doublesMinutes: e.minutes.DOUBLES
				};
			}), s = n, c = zP({
				formatCodes: a.matchUpFormatCodes,
				overrides: o,
				availableFormats: t.matchUpFormatCodes ?? UP(),
				onFormatCodesChange: (t) => e.setRecoveryFormatCodes(s, t),
				onTimeChange: (t, n, r) => e.setRecoveryTime(s, t, n, r),
				onAddOverride: () => e.addRecoveryCategoryOverride(s),
				onRemoveOverride: (t) => e.removeRecoveryCategoryOverride(s, t),
				onRemoveGroup: () => e.removeRecoveryFormatGroup(s)
			});
			r.appendChild(c);
		}
		if (i.length === 0) {
			let e = document.createElement("div");
			e.style.cssText = "font-size:12px;color:var(--sp-muted);padding:8px 0;", e.textContent = "No format-specific recovery times configured. Add a format group to set per-format recovery.", r.appendChild(e);
		}
	}
	return {
		element: n,
		update: a
	};
}
function UP() {
	return [
		"SET3-S:6/TB7",
		"SET3-S:6/TB7-F:TB10",
		"SET3-S:6/TB7-F:TB7",
		"SET3-S:4NOAD-F:TB7",
		"SET3-S:4/TB7",
		"SET3-S:4/TB7-F:TB7",
		"SET3-S:4/TB7-F:TB10",
		"SET3-S:4/TB5@3",
		"SET1-S:8/TB7",
		"SET1-S:8/TB7@7",
		"SET1-S:5/TB9@4",
		"SET1-S:6/TB7",
		"SET1-S:6NOAD",
		"SET1-S:4/TB7",
		"SET1-S:4/TB5@3",
		"SET1-S:4NOAD",
		"SET3-S:TB10",
		"SET1-S:T20",
		"SET1-S:TB10"
	];
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/schedulingEditorPanel.ts
function WP(e, t) {
	let n = document.createElement("div");
	n.className = SP();
	let r = [
		{
			id: "modificationFlags",
			label: "Modification Flags",
			factory: () => CP(e)
		},
		{
			id: "dailyLimits",
			label: "Daily Limits",
			factory: () => OP(e)
		},
		{
			id: "defaultTimes",
			label: "Default Times",
			factory: () => NP(e)
		},
		{
			id: "averageTimes",
			label: "Match Average Times",
			factory: () => BP(e, t)
		},
		{
			id: "recoveryTimes",
			label: "Match Recovery Times",
			factory: () => HP(e, t)
		}
	], i = [];
	for (let t of r) {
		let r = document.createElement("div");
		r.className = eP();
		let a = document.createElement("div");
		a.className = tP();
		let o = document.createElement("span");
		o.className = nP();
		let s = document.createElement("span");
		s.textContent = t.label, a.appendChild(o), a.appendChild(s), a.addEventListener("click", () => e.toggleSection(t.id));
		let c = document.createElement("div");
		c.className = rP();
		let l = t.factory();
		c.appendChild(l.element), r.appendChild(a), r.appendChild(c), n.appendChild(r), i.push({
			id: t.id,
			chevron: o,
			bodyEl: c,
			inner: l
		});
	}
	function a(e) {
		for (let t of i) {
			let n = e.expandedSections.has(t.id);
			t.chevron.textContent = n ? "▼" : "▶", t.bodyEl.style.display = n ? "block" : "none", n && t.inner.update(e);
		}
	}
	return {
		element: n,
		update: a
	};
}
//#endregion
//#region src/components/policy-catalog/editors/scheduling/schedulingEditorControl.ts
var GP = class e {
	constructor(e) {
		this.container = null, this.store = new $N(e), this.panel = WP(this.store, e), this.unsubscribe = this.store.subscribe((e) => {
			this.panel.update(e);
		}), this.panel.update(this.store.getState());
	}
	render(e) {
		this.container = e, e.appendChild(this.panel.element);
	}
	destroy() {
		this.unsubscribe(), this.container && this.panel.element.parentNode === this.container && this.container.removeChild(this.panel.element), this.container = null;
	}
	getData() {
		return this.store.getData();
	}
	setData(e) {
		this.store.setData(e);
	}
	getStore() {
		return this.store;
	}
	static createEditorInstance(t) {
		let n = new e({
			initialPolicy: t.initialData,
			onChange: (e) => t.onChange(e)
		});
		return {
			element: n.panel.element,
			setData(e) {
				n.setData(e);
			},
			getData() {
				return n.getData();
			},
			destroy() {
				n.destroy();
			}
		};
	}
};
function KP(e, t) {
	let n = new GP(e);
	return n.render(t), n;
}
//#endregion
//#region src/components/policy-catalog/ui/styles.ts
var qP = () => "pc-layout", JP = () => "pc-panel", YP = () => "pc-panel-header", XP = () => "pc-panel-title", ZP = () => "pc-panel-meta", QP = () => "pc-toolbar", $P = () => "pc-input", eF = () => "pc-select", tF = () => "pc-catalog", nF = () => "pc-group", rF = () => "pc-group-header", iF = () => "pc-group-chevron", aF = () => "pc-group-body", oF = () => "pc-card", sF = () => "pc-card-title", cF = () => "pc-card-meta", lF = () => "pc-type-badge", uF = () => "pc-editor", dF = () => "pc-editor-header", fF = () => "pc-editor-header-left", pF = () => "pc-editor-actions", mF = () => "sp-btn sp-btn--sm", hF = () => "sp-btn sp-btn--sm sp-btn--accent", gF = () => "pc-dirty-dot", _F = () => "pc-editor-body", vF = () => "pc-empty", yF = () => "pc-json-editor", bF = () => "pc-json-error";
//#endregion
//#region src/components/policy-catalog/ui/policyCatalogLayout.ts
function xF(e) {
	let t = document.createElement("div");
	t.className = qP(), t.appendChild(e.catalogPanel.element), t.appendChild(e.editorShell.element);
	function n(t) {
		e.catalogPanel.update(t), e.editorShell.update(t);
	}
	return {
		element: t,
		update: n
	};
}
//#endregion
//#region src/components/policy-catalog/domain/policyDefaults.ts
var SF = "scheduling", CF = "scoring", wF = "seeding", TF = "draws", EF = "avoidance", DF = "feedIn", OF = "progression", kF = "roundNaming", AF = "positionActions", jF = "matchUpActions", MF = "roundRobinTally", NF = "rankingPoints", PF = "competitiveBands", FF = "voluntaryConsolation", IF = "participant", LF = "display", RF = "audit", zF = "Tournament Operations", BF = "Scoring & Results", VF = "Ranking Points", HF = "Draw Configuration", UF = "Participants", WF = "Display & Audit", GF = (e, t, n, r, i) => ({
	policyType: e,
	label: t,
	description: n,
	group: r,
	hasEditor: i
}), KF = [
	GF(SF, "Scheduling", "Match scheduling, average times, recovery times, daily limits", zF, !0),
	GF(AF, "Position Actions", "Allowed position actions (alternates, walkovers, withdrawals)", zF, !1),
	GF(jF, "MatchUp Actions", "Allowed matchUp status transitions and actions", zF, !1),
	GF(EF, "Avoidance", "Draw placement avoidance rules (club, nationality, region)", zF, !1),
	GF(CF, "Scoring", "Score entry validation and completion rules", BF, !1),
	GF(MF, "Round Robin Tally", "Round-robin group standing calculation method", BF, !1),
	GF(NF, "Ranking Points", "Point allocation by draw size, round, and result", VF, !0),
	GF(PF, "Competitive Bands", "Rating/ranking band definitions for competitive grouping", BF, !1),
	GF(TF, "Draws", "Draw generation rules and structure options", HF, !1),
	GF(wF, "Seeding", "Seeding thresholds and placement rules by draw size", HF, !1),
	GF(DF, "Feed-In", "Feed-in consolation structure rules", HF, !1),
	GF(OF, "Progression", "Player progression between draw structures", HF, !1),
	GF(FF, "Voluntary Consolation", "Voluntary consolation entry rules", HF, !1),
	GF(kF, "Round Naming", "Custom round name labels (QF, SF, F, etc.)", HF, !1),
	GF(IF, "Participant", "Participant display and data rules", UF, !1),
	GF(LF, "Display", "Client display configuration (public vs admin views)", WF, !1),
	GF(RF, "Audit", "Audit trail and change logging configuration", WF, !1)
];
function qF(e) {
	return KF.find((t) => t.policyType === e);
}
function JF(e) {
	return e === "rankingPoints" ? BM() : e === "scheduling" ? QN() : {};
}
var YF = [
	zF,
	BF,
	VF,
	HF,
	UF,
	WF
];
//#endregion
//#region src/components/policy-catalog/domain/catalogProjections.ts
function XF(e, t) {
	let n = t.toLowerCase().trim();
	return n ? e.filter((e) => {
		let t = qF(e.policyType);
		return [
			e.name,
			e.description,
			e.policyType,
			t?.label ?? "",
			e.source
		].join(" ").toLowerCase().includes(n);
	}) : e;
}
function ZF(e, t) {
	let n = /* @__PURE__ */ new Map();
	if (t === "type") {
		for (let e of YF) n.set(e, []);
		for (let t of e) {
			let e = qF(t.policyType)?.group ?? "Display & Audit", r = n.get(e);
			r ? r.push(t) : n.set(e, [t]);
		}
		for (let [e, t] of n) t.length === 0 && n.delete(e);
	} else for (let t of e) {
		let e = t.source === "builtin" ? "Built-in Policies" : "User Policies", r = n.get(e);
		r ? r.push(t) : n.set(e, [t]);
	}
	return n;
}
//#endregion
//#region src/components/policy-catalog/ui/policyCatalogPanel.ts
function QF(e) {
	let t = document.createElement("div");
	t.className = JP(), t.style.overflowY = "auto", t.style.scrollbarWidth = "thin", t.style.scrollbarColor = "var(--sp-scrollbar) transparent";
	let n = /* @__PURE__ */ new Set(), r = null, i = document.createElement("div");
	i.className = YP();
	let a = document.createElement("div");
	a.className = XP(), a.textContent = "Policy Catalog";
	let o = document.createElement("div");
	o.className = ZP(), i.appendChild(a), i.appendChild(o), t.appendChild(i);
	let s = document.createElement("div");
	s.className = QP();
	let c = document.createElement("input");
	c.type = "text", c.placeholder = "Search policies...", c.className = $P(), c.addEventListener("input", () => e.onSearchChange(c.value));
	let l = document.createElement("select");
	l.className = eF();
	for (let [e, t] of [["type", "By Type"], ["source", "By Source"]]) {
		let n = document.createElement("option");
		n.value = e, n.textContent = t, l.appendChild(n);
	}
	l.addEventListener("change", () => e.onGroupByChange(l.value));
	let u = document.createElement("div");
	u.style.cssText = "position:relative;flex-shrink:0";
	let d = document.createElement("button");
	d.className = "sp-btn-icon", d.textContent = "+", d.title = "New policy", d.style.cssText = "font-size:1rem;font-weight:700";
	let f = document.createElement("div");
	f.style.cssText = "display:none;position:absolute;top:100%;right:0;z-index:100;min-width:180px;background:var(--sp-panel-bg);border:1px solid var(--sp-border);border-radius:12px;box-shadow:var(--sp-panel-shadow);padding:4px;margin-top:4px";
	let p = KF.filter((e) => e.hasEditor);
	for (let t of p) {
		let n = document.createElement("div");
		n.style.cssText = "padding:6px 10px;font-size:12px;border-radius:8px;cursor:pointer;color:var(--sp-text)", n.textContent = t.label, n.addEventListener("mouseenter", () => {
			n.style.background = "var(--sp-hover-bg)";
		}), n.addEventListener("mouseleave", () => {
			n.style.background = "";
		}), n.addEventListener("click", (n) => {
			n.stopPropagation(), f.style.display = "none", e.onNewPolicy?.(t.policyType);
		}), f.appendChild(n);
	}
	d.addEventListener("click", (e) => {
		e.stopPropagation(), f.style.display = f.style.display === "none" ? "block" : "none";
	}), document.addEventListener("click", () => {
		f.style.display = "none";
	}), u.appendChild(d), u.appendChild(f), s.appendChild(c), s.appendChild(l), s.appendChild(u), t.appendChild(s);
	let m = document.createElement("div");
	m.className = tF(), t.appendChild(m);
	function h(t) {
		r = t;
		let i = XF(t.catalog, t.searchQuery), a = ZF(i, t.groupBy);
		o.textContent = `${i.length} policies`, c.value !== t.searchQuery && (c.value = t.searchQuery), l.value !== t.groupBy && (l.value = t.groupBy), m.innerHTML = "";
		for (let [i, o] of a) {
			let a = document.createElement("div");
			a.className = nF();
			let s = n.has(i), c = document.createElement("div");
			c.className = rF();
			let l = document.createElement("span");
			l.className = iF(), l.textContent = s ? "▶" : "▼";
			let u = document.createElement("span");
			u.textContent = `${i} (${o.length})`, c.appendChild(l), c.appendChild(u), c.addEventListener("click", () => {
				n.has(i) ? n.delete(i) : n.add(i), r && h(r);
			});
			let d = document.createElement("div");
			d.className = aF(), s && (d.style.display = "none");
			for (let n of o) {
				let r = document.createElement("div");
				r.className = oF(), n.id === t.selectedId && r.classList.add("active"), r.addEventListener("click", () => e.onSelectPolicy(n.id));
				let i = document.createElement("div");
				i.style.cssText = "display:flex;align-items:center;gap:4px";
				let a = document.createElement("div");
				if (a.className = sF(), a.style.flex = "1", a.textContent = n.name, i.appendChild(a), e.onDuplicatePolicy) {
					let t = document.createElement("span");
					t.style.cssText = "font-size:10px;cursor:pointer;color:var(--sp-muted);padding:2px", t.textContent = "⎘", t.title = "Duplicate", t.addEventListener("click", (t) => {
						t.stopPropagation(), e.onDuplicatePolicy?.(n.id);
					}), i.appendChild(t);
				}
				if (n.source === "user" && e.onDeletePolicy) {
					let t = document.createElement("span");
					t.style.cssText = "font-size:10px;cursor:pointer;color:var(--sp-muted);padding:2px", t.textContent = "✕", t.title = "Delete", t.addEventListener("click", (t) => {
						t.stopPropagation(), e.onDeletePolicy?.(n.id);
					}), i.appendChild(t);
				}
				r.appendChild(i);
				let o = document.createElement("div");
				o.className = cF();
				let s = qF(n.policyType), c = document.createElement("span");
				c.className = lF(), c.textContent = s?.label ?? n.policyType;
				let l = document.createElement("span");
				l.className = `${lF()} ${n.source}`, l.textContent = n.source, o.appendChild(c), o.appendChild(l), r.appendChild(o), d.appendChild(r);
			}
			a.appendChild(c), a.appendChild(d), m.appendChild(a);
		}
	}
	return {
		element: t,
		update: h
	};
}
//#endregion
//#region src/components/policy-catalog/domain/utils.ts
function $F(e) {
	return structuredClone(e);
}
//#endregion
//#region src/components/policy-catalog/engine/policyCatalogStore.ts
var eI = class {
	constructor(e) {
		this.listeners = /* @__PURE__ */ new Set(), this.config = e;
		let t = new Set((e.builtinPolicies ?? []).map((e) => e.id));
		this.state = {
			catalog: [...e.builtinPolicies ?? [], ...(e.userPolicies ?? []).filter((e) => !t.has(e.id))],
			searchQuery: "",
			groupBy: "type",
			selectedId: null,
			editorDraft: null,
			dirty: !1
		};
	}
	getState() {
		return this.state;
	}
	getSelectedItem() {
		return this.state.selectedId ? this.state.catalog.find((e) => e.id === this.state.selectedId) ?? null : null;
	}
	setCatalogSearch(e) {
		this.setState({ searchQuery: e });
	}
	setCatalogGroupBy(e) {
		this.setState({ groupBy: e });
	}
	selectPolicy(e) {
		if (this.state.selectedId === e) return;
		let t = this.state.catalog.find((t) => t.id === e);
		t && (this.setState({
			selectedId: e,
			editorDraft: $F(t.policyData),
			dirty: !1
		}), this.config.onSelectionChanged?.(t));
	}
	clearSelection() {
		this.state.selectedId && (this.setState({
			selectedId: null,
			editorDraft: null,
			dirty: !1
		}), this.config.onSelectionChanged?.(null));
	}
	updateEditorDraft(e) {
		this.setState({
			editorDraft: e,
			dirty: !0
		});
	}
	markDirty() {
		this.state.dirty || this.setState({ dirty: !0 });
	}
	markClean() {
		this.state.dirty && this.setState({ dirty: !1 });
	}
	savePolicy() {
		let e = this.getSelectedItem();
		if (!e || !this.state.editorDraft) return;
		let t = {
			...e,
			policyData: $F(this.state.editorDraft)
		}, n = this.state.catalog.map((e) => e.id === t.id ? t : e);
		this.state = {
			...this.state,
			catalog: n,
			dirty: !1
		}, this.emit(), this.config.onPolicySaved?.(t);
	}
	resetDraft() {
		let e = this.getSelectedItem();
		e && this.setState({
			editorDraft: $F(e.policyData),
			dirty: !1
		});
	}
	applyPolicy() {
		let e = this.getSelectedItem();
		if (!e) return;
		let t = {
			...e,
			policyData: this.state.editorDraft ? $F(this.state.editorDraft) : $F(e.policyData)
		};
		this.config.onPolicyApplied?.(t);
	}
	addNewPolicy(e) {
		let t = `user-${e}-${Date.now()}`, n = {
			id: t,
			name: `New ${e} policy`,
			policyType: e,
			source: "user",
			description: "",
			policyData: JF(e)
		}, r = [...this.state.catalog, n];
		return this.state = {
			...this.state,
			catalog: r,
			selectedId: t,
			editorDraft: $F(n.policyData),
			dirty: !1
		}, this.emit(), this.config.onPolicyCreated?.(n), this.config.onSelectionChanged?.(n), t;
	}
	duplicatePolicy(e) {
		let t = this.state.catalog.find((t) => t.id === e);
		if (!t) return null;
		let n = `user-${t.policyType}-${Date.now()}`, r = {
			id: n,
			name: `${t.name} (Copy)`,
			policyType: t.policyType,
			source: "user",
			description: t.description,
			policyData: $F(t.policyData)
		}, i = [...this.state.catalog, r];
		return this.state = {
			...this.state,
			catalog: i,
			selectedId: n,
			editorDraft: $F(r.policyData),
			dirty: !1
		}, this.emit(), this.config.onPolicyCreated?.(r), this.config.onSelectionChanged?.(r), n;
	}
	deletePolicy(e) {
		let t = this.state.catalog.find((t) => t.id === e);
		if (!t || t.source === "builtin") return;
		let n = this.state.catalog.filter((t) => t.id !== e), r = this.state.selectedId === e;
		this.state = {
			...this.state,
			catalog: n,
			...r ? {
				selectedId: null,
				editorDraft: null,
				dirty: !1
			} : {}
		}, this.emit(), this.config.onPolicyDeleted?.(e), r && this.config.onSelectionChanged?.(null);
	}
	subscribe(e) {
		return this.listeners.add(e), () => {
			this.listeners.delete(e);
		};
	}
	setState(e) {
		this.state = {
			...this.state,
			...e
		}, this.emit();
	}
	emit() {
		for (let e of this.listeners) e(this.state);
	}
};
//#endregion
//#region src/components/policy-catalog/ui/editorShell.ts
function tI(e) {
	let t = document.createElement("div");
	t.className = JP();
	let n = document.createElement("div");
	n.className = uF();
	let r = document.createElement("div");
	r.className = dF();
	let i = document.createElement("div");
	i.className = fF();
	let a = document.createElement("div");
	a.className = XP();
	let o = document.createElement("span");
	o.className = lF();
	let s = document.createElement("span");
	s.className = lF(), s.textContent = "read-only", s.style.display = "none";
	let c = document.createElement("div");
	c.className = gF(), c.style.display = "none", c.title = "Unsaved changes", i.appendChild(c), i.appendChild(a), i.appendChild(o), i.appendChild(s);
	let l = document.createElement("div");
	l.className = pF();
	let u = document.createElement("button");
	u.className = mF(), u.textContent = "Reset", u.addEventListener("click", () => e.onReset());
	let d = document.createElement("button");
	d.className = hF(), d.textContent = "Save", d.addEventListener("click", () => e.onSave());
	let f = document.createElement("button");
	f.className = mF(), f.textContent = "Apply", f.addEventListener("click", () => e.onApply());
	let p = document.createElement("button");
	p.className = mF(), p.textContent = "Duplicate", p.addEventListener("click", () => e.onDuplicate()), l.appendChild(u), l.appendChild(d), l.appendChild(f), l.appendChild(p);
	let m = document.createElement("div");
	m.className = pF();
	let h = document.createElement("button");
	h.className = hF(), h.textContent = "Use as Template", h.addEventListener("click", () => e.onDuplicate()), m.appendChild(h), r.appendChild(i), r.appendChild(l), r.appendChild(m);
	let g = document.createElement("div");
	g.className = _F(), n.appendChild(r), n.appendChild(g);
	let _ = document.createElement("div");
	_.className = vF(), _.textContent = "Select a policy to edit", t.appendChild(n), t.appendChild(_);
	function v(e) {
		let t = e.selectedId !== null;
		if (n.style.display = t ? "flex" : "none", _.style.display = t ? "none" : "flex", !t) return;
		let r = e.catalog.find((t) => t.id === e.selectedId);
		if (!r) return;
		let i = r.source === "builtin";
		a.textContent = r.name, o.textContent = qF(r.policyType)?.label ?? r.policyType, s.style.display = i ? "" : "none", l.style.display = i ? "none" : "flex", m.style.display = i ? "flex" : "none", c.style.display = !i && e.dirty ? "block" : "none";
	}
	return {
		element: t,
		update: v,
		bodyElement: g
	};
}
//#endregion
//#region src/components/policy-catalog/ui/jsonEditor.ts
function nI(e) {
	let t = document.createElement("div");
	t.className = yF();
	let n = document.createElement("textarea");
	n.value = JSON.stringify(e.initialData, null, 2);
	let r = document.createElement("div");
	r.className = bF(), r.style.display = "none";
	let i = { ...e.initialData };
	return n.addEventListener("input", () => {
		try {
			let t = JSON.parse(n.value);
			i = t, r.style.display = "none", e.onChange(t);
		} catch (e) {
			r.style.display = "block", r.textContent = `Invalid JSON: ${e.message}`;
		}
	}), t.appendChild(n), t.appendChild(r), {
		element: t,
		setData(e) {
			i = { ...e }, n.value = JSON.stringify(e, null, 2), r.style.display = "none";
		},
		getData() {
			return { ...i };
		},
		destroy() {
			t.remove();
		}
	};
}
//#endregion
//#region src/components/policy-catalog/controller/policyCatalogControl.ts
var rI = class {
	constructor(e) {
		this.currentEditor = null, this.container = null, this.store = new eI(e);
		let t = QF({
			onSearchChange: (e) => this.store.setCatalogSearch(e),
			onGroupByChange: (e) => this.store.setCatalogGroupBy(e),
			onSelectPolicy: (e) => this.handleSelectPolicy(e),
			onNewPolicy: (e) => {
				this.store.addNewPolicy(e), this.mountEditorForSelection();
			},
			onDuplicatePolicy: (e) => {
				this.store.duplicatePolicy(e), this.mountEditorForSelection();
			},
			onDeletePolicy: (e) => {
				this.store.deletePolicy(e), this.store.getSelectedItem() || this.destroyCurrentEditor();
			}
		});
		this.editorShell = tI({
			onSave: () => this.store.savePolicy(),
			onReset: () => {
				this.store.resetDraft(), this.syncEditorFromStore();
			},
			onApply: () => this.store.applyPolicy(),
			onDuplicate: () => {
				let e = this.store.getSelectedItem();
				e && (this.store.duplicatePolicy(e.id), this.mountEditorForSelection());
			}
		}), this.layout = xF({
			catalogPanel: t,
			editorShell: this.editorShell
		}), this.unsubscribe = this.store.subscribe((e) => {
			this.layout.update(e);
		}), this.layout.update(this.store.getState());
	}
	render(e) {
		this.container = e, e.appendChild(this.layout.element);
	}
	destroy() {
		this.destroyCurrentEditor(), this.unsubscribe(), this.container && this.layout.element.parentNode === this.container && this.layout.element.remove(), this.container = null;
	}
	getStore() {
		return this.store;
	}
	handleSelectPolicy(e) {
		this.store.selectPolicy(e), this.mountEditorForSelection();
	}
	mountEditorForSelection() {
		this.destroyCurrentEditor();
		let e = this.store.getSelectedItem();
		if (!e) return;
		let t = e.source === "builtin", n = {
			initialData: { ...e.policyData },
			onChange: (e) => {
				this.store.updateEditorDraft(e);
			},
			readonly: t
		};
		e.policyType === "scheduling" ? this.currentEditor = GP.createEditorInstance(n) : e.policyType === "rankingPoints" ? this.currentEditor = YN.createEditorInstance(n) : this.currentEditor = nI(n), this.editorShell.bodyElement.innerHTML = "", this.editorShell.bodyElement.appendChild(this.currentEditor.element);
	}
	syncEditorFromStore() {
		let e = this.store.getState();
		this.currentEditor && e.editorDraft && this.currentEditor.setData(e.editorDraft);
	}
	destroyCurrentEditor() {
		this.currentEditor &&= (this.currentEditor.destroy(), null), this.editorShell.bodyElement.innerHTML = "";
	}
};
//#endregion
//#region src/components/policy-catalog/editors/scheduling/domain/schedulingValidation.ts
function iI(e, t, n, r) {
	e !== void 0 && e < 0 && r.push({
		severity: "error",
		path: t,
		message: n
	});
}
function aI(e, t) {
	if (!e.defaultTimes) return;
	let n = e.defaultTimes.averageTimes;
	if (n) for (let e = 0; e < n.length; e++) iI(n[e].minutes.default, `defaultTimes.averageTimes[${e}].minutes.default`, "Default average time must be non-negative", t), iI(n[e].minutes.DOUBLES, `defaultTimes.averageTimes[${e}].minutes.DOUBLES`, "Doubles average time must be non-negative", t);
	let r = e.defaultTimes.recoveryTimes;
	if (r) for (let e = 0; e < r.length; e++) iI(r[e].minutes.default, `defaultTimes.recoveryTimes[${e}].minutes.default`, "Default recovery time must be non-negative", t);
}
function oI(e, t) {
	if (!e.defaultDailyLimits) return;
	let n = e.defaultDailyLimits;
	iI(n.SINGLES, "defaultDailyLimits.SINGLES", "Singles daily limit must be non-negative", t), iI(n.DOUBLES, "defaultDailyLimits.DOUBLES", "Doubles daily limit must be non-negative", t), iI(n.total, "defaultDailyLimits.total", "Total daily limit must be non-negative", t);
}
function sI(e) {
	let t = [];
	return aI(e, t), oI(e, t), e.matchUpAverageTimes && cI(e.matchUpAverageTimes, "matchUpAverageTimes", "averageTimes", t), e.matchUpRecoveryTimes && lI(e.matchUpRecoveryTimes, "matchUpRecoveryTimes", t), uI(e, t), t;
}
function cI(e, t, n, r) {
	for (let i = 0; i < e.length; i++) {
		let a = e[i];
		a.matchUpFormatCodes.length || r.push({
			severity: "error",
			path: `${t}[${i}].matchUpFormatCodes`,
			message: "At least one format code is required per format group"
		});
		let o = a[n];
		if (o) for (let e = 0; e < o.length; e++) iI(o[e].minutes.default, `${t}[${i}].${n}[${e}].minutes.default`, "Time must be non-negative", r), iI(o[e].minutes.DOUBLES, `${t}[${i}].${n}[${e}].minutes.DOUBLES`, "Doubles time must be non-negative", r);
	}
}
function lI(e, t, n) {
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		i.matchUpFormatCodes.length || n.push({
			severity: "error",
			path: `${t}[${r}].matchUpFormatCodes`,
			message: "At least one format code is required per format group"
		});
		for (let e = 0; e < i.recoveryTimes.length; e++) iI(i.recoveryTimes[e].minutes.default, `${t}[${r}].recoveryTimes[${e}].minutes.default`, "Recovery time must be non-negative", n), iI(i.recoveryTimes[e].minutes.DOUBLES, `${t}[${r}].recoveryTimes[${e}].minutes.DOUBLES`, "Doubles recovery time must be non-negative", n);
	}
}
function uI(e, t) {
	let n = (e, n) => {
		if (!e) return;
		let r = /* @__PURE__ */ new Map();
		for (let i = 0; i < e.length; i++) for (let a of e[i].matchUpFormatCodes) r.has(a) ? t.push({
			severity: "warning",
			path: `${n}[${i}].matchUpFormatCodes`,
			message: `Format code "${a}" also appears in group ${r.get(a)}`
		}) : r.set(a, i);
	};
	n(e.matchUpAverageTimes, "matchUpAverageTimes"), n(e.matchUpRecoveryTimes, "matchUpRecoveryTimes");
}
//#endregion
//#region src/components/policy-catalog/index.ts
function dI(e, t) {
	let n = new rI(e);
	return n.render(t), n;
}
//#endregion
export { Fj as CompositionEditorStore, pj as DEFAULT_SCHEDULE_CELL_CONFIG, th as DrawStateManager, fs as InlineScoringManager, Wm as MATCH_FORMATS, YF as POLICY_TYPE_GROUPS, KF as POLICY_TYPE_METADATA, rI as PolicyCatalogControl, eI as PolicyCatalogStore, yT as ProfileStore, uj as SchedulePageControl, lj as SchedulePageStore, GP as SchedulingEditorControl, $N as SchedulingEditorStore, MT as SchedulingProfileControl, PE as TemporalGrid, Fk as TopologyBuilderControl, FD as TopologyStore, Nj as activateScheduleCellTypeAhead, hT as applyDropCommit, Vm as badmintonCourt, dC as barButton, Rm as baseballDiamond, Lm as basketballCourt, cj as buildCourtGridSlot, AT as buildDateStrip, AO as buildEdgeEditor, tI as buildEditorShell, Uw as buildInspectorPanel, pT as buildIssueIndex, Qw as buildIssuesPanel, nI as buildJsonEditor, ej as buildMatchUpCard, rj as buildMatchUpCatalog, vO as buildNodeEditor, xF as buildPolicyCatalogLayout, QF as buildPolicyCatalogPanel, TT as buildRoundCard, Zw as buildRoundCatalog, sj as buildScheduleDateStrip, mj as buildScheduleGridCell, JA as buildScheduleInspectorPanel, ij as buildScheduleIssueIndex, oj as buildScheduleIssuesPanel, WA as buildSchedulePageLayout, WP as buildSchedulingEditorPanel, kw as buildSchedulingProfileLayout, Vs as buildSetScore, bD as buildStructureCard, ak as buildToolbar, ok as buildTopologyBuilderLayout, KD as buildTopologyCanvas, DT as buildVenueBoard, LS as burstChart, R as cModal, Ls as calculateComplement, yi as compositions, kC as controlBar, Um as courthiveComponentsVersion, Aw as createCardPopoverManager, AM as createCompositionEditor, zM as createInlineScoringFooter, dI as createPolicyCatalog, Pj as createSchedulePage, KP as createSchedulingEditor, NT as createSchedulingProfile, FE as createTemporalGrid, Nm as destroyTipster, bd as drawer, aC as dropDownButton, QN as emptySchedulingPolicy, us as engineToMatchUp, Kw as filterCatalog, QA as filterMatchUpCatalog, XF as filterPolicyCatalog, zw as findIssuesForLocator, XN as formatCodeLabel, US as fromFactoryDrawData, KS as fromLegacyDraw, XE as generatePreviewMatchUps, Eo as getAgeCategoryModal, ko as getCategoryModal, os as getFlightProfileModal, Ui as getGenerateTeamsModal, Ra as getMatchUpFormatModal, Is as getMatchWinner, Ms as getMaxAllowedScore, Li as getMockParticipantsModal, Jw as getPlannedRoundKeys, qF as getPolicyTypeMeta, xD as getPortPosition, Rw as getRoundAt, hs as getScoringConfig, ks as getSetFormatForIndex, Ps as getSetWinner, Lw as getVenueRounds, qw as groupCatalog, $A as groupMatchUpCatalog, ZF as groupPolicyCatalog, zm as hockeyRink, xd as initDrawer, ZA as isCompletedStatus, Fs as isMatchComplete, Ns as isSetComplete, As as isSetTiebreakOnly, js as isSetTimed, Mj as mapMatchUpToCellData, GA as matchUpLabel, qA as matchUpSearchKey, Vw as maxSeverity, Yi as openCompositionEditorModal, Zi as openScheduleCellConfigModal, Hm as padelCourt, KA as participantLabel, Bm as pickleballCourt, Gm as renderButtons, ui as renderContainer, Tn as renderField, Ei as renderForm, cs as renderInlineMatchUp, oi as renderMatchUp, Sd as renderMenu, wn as renderOptions, wr as renderParticipant, Mn as renderParticipantInput, si as renderRound, Er as renderRoundHeader, Ci as renderSchematicMatchUp, wi as renderSchematicRound, Ti as renderSchematicStructure, MM as renderScorecard, ci as renderStructure, NM as renderTeamVsHeader, _s as resetScoringConfig, xi as resolvePublishedComposition, au as scoringModal, sC as selectItem, gs as setScoringConfig, Rs as shouldApplySmartComplement, Bs as shouldCreateNextSet, zs as shouldShowTiebreak, ME as showCourtAvailabilityModal, Tk as standardTemplates, Im as tennisCourt, Pm as tipster, yC as toggleOverlay, Qk as topologyToDrawOptions, PM as updateTieScore, nT as validateProfile, sI as validateSchedulingPolicy, BO as validateTopology, xn as validator, eh as validators };
